/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.10.0 (NJsonSchema v9.10.49.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import * as moment from 'moment';
export var API_BASE_URL = new InjectionToken('API_BASE_URL');
var AccountServiceProxy = /** @class */ (function () {
    function AccountServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.isTenantAvailable = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsTenantAvailable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processIsTenantAvailable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.resolveTenantId = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResolveTenantId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResolveTenantId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processResolveTenantId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.register = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegister(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegister(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processRegister = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.sendEmailActivationLink = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendEmailActivationLink(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSendEmailActivationLink = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.activateEmail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActivateEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActivateEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processActivateEmail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.impersonate = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImpersonate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImpersonate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processImpersonate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AccountServiceProxy.prototype.backToImpersonator = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBackToImpersonator(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBackToImpersonator(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processBackToImpersonator = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.switchToLinkedAccount = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSwitchToLinkedAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSwitchToLinkedAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], AccountServiceProxy);
    return AccountServiceProxy;
}());
export { AccountServiceProxy };
var AlarmGroupServiceProxy = /** @class */ (function () {
    function AlarmGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @configureId (optional)
     * @return Success
     */
    AlarmGroupServiceProxy.prototype.getAlarmGroups = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmGroup/GetAlarmGroups?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAlarmGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAlarmGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmGroupServiceProxy.prototype.processGetAlarmGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(AlarmGroupListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AlarmGroupServiceProxy.prototype.createOrUpdateAlarmGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmGroup/CreateOrUpdateAlarmGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateAlarmGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateAlarmGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmGroupServiceProxy.prototype.processCreateOrUpdateAlarmGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @id (optional)
     * @return Success
     */
    AlarmGroupServiceProxy.prototype.deleteAlarmGroup = function (configureId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmGroup/DeleteAlarmGroup?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteAlarmGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteAlarmGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmGroupServiceProxy.prototype.processDeleteAlarmGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AlarmGroupServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], AlarmGroupServiceProxy);
    return AlarmGroupServiceProxy;
}());
export { AlarmGroupServiceProxy };
var AlarmRegistrationsServiceProxy = /** @class */ (function () {
    function AlarmRegistrationsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 查询报警数据，包括筛选内容
     * @configureId (optional)
     * @alarmDataSource (optional) 告警来源
     * @alarmLevel (optional) 告警级别
     * @groupId (optional) 告警组 Id
     * @alarmSearchCriteria (optional) 报警名称
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.getConfigureAlarms = function (configureId, alarmDataSource, alarmLevel, groupId, alarmSearchCriteria, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/GetConfigureAlarms?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (alarmDataSource !== undefined)
            url_ += "AlarmDataSource=" + encodeURIComponent("" + alarmDataSource) + "&";
        if (alarmLevel !== undefined)
            url_ += "AlarmLevel=" + encodeURIComponent("" + alarmLevel) + "&";
        if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (alarmSearchCriteria !== undefined)
            url_ += "AlarmSearchCriteria=" + encodeURIComponent("" + alarmSearchCriteria) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processGetConfigureAlarms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfAlarmDefListDto.fromJS(resultData200) : new PagedResultDtoOfAlarmDefListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量导入检查报警名是否重复
     * @batchImportAlarmsDto (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.batchImportCheckAlarmNameRepeat = function (batchImportAlarmsDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/BatchImportCheckAlarmNameRepeat";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(batchImportAlarmsDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchImportCheckAlarmNameRepeat(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchImportCheckAlarmNameRepeat(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processBatchImportCheckAlarmNameRepeat = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.createOrUpdateAlarmDef = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/CreateOrUpdateAlarmDef";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateAlarmDef(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateAlarmDef(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processCreateOrUpdateAlarmDef = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除报警数据
     * @alarmDefIds (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.deleteConfigureAlarm = function (alarmDefIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/DeleteConfigureAlarm?";
        if (alarmDefIds !== undefined)
            alarmDefIds && alarmDefIds.forEach(function (item) { url_ += "AlarmDefIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteConfigureAlarm(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteConfigureAlarm(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processDeleteConfigureAlarm = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量修改报警等级
     * @input (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.batchModifyAlarmLevel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/BatchModifyAlarmLevel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchModifyAlarmLevel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchModifyAlarmLevel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processBatchModifyAlarmLevel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量导入报警
     * @batchImportAlarmsDto (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.batchImportAlarms = function (batchImportAlarmsDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/BatchImportAlarms";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(batchImportAlarmsDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchImportAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchImportAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processBatchImportAlarms = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据id获取报警数据
     * @configureAlarmId (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.getAlarmToEdit = function (configureAlarmId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/GetAlarmToEdit?";
        if (configureAlarmId !== undefined)
            url_ += "configureAlarmId=" + encodeURIComponent("" + configureAlarmId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAlarmToEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAlarmToEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processGetAlarmToEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AlarmToEditDto.fromJS(resultData200) : new AlarmToEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据数据源获取fbox报警信息
     * @dataSourceId (optional)
     * @return Success
     */
    AlarmRegistrationsServiceProxy.prototype.getRefAlarmDtosByDataSourceId = function (dataSourceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AlarmRegistrations/GetRefAlarmDtosByDataSourceId?";
        if (dataSourceId !== undefined)
            url_ += "dataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRefAlarmDtosByDataSourceId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRefAlarmDtosByDataSourceId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AlarmRegistrationsServiceProxy.prototype.processGetRefAlarmDtosByDataSourceId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(RefAlarmDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AlarmRegistrationsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], AlarmRegistrationsServiceProxy);
    return AlarmRegistrationsServiceProxy;
}());
export { AlarmRegistrationsServiceProxy };
var AuditLogServiceProxy = /** @class */ (function () {
    function AuditLogServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @startDate (optional)
     * @endDate (optional)
     * @userName (optional)
     * @serviceName (optional)
     * @methodName (optional)
     * @browserInfo (optional)
     * @hasException (optional)
     * @minExecutionDuration (optional)
     * @maxExecutionDuration (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getAuditLogs = function (startDate, endDate, userName, serviceName, methodName, browserInfo, hasException, minExecutionDuration, maxExecutionDuration, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAuditLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAuditLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetAuditLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfAuditLogListDto.fromJS(resultData200) : new PagedResultDtoOfAuditLogListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @startDate (optional)
     * @endDate (optional)
     * @userName (optional)
     * @serviceName (optional)
     * @methodName (optional)
     * @browserInfo (optional)
     * @hasException (optional)
     * @minExecutionDuration (optional)
     * @maxExecutionDuration (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getAuditLogsToExcel = function (startDate, endDate, userName, serviceName, methodName, browserInfo, hasException, minExecutionDuration, maxExecutionDuration, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAuditLogsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetAuditLogsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityHistoryObjectTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityHistoryObjectTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityHistoryObjectTypes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(NameValueDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @startDate (optional)
     * @endDate (optional)
     * @userName (optional)
     * @entityTypeFullName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityChanges = function (startDate, endDate, userName, entityTypeFullName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityChanges = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfEntityChangeListDto.fromJS(resultData200) : new PagedResultDtoOfEntityChangeListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @startDate (optional)
     * @endDate (optional)
     * @userName (optional)
     * @entityTypeFullName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityChangesToExcel = function (startDate, endDate, userName, entityTypeFullName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityChangesToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityChangesToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @entityChangeId (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityPropertyChanges = function (entityChangeId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityPropertyChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityPropertyChanges = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(EntityPropertyChangeDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AuditLogServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], AuditLogServiceProxy);
    return AuditLogServiceProxy;
}());
export { AuditLogServiceProxy };
var BackgroundJobServiceProxy = /** @class */ (function () {
    function BackgroundJobServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取当前job的状态
     * @jobId (optional)
     * @return Success
     */
    BackgroundJobServiceProxy.prototype.getBackgroundJobState = function (jobId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BackgroundJob/GetBackgroundJobState?";
        if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBackgroundJobState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBackgroundJobState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BackgroundJobServiceProxy.prototype.processGetBackgroundJobState = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    BackgroundJobServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], BackgroundJobServiceProxy);
    return BackgroundJobServiceProxy;
}());
export { BackgroundJobServiceProxy };
var BaiduTokenServiceProxy = /** @class */ (function () {
    function BaiduTokenServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    BaiduTokenServiceProxy.prototype.getBaiduToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BaiduToken/GetBaiduToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBaiduToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBaiduToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BaiduTokenServiceProxy.prototype.processGetBaiduToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? BaiduSpeechApiTokenInfo.fromJS(resultData200) : new BaiduSpeechApiTokenInfo();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    BaiduTokenServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], BaiduTokenServiceProxy);
    return BaiduTokenServiceProxy;
}());
export { BaiduTokenServiceProxy };
var BatchControlServiceProxy = /** @class */ (function () {
    function BatchControlServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    BatchControlServiceProxy.prototype.getBatchControlList = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BatchControl/GetBatchControlList";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBatchControlList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBatchControlList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BatchControlServiceProxy.prototype.processGetBatchControlList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(BatchControlListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @uid (optional)
     * @name (optional)
     * @return Success
     */
    BatchControlServiceProxy.prototype.getBatchControlLogList = function (uid, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BatchControl/GetBatchControlLogList?";
        if (uid !== undefined)
            url_ += "Uid=" + encodeURIComponent("" + uid) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBatchControlLogList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBatchControlLogList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BatchControlServiceProxy.prototype.processGetBatchControlLogList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(BatchControlLogListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    BatchControlServiceProxy.prototype.batchWriteValue = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BatchControl/BatchWriteValue";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchWriteValue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchWriteValue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BatchControlServiceProxy.prototype.processBatchWriteValue = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @uid (optional)
     * @return Success
     */
    BatchControlServiceProxy.prototype.batchRewriteValue = function (uid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BatchControl/BatchRewriteValue?";
        if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchRewriteValue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchRewriteValue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BatchControlServiceProxy.prototype.processBatchRewriteValue = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    BatchControlServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], BatchControlServiceProxy);
    return BatchControlServiceProxy;
}());
export { BatchControlServiceProxy };
var CachingServiceProxy = /** @class */ (function () {
    function CachingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    CachingServiceProxy.prototype.getAllCaches = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCaches(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCaches(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processGetAllCaches = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfCacheDto.fromJS(resultData200) : new ListResultDtoOfCacheDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CachingServiceProxy.prototype.clearCache = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearCache(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearCache(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processClearCache = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    CachingServiceProxy.prototype.clearAllCaches = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearAllCaches(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearAllCaches(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processClearAllCaches = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CachingServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], CachingServiceProxy);
    return CachingServiceProxy;
}());
export { CachingServiceProxy };
var ChatServiceProxy = /** @class */ (function () {
    function ChatServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ChatServiceProxy.prototype.getUserChatFriendsWithSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserChatFriendsWithSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processGetUserChatFriendsWithSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetUserChatFriendsWithSettingsOutput.fromJS(resultData200) : new GetUserChatFriendsWithSettingsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tenantId (optional)
     * @userId (optional)
     * @minMessageId (optional)
     * @return Success
     */
    ChatServiceProxy.prototype.getUserChatMessages = function (tenantId, userId, minMessageId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserChatMessages(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processGetUserChatMessages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfChatMessageDto.fromJS(resultData200) : new ListResultDtoOfChatMessageDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ChatServiceProxy.prototype.markAllUnreadMessagesOfUserAsRead = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAllUnreadMessagesOfUserAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processMarkAllUnreadMessagesOfUserAsRead = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ChatServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ChatServiceProxy);
    return ChatServiceProxy;
}());
export { ChatServiceProxy };
var CommonLookupServiceProxy = /** @class */ (function () {
    function CommonLookupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @onlyFreeItems (optional)
     * @return Success
     */
    CommonLookupServiceProxy.prototype.getEditionsForCombobox = function (onlyFreeItems) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionsForCombobox(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processGetEditionsForCombobox = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200) : new ListResultDtoOfSubscribableEditionComboboxItemDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CommonLookupServiceProxy.prototype.findUsers = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processFindUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    CommonLookupServiceProxy.prototype.getDefaultEditionName = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDefaultEditionName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processGetDefaultEditionName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetDefaultEditionNameOutput.fromJS(resultData200) : new GetDefaultEditionNameOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CommonLookupServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], CommonLookupServiceProxy);
    return CommonLookupServiceProxy;
}());
export { CommonLookupServiceProxy };
var ConfigureServiceProxy = /** @class */ (function () {
    function ConfigureServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.updateConfigure = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/UpdateConfigure";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateConfigure(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateConfigure(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processUpdateConfigure = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.initialize = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/Initialize";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processInitialize(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processInitialize(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processInitialize = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dataSourceId (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.getTypeName = function (dataSourceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/GetTypeName?";
        if (dataSourceId !== undefined)
            url_ += "dataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTypeName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTypeName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processGetTypeName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetBoxTypeNameDto.fromJS(resultData200) : new GetBoxTypeNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.getConfigureViews = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/GetConfigureViews?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureViews(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureViews(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processGetConfigureViews = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfConfigureViewListDto.fromJS(resultData200) : new ListResultDtoOfConfigureViewListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.getMainViewIndex = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/GetMainViewIndex?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMainViewIndex(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMainViewIndex(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processGetMainViewIndex = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? MainViewIndexDto.fromJS(resultData200) : new MainViewIndexDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.saveElementPassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/SaveElementPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveElementPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveElementPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processSaveElementPassword = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.getElementPassword = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/GetElementPassword?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetElementPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetElementPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processGetElementPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureServiceProxy.prototype.updateDataSourcePlcInfos = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configure/UpdateDataSourcePlcInfos";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDataSourcePlcInfos(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDataSourcePlcInfos(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureServiceProxy.prototype.processUpdateDataSourcePlcInfos = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureServiceProxy);
    return ConfigureServiceProxy;
}());
export { ConfigureServiceProxy };
var ConfigureDashboardServiceProxy = /** @class */ (function () {
    function ConfigureDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * Get configure dashboards by configure id
     * @configureId (optional)
     * @return Success
     */
    ConfigureDashboardServiceProxy.prototype.getConfigureDashboards = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureDashboard/GetConfigureDashboards?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureDashboards(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureDashboards(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureDashboardServiceProxy.prototype.processGetConfigureDashboards = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(ConfigureDashboardDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * create configure dashboard or update configure dashboard name
     * @input (optional)
     * @return Success
     */
    ConfigureDashboardServiceProxy.prototype.saveConfigureDashboardName = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureDashboard/SaveConfigureDashboardName";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveConfigureDashboardName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveConfigureDashboardName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureDashboardServiceProxy.prototype.processSaveConfigureDashboardName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SaveConfigureDashboardResultDto.fromJS(resultData200) : new SaveConfigureDashboardResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * save configure dashboard name
     * @input (optional)
     * @return Success
     */
    ConfigureDashboardServiceProxy.prototype.saveConfigureDashboardContent = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureDashboard/SaveConfigureDashboardContent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveConfigureDashboardContent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveConfigureDashboardContent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureDashboardServiceProxy.prototype.processSaveConfigureDashboardContent = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Delete dashboard by Id
     * @id (optional)
     * @return Success
     */
    ConfigureDashboardServiceProxy.prototype.deleteDashboard = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureDashboard/DeleteDashboard?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureDashboardServiceProxy.prototype.processDeleteDashboard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * save grid item in dashboard
     * @input (optional)
     * @return Success
     */
    ConfigureDashboardServiceProxy.prototype.saveDashboardItem = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureDashboard/SaveDashboardItem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveDashboardItem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveDashboardItem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureDashboardServiceProxy.prototype.processSaveDashboardItem = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureDashboardServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureDashboardServiceProxy);
    return ConfigureDashboardServiceProxy;
}());
export { ConfigureDashboardServiceProxy };
var ConfigureEventServiceProxy = /** @class */ (function () {
    function ConfigureEventServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @configureId (optional)
     * @groupId (optional)
     * @eventNameOrVariableName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ConfigureEventServiceProxy.prototype.getEvents = function (configureId, groupId, eventNameOrVariableName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEvent/GetEvents?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (eventNameOrVariableName !== undefined)
            url_ += "EventNameOrVariableName=" + encodeURIComponent("" + eventNameOrVariableName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEvents(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEvents(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventServiceProxy.prototype.processGetEvents = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfEventListDto.fromJS(resultData200) : new PagedResultDtoOfEventListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureEventServiceProxy.prototype.getEventForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEvent/GetEventForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventServiceProxy.prototype.processGetEventForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EventForEditDto.fromJS(resultData200) : new EventForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureEventServiceProxy.prototype.createOrUpdateEvent = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEvent/CreateOrUpdateEvent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateEvent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateEvent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventServiceProxy.prototype.processCreateOrUpdateEvent = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureEventServiceProxy.prototype.batchEditEvents = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEvent/BatchEditEvents";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchEditEvents(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchEditEvents(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventServiceProxy.prototype.processBatchEditEvents = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @id (optional)
     * @return Success
     */
    ConfigureEventServiceProxy.prototype.deleteEvent = function (configureId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEvent/DeleteEvent?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteEvent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteEvent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventServiceProxy.prototype.processDeleteEvent = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureEventServiceProxy.prototype.batchDeleteEvent = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEvent/BatchDeleteEvent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchDeleteEvent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchDeleteEvent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventServiceProxy.prototype.processBatchDeleteEvent = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureEventServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureEventServiceProxy);
    return ConfigureEventServiceProxy;
}());
export { ConfigureEventServiceProxy };
var ConfigureEventGroupServiceProxy = /** @class */ (function () {
    function ConfigureEventGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @configureId (optional)
     * @return Success
     */
    ConfigureEventGroupServiceProxy.prototype.getEventGroups = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEventGroup/GetEventGroups?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventGroupServiceProxy.prototype.processGetEventGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(EventGroupListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureEventGroupServiceProxy.prototype.createOrUpdateEventGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEventGroup/CreateOrUpdateEventGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateEventGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateEventGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventGroupServiceProxy.prototype.processCreateOrUpdateEventGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @id (optional)
     * @return Success
     */
    ConfigureEventGroupServiceProxy.prototype.deleteEventGroup = function (configureId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureEventGroup/DeleteEventGroup?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteEventGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteEventGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureEventGroupServiceProxy.prototype.processDeleteEventGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureEventGroupServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureEventGroupServiceProxy);
    return ConfigureEventGroupServiceProxy;
}());
export { ConfigureEventGroupServiceProxy };
var ConfigureGalleryServiceProxy = /** @class */ (function () {
    function ConfigureGalleryServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.getGraphs = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/GetGraphs?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processGetGraphs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfConfigureGraphDto.fromJS(resultData200) : new IListResultOfConfigureGraphDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @id (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.getGraphStates = function (configureId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/GetGraphStates?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphStates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphStates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processGetGraphStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfConfigureGraphStateDto.fromJS(resultData200) : new IListResultOfConfigureGraphStateDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @id (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.getGraphForEdit = function (configureId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/GetGraphForEdit?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processGetGraphForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ConfigureGraphEditDto.fromJS(resultData200) : new ConfigureGraphEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.createOrUpdateGraph = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/CreateOrUpdateGraph";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateGraph(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateGraph(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processCreateOrUpdateGraph = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tempFileIds (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.deleteTempGraph = function (tempFileIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/DeleteTempGraph?";
        if (tempFileIds !== undefined)
            tempFileIds && tempFileIds.forEach(function (item) { url_ += "TempFileIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTempGraph(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTempGraph(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processDeleteTempGraph = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.getGraphUrl = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/GetGraphUrl?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processGetGraphUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GraphStateUrlDto.fromJS(resultData200) : new GraphStateUrlDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.getConfigureGraphSettings = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/GetConfigureGraphSettings?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureGraphSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureGraphSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processGetConfigureGraphSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(GraphSettingDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.importConfigureGraphIntoUserGallery = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/ImportConfigureGraphIntoUserGallery";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportConfigureGraphIntoUserGallery(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportConfigureGraphIntoUserGallery(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processImportConfigureGraphIntoUserGallery = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.coverUserGalleryFromConfigureGallery = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/CoverUserGalleryFromConfigureGallery";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCoverUserGalleryFromConfigureGallery(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCoverUserGalleryFromConfigureGallery(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processCoverUserGalleryFromConfigureGallery = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureGalleryServiceProxy.prototype.pullConfigureGraphStates = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureGallery/PullConfigureGraphStates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPullConfigureGraphStates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPullConfigureGraphStates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureGalleryServiceProxy.prototype.processPullConfigureGraphStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfGetConfigureGraphStateResultDto.fromJS(resultData200) : new IListResultOfGetConfigureGraphStateResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureGalleryServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureGalleryServiceProxy);
    return ConfigureGalleryServiceProxy;
}());
export { ConfigureGalleryServiceProxy };
var ConfigurePermissionServiceProxy = /** @class */ (function () {
    function ConfigurePermissionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    ConfigurePermissionServiceProxy.prototype.deletePermission = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigurePermission/DeletePermission?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeletePermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeletePermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigurePermissionServiceProxy.prototype.processDeletePermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @permissionDto (optional)
     * @return Success
     */
    ConfigurePermissionServiceProxy.prototype.saveConfigurePermission = function (permissionDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigurePermission/SaveConfigurePermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(permissionDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveConfigurePermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveConfigurePermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigurePermissionServiceProxy.prototype.processSaveConfigurePermission = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ConfigurePermissionDto.fromJS(resultData200) : new ConfigurePermissionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigurePermissionServiceProxy.prototype.checkConfigurePermissionUsed = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigurePermission/CheckConfigurePermissionUsed";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckConfigurePermissionUsed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckConfigurePermissionUsed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigurePermissionServiceProxy.prototype.processCheckConfigurePermissionUsed = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigurePermissionServiceProxy.prototype.getConfigurePermissions = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigurePermission/GetConfigurePermissions?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigurePermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigurePermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigurePermissionServiceProxy.prototype.processGetConfigurePermissions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfConfigurePermissionDto.fromJS(resultData200) : new IListResultOfConfigurePermissionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigurePermissionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigurePermissionServiceProxy);
    return ConfigurePermissionServiceProxy;
}());
export { ConfigurePermissionServiceProxy };
var ConfigureReleaseServiceProxy = /** @class */ (function () {
    function ConfigureReleaseServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureReleaseServiceProxy.prototype.releaseConfigure = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureRelease/ReleaseConfigure";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processReleaseConfigure(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processReleaseConfigure(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureReleaseServiceProxy.prototype.processReleaseConfigure = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureReleaseServiceProxy.prototype.getDeletedDataSources = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureRelease/GetDeletedDataSources?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeletedDataSources(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeletedDataSources(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureReleaseServiceProxy.prototype.processGetDeletedDataSources = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfDeletedDataSourceDto.fromJS(resultData200) : new IListResultOfDeletedDataSourceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureReleaseServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureReleaseServiceProxy);
    return ConfigureReleaseServiceProxy;
}());
export { ConfigureReleaseServiceProxy };
var ConfigureSettingsServiceProxy = /** @class */ (function () {
    function ConfigureSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ConfigureSettingsServiceProxy.prototype.getSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureSettings/GetSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureSettingsServiceProxy.prototype.processGetSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ConfigureSettingsDto.fromJS(resultData200) : new ConfigureSettingsDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @settings (optional)
     * @return Success
     */
    ConfigureSettingsServiceProxy.prototype.saveSettings = function (settings) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureSettings/SaveSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(settings);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureSettingsServiceProxy.prototype.processSaveSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureSettingsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureSettingsServiceProxy);
    return ConfigureSettingsServiceProxy;
}());
export { ConfigureSettingsServiceProxy };
var ConfigureVideoServiceProxy = /** @class */ (function () {
    function ConfigureVideoServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureVideoServiceProxy.prototype.getConfigureVideos = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureVideo/GetConfigureVideos?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureVideos(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureVideos(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureVideoServiceProxy.prototype.processGetConfigureVideos = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfConfigureVideoDto.fromJS(resultData200) : new IListResultOfConfigureVideoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureVideoServiceProxy.prototype.getConfigureVideoNames = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureVideo/GetConfigureVideoNames?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureVideoNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureVideoNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureVideoServiceProxy.prototype.processGetConfigureVideoNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfConfigureVideoNameDto.fromJS(resultData200) : new IListResultOfConfigureVideoNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureVideoServiceProxy.prototype.deleteVideo = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureVideo/DeleteVideo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteVideo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteVideo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureVideoServiceProxy.prototype.processDeleteVideo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureVideoDto (optional)
     * @return Success
     */
    ConfigureVideoServiceProxy.prototype.saveConfigureVideo = function (configureVideoDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureVideo/SaveConfigureVideo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(configureVideoDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveConfigureVideo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveConfigureVideo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureVideoServiceProxy.prototype.processSaveConfigureVideo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ConfigureVideoDto.fromJS(resultData200) : new ConfigureVideoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureVideoServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureVideoServiceProxy);
    return ConfigureVideoServiceProxy;
}());
export { ConfigureVideoServiceProxy };
var ConfigureViewServiceProxy = /** @class */ (function () {
    function ConfigureViewServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.createOrUpdateView = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/CreateOrUpdateView";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processCreateOrUpdateView = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.getConfigureViewsNames = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/GetConfigureViewsNames?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureViewsNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureViewsNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processGetConfigureViewsNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfConfigureViewNameDto.fromJS(resultData200) : new IListResultOfConfigureViewNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.getViewConfigure = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/GetViewConfigure?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetViewConfigure(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetViewConfigure(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processGetViewConfigure = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ViewConfigureDto.fromJS(resultData200) : new ViewConfigureDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.getViewConfigures = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/GetViewConfigures?";
        if (input !== undefined)
            input && input.forEach(function (item) { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetViewConfigures(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetViewConfigures(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processGetViewConfigures = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfViewConfiguresDto.fromJS(resultData200) : new IListResultOfViewConfiguresDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.deleteConfigureView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/DeleteConfigureView?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteConfigureView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteConfigureView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processDeleteConfigureView = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.copyConfigureView = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/CopyConfigureView";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCopyConfigureView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCopyConfigureView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processCopyConfigureView = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.setWebMainView = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/SetWebMainView";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetWebMainView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetWebMainView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processSetWebMainView = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.setMobileMainView = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/SetMobileMainView";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetMobileMainView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetMobileMainView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processSetMobileMainView = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.resetMobileMainView = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/ResetMobileMainView";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetMobileMainView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetMobileMainView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processResetMobileMainView = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @viewType (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.getConfigureViewsNamesByType = function (configureId, viewType) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/GetConfigureViewsNamesByType?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (viewType !== undefined)
            url_ += "ViewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureViewsNamesByType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureViewsNamesByType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processGetConfigureViewsNamesByType = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfConfigureViewNameDto.fromJS(resultData200) : new IListResultOfConfigureViewNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @type (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.getConfigureViewSetting = function (configureId, type) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/GetConfigureViewSetting?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureViewSetting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureViewSetting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processGetConfigureViewSetting = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ConfigureViewSettingDto.fromJS(resultData200) : new ConfigureViewSettingDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ConfigureViewServiceProxy.prototype.updateConfigureViewSetting = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConfigureView/UpdateConfigureViewSetting";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateConfigureViewSetting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateConfigureViewSetting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConfigureViewServiceProxy.prototype.processUpdateConfigureViewSetting = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ConfigureViewServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ConfigureViewServiceProxy);
    return ConfigureViewServiceProxy;
}());
export { ConfigureViewServiceProxy };
var CustomManualNotificationServiceProxy = /** @class */ (function () {
    function CustomManualNotificationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @titleOrContent (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    CustomManualNotificationServiceProxy.prototype.getNotifications = function (titleOrContent, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomManualNotification/GetNotifications?";
        if (titleOrContent !== undefined)
            url_ += "TitleOrContent=" + encodeURIComponent("" + titleOrContent) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNotifications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNotifications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomManualNotificationServiceProxy.prototype.processGetNotifications = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetNotificationOutputDto.fromJS(resultData200) : new PagedResultDtoOfGetNotificationOutputDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CustomManualNotificationServiceProxy.prototype.createOrEdit = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomManualNotification/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomManualNotificationServiceProxy.prototype.processCreateOrEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CustomManualNotificationServiceProxy.prototype.publish = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomManualNotification/Publish";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPublish(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPublish(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomManualNotificationServiceProxy.prototype.processPublish = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CustomManualNotificationServiceProxy.prototype.revoke = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomManualNotification/Revoke";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRevoke(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRevoke(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomManualNotificationServiceProxy.prototype.processRevoke = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    CustomManualNotificationServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomManualNotification/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomManualNotificationServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CustomManualNotificationServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], CustomManualNotificationServiceProxy);
    return CustomManualNotificationServiceProxy;
}());
export { CustomManualNotificationServiceProxy };
var CustomTitleServiceProxy = /** @class */ (function () {
    function CustomTitleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取当前用户用户的所有显示自定义列
     * @return Success
     */
    CustomTitleServiceProxy.prototype.getAllTitleInfo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomTitle/GetAllTitleInfo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllTitleInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllTitleInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomTitleServiceProxy.prototype.processGetAllTitleInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(TitleInfoDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 修改指定表的显示自定义列
     * @input (optional) 修改模型
     * @return Success
     */
    CustomTitleServiceProxy.prototype.updateTitleInfo = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomTitle/UpdateTitleInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTitleInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTitleInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomTitleServiceProxy.prototype.processUpdateTitleInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(TitleInfoDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CustomTitleServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], CustomTitleServiceProxy);
    return CustomTitleServiceProxy;
}());
export { CustomTitleServiceProxy };
var DashboardServiceProxy = /** @class */ (function () {
    function DashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    DashboardServiceProxy.prototype.getDashboards = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboards";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboards(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboards(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetDashboards = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                        var item = resultData200_14[_i];
                        result200.push(DashboardListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DashboardServiceProxy.prototype.checkCurrentDashBoardCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/CheckCurrentDashBoardCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckCurrentDashBoardCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckCurrentDashBoardCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processCheckCurrentDashBoardCount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.saveDashboard = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/SaveDashboard";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processSaveDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.reOrderDashBoard = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/ReOrderDashBoard";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processReOrderDashBoard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processReOrderDashBoard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processReOrderDashBoard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.saveDashBoardContent = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/SaveDashBoardContent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveDashBoardContent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveDashBoardContent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processSaveDashBoardContent = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dashboardId (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.getDashboardByIdAsync = function (dashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardByIdAsync?";
        if (dashboardId !== undefined)
            url_ += "DashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardByIdAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardByIdAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetDashboardByIdAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? Dashboard.fromJS(resultData200) : new Dashboard();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dashboardId (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.deleteDashboardAsync = function (dashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/DeleteDashboardAsync?";
        if (dashboardId !== undefined)
            url_ += "DashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDashboardAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDashboardAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processDeleteDashboardAsync = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dashboardId (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.getDashboardPermissionByDashboardIdAsync = function (dashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardPermissionByDashboardIdAsync?";
        if (dashboardId !== undefined)
            url_ += "DashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardPermissionByDashboardIdAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardPermissionByDashboardIdAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetDashboardPermissionByDashboardIdAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_15 = resultData200; _i < resultData200_15.length; _i++) {
                        var item = resultData200_15[_i];
                        result200.push(TargetOwnerPermission.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dashboardId (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.getDashboardOwnerInfoAsync = function (dashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardOwnerInfoAsync?";
        if (dashboardId !== undefined)
            url_ += "DashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardOwnerInfoAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardOwnerInfoAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetDashboardOwnerInfoAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_16 = resultData200; _i < resultData200_16.length; _i++) {
                        var item = resultData200_16[_i];
                        result200.push(DashboardOwnerInfoDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dashboardId (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.getUsersInfoForDashboardPermissionByDashboardIdAsync = function (dashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetUsersInfoForDashboardPermissionByDashboardIdAsync?";
        if (dashboardId !== undefined)
            url_ += "DashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsersInfoForDashboardPermissionByDashboardIdAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsersInfoForDashboardPermissionByDashboardIdAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetUsersInfoForDashboardPermissionByDashboardIdAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_17 = resultData200; _i < resultData200_17.length; _i++) {
                        var item = resultData200_17[_i];
                        result200.push(User.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.checkReportIsExistInDashboard = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/CheckReportIsExistInDashboard";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckReportIsExistInDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckReportIsExistInDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processCheckReportIsExistInDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @reportTitle (optional)
     * @reportDisplayType (optional)
     * @selectedReportIds (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.getReportsAsync = function (reportTitle, reportDisplayType, selectedReportIds, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetReportsAsync?";
        if (reportTitle !== undefined)
            url_ += "ReportTitle=" + encodeURIComponent("" + reportTitle) + "&";
        if (reportDisplayType !== undefined)
            url_ += "ReportDisplayType=" + encodeURIComponent("" + reportDisplayType) + "&";
        if (selectedReportIds !== undefined)
            selectedReportIds && selectedReportIds.forEach(function (item) { url_ += "SelectedReportIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReportsAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReportsAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetReportsAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfReportListDto.fromJS(resultData200) : new PagedResultDtoOfReportListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.updateDashboardTheme = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/UpdateDashboardTheme";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDashboardTheme(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDashboardTheme(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processUpdateDashboardTheme = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DashboardServiceProxy.prototype.getCurrentUserDashboardTheme = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetCurrentUserDashboardTheme";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentUserDashboardTheme(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentUserDashboardTheme(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetCurrentUserDashboardTheme = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DashboardThemeDto.fromJS(resultData200) : new DashboardThemeDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.updateDashboardRefreshCycle = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/UpdateDashboardRefreshCycle";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDashboardRefreshCycle(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDashboardRefreshCycle(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processUpdateDashboardRefreshCycle = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DashboardServiceProxy.prototype.getCurrentDashboardRefreshCycle = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetCurrentDashboardRefreshCycle";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentDashboardRefreshCycle(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentDashboardRefreshCycle(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetCurrentDashboardRefreshCycle = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dashboardId (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.getDashboardMapOption = function (dashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardMapOption?";
        if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardMapOption(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardMapOption(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetDashboardMapOption = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UpdateUserMapInfoDto.fromJS(resultData200) : new UpdateUserMapInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DashboardServiceProxy.prototype.updateDashBoardMapInfo = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Dashboard/UpdateDashBoardMapInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDashBoardMapInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDashBoardMapInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processUpdateDashBoardMapInfo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DashboardServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DashboardServiceProxy);
    return DashboardServiceProxy;
}());
export { DashboardServiceProxy };
var DataDictionaryServiceProxy = /** @class */ (function () {
    function DataDictionaryServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @dictionaryItemId (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.deleteDictionaryItem = function (dictionaryItemId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/DeleteDictionaryItem?";
        if (dictionaryItemId !== undefined)
            url_ += "DictionaryItemId=" + encodeURIComponent("" + dictionaryItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDictionaryItem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDictionaryItem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processDeleteDictionaryItem = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.getDataDictionary = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/GetDataDictionary";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataDictionary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataDictionary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processGetDataDictionary = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDictionaryDto.fromJS(resultData200) : new ListResultDtoOfDictionaryDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @code (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.getDataDictionaryItemByCode = function (code) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/GetDataDictionaryItemByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataDictionaryItemByCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataDictionaryItemByCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processGetDataDictionaryItemByCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDictionaryItemDto.fromJS(resultData200) : new ListResultDtoOfDictionaryItemDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dataDictionaryId (optional)
     * @queryStr (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.getDataDictionaryItemByType = function (dataDictionaryId, queryStr, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/GetDataDictionaryItemByType?";
        if (dataDictionaryId !== undefined)
            url_ += "DataDictionaryId=" + encodeURIComponent("" + dataDictionaryId) + "&";
        if (queryStr !== undefined)
            url_ += "QueryStr=" + encodeURIComponent("" + queryStr) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataDictionaryItemByType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataDictionaryItemByType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processGetDataDictionaryItemByType = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDictionaryItemDto.fromJS(resultData200) : new PagedResultDtoOfDictionaryItemDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dataDictionaryId (optional)
     * @queryStr (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.getPagedHostDataDictionaryItems = function (dataDictionaryId, queryStr, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/GetPagedHostDataDictionaryItems?";
        if (dataDictionaryId !== undefined)
            url_ += "DataDictionaryId=" + encodeURIComponent("" + dataDictionaryId) + "&";
        if (queryStr !== undefined)
            url_ += "QueryStr=" + encodeURIComponent("" + queryStr) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPagedHostDataDictionaryItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPagedHostDataDictionaryItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processGetPagedHostDataDictionaryItems = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfHostDataDictionaryItem.fromJS(resultData200) : new PagedResultDtoOfHostDataDictionaryItem();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.getDictionaryCodeObject = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/GetDictionaryCodeObject";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDictionaryCodeObject(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDictionaryCodeObject(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processGetDictionaryCodeObject = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DictionaryCode.fromJS(resultData200) : new DictionaryCode();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @queryStr (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.getPagedDataDictionary = function (queryStr, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/GetPagedDataDictionary?";
        if (queryStr !== undefined)
            url_ += "QueryStr=" + encodeURIComponent("" + queryStr) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPagedDataDictionary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPagedDataDictionary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processGetPagedDataDictionary = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDictionaryDto.fromJS(resultData200) : new PagedResultDtoOfDictionaryDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.insertOrUpdateDictionary = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/InsertOrUpdateDictionary";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processInsertOrUpdateDictionary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processInsertOrUpdateDictionary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processInsertOrUpdateDictionary = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.insetOrUpdateDictionaryItem = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/InsetOrUpdateDictionaryItem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processInsetOrUpdateDictionaryItem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processInsetOrUpdateDictionaryItem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processInsetOrUpdateDictionaryItem = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DataDictionaryServiceProxy.prototype.insertHostDictionaryItem = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataDictionary/InsertHostDictionaryItem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processInsertHostDictionaryItem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processInsertHostDictionaryItem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataDictionaryServiceProxy.prototype.processInsertHostDictionaryItem = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DataDictionaryServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DataDictionaryServiceProxy);
    return DataDictionaryServiceProxy;
}());
export { DataDictionaryServiceProxy };
var DataSourceServiceProxy = /** @class */ (function () {
    function DataSourceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.saveDataSource = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/SaveDataSource";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveDataSource(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveDataSource(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processSaveDataSource = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.deleteDataSource = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/DeleteDataSource?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDataSource(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDataSource(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processDeleteDataSource = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.getDataSourceForDataConfigByConfigureId = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/GetDataSourceForDataConfigByConfigureId?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataSourceForDataConfigByConfigureId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataSourceForDataConfigByConfigureId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processGetDataSourceForDataConfigByConfigureId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_18 = resultData200; _i < resultData200_18.length; _i++) {
                        var item = resultData200_18[_i];
                        result200.push(DataSourceForDataConfigDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.getDataSourcesByConfigureId = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/GetDataSourcesByConfigureId?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataSourcesByConfigureId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataSourcesByConfigureId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processGetDataSourcesByConfigureId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_19 = resultData200; _i < resultData200_19.length; _i++) {
                        var item = resultData200_19[_i];
                        result200.push(DataSourceDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.getById = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/GetById?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processGetById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DataSourceDto.fromJS(resultData200) : new DataSourceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 数据源导入功能
     * @input (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.dataSourceImport = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/DataSourceImport";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDataSourceImport(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDataSourceImport(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processDataSourceImport = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.buildDataAfterImportCheckVariableOrAlarmNameRepeat = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/BuildDataAfterImportCheckVariableOrAlarmNameRepeat";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBuildDataAfterImportCheckVariableOrAlarmNameRepeat(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBuildDataAfterImportCheckVariableOrAlarmNameRepeat(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processBuildDataAfterImportCheckVariableOrAlarmNameRepeat = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DataSourceServiceProxy.prototype.buildDataAfterImport = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSource/BuildDataAfterImport";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBuildDataAfterImport(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBuildDataAfterImport(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceServiceProxy.prototype.processBuildDataAfterImport = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DataSourceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DataSourceServiceProxy);
    return DataSourceServiceProxy;
}());
export { DataSourceServiceProxy };
var DataSourceImportInfoServiceProxy = /** @class */ (function () {
    function DataSourceImportInfoServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    DataSourceImportInfoServiceProxy.prototype.createOrUpdateDataSourceImportInfo = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSourceImportInfo/CreateOrUpdateDataSourceImportInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateDataSourceImportInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateDataSourceImportInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceImportInfoServiceProxy.prototype.processCreateOrUpdateDataSourceImportInfo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DataSourceImportInfoServiceProxy.prototype.getBoxAccountForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DataSourceImportInfo/GetBoxAccountForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBoxAccountForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBoxAccountForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DataSourceImportInfoServiceProxy.prototype.processGetBoxAccountForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetDataSourceImportInfoForEditDto.fromJS(resultData200) : new GetDataSourceImportInfoForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DataSourceImportInfoServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DataSourceImportInfoServiceProxy);
    return DataSourceImportInfoServiceProxy;
}());
export { DataSourceImportInfoServiceProxy };
var DemoUiComponentsServiceProxy = /** @class */ (function () {
    function DemoUiComponentsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @date (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDate = function (date) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @date (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDateTime = function (date) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDateTime(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDateTime = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @startDate (optional)
     * @endDate (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDateRange = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDateRange(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDateRange = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @searchTerm (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.getCountries = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processGetCountries = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_20 = resultData200; _i < resultData200_20.length; _i++) {
                        var item = resultData200_20[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @selectedCountries (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetSelectedCountries = function (selectedCountries) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(selectedCountries);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetSelectedCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetSelectedCountries = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_21 = resultData200; _i < resultData200_21.length; _i++) {
                        var item = resultData200_21[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetValue = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetValue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetValue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetValue = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? StringOutput.fromJS(resultData200) : new StringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DemoUiComponentsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DemoUiComponentsServiceProxy);
    return DemoUiComponentsServiceProxy;
}());
export { DemoUiComponentsServiceProxy };
var DeviceServiceProxy = /** @class */ (function () {
    function DeviceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取设备信息用于编辑
     * @id (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.getDeviceForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/GetDeviceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processGetDeviceForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceForEditDto.fromJS(resultData200) : new DeviceForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 新增编辑或更新设备
     * @input (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.createOrUpdateDevice = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/CreateOrUpdateDevice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateDevice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateDevice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processCreateOrUpdateDevice = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OperationResultDto.fromJS(resultData200) : new OperationResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除设备
     * @id (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.deleteDevice = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/DeleteDevice?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDevice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDevice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processDeleteDevice = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量删除设备
     * @deviceIdList (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.batchDeleteDevice = function (deviceIdList) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/BatchDeleteDevice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(deviceIdList);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchDeleteDevice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchDeleteDevice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processBatchDeleteDevice = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 复制设备
     * @input (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.copyDevice = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/CopyDevice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCopyDevice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCopyDevice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processCopyDevice = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除临时文件
     * @id (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.deleteTempDevicePicture = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/DeleteTempDevicePicture?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTempDevicePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTempDevicePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processDeleteTempDevicePicture = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 上传设备图片到临时目录
     * @file (optional) 文件流
     * @return Success
     */
    DeviceServiceProxy.prototype.createDevicePictureTempFile = function (file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/CreateDevicePictureTempFile?";
        if (file !== undefined)
            url_ += "File=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateDevicePictureTempFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateDevicePictureTempFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processCreateDevicePictureTempFile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 下载设备图片
     * @input (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.downloadDevicePicture = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/DownloadDevicePicture";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDownloadDevicePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDownloadDevicePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processDownloadDevicePicture = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取设备图片
     * @id (optional)
     * @return Success
     */
    DeviceServiceProxy.prototype.getPicturesForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Device/GetPicturesForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPicturesForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPicturesForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceServiceProxy.prototype.processGetPicturesForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_22 = resultData200; _i < resultData200_22.length; _i++) {
                        var item = resultData200_22[_i];
                        result200.push(DevicePictureDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceServiceProxy);
    return DeviceServiceProxy;
}());
export { DeviceServiceProxy };
var DeviceCameraServiceProxy = /** @class */ (function () {
    function DeviceCameraServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    DeviceCameraServiceProxy.prototype.bindCamera = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCamera/BindCamera";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBindCamera(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBindCamera(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCameraServiceProxy.prototype.processBindCamera = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceCameraServiceProxy.prototype.unBindCamera = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCamera/UnBindCamera";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnBindCamera(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnBindCamera(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCameraServiceProxy.prototype.processUnBindCamera = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceCameraServiceProxy.prototype.getCameras = function (deviceId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCamera/GetCameras?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCameras(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCameras(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCameraServiceProxy.prototype.processGetCameras = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCameraListDto.fromJS(resultData200) : new PagedResultDtoOfCameraListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @return Success
     */
    DeviceCameraServiceProxy.prototype.getLiveCameras = function (deviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCamera/GetLiveCameras?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLiveCameras(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLiveCameras(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCameraServiceProxy.prototype.processGetLiveCameras = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_23 = resultData200; _i < resultData200_23.length; _i++) {
                        var item = resultData200_23[_i];
                        result200.push(LiveCameraDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @return Success
     */
    DeviceCameraServiceProxy.prototype.existCamera = function (deviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCamera/ExistCamera?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExistCamera(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExistCamera(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCameraServiceProxy.prototype.processExistCamera = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceCameraServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceCameraServiceProxy);
    return DeviceCameraServiceProxy;
}());
export { DeviceCameraServiceProxy };
var DeviceCustomFieldServiceProxy = /** @class */ (function () {
    function DeviceCustomFieldServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceCustomFieldServiceProxy.prototype.getCustomField = function (sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCustomField/GetCustomField?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCustomField(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCustomField(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCustomFieldServiceProxy.prototype.processGetCustomField = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCustomFieldDto.fromJS(resultData200) : new PagedResultDtoOfCustomFieldDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DeviceCustomFieldServiceProxy.prototype.getCustomFieldForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCustomField/GetCustomFieldForEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCustomFieldForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCustomFieldForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCustomFieldServiceProxy.prototype.processGetCustomFieldForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CustomFieldDto.fromJS(resultData200) : new CustomFieldDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceCustomFieldServiceProxy.prototype.addOrUpdateCustomField = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCustomField/AddOrUpdateCustomField";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddOrUpdateCustomField(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddOrUpdateCustomField(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCustomFieldServiceProxy.prototype.processAddOrUpdateCustomField = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DeviceCustomFieldServiceProxy.prototype.deleteCustomField = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCustomField/DeleteCustomField?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteCustomField(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteCustomField(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCustomFieldServiceProxy.prototype.processDeleteCustomField = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @return Success
     */
    DeviceCustomFieldServiceProxy.prototype.getAllCustomFieldAndDetail = function (deviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCustomField/GetAllCustomFieldAndDetail?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCustomFieldAndDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCustomFieldAndDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCustomFieldServiceProxy.prototype.processGetAllCustomFieldAndDetail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfCustomFieldDto.fromJS(resultData200) : new ListResultDtoOfCustomFieldDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @return Success
     */
    DeviceCustomFieldServiceProxy.prototype.getFieldDetailForShow = function (deviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceCustomField/GetFieldDetailForShow?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFieldDetailForShow(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFieldDetailForShow(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceCustomFieldServiceProxy.prototype.processGetFieldDetailForShow = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfCustomFieldDetailForShowDto.fromJS(resultData200) : new ListResultDtoOfCustomFieldDetailForShowDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceCustomFieldServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceCustomFieldServiceProxy);
    return DeviceCustomFieldServiceProxy;
}());
export { DeviceCustomFieldServiceProxy };
var DeviceDashboardServiceProxy = /** @class */ (function () {
    function DeviceDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取设备仪表盘组态
     * @deviceDashboardId (optional)
     * @return Success
     */
    DeviceDashboardServiceProxy.prototype.getDeviceDashboard = function (deviceDashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDashboard/GetDeviceDashboard?";
        if (deviceDashboardId !== undefined)
            url_ += "DeviceDashboardId=" + encodeURIComponent("" + deviceDashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDashboardServiceProxy.prototype.processGetDeviceDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceDashboardDto.fromJS(resultData200) : new DeviceDashboardDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 修改设备仪表盘表中组态
     * @input (optional) 修改模型
     * @return Success
     */
    DeviceDashboardServiceProxy.prototype.updateDeviceDashboard = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDashboard/UpdateDeviceDashboard";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDeviceDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDeviceDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDashboardServiceProxy.prototype.processUpdateDeviceDashboard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 创建仪表盘
    创建仪表盘时,先往当前order表中插入一条数据,然后再添加一个空的仪表盘
     * @input (optional) 创建仪表盘模型
     * @return Success
     */
    DeviceDashboardServiceProxy.prototype.createDeviceDashboard = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDashboard/CreateDeviceDashboard";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateDeviceDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateDeviceDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDashboardServiceProxy.prototype.processCreateDeviceDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceDashboardOrderDto.fromJS(resultData200) : new DeviceDashboardOrderDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 修改仪表盘Order
     * @input (optional) 修改模型
     * @return Success
     */
    DeviceDashboardServiceProxy.prototype.updateOrders = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDashboard/UpdateOrders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDashboardServiceProxy.prototype.processUpdateOrders = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除设备仪表盘
    删除设备仪表盘首先需要删除其order,然后将order中index重新排序
    然后再删除仪表盘
     * @dashboardId (optional)
     * @return Success
     */
    DeviceDashboardServiceProxy.prototype.deleteDeviceDashboard = function (dashboardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDashboard/DeleteDeviceDashboard?";
        if (dashboardId !== undefined)
            url_ += "DashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDeviceDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDeviceDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDashboardServiceProxy.prototype.processDeleteDeviceDashboard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DeviceDashboardServiceProxy.prototype.getDeviceDashboardOrders = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDashboard/GetDeviceDashboardOrders?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceDashboardOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceDashboardOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDashboardServiceProxy.prototype.processGetDeviceDashboardOrders = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_24 = resultData200; _i < resultData200_24.length; _i++) {
                        var item = resultData200_24[_i];
                        result200.push(DeviceDashboardOrderDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceDashboardServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceDashboardServiceProxy);
    return DeviceDashboardServiceProxy;
}());
export { DeviceDashboardServiceProxy };
var DeviceDetailServiceProxy = /** @class */ (function () {
    function DeviceDetailServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取设备详情
     * @id (optional)
     * @return Success
     */
    DeviceDetailServiceProxy.prototype.getDeviceDetails = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDetail/GetDeviceDetails?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceDetails(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceDetails(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDetailServiceProxy.prototype.processGetDeviceDetails = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceDetailDto.fromJS(resultData200) : new DeviceDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取设备IoT配置信息
     * @id (optional)
     * @return Success
     */
    DeviceDetailServiceProxy.prototype.getDeviceForIotConfigure = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDetail/GetDeviceForIotConfigure?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceForIotConfigure(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceForIotConfigure(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDetailServiceProxy.prototype.processGetDeviceForIotConfigure = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceForIoTDto.fromJS(resultData200) : new DeviceForIoTDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取设备基本信息
     * @id (optional)
     * @return Success
     */
    DeviceDetailServiceProxy.prototype.getDeviceBaseInfo = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDetail/GetDeviceBaseInfo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceBaseInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceBaseInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDetailServiceProxy.prototype.processGetDeviceBaseInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceBaseInfoDto.fromJS(resultData200) : new DeviceBaseInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 设置设备缩略图
     * @input (optional)
     * @return Success
     */
    DeviceDetailServiceProxy.prototype.setDeviceThumbnail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDetail/SetDeviceThumbnail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetDeviceThumbnail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetDeviceThumbnail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDetailServiceProxy.prototype.processSetDeviceThumbnail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceDetailServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceDetailServiceProxy);
    return DeviceDetailServiceProxy;
}());
export { DeviceDetailServiceProxy };
var DeviceDocumentServiceProxy = /** @class */ (function () {
    function DeviceDocumentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @deviceId (optional)
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.getDocuments = function (deviceId, name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/GetDocuments?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDocuments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDocuments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processGetDocuments = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDeviceDocumentDto.fromJS(resultData200) : new PagedResultDtoOfDeviceDocumentDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.getFolders = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/GetFolders?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFolders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFolders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processGetFolders = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_25 = resultData200; _i < resultData200_25.length; _i++) {
                        var item = resultData200_25[_i];
                        result200.push(DeviceFolderListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.getFileDto = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/GetFileDto?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFileDto(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFileDto(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processGetFileDto = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.createOrUpdateFolder = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/CreateOrUpdateFolder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateFolder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateFolder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processCreateOrUpdateFolder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @name (optional)
     * @documentType (optional)
     * @parentId (optional)
     * @formFile (optional)
     * @id (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.createOrUpdateDocument = function (deviceId, name, documentType, parentId, formFile, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/CreateOrUpdateDocument?";
        if (formFile !== undefined)
            url_ += "FormFile=" + encodeURIComponent("" + formFile) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (deviceId !== null && deviceId !== undefined)
            content_.append("DeviceId", deviceId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (documentType !== null && documentType !== undefined)
            content_.append("DocumentType", documentType.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateDocument(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateDocument(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processCreateOrUpdateDocument = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @id (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.deleteDocument = function (deviceId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/DeleteDocument?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDocument(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDocument(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processDeleteDocument = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @cascadeDelete (optional)
     * @deviceId (optional)
     * @id (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.deleteFolder = function (cascadeDelete, deviceId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/DeleteFolder?";
        if (cascadeDelete !== undefined)
            url_ += "CascadeDelete=" + encodeURIComponent("" + cascadeDelete) + "&";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteFolder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteFolder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processDeleteFolder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceDocumentServiceProxy.prototype.batchDeleteFolderOrDocument = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceDocument/BatchDeleteFolderOrDocument";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchDeleteFolderOrDocument(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchDeleteFolderOrDocument(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceDocumentServiceProxy.prototype.processBatchDeleteFolderOrDocument = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceDocumentServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceDocumentServiceProxy);
    return DeviceDocumentServiceProxy;
}());
export { DeviceDocumentServiceProxy };
var DeviceGroupServiceProxy = /** @class */ (function () {
    function DeviceGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.createDeviceGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/CreateDeviceGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processCreateDeviceGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceGroupDto.fromJS(resultData200) : new DeviceGroupDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @originalChanged (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.updateDeviceGroup = function (input, originalChanged) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/UpdateDeviceGroup?";
        if (originalChanged !== undefined)
            url_ += "originalChanged=" + encodeURIComponent("" + originalChanged) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processUpdateDeviceGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceGroupDto.fromJS(resultData200) : new DeviceGroupDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.deleteDeviceGroup = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/DeleteDeviceGroup?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processDeleteDeviceGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.moveDeviceGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/MoveDeviceGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMoveDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMoveDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processMoveDeviceGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceGroupDto.fromJS(resultData200) : new DeviceGroupDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.getDeviceGroup = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/GetDeviceGroup";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processGetDeviceGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceGroupDto.fromJS(resultData200) : new ListResultDtoOfDeviceGroupDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @currentId (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.getAllDeviceGroups = function (currentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/GetAllDeviceGroups?";
        if (currentId !== undefined)
            url_ += "currentId=" + encodeURIComponent("" + currentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDeviceGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDeviceGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processGetAllDeviceGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceGroupListDto.fromJS(resultData200) : new ListResultDtoOfDeviceGroupListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.findDevices = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/FindDevices";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindDevices(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindDevices(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processFindDevices = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDeviceGroupDevicesListDto.fromJS(resultData200) : new PagedResultDtoOfDeviceGroupDevicesListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @filter (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.getDeviceGroupDeviceList = function (id, filter, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/GetDeviceGroupDeviceList?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceGroupDeviceList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceGroupDeviceList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processGetDeviceGroupDeviceList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDeviceGroupDevicesListDto.fromJS(resultData200) : new PagedResultDtoOfDeviceGroupDevicesListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.addDeviceToDeviceGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/AddDeviceToDeviceGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddDeviceToDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddDeviceToDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processAddDeviceToDeviceGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @deviceGroupId (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.removeDeviceFromDeviceGroup = function (deviceId, deviceGroupId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/RemoveDeviceFromDeviceGroup?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (deviceGroupId !== undefined)
            url_ += "DeviceGroupId=" + encodeURIComponent("" + deviceGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveDeviceFromDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveDeviceFromDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processRemoveDeviceFromDeviceGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceId (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.getDeviceGroupIdByDeviceId = function (deviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/GetDeviceGroupIdByDeviceId?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceGroupIdByDeviceId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceGroupIdByDeviceId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processGetDeviceGroupIdByDeviceId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceGroupListDto.fromJS(resultData200) : new DeviceGroupListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @groupId (optional)
     * @return Success
     */
    DeviceGroupServiceProxy.prototype.getDeviceGroupByGroupId = function (groupId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceGroup/GetDeviceGroupByGroupId?";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceGroupByGroupId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceGroupByGroupId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceGroupServiceProxy.prototype.processGetDeviceGroupByGroupId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceGroupDto.fromJS(resultData200) : new DeviceGroupDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceGroupServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceGroupServiceProxy);
    return DeviceGroupServiceProxy;
}());
export { DeviceGroupServiceProxy };
var DeviceInfoServiceProxy = /** @class */ (function () {
    function DeviceInfoServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @filter (optional)
     * @subscriptionEndDateStart (optional)
     * @subscriptionEndDateEnd (optional)
     * @creationDateStart (optional)
     * @creationDateEnd (optional)
     * @editionId (optional)
     * @editionIdSpecified (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceInfoServiceProxy.prototype.getDeviceInfoCountOfTenant = function (filter, subscriptionEndDateStart, subscriptionEndDateEnd, creationDateStart, creationDateEnd, editionId, editionIdSpecified, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceInfo/GetDeviceInfoCountOfTenant?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&";
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&";
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceInfoCountOfTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceInfoCountOfTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceInfoServiceProxy.prototype.processGetDeviceInfoCountOfTenant = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDeviceInfoCount.fromJS(resultData200) : new PagedResultDtoOfDeviceInfoCount();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导出租户统计列表
     * @input (optional)
     * @return Success
     */
    DeviceInfoServiceProxy.prototype.exportTenants = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceInfo/ExportTenants";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportTenants(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportTenants(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceInfoServiceProxy.prototype.processExportTenants = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceInfoServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceInfoServiceProxy);
    return DeviceInfoServiceProxy;
}());
export { DeviceInfoServiceProxy };
var DeviceListServiceProxy = /** @class */ (function () {
    function DeviceListServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取设备列表
     * @deviceCommunicateState (optional) 设备状态
     * @deviceModelId (optional) IoT模型
     * @deviceGroupId (optional) 设备分组id
     * @address (optional) 设备详细地址
     * @deviceNameOrSerialNo (optional) 设备名称、设备序列号
     * @boxSerialNumber (optional) 终端序列号
     * @orderNumber (optional) 订单编号
     * @deviceProductionStartDate (optional) 生产开始日期
     * @deviceProductionEndDate (optional) 生产结束日期
     * @deviceDeliveryStartDate (optional) 交付开始日期
     * @deviceDeliveryEndDate (optional) 交付结束日期
     * @creationStartTime (optional) 创建开始时间
     * @creationEndTime (optional) 创建结束时间
     * @markTableDataFavorites (optional) 查询标记的收藏的表数据
     * @devicePattern (optional) 设备型号
     * @provinceId (optional) 省份RegionId
     * @cityId (optional) 市RegionId
     * @districtId (optional) 区RegionId
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceListServiceProxy.prototype.getDevices = function (deviceCommunicateState, deviceModelId, deviceGroupId, address, deviceNameOrSerialNo, boxSerialNumber, orderNumber, deviceProductionStartDate, deviceProductionEndDate, deviceDeliveryStartDate, deviceDeliveryEndDate, creationStartTime, creationEndTime, markTableDataFavorites, devicePattern, provinceId, cityId, districtId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceList/GetDevices?";
        if (deviceCommunicateState !== undefined)
            url_ += "DeviceCommunicateState=" + encodeURIComponent("" + deviceCommunicateState) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (deviceGroupId !== undefined)
            url_ += "DeviceGroupId=" + encodeURIComponent("" + deviceGroupId) + "&";
        if (address !== undefined)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (deviceNameOrSerialNo !== undefined)
            url_ += "DeviceNameOrSerialNo=" + encodeURIComponent("" + deviceNameOrSerialNo) + "&";
        if (boxSerialNumber !== undefined)
            url_ += "BoxSerialNumber=" + encodeURIComponent("" + boxSerialNumber) + "&";
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (deviceProductionStartDate !== undefined)
            url_ += "DeviceProductionStartDate=" + encodeURIComponent(deviceProductionStartDate ? "" + deviceProductionStartDate.toJSON() : "") + "&";
        if (deviceProductionEndDate !== undefined)
            url_ += "DeviceProductionEndDate=" + encodeURIComponent(deviceProductionEndDate ? "" + deviceProductionEndDate.toJSON() : "") + "&";
        if (deviceDeliveryStartDate !== undefined)
            url_ += "DeviceDeliveryStartDate=" + encodeURIComponent(deviceDeliveryStartDate ? "" + deviceDeliveryStartDate.toJSON() : "") + "&";
        if (deviceDeliveryEndDate !== undefined)
            url_ += "DeviceDeliveryEndDate=" + encodeURIComponent(deviceDeliveryEndDate ? "" + deviceDeliveryEndDate.toJSON() : "") + "&";
        if (creationStartTime !== undefined)
            url_ += "CreationStartTime=" + encodeURIComponent(creationStartTime ? "" + creationStartTime.toJSON() : "") + "&";
        if (creationEndTime !== undefined)
            url_ += "CreationEndTime=" + encodeURIComponent(creationEndTime ? "" + creationEndTime.toJSON() : "") + "&";
        if (markTableDataFavorites !== undefined)
            url_ += "MarkTableDataFavorites=" + encodeURIComponent("" + markTableDataFavorites) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (provinceId !== undefined)
            url_ += "ProvinceId=" + encodeURIComponent("" + provinceId) + "&";
        if (cityId !== undefined)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (districtId !== undefined)
            url_ += "DistrictId=" + encodeURIComponent("" + districtId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevices(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevices(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceListServiceProxy.prototype.processGetDevices = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceListQueryDto.fromJS(resultData200) : new DeviceListQueryDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 设备列表查询条件
     * @deviceCommunicateState (optional) 设备状态
     * @deviceModelId (optional) IoT模型
     * @deviceGroupId (optional) 设备分组id
     * @address (optional) 设备详细地址
     * @deviceNameOrSerialNo (optional) 设备名称、设备序列号
     * @boxSerialNumber (optional) 终端序列号
     * @orderNumber (optional) 订单编号
     * @deviceProductionStartDate (optional) 生产开始日期
     * @deviceProductionEndDate (optional) 生产结束日期
     * @deviceDeliveryStartDate (optional) 交付开始日期
     * @deviceDeliveryEndDate (optional) 交付结束日期
     * @creationStartTime (optional) 创建开始时间
     * @creationEndTime (optional) 创建结束时间
     * @markTableDataFavorites (optional) 查询标记的收藏的表数据
     * @devicePattern (optional) 设备型号
     * @provinceId (optional) 省份RegionId
     * @cityId (optional) 市RegionId
     * @districtId (optional) 区RegionId
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceListServiceProxy.prototype.getDevicesFilterQueryable = function (deviceCommunicateState, deviceModelId, deviceGroupId, address, deviceNameOrSerialNo, boxSerialNumber, orderNumber, deviceProductionStartDate, deviceProductionEndDate, deviceDeliveryStartDate, deviceDeliveryEndDate, creationStartTime, creationEndTime, markTableDataFavorites, devicePattern, provinceId, cityId, districtId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceList/GetDevicesFilterQueryable?";
        if (deviceCommunicateState !== undefined)
            url_ += "DeviceCommunicateState=" + encodeURIComponent("" + deviceCommunicateState) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (deviceGroupId !== undefined)
            url_ += "DeviceGroupId=" + encodeURIComponent("" + deviceGroupId) + "&";
        if (address !== undefined)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (deviceNameOrSerialNo !== undefined)
            url_ += "DeviceNameOrSerialNo=" + encodeURIComponent("" + deviceNameOrSerialNo) + "&";
        if (boxSerialNumber !== undefined)
            url_ += "BoxSerialNumber=" + encodeURIComponent("" + boxSerialNumber) + "&";
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (deviceProductionStartDate !== undefined)
            url_ += "DeviceProductionStartDate=" + encodeURIComponent(deviceProductionStartDate ? "" + deviceProductionStartDate.toJSON() : "") + "&";
        if (deviceProductionEndDate !== undefined)
            url_ += "DeviceProductionEndDate=" + encodeURIComponent(deviceProductionEndDate ? "" + deviceProductionEndDate.toJSON() : "") + "&";
        if (deviceDeliveryStartDate !== undefined)
            url_ += "DeviceDeliveryStartDate=" + encodeURIComponent(deviceDeliveryStartDate ? "" + deviceDeliveryStartDate.toJSON() : "") + "&";
        if (deviceDeliveryEndDate !== undefined)
            url_ += "DeviceDeliveryEndDate=" + encodeURIComponent(deviceDeliveryEndDate ? "" + deviceDeliveryEndDate.toJSON() : "") + "&";
        if (creationStartTime !== undefined)
            url_ += "CreationStartTime=" + encodeURIComponent(creationStartTime ? "" + creationStartTime.toJSON() : "") + "&";
        if (creationEndTime !== undefined)
            url_ += "CreationEndTime=" + encodeURIComponent(creationEndTime ? "" + creationEndTime.toJSON() : "") + "&";
        if (markTableDataFavorites !== undefined)
            url_ += "MarkTableDataFavorites=" + encodeURIComponent("" + markTableDataFavorites) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (provinceId !== undefined)
            url_ += "ProvinceId=" + encodeURIComponent("" + provinceId) + "&";
        if (cityId !== undefined)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (districtId !== undefined)
            url_ += "DistrictId=" + encodeURIComponent("" + districtId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevicesFilterQueryable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevicesFilterQueryable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceListServiceProxy.prototype.processGetDevicesFilterQueryable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto.fromJS(resultData200) : new ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导出 Excel
     * @input (optional)
     * @return Success
     */
    DeviceListServiceProxy.prototype.exportDevices = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceList/ExportDevices";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportDevices(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportDevices(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceListServiceProxy.prototype.processExportDevices = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceListServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceListServiceProxy);
    return DeviceListServiceProxy;
}());
export { DeviceListServiceProxy };
var DeviceLogServiceProxy = /** @class */ (function () {
    function DeviceLogServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @startDate (optional)
     * @endDate (optional)
     * @offset (optional)
     * @boxSerialNumber (optional)
     * @return Success
     */
    DeviceLogServiceProxy.prototype.getBoxLogs = function (startDate, endDate, offset, boxSerialNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceLog/GetBoxLogs?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (boxSerialNumber !== undefined)
            url_ += "BoxSerialNumber=" + encodeURIComponent("" + boxSerialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBoxLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBoxLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceLogServiceProxy.prototype.processGetBoxLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_26 = resultData200; _i < resultData200_26.length; _i++) {
                        var item = resultData200_26[_i];
                        result200.push(BoxLogDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    DeviceLogServiceProxy.prototype.exportBoxLogs = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceLog/ExportBoxLogs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportBoxLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportBoxLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceLogServiceProxy.prototype.processExportBoxLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceLogServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceLogServiceProxy);
    return DeviceLogServiceProxy;
}());
export { DeviceLogServiceProxy };
var DeviceMaintenancePlanServiceProxy = /** @class */ (function () {
    function DeviceMaintenancePlanServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    DeviceMaintenancePlanServiceProxy.prototype.getDeviceMaintenancePlan = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceMaintenancePlan/GetDeviceMaintenancePlan?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceMaintenancePlan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceMaintenancePlan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceMaintenancePlanServiceProxy.prototype.processGetDeviceMaintenancePlan = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceMaintenancePlanDto.fromJS(resultData200) : new DeviceMaintenancePlanDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceMaintenancePlanServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceMaintenancePlanServiceProxy);
    return DeviceMaintenancePlanServiceProxy;
}());
export { DeviceMaintenancePlanServiceProxy };
var DeviceModelServiceProxy = /** @class */ (function () {
    function DeviceModelServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 分页获取已授权模板
     * @name (optional)
     * @industry (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.getDeviceModels = function (name, industry, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/GetDeviceModels?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (industry !== undefined)
            url_ += "Industry=" + encodeURIComponent("" + industry) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processGetDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDeviceModelListDto.fromJS(resultData200) : new PagedResultDtoOfDeviceModelListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取待编辑设备模板信息
     * @id (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.getDeviceModelForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/GetDeviceModelForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModelForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModelForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processGetDeviceModelForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetDeviceModelForEditDto.fromJS(resultData200) : new GetDeviceModelForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 创建或编辑设备模板
     * @input (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.createOrUpdateDeviceModel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/CreateOrUpdateDeviceModel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateDeviceModel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateDeviceModel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processCreateOrUpdateDeviceModel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除设备模板
     * @id (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.deleteDeviceModel = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/DeleteDeviceModel?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDeviceModel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDeviceModel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processDeleteDeviceModel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 复制设备模板
     * @input (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.copyDeviceModel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/CopyDeviceModel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCopyDeviceModel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCopyDeviceModel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processCopyDeviceModel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取已授权的所有模板
     * @return Success
     */
    DeviceModelServiceProxy.prototype.getAllDeviceModels = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/GetAllDeviceModels";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processGetAllDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceModelListDto.fromJS(resultData200) : new ListResultDtoOfDeviceModelListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取是否有组态权限
     * @id (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.getDeviceModelPermissions = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/GetDeviceModelPermissions?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModelPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModelPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processGetDeviceModelPermissions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 是否有组态权限
     * @configureId (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.configureDesignGranted = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/ConfigureDesignGranted?";
        if (configureId !== undefined)
            url_ += "configureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processConfigureDesignGranted(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processConfigureDesignGranted(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processConfigureDesignGranted = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceModelId (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.getAllDeviceModelsByDevice = function (deviceModelId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/GetAllDeviceModelsByDevice?";
        if (deviceModelId !== undefined)
            url_ += "deviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDeviceModelsByDevice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDeviceModelsByDevice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processGetAllDeviceModelsByDevice = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_27 = resultData200; _i < resultData200_27.length; _i++) {
                        var item = resultData200_27[_i];
                        result200.push(DeviceModelSelectorDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据分组查询设备模板
     * @modelGroupId (optional) 模板组id
     * @isAll (optional) 是否查询全部
     * @industry (optional) 行业
     * @searchStr (optional) 搜索字符串
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.getDeviceModelsByGroup = function (modelGroupId, isAll, industry, searchStr, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/GetDeviceModelsByGroup?";
        if (modelGroupId !== undefined)
            url_ += "ModelGroupId=" + encodeURIComponent("" + modelGroupId) + "&";
        if (isAll !== undefined)
            url_ += "IsAll=" + encodeURIComponent("" + isAll) + "&";
        if (industry !== undefined)
            url_ += "Industry=" + encodeURIComponent("" + industry) + "&";
        if (searchStr !== undefined)
            url_ += "SearchStr=" + encodeURIComponent("" + searchStr) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModelsByGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModelsByGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processGetDeviceModelsByGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDeviceModelsOfGroupDto.fromJS(resultData200) : new PagedResultDtoOfDeviceModelsOfGroupDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量删除模板
     * @input (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.batchDeleteDeviceModel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/BatchDeleteDeviceModel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchDeleteDeviceModel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchDeleteDeviceModel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processBatchDeleteDeviceModel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取行业
     * @return Success
     */
    DeviceModelServiceProxy.prototype.getUserIndustries = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/GetUserIndustries";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserIndustries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserIndustries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processGetUserIndustries = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_28 = resultData200; _i < resultData200_28.length; _i++) {
                        var item = resultData200_28[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 移动设备模板分组
     * @input (optional)
     * @return Success
     */
    DeviceModelServiceProxy.prototype.moveModelGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceModel/MoveModelGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMoveModelGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMoveModelGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceModelServiceProxy.prototype.processMoveModelGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceModelServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceModelServiceProxy);
    return DeviceModelServiceProxy;
}());
export { DeviceModelServiceProxy };
var DeviceMonitorServiceProxy = /** @class */ (function () {
    function DeviceMonitorServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    DeviceMonitorServiceProxy.prototype.getDeviceForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceMonitor/GetDeviceForView?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceMonitorServiceProxy.prototype.processGetDeviceForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceViewDto.fromJS(resultData200) : new DeviceViewDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DeviceMonitorServiceProxy.prototype.getDeviceDisplayMode = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceMonitor/GetDeviceDisplayMode";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceDisplayMode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceDisplayMode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceMonitorServiceProxy.prototype.processGetDeviceDisplayMode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceMonitorServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceMonitorServiceProxy);
    return DeviceMonitorServiceProxy;
}());
export { DeviceMonitorServiceProxy };
var DeviceMonitorTreeServiceProxy = /** @class */ (function () {
    function DeviceMonitorTreeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    DeviceMonitorTreeServiceProxy.prototype.getRegionDevicesForTree = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceMonitorTree/GetRegionDevicesForTree";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRegionDevicesForTree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRegionDevicesForTree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceMonitorTreeServiceProxy.prototype.processGetRegionDevicesForTree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceTreeWithRegionDto.fromJS(resultData200) : new DeviceTreeWithRegionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DeviceMonitorTreeServiceProxy.prototype.getDeviceModelDevicesForTree = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceMonitorTree/GetDeviceModelDevicesForTree";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModelDevicesForTree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModelDevicesForTree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceMonitorTreeServiceProxy.prototype.processGetDeviceModelDevicesForTree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceTreeWithExtentiontDto.fromJS(resultData200) : new DeviceTreeWithExtentiontDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DeviceMonitorTreeServiceProxy.prototype.getDeviceGroupForTree = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceMonitorTree/GetDeviceGroupForTree";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceGroupForTree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceGroupForTree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceMonitorTreeServiceProxy.prototype.processGetDeviceGroupForTree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceTreeWithExtentiontDto.fromJS(resultData200) : new DeviceTreeWithExtentiontDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取外部组织所有设备
     * @return Success
     */
    DeviceMonitorTreeServiceProxy.prototype.getExternalOrganizationDevicesForTree = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceMonitorTree/GetExternalOrganizationDevicesForTree";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExternalOrganizationDevicesForTree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExternalOrganizationDevicesForTree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceMonitorTreeServiceProxy.prototype.processGetExternalOrganizationDevicesForTree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceTreeWithExtentiontDto.fromJS(resultData200) : new DeviceTreeWithExtentiontDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceMonitorTreeServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceMonitorTreeServiceProxy);
    return DeviceMonitorTreeServiceProxy;
}());
export { DeviceMonitorTreeServiceProxy };
var DevicePermissionServiceProxy = /** @class */ (function () {
    function DevicePermissionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取所有拥有该设备的人员
     * @id (optional)
     * @return Success
     */
    DevicePermissionServiceProxy.prototype.getGrantedUserList = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DevicePermission/GetGrantedUserList?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGrantedUserList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGrantedUserList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DevicePermissionServiceProxy.prototype.processGetGrantedUserList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_29 = resultData200; _i < resultData200_29.length; _i++) {
                        var item = resultData200_29[_i];
                        result200.push(DeviceUserPermissionDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DevicePermissionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DevicePermissionServiceProxy);
    return DevicePermissionServiceProxy;
}());
export { DevicePermissionServiceProxy };
var DevicePositionServiceProxy = /** @class */ (function () {
    function DevicePositionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @deviceModelId (optional) 设备模板 Id
     * @virtualDeviceId (optional) 虚拟设备 Id
     * @return Success
     */
    DevicePositionServiceProxy.prototype.getReleasedDataSourceWithPositions = function (deviceModelId, virtualDeviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DevicePosition/GetReleasedDataSourceWithPositions?";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedDataSourceWithPositions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedDataSourceWithPositions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DevicePositionServiceProxy.prototype.processGetReleasedDataSourceWithPositions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfReleasedDataSourceWithPositionDto.fromJS(resultData200) : new ListResultDtoOfReleasedDataSourceWithPositionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DevicePositionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DevicePositionServiceProxy);
    return DevicePositionServiceProxy;
}());
export { DevicePositionServiceProxy };
var DeviceRepairBomServiceProxy = /** @class */ (function () {
    function DeviceRepairBomServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取列表
     * @deviceId (optional)
     * @searchStr (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.getDeviceRepairBomTreeList = function (deviceId, searchStr, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/GetDeviceRepairBomTreeList?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (searchStr !== undefined)
            url_ += "SearchStr=" + encodeURIComponent("" + searchStr) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceRepairBomTreeList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceRepairBomTreeList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processGetDeviceRepairBomTreeList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDeviceRepairBomData.fromJS(resultData200) : new PagedResultDtoOfDeviceRepairBomData();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除
     * @ids (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.batchDeleteDeviceRepairBom = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/BatchDeleteDeviceRepairBom";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ids);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchDeleteDeviceRepairBom(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchDeleteDeviceRepairBom(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processBatchDeleteDeviceRepairBom = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 添加或修改
     * @input (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.addOrUpdateDeviceRepairBom = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/AddOrUpdateDeviceRepairBom";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddOrUpdateDeviceRepairBom(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddOrUpdateDeviceRepairBom(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processAddOrUpdateDeviceRepairBom = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取部件，用来选择父级
     * @deviceId (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.getParentNodes = function (deviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/GetParentNodes?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetParentNodes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetParentNodes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processGetParentNodes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_30 = resultData200; _i < resultData200_30.length; _i++) {
                        var item = resultData200_30[_i];
                        result200.push(ParentNodesDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据bomid，获取详细内容
     * @deviceRepairBomId (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.getDeviceRepairBomToEdit = function (deviceRepairBomId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/GetDeviceRepairBomToEdit?";
        if (deviceRepairBomId !== undefined)
            url_ += "deviceRepairBomId=" + encodeURIComponent("" + deviceRepairBomId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceRepairBomToEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceRepairBomToEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processGetDeviceRepairBomToEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AddDeviceRepairBomDto.fromJS(resultData200) : new AddDeviceRepairBomDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导出excel
     * @input (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.outputExcelFile = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/OutputExcelFile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOutputExcelFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOutputExcelFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processOutputExcelFile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导入excel，解析内容
     * @input (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.parseDataFromChart = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/ParseDataFromChart";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processParseDataFromChart(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processParseDataFromChart(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processParseDataFromChart = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除有零件的部件
     * @id (optional)
     * @isDeleteBoth (optional)
     * @return Success
     */
    DeviceRepairBomServiceProxy.prototype.deleteParentComponent = function (id, isDeleteBoth) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceRepairBom/DeleteParentComponent?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isDeleteBoth !== undefined)
            url_ += "isDeleteBoth=" + encodeURIComponent("" + isDeleteBoth) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteParentComponent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteParentComponent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceRepairBomServiceProxy.prototype.processDeleteParentComponent = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceRepairBomServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceRepairBomServiceProxy);
    return DeviceRepairBomServiceProxy;
}());
export { DeviceRepairBomServiceProxy };
var DeviceReportSearchServiceProxy = /** @class */ (function () {
    function DeviceReportSearchServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getDeviceNames = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetDeviceNames?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetDeviceNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getSerialNumbers = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetSerialNumbers?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSerialNumbers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSerialNumbers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetSerialNumbers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getDeviceModels = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetDeviceModels?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfInt32.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfInt32();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getDevicePatterns = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetDevicePatterns?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevicePatterns(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevicePatterns(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetDevicePatterns = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getDeviceGroups = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetDeviceGroups?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetDeviceGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfInt64.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfInt64();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getOrderNumbers = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetOrderNumbers?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderNumbers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderNumbers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetOrderNumbers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getProvinces = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetProvinces?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProvinces(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProvinces(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetProvinces = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getCitys = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetCitys?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCitys(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCitys(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetCitys = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getDistricts = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetDistricts?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDistricts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDistricts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetDistricts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DeviceReportSearchServiceProxy.prototype.getBoxSerialNoes = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeviceReportSearch/GetBoxSerialNoes?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBoxSerialNoes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBoxSerialNoes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeviceReportSearchServiceProxy.prototype.processGetBoxSerialNoes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DeviceReportSearchServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DeviceReportSearchServiceProxy);
    return DeviceReportSearchServiceProxy;
}());
export { DeviceReportSearchServiceProxy };
var DocumentManageServiceProxy = /** @class */ (function () {
    function DocumentManageServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 新增文档
     * @input (optional)
     * @return Success
     */
    DocumentManageServiceProxy.prototype.createDocument = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentManage/CreateDocument";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateDocument(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateDocument(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentManageServiceProxy.prototype.processCreateDocument = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 更新文件
     * @input (optional)
     * @return Success
     */
    DocumentManageServiceProxy.prototype.updateDocument = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentManage/UpdateDocument";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDocument(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDocument(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentManageServiceProxy.prototype.processUpdateDocument = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除文档
     * @id (optional)
     * @return Success
     */
    DocumentManageServiceProxy.prototype.deleteDocument = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentManage/DeleteDocument?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDocument(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDocument(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentManageServiceProxy.prototype.processDeleteDocument = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 下载文档
     * @id (optional)
     * @return Success
     */
    DocumentManageServiceProxy.prototype.getDownLoadFileDto = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentManage/GetDownLoadFileDto?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDownLoadFileDto(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDownLoadFileDto(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentManageServiceProxy.prototype.processGetDownLoadFileDto = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DownloadFileDto.fromJS(resultData200) : new DownloadFileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取当前用户所拥有的文档
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    DocumentManageServiceProxy.prototype.getDocumentList = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentManage/GetDocumentList?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDocumentList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDocumentList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentManageServiceProxy.prototype.processGetDocumentList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDocumentListDto.fromJS(resultData200) : new PagedResultDtoOfDocumentListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DocumentManageServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DocumentManageServiceProxy);
    return DocumentManageServiceProxy;
}());
export { DocumentManageServiceProxy };
var DocumentSpaceServiceProxy = /** @class */ (function () {
    function DocumentSpaceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    DocumentSpaceServiceProxy.prototype.getDocumentSpace = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentSpace/GetDocumentSpace";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDocumentSpace(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDocumentSpace(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentSpaceServiceProxy.prototype.processGetDocumentSpace = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DocumentSpaceDto.fromJS(resultData200) : new DocumentSpaceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DocumentSpaceServiceProxy.prototype.getSignleFileSize = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentSpace/GetSignleFileSize";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSignleFileSize(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSignleFileSize(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentSpaceServiceProxy.prototype.processGetSignleFileSize = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DocumentSingleFileSizeDto.fromJS(resultData200) : new DocumentSingleFileSizeDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    DocumentSpaceServiceProxy.prototype.getDocumentLimit = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentSpace/GetDocumentLimit";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDocumentLimit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDocumentLimit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentSpaceServiceProxy.prototype.processGetDocumentLimit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DocumentLimitDto.fromJS(resultData200) : new DocumentLimitDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DocumentSpaceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], DocumentSpaceServiceProxy);
    return DocumentSpaceServiceProxy;
}());
export { DocumentSpaceServiceProxy };
var EditionServiceProxy = /** @class */ (function () {
    function EditionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    EditionServiceProxy.prototype.getEditions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfEditionListDto.fromJS(resultData200) : new ListResultDtoOfEditionListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getEditionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditionForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetEditionEditOutput.fromJS(resultData200) : new GetEditionEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.createOrUpdateEdition = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processCreateOrUpdateEdition = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.deleteEdition = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processDeleteEdition = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @selectedEditionId (optional)
     * @addAllItem (optional)
     * @onlyFreeItems (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getEditionComboboxItems = function (selectedEditionId, addAllItem, onlyFreeItems) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionComboboxItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditionComboboxItems = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_31 = resultData200; _i < resultData200_31.length; _i++) {
                        var item = resultData200_31[_i];
                        result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    EditionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], EditionServiceProxy);
    return EditionServiceProxy;
}());
export { EditionServiceProxy };
var ExternalOrganizationServiceProxy = /** @class */ (function () {
    function ExternalOrganizationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getOrganizations = function (maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetOrganizations?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetOrganizations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfExternalOrganizationListDto.fromJS(resultData200) : new PagedResultDtoOfExternalOrganizationListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getOrganizationsForMap = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetOrganizationsForMap";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationsForMap(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationsForMap(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetOrganizationsForMap = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_32 = resultData200; _i < resultData200_32.length; _i++) {
                        var item = resultData200_32[_i];
                        result200.push(OrganizationListForMapDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取单个外部组织 Dto
     * @organizationId (optional) 组织 Id
     * @userId (optional) 用户 Id
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getOrganizationTreeForDetail = function (organizationId, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetOrganizationTreeForDetail?";
        if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationTreeForDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationTreeForDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetOrganizationTreeForDetail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_33 = resultData200; _i < resultData200_33.length; _i++) {
                        var item = resultData200_33[_i];
                        result200.push(OrganizationForTreeDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @term (optional)
     * @organizationRole (optional)
     * @organizationLevel (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getOrganizationsWithFilter = function (term, organizationRole, organizationLevel, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetOrganizationsWithFilter?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (organizationRole !== undefined)
            url_ += "OrganizationRole=" + encodeURIComponent("" + organizationRole) + "&";
        if (organizationLevel !== undefined)
            url_ += "OrganizationLevel=" + encodeURIComponent("" + organizationLevel) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationsWithFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationsWithFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetOrganizationsWithFilter = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfExternalOrganizationListDto.fromJS(resultData200) : new PagedResultDtoOfExternalOrganizationListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getAttachmentsForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetAttachmentsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAttachmentsForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAttachmentsForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetAttachmentsForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_34 = resultData200; _i < resultData200_34.length; _i++) {
                        var item = resultData200_34[_i];
                        result200.push(OrganizationAttachmentDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getOrganizationForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetOrganizationForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetOrganizationForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ExternalOrganizationForEditDto.fromJS(resultData200) : new ExternalOrganizationForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getOrganizationDetail = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetOrganizationDetail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetOrganizationDetail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDetailDto.fromJS(resultData200) : new OrganizationDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取外部组织角色
     * @id (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getRoles = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetRoles?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetRoles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_35 = resultData200; _i < resultData200_35.length; _i++) {
                        var item = resultData200_35[_i];
                        result200.push(RoleListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @filter (optional)
     * @role (optional)
     * @active (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getUsers = function (id, filter, role, active, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetUsers?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (active !== undefined)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserListForDetailDto.fromJS(resultData200) : new PagedResultDtoOfUserListForDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.createOrUpdateOrganization = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/CreateOrUpdateOrganization";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateOrganization(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateOrganization(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processCreateOrUpdateOrganization = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.deleteOrganization = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/DeleteOrganization?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteOrganization(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteOrganization(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processDeleteOrganization = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @file (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.createOrganizationTempFile = function (file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/CreateOrganizationTempFile?";
        if (file !== undefined)
            url_ += "File=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrganizationTempFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrganizationTempFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processCreateOrganizationTempFile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.deleteTempFile = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/DeleteTempFile?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTempFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTempFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processDeleteTempFile = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.downloadAttachment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/DownloadAttachment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDownloadAttachment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDownloadAttachment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processDownloadAttachment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.exportToExcel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processExportToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 项目组用 查询外部组织及一条联系人
     * @term (optional) 搜索条件 简称全称序列号
     * @role (optional) 组织角色
     * @level (optional) 组织级别
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.getOrganizationsWithContact = function (term, role, level, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/GetOrganizationsWithContact?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (level !== undefined)
            url_ += "Level=" + encodeURIComponent("" + level) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationsWithContact(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationsWithContact(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processGetOrganizationsWithContact = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfExternalOrganizationWithContactDto.fromJS(resultData200) : new PagedResultDtoOfExternalOrganizationWithContactDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 检查是否存在超级管理员
     * @input (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.checkAdminUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/CheckAdminUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckAdminUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckAdminUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processCheckAdminUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除外部组织管理员并删除外部组织所有用户
     * @id (optional)
     * @return Success
     */
    ExternalOrganizationServiceProxy.prototype.deleteExternalUsers = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalOrganization/DeleteExternalUsers?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteExternalUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteExternalUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalOrganizationServiceProxy.prototype.processDeleteExternalUsers = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ExternalOrganizationServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ExternalOrganizationServiceProxy);
    return ExternalOrganizationServiceProxy;
}());
export { ExternalOrganizationServiceProxy };
var EzvizServiceProxy = /** @class */ (function () {
    function EzvizServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @deviceSerial (optional)
     * @channelNo (optional)
     * @return Success
     */
    EzvizServiceProxy.prototype.getLiveAddress = function (deviceSerial, channelNo) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Ezviz/GetLiveAddress?";
        if (deviceSerial !== undefined)
            url_ += "DeviceSerial=" + encodeURIComponent("" + deviceSerial) + "&";
        if (channelNo !== undefined)
            url_ += "ChannelNo=" + encodeURIComponent("" + channelNo) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLiveAddress(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLiveAddress(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EzvizServiceProxy.prototype.processGetLiveAddress = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CameraDto.fromJS(resultData200) : new CameraDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EzvizServiceProxy.prototype.rotate = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Ezviz/Rotate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRotate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRotate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EzvizServiceProxy.prototype.processRotate = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EzvizServiceProxy.prototype.stopRotate = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Ezviz/StopRotate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processStopRotate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processStopRotate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EzvizServiceProxy.prototype.processStopRotate = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    EzvizServiceProxy.prototype.getEzvizSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Ezviz/GetEzvizSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEzvizSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEzvizSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EzvizServiceProxy.prototype.processGetEzvizSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantEzvizSettingsEditDto.fromJS(resultData200) : new TenantEzvizSettingsEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EzvizServiceProxy.prototype.updateEzvizSettings = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Ezviz/UpdateEzvizSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateEzvizSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateEzvizSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EzvizServiceProxy.prototype.processUpdateEzvizSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    EzvizServiceProxy.prototype.unBindAccount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Ezviz/UnBindAccount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnBindAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnBindAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EzvizServiceProxy.prototype.processUnBindAccount = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    EzvizServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], EzvizServiceProxy);
    return EzvizServiceProxy;
}());
export { EzvizServiceProxy };
var FaultTypeServiceProxy = /** @class */ (function () {
    function FaultTypeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @name (optional)
     * @return Success
     */
    FaultTypeServiceProxy.prototype.getFaultTypes = function (name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FaultType/GetFaultTypes?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFaultTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFaultTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FaultTypeServiceProxy.prototype.processGetFaultTypes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfFaultTypeListDto.fromJS(resultData200) : new ListResultDtoOfFaultTypeListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FaultTypeServiceProxy.prototype.createOrUpdateFaultType = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FaultType/CreateOrUpdateFaultType";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateFaultType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateFaultType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FaultTypeServiceProxy.prototype.processCreateOrUpdateFaultType = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    FaultTypeServiceProxy.prototype.deleteFaultType = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FaultType/DeleteFaultType?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteFaultType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteFaultType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FaultTypeServiceProxy.prototype.processDeleteFaultType = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FaultTypeServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FaultTypeServiceProxy);
    return FaultTypeServiceProxy;
}());
export { FaultTypeServiceProxy };
var FBoxServiceProxy = /** @class */ (function () {
    function FBoxServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    FBoxServiceProxy.prototype.checkBoxBelongToTenant = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBox/CheckBoxBelongToTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckBoxBelongToTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckBoxBelongToTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxServiceProxy.prototype.processCheckBoxBelongToTenant = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CheckBoxResult.fromJS(resultData200) : new CheckBoxResult();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @serialNumber (optional)
     * @return Success
     */
    FBoxServiceProxy.prototype.getFBoxInfo = function (serialNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBox/GetFBoxInfo?";
        if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxServiceProxy.prototype.processGetFBoxInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfFBoxInfoDto.fromJS(resultData200) : new IListResultOfFBoxInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FBoxServiceProxy.prototype.unBindFBox = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBox/UnBindFBox";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnBindFBox(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnBindFBox(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxServiceProxy.prototype.processUnBindFBox = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FBoxServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FBoxServiceProxy);
    return FBoxServiceProxy;
}());
export { FBoxServiceProxy };
var FBoxAccountSettingsServiceProxy = /** @class */ (function () {
    function FBoxAccountSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.getAccountSettingStatusInfo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/GetAccountSettingStatusInfo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAccountSettingStatusInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAccountSettingStatusInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processGetAccountSettingStatusInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AccountSettingStatusInfoDto.fromJS(resultData200) : new AccountSettingStatusInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.configureFBoxAccount = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/ConfigureFBoxAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processConfigureFBoxAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processConfigureFBoxAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processConfigureFBoxAccount = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.changeFBoxAccount = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/ChangeFBoxAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeFBoxAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeFBoxAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processChangeFBoxAccount = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.changeFBoxAccountPassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/ChangeFBoxAccountPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeFBoxAccountPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeFBoxAccountPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processChangeFBoxAccountPassword = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.getFBoxAccountName = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/GetFBoxAccountName";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxAccountName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxAccountName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processGetFBoxAccountName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetFBoxAccountNameDto.fromJS(resultData200) : new GetFBoxAccountNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.getFBoxAccountMainAddress = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/GetFBoxAccountMainAddress";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxAccountMainAddress(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxAccountMainAddress(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processGetFBoxAccountMainAddress = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.hasTenantFBoxAccount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/HasTenantFBoxAccount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processHasTenantFBoxAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processHasTenantFBoxAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processHasTenantFBoxAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.getFBoxServerState = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/GetFBoxServerState";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxServerState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxServerState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processGetFBoxServerState = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FBoxServerStateDto.fromJS(resultData200) : new FBoxServerStateDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.reInitFBoxService = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/ReInitFBoxService";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processReInitFBoxService(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processReInitFBoxService(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processReInitFBoxService = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    FBoxAccountSettingsServiceProxy.prototype.deleteFBoxAccount = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAccountSettings/DeleteFBoxAccount?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteFBoxAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteFBoxAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAccountSettingsServiceProxy.prototype.processDeleteFBoxAccount = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FBoxAccountSettingsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FBoxAccountSettingsServiceProxy);
    return FBoxAccountSettingsServiceProxy;
}());
export { FBoxAccountSettingsServiceProxy };
var FBoxAlarmRegistrationServiceProxy = /** @class */ (function () {
    function FBoxAlarmRegistrationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @dataSourceId (optional)
     * @name (optional)
     * @groupName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    FBoxAlarmRegistrationServiceProxy.prototype.getFBoxAlarms = function (dataSourceId, name, groupName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAlarmRegistration/GetFBoxAlarms?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (groupName !== undefined)
            url_ += "GroupName=" + encodeURIComponent("" + groupName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAlarmRegistrationServiceProxy.prototype.processGetFBoxAlarms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfFBoxAlarmForSingleDataSource.fromJS(resultData200) : new PagedResultDtoOfFBoxAlarmForSingleDataSource();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取报警分组名称
     * @dataSourceId (optional)
     * @return Success
     */
    FBoxAlarmRegistrationServiceProxy.prototype.getRefAlarmGroupNames = function (dataSourceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAlarmRegistration/GetRefAlarmGroupNames?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRefAlarmGroupNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRefAlarmGroupNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAlarmRegistrationServiceProxy.prototype.processGetRefAlarmGroupNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_36 = resultData200; _i < resultData200_36.length; _i++) {
                        var item = resultData200_36[_i];
                        result200.push(RefAlarmGroupNameDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取分页fbox报警数据，并筛选
     * @dataSourceId (optional)
     * @name (optional)
     * @groupName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    FBoxAlarmRegistrationServiceProxy.prototype.getRefAlarmDefs = function (dataSourceId, name, groupName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxAlarmRegistration/GetRefAlarmDefs?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (groupName !== undefined)
            url_ += "GroupName=" + encodeURIComponent("" + groupName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRefAlarmDefs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRefAlarmDefs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxAlarmRegistrationServiceProxy.prototype.processGetRefAlarmDefs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRefAlarmDto.fromJS(resultData200) : new PagedResultDtoOfRefAlarmDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FBoxAlarmRegistrationServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FBoxAlarmRegistrationServiceProxy);
    return FBoxAlarmRegistrationServiceProxy;
}());
export { FBoxAlarmRegistrationServiceProxy };
var FBoxHistoryDataServiceProxy = /** @class */ (function () {
    function FBoxHistoryDataServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @dataSourceId (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    FBoxHistoryDataServiceProxy.prototype.getFBoxHistoryDataList = function (dataSourceId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxHistoryData/GetFBoxHistoryDataList?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxHistoryDataList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxHistoryDataList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxHistoryDataServiceProxy.prototype.processGetFBoxHistoryDataList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfFBoxHistoryDataListDto.fromJS(resultData200) : new PagedResultDtoOfFBoxHistoryDataListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FBoxHistoryDataServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FBoxHistoryDataServiceProxy);
    return FBoxHistoryDataServiceProxy;
}());
export { FBoxHistoryDataServiceProxy };
var FBoxMicroScriptServiceProxy = /** @class */ (function () {
    function FBoxMicroScriptServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @dataSourceId (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    FBoxMicroScriptServiceProxy.prototype.getMacroExecutePlanDetails = function (dataSourceId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxMicroScript/GetMacroExecutePlanDetails?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMacroExecutePlanDetails(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMacroExecutePlanDetails(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxMicroScriptServiceProxy.prototype.processGetMacroExecutePlanDetails = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfFBoxMacroExecutePlanDetailDto.fromJS(resultData200) : new PagedResultDtoOfFBoxMacroExecutePlanDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FBoxMicroScriptServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FBoxMicroScriptServiceProxy);
    return FBoxMicroScriptServiceProxy;
}());
export { FBoxMicroScriptServiceProxy };
var FBoxStateReportSearchServiceProxy = /** @class */ (function () {
    function FBoxStateReportSearchServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    FBoxStateReportSearchServiceProxy.prototype.getBoxSerialNumberAsync = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxStateReportSearch/GetBoxSerialNumberAsync?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBoxSerialNumberAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBoxSerialNumberAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxStateReportSearchServiceProxy.prototype.processGetBoxSerialNumberAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FBoxStateReportSearchServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FBoxStateReportSearchServiceProxy);
    return FBoxStateReportSearchServiceProxy;
}());
export { FBoxStateReportSearchServiceProxy };
var FBoxVariableServiceProxy = /** @class */ (function () {
    function FBoxVariableServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @dataSourceId (optional)
     * @name (optional)
     * @groupName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    FBoxVariableServiceProxy.prototype.getFBoxVariables = function (dataSourceId, name, groupName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxVariable/GetFBoxVariables?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (groupName !== undefined)
            url_ += "GroupName=" + encodeURIComponent("" + groupName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxVariableServiceProxy.prototype.processGetFBoxVariables = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfFBoxVariableForSingleDataSourceDto.fromJS(resultData200) : new PagedResultDtoOfFBoxVariableForSingleDataSourceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dataSourceId (optional)
     * @return Success
     */
    FBoxVariableServiceProxy.prototype.getFBoxVariableGroupNames = function (dataSourceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FBoxVariable/GetFBoxVariableGroupNames?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxVariableGroupNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxVariableGroupNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FBoxVariableServiceProxy.prototype.processGetFBoxVariableGroupNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_37 = resultData200; _i < resultData200_37.length; _i++) {
                        var item = resultData200_37[_i];
                        result200.push(FBoxVariableGroupNameDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FBoxVariableServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FBoxVariableServiceProxy);
    return FBoxVariableServiceProxy;
}());
export { FBoxVariableServiceProxy };
var FileHelperServiceProxy = /** @class */ (function () {
    function FileHelperServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @tempFileId (optional)
     * @return Success
     */
    FileHelperServiceProxy.prototype.deleteTempFile = function (tempFileId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FileHelper/DeleteTempFile?";
        if (tempFileId !== undefined)
            url_ += "tempFileId=" + encodeURIComponent("" + tempFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTempFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTempFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FileHelperServiceProxy.prototype.processDeleteTempFile = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FileHelperServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FileHelperServiceProxy);
    return FileHelperServiceProxy;
}());
export { FileHelperServiceProxy };
var FriendshipServiceProxy = /** @class */ (function () {
    function FriendshipServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.createFriendshipRequest = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateFriendshipRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processCreateFriendshipRequest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.createFriendshipRequestByUserName = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateFriendshipRequestByUserName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processCreateFriendshipRequestByUserName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.blockUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBlockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBlockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processBlockUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.unblockUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnblockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnblockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processUnblockUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.acceptFriendshipRequest = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAcceptFriendshipRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processAcceptFriendshipRequest = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    FriendshipServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], FriendshipServiceProxy);
    return FriendshipServiceProxy;
}());
export { FriendshipServiceProxy };
var GalleryServiceProxy = /** @class */ (function () {
    function GalleryServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @type (optional)
     * @return Success
     */
    GalleryServiceProxy.prototype.getGalleryConfig = function (type) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Gallery/GetGalleryConfig?";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGalleryConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGalleryConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GalleryServiceProxy.prototype.processGetGalleryConfig = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_38 = resultData200; _i < resultData200_38.length; _i++) {
                        var item = resultData200_38[_i];
                        result200.push(GraphConfigDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GalleryServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], GalleryServiceProxy);
    return GalleryServiceProxy;
}());
export { GalleryServiceProxy };
var HistoryAlarmServiceProxy = /** @class */ (function () {
    function HistoryAlarmServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 分页获取当前告警
    当前告警为以下状态:
    1.触发未确认
    2.触发已确认
    3.恢复未确认
    注意:
    1.如果虚拟设备ID传入,则查询当前虚拟设备ID的所有告警
    如果虚拟设备未传入,或者小于等于0,则查询当前用户所管理的所有设备数据
    2.显示具有四种类型,(1).触发未确认.(2).触发已确认.(3).恢复未确认(4)恢复已确认
    数据库存储只有两种类型,(1),触发,(2)恢复
    在查询时将前端类型转换为存储类型+确认时间是否为空
     * @virtualDeviceId (optional) 虚拟设备ID
    如果不传,获取传入小于等于0,
    则查询为当前用户所管理的所有虚拟设备数据
     * @alarmName (optional) 告警名称
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    HistoryAlarmServiceProxy.prototype.getCurrentAlarms = function (virtualDeviceId, alarmName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryAlarm/GetCurrentAlarms?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (alarmName !== undefined)
            url_ += "AlarmName=" + encodeURIComponent("" + alarmName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryAlarmServiceProxy.prototype.processGetCurrentAlarms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfHistoryAlarmOutput.fromJS(resultData200) : new PagedResultDtoOfHistoryAlarmOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 分页获取历史告警
    注意:
    1.如果虚拟设备ID传入,则查询当前虚拟设备ID的所有告警
    如果虚拟设备未传入,或者小于等于0,则查询当前用户所管理的所有设备数据
    2.显示具有四种类型,(1).触发未确认.(2).触发已确认.(3).恢复未确认(4)恢复已确认
    数据库存储只有两种类型,(1),触发,(2)恢复
    在查询时将前端类型转换为存储类型+确认时间是否为空
     * @virtualDeviceId (optional) 虚拟设备ID
    如果不传或者传入的小于等于0,则查询当前用户所管理的虚拟设备数据
     * @triggeredStartTime (optional) 触发时间间隔
    起始时间
     * @triggeredEndTime (optional) 触发时间间隔
    结束时间
     * @state (optional) 状态
     * @alarmLevel (optional) 告警等级
     * @alarmName (optional) 告警名称
     * @deviceName (optional) 设备名称
     * @alarmGroupName (optional) 告警组
     * @malfunctionCode (optional) 故障代码
     * @fCloudVariableName (optional) 变量名称
     * @recoveryStartTime (optional) 恢复开始时间
     * @recoveryEndTime (optional) 回复结束时间
     * @confirmStartTime (optional) 确认开始时间
     * @confirmEndTime (optional) 确认结束时间
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    HistoryAlarmServiceProxy.prototype.getHistoryAlarms = function (virtualDeviceId, triggeredStartTime, triggeredEndTime, state, alarmLevel, alarmName, deviceName, alarmGroupName, malfunctionCode, fCloudVariableName, recoveryStartTime, recoveryEndTime, confirmStartTime, confirmEndTime, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryAlarm/GetHistoryAlarms?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (triggeredStartTime !== undefined)
            url_ += "TriggeredStartTime=" + encodeURIComponent(triggeredStartTime ? "" + triggeredStartTime.toJSON() : "") + "&";
        if (triggeredEndTime !== undefined)
            url_ += "TriggeredEndTime=" + encodeURIComponent(triggeredEndTime ? "" + triggeredEndTime.toJSON() : "") + "&";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (alarmLevel !== undefined)
            url_ += "AlarmLevel=" + encodeURIComponent("" + alarmLevel) + "&";
        if (alarmName !== undefined)
            url_ += "AlarmName=" + encodeURIComponent("" + alarmName) + "&";
        if (deviceName !== undefined)
            url_ += "DeviceName=" + encodeURIComponent("" + deviceName) + "&";
        if (alarmGroupName !== undefined)
            url_ += "AlarmGroupName=" + encodeURIComponent("" + alarmGroupName) + "&";
        if (malfunctionCode !== undefined)
            url_ += "MalfunctionCode=" + encodeURIComponent("" + malfunctionCode) + "&";
        if (fCloudVariableName !== undefined)
            url_ += "FCloudVariableName=" + encodeURIComponent("" + fCloudVariableName) + "&";
        if (recoveryStartTime !== undefined)
            url_ += "RecoveryStartTime=" + encodeURIComponent(recoveryStartTime ? "" + recoveryStartTime.toJSON() : "") + "&";
        if (recoveryEndTime !== undefined)
            url_ += "RecoveryEndTime=" + encodeURIComponent(recoveryEndTime ? "" + recoveryEndTime.toJSON() : "") + "&";
        if (confirmStartTime !== undefined)
            url_ += "ConfirmStartTime=" + encodeURIComponent(confirmStartTime ? "" + confirmStartTime.toJSON() : "") + "&";
        if (confirmEndTime !== undefined)
            url_ += "ConfirmEndTime=" + encodeURIComponent(confirmEndTime ? "" + confirmEndTime.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryAlarmServiceProxy.prototype.processGetHistoryAlarms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfHistoryAlarmOutput.fromJS(resultData200) : new PagedResultDtoOfHistoryAlarmOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导出告警
    导出告警分为导出当前告警和历史告警
    导出当前告警导出的类型为
    1.触发未确认
    2.触发已确认
    3.恢复未确认
    注意:
    1.如果虚拟设备ID传入,则查询当前虚拟设备ID的所有告警
    如果虚拟设备未传入,或者小于等于0,则查询当前用户所管理的所有设备数据
    2.显示具有四种类型,(1).触发未确认.(2).触发已确认.(3).恢复未确认(4)恢复已确认
    数据库存储只有两种类型,(1),触发,(2)恢复
    在查询时将前端类型转换为存储类型+确认时间是否为空
     * @input (optional) 导出模型
     * @return Success
     */
    HistoryAlarmServiceProxy.prototype.outputExcelFile = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryAlarm/OutputExcelFile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOutputExcelFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOutputExcelFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryAlarmServiceProxy.prototype.processOutputExcelFile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据数据ID导出指定数据
     * @ids (optional) 数据ID集合
     * @return Success
     */
    HistoryAlarmServiceProxy.prototype.outputExcelFileById = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryAlarm/OutputExcelFileById";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ids);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOutputExcelFileById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOutputExcelFileById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryAlarmServiceProxy.prototype.processOutputExcelFileById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 确认告警
     * @ids (optional) 告警实例ID集合
     * @return Success
     */
    HistoryAlarmServiceProxy.prototype.confirmAlarm = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryAlarm/ConfirmAlarm";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ids);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processConfirmAlarm(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processConfirmAlarm(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryAlarmServiceProxy.prototype.processConfirmAlarm = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除告警
     * @ids (optional)
     * @return Success
     */
    HistoryAlarmServiceProxy.prototype.deleteAlarms = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryAlarm/DeleteAlarms?";
        if (ids !== undefined)
            ids && ids.forEach(function (item) { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryAlarmServiceProxy.prototype.processDeleteAlarms = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    HistoryAlarmServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], HistoryAlarmServiceProxy);
    return HistoryAlarmServiceProxy;
}());
export { HistoryAlarmServiceProxy };
var HistoryDataServiceProxy = /** @class */ (function () {
    function HistoryDataServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @configureId (optional) 组件编号,不可为空
     * @dataSourceId (optional) 数据源编号,查询时可为空
     * @historyDataNameOrChannelName (optional) 历史数据名称或通道名称
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.getHistoryData = function (configureId, dataSourceId, historyDataNameOrChannelName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/GetHistoryData?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (historyDataNameOrChannelName !== undefined)
            url_ += "HistoryDataNameOrChannelName=" + encodeURIComponent("" + historyDataNameOrChannelName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processGetHistoryData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfHistoryDataDto.fromJS(resultData200) : new PagedResultDtoOfHistoryDataDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional) 组件编号,不可为空
     * @dataSourceId (optional) 数据源编号,查询时可为空
     * @historyDataNameOrChannelName (optional) 历史数据名称或通道名称
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.getNoImportHistoryData = function (configureId, dataSourceId, historyDataNameOrChannelName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/GetNoImportHistoryData?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (historyDataNameOrChannelName !== undefined)
            url_ += "HistoryDataNameOrChannelName=" + encodeURIComponent("" + historyDataNameOrChannelName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNoImportHistoryData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNoImportHistoryData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processGetNoImportHistoryData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfHistoryDataDto.fromJS(resultData200) : new PagedResultDtoOfHistoryDataDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @ids (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.delHistoryData = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/DelHistoryData";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ids);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelHistoryData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelHistoryData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processDelHistoryData = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @dataSourceCode (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.getHistoryDataNames = function (configureId, dataSourceCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/GetHistoryDataNames?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (dataSourceCode !== undefined)
            url_ += "DataSourceCode=" + encodeURIComponent("" + dataSourceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryDataNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryDataNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processGetHistoryDataNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfHistoryDataNameListDto.fromJS(resultData200) : new ListResultDtoOfHistoryDataNameListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.getHistoryDataChannels = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/GetHistoryDataChannels?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryDataChannels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryDataChannels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processGetHistoryDataChannels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfHistoryDataChannelNameListDto.fromJS(resultData200) : new ListResultDtoOfHistoryDataChannelNameListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.createOrUpdateHistoryDataItem = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/CreateOrUpdateHistoryDataItem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateHistoryDataItem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateHistoryDataItem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processCreateOrUpdateHistoryDataItem = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.deleteHistoryDataItem = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/DeleteHistoryDataItem?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteHistoryDataItem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteHistoryDataItem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processDeleteHistoryDataItem = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.batchImportHistoryDataChannelFromDataSource = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/BatchImportHistoryDataChannelFromDataSource";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchImportHistoryDataChannelFromDataSource(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchImportHistoryDataChannelFromDataSource(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processBatchImportHistoryDataChannelFromDataSource = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    HistoryDataServiceProxy.prototype.batchImportHistoryDataChannel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryData/BatchImportHistoryDataChannel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchImportHistoryDataChannel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchImportHistoryDataChannel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryDataServiceProxy.prototype.processBatchImportHistoryDataChannel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    HistoryDataServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], HistoryDataServiceProxy);
    return HistoryDataServiceProxy;
}());
export { HistoryDataServiceProxy };
var HistoryEventServiceProxy = /** @class */ (function () {
    function HistoryEventServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取历史事件
    注意:
    1.如果虚拟设备ID传入,则查询当前虚拟设备ID的所有告警
    如果虚拟设备未传入,或者小于等于0,则查询当前用户所管理的所有设备数据
     * @virtualDeviceId (optional) 值为null或者0  代表全局所有虚拟设备
     * @triggeredStartTime (optional) 触发时间间隔
    起始时间
     * @triggeredEndTime (optional) 触发时间间隔
    结束时间
     * @state (optional) 状态
     * @eventName (optional) 事件名称
     * @deviceName (optional) 设备名称
     * @eventGroupName (optional) 事件组
     * @fCloudVariableName (optional) 变量名称
     * @recoveryStartTime (optional) 恢复开始时间
     * @recoveryEndTime (optional) 恢复结束时间
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    HistoryEventServiceProxy.prototype.getHistoryEvent = function (virtualDeviceId, triggeredStartTime, triggeredEndTime, state, eventName, deviceName, eventGroupName, fCloudVariableName, recoveryStartTime, recoveryEndTime, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryEvent/GetHistoryEvent?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (triggeredStartTime !== undefined)
            url_ += "TriggeredStartTime=" + encodeURIComponent(triggeredStartTime ? "" + triggeredStartTime.toJSON() : "") + "&";
        if (triggeredEndTime !== undefined)
            url_ += "TriggeredEndTime=" + encodeURIComponent(triggeredEndTime ? "" + triggeredEndTime.toJSON() : "") + "&";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (eventName !== undefined)
            url_ += "EventName=" + encodeURIComponent("" + eventName) + "&";
        if (deviceName !== undefined)
            url_ += "DeviceName=" + encodeURIComponent("" + deviceName) + "&";
        if (eventGroupName !== undefined)
            url_ += "EventGroupName=" + encodeURIComponent("" + eventGroupName) + "&";
        if (fCloudVariableName !== undefined)
            url_ += "FCloudVariableName=" + encodeURIComponent("" + fCloudVariableName) + "&";
        if (recoveryStartTime !== undefined)
            url_ += "RecoveryStartTime=" + encodeURIComponent(recoveryStartTime ? "" + recoveryStartTime.toJSON() : "") + "&";
        if (recoveryEndTime !== undefined)
            url_ += "RecoveryEndTime=" + encodeURIComponent(recoveryEndTime ? "" + recoveryEndTime.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryEvent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryEvent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryEventServiceProxy.prototype.processGetHistoryEvent = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfHistoryEventOutput.fromJS(resultData200) : new PagedResultDtoOfHistoryEventOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导出历史事件
    注意:虚拟设备ID具有两种获取方式
    1.直接传入单个虚拟设备ID
    2.如果没有传入,那么则查询的是当前用户所管理的所有虚拟设备ID
     * @input (optional) 导出条件
     * @return Success
     */
    HistoryEventServiceProxy.prototype.outputExcelFile = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryEvent/OutputExcelFile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOutputExcelFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOutputExcelFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryEventServiceProxy.prototype.processOutputExcelFile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据id导出文件
     * @ids (optional) 数据实例id集合
     * @return Success
     */
    HistoryEventServiceProxy.prototype.outputExcelFileById = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HistoryEvent/OutputExcelFileById";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ids);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOutputExcelFileById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOutputExcelFileById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HistoryEventServiceProxy.prototype.processOutputExcelFileById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    HistoryEventServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], HistoryEventServiceProxy);
    return HistoryEventServiceProxy;
}());
export { HistoryEventServiceProxy };
var HostDashboardServiceProxy = /** @class */ (function () {
    function HostDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @incomeStatisticsDateInterval (optional)
     * @startDate (optional)
     * @endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getDashboardStatisticsData = function (incomeStatisticsDateInterval, startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardStatisticsData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardStatisticsData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetDashboardStatisticsData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? HostDashboardData.fromJS(resultData200) : new HostDashboardData();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @incomeStatisticsDateInterval (optional)
     * @startDate (optional)
     * @endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getIncomeStatistics = function (incomeStatisticsDateInterval, startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetIncomeStatistics(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetIncomeStatistics = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetIncomeStatisticsDataOutput.fromJS(resultData200) : new GetIncomeStatisticsDataOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @startDate (optional)
     * @endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getEditionTenantStatistics = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionTenantStatistics(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetEditionTenantStatistics = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetEditionTenantStatisticsOutput.fromJS(resultData200) : new GetEditionTenantStatisticsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    HostDashboardServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], HostDashboardServiceProxy);
    return HostDashboardServiceProxy;
}());
export { HostDashboardServiceProxy };
var HostSettingsServiceProxy = /** @class */ (function () {
    function HostSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    HostSettingsServiceProxy.prototype.getAllSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processGetAllSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? HostSettingsEditDto.fromJS(resultData200) : new HostSettingsEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    HostSettingsServiceProxy.prototype.updateAllSettings = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processUpdateAllSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    HostSettingsServiceProxy.prototype.sendTestEmail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTestEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTestEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processSendTestEmail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    HostSettingsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], HostSettingsServiceProxy);
    return HostSettingsServiceProxy;
}());
export { HostSettingsServiceProxy };
var InstallServiceProxy = /** @class */ (function () {
    function InstallServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    InstallServiceProxy.prototype.setup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processSetup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    InstallServiceProxy.prototype.getAppSettingsJson = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAppSettingsJson(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processGetAppSettingsJson = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    InstallServiceProxy.prototype.checkDatabase = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckDatabase(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckDatabase(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processCheckDatabase = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CheckDatabaseOutput.fromJS(resultData200) : new CheckDatabaseOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    InstallServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], InstallServiceProxy);
    return InstallServiceProxy;
}());
export { InstallServiceProxy };
var InternalOrganizationServiceProxy = /** @class */ (function () {
    function InternalOrganizationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getOrganizationsForTree = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetOrganizationsForTree?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationsForTree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationsForTree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetOrganizationsForTree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_39 = resultData200; _i < resultData200_39.length; _i++) {
                        var item = resultData200_39[_i];
                        result200.push(OrganizationForTreeDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getOrganizationTreeForDetail = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetOrganizationTreeForDetail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationTreeForDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationTreeForDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetOrganizationTreeForDetail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_40 = resultData200; _i < resultData200_40.length; _i++) {
                        var item = resultData200_40[_i];
                        result200.push(OrganizationForTreeDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getOrganizations = function (maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetOrganizations?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetOrganizations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getOrganizationsForMap = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetOrganizationsForMap";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationsForMap(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationsForMap(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetOrganizationsForMap = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_41 = resultData200; _i < resultData200_41.length; _i++) {
                        var item = resultData200_41[_i];
                        result200.push(OrganizationListForMapDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getAttachmentsForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetAttachmentsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAttachmentsForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAttachmentsForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetAttachmentsForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_42 = resultData200; _i < resultData200_42.length; _i++) {
                        var item = resultData200_42[_i];
                        result200.push(OrganizationAttachmentDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @term (optional)
     * @organizationType (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getOrganizationsWithFilter = function (term, organizationType, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetOrganizationsWithFilter?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (organizationType !== undefined)
            url_ += "OrganizationType=" + encodeURIComponent("" + organizationType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationsWithFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationsWithFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetOrganizationsWithFilter = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getOrganizationForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetOrganizationForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetOrganizationForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationForEditDto.fromJS(resultData200) : new OrganizationForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getOrganizationDetail = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetOrganizationDetail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetOrganizationDetail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDetailDto.fromJS(resultData200) : new OrganizationDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取内部组织角色
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getRoles = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetRoles";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetRoles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_43 = resultData200; _i < resultData200_43.length; _i++) {
                        var item = resultData200_43[_i];
                        result200.push(RoleListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @filter (optional)
     * @role (optional)
     * @active (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.getUsers = function (id, filter, role, active, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/GetUsers?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (active !== undefined)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processGetUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserListForDetailDto.fromJS(resultData200) : new PagedResultDtoOfUserListForDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.createOrUpdateOrganization = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/CreateOrUpdateOrganization";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateOrganization(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateOrganization(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processCreateOrUpdateOrganization = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.deleteOrganization = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/DeleteOrganization?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteOrganization(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteOrganization(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processDeleteOrganization = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @file (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.createOrganizationTempFile = function (file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/CreateOrganizationTempFile?";
        if (file !== undefined)
            url_ += "File=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrganizationTempFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrganizationTempFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processCreateOrganizationTempFile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.deleteTempFile = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/DeleteTempFile?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTempFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTempFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processDeleteTempFile = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.downloadAttachment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/DownloadAttachment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDownloadAttachment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDownloadAttachment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processDownloadAttachment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    InternalOrganizationServiceProxy.prototype.exportToExcel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InternalOrganization/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InternalOrganizationServiceProxy.prototype.processExportToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    InternalOrganizationServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], InternalOrganizationServiceProxy);
    return InternalOrganizationServiceProxy;
}());
export { InternalOrganizationServiceProxy };
var InvoiceServiceProxy = /** @class */ (function () {
    function InvoiceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    InvoiceServiceProxy.prototype.getInvoiceInfo = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetInvoiceInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InvoiceServiceProxy.prototype.processGetInvoiceInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvoiceDto.fromJS(resultData200) : new InvoiceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    InvoiceServiceProxy.prototype.createInvoice = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateInvoice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateInvoice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InvoiceServiceProxy.prototype.processCreateInvoice = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    InvoiceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], InvoiceServiceProxy);
    return InvoiceServiceProxy;
}());
export { InvoiceServiceProxy };
var LanguageServiceProxy = /** @class */ (function () {
    function LanguageServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguages(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguages(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguageForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguageForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguageForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetLanguageForEditOutput.fromJS(resultData200) : new GetLanguageForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.createOrUpdateLanguage = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processCreateOrUpdateLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.deleteLanguage = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processDeleteLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.setDefaultLanguage = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetDefaultLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processSetDefaultLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @sorting (optional)
     * @baseLanguageName (optional)
     * @targetValueFilter (optional)
     * @filterText (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguageTexts = function (maxResultCount, skipCount, sorting, sourceName, baseLanguageName, targetLanguageName, targetValueFilter, filterText) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguageTexts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguageTexts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfLanguageTextListDto.fromJS(resultData200) : new PagedResultDtoOfLanguageTextListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.updateLanguageText = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateLanguageText(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processUpdateLanguageText = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    LanguageServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], LanguageServiceProxy);
    return LanguageServiceProxy;
}());
export { LanguageServiceProxy };
var LiveReportServiceProxy = /** @class */ (function () {
    function LiveReportServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @virtualDeviceId (optional)
     * @variableGroupName (optional)
     * @dataSourceName (optional)
     * @dataType (optional)
     * @rwType (optional)
     * @variableNames (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    LiveReportServiceProxy.prototype.getVirtualDeviceVariables = function (virtualDeviceId, variableGroupName, dataSourceName, dataType, rwType, variableNames, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LiveReport/GetVirtualDeviceVariables?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (variableGroupName !== undefined)
            url_ += "VariableGroupName=" + encodeURIComponent("" + variableGroupName) + "&";
        if (dataSourceName !== undefined)
            url_ += "DataSourceName=" + encodeURIComponent("" + dataSourceName) + "&";
        if (dataType !== undefined)
            url_ += "DataType=" + encodeURIComponent("" + dataType) + "&";
        if (rwType !== undefined)
            url_ += "RwType=" + encodeURIComponent("" + rwType) + "&";
        if (variableNames !== undefined)
            variableNames && variableNames.forEach(function (item) { url_ += "VariableNames=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVirtualDeviceVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVirtualDeviceVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LiveReportServiceProxy.prototype.processGetVirtualDeviceVariables = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVariableItemForLiveReportDto.fromJS(resultData200) : new PagedResultDtoOfVariableItemForLiveReportDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    LiveReportServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], LiveReportServiceProxy);
    return LiveReportServiceProxy;
}());
export { LiveReportServiceProxy };
var LiveVariableDataServiceProxy = /** @class */ (function () {
    function LiveVariableDataServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取某个变量某个时间段的值
     * @loadFCloudVariableDataDto (optional)
     * @return Success
     */
    LiveVariableDataServiceProxy.prototype.loadVariableData = function (loadFCloudVariableDataDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LiveVariableData/LoadVariableData";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(loadFCloudVariableDataDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLoadVariableData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLoadVariableData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LiveVariableDataServiceProxy.prototype.processLoadVariableData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_44 = resultData200; _i < resultData200_44.length; _i++) {
                        var item = resultData200_44[_i];
                        result200.push(LiveVariableDataDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取设备轨迹
     * @input (optional)
     * @return Success
     */
    LiveVariableDataServiceProxy.prototype.queryVirtualDeviceTrajectory = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LiveVariableData/QueryVirtualDeviceTrajectory";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processQueryVirtualDeviceTrajectory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processQueryVirtualDeviceTrajectory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LiveVariableDataServiceProxy.prototype.processQueryVirtualDeviceTrajectory = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_45 = resultData200; _i < resultData200_45.length; _i++) {
                        var item = resultData200_45[_i];
                        result200.push(VirtualDeviceTrajectoryDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    LiveVariableDataServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], LiveVariableDataServiceProxy);
    return LiveVariableDataServiceProxy;
}());
export { LiveVariableDataServiceProxy };
var LoginInfoServiceProxy = /** @class */ (function () {
    function LoginInfoServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @takeCount (optional)
     * @skipCount (optional)
     * @startTime (optional)
     * @endTime (optional)
     * @clientType (optional)
     * @return Success
     */
    LoginInfoServiceProxy.prototype.getPagedLoginInfo = function (takeCount, skipCount, startTime, endTime, clientType) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LoginInfo/GetPagedLoginInfo?";
        if (takeCount !== undefined)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        if (clientType !== undefined)
            url_ += "ClientType=" + encodeURIComponent("" + clientType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPagedLoginInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPagedLoginInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoginInfoServiceProxy.prototype.processGetPagedLoginInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfActionLogInfoDto.fromJS(resultData200) : new PagedResultDtoOfActionLogInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    LoginInfoServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], LoginInfoServiceProxy);
    return LoginInfoServiceProxy;
}());
export { LoginInfoServiceProxy };
var MaintenancePlanServiceProxy = /** @class */ (function () {
    function MaintenancePlanServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    MaintenancePlanServiceProxy.prototype.createMaintenancePlan = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlan/CreateMaintenancePlan";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateMaintenancePlan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateMaintenancePlan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanServiceProxy.prototype.processCreateMaintenancePlan = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    MaintenancePlanServiceProxy.prototype.updateMaintenancePlan = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlan/UpdateMaintenancePlan";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateMaintenancePlan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateMaintenancePlan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanServiceProxy.prototype.processUpdateMaintenancePlan = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    MaintenancePlanServiceProxy.prototype.deleteMaintenancePlan = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlan/DeleteMaintenancePlan?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteMaintenancePlan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteMaintenancePlan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanServiceProxy.prototype.processDeleteMaintenancePlan = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @deviceName (optional) 设备名称
     * @deviceSerialNumber (optional) 设备序列号
     * @deviceModelId (optional) 设备模板
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    MaintenancePlanServiceProxy.prototype.getUnplanedDevices = function (deviceName, deviceSerialNumber, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlan/GetUnplanedDevices?";
        if (deviceName !== undefined)
            url_ += "DeviceName=" + encodeURIComponent("" + deviceName) + "&";
        if (deviceSerialNumber !== undefined)
            url_ += "DeviceSerialNumber=" + encodeURIComponent("" + deviceSerialNumber) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUnplanedDevices(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUnplanedDevices(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanServiceProxy.prototype.processGetUnplanedDevices = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUnAssignedDeviceDto.fromJS(resultData200) : new PagedResultDtoOfUnAssignedDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    MaintenancePlanServiceProxy.prototype.assignWorkOrder = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlan/AssignWorkOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAssignWorkOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAssignWorkOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanServiceProxy.prototype.processAssignWorkOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MaintenancePlanServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], MaintenancePlanServiceProxy);
    return MaintenancePlanServiceProxy;
}());
export { MaintenancePlanServiceProxy };
var MaintenancePlanListServiceProxy = /** @class */ (function () {
    function MaintenancePlanListServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @baseFilter (optional)
     * @warrantyType (optional) 维保类型
     * @planState (optional) 计划状态
     * @deviceModelId (optional) 产品型号
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    MaintenancePlanListServiceProxy.prototype.getMaintenancePlanList = function (baseFilter, warrantyType, planState, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlanList/GetMaintenancePlanList?";
        if (baseFilter !== undefined)
            url_ += "BaseFilter=" + encodeURIComponent("" + baseFilter) + "&";
        if (warrantyType !== undefined)
            url_ += "WarrantyType=" + encodeURIComponent("" + warrantyType) + "&";
        if (planState !== undefined)
            url_ += "PlanState=" + encodeURIComponent("" + planState) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMaintenancePlanList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMaintenancePlanList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanListServiceProxy.prototype.processGetMaintenancePlanList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfMaintenancePlanDto.fromJS(resultData200) : new PagedResultDtoOfMaintenancePlanDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    MaintenancePlanListServiceProxy.prototype.getUsedDeviceModels = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlanList/GetUsedDeviceModels";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsedDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsedDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanListServiceProxy.prototype.processGetUsedDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceModelListDto.fromJS(resultData200) : new ListResultDtoOfDeviceModelListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    MaintenancePlanListServiceProxy.prototype.getAllDeviceModels = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlanList/GetAllDeviceModels";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanListServiceProxy.prototype.processGetAllDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceModelListDto.fromJS(resultData200) : new ListResultDtoOfDeviceModelListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    MaintenancePlanListServiceProxy.prototype.exportMaintenancePlans = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenancePlanList/ExportMaintenancePlans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportMaintenancePlans(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportMaintenancePlans(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenancePlanListServiceProxy.prototype.processExportMaintenancePlans = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MaintenancePlanListServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], MaintenancePlanListServiceProxy);
    return MaintenancePlanListServiceProxy;
}());
export { MaintenancePlanListServiceProxy };
var MaintenanceRecordsServiceProxy = /** @class */ (function () {
    function MaintenanceRecordsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @serialNumber (optional) 工单号
     * @deviceId (optional) 设备Id
     * @creationStartTime (optional) 创建时间开始
     * @creationEndTime (optional) 创建时间结束
     * @finishStartTime (optional) 完成时间开始
     * @finishEndTime (optional) 完成时间结束
     * @workOrderType (optional) 工单类型
     * @state (optional) 工单状态
     * @exector (optional) 维保人
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    MaintenanceRecordsServiceProxy.prototype.getMaintenanceRecordList = function (serialNumber, deviceId, creationStartTime, creationEndTime, finishStartTime, finishEndTime, workOrderType, state, exector, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MaintenanceRecords/GetMaintenanceRecordList?";
        if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (creationStartTime !== undefined)
            url_ += "CreationStartTime=" + encodeURIComponent(creationStartTime ? "" + creationStartTime.toJSON() : "") + "&";
        if (creationEndTime !== undefined)
            url_ += "CreationEndTime=" + encodeURIComponent(creationEndTime ? "" + creationEndTime.toJSON() : "") + "&";
        if (finishStartTime !== undefined)
            url_ += "FinishStartTime=" + encodeURIComponent(finishStartTime ? "" + finishStartTime.toJSON() : "") + "&";
        if (finishEndTime !== undefined)
            url_ += "FinishEndTime=" + encodeURIComponent(finishEndTime ? "" + finishEndTime.toJSON() : "") + "&";
        if (workOrderType !== undefined)
            url_ += "WorkOrderType=" + encodeURIComponent("" + workOrderType) + "&";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (exector !== undefined)
            url_ += "Exector=" + encodeURIComponent("" + exector) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMaintenanceRecordList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMaintenanceRecordList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MaintenanceRecordsServiceProxy.prototype.processGetMaintenanceRecordList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfMaintenanceRecordDto.fromJS(resultData200) : new PagedResultDtoOfMaintenanceRecordDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MaintenanceRecordsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], MaintenanceRecordsServiceProxy);
    return MaintenanceRecordsServiceProxy;
}());
export { MaintenanceRecordsServiceProxy };
var ModelGroupServiceProxy = /** @class */ (function () {
    function ModelGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * input.Id 有值时排除子集 没有时查询全部
     * @id (optional)
     * @return Success
     */
    ModelGroupServiceProxy.prototype.getModelGroups = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelGroup/GetModelGroups?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetModelGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetModelGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelGroupServiceProxy.prototype.processGetModelGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_46 = resultData200; _i < resultData200_46.length; _i++) {
                        var item = resultData200_46[_i];
                        result200.push(ModelGroupListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取编辑组对象
     * @id (optional)
     * @return Success
     */
    ModelGroupServiceProxy.prototype.getModelGroupForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelGroup/GetModelGroupForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetModelGroupForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetModelGroupForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelGroupServiceProxy.prototype.processGetModelGroupForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ModelGroupForEditDto.fromJS(resultData200) : new ModelGroupForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 创建或修改模板组
     * @input (optional)
     * @return Success
     */
    ModelGroupServiceProxy.prototype.createOrUpdateModelGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelGroup/CreateOrUpdateModelGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateModelGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateModelGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelGroupServiceProxy.prototype.processCreateOrUpdateModelGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除模板组
     * @id (optional)
     * @return Success
     */
    ModelGroupServiceProxy.prototype.deleteModelGroup = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelGroup/DeleteModelGroup?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteModelGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteModelGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelGroupServiceProxy.prototype.processDeleteModelGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 更新模板组排序
     * @input (optional)
     * @return Success
     */
    ModelGroupServiceProxy.prototype.updateModelGroupOrder = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelGroup/UpdateModelGroupOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateModelGroupOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateModelGroupOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelGroupServiceProxy.prototype.processUpdateModelGroupOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ModelGroupServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ModelGroupServiceProxy);
    return ModelGroupServiceProxy;
}());
export { ModelGroupServiceProxy };
var ModelImportServiceProxy = /** @class */ (function () {
    function ModelImportServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 检测即将导入的模板名是否存在
     * @input (optional)
     * @return Success
     */
    ModelImportServiceProxy.prototype.checkRepeatName = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelImport/CheckRepeatName";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckRepeatName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckRepeatName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelImportServiceProxy.prototype.processCheckRepeatName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 跨租户导入模板
     * @input (optional)
     * @return Success
     */
    ModelImportServiceProxy.prototype.importModel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelImport/ImportModel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportModel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportModel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelImportServiceProxy.prototype.processImportModel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ModelImportServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ModelImportServiceProxy);
    return ModelImportServiceProxy;
}());
export { ModelImportServiceProxy };
var ModelShareServiceProxy = /** @class */ (function () {
    function ModelShareServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 创建分享码
     * @input (optional)
     * @return Success
     */
    ModelShareServiceProxy.prototype.createShareCode = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelShare/CreateShareCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateShareCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateShareCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelShareServiceProxy.prototype.processCreateShareCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 检查分享码是否有效
     * @input (optional)
     * @return Success
     */
    ModelShareServiceProxy.prototype.checkShareCode = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ModelShare/CheckShareCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckShareCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckShareCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ModelShareServiceProxy.prototype.processCheckShareCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ModelShareServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ModelShareServiceProxy);
    return ModelShareServiceProxy;
}());
export { ModelShareServiceProxy };
var NotificationServiceProxy = /** @class */ (function () {
    function NotificationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @state (optional)
     * @startTime (optional)
     * @endTime (optional)
     * @searchStr (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.getUserNotifications = function (state, startTime, endTime, searchStr, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        if (searchStr !== undefined)
            url_ += "SearchStr=" + encodeURIComponent("" + searchStr) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserNotifications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserNotifications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetUserNotifications = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetNotificationsOutput.fromJS(resultData200) : new GetNotificationsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 设置全部消息为已读
    此方法具有两种操作
    1.如果消息数量小于1万,那么直接设置
    2.如果消息数量大于1万,则将消息扔到job中执行,
     * @return Success
     */
    NotificationServiceProxy.prototype.setAllNotificationsAsRead = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetAllNotificationsAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processSetAllNotificationsAsRead = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 消息设为已读
     * @input (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.setNotificationAsRead = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetNotificationAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processSetNotificationAsRead = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    NotificationServiceProxy.prototype.getNotificationSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNotificationSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetNotificationSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetNotificationSettingsOutput.fromJS(resultData200) : new GetNotificationSettingsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取语音配置
     * @return Success
     */
    NotificationServiceProxy.prototype.getEnableAlarmSound = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetEnableAlarmSound";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEnableAlarmSound(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEnableAlarmSound(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetEnableAlarmSound = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AlarmSoundConfigDto.fromJS(resultData200) : new AlarmSoundConfigDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.updateNotificationSettings = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateNotificationSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processUpdateNotificationSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    NotificationServiceProxy.prototype.getUserUnreadNotificationCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetUserUnreadNotificationCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserUnreadNotificationCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserUnreadNotificationCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetUserUnreadNotificationCount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 清除全部消息
    此方法具有两种操作
    1.如果消息数量小于1万,那么直接清除
    2.如果消息数量大于1万,则将消息扔到job中执行,
     * @return Success
     */
    NotificationServiceProxy.prototype.deleteAllUserNotifications = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteAllUserNotifications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processDeleteAllUserNotifications = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据消息id，删除消息
     * @userNotificationIds (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.deleteNotificationByIds = function (userNotificationIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotificationByIds?";
        if (userNotificationIds !== undefined)
            userNotificationIds && userNotificationIds.forEach(function (item) { url_ += "UserNotificationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteNotificationByIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteNotificationByIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processDeleteNotificationByIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.exportAlarmNotifications = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/ExportAlarmNotifications";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportAlarmNotifications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportAlarmNotifications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processExportAlarmNotifications = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    NotificationServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], NotificationServiceProxy);
    return NotificationServiceProxy;
}());
export { NotificationServiceProxy };
var NotificationBlacklistServiceProxy = /** @class */ (function () {
    function NotificationBlacklistServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @tenantId (optional)
     * @return Success
     */
    NotificationBlacklistServiceProxy.prototype.isTenantEnableAsync = function (tenantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NotificationBlacklist/IsTenantEnableAsync?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsTenantEnableAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsTenantEnableAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationBlacklistServiceProxy.prototype.processIsTenantEnableAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @boxSerialNumber (optional)
     * @return Success
     */
    NotificationBlacklistServiceProxy.prototype.isBoxEnableAsync = function (boxSerialNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NotificationBlacklist/IsBoxEnableAsync?";
        if (boxSerialNumber !== undefined)
            url_ += "boxSerialNumber=" + encodeURIComponent("" + boxSerialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsBoxEnableAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsBoxEnableAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationBlacklistServiceProxy.prototype.processIsBoxEnableAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tenantId (optional)
     * @return Success
     */
    NotificationBlacklistServiceProxy.prototype.enableTenantAlarmNotification = function (tenantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NotificationBlacklist/EnableTenantAlarmNotification?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEnableTenantAlarmNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEnableTenantAlarmNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationBlacklistServiceProxy.prototype.processEnableTenantAlarmNotification = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tenantId (optional)
     * @return Success
     */
    NotificationBlacklistServiceProxy.prototype.disableTenantAlarmNotification = function (tenantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NotificationBlacklist/DisableTenantAlarmNotification?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDisableTenantAlarmNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDisableTenantAlarmNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationBlacklistServiceProxy.prototype.processDisableTenantAlarmNotification = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @boxSerialNumber (optional)
     * @return Success
     */
    NotificationBlacklistServiceProxy.prototype.enableBoxAlarmNotification = function (boxSerialNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NotificationBlacklist/EnableBoxAlarmNotification?";
        if (boxSerialNumber !== undefined)
            url_ += "boxSerialNumber=" + encodeURIComponent("" + boxSerialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEnableBoxAlarmNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEnableBoxAlarmNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationBlacklistServiceProxy.prototype.processEnableBoxAlarmNotification = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @boxSerialNumber (optional)
     * @return Success
     */
    NotificationBlacklistServiceProxy.prototype.disableBoxAlarmNotification = function (boxSerialNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NotificationBlacklist/DisableBoxAlarmNotification?";
        if (boxSerialNumber !== undefined)
            url_ += "boxSerialNumber=" + encodeURIComponent("" + boxSerialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDisableBoxAlarmNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDisableBoxAlarmNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationBlacklistServiceProxy.prototype.processDisableBoxAlarmNotification = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    NotificationBlacklistServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], NotificationBlacklistServiceProxy);
    return NotificationBlacklistServiceProxy;
}());
export { NotificationBlacklistServiceProxy };
var OperationCenterServiceProxy = /** @class */ (function () {
    function OperationCenterServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    OperationCenterServiceProxy.prototype.getDevicesForMap = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenter/GetDevicesForMap";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevicesForMap(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevicesForMap(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterServiceProxy.prototype.processGetDevicesForMap = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceListForMapDto.fromJS(resultData200) : new ListResultDtoOfDeviceListForMapDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    OperationCenterServiceProxy.prototype.getDeviceLocationInfoForMap = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenter/GetDeviceLocationInfoForMap";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceLocationInfoForMap(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceLocationInfoForMap(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterServiceProxy.prototype.processGetDeviceLocationInfoForMap = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceLocationInfoForMapDto.fromJS(resultData200) : new ListResultDtoOfDeviceLocationInfoForMapDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    OperationCenterServiceProxy.prototype.getUserLocationsForMap = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenter/GetUserLocationsForMap";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserLocationsForMap(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserLocationsForMap(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterServiceProxy.prototype.processGetUserLocationsForMap = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfUserLocationsForMapDto.fromJS(resultData200) : new ListResultDtoOfUserLocationsForMapDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @userId (optional)
     * @return Success
     */
    OperationCenterServiceProxy.prototype.getUserContact = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenter/GetUserContact?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserContact(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserContact(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterServiceProxy.prototype.processGetUserContact = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserContactDto.fromJS(resultData200) : new UserContactDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @releasedConfigureId (optional)
     * @return Success
     */
    OperationCenterServiceProxy.prototype.getDeviceThumbnailVariables = function (releasedConfigureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenter/GetDeviceThumbnailVariables?";
        if (releasedConfigureId !== undefined)
            url_ += "releasedConfigureId=" + encodeURIComponent("" + releasedConfigureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceThumbnailVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceThumbnailVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterServiceProxy.prototype.processGetDeviceThumbnailVariables = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfReleasedVariableNameMappingListDto.fromJS(resultData200) : new ListResultDtoOfReleasedVariableNameMappingListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    OperationCenterServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], OperationCenterServiceProxy);
    return OperationCenterServiceProxy;
}());
export { OperationCenterServiceProxy };
var OperationCenterConfigServiceProxy = /** @class */ (function () {
    function OperationCenterConfigServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    OperationCenterConfigServiceProxy.prototype.updateUserMapInfo = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenterConfig/UpdateUserMapInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserMapInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserMapInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterConfigServiceProxy.prototype.processUpdateUserMapInfo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    OperationCenterConfigServiceProxy.prototype.updateMapTheme = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenterConfig/UpdateMapTheme";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateMapTheme(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateMapTheme(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterConfigServiceProxy.prototype.processUpdateMapTheme = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 更新地图点是否聚合
     * @isPointAggregation (optional) 点是否聚合
     * @return Success
     */
    OperationCenterConfigServiceProxy.prototype.updateMapPointAggregation = function (isPointAggregation) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenterConfig/UpdateMapPointAggregation?";
        if (isPointAggregation !== undefined)
            url_ += "isPointAggregation=" + encodeURIComponent("" + isPointAggregation) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateMapPointAggregation(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateMapPointAggregation(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterConfigServiceProxy.prototype.processUpdateMapPointAggregation = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    OperationCenterConfigServiceProxy.prototype.getCurrentUserMapOption = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenterConfig/GetCurrentUserMapOption";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentUserMapOption(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentUserMapOption(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterConfigServiceProxy.prototype.processGetCurrentUserMapOption = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserMapAndThemeInfoDto.fromJS(resultData200) : new UserMapAndThemeInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    OperationCenterConfigServiceProxy.prototype.getThumbnailConfig = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenterConfig/GetThumbnailConfig";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetThumbnailConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetThumbnailConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterConfigServiceProxy.prototype.processGetThumbnailConfig = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ThumbnailConfigDto.fromJS(resultData200) : new ThumbnailConfigDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    OperationCenterConfigServiceProxy.prototype.getMapDeviceRefreshTime = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OperationCenterConfig/GetMapDeviceRefreshTime";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMapDeviceRefreshTime(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMapDeviceRefreshTime(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OperationCenterConfigServiceProxy.prototype.processGetMapDeviceRefreshTime = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    OperationCenterConfigServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], OperationCenterConfigServiceProxy);
    return OperationCenterConfigServiceProxy;
}());
export { OperationCenterConfigServiceProxy };
var OrganizationServiceProxy = /** @class */ (function () {
    function OrganizationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取组织机构树
     * @return Success
     */
    OrganizationServiceProxy.prototype.getOrganizationsForTree = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Organization/GetOrganizationsForTree";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationsForTree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationsForTree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationServiceProxy.prototype.processGetOrganizationsForTree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_47 = resultData200; _i < resultData200_47.length; _i++) {
                        var item = resultData200_47[_i];
                        result200.push(OrganizationForTreeDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 运营仪表盘获取待选择用户
     * @return Success
     */
    OrganizationServiceProxy.prototype.getUsersForDashboard = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Organization/GetUsersForDashboard";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsersForDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsersForDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationServiceProxy.prototype.processGetUsersForDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_48 = resultData200; _i < resultData200_48.length; _i++) {
                        var item = resultData200_48[_i];
                        result200.push(UserListForDashboardDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取内部组织用户
     * @id (optional)
     * @return Success
     */
    OrganizationServiceProxy.prototype.getInternalUserList = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Organization/GetInternalUserList?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetInternalUserList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetInternalUserList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationServiceProxy.prototype.processGetInternalUserList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_49 = resultData200; _i < resultData200_49.length; _i++) {
                        var item = resultData200_49[_i];
                        result200.push(UserListForOrganizationDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取内部组织树
     * @return Success
     */
    OrganizationServiceProxy.prototype.getInternalOrganizationsForTree = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Organization/GetInternalOrganizationsForTree";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetInternalOrganizationsForTree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetInternalOrganizationsForTree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationServiceProxy.prototype.processGetInternalOrganizationsForTree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_50 = resultData200; _i < resultData200_50.length; _i++) {
                        var item = resultData200_50[_i];
                        result200.push(OrganizationForTreeDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    OrganizationServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], OrganizationServiceProxy);
    return OrganizationServiceProxy;
}());
export { OrganizationServiceProxy };
var OrganizationDataPermissionServiceProxy = /** @class */ (function () {
    function OrganizationDataPermissionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 内部组织查看数据权限
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDeviceQueryOptions = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDeviceQueryOptions?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceQueryOptions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceQueryOptions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDeviceQueryOptions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceQueryOptionDto.fromJS(resultData200) : new OrganizationDeviceQueryOptionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织设备筛选项
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDeviceQueryOptionsForExternal = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDeviceQueryOptionsForExternal?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceQueryOptionsForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceQueryOptionsForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDeviceQueryOptionsForExternal = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceQueryOptionDto.fromJS(resultData200) : new OrganizationDeviceQueryOptionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户设备筛选项
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDeviceQueryOptionsForUser = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDeviceQueryOptionsForUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceQueryOptionsForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceQueryOptionsForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDeviceQueryOptionsForUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceQueryOptionDto.fromJS(resultData200) : new OrganizationDeviceQueryOptionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织获取设备
     * @id (optional) 人员Id 或者组织 Id
     * @term (optional) 搜索
     * @devicePattern (optional) 设备型号
     * @deviceModelId (optional) 设备模板 Id
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDevices = function (id, term, devicePattern, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDevices?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevices(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevices(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDevices = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationDeviceDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织获取设备
     * @id (optional) 人员Id 或者组织 Id
     * @term (optional) 搜索
     * @devicePattern (optional) 设备型号
     * @deviceModelId (optional) 设备模板 Id
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDevicesForExternal = function (id, term, devicePattern, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDevicesForExternal?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevicesForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevicesForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDevicesForExternal = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationDeviceDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户获取设备
     * @id (optional) 人员Id 或者组织 Id
     * @term (optional) 搜索
     * @devicePattern (optional) 设备型号
     * @deviceModelId (optional) 设备模板 Id
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDevicesForUser = function (id, term, devicePattern, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDevicesForUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevicesForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevicesForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDevicesForUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationDeviceDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织获取设备
     * @id (optional) 用户 Id 或 组织 Id
     * @term (optional) 搜索条件
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDeviceModels = function (id, term, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDeviceModels?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationDeviceModelDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织获取设备模板
     * @id (optional) 用户 Id 或 组织 Id
     * @term (optional) 搜索条件
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDeviceModelsForExternal = function (id, term, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDeviceModelsForExternal?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModelsForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModelsForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDeviceModelsForExternal = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationDeviceModelDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户获取设备模板
     * @id (optional) 用户 Id 或 组织 Id
     * @term (optional) 搜索条件
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDeviceModelsForUser = function (id, term, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDeviceModelsForUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModelsForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModelsForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDeviceModelsForUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationDeviceModelDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织获取待分配设备筛选项
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDeviceQueryOptions = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDeviceQueryOptions?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDeviceQueryOptions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDeviceQueryOptions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDeviceQueryOptions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceQueryOptionDto.fromJS(resultData200) : new OrganizationDeviceQueryOptionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织获取待分配设备筛选项
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDeviceQueryOptionsForExternal = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDeviceQueryOptionsForExternal?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDeviceQueryOptionsForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDeviceQueryOptionsForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDeviceQueryOptionsForExternal = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceQueryOptionDto.fromJS(resultData200) : new OrganizationDeviceQueryOptionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户获取待分配设备筛选项
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDeviceQueryOptionsForUser = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDeviceQueryOptionsForUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDeviceQueryOptionsForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDeviceQueryOptionsForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDeviceQueryOptionsForUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceQueryOptionDto.fromJS(resultData200) : new OrganizationDeviceQueryOptionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织获取待分配设备
     * @id (optional) 人员Id 或者组织 Id
     * @term (optional) 搜索
     * @devicePattern (optional) 设备型号
     * @deviceModelId (optional) 设备模板 Id
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDevices = function (id, term, devicePattern, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDevices?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDevices(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDevices(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDevices = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationAssignDeviceDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationAssignDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织获取待分配设备
     * @id (optional) 人员Id 或者组织 Id
     * @term (optional) 搜索
     * @devicePattern (optional) 设备型号
     * @deviceModelId (optional) 设备模板 Id
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDevicesForExternal = function (id, term, devicePattern, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDevicesForExternal?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDevicesForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDevicesForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDevicesForExternal = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationAssignDeviceDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationAssignDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户获取待分配设备
     * @id (optional) 人员Id 或者组织 Id
     * @term (optional) 搜索
     * @devicePattern (optional) 设备型号
     * @deviceModelId (optional) 设备模板 Id
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDevicesForUser = function (id, term, devicePattern, deviceModelId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDevicesForUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (devicePattern !== undefined)
            url_ += "DevicePattern=" + encodeURIComponent("" + devicePattern) + "&";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDevicesForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDevicesForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDevicesForUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationAssignDeviceDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationAssignDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织获取待分配设备模板
     * @id (optional) 用户 Id 或 组织 Id
     * @term (optional) 搜索条件
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDeviceModels = function (id, term, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDeviceModels?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationAssignDeviceModelDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationAssignDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织获取待分配设备模板
     * @id (optional) 用户 Id 或 组织 Id
     * @term (optional) 搜索条件
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDeviceModelsForExternal = function (id, term, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDeviceModelsForExternal?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDeviceModelsForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDeviceModelsForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDeviceModelsForExternal = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationAssignDeviceModelDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationAssignDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户获取待分配设备模板
     * @id (optional) 用户 Id 或 组织 Id
     * @term (optional) 搜索条件
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getAssignDeviceModelsForUser = function (id, term, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetAssignDeviceModelsForUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignDeviceModelsForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignDeviceModelsForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetAssignDeviceModelsForUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationAssignDeviceModelDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationAssignDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织批量分配设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchAssignDevicePermission = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchAssignDevicePermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchAssignDevicePermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchAssignDevicePermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchAssignDevicePermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织批量分配设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchAssignDevicePermissionForExternal = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchAssignDevicePermissionForExternal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchAssignDevicePermissionForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchAssignDevicePermissionForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchAssignDevicePermissionForExternal = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户批量分配设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchAssignDevicePermissionForUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchAssignDevicePermissionForUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchAssignDevicePermissionForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchAssignDevicePermissionForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchAssignDevicePermissionForUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织批量分配设备模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchAssignDeviceModelPermission = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchAssignDeviceModelPermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchAssignDeviceModelPermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchAssignDeviceModelPermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchAssignDeviceModelPermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织批量分配设备模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchAssignDeviceModelPermissionForExternal = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchAssignDeviceModelPermissionForExternal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchAssignDeviceModelPermissionForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchAssignDeviceModelPermissionForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchAssignDeviceModelPermissionForExternal = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户批量分配设备模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchAssignDeviceModelPermissionForUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchAssignDeviceModelPermissionForUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchAssignDeviceModelPermissionForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchAssignDeviceModelPermissionForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchAssignDeviceModelPermissionForUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取登录用户指定设备权限
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getDeviceDataPermissionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetDeviceDataPermissionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceDataPermissionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceDataPermissionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetDeviceDataPermissionForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceDto.fromJS(resultData200) : new OrganizationDeviceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织编辑权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.editDeviceDataPermission = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/EditDeviceDataPermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEditDeviceDataPermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEditDeviceDataPermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processEditDeviceDataPermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 编辑外部组织指定设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.editDeviceDataPermissionForExternal = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/EditDeviceDataPermissionForExternal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEditDeviceDataPermissionForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEditDeviceDataPermissionForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processEditDeviceDataPermissionForExternal = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 编辑用户指定设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.editDeviceDataPermissionForUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/EditDeviceDataPermissionForUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEditDeviceDataPermissionForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEditDeviceDataPermissionForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processEditDeviceDataPermissionForUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取登录用户指定模板权限
     * @id (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.getModelDataPermissionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/GetModelDataPermissionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetModelDataPermissionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetModelDataPermissionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processGetModelDataPermissionForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationDeviceModelDto.fromJS(resultData200) : new OrganizationDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 内部组织编辑指定模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.editModelDataPermission = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/EditModelDataPermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEditModelDataPermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEditModelDataPermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processEditModelDataPermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 外部组织编辑指定模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.editModelDataPermissionForExternal = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/EditModelDataPermissionForExternal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEditModelDataPermissionForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEditModelDataPermissionForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processEditModelDataPermissionForExternal = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户编辑指定模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.editModelDataPermissionForUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/EditModelDataPermissionForUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEditModelDataPermissionForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEditModelDataPermissionForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processEditModelDataPermissionForUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量移除内部组织设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchRemoveDevicePermission = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchRemoveDevicePermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchRemoveDevicePermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchRemoveDevicePermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchRemoveDevicePermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量移除外部组织设备权限
    将会移除外部组织的外部组织设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchRemoveDevicePermissionForExternal = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchRemoveDevicePermissionForExternal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchRemoveDevicePermissionForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchRemoveDevicePermissionForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchRemoveDevicePermissionForExternal = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量移除用户设备权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchRemoveDevicePermissionForUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchRemoveDevicePermissionForUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchRemoveDevicePermissionForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchRemoveDevicePermissionForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchRemoveDevicePermissionForUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量移除内部组织模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchRemoveModelPermission = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchRemoveModelPermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchRemoveModelPermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchRemoveModelPermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchRemoveModelPermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量移除外部组织模板权限
    将会移除外部组织的外部组织模板权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchRemoveModelPermissionForExternal = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchRemoveModelPermissionForExternal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchRemoveModelPermissionForExternal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchRemoveModelPermissionForExternal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchRemoveModelPermissionForExternal = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 批量移除用户权限
     * @input (optional)
     * @return Success
     */
    OrganizationDataPermissionServiceProxy.prototype.batchRemoveModelPermissionForUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationDataPermission/BatchRemoveModelPermissionForUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchRemoveModelPermissionForUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchRemoveModelPermissionForUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationDataPermissionServiceProxy.prototype.processBatchRemoveModelPermissionForUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    OrganizationDataPermissionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], OrganizationDataPermissionServiceProxy);
    return OrganizationDataPermissionServiceProxy;
}());
export { OrganizationDataPermissionServiceProxy };
var OrganizationUnitServiceProxy = /** @class */ (function () {
    function OrganizationUnitServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取能看见的组织
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getOrganizationUnits = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationUnits(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetOrganizationUnits = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 查找组织下的用户
     * @organizationId (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getOrganizationUnitUsersByOrganizationId = function (organizationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsersByOrganizationId?";
        if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationUnitUsersByOrganizationId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationUnitUsersByOrganizationId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetOrganizationUnitUsersByOrganizationId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfOrganizationUserListDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUserListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 查找能看见的所有用户
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getAllUsers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetAllUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_51 = resultData200; _i < resultData200_51.length; _i++) {
                        var item = resultData200_51[_i];
                        result200.push(UserInfoListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    OrganizationUnitServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], OrganizationUnitServiceProxy);
    return OrganizationUnitServiceProxy;
}());
export { OrganizationUnitServiceProxy };
var PaymentServiceProxy = /** @class */ (function () {
    function PaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @upgradeEditionId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPaymentInfo = function (upgradeEditionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPaymentInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PaymentInfoDto.fromJS(resultData200) : new PaymentInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.createPayment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatePayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatePayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processCreatePayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.executePayment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/ExecutePayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExecutePayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExecutePayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processExecutePayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPaymentHistory = function (sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentHistory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPaymentHistory = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200) : new PagedResultDtoOfSubscriptionPaymentListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    PaymentServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], PaymentServiceProxy);
    return PaymentServiceProxy;
}());
export { PaymentServiceProxy };
var PermissionServiceProxy = /** @class */ (function () {
    function PermissionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    PermissionServiceProxy.prototype.getAllPermissions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PermissionServiceProxy.prototype.processGetAllPermissions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200) : new ListResultDtoOfFlatPermissionWithLevelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    PermissionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], PermissionServiceProxy);
    return PermissionServiceProxy;
}());
export { PermissionServiceProxy };
var ProfileServiceProxy = /** @class */ (function () {
    function ProfileServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getCurrentUserProfileForEdit = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentUserProfileForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetCurrentUserProfileForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CurrentUserProfileEditDto.fromJS(resultData200) : new CurrentUserProfileEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.updateGoogleAuthenticatorKey = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateGoogleAuthenticatorKey(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateGoogleAuthenticatorKey = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200) : new UpdateGoogleAuthenticatorKeyOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.sendVerificationSms = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendVerificationSms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendVerificationSms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processSendVerificationSms = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.verifySmsCode = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processVerifySmsCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processVerifySmsCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processVerifySmsCode = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.sendVerificationEmail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendVerificationEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendVerificationEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processSendVerificationEmail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.verifyEmailCode = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/VerifyEmailCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processVerifyEmailCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processVerifyEmailCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processVerifyEmailCode = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateCurrentUserProfile = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateCurrentUserProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateCurrentUserProfile = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.changePassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangePassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangePassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processChangePassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? JwtAccessToken.fromJS(resultData200) : new JwtAccessToken();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateProfilePicture = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateProfilePicture = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getPasswordComplexitySetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPasswordComplexitySetting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetPasswordComplexitySetting = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetPasswordComplexitySettingOutput.fromJS(resultData200) : new GetPasswordComplexitySettingOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getProfilePicture = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetProfilePicture = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @userId (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.getProfilePictureByUserId = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserId?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePictureByUserId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePictureByUserId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetProfilePictureByUserId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @profilePictureId (optional)
     * @userId (optional)
     * @tenantId (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.getFriendProfilePictureById = function (profilePictureId, userId, tenantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFriendProfilePictureById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFriendProfilePictureById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetFriendProfilePictureById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @profilePictureId (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.getProfilePictureById = function (profilePictureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePictureById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetProfilePictureById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.changeLanguage = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processChangeLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ProfileServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ProfileServiceProxy);
    return ProfileServiceProxy;
}());
export { ProfileServiceProxy };
var RegionServiceProxy = /** @class */ (function () {
    function RegionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取所有地区信息
     * @return Success
     */
    RegionServiceProxy.prototype.getAllRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Region/GetAllRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllRegions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllRegions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RegionServiceProxy.prototype.processGetAllRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_52 = resultData200; _i < resultData200_52.length; _i++) {
                        var item = resultData200_52[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据省名称、市名称、地区名称查询获取Id
     * @provinceName (optional)
     * @cityName (optional)
     * @districtName (optional)
     * @return Success
     */
    RegionServiceProxy.prototype.parseAddressToRegion = function (provinceName, cityName, districtName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Region/ParseAddressToRegion?";
        if (provinceName !== undefined)
            url_ += "provinceName=" + encodeURIComponent("" + provinceName) + "&";
        if (cityName !== undefined)
            url_ += "cityName=" + encodeURIComponent("" + cityName) + "&";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processParseAddressToRegion(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processParseAddressToRegion(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RegionServiceProxy.prototype.processParseAddressToRegion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RegionCode.fromJS(resultData200) : new RegionCode();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据Id数组获取所有地区信息
     * @regionIds (optional)
     * @return Success
     */
    RegionServiceProxy.prototype.getRegions = function (regionIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Region/GetRegions?";
        if (regionIds !== undefined)
            regionIds && regionIds.forEach(function (item) { url_ += "regionIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRegions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRegions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RegionServiceProxy.prototype.processGetRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_53 = resultData200; _i < resultData200_53.length; _i++) {
                        var item = resultData200_53[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取所有省份信息
     * @return Success
     */
    RegionServiceProxy.prototype.getProvinceRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Region/GetProvinceRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProvinceRegions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProvinceRegions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RegionServiceProxy.prototype.processGetProvinceRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_54 = resultData200; _i < resultData200_54.length; _i++) {
                        var item = resultData200_54[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * get cities region from province region id
     * @regionId (optional) province region id
     * @return Success
     */
    RegionServiceProxy.prototype.getCityRegions = function (regionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Region/GetCityRegions?";
        if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCityRegions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCityRegions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RegionServiceProxy.prototype.processGetCityRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_55 = resultData200; _i < resultData200_55.length; _i++) {
                        var item = resultData200_55[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * get cities region
     * @return Success
     */
    RegionServiceProxy.prototype.getDistrictRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Region/GetDistrictRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDistrictRegions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDistrictRegions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RegionServiceProxy.prototype.processGetDistrictRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_56 = resultData200; _i < resultData200_56.length; _i++) {
                        var item = resultData200_56[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * get region merger name from region id
     * @regionId (optional) region id
     * @return Success
     */
    RegionServiceProxy.prototype.getMergerNameFromRegionId = function (regionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Region/GetMergerNameFromRegionId?";
        if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMergerNameFromRegionId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMergerNameFromRegionId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RegionServiceProxy.prototype.processGetMergerNameFromRegionId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RegionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], RegionServiceProxy);
    return RegionServiceProxy;
}());
export { RegionServiceProxy };
var ReleasedConfigureServiceProxy = /** @class */ (function () {
    function ReleasedConfigureServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取发布后的组态
    注意:如果组态未发布,返回类型中ReleasedConfigureErrorType为NoReleased值
     * @virtualDeviceId (optional) 虚拟设备Id
     * @configureId (optional) 组态Id
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getReleasedConfigure = function (virtualDeviceId, configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetReleasedConfigure?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedConfigure(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedConfigure(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetReleasedConfigure = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReleasedConfigureInfoDto.fromJS(resultData200) : new ReleasedConfigureInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @virtualDeviceId (optional)
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getReleasedConfigureByVirtualDeviceId = function (virtualDeviceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetReleasedConfigureByVirtualDeviceId?";
        if (virtualDeviceId !== undefined)
            url_ += "virtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedConfigureByVirtualDeviceId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedConfigureByVirtualDeviceId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetReleasedConfigureByVirtualDeviceId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReleasedConfigureInfoDto.fromJS(resultData200) : new ReleasedConfigureInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @releasedConfigureId (optional)
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getReleasedMainView = function (configureId, releasedConfigureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetReleasedMainView?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (releasedConfigureId !== undefined)
            url_ += "ReleasedConfigureId=" + encodeURIComponent("" + releasedConfigureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedMainView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedMainView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetReleasedMainView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReleasedConfigureDto.fromJS(resultData200) : new ReleasedConfigureDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取组态页面
    如果没有权限或者数据查询错误并不会抛出异常或返回null
    而是会返回实体模型并且具有错误类型
     * @configureId (optional)
     * @releasedConfigureId (optional)
     * @configureViewId (optional) 画面 Id, 可空
     * @configureViewCode (optional) 画面 Code, Id, Code 二选一
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getReleasedViewByConfigureId = function (configureId, releasedConfigureId, configureViewId, configureViewCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetReleasedViewByConfigureId?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (releasedConfigureId !== undefined)
            url_ += "ReleasedConfigureId=" + encodeURIComponent("" + releasedConfigureId) + "&";
        if (configureViewId !== undefined)
            url_ += "ConfigureViewId=" + encodeURIComponent("" + configureViewId) + "&";
        if (configureViewCode !== undefined)
            url_ += "ConfigureViewCode=" + encodeURIComponent("" + configureViewCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedViewByConfigureId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedViewByConfigureId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetReleasedViewByConfigureId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReleasedConfigureDto.fromJS(resultData200) : new ReleasedConfigureDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @releasedConfigureId (optional)
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getReleasedThumbnailView = function (configureId, releasedConfigureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetReleasedThumbnailView?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (releasedConfigureId !== undefined)
            url_ += "ReleasedConfigureId=" + encodeURIComponent("" + releasedConfigureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedThumbnailView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedThumbnailView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetReleasedThumbnailView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReleasedConfigureDto.fromJS(resultData200) : new ReleasedConfigureDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getReleasedConfigureViews = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetReleasedConfigureViews?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedConfigureViews(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedConfigureViews(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetReleasedConfigureViews = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_57 = resultData200; _i < resultData200_57.length; _i++) {
                        var item = resultData200_57[_i];
                        result200.push(ReleasedConfigureViewForDevice.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Dynamic get configureViewName by VirtualDeviceId and ConfigureViewId / ConfigureViewCode
     * @virtualDeviceId (optional)
     * @configureViewId (optional)
     * @configureViewCode (optional)
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getDeviceNameAndConfigureViewName = function (virtualDeviceId, configureViewId, configureViewCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetDeviceNameAndConfigureViewName?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (configureViewId !== undefined)
            url_ += "ConfigureViewId=" + encodeURIComponent("" + configureViewId) + "&";
        if (configureViewCode !== undefined)
            url_ += "ConfigureViewCode=" + encodeURIComponent("" + configureViewCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceNameAndConfigureViewName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceNameAndConfigureViewName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetDeviceNameAndConfigureViewName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DeviceNameAndConfigureViewNameDto.fromJS(resultData200) : new DeviceNameAndConfigureViewNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Dynamic get main configure view name by configureId
     * @configureId (optional)
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getMainViewName = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetMainViewName?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMainViewName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMainViewName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetMainViewName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? MainConfigureViewNameDto.fromJS(resultData200) : new MainConfigureViewNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @releasedConfigureId (optional)
     * @viewIndex (optional)
     * @return Success
     */
    ReleasedConfigureServiceProxy.prototype.getReleasedView = function (configureId, releasedConfigureId, viewIndex) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigure/GetReleasedView?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (releasedConfigureId !== undefined)
            url_ += "ReleasedConfigureId=" + encodeURIComponent("" + releasedConfigureId) + "&";
        if (viewIndex !== undefined)
            url_ += "ViewIndex=" + encodeURIComponent("" + viewIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleasedView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleasedView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureServiceProxy.prototype.processGetReleasedView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReleasedConfigureDto.fromJS(resultData200) : new ReleasedConfigureDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReleasedConfigureServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReleasedConfigureServiceProxy);
    return ReleasedConfigureServiceProxy;
}());
export { ReleasedConfigureServiceProxy };
var ReleasedConfigureGraphServiceProxy = /** @class */ (function () {
    function ReleasedConfigureGraphServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @releasedId (optional)
     * @graphId (optional)
     * @stateIndex (optional)
     * @return Success
     */
    ReleasedConfigureGraphServiceProxy.prototype.getReleaseGraphState = function (releasedId, graphId, stateIndex) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigureGraph/GetReleaseGraphState?";
        if (releasedId !== undefined)
            url_ += "ReleasedId=" + encodeURIComponent("" + releasedId) + "&";
        if (graphId !== undefined)
            url_ += "GraphId=" + encodeURIComponent("" + graphId) + "&";
        if (stateIndex !== undefined)
            url_ += "StateIndex=" + encodeURIComponent("" + stateIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReleaseGraphState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReleaseGraphState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureGraphServiceProxy.prototype.processGetReleaseGraphState = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReleasedConfigureGraphStateDto.fromJS(resultData200) : new ReleasedConfigureGraphStateDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ReleasedConfigureGraphServiceProxy.prototype.pullReleasedGraphStates = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedConfigureGraph/PullReleasedGraphStates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPullReleasedGraphStates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPullReleasedGraphStates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedConfigureGraphServiceProxy.prototype.processPullReleasedGraphStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfGetReleasedGraphStateResultDto.fromJS(resultData200) : new IListResultOfGetReleasedGraphStateResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReleasedConfigureGraphServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReleasedConfigureGraphServiceProxy);
    return ReleasedConfigureGraphServiceProxy;
}());
export { ReleasedConfigureGraphServiceProxy };
var ReleasedDataSourceAppSerivceServiceProxy = /** @class */ (function () {
    function ReleasedDataSourceAppSerivceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    ReleasedDataSourceAppSerivceServiceProxy.prototype.getVirtualDeviceRelatedReleasedDataSources = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedDataSourceAppSerivce/GetVirtualDeviceRelatedReleasedDataSources?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVirtualDeviceRelatedReleasedDataSources(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVirtualDeviceRelatedReleasedDataSources(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedDataSourceAppSerivceServiceProxy.prototype.processGetVirtualDeviceRelatedReleasedDataSources = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfReleasedDataSourceDto.fromJS(resultData200) : new ListResultDtoOfReleasedDataSourceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReleasedDataSourceAppSerivceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReleasedDataSourceAppSerivceServiceProxy);
    return ReleasedDataSourceAppSerivceServiceProxy;
}());
export { ReleasedDataSourceAppSerivceServiceProxy };
var ReleasedVariableServiceProxy = /** @class */ (function () {
    function ReleasedVariableServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 根据虚拟设备ID获取所有变量分组
     * @id (optional)
     * @return Success
     */
    ReleasedVariableServiceProxy.prototype.getAllVariableGroups = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedVariable/GetAllVariableGroups?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllVariableGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllVariableGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedVariableServiceProxy.prototype.processGetAllVariableGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_58 = resultData200; _i < resultData200_58.length; _i++) {
                        var item = resultData200_58[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据虚拟设备ID获取所有数据源的名称
     * @id (optional)
     * @return Success
     */
    ReleasedVariableServiceProxy.prototype.getAllDataSourceNames = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedVariable/GetAllDataSourceNames?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDataSourceNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDataSourceNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedVariableServiceProxy.prototype.processGetAllDataSourceNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_59 = resultData200; _i < resultData200_59.length; _i++) {
                        var item = resultData200_59[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据GetAllVariablesDto获取发布后的变量
     * @virtualDeviceId (optional) 虚拟设备id
     * @enableVariableStorage (optional) 是否启用变量存储
     * @variableDataTypes (optional)
     * @return Success
     */
    ReleasedVariableServiceProxy.prototype.getAllVariables = function (virtualDeviceId, enableVariableStorage, variableDataTypes) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReleasedVariable/GetAllVariables?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (enableVariableStorage !== undefined)
            url_ += "EnableVariableStorage=" + encodeURIComponent("" + enableVariableStorage) + "&";
        if (variableDataTypes !== undefined)
            variableDataTypes && variableDataTypes.forEach(function (item) { url_ += "VariableDataTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReleasedVariableServiceProxy.prototype.processGetAllVariables = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_60 = resultData200; _i < resultData200_60.length; _i++) {
                        var item = resultData200_60[_i];
                        result200.push(ReleasedVariableDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReleasedVariableServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReleasedVariableServiceProxy);
    return ReleasedVariableServiceProxy;
}());
export { ReleasedVariableServiceProxy };
var RepairListServiceProxy = /** @class */ (function () {
    function RepairListServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取当前用户所管理的需求管理
     * @filterString (optional) 过滤字段,目前有故障编号和设备名称
     * @state (optional) 状态
     * @contactName (optional)
     * @contactPhoneNumber (optional) 联系电话
     * @companyName (optional)
     * @startTime (optional)
     * @endTime (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    RepairListServiceProxy.prototype.getRepairList = function (filterString, state, contactName, contactPhoneNumber, companyName, startTime, endTime, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairList/GetRepairList?";
        if (filterString !== undefined)
            url_ += "FilterString=" + encodeURIComponent("" + filterString) + "&";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (contactName !== undefined)
            url_ += "ContactName=" + encodeURIComponent("" + contactName) + "&";
        if (contactPhoneNumber !== undefined)
            url_ += "ContactPhoneNumber=" + encodeURIComponent("" + contactPhoneNumber) + "&";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&";
        if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRepairList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRepairList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairListServiceProxy.prototype.processGetRepairList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRepairDto.fromJS(resultData200) : new PagedResultDtoOfRepairDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导出当前用户所管理的需求管理
     * @input (optional)
     * @return Success
     */
    RepairListServiceProxy.prototype.exportRepairs = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairList/ExportRepairs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportRepairs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportRepairs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairListServiceProxy.prototype.processExportRepairs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RepairListServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], RepairListServiceProxy);
    return RepairListServiceProxy;
}());
export { RepairListServiceProxy };
var RepairManageServiceProxy = /** @class */ (function () {
    function RepairManageServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.getRepairImagesUrl = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/GetRepairImagesUrl?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRepairImagesUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRepairImagesUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processGetRepairImagesUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_61 = resultData200; _i < resultData200_61.length; _i++) {
                        var item = resultData200_61[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.getRepairThumbImagesUrl = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/GetRepairThumbImagesUrl?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRepairThumbImagesUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRepairThumbImagesUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processGetRepairThumbImagesUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_62 = resultData200; _i < resultData200_62.length; _i++) {
                        var item = resultData200_62[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    RepairManageServiceProxy.prototype.getCustomers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/GetCustomers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCustomers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCustomers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processGetCustomers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_63 = resultData200; _i < resultData200_63.length; _i++) {
                        var item = resultData200_63[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.assignWorkOrder = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/AssignWorkOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAssignWorkOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAssignWorkOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processAssignWorkOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.markAsCompleted = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/MarkAsCompleted";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsCompleted(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsCompleted(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processMarkAsCompleted = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取待分配维修人员
     * @filter (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.getAssigners = function (filter, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/GetAssigners?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssigners(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssigners(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processGetAssigners = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.getReportFaultCode = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/GetReportFaultCode?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReportFaultCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReportFaultCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processGetReportFaultCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReportFaultCodeDto.fromJS(resultData200) : new ReportFaultCodeDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.createRepair = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/CreateRepair";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateRepair(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateRepair(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processCreateRepair = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @filter (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.getDeviceListForRepair = function (filter, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/GetDeviceListForRepair?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceListForRepair(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceListForRepair(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processGetDeviceListForRepair = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    RepairManageServiceProxy.prototype.getRepairContact = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/GetRepairContact";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRepairContact(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRepairContact(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processGetRepairContact = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RepairContactDto.fromJS(resultData200) : new RepairContactDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @thumbId (optional)
     * @imageId (optional)
     * @return Success
     */
    RepairManageServiceProxy.prototype.deleteTempImage = function (thumbId, imageId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairManage/DeleteTempImage?";
        if (thumbId !== undefined)
            url_ += "ThumbId=" + encodeURIComponent("" + thumbId) + "&";
        if (imageId !== undefined)
            url_ += "ImageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTempImage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTempImage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairManageServiceProxy.prototype.processDeleteTempImage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RepairManageServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], RepairManageServiceProxy);
    return RepairManageServiceProxy;
}());
export { RepairManageServiceProxy };
var RepairProgressServiceProxy = /** @class */ (function () {
    function RepairProgressServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @repairId (optional)
     * @return Success
     */
    RepairProgressServiceProxy.prototype.getProgresses = function (repairId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RepairProgress/GetProgresses?";
        if (repairId !== undefined)
            url_ += "repairId=" + encodeURIComponent("" + repairId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProgresses(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProgresses(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RepairProgressServiceProxy.prototype.processGetProgresses = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_64 = resultData200; _i < resultData200_64.length; _i++) {
                        var item = resultData200_64[_i];
                        result200.push(RepairProgressDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RepairProgressServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], RepairProgressServiceProxy);
    return RepairProgressServiceProxy;
}());
export { RepairProgressServiceProxy };
var ReportApplyServiceProxy = /** @class */ (function () {
    function ReportApplyServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ReportApplyServiceProxy.prototype.getApplyInfo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportApply/GetApplyInfo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetApplyInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetApplyInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportApplyServiceProxy.prototype.processGetApplyInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ApplyInfoDto.fromJS(resultData200) : new ApplyInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ReportApplyServiceProxy.prototype.updateApplyInfo = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportApply/UpdateApplyInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateApplyInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateApplyInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportApplyServiceProxy.prototype.processUpdateApplyInfo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ReportApplyServiceProxy.prototype.canActivateReportApply = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportApply/CanActivateReportApply";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCanActivateReportApply(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCanActivateReportApply(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportApplyServiceProxy.prototype.processCanActivateReportApply = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReportApplyServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReportApplyServiceProxy);
    return ReportApplyServiceProxy;
}());
export { ReportApplyServiceProxy };
var ReportResultServiceProxy = /** @class */ (function () {
    function ReportResultServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 加载报表
     * @input (optional)
     * @return Success
     */
    ReportResultServiceProxy.prototype.loadReportResult = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportResult/LoadReportResult";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLoadReportResult(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLoadReportResult(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportResultServiceProxy.prototype.processLoadReportResult = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ReportDataResultDto.fromJS(resultData200) : new ReportDataResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 导出报表到Excel
     * @input (optional)
     * @return Success
     */
    ReportResultServiceProxy.prototype.exportExcel = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportResult/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportResultServiceProxy.prototype.processExportExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReportResultServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReportResultServiceProxy);
    return ReportResultServiceProxy;
}());
export { ReportResultServiceProxy };
var ReportsServiceProxy = /** @class */ (function () {
    function ReportsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @filterInput (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportsServiceProxy.prototype.getReports = function (filterInput, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Reports/GetReports?";
        if (filterInput !== undefined)
            url_ += "FilterInput=" + encodeURIComponent("" + filterInput) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReports(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReports(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsServiceProxy.prototype.processGetReports = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameReportResultDto.fromJS(resultData200) : new PagedResultDtoOfNameReportResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @filterText (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportsServiceProxy.prototype.getReportsByFilters = function (filterText, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Reports/GetReportsByFilters?";
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReportsByFilters(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReportsByFilters(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsServiceProxy.prototype.processGetReportsByFilters = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfReportsListDto.fromJS(resultData200) : new PagedResultDtoOfReportsListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @reportId (optional)
     * @return Success
     */
    ReportsServiceProxy.prototype.getReportById = function (reportId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Reports/GetReportById?";
        if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReportById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReportById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsServiceProxy.prototype.processGetReportById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? StatisticReportDto.fromJS(resultData200) : new StatisticReportDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @reportId (optional)
     * @return Success
     */
    ReportsServiceProxy.prototype.getReportConfigById = function (reportId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Reports/GetReportConfigById?";
        if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReportConfigById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReportConfigById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsServiceProxy.prototype.processGetReportConfigById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetReportConfigByIdResultDto.fromJS(resultData200) : new GetReportConfigByIdResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @reportId (optional)
     * @return Success
     */
    ReportsServiceProxy.prototype.deleteReports = function (reportId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Reports/DeleteReports?";
        if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteReports(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteReports(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsServiceProxy.prototype.processDeleteReports = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ReportsServiceProxy.prototype.saveReport = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Reports/SaveReport";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveReport(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveReport(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsServiceProxy.prototype.processSaveReport = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReportsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReportsServiceProxy);
    return ReportsServiceProxy;
}());
export { ReportsServiceProxy };
var ReportSearchCriteriaServiceProxy = /** @class */ (function () {
    function ReportSearchCriteriaServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getDeviceModels = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetDeviceModels?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getDevices = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetDevices?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevices(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevices(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetDevices = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getDataSources = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetDataSources?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataSources(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataSources(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetDataSources = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getHistoryData = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetHistoryData?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetHistoryData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getHistoryDataChannel = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetHistoryDataChannel?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryDataChannel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryDataChannel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetHistoryDataChannel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getAlarmDef = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetAlarmDef?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAlarmDef(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAlarmDef(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetAlarmDef = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getDeviceGroup = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetDeviceGroup?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetDeviceGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getDevicePatterns = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetDevicePatterns?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDevicePatterns(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDevicePatterns(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetDevicePatterns = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ReportSearchCriteriaServiceProxy.prototype.getAlarmFaultCodes = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportSearchCriteria/GetAlarmFaultCodes?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAlarmFaultCodes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAlarmFaultCodes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportSearchCriteriaServiceProxy.prototype.processGetAlarmFaultCodes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReportSearchCriteriaServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReportSearchCriteriaServiceProxy);
    return ReportSearchCriteriaServiceProxy;
}());
export { ReportSearchCriteriaServiceProxy };
var ReportsPreviewTableServiceProxy = /** @class */ (function () {
    function ReportsPreviewTableServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @tenantId (optional)
     * @table (optional)
     * @return Success
     */
    ReportsPreviewTableServiceProxy.prototype.getPreviewTableOfHistoryDataAsync = function (tenantId, table) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportsPreviewTable/GetPreviewTableOfHistoryDataAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (table !== undefined)
            url_ += "Table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPreviewTableOfHistoryDataAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPreviewTableOfHistoryDataAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsPreviewTableServiceProxy.prototype.processGetPreviewTableOfHistoryDataAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfHistoryDataTableDto.fromJS(resultData200) : new ListResultDtoOfHistoryDataTableDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tenantId (optional)
     * @table (optional)
     * @return Success
     */
    ReportsPreviewTableServiceProxy.prototype.getPreviewTableOfAlarmAsync = function (tenantId, table) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportsPreviewTable/GetPreviewTableOfAlarmAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (table !== undefined)
            url_ += "Table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPreviewTableOfAlarmAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPreviewTableOfAlarmAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsPreviewTableServiceProxy.prototype.processGetPreviewTableOfAlarmAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfAlarmTableDto.fromJS(resultData200) : new ListResultDtoOfAlarmTableDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tenantId (optional)
     * @table (optional)
     * @return Success
     */
    ReportsPreviewTableServiceProxy.prototype.getPreviewTableOfDeviceAsync = function (tenantId, table) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportsPreviewTable/GetPreviewTableOfDeviceAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (table !== undefined)
            url_ += "Table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPreviewTableOfDeviceAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPreviewTableOfDeviceAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsPreviewTableServiceProxy.prototype.processGetPreviewTableOfDeviceAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceTableDto.fromJS(resultData200) : new ListResultDtoOfDeviceTableDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tenantId (optional)
     * @table (optional)
     * @return Success
     */
    ReportsPreviewTableServiceProxy.prototype.getPreviewTableOfUserAsync = function (tenantId, table) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportsPreviewTable/GetPreviewTableOfUserAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (table !== undefined)
            url_ += "Table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPreviewTableOfUserAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPreviewTableOfUserAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsPreviewTableServiceProxy.prototype.processGetPreviewTableOfUserAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfUserTableDto.fromJS(resultData200) : new ListResultDtoOfUserTableDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @tenantId (optional)
     * @table (optional)
     * @return Success
     */
    ReportsPreviewTableServiceProxy.prototype.getPreviewTableOfFBoxStateAsync = function (tenantId, table) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportsPreviewTable/GetPreviewTableOfFBoxStateAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (table !== undefined)
            url_ += "Table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPreviewTableOfFBoxStateAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPreviewTableOfFBoxStateAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsPreviewTableServiceProxy.prototype.processGetPreviewTableOfFBoxStateAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfFBoxStateTableDto.fromJS(resultData200) : new ListResultDtoOfFBoxStateTableDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @reportQueryTarget (optional)
     * @return Success
     */
    ReportsPreviewTableServiceProxy.prototype.getTableHeaderTitleAsync = function (reportQueryTarget) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportsPreviewTable/GetTableHeaderTitleAsync?";
        if (reportQueryTarget !== undefined)
            url_ += "ReportQueryTarget=" + encodeURIComponent("" + reportQueryTarget) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTableHeaderTitleAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTableHeaderTitleAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportsPreviewTableServiceProxy.prototype.processGetTableHeaderTitleAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_65 = resultData200; _i < resultData200_65.length; _i++) {
                        var item = resultData200_65[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReportsPreviewTableServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReportsPreviewTableServiceProxy);
    return ReportsPreviewTableServiceProxy;
}());
export { ReportsPreviewTableServiceProxy };
var ReportTableSchemaServiceProxy = /** @class */ (function () {
    function ReportTableSchemaServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取表定义
     * @return Success
     */
    ReportTableSchemaServiceProxy.prototype.getTableDefinitions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportTableSchema/GetTableDefinitions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTableDefinitions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTableDefinitions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportTableSchemaServiceProxy.prototype.processGetTableDefinitions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_66 = resultData200; _i < resultData200_66.length; _i++) {
                        var item = resultData200_66[_i];
                        result200.push(TableDefinition.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取表字段筛选项定义
     * @return Success
     */
    ReportTableSchemaServiceProxy.prototype.getTableFieldFilterDefinitions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReportTableSchema/GetTableFieldFilterDefinitions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTableFieldFilterDefinitions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTableFieldFilterDefinitions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReportTableSchemaServiceProxy.prototype.processGetTableFieldFilterDefinitions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_67 = resultData200; _i < resultData200_67.length; _i++) {
                        var item = resultData200_67[_i];
                        result200.push(TableFieldFilterDefinitionDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReportTableSchemaServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ReportTableSchemaServiceProxy);
    return ReportTableSchemaServiceProxy;
}());
export { ReportTableSchemaServiceProxy };
var ResetPasswordServiceProxy = /** @class */ (function () {
    function ResetPasswordServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 检查邮箱或电话号码是否存在于当前租户
     * @input (optional)
     * @return Success
     */
    ResetPasswordServiceProxy.prototype.checkEmailPhone = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ResetPassword/CheckEmailPhone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckEmailPhone(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckEmailPhone(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ResetPasswordServiceProxy.prototype.processCheckEmailPhone = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CheckEmailPhoneResultDto.fromJS(resultData200) : new CheckEmailPhoneResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 发送重置密码验证码
     * @input (optional)
     * @return Success
     */
    ResetPasswordServiceProxy.prototype.sendResetCaptcha = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ResetPassword/SendResetCaptcha";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendResetCaptcha(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendResetCaptcha(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ResetPasswordServiceProxy.prototype.processSendResetCaptcha = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 验证验证码是否有效, 如果有效生成一个新的 Token 有效期 30min
     * @input (optional)
     * @return Success
     */
    ResetPasswordServiceProxy.prototype.validateCaptcha = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ResetPassword/ValidateCaptcha";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateCaptcha(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateCaptcha(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ResetPasswordServiceProxy.prototype.processValidateCaptcha = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CheckResetPwdCaptchaResultDto.fromJS(resultData200) : new CheckResetPwdCaptchaResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 重置密码
     * @input (optional)
     * @return Success
     */
    ResetPasswordServiceProxy.prototype.resetPassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ResetPassword/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ResetPasswordServiceProxy.prototype.processResetPassword = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 重置密码 By reset code
     * @input (optional)
     * @return Success
     */
    ResetPasswordServiceProxy.prototype.resetPasswordByResetCode = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ResetPassword/ResetPasswordByResetCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetPasswordByResetCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetPasswordByResetCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ResetPasswordServiceProxy.prototype.processResetPasswordByResetCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ResetPasswordByResetCodeResultDto.fromJS(resultData200) : new ResetPasswordByResetCodeResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取短信功能是否启用
     * @return Success
     */
    ResetPasswordServiceProxy.prototype.isSmsEnabled = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ResetPassword/IsSmsEnabled";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsSmsEnabled(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsSmsEnabled(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ResetPasswordServiceProxy.prototype.processIsSmsEnabled = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ResetPasswordServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ResetPasswordServiceProxy);
    return ResetPasswordServiceProxy;
}());
export { ResetPasswordServiceProxy };
var RoleServiceProxy = /** @class */ (function () {
    function RoleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @permission (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.getRoles = function (permission) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processGetRoles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.getRoleForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoleForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processGetRoleForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.updateRolePermission = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/UpdateRolePermission";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateRolePermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateRolePermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processUpdateRolePermission = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.createOrUpdateRole = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateRole(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processCreateOrUpdateRole = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.deleteRole = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteRole(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteRole(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processDeleteRole = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    RoleServiceProxy.prototype.getRolesForReportDashBoard = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetRolesForReportDashBoard";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRolesForReportDashBoard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRolesForReportDashBoard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processGetRolesForReportDashBoard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RoleServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], RoleServiceProxy);
    return RoleServiceProxy;
}());
export { RoleServiceProxy };
var SerialNumberServiceProxy = /** @class */ (function () {
    function SerialNumberServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @nameOrCode (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    SerialNumberServiceProxy.prototype.getSerialNumbers = function (nameOrCode, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SerialNumber/GetSerialNumbers?";
        if (nameOrCode !== undefined)
            url_ += "NameOrCode=" + encodeURIComponent("" + nameOrCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSerialNumbers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSerialNumbers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SerialNumberServiceProxy.prototype.processGetSerialNumbers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSerialNumberListDto.fromJS(resultData200) : new PagedResultDtoOfSerialNumberListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    SerialNumberServiceProxy.prototype.getSerialNumberForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SerialNumber/GetSerialNumberForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSerialNumberForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSerialNumberForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SerialNumberServiceProxy.prototype.processGetSerialNumberForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SerialNumberForEditDto.fromJS(resultData200) : new SerialNumberForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    SerialNumberServiceProxy.prototype.generateSerialNumber = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SerialNumber/GenerateSerialNumber";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGenerateSerialNumber(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGenerateSerialNumber(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SerialNumberServiceProxy.prototype.processGenerateSerialNumber = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    SerialNumberServiceProxy.prototype.batchGenerateSerialNumber = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SerialNumber/BatchGenerateSerialNumber";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchGenerateSerialNumber(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchGenerateSerialNumber(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SerialNumberServiceProxy.prototype.processBatchGenerateSerialNumber = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_68 = resultData200; _i < resultData200_68.length; _i++) {
                        var item = resultData200_68[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    SerialNumberServiceProxy.prototype.createOrUpdateSerialNumber = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SerialNumber/CreateOrUpdateSerialNumber";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateSerialNumber(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateSerialNumber(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SerialNumberServiceProxy.prototype.processCreateOrUpdateSerialNumber = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    SerialNumberServiceProxy.prototype.deleteSerialNumber = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SerialNumber/DeleteSerialNumber?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteSerialNumber(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteSerialNumber(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SerialNumberServiceProxy.prototype.processDeleteSerialNumber = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    SerialNumberServiceProxy.prototype.preview = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SerialNumber/Preview";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPreview(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPreview(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SerialNumberServiceProxy.prototype.processPreview = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    SerialNumberServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], SerialNumberServiceProxy);
    return SerialNumberServiceProxy;
}());
export { SerialNumberServiceProxy };
var SessionServiceProxy = /** @class */ (function () {
    function SessionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.getCurrentLoginInformations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentLoginInformations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SessionServiceProxy.prototype.processGetCurrentLoginInformations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.updateUserSignInToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserSignInToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SessionServiceProxy.prototype.processUpdateUserSignInToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    SessionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], SessionServiceProxy);
    return SessionServiceProxy;
}());
export { SessionServiceProxy };
var SubscriptionServiceProxy = /** @class */ (function () {
    function SubscriptionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @upgradeEditionId (optional)
     * @return Success
     */
    SubscriptionServiceProxy.prototype.upgradeTenantToEquivalentEdition = function (upgradeEditionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpgradeTenantToEquivalentEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpgradeTenantToEquivalentEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SubscriptionServiceProxy.prototype.processUpgradeTenantToEquivalentEdition = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    SubscriptionServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], SubscriptionServiceProxy);
    return SubscriptionServiceProxy;
}());
export { SubscriptionServiceProxy };
var SystemGalleryServiceProxy = /** @class */ (function () {
    function SystemGalleryServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    SystemGalleryServiceProxy.prototype.getCategories = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SystemGallery/GetCategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCategories(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCategories(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SystemGalleryServiceProxy.prototype.processGetCategories = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_69 = resultData200; _i < resultData200_69.length; _i++) {
                        var item = resultData200_69[_i];
                        result200.push(SystemCategoryDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    SystemGalleryServiceProxy.prototype.getGraphs = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SystemGallery/GetGraphs?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SystemGalleryServiceProxy.prototype.processGetGraphs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_70 = resultData200; _i < resultData200_70.length; _i++) {
                        var item = resultData200_70[_i];
                        result200.push(SystemGraphDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @categoryId (optional)
     * @graphId (optional)
     * @return Success
     */
    SystemGalleryServiceProxy.prototype.getGraphStates = function (categoryId, graphId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SystemGallery/GetGraphStates?";
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (graphId !== undefined)
            url_ += "GraphId=" + encodeURIComponent("" + graphId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphStates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphStates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SystemGalleryServiceProxy.prototype.processGetGraphStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_71 = resultData200; _i < resultData200_71.length; _i++) {
                        var item = resultData200_71[_i];
                        result200.push(SystemGraphStateDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    SystemGalleryServiceProxy.prototype.importIntoConfigureGallery = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SystemGallery/ImportIntoConfigureGallery";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportIntoConfigureGallery(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportIntoConfigureGallery(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SystemGalleryServiceProxy.prototype.processImportIntoConfigureGallery = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    SystemGalleryServiceProxy.prototype.coverConfigureGalleryFromSystem = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SystemGallery/CoverConfigureGalleryFromSystem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCoverConfigureGalleryFromSystem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCoverConfigureGalleryFromSystem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SystemGalleryServiceProxy.prototype.processCoverConfigureGalleryFromSystem = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    SystemGalleryServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], SystemGalleryServiceProxy);
    return SystemGalleryServiceProxy;
}());
export { SystemGalleryServiceProxy };
var TableDataFavoriteServiceProxy = /** @class */ (function () {
    function TableDataFavoriteServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 收藏表格数据
     * @input (optional)
     * @return Success
     */
    TableDataFavoriteServiceProxy.prototype.createTableDataFavorite = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TableDataFavorite/CreateTableDataFavorite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTableDataFavorite(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTableDataFavorite(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TableDataFavoriteServiceProxy.prototype.processCreateTableDataFavorite = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 取消收藏表格数据
     * @objectId (optional) 对象主键ID
     * @objectType (optional) 对象类型（例：Nameof(Device)）
     * @return Success
     */
    TableDataFavoriteServiceProxy.prototype.deleteTableDataFavorite = function (objectId, objectType) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TableDataFavorite/DeleteTableDataFavorite?";
        if (objectId !== undefined)
            url_ += "ObjectId=" + encodeURIComponent("" + objectId) + "&";
        if (objectType !== undefined)
            url_ += "ObjectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTableDataFavorite(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTableDataFavorite(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TableDataFavoriteServiceProxy.prototype.processDeleteTableDataFavorite = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取收藏的表格数据
     * @objectType (optional) 对象类型（例：Nameof(Device)）
     * @return Success
     */
    TableDataFavoriteServiceProxy.prototype.getTableDataFavorites = function (objectType) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TableDataFavorite/GetTableDataFavorites?";
        if (objectType !== undefined)
            url_ += "ObjectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTableDataFavorites(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTableDataFavorites(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TableDataFavoriteServiceProxy.prototype.processGetTableDataFavorites = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_72 = resultData200; _i < resultData200_72.length; _i++) {
                        var item = resultData200_72[_i];
                        result200.push(TableDataFavorite.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TableDataFavoriteServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TableDataFavoriteServiceProxy);
    return TableDataFavoriteServiceProxy;
}());
export { TableDataFavoriteServiceProxy };
var TableUserFilterServiceProxy = /** @class */ (function () {
    function TableUserFilterServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 添加列表筛选条件
     * @input (optional)
     * @return Success
     */
    TableUserFilterServiceProxy.prototype.addTableUserFilter = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TableUserFilter/AddTableUserFilter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddTableUserFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddTableUserFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TableUserFilterServiceProxy.prototype.processAddTableUserFilter = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 移除筛选项
     * @pageName 页面名称
     * @filterName 筛选名称
     * @return Success
     */
    TableUserFilterServiceProxy.prototype.removeTableUserFilter = function (pageName, filterName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TableUserFilter/RemoveTableUserFilter?";
        if (pageName === undefined || pageName === null)
            throw new Error("The parameter 'pageName' must be defined and cannot be null.");
        else
            url_ += "PageName=" + encodeURIComponent("" + pageName) + "&";
        if (filterName === undefined || filterName === null)
            throw new Error("The parameter 'filterName' must be defined and cannot be null.");
        else
            url_ += "FilterName=" + encodeURIComponent("" + filterName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveTableUserFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveTableUserFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TableUserFilterServiceProxy.prototype.processRemoveTableUserFilter = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 查询条件查询根据页面名称
     * @input (optional)
     * @return Success
     */
    TableUserFilterServiceProxy.prototype.queryTableUserFilterList = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TableUserFilter/QueryTableUserFilterList";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processQueryTableUserFilterList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processQueryTableUserFilterList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TableUserFilterServiceProxy.prototype.processQueryTableUserFilterList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_73 = resultData200; _i < resultData200_73.length; _i++) {
                        var item = resultData200_73[_i];
                        result200.push(TableUserFilterDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TableUserFilterServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TableUserFilterServiceProxy);
    return TableUserFilterServiceProxy;
}());
export { TableUserFilterServiceProxy };
var TenantServiceProxy = /** @class */ (function () {
    function TenantServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 获取租户信息
     * @filter (optional)
     * @subscriptionEndDateStart (optional)
     * @subscriptionEndDateEnd (optional)
     * @creationDateStart (optional)
     * @creationDateEnd (optional)
     * @editionId (optional)
     * @editionIdSpecified (optional)
     * @customerLinkman (optional)
     * @customerPhone (optional)
     * @excludeTenantIds (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenants = function (filter, subscriptionEndDateStart, subscriptionEndDateEnd, creationDateStart, creationDateEnd, editionId, editionIdSpecified, customerLinkman, customerPhone, excludeTenantIds, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&";
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&";
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (customerLinkman !== undefined)
            url_ += "CustomerLinkman=" + encodeURIComponent("" + customerLinkman) + "&";
        if (customerPhone !== undefined)
            url_ += "CustomerPhone=" + encodeURIComponent("" + customerPhone) + "&";
        if (excludeTenantIds !== undefined)
            excludeTenantIds && excludeTenantIds.forEach(function (item) { url_ += "ExcludeTenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenants(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenants(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenants = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 创建租户
     * @input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.createTenant = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processCreateTenant = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取租户信息用于编辑
     * @id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenantForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenantForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantEditDto.fromJS(resultData200) : new TenantEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 更新租户信息
     * @input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.updateTenant = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUpdateTenant = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 重新激活
     * @input (optional) 租户ID
     * @return Success
     */
    TenantServiceProxy.prototype.reactivation = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/Reactivation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processReactivation(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processReactivation(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processReactivation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 删除租户
     * @id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.deleteTenant = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processDeleteTenant = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 根据条件获取租户功能
     * @id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenantFeaturesForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantFeaturesForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenantFeaturesForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetTenantFeaturesEditOutput.fromJS(resultData200) : new GetTenantFeaturesEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 调整租户功能
     * @input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.updateTenantFeatures = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTenantFeatures(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUpdateTenantFeatures = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 重置租户版本功能
     * @input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.resetTenantSpecificFeatures = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetTenantSpecificFeatures(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processResetTenantSpecificFeatures = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 解锁租户管理员
     * @input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.unlockTenantAdmin = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlockTenantAdmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUnlockTenantAdmin = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 校验租户名称或Host名称是否有效
     * @input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.isTenantOrHostNameValid = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/IsTenantOrHostNameValid";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsTenantOrHostNameValid(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsTenantOrHostNameValid(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processIsTenantOrHostNameValid = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取有效的Host名称
     * @return Success
     */
    TenantServiceProxy.prototype.getValidHostNames = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetValidHostNames";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetValidHostNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetValidHostNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetValidHostNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfString.fromJS(resultData200) : new IListResultOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TenantServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TenantServiceProxy);
    return TenantServiceProxy;
}());
export { TenantServiceProxy };
var TenantDashboardServiceProxy = /** @class */ (function () {
    function TenantDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getMemberActivity = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMemberActivity(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMemberActivity(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetMemberActivity = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetMemberActivityOutput.fromJS(resultData200) : new GetMemberActivityOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @salesSummaryDatePeriod (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getDashboardData = function (salesSummaryDatePeriod) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetDashboardDataOutput.fromJS(resultData200) : new GetDashboardDataOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @salesSummaryDatePeriod (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getSalesSummary = function (salesSummaryDatePeriod) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSalesSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSalesSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetSalesSummary = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetSalesSummaryOutput.fromJS(resultData200) : new GetSalesSummaryOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getRegionalStats = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRegionalStats(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRegionalStats(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetRegionalStats = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetRegionalStatsOutput.fromJS(resultData200) : new GetRegionalStatsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getGeneralStats = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGeneralStats(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGeneralStats(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetGeneralStats = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetGeneralStatsOutput.fromJS(resultData200) : new GetGeneralStatsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TenantDashboardServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TenantDashboardServiceProxy);
    return TenantDashboardServiceProxy;
}());
export { TenantDashboardServiceProxy };
var TenantRegisterServiceProxy = /** @class */ (function () {
    function TenantRegisterServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 创建或更新租户注册信息
     * @input (optional)
     * @return Success
     */
    TenantRegisterServiceProxy.prototype.createOrUpdateTenantRegist = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegister/CreateOrUpdateTenantRegist";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateTenantRegist(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateTenantRegist(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegisterServiceProxy.prototype.processCreateOrUpdateTenantRegist = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OperationResultDto.fromJS(resultData200) : new OperationResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 审批分页
     * @startDate (optional) 开始时间
     * @endDate (optional) 结束时间
     * @approvalStatus (optional) 审核状态（枚举项：未审核、驳回、已通过）
     * @keyword (optional) 搜索关键字
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    TenantRegisterServiceProxy.prototype.getTenantRegistrationList = function (startDate, endDate, approvalStatus, keyword, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegister/GetTenantRegistrationList?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (approvalStatus !== undefined)
            url_ += "ApprovalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantRegistrationList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantRegistrationList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegisterServiceProxy.prototype.processGetTenantRegistrationList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfTenantRegistration.fromJS(resultData200) : new PagedResultDtoOfTenantRegistration();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 审批通过
     * @input (optional)
     * @return Success
     */
    TenantRegisterServiceProxy.prototype.approved = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegister/Approved";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processApproved(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processApproved(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegisterServiceProxy.prototype.processApproved = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 审批驳回
     * @input (optional)
     * @return Success
     */
    TenantRegisterServiceProxy.prototype.reject = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegister/Reject";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processReject(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processReject(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegisterServiceProxy.prototype.processReject = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 发送验证码
     * @input (optional)
     * @return Success
     */
    TenantRegisterServiceProxy.prototype.sendVerificationCodeAsync = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegister/SendVerificationCodeAsync";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendVerificationCodeAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendVerificationCodeAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegisterServiceProxy.prototype.processSendVerificationCodeAsync = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 校验租户名称是否重复
     * @input (optional)
     * @return Success
     */
    TenantRegisterServiceProxy.prototype.checkDuplicateTenantNameAsync = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegister/CheckDuplicateTenantNameAsync";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckDuplicateTenantNameAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckDuplicateTenantNameAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegisterServiceProxy.prototype.processCheckDuplicateTenantNameAsync = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 校验手机或邮箱验证码信息
     * @model (optional)
     * @return Success
     */
    TenantRegisterServiceProxy.prototype.checkVerificationCodeAsync = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegister/CheckVerificationCodeAsync";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckVerificationCodeAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckVerificationCodeAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegisterServiceProxy.prototype.processCheckVerificationCodeAsync = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TenantRegisterServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TenantRegisterServiceProxy);
    return TenantRegisterServiceProxy;
}());
export { TenantRegisterServiceProxy };
var TenantRegistrationServiceProxy = /** @class */ (function () {
    function TenantRegistrationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.registerTenant = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processRegisterTenant = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RegisterTenantOutput.fromJS(resultData200) : new RegisterTenantOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.getEditionsForSelect = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionsForSelect(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processGetEditionsForSelect = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EditionsSelectOutput.fromJS(resultData200) : new EditionsSelectOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @editionId (optional)
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.getEdition = function (editionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processGetEdition = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EditionSelectDto.fromJS(resultData200) : new EditionSelectDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TenantRegistrationServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TenantRegistrationServiceProxy);
    return TenantRegistrationServiceProxy;
}());
export { TenantRegistrationServiceProxy };
var TenantSettingsServiceProxy = /** @class */ (function () {
    function TenantSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.getAllSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processGetAllSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantSettingsEditDto.fromJS(resultData200) : new TenantSettingsEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 当前是否显示演示演示系统
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.isDisplayDemonstrationSystem = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/IsDisplayDemonstrationSystem";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsDisplayDemonstrationSystem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsDisplayDemonstrationSystem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processIsDisplayDemonstrationSystem = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.updateAllSettings = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processUpdateAllSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearLogo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearLogo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearLogo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearLogo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearAppLogo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearAppLogo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearAppLogo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearAppLogo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearAppLogo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearLoginPageBackgroundImage = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLoginPageBackgroundImage";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearLoginPageBackgroundImage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearLoginPageBackgroundImage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearLoginPageBackgroundImage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearCustomCss = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearCustomCss(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearCustomCss(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearCustomCss = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.sendTestEmail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTestEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTestEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processSendTestEmail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TenantSettingsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TenantSettingsServiceProxy);
    return TenantSettingsServiceProxy;
}());
export { TenantSettingsServiceProxy };
var ThumbnailServiceProxy = /** @class */ (function () {
    function ThumbnailServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    ThumbnailServiceProxy.prototype.createThumbnail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Thumbnail/CreateThumbnail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateThumbnail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateThumbnail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailServiceProxy.prototype.processCreateThumbnail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @thumbnailGroupId (optional) 缩略图Id
     * @return Success
     */
    ThumbnailServiceProxy.prototype.getThumbnails = function (thumbnailGroupId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Thumbnail/GetThumbnails?";
        if (thumbnailGroupId !== undefined)
            url_ += "ThumbnailGroupId=" + encodeURIComponent("" + thumbnailGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetThumbnails(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetThumbnails(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailServiceProxy.prototype.processGetThumbnails = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfDeviceThumbnailDto.fromJS(resultData200) : new ListResultDtoOfDeviceThumbnailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ThumbnailServiceProxy.prototype.deleteThumbnail = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Thumbnail/DeleteThumbnail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteThumbnail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteThumbnail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailServiceProxy.prototype.processDeleteThumbnail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ThumbnailServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ThumbnailServiceProxy);
    return ThumbnailServiceProxy;
}());
export { ThumbnailServiceProxy };
var ThumbnailAssginDeviceServiceProxy = /** @class */ (function () {
    function ThumbnailAssginDeviceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @deviceModelId (optional)
     * @name (optional)
     * @serialNumber (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    ThumbnailAssginDeviceServiceProxy.prototype.getThumbnailUnAssginDevice = function (deviceModelId, name, serialNumber, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ThumbnailAssginDevice/GetThumbnailUnAssginDevice?";
        if (deviceModelId !== undefined)
            url_ += "DeviceModelId=" + encodeURIComponent("" + deviceModelId) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetThumbnailUnAssginDevice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetThumbnailUnAssginDevice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailAssginDeviceServiceProxy.prototype.processGetThumbnailUnAssginDevice = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfThumbnailUnAssignedDeviceModelDto.fromJS(resultData200) : new PagedResultDtoOfThumbnailUnAssignedDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ThumbnailAssginDeviceServiceProxy.prototype.getUnAssignedDeviceModels = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ThumbnailAssginDevice/GetUnAssignedDeviceModels";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUnAssignedDeviceModels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUnAssignedDeviceModels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailAssginDeviceServiceProxy.prototype.processGetUnAssignedDeviceModels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfUnAssignedDeviceModelDto.fromJS(resultData200) : new ListResultDtoOfUnAssignedDeviceModelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ThumbnailAssginDeviceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ThumbnailAssginDeviceServiceProxy);
    return ThumbnailAssginDeviceServiceProxy;
}());
export { ThumbnailAssginDeviceServiceProxy };
var ThumbnailGroupServiceProxy = /** @class */ (function () {
    function ThumbnailGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    ThumbnailGroupServiceProxy.prototype.createOrUpdateThumbnailGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ThumbnailGroup/CreateOrUpdateThumbnailGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateThumbnailGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateThumbnailGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailGroupServiceProxy.prototype.processCreateOrUpdateThumbnailGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ThumbnailGroupServiceProxy.prototype.deleteThumbnailGroup = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ThumbnailGroup/DeleteThumbnailGroup?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteThumbnailGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteThumbnailGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailGroupServiceProxy.prototype.processDeleteThumbnailGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ThumbnailGroupServiceProxy.prototype.getThumbnailGroups = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ThumbnailGroup/GetThumbnailGroups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetThumbnailGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetThumbnailGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailGroupServiceProxy.prototype.processGetThumbnailGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfThumbnailGroupListDto.fromJS(resultData200) : new ListResultDtoOfThumbnailGroupListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ThumbnailGroupServiceProxy.prototype.getThumbnailForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ThumbnailGroup/GetThumbnailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetThumbnailForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetThumbnailForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ThumbnailGroupServiceProxy.prototype.processGetThumbnailForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ThumbnailGroupEditDto.fromJS(resultData200) : new ThumbnailGroupEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ThumbnailGroupServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], ThumbnailGroupServiceProxy);
    return ThumbnailGroupServiceProxy;
}());
export { ThumbnailGroupServiceProxy };
var TimingServiceProxy = /** @class */ (function () {
    function TimingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @defaultTimezoneScope (optional)
     * @return Success
     */
    TimingServiceProxy.prototype.getTimezones = function (defaultTimezoneScope) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTimezones(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTimezones(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TimingServiceProxy.prototype.processGetTimezones = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfNameValueDto.fromJS(resultData200) : new ListResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @selectedTimezoneId (optional)
     * @return Success
     */
    TimingServiceProxy.prototype.getTimezoneComboboxItems = function (selectedTimezoneId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTimezoneComboboxItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TimingServiceProxy.prototype.processGetTimezoneComboboxItems = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_74 = resultData200; _i < resultData200_74.length; _i++) {
                        var item = resultData200_74[_i];
                        result200.push(ComboboxItemDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TimingServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TimingServiceProxy);
    return TimingServiceProxy;
}());
export { TimingServiceProxy };
var TokenAuthServiceProxy = /** @class */ (function () {
    function TokenAuthServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TokenAuthServiceProxy.prototype.lightHouseDemoAutoAuthenticate = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/LightHouseDemoAutoAuthenticate";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLightHouseDemoAutoAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLightHouseDemoAutoAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processLightHouseDemoAutoAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DemonstrationSystemApiGetAccessCodeResult.fromJS(resultData200) : new DemonstrationSystemApiGetAccessCodeResult();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @model (optional)
     * @isMobile (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.authenticate = function (model, isMobile) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/Authenticate?";
        if (isMobile !== undefined)
            url_ += "isMobile=" + encodeURIComponent("" + isMobile) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.apiGetAccessCode = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ApiGetAccessCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processApiGetAccessCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processApiGetAccessCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processApiGetAccessCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ApiGetAccessCodeResult.fromJS(resultData200) : new ApiGetAccessCodeResult();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @accessCode (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.apiAuthenticate = function (accessCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ApiAuthenticate?";
        if (accessCode !== undefined)
            url_ += "accessCode=" + encodeURIComponent("" + accessCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processApiAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processApiAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processApiAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ApiAuthenticateResult.fromJS(resultData200) : new ApiAuthenticateResult();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @accessCode (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.reNewAccessCode = function (accessCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ReNewAccessCode?";
        if (accessCode !== undefined)
            url_ += "accessCode=" + encodeURIComponent("" + accessCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processReNewAccessCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processReNewAccessCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processReNewAccessCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.sendTwoFactorConfirmationCode = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorConfirmationCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTwoFactorConfirmationCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTwoFactorConfirmationCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processSendTwoFactorConfirmationCode = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.sendTwoFactorAuthCode = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTwoFactorAuthCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processSendTwoFactorAuthCode = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @impersonationToken (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.impersonatedAuthenticate = function (impersonationToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImpersonatedAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processImpersonatedAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ImpersonatedAuthenticateResultModel.fromJS(resultData200) : new ImpersonatedAuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @switchAccountToken (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.linkedAccountAuthenticate = function (switchAccountToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLinkedAccountAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processLinkedAccountAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SwitchedAccountAuthenticateResultModel.fromJS(resultData200) : new SwitchedAccountAuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TokenAuthServiceProxy.prototype.getExternalAuthenticationProviders = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExternalAuthenticationProviders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processGetExternalAuthenticationProviders = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_75 = resultData200; _i < resultData200_75.length; _i++) {
                        var item = resultData200_75[_i];
                        result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.externalAuthenticate = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExternalAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processExternalAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @message (optional)
     * @severity (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.testNotification = function (message, severity) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processTestNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processTestNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processTestNotification = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TokenAuthServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], TokenAuthServiceProxy);
    return TokenAuthServiceProxy;
}());
export { TokenAuthServiceProxy };
var UiCustomizationSettingsServiceProxy = /** @class */ (function () {
    function UiCustomizationSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.getUiManagementSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processGetUiManagementSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UiCustomizationSettingsEditDto.fromJS(resultData200) : new UiCustomizationSettingsEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @settings (optional)
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.updateUiManagementSettings = function (settings) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(settings);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUpdateUiManagementSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @settings (optional)
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.updateDefaultUiManagementSettings = function (settings) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(settings);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDefaultUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUpdateDefaultUiManagementSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.useSystemDefaultSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUseSystemDefaultSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUseSystemDefaultSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    UiCustomizationSettingsServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], UiCustomizationSettingsServiceProxy);
    return UiCustomizationSettingsServiceProxy;
}());
export { UiCustomizationSettingsServiceProxy };
var UserServiceProxy = /** @class */ (function () {
    function UserServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.pickUsersForModal = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/PickUsersForModal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPickUsersForModal(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPickUsersForModal(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processPickUsersForModal = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserListForPickDto.fromJS(resultData200) : new PagedResultDtoOfUserListForPickDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @filter (optional)
     * @role (optional)
     * @active (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUsers = function (filter, role, active, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (active !== undefined)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserListDto.fromJS(resultData200) : new PagedResultDtoOfUserListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @filter (optional)
     * @role (optional)
     * @active (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUsersToExcel = function (filter, role, active, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (active !== undefined)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsersToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUsersToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取待编辑的用户
     * @externalMode (optional)
     * @organizationId (optional)
     * @id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUserForEdit = function (externalMode, organizationId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (externalMode !== undefined)
            url_ += "ExternalMode=" + encodeURIComponent("" + externalMode) + "&";
        if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUserForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetUserForEditOutput.fromJS(resultData200) : new GetUserForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUserPermissionsForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserPermissionsForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUserPermissionsForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.updateUserPermissions = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processUpdateUserPermissions = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.createOrUpdateUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processCreateOrUpdateUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CreateOrUpdateUserResultDto.fromJS(resultData200) : new CreateOrUpdateUserResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.deleteUser = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processDeleteUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取当前用户所有的虚拟设备ID
     * @return Success
     */
    UserServiceProxy.prototype.getVirtualDeviceId = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetVirtualDeviceId";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVirtualDeviceId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVirtualDeviceId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetVirtualDeviceId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_76 = resultData200; _i < resultData200_76.length; _i++) {
                        var item = resultData200_76[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.batchDeleteUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/BatchDeleteUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchDeleteUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchDeleteUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processBatchDeleteUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.unlockUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processUnlockUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.setAccountState = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/SetAccountState";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetAccountState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetAccountState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processSetAccountState = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.batchSetAccountState = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/BatchSetAccountState";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchSetAccountState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchSetAccountState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processBatchSetAccountState = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UserServiceProxy.prototype.getAllUsers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetAllUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfUserInfoListDto.fromJS(resultData200) : new ListResultDtoOfUserInfoListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUserDetail = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUserDetail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUserDetail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserDetailDto.fromJS(resultData200) : new UserDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    UserServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], UserServiceProxy);
    return UserServiceProxy;
}());
export { UserServiceProxy };
var UserGalleryAppSerivceServiceProxy = /** @class */ (function () {
    function UserGalleryAppSerivceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.getUserGroups = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/GetUserGroups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processGetUserGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserGroupsDto.fromJS(resultData200) : new UserGroupsDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.getGraphs = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/GetGraphs?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processGetGraphs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfUserGraphDto.fromJS(resultData200) : new IListResultOfUserGraphDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.getGraphStates = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/GetGraphStates?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGraphStates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGraphStates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processGetGraphStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfUserGraphStateDto.fromJS(resultData200) : new IListResultOfUserGraphStateDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.importUserGraphIntoConfigureGallery = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/ImportUserGraphIntoConfigureGallery";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportUserGraphIntoConfigureGallery(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportUserGraphIntoConfigureGallery(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processImportUserGraphIntoConfigureGallery = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.coverConfigureGalleryFromUserGallery = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/CoverConfigureGalleryFromUserGallery";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCoverConfigureGalleryFromUserGallery(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCoverConfigureGalleryFromUserGallery(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processCoverConfigureGalleryFromUserGallery = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.createOrUpdateGraph = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/CreateOrUpdateGraph";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateGraph(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateGraph(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processCreateOrUpdateGraph = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @userGalleryId (optional)
     * @id (optional)
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.getUserGraphForEdit = function (userGalleryId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/GetUserGraphForEdit?";
        if (userGalleryId !== undefined)
            url_ += "UserGalleryId=" + encodeURIComponent("" + userGalleryId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserGraphForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserGraphForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processGetUserGraphForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserGraphEditDto.fromJS(resultData200) : new UserGraphEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @userGalleryId (optional)
     * @id (optional)
     * @return Success
     */
    UserGalleryAppSerivceServiceProxy.prototype.deleteUserGraph = function (userGalleryId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserGalleryAppSerivce/DeleteUserGraph?";
        if (userGalleryId !== undefined)
            url_ += "UserGalleryId=" + encodeURIComponent("" + userGalleryId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteUserGraph(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteUserGraph(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserGalleryAppSerivceServiceProxy.prototype.processDeleteUserGraph = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    UserGalleryAppSerivceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], UserGalleryAppSerivceServiceProxy);
    return UserGalleryAppSerivceServiceProxy;
}());
export { UserGalleryAppSerivceServiceProxy };
var UserLinkServiceProxy = /** @class */ (function () {
    function UserLinkServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.linkToUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLinkToUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLinkToUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processLinkToUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @sorting (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.getLinkedUsers = function (maxResultCount, skipCount, sorting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLinkedUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processGetLinkedUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfLinkedUserDto.fromJS(resultData200) : new PagedResultDtoOfLinkedUserDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UserLinkServiceProxy.prototype.getRecentlyUsedLinkedUsers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRecentlyUsedLinkedUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processGetRecentlyUsedLinkedUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfLinkedUserDto.fromJS(resultData200) : new ListResultDtoOfLinkedUserDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.unlinkUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlinkUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlinkUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processUnlinkUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    UserLinkServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], UserLinkServiceProxy);
    return UserLinkServiceProxy;
}());
export { UserLinkServiceProxy };
var UserLoginServiceProxy = /** @class */ (function () {
    function UserLoginServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UserLoginServiceProxy.prototype.getRecentUserLoginAttempts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRecentUserLoginAttempts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLoginServiceProxy.prototype.processGetRecentUserLoginAttempts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200) : new ListResultDtoOfUserLoginAttemptDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 登出记录登出日志
     * @return Success
     */
    UserLoginServiceProxy.prototype.userSignOut = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLogin/UserSignOut";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUserSignOut(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUserSignOut(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLoginServiceProxy.prototype.processUserSignOut = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    UserLoginServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], UserLoginServiceProxy);
    return UserLoginServiceProxy;
}());
export { UserLoginServiceProxy };
var UserReportSearchServiceProxy = /** @class */ (function () {
    function UserReportSearchServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    UserReportSearchServiceProxy.prototype.getUserNamesAsync = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserReportSearch/GetUserNamesAsync?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserNamesAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserNamesAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserReportSearchServiceProxy.prototype.processGetUserNamesAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    UserReportSearchServiceProxy.prototype.getNamesAsync = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserReportSearch/GetNamesAsync?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNamesAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNamesAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserReportSearchServiceProxy.prototype.processGetNamesAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    UserReportSearchServiceProxy.prototype.getPhoneNumbersAsync = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserReportSearch/GetPhoneNumbersAsync?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPhoneNumbersAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPhoneNumbersAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserReportSearchServiceProxy.prototype.processGetPhoneNumbersAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    UserReportSearchServiceProxy.prototype.getEmailAddressAsync = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserReportSearch/GetEmailAddressAsync?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEmailAddressAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEmailAddressAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserReportSearchServiceProxy.prototype.processGetEmailAddressAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfString();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @name (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    UserReportSearchServiceProxy.prototype.getRolesAsync = function (name, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserReportSearch/GetRolesAsync?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRolesAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRolesAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserReportSearchServiceProxy.prototype.processGetRolesAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameCriteriaResultDtoOfInt64.fromJS(resultData200) : new PagedResultDtoOfNameCriteriaResultDtoOfInt64();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    UserReportSearchServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], UserReportSearchServiceProxy);
    return UserReportSearchServiceProxy;
}());
export { UserReportSearchServiceProxy };
var VariableServiceProxy = /** @class */ (function () {
    function VariableServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @configureId (optional)
     * @dataSourceId (optional)
     * @groupId (optional)
     * @dataType (optional)
     * @variableRwType (optional)
     * @variableNameOrMonitorName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getVariables = function (configureId, dataSourceId, groupId, dataType, variableRwType, variableNameOrMonitorName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetVariables?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (dataType !== undefined)
            url_ += "DataType=" + encodeURIComponent("" + dataType) + "&";
        if (variableRwType !== undefined)
            url_ += "VariableRwType=" + encodeURIComponent("" + variableRwType) + "&";
        if (variableNameOrMonitorName !== undefined)
            url_ += "VariableNameOrMonitorName=" + encodeURIComponent("" + variableNameOrMonitorName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetVariables = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVariableListDto.fromJS(resultData200) : new PagedResultDtoOfVariableListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @dataSourceId (optional)
     * @dataType (optional)
     * @name (optional)
     * @groupName (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getFBoxVariablesWithFilterReferenced = function (dataSourceId, dataType, name, groupName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetFBoxVariablesWithFilterReferenced?";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (dataType !== undefined)
            url_ += "DataType=" + encodeURIComponent("" + dataType) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (groupName !== undefined)
            url_ += "GroupName=" + encodeURIComponent("" + groupName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxVariablesWithFilterReferenced(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxVariablesWithFilterReferenced(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetFBoxVariablesWithFilterReferenced = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRefFBoxVariableDto.fromJS(resultData200) : new PagedResultDtoOfRefFBoxVariableDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getVariableForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetVariableForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVariableForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVariableForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetVariableForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? VariableForEditDto.fromJS(resultData200) : new VariableForEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getFBoxVariableListForSearch = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetFBoxVariableListForSearch?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFBoxVariableListForSearch(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFBoxVariableListForSearch(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetFBoxVariableListForSearch = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_77 = resultData200; _i < resultData200_77.length; _i++) {
                        var item = resultData200_77[_i];
                        result200.push(RefFBoxVariableDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.createOrUpdateVariableCheck = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/CreateOrUpdateVariableCheck";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateVariableCheck(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateVariableCheck(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processCreateOrUpdateVariableCheck = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.createOrUpdateVariable = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/CreateOrUpdateVariable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateVariable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateVariable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processCreateOrUpdateVariable = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.batchImportVariableCheck = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/BatchImportVariableCheck";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchImportVariableCheck(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchImportVariableCheck(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processBatchImportVariableCheck = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.batchImportVariablesFromFBoxVariable = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/BatchImportVariablesFromFBoxVariable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchImportVariablesFromFBoxVariable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchImportVariablesFromFBoxVariable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processBatchImportVariablesFromFBoxVariable = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.deleteVariable = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/DeleteVariable?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteVariable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteVariable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processDeleteVariable = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.batchDeleteVariables = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/BatchDeleteVariables";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchDeleteVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchDeleteVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processBatchDeleteVariables = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @dataSourceCode (optional)
     * @name (optional)
     * @groupName (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getConfigureVariableName = function (configureId, dataSourceCode, name, groupName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetConfigureVariableName?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (dataSourceCode !== undefined)
            url_ += "DataSourceCode=" + encodeURIComponent("" + dataSourceCode) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (groupName !== undefined)
            url_ += "GroupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfigureVariableName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfigureVariableName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetConfigureVariableName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.batchEditVariables = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/BatchEditVariables";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBatchEditVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBatchEditVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processBatchEditVariables = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取启用数据存储的Int32或Float型变量
     * @variableName (optional) 变量名称
     * @configureId (optional) 组态ID
     * @return Success
     */
    VariableServiceProxy.prototype.getStorageEnabledNumberVariableNames = function (variableName, configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetStorageEnabledNumberVariableNames?";
        if (variableName !== undefined)
            url_ += "VariableName=" + encodeURIComponent("" + variableName) + "&";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStorageEnabledNumberVariableNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStorageEnabledNumberVariableNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetStorageEnabledNumberVariableNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_78 = resultData200; _i < resultData200_78.length; _i++) {
                        var item = resultData200_78[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @name (optional)
     * @selectedVariableName (optional)
     * @dataSourceId (optional)
     * @groupId (optional)
     * @dataType (optional)
     * @readWriteModel (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getVariablesForDesignerSelect = function (configureId, name, selectedVariableName, dataSourceId, groupId, dataType, readWriteModel, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetVariablesForDesignerSelect?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (selectedVariableName !== undefined)
            url_ += "SelectedVariableName=" + encodeURIComponent("" + selectedVariableName) + "&";
        if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (dataType !== undefined)
            url_ += "DataType=" + encodeURIComponent("" + dataType) + "&";
        if (readWriteModel !== undefined)
            url_ += "ReadWriteModel=" + encodeURIComponent("" + readWriteModel) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVariablesForDesignerSelect(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVariablesForDesignerSelect(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetVariablesForDesignerSelect = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVariableForDesignerDto.fromJS(resultData200) : new PagedResultDtoOfVariableForDesignerDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @dataType (optional)
     * @readWriteModel (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getVariablesForDesigner = function (configureId, dataType, readWriteModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetVariablesForDesigner?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (dataType !== undefined)
            url_ += "DataType=" + encodeURIComponent("" + dataType) + "&";
        if (readWriteModel !== undefined)
            url_ += "ReadWriteModel=" + encodeURIComponent("" + readWriteModel) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVariablesForDesigner(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVariablesForDesigner(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetVariablesForDesigner = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_79 = resultData200; _i < resultData200_79.length; _i++) {
                        var item = resultData200_79[_i];
                        result200.push(VariableForDesignerListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.findVariableForDesigner = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/FindVariableForDesigner";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindVariableForDesigner(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindVariableForDesigner(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processFindVariableForDesigner = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? VariableSpecifiedForDesignerDto.fromJS(resultData200) : new VariableSpecifiedForDesignerDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getAllVariables = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetAllVariables?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllVariables(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllVariables(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetAllVariables = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfVariableNameMappingListDto.fromJS(resultData200) : new ListResultDtoOfVariableNameMappingListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @return Success
     */
    VariableServiceProxy.prototype.getVariableDataSourcesForDeviceMonitorList = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Variable/GetVariableDataSourcesForDeviceMonitorList?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVariableDataSourcesForDeviceMonitorList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVariableDataSourcesForDeviceMonitorList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableServiceProxy.prototype.processGetVariableDataSourcesForDeviceMonitorList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_80 = resultData200; _i < resultData200_80.length; _i++) {
                        var item = resultData200_80[_i];
                        result200.push(VariableDataSourceListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VariableServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VariableServiceProxy);
    return VariableServiceProxy;
}());
export { VariableServiceProxy };
var VariableGroupServiceProxy = /** @class */ (function () {
    function VariableGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @configureId (optional)
     * @return Success
     */
    VariableGroupServiceProxy.prototype.getVariableGroups = function (configureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VariableGroup/GetVariableGroups?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVariableGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVariableGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableGroupServiceProxy.prototype.processGetVariableGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_81 = resultData200; _i < resultData200_81.length; _i++) {
                        var item = resultData200_81[_i];
                        result200.push(VariableGroupListDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VariableGroupServiceProxy.prototype.createOrUpdateVariableGroup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VariableGroup/CreateOrUpdateVariableGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateVariableGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateVariableGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableGroupServiceProxy.prototype.processCreateOrUpdateVariableGroup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @configureId (optional)
     * @id (optional)
     * @return Success
     */
    VariableGroupServiceProxy.prototype.deleteVariableGroup = function (configureId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VariableGroup/DeleteVariableGroup?";
        if (configureId !== undefined)
            url_ += "ConfigureId=" + encodeURIComponent("" + configureId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteVariableGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteVariableGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VariableGroupServiceProxy.prototype.processDeleteVariableGroup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_82 = resultData200; _i < resultData200_82.length; _i++) {
                        var item = resultData200_82[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VariableGroupServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VariableGroupServiceProxy);
    return VariableGroupServiceProxy;
}());
export { VariableGroupServiceProxy };
var VirtualDeviceServiceProxy = /** @class */ (function () {
    function VirtualDeviceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceServiceProxy.prototype.saveElementPassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDevice/SaveElementPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveElementPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveElementPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceServiceProxy.prototype.processSaveElementPassword = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceServiceProxy.prototype.checkElementPasswordValid = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDevice/CheckElementPasswordValid";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckElementPasswordValid(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckElementPasswordValid(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceServiceProxy.prototype.processCheckElementPasswordValid = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceServiceProxy);
    return VirtualDeviceServiceProxy;
}());
export { VirtualDeviceServiceProxy };
var VirtualDeviceAlarmServiceProxy = /** @class */ (function () {
    function VirtualDeviceAlarmServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    VirtualDeviceAlarmServiceProxy.prototype.getCurrentAlarms = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceAlarm/GetCurrentAlarms?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceAlarmServiceProxy.prototype.processGetCurrentAlarms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CurrentAlarmResultDto.fromJS(resultData200) : new CurrentAlarmResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @virtualDeviceId (optional) DeviceId
     * @alarmName (optional)
     * @startDate (optional)
     * @endDate (optional)
     * @limit (optional)
     * @dataSourceCode (optional)
     * @nextPage (optional)
     * @limitDateTime (optional)
     * @return Success
     */
    VirtualDeviceAlarmServiceProxy.prototype.getHistoryAlarms = function (virtualDeviceId, alarmName, startDate, endDate, limit, dataSourceCode, nextPage, limitDateTime) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceAlarm/GetHistoryAlarms?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (alarmName !== undefined)
            url_ += "AlarmName=" + encodeURIComponent("" + alarmName) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (dataSourceCode !== undefined)
            url_ += "DataSourceCode=" + encodeURIComponent("" + dataSourceCode) + "&";
        if (nextPage !== undefined)
            url_ += "NextPage=" + encodeURIComponent("" + nextPage) + "&";
        if (limitDateTime !== undefined)
            url_ += "LimitDateTime=" + encodeURIComponent(limitDateTime ? "" + limitDateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryAlarms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryAlarms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceAlarmServiceProxy.prototype.processGetHistoryAlarms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? HistoryAlarmResultDto.fromJS(resultData200) : new HistoryAlarmResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceAlarmServiceProxy.prototype.confirmAlarm = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceAlarm/ConfirmAlarm";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processConfirmAlarm(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processConfirmAlarm(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceAlarmServiceProxy.prototype.processConfirmAlarm = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ConfirmAlarmResultDto.fromJS(resultData200) : new ConfirmAlarmResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceAlarmServiceProxy.prototype.exportHistoryAlarm = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceAlarm/ExportHistoryAlarm";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportHistoryAlarm(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportHistoryAlarm(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceAlarmServiceProxy.prototype.processExportHistoryAlarm = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    VirtualDeviceAlarmServiceProxy.prototype.getTransportType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceAlarm/GetTransportType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTransportType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTransportType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceAlarmServiceProxy.prototype.processGetTransportType = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceAlarmServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceAlarmServiceProxy);
    return VirtualDeviceAlarmServiceProxy;
}());
export { VirtualDeviceAlarmServiceProxy };
var VirtualDeviceDataSourceServiceProxy = /** @class */ (function () {
    function VirtualDeviceDataSourceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    VirtualDeviceDataSourceServiceProxy.prototype.getVirtualDeviceDataSources = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceDataSource/GetVirtualDeviceDataSources?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVirtualDeviceDataSources(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVirtualDeviceDataSources(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceDataSourceServiceProxy.prototype.processGetVirtualDeviceDataSources = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfVirtualDeviceDataSourceListDto.fromJS(resultData200) : new ListResultDtoOfVirtualDeviceDataSourceListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceDataSourceServiceProxy.prototype.checkDataSourcesUnderCurrentAccount = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceDataSource/CheckDataSourcesUnderCurrentAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckDataSourcesUnderCurrentAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckDataSourcesUnderCurrentAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceDataSourceServiceProxy.prototype.processCheckDataSourcesUnderCurrentAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceDataSourceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceDataSourceServiceProxy);
    return VirtualDeviceDataSourceServiceProxy;
}());
export { VirtualDeviceDataSourceServiceProxy };
var VirtualDeviceDataSourceBindServiceProxy = /** @class */ (function () {
    function VirtualDeviceDataSourceBindServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceDataSourceBindServiceProxy.prototype.bindDataSourceAsync = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceDataSourceBind/BindDataSourceAsync";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBindDataSourceAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBindDataSourceAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceDataSourceBindServiceProxy.prototype.processBindDataSourceAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OperationResultDto.fromJS(resultData200) : new OperationResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceDataSourceBindServiceProxy.prototype.unBindDataSourceAsync = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceDataSourceBind/UnBindDataSourceAsync";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnBindDataSourceAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnBindDataSourceAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceDataSourceBindServiceProxy.prototype.processUnBindDataSourceAsync = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OperationResultDto.fromJS(resultData200) : new OperationResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceDataSourceBindServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceDataSourceBindServiceProxy);
    return VirtualDeviceDataSourceBindServiceProxy;
}());
export { VirtualDeviceDataSourceBindServiceProxy };
var VirtualDeviceForceIssueServiceProxy = /** @class */ (function () {
    function VirtualDeviceForceIssueServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceForceIssueServiceProxy.prototype.forceIssue = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceForceIssue/ForceIssue";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processForceIssue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processForceIssue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceForceIssueServiceProxy.prototype.processForceIssue = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceForceIssueServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceForceIssueServiceProxy);
    return VirtualDeviceForceIssueServiceProxy;
}());
export { VirtualDeviceForceIssueServiceProxy };
var VirtualDeviceHistoryDataServiceProxy = /** @class */ (function () {
    function VirtualDeviceHistoryDataServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @virtualDeviceId (optional)
     * @dataSourceCode (optional)
     * @return Success
     */
    VirtualDeviceHistoryDataServiceProxy.prototype.getHistoryDataItems = function (virtualDeviceId, dataSourceCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceHistoryData/GetHistoryDataItems?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (dataSourceCode !== undefined)
            url_ += "DataSourceCode=" + encodeURIComponent("" + dataSourceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoryDataItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoryDataItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceHistoryDataServiceProxy.prototype.processGetHistoryDataItems = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? HistoryDataItemResultDto.fromJS(resultData200) : new HistoryDataItemResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceHistoryDataServiceProxy.prototype.postByRowHistoryData = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceHistoryData/PostByRowHistoryData";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPostByRowHistoryData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPostByRowHistoryData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceHistoryDataServiceProxy.prototype.processPostByRowHistoryData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RowHistoryDataDto.fromJS(resultData200) : new RowHistoryDataDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceHistoryDataServiceProxy.prototype.pullVirtualDeviceHistoryData = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceHistoryData/PullVirtualDeviceHistoryData";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPullVirtualDeviceHistoryData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPullVirtualDeviceHistoryData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceHistoryDataServiceProxy.prototype.processPullVirtualDeviceHistoryData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RowHistoryDataDto.fromJS(resultData200) : new RowHistoryDataDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceHistoryDataServiceProxy.prototype.exportHistoryDataCsv = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceHistoryData/ExportHistoryDataCsv";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportHistoryDataCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportHistoryDataCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceHistoryDataServiceProxy.prototype.processExportHistoryDataCsv = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    VirtualDeviceHistoryDataServiceProxy.prototype.getTransportType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceHistoryData/GetTransportType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTransportType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTransportType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceHistoryDataServiceProxy.prototype.processGetTransportType = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceHistoryDataServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceHistoryDataServiceProxy);
    return VirtualDeviceHistoryDataServiceProxy;
}());
export { VirtualDeviceHistoryDataServiceProxy };
var VirtualDeviceOperationHistoriesServiceProxy = /** @class */ (function () {
    function VirtualDeviceOperationHistoriesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @virtualDeviceId (optional)
     * @operatorNameFilter (optional)
     * @maxCreationTimeFilter (optional)
     * @minCreationTimeFilter (optional)
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    VirtualDeviceOperationHistoriesServiceProxy.prototype.getAll = function (virtualDeviceId, operatorNameFilter, maxCreationTimeFilter, minCreationTimeFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceOperationHistories/GetAll?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (operatorNameFilter !== undefined)
            url_ += "OperatorNameFilter=" + encodeURIComponent("" + operatorNameFilter) + "&";
        if (maxCreationTimeFilter !== undefined)
            url_ += "MaxCreationTimeFilter=" + encodeURIComponent(maxCreationTimeFilter ? "" + maxCreationTimeFilter.toJSON() : "") + "&";
        if (minCreationTimeFilter !== undefined)
            url_ += "MinCreationTimeFilter=" + encodeURIComponent(minCreationTimeFilter ? "" + minCreationTimeFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceOperationHistoriesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVirtualDeviceOperationHistoryDto.fromJS(resultData200) : new PagedResultDtoOfVirtualDeviceOperationHistoryDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceOperationHistoriesServiceProxy.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceOperationHistories/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceOperationHistoriesServiceProxy.prototype.processCreate = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceOperationHistoriesServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceOperationHistoriesServiceProxy);
    return VirtualDeviceOperationHistoriesServiceProxy;
}());
export { VirtualDeviceOperationHistoriesServiceProxy };
var VirtualDeviceStateServiceProxy = /** @class */ (function () {
    function VirtualDeviceStateServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    VirtualDeviceStateServiceProxy.prototype.refreshState = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceState/RefreshState";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRefreshState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRefreshState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceStateServiceProxy.prototype.processRefreshState = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? VirtualDeviceOperationResultDto.fromJS(resultData200) : new VirtualDeviceOperationResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    VirtualDeviceStateServiceProxy.prototype.refreshAllTenantDeviceStates = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceState/RefreshAllTenantDeviceStates";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRefreshAllTenantDeviceStates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRefreshAllTenantDeviceStates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceStateServiceProxy.prototype.processRefreshAllTenantDeviceStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RefreshAllTenantDeviceStateResultDto.fromJS(resultData200) : new RefreshAllTenantDeviceStateResultDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceStateServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceStateServiceProxy);
    return VirtualDeviceStateServiceProxy;
}());
export { VirtualDeviceStateServiceProxy };
var VirtualDeviceVideoServiceProxy = /** @class */ (function () {
    function VirtualDeviceVideoServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @virtualDeviceId (optional)
     * @tag (optional)
     * @return Success
     */
    VirtualDeviceVideoServiceProxy.prototype.getVideoUrl = function (virtualDeviceId, tag) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceVideo/GetVideoUrl?";
        if (virtualDeviceId !== undefined)
            url_ += "VirtualDeviceId=" + encodeURIComponent("" + virtualDeviceId) + "&";
        if (tag !== undefined)
            url_ += "Tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVideoUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVideoUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceVideoServiceProxy.prototype.processGetVideoUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    VirtualDeviceVideoServiceProxy.prototype.getVirtualDeviceVideos = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceVideo/GetVirtualDeviceVideos?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetVirtualDeviceVideos(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetVirtualDeviceVideos(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceVideoServiceProxy.prototype.processGetVirtualDeviceVideos = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IListResultOfVirtualDeviceVideoDto.fromJS(resultData200) : new IListResultOfVirtualDeviceVideoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @virtualDeviceVideoDto (optional)
     * @return Success
     */
    VirtualDeviceVideoServiceProxy.prototype.saveVirtualDeviceVideo = function (virtualDeviceVideoDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceVideo/SaveVirtualDeviceVideo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(virtualDeviceVideoDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveVirtualDeviceVideo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveVirtualDeviceVideo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceVideoServiceProxy.prototype.processSaveVirtualDeviceVideo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceVideoServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceVideoServiceProxy);
    return VirtualDeviceVideoServiceProxy;
}());
export { VirtualDeviceVideoServiceProxy };
var VirtualDeviceWeatherServiceProxy = /** @class */ (function () {
    function VirtualDeviceWeatherServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @id (optional)
     * @return Success
     */
    VirtualDeviceWeatherServiceProxy.prototype.getWeatherInfo = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/VirtualDeviceWeather/GetWeatherInfo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWeatherInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWeatherInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VirtualDeviceWeatherServiceProxy.prototype.processGetWeatherInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? WeatherInfoDto.fromJS(resultData200) : new WeatherInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    VirtualDeviceWeatherServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], VirtualDeviceWeatherServiceProxy);
    return VirtualDeviceWeatherServiceProxy;
}());
export { VirtualDeviceWeatherServiceProxy };
var WebLogServiceProxy = /** @class */ (function () {
    function WebLogServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    WebLogServiceProxy.prototype.getLatestWebLogs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLatestWebLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebLogServiceProxy.prototype.processGetLatestWebLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetLatestWebLogsOutput.fromJS(resultData200) : new GetLatestWebLogsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WebLogServiceProxy.prototype.downloadWebLogs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDownloadWebLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebLogServiceProxy.prototype.processDownloadWebLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WebLogServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], WebLogServiceProxy);
    return WebLogServiceProxy;
}());
export { WebLogServiceProxy };
var WeChatServiceProxy = /** @class */ (function () {
    function WeChatServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * 增加或者更新公众号信息
     * @input (optional)
     * @return Success
     */
    WeChatServiceProxy.prototype.insertOrUpdateOfficialAccount = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WeChat/InsertOrUpdateOfficialAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processInsertOrUpdateOfficialAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processInsertOrUpdateOfficialAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WeChatServiceProxy.prototype.processInsertOrUpdateOfficialAccount = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取公众号信息
     * @return Success
     */
    WeChatServiceProxy.prototype.getOfficialAccount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WeChat/GetOfficialAccount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOfficialAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOfficialAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WeChatServiceProxy.prototype.processGetOfficialAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OfficialAccountDto.fromJS(resultData200) : new OfficialAccountDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取微信临时二维码字符串
     * @return Success
     */
    WeChatServiceProxy.prototype.getWeChatTempQrCode = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WeChat/GetWeChatTempQrCode";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWeChatTempQrCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWeChatTempQrCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WeChatServiceProxy.prototype.processGetWeChatTempQrCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? WeChatTempQrCodeDto.fromJS(resultData200) : new WeChatTempQrCodeDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取微信url配置信息
     * @return Success
     */
    WeChatServiceProxy.prototype.getWeChatUrlConfig = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WeChat/GetWeChatUrlConfig";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWeChatUrlConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWeChatUrlConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WeChatServiceProxy.prototype.processGetWeChatUrlConfig = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? WeChatUrlConfigDto.fromJS(resultData200) : new WeChatUrlConfigDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 获取微信临时二维码ticket
     * @return Success
     */
    WeChatServiceProxy.prototype.getWeChatTempQrCodeTicket = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WeChat/GetWeChatTempQrCodeTicket";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWeChatTempQrCodeTicket(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWeChatTempQrCodeTicket(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WeChatServiceProxy.prototype.processGetWeChatTempQrCodeTicket = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * 用户取消绑定
     * @return Success
     */
    WeChatServiceProxy.prototype.userUnBind = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WeChat/UserUnBind";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUserUnBind(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUserUnBind(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WeChatServiceProxy.prototype.processUserUnBind = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WeChatServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], WeChatServiceProxy);
    return WeChatServiceProxy;
}());
export { WeChatServiceProxy };
var WorkAttendanceRuleServiceProxy = /** @class */ (function () {
    function WorkAttendanceRuleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    WorkAttendanceRuleServiceProxy.prototype.getWorkRule = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkAttendanceRule/GetWorkRule";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkRule(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkRule(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkAttendanceRuleServiceProxy.prototype.processGetWorkRule = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? WorkRuleDto.fromJS(resultData200) : new WorkRuleDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    WorkAttendanceRuleServiceProxy.prototype.createOrUpdateWorkRule = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkAttendanceRule/CreateOrUpdateWorkRule";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateWorkRule(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateWorkRule(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkAttendanceRuleServiceProxy.prototype.processCreateOrUpdateWorkRule = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WorkAttendanceRuleServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], WorkAttendanceRuleServiceProxy);
    return WorkAttendanceRuleServiceProxy;
}());
export { WorkAttendanceRuleServiceProxy };
var WorkAttendanceServiceServiceProxy = /** @class */ (function () {
    function WorkAttendanceServiceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @attendanceJobNumberOrName (optional)
     * @attendanceTime (optional)
     * @deviceId (optional)
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    WorkAttendanceServiceServiceProxy.prototype.getWorkAttendanceRecords = function (attendanceJobNumberOrName, attendanceTime, deviceId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkAttendanceService/GetWorkAttendanceRecords?";
        if (attendanceJobNumberOrName !== undefined)
            url_ += "AttendanceJobNumberOrName=" + encodeURIComponent("" + attendanceJobNumberOrName) + "&";
        if (attendanceTime !== undefined)
            url_ += "AttendanceTime=" + encodeURIComponent("" + attendanceTime) + "&";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkAttendanceRecords(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkAttendanceRecords(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkAttendanceServiceServiceProxy.prototype.processGetWorkAttendanceRecords = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfWorkAttendanceRecordOutput.fromJS(resultData200) : new PagedResultDtoOfWorkAttendanceRecordOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WorkAttendanceServiceServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], WorkAttendanceServiceServiceProxy);
    return WorkAttendanceServiceServiceProxy;
}());
export { WorkAttendanceServiceServiceProxy };
var WorkOrderServiceProxy = /** @class */ (function () {
    function WorkOrderServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @input (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.acceptedWorkOrder = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/AcceptedWorkOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAcceptedWorkOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAcceptedWorkOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processAcceptedWorkOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.completedWorkOrder = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/CompletedWorkOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCompletedWorkOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCompletedWorkOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processCompletedWorkOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getWorkOrderDetail = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetWorkOrderDetail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkOrderDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkOrderDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetWorkOrderDetail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? WorkOrderDetailDto.fromJS(resultData200) : new WorkOrderDetailDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getExecutorNames = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetExecutorNames";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExecutorNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExecutorNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetExecutorNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfExecutorNameDto.fromJS(resultData200) : new ListResultDtoOfExecutorNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getCustomerCompanyNames = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetCustomerCompanyNames";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCustomerCompanyNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCustomerCompanyNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetCustomerCompanyNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfCompanyNameDto.fromJS(resultData200) : new ListResultDtoOfCompanyNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getAssignerNames = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetAssignerNames";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAssignerNames(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAssignerNames(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetAssignerNames = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfAssignerNameDto.fromJS(resultData200) : new ListResultDtoOfAssignerNameDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.createWorkOrder = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/CreateWorkOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateWorkOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateWorkOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processCreateWorkOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @filter (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getDeviceListForWorkOrder = function (filter, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetDeviceListForWorkOrder?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeviceListForWorkOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeviceListForWorkOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetDeviceListForWorkOrder = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getWorkOrderImagesUrl = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetWorkOrderImagesUrl?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkOrderImagesUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkOrderImagesUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetWorkOrderImagesUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_83 = resultData200; _i < resultData200_83.length; _i++) {
                        var item = resultData200_83[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getWorkOrderThumbImagesUrl = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetWorkOrderThumbImagesUrl?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkOrderThumbImagesUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkOrderThumbImagesUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetWorkOrderThumbImagesUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_84 = resultData200; _i < resultData200_84.length; _i++) {
                        var item = resultData200_84[_i];
                        result200.push(item);
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    WorkOrderServiceProxy.prototype.getWorkOrderSerialNumber = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrder/GetWorkOrderSerialNumber?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkOrderSerialNumber(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkOrderSerialNumber(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderServiceProxy.prototype.processGetWorkOrderSerialNumber = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? WorkOrderSerialNumberDto.fromJS(resultData200) : new WorkOrderSerialNumberDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WorkOrderServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], WorkOrderServiceProxy);
    return WorkOrderServiceProxy;
}());
export { WorkOrderServiceProxy };
var WorkOrderListServiceProxy = /** @class */ (function () {
    function WorkOrderListServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @baseFilter (optional)
     * @state (optional) 工单状态
     * @executorName (optional) 维修人员
     * @customerName (optional) 客户
     * @assignerName (optional) 派单操作人
     * @assignStartTime (optional) 派单起始时间
     * @assignEndTime (optional) 派单终止时间
     * @finishStartTime (optional) 结单起始时间
     * @finishEndTime (optional) 结单派单终止时间
     * @workOrderType (optional) 工单类型
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    WorkOrderListServiceProxy.prototype.getWorkOrderList = function (baseFilter, state, executorName, customerName, assignerName, assignStartTime, assignEndTime, finishStartTime, finishEndTime, workOrderType, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrderList/GetWorkOrderList?";
        if (baseFilter !== undefined)
            url_ += "BaseFilter=" + encodeURIComponent("" + baseFilter) + "&";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (executorName !== undefined)
            url_ += "ExecutorName=" + encodeURIComponent("" + executorName) + "&";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (assignerName !== undefined)
            url_ += "AssignerName=" + encodeURIComponent("" + assignerName) + "&";
        if (assignStartTime !== undefined)
            url_ += "AssignStartTime=" + encodeURIComponent(assignStartTime ? "" + assignStartTime.toJSON() : "") + "&";
        if (assignEndTime !== undefined)
            url_ += "AssignEndTime=" + encodeURIComponent(assignEndTime ? "" + assignEndTime.toJSON() : "") + "&";
        if (finishStartTime !== undefined)
            url_ += "FinishStartTime=" + encodeURIComponent(finishStartTime ? "" + finishStartTime.toJSON() : "") + "&";
        if (finishEndTime !== undefined)
            url_ += "FinishEndTime=" + encodeURIComponent(finishEndTime ? "" + finishEndTime.toJSON() : "") + "&";
        if (workOrderType !== undefined)
            url_ += "WorkOrderType=" + encodeURIComponent("" + workOrderType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkOrderList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkOrderList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderListServiceProxy.prototype.processGetWorkOrderList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfWorkOrderDto.fromJS(resultData200) : new PagedResultDtoOfWorkOrderDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @baseFilter (optional)
     * @state (optional) 工单状态
     * @customerName (optional) 客户
     * @assignerName (optional) 派单操作人
     * @assignStartTime (optional) 派单起始时间
     * @assignEndTime (optional) 派单终止时间
     * @finishStartTime (optional) 结单起始时间
     * @finishEndTime (optional) 结单派单终止时间
     * @workOrderType (optional) 工单类型
     * @sorting (optional)
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    WorkOrderListServiceProxy.prototype.getMyWorkOrderList = function (baseFilter, state, customerName, assignerName, assignStartTime, assignEndTime, finishStartTime, finishEndTime, workOrderType, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrderList/GetMyWorkOrderList?";
        if (baseFilter !== undefined)
            url_ += "BaseFilter=" + encodeURIComponent("" + baseFilter) + "&";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (assignerName !== undefined)
            url_ += "AssignerName=" + encodeURIComponent("" + assignerName) + "&";
        if (assignStartTime !== undefined)
            url_ += "AssignStartTime=" + encodeURIComponent(assignStartTime ? "" + assignStartTime.toJSON() : "") + "&";
        if (assignEndTime !== undefined)
            url_ += "AssignEndTime=" + encodeURIComponent(assignEndTime ? "" + assignEndTime.toJSON() : "") + "&";
        if (finishStartTime !== undefined)
            url_ += "FinishStartTime=" + encodeURIComponent(finishStartTime ? "" + finishStartTime.toJSON() : "") + "&";
        if (finishEndTime !== undefined)
            url_ += "FinishEndTime=" + encodeURIComponent(finishEndTime ? "" + finishEndTime.toJSON() : "") + "&";
        if (workOrderType !== undefined)
            url_ += "WorkOrderType=" + encodeURIComponent("" + workOrderType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyWorkOrderList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyWorkOrderList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderListServiceProxy.prototype.processGetMyWorkOrderList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfMyWorkOrderDto.fromJS(resultData200) : new PagedResultDtoOfMyWorkOrderDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    WorkOrderListServiceProxy.prototype.exportWorkOrders = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrderList/ExportWorkOrders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportWorkOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportWorkOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderListServiceProxy.prototype.processExportWorkOrders = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    WorkOrderListServiceProxy.prototype.exportMyWorkOrders = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrderList/ExportMyWorkOrders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportMyWorkOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportMyWorkOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderListServiceProxy.prototype.processExportMyWorkOrders = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WorkOrderListServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], WorkOrderListServiceProxy);
    return WorkOrderListServiceProxy;
}());
export { WorkOrderListServiceProxy };
var WorkOrderProgressServiceProxy = /** @class */ (function () {
    function WorkOrderProgressServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @workOrderId (optional)
     * @return Success
     */
    WorkOrderProgressServiceProxy.prototype.getProgresses = function (workOrderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WorkOrderProgress/GetProgresses?";
        if (workOrderId !== undefined)
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProgresses(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProgresses(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WorkOrderProgressServiceProxy.prototype.processGetProgresses = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_85 = resultData200; _i < resultData200_85.length; _i++) {
                        var item = resultData200_85[_i];
                        result200.push(WorkOrderProgressDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WorkOrderProgressServiceProxy = __decorate([
        Injectable(),
        __param(0, Inject(HttpClient)), __param(1, Optional()), __param(1, Inject(API_BASE_URL))
    ], WorkOrderProgressServiceProxy);
    return WorkOrderProgressServiceProxy;
}());
export { WorkOrderProgressServiceProxy };
var IsTenantAvailableInput = /** @class */ (function () {
    function IsTenantAvailableInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    };
    IsTenantAvailableInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    };
    IsTenantAvailableInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return IsTenantAvailableInput;
}());
export { IsTenantAvailableInput };
var IsTenantAvailableOutput = /** @class */ (function () {
    function IsTenantAvailableOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableOutput.prototype.init = function (data) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    };
    IsTenantAvailableOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    };
    IsTenantAvailableOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    };
    return IsTenantAvailableOutput;
}());
export { IsTenantAvailableOutput };
var ResolveTenantIdInput = /** @class */ (function () {
    function ResolveTenantIdInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResolveTenantIdInput.prototype.init = function (data) {
        if (data) {
            this.c = data["c"];
        }
    };
    ResolveTenantIdInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    };
    ResolveTenantIdInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    };
    return ResolveTenantIdInput;
}());
export { ResolveTenantIdInput };
var RegisterInput = /** @class */ (function () {
    function RegisterInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterInput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    };
    RegisterInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterInput();
        result.init(data);
        return result;
    };
    RegisterInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    };
    return RegisterInput;
}());
export { RegisterInput };
var RegisterOutput = /** @class */ (function () {
    function RegisterOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterOutput.prototype.init = function (data) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    };
    RegisterOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterOutput();
        result.init(data);
        return result;
    };
    RegisterOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    };
    return RegisterOutput;
}());
export { RegisterOutput };
var SendEmailActivationLinkInput = /** @class */ (function () {
    function SendEmailActivationLinkInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendEmailActivationLinkInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendEmailActivationLinkInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    };
    SendEmailActivationLinkInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendEmailActivationLinkInput;
}());
export { SendEmailActivationLinkInput };
var ActivateEmailInput = /** @class */ (function () {
    function ActivateEmailInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivateEmailInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
            this.c = data["c"];
        }
    };
    ActivateEmailInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivateEmailInput();
        result.init(data);
        return result;
    };
    ActivateEmailInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    };
    return ActivateEmailInput;
}());
export { ActivateEmailInput };
var ImpersonateInput = /** @class */ (function () {
    function ImpersonateInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonateInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    ImpersonateInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonateInput();
        result.init(data);
        return result;
    };
    ImpersonateInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return ImpersonateInput;
}());
export { ImpersonateInput };
var ImpersonateOutput = /** @class */ (function () {
    function ImpersonateOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonateOutput.prototype.init = function (data) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    ImpersonateOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonateOutput();
        result.init(data);
        return result;
    };
    ImpersonateOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return ImpersonateOutput;
}());
export { ImpersonateOutput };
var SwitchToLinkedAccountInput = /** @class */ (function () {
    function SwitchToLinkedAccountInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchToLinkedAccountInput.prototype.init = function (data) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    };
    SwitchToLinkedAccountInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    };
    SwitchToLinkedAccountInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    };
    return SwitchToLinkedAccountInput;
}());
export { SwitchToLinkedAccountInput };
var SwitchToLinkedAccountOutput = /** @class */ (function () {
    function SwitchToLinkedAccountOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchToLinkedAccountOutput.prototype.init = function (data) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    SwitchToLinkedAccountOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    };
    SwitchToLinkedAccountOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return SwitchToLinkedAccountOutput;
}());
export { SwitchToLinkedAccountOutput };
var AlarmGroupListDto = /** @class */ (function () {
    function AlarmGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AlarmGroupListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    AlarmGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AlarmGroupListDto();
        result.init(data);
        return result;
    };
    AlarmGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return AlarmGroupListDto;
}());
export { AlarmGroupListDto };
var CreateOrUpdateAlarmGroupDto = /** @class */ (function () {
    function CreateOrUpdateAlarmGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateAlarmGroupDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateAlarmGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateAlarmGroupDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateAlarmGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateAlarmGroupDto;
}());
export { CreateOrUpdateAlarmGroupDto };
var PagedResultDtoOfAlarmDefListDto = /** @class */ (function () {
    function PagedResultDtoOfAlarmDefListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfAlarmDefListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(AlarmDefListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfAlarmDefListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfAlarmDefListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfAlarmDefListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfAlarmDefListDto;
}());
export { PagedResultDtoOfAlarmDefListDto };
var AlarmDefListDto = /** @class */ (function () {
    function AlarmDefListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AlarmDefListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.alarmMessage = data["alarmMessage"];
            this.alarmDataSource = data["alarmDataSource"];
            this.alarmLevel = data["alarmLevel"];
            this.faultCode = data["faultCode"];
            this.groupName = data["groupName"];
            this.dataSourceName = data["dataSourceName"];
            this.refAlarmDto = data["refAlarmDto"] ? RefAlarmDto.fromJS(data["refAlarmDto"]) : undefined;
            this.triggerRuleType = data["triggerRuleType"];
            this.triggerRuleValue = data["triggerRuleValue"] ? TriggerRuleValue.fromJS(data["triggerRuleValue"]) : undefined;
            this.variableName = data["variableName"];
            this.variableDataType = data["variableDataType"];
            this.refAlarmDefName = data["refAlarmDefName"];
            this.id = data["id"];
        }
    };
    AlarmDefListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AlarmDefListDto();
        result.init(data);
        return result;
    };
    AlarmDefListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alarmMessage"] = this.alarmMessage;
        data["alarmDataSource"] = this.alarmDataSource;
        data["alarmLevel"] = this.alarmLevel;
        data["faultCode"] = this.faultCode;
        data["groupName"] = this.groupName;
        data["dataSourceName"] = this.dataSourceName;
        data["refAlarmDto"] = this.refAlarmDto ? this.refAlarmDto.toJSON() : undefined;
        data["triggerRuleType"] = this.triggerRuleType;
        data["triggerRuleValue"] = this.triggerRuleValue ? this.triggerRuleValue.toJSON() : undefined;
        data["variableName"] = this.variableName;
        data["variableDataType"] = this.variableDataType;
        data["refAlarmDefName"] = this.refAlarmDefName;
        data["id"] = this.id;
        return data;
    };
    return AlarmDefListDto;
}());
export { AlarmDefListDto };
var RefAlarmDto = /** @class */ (function () {
    function RefAlarmDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RefAlarmDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.alarmMessage = data["alarmMessage"];
            this.condition1 = data["condition1"];
            this.condition2 = data["condition2"];
            this.operand1 = data["operand1"];
            this.operand2 = data["operand2"];
            this.conditionCombineMethod = data["conditionCombineMethod"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.devAlias = data["devAlias"];
            this.dataType = data["dataType"];
            this.addressDescription = data["addressDescription"];
            this.stationNo = data["stationNo"];
            this.refAlarmDefinitionKey = data["refAlarmDefinitionKey"];
            this.groupName = data["groupName"];
            this.id = data["id"];
        }
    };
    RefAlarmDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RefAlarmDto();
        result.init(data);
        return result;
    };
    RefAlarmDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alarmMessage"] = this.alarmMessage;
        data["condition1"] = this.condition1;
        data["condition2"] = this.condition2;
        data["operand1"] = this.operand1;
        data["operand2"] = this.operand2;
        data["conditionCombineMethod"] = this.conditionCombineMethod;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["devAlias"] = this.devAlias;
        data["dataType"] = this.dataType;
        data["addressDescription"] = this.addressDescription;
        data["stationNo"] = this.stationNo;
        data["refAlarmDefinitionKey"] = this.refAlarmDefinitionKey;
        data["groupName"] = this.groupName;
        data["id"] = this.id;
        return data;
    };
    return RefAlarmDto;
}());
export { RefAlarmDto };
var TriggerRuleValue = /** @class */ (function () {
    function TriggerRuleValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TriggerRuleValue.prototype.init = function (data) {
        if (data) {
            this.threshold = data["threshold"] ? ThresholdValue.fromJS(data["threshold"]) : undefined;
            this.deviance = data["deviance"] ? DevianceValue.fromJS(data["deviance"]) : undefined;
            this.changeRate = data["changeRate"] ? ChangeRateValue.fromJS(data["changeRate"]) : undefined;
            this.value = data["value"];
        }
    };
    TriggerRuleValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TriggerRuleValue();
        result.init(data);
        return result;
    };
    TriggerRuleValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["threshold"] = this.threshold ? this.threshold.toJSON() : undefined;
        data["deviance"] = this.deviance ? this.deviance.toJSON() : undefined;
        data["changeRate"] = this.changeRate ? this.changeRate.toJSON() : undefined;
        data["value"] = this.value;
        return data;
    };
    return TriggerRuleValue;
}());
export { TriggerRuleValue };
var ThresholdValue = /** @class */ (function () {
    function ThresholdValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThresholdValue.prototype.init = function (data) {
        if (data) {
            this.condition1 = data["condition1"];
            this.operand1 = data["operand1"];
            this.conditionCombine = data["conditionCombine"];
            this.condition2 = data["condition2"];
            this.operand2 = data["operand2"];
        }
    };
    ThresholdValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThresholdValue();
        result.init(data);
        return result;
    };
    ThresholdValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["condition1"] = this.condition1;
        data["operand1"] = this.operand1;
        data["conditionCombine"] = this.conditionCombine;
        data["condition2"] = this.condition2;
        data["operand2"] = this.operand2;
        return data;
    };
    return ThresholdValue;
}());
export { ThresholdValue };
var DevianceValue = /** @class */ (function () {
    function DevianceValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DevianceValue.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.targetValue = data["targetValue"];
        }
    };
    DevianceValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DevianceValue();
        result.init(data);
        return result;
    };
    DevianceValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["targetValue"] = this.targetValue;
        return data;
    };
    return DevianceValue;
}());
export { DevianceValue };
var ChangeRateValue = /** @class */ (function () {
    function ChangeRateValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeRateValue.prototype.init = function (data) {
        if (data) {
            this.changeRate = data["changeRate"];
            this.cycle = data["cycle"];
        }
    };
    ChangeRateValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangeRateValue();
        result.init(data);
        return result;
    };
    ChangeRateValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["changeRate"] = this.changeRate;
        data["cycle"] = this.cycle;
        return data;
    };
    return ChangeRateValue;
}());
export { ChangeRateValue };
var BatchImportAlarmsDto = /** @class */ (function () {
    function BatchImportAlarmsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchImportAlarmsDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.isImportAll = data["isImportAll"];
            if (data["fBoxAlarmIds"] && data["fBoxAlarmIds"].constructor === Array) {
                this.fBoxAlarmIds = [];
                for (var _i = 0, _a = data["fBoxAlarmIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.fBoxAlarmIds.push(item);
                }
            }
            this.enumHandleDuplicateNameRule = data["enumHandleDuplicateNameRule"];
        }
    };
    BatchImportAlarmsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchImportAlarmsDto();
        result.init(data);
        return result;
    };
    BatchImportAlarmsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["isImportAll"] = this.isImportAll;
        if (this.fBoxAlarmIds && this.fBoxAlarmIds.constructor === Array) {
            data["fBoxAlarmIds"] = [];
            for (var _i = 0, _a = this.fBoxAlarmIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["fBoxAlarmIds"].push(item);
            }
        }
        data["enumHandleDuplicateNameRule"] = this.enumHandleDuplicateNameRule;
        return data;
    };
    return BatchImportAlarmsDto;
}());
export { BatchImportAlarmsDto };
var CreateOrUpdateConfigureAlarmDefDto = /** @class */ (function () {
    function CreateOrUpdateConfigureAlarmDefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateConfigureAlarmDefDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.alarmDataSource = data["alarmDataSource"];
            this.alarmSourceId = data["alarmSourceId"];
            this.refAlarmDefinitionKey = data["refAlarmDefinitionKey"];
            this.variableName = data["variableName"];
            this.name = data["name"];
            this.alarmMessage = data["alarmMessage"];
            this.alarmLevel = data["alarmLevel"];
            this.faultCode = data["faultCode"];
            this.configureAlarmGroupId = data["configureAlarmGroupId"];
            this.triggerRuleType = data["triggerRuleType"];
            this.triggerRuleValue = data["triggerRuleValue"] ? TriggerRuleValue.fromJS(data["triggerRuleValue"]) : undefined;
            this.delayTime = data["delayTime"];
            this.deadBand = data["deadBand"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateConfigureAlarmDefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateConfigureAlarmDefDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateConfigureAlarmDefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["alarmDataSource"] = this.alarmDataSource;
        data["alarmSourceId"] = this.alarmSourceId;
        data["refAlarmDefinitionKey"] = this.refAlarmDefinitionKey;
        data["variableName"] = this.variableName;
        data["name"] = this.name;
        data["alarmMessage"] = this.alarmMessage;
        data["alarmLevel"] = this.alarmLevel;
        data["faultCode"] = this.faultCode;
        data["configureAlarmGroupId"] = this.configureAlarmGroupId;
        data["triggerRuleType"] = this.triggerRuleType;
        data["triggerRuleValue"] = this.triggerRuleValue ? this.triggerRuleValue.toJSON() : undefined;
        data["delayTime"] = this.delayTime;
        data["deadBand"] = this.deadBand;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateConfigureAlarmDefDto;
}());
export { CreateOrUpdateConfigureAlarmDefDto };
var BatchModifyAlarmLevelDto = /** @class */ (function () {
    function BatchModifyAlarmLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchModifyAlarmLevelDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (var _i = 0, _a = data["ids"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.ids.push(item);
                }
            }
            this.alarmLevel = data["alarmLevel"];
            this.groupId = data["groupId"];
        }
    };
    BatchModifyAlarmLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchModifyAlarmLevelDto();
        result.init(data);
        return result;
    };
    BatchModifyAlarmLevelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (var _i = 0, _a = this.ids; _i < _a.length; _i++) {
                var item = _a[_i];
                data["ids"].push(item);
            }
        }
        data["alarmLevel"] = this.alarmLevel;
        data["groupId"] = this.groupId;
        return data;
    };
    return BatchModifyAlarmLevelDto;
}());
export { BatchModifyAlarmLevelDto };
var AlarmToEditDto = /** @class */ (function () {
    function AlarmToEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AlarmToEditDto.prototype.init = function (data) {
        if (data) {
            this.alarmDataSource = data["alarmDataSource"];
            this.alarmSourceId = data["alarmSourceId"];
            this.variableName = data["variableName"];
            this.variableDataType = data["variableDataType"];
            this.name = data["name"];
            this.alarmMessage = data["alarmMessage"];
            this.alarmLevel = data["alarmLevel"];
            this.faultCode = data["faultCode"];
            this.configureAlarmGroupId = data["configureAlarmGroupId"];
            this.triggerRuleType = data["triggerRuleType"];
            this.triggerRuleValue = data["triggerRuleValue"] ? TriggerRuleValue.fromJS(data["triggerRuleValue"]) : undefined;
            this.delayTime = data["delayTime"];
            this.deadBand = data["deadBand"];
            this.refAlarmDto = data["refAlarmDto"] ? RefAlarmDto.fromJS(data["refAlarmDto"]) : undefined;
            if (data["canSelectRefAlarms"] && data["canSelectRefAlarms"].constructor === Array) {
                this.canSelectRefAlarms = [];
                for (var _i = 0, _a = data["canSelectRefAlarms"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.canSelectRefAlarms.push(RefAlarmDto.fromJS(item));
                }
            }
        }
    };
    AlarmToEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AlarmToEditDto();
        result.init(data);
        return result;
    };
    AlarmToEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["alarmDataSource"] = this.alarmDataSource;
        data["alarmSourceId"] = this.alarmSourceId;
        data["variableName"] = this.variableName;
        data["variableDataType"] = this.variableDataType;
        data["name"] = this.name;
        data["alarmMessage"] = this.alarmMessage;
        data["alarmLevel"] = this.alarmLevel;
        data["faultCode"] = this.faultCode;
        data["configureAlarmGroupId"] = this.configureAlarmGroupId;
        data["triggerRuleType"] = this.triggerRuleType;
        data["triggerRuleValue"] = this.triggerRuleValue ? this.triggerRuleValue.toJSON() : undefined;
        data["delayTime"] = this.delayTime;
        data["deadBand"] = this.deadBand;
        data["refAlarmDto"] = this.refAlarmDto ? this.refAlarmDto.toJSON() : undefined;
        if (this.canSelectRefAlarms && this.canSelectRefAlarms.constructor === Array) {
            data["canSelectRefAlarms"] = [];
            for (var _i = 0, _a = this.canSelectRefAlarms; _i < _a.length; _i++) {
                var item = _a[_i];
                data["canSelectRefAlarms"].push(item.toJSON());
            }
        }
        return data;
    };
    return AlarmToEditDto;
}());
export { AlarmToEditDto };
var PagedResultDtoOfAuditLogListDto = /** @class */ (function () {
    function PagedResultDtoOfAuditLogListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfAuditLogListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(AuditLogListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfAuditLogListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfAuditLogListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfAuditLogListDto;
}());
export { PagedResultDtoOfAuditLogListDto };
var AuditLogListDto = /** @class */ (function () {
    function AuditLogListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuditLogListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    };
    AuditLogListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuditLogListDto();
        result.init(data);
        return result;
    };
    AuditLogListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    };
    return AuditLogListDto;
}());
export { AuditLogListDto };
var FileDto = /** @class */ (function () {
    function FileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FileDto.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
            this.errorMessage = data["errorMessage"];
        }
    };
    FileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FileDto();
        result.init(data);
        return result;
    };
    FileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return FileDto;
}());
export { FileDto };
var NameValueDto = /** @class */ (function () {
    function NameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueDto();
        result.init(data);
        return result;
    };
    NameValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueDto;
}());
export { NameValueDto };
var PagedResultDtoOfEntityChangeListDto = /** @class */ (function () {
    function PagedResultDtoOfEntityChangeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfEntityChangeListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EntityChangeListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfEntityChangeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfEntityChangeListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfEntityChangeListDto;
}());
export { PagedResultDtoOfEntityChangeListDto };
var EntityChangeListDto = /** @class */ (function () {
    function EntityChangeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityChangeListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.changeTime = data["changeTime"] ? moment(data["changeTime"].toString()) : undefined;
            this.entityTypeFullName = data["entityTypeFullName"];
            this.changeType = data["changeType"];
            this.changeTypeName = data["changeTypeName"];
            this.entityChangeSetId = data["entityChangeSetId"];
            this.id = data["id"];
        }
    };
    EntityChangeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityChangeListDto();
        result.init(data);
        return result;
    };
    EntityChangeListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    };
    return EntityChangeListDto;
}());
export { EntityChangeListDto };
var EntityPropertyChangeDto = /** @class */ (function () {
    function EntityPropertyChangeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityPropertyChangeDto.prototype.init = function (data) {
        if (data) {
            this.entityChangeId = data["entityChangeId"];
            this.newValue = data["newValue"];
            this.originalValue = data["originalValue"];
            this.propertyName = data["propertyName"];
            this.propertyTypeFullName = data["propertyTypeFullName"];
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    };
    EntityPropertyChangeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    };
    EntityPropertyChangeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    };
    return EntityPropertyChangeDto;
}());
export { EntityPropertyChangeDto };
var BaiduSpeechApiTokenInfo = /** @class */ (function () {
    function BaiduSpeechApiTokenInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaiduSpeechApiTokenInfo.prototype.init = function (data) {
        if (data) {
            this.token = data["token"];
            this.expireTime = data["expireTime"];
        }
    };
    BaiduSpeechApiTokenInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaiduSpeechApiTokenInfo();
        result.init(data);
        return result;
    };
    BaiduSpeechApiTokenInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expireTime"] = this.expireTime;
        return data;
    };
    return BaiduSpeechApiTokenInfo;
}());
export { BaiduSpeechApiTokenInfo };
var BatchControlListDto = /** @class */ (function () {
    function BatchControlListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchControlListDto.prototype.init = function (data) {
        if (data) {
            this.uid = data["uid"];
            this.name = data["name"];
            this.dataType = data["dataType"];
            this.remark = data["remark"];
        }
    };
    BatchControlListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchControlListDto();
        result.init(data);
        return result;
    };
    BatchControlListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["remark"] = this.remark;
        return data;
    };
    return BatchControlListDto;
}());
export { BatchControlListDto };
var BatchControlLogListDto = /** @class */ (function () {
    function BatchControlLogListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchControlLogListDto.prototype.init = function (data) {
        if (data) {
            this.uid = data["uid"];
            this.status = data["status"];
            this.statusStr = data["statusStr"];
            this.boxNo = data["boxNo"];
            this.groupAndVariableName = data["groupAndVariableName"];
            this.value = data["value"];
            this.lastWriteTime = data["lastWriteTime"] ? moment(data["lastWriteTime"].toString()) : undefined;
        }
    };
    BatchControlLogListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchControlLogListDto();
        result.init(data);
        return result;
    };
    BatchControlLogListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["boxNo"] = this.boxNo;
        data["groupAndVariableName"] = this.groupAndVariableName;
        data["value"] = this.value;
        data["lastWriteTime"] = this.lastWriteTime ? this.lastWriteTime.toISOString() : undefined;
        return data;
    };
    return BatchControlLogListDto;
}());
export { BatchControlLogListDto };
var BatchWriteDto = /** @class */ (function () {
    function BatchWriteDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchWriteDto.prototype.init = function (data) {
        if (data) {
            this.uid = data["uid"];
            this.name = data["name"];
            this.doubleValue = data["doubleValue"];
            this.strValue = data["strValue"];
        }
    };
    BatchWriteDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchWriteDto();
        result.init(data);
        return result;
    };
    BatchWriteDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["doubleValue"] = this.doubleValue;
        data["strValue"] = this.strValue;
        return data;
    };
    return BatchWriteDto;
}());
export { BatchWriteDto };
var ListResultDtoOfCacheDto = /** @class */ (function () {
    function ListResultDtoOfCacheDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfCacheDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CacheDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfCacheDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfCacheDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfCacheDto;
}());
export { ListResultDtoOfCacheDto };
var CacheDto = /** @class */ (function () {
    function CacheDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CacheDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    CacheDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CacheDto();
        result.init(data);
        return result;
    };
    CacheDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return CacheDto;
}());
export { CacheDto };
var EntityDtoOfString = /** @class */ (function () {
    function EntityDtoOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfString.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfString();
        result.init(data);
        return result;
    };
    EntityDtoOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfString;
}());
export { EntityDtoOfString };
var GetUserChatFriendsWithSettingsOutput = /** @class */ (function () {
    function GetUserChatFriendsWithSettingsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserChatFriendsWithSettingsOutput.prototype.init = function (data) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : undefined;
            if (data["friends"] && data["friends"].constructor === Array) {
                this.friends = [];
                for (var _i = 0, _a = data["friends"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.friends.push(FriendDto.fromJS(item));
                }
            }
        }
    };
    GetUserChatFriendsWithSettingsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    };
    GetUserChatFriendsWithSettingsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : undefined;
        if (this.friends && this.friends.constructor === Array) {
            data["friends"] = [];
            for (var _i = 0, _a = this.friends; _i < _a.length; _i++) {
                var item = _a[_i];
                data["friends"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetUserChatFriendsWithSettingsOutput;
}());
export { GetUserChatFriendsWithSettingsOutput };
var FriendDto = /** @class */ (function () {
    function FriendDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FriendDto.prototype.init = function (data) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    };
    FriendDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FriendDto();
        result.init(data);
        return result;
    };
    FriendDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    };
    return FriendDto;
}());
export { FriendDto };
var ListResultDtoOfChatMessageDto = /** @class */ (function () {
    function ListResultDtoOfChatMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfChatMessageDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ChatMessageDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfChatMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfChatMessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfChatMessageDto;
}());
export { ListResultDtoOfChatMessageDto };
var ChatMessageDto = /** @class */ (function () {
    function ChatMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChatMessageDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    };
    ChatMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChatMessageDto();
        result.init(data);
        return result;
    };
    ChatMessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    };
    return ChatMessageDto;
}());
export { ChatMessageDto };
var MarkAllUnreadMessagesOfUserAsReadInput = /** @class */ (function () {
    function MarkAllUnreadMessagesOfUserAsReadInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarkAllUnreadMessagesOfUserAsReadInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    MarkAllUnreadMessagesOfUserAsReadInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    };
    MarkAllUnreadMessagesOfUserAsReadInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return MarkAllUnreadMessagesOfUserAsReadInput;
}());
export { MarkAllUnreadMessagesOfUserAsReadInput };
var ListResultDtoOfSubscribableEditionComboboxItemDto = /** @class */ (function () {
    function ListResultDtoOfSubscribableEditionComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfSubscribableEditionComboboxItemDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfSubscribableEditionComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfSubscribableEditionComboboxItemDto;
}());
export { ListResultDtoOfSubscribableEditionComboboxItemDto };
var SubscribableEditionComboboxItemDto = /** @class */ (function () {
    function SubscribableEditionComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscribableEditionComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    };
    SubscribableEditionComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    };
    SubscribableEditionComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    };
    return SubscribableEditionComboboxItemDto;
}());
export { SubscribableEditionComboboxItemDto };
var FindUsersInput = /** @class */ (function () {
    function FindUsersInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindUsersInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    };
    FindUsersInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindUsersInput();
        result.init(data);
        return result;
    };
    FindUsersInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    };
    return FindUsersInput;
}());
export { FindUsersInput };
var PagedResultDtoOfNameValueDto = /** @class */ (function () {
    function PagedResultDtoOfNameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfNameValueDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfNameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfNameValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfNameValueDto;
}());
export { PagedResultDtoOfNameValueDto };
var GetDefaultEditionNameOutput = /** @class */ (function () {
    function GetDefaultEditionNameOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDefaultEditionNameOutput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    GetDefaultEditionNameOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    };
    GetDefaultEditionNameOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return GetDefaultEditionNameOutput;
}());
export { GetDefaultEditionNameOutput };
var UpdateConfigureDto = /** @class */ (function () {
    function UpdateConfigureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateConfigureDto.prototype.init = function (data) {
        if (data) {
            if (data["configureViews"] && data["configureViews"].constructor === Array) {
                this.configureViews = [];
                for (var _i = 0, _a = data["configureViews"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.configureViews.push(UpdateConfigureViewDto.fromJS(item));
                }
            }
        }
    };
    UpdateConfigureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateConfigureDto();
        result.init(data);
        return result;
    };
    UpdateConfigureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.configureViews && this.configureViews.constructor === Array) {
            data["configureViews"] = [];
            for (var _i = 0, _a = this.configureViews; _i < _a.length; _i++) {
                var item = _a[_i];
                data["configureViews"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateConfigureDto;
}());
export { UpdateConfigureDto };
var UpdateConfigureViewDto = /** @class */ (function () {
    function UpdateConfigureViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateConfigureViewDto.prototype.init = function (data) {
        if (data) {
            this.configure = data["configure"];
            this.id = data["id"];
        }
    };
    UpdateConfigureViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateConfigureViewDto();
        result.init(data);
        return result;
    };
    UpdateConfigureViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configure"] = this.configure;
        data["id"] = this.id;
        return data;
    };
    return UpdateConfigureViewDto;
}());
export { UpdateConfigureViewDto };
var EntityDto = /** @class */ (function () {
    function EntityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDto();
        result.init(data);
        return result;
    };
    EntityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDto;
}());
export { EntityDto };
var GetBoxTypeNameDto = /** @class */ (function () {
    function GetBoxTypeNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBoxTypeNameDto.prototype.init = function (data) {
        if (data) {
            this.boxTypeName = data["boxTypeName"];
            this.errorMessage = data["errorMessage"];
        }
    };
    GetBoxTypeNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBoxTypeNameDto();
        result.init(data);
        return result;
    };
    GetBoxTypeNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["boxTypeName"] = this.boxTypeName;
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return GetBoxTypeNameDto;
}());
export { GetBoxTypeNameDto };
var ListResultDtoOfConfigureViewListDto = /** @class */ (function () {
    function ListResultDtoOfConfigureViewListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfConfigureViewListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ConfigureViewListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfConfigureViewListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfConfigureViewListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfConfigureViewListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfConfigureViewListDto;
}());
export { ListResultDtoOfConfigureViewListDto };
var ConfigureViewListDto = /** @class */ (function () {
    function ConfigureViewListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureViewListDto.prototype.init = function (data) {
        if (data) {
            this.index = data["index"];
            this.type = data["type"];
            this.width = data["width"];
            this.height = data["height"];
            this.configure = data["configure"];
            this.code = data["code"];
            this.id = data["id"];
        }
    };
    ConfigureViewListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureViewListDto();
        result.init(data);
        return result;
    };
    ConfigureViewListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["type"] = this.type;
        data["width"] = this.width;
        data["height"] = this.height;
        data["configure"] = this.configure;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    };
    return ConfigureViewListDto;
}());
export { ConfigureViewListDto };
var MainViewIndexDto = /** @class */ (function () {
    function MainViewIndexDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MainViewIndexDto.prototype.init = function (data) {
        if (data) {
            this.mainViewIndex = data["mainViewIndex"];
            this.mobileMainViewIndex = data["mobileMainViewIndex"];
        }
    };
    MainViewIndexDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MainViewIndexDto();
        result.init(data);
        return result;
    };
    MainViewIndexDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mainViewIndex"] = this.mainViewIndex;
        data["mobileMainViewIndex"] = this.mobileMainViewIndex;
        return data;
    };
    return MainViewIndexDto;
}());
export { MainViewIndexDto };
var SaveElementPasswordDto = /** @class */ (function () {
    function SaveElementPasswordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SaveElementPasswordDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.elementPassword = data["elementPassword"];
        }
    };
    SaveElementPasswordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SaveElementPasswordDto();
        result.init(data);
        return result;
    };
    SaveElementPasswordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["elementPassword"] = this.elementPassword;
        return data;
    };
    return SaveElementPasswordDto;
}());
export { SaveElementPasswordDto };
var UpdateDataSourcePlcInfosDto = /** @class */ (function () {
    function UpdateDataSourcePlcInfosDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateDataSourcePlcInfosDto.prototype.init = function (data) {
        if (data) {
            this.refDataSourceKey = data["refDataSourceKey"];
            if (data["plcInfos"] && data["plcInfos"].constructor === Array) {
                this.plcInfos = [];
                for (var _i = 0, _a = data["plcInfos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.plcInfos.push(PlcInfoDto.fromJS(item));
                }
            }
        }
    };
    UpdateDataSourcePlcInfosDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateDataSourcePlcInfosDto();
        result.init(data);
        return result;
    };
    UpdateDataSourcePlcInfosDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["refDataSourceKey"] = this.refDataSourceKey;
        if (this.plcInfos && this.plcInfos.constructor === Array) {
            data["plcInfos"] = [];
            for (var _i = 0, _a = this.plcInfos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["plcInfos"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateDataSourcePlcInfosDto;
}());
export { UpdateDataSourcePlcInfosDto };
var PlcInfoDto = /** @class */ (function () {
    function PlcInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PlcInfoDto.prototype.init = function (data) {
        if (data) {
            this.plcId = data["plcId"];
            this.plcName = data["plcName"];
            this.alias = data["alias"];
            this.type = data["type"];
            this.advanced = data["advanced"] ? PlcAdvancedSettings.fromJS(data["advanced"]) : undefined;
            this.portNo = data["portNo"];
            this.plcDongleFlag = data["plcDongleFlag"];
            this.interface = data["interface"];
            this.baudRate = data["baudRate"];
            this.dataBits = data["dataBits"];
            this.stopBits = data["stopBits"];
            this.parityType = data["parityType"];
            this.class = data["class"];
            this.ip = data["ip"];
            this.port = data["port"];
            this.enableBroadcast = data["enableBroadcast"];
            this.broadcastStationNo = data["broadcastStationNo"];
            this.defaultStationNo = data["defaultStationNo"];
            this.slaveNo = data["slaveNo"];
        }
    };
    PlcInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PlcInfoDto();
        result.init(data);
        return result;
    };
    PlcInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["plcId"] = this.plcId;
        data["plcName"] = this.plcName;
        data["alias"] = this.alias;
        data["type"] = this.type;
        data["advanced"] = this.advanced ? this.advanced.toJSON() : undefined;
        data["portNo"] = this.portNo;
        data["plcDongleFlag"] = this.plcDongleFlag;
        data["interface"] = this.interface;
        data["baudRate"] = this.baudRate;
        data["dataBits"] = this.dataBits;
        data["stopBits"] = this.stopBits;
        data["parityType"] = this.parityType;
        data["class"] = this.class;
        data["ip"] = this.ip;
        data["port"] = this.port;
        data["enableBroadcast"] = this.enableBroadcast;
        data["broadcastStationNo"] = this.broadcastStationNo;
        data["defaultStationNo"] = this.defaultStationNo;
        data["slaveNo"] = this.slaveNo;
        return data;
    };
    return PlcInfoDto;
}());
export { PlcInfoDto };
var PlcAdvancedSettings = /** @class */ (function () {
    function PlcAdvancedSettings(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PlcAdvancedSettings.prototype.init = function (data) {
        if (data) {
            this.plcResponseTimeout = data["plcResponseTimeout"];
            this.protocolTimeout1 = data["protocolTimeout1"];
            this.protocolTimeout2 = data["protocolTimeout2"];
            this.maxPacketsWordReg = data["maxPacketsWordReg"];
            this.maxPacketsBitReg = data["maxPacketsBitReg"];
            this.assembleIntervalWordReg = data["assembleIntervalWordReg"];
            this.assembleIntervalBitReg = data["assembleIntervalBitReg"];
            this.protocolInterval = data["protocolInterval"];
            this.byteOrder16 = data["byteOrder16"];
            this.byteOrder32 = data["byteOrder32"];
            this.byteOrderFloat = data["byteOrderFloat"];
            this.retryType = data["retryType"];
            this.alarmInfDispTms = data["alarmInfDispTms"];
            this.errMsgDispTime = data["errMsgDispTime"];
            this.connectionType = data["connectionType"];
            this.cpuBase = data["cpuBase"];
            this.cpuSlot = data["cpuSlot"];
            this.ltsap = data["ltsap"];
            this.rtsap = data["rtsap"];
            this.retryCount = data["retryCount"];
        }
    };
    PlcAdvancedSettings.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PlcAdvancedSettings();
        result.init(data);
        return result;
    };
    PlcAdvancedSettings.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["plcResponseTimeout"] = this.plcResponseTimeout;
        data["protocolTimeout1"] = this.protocolTimeout1;
        data["protocolTimeout2"] = this.protocolTimeout2;
        data["maxPacketsWordReg"] = this.maxPacketsWordReg;
        data["maxPacketsBitReg"] = this.maxPacketsBitReg;
        data["assembleIntervalWordReg"] = this.assembleIntervalWordReg;
        data["assembleIntervalBitReg"] = this.assembleIntervalBitReg;
        data["protocolInterval"] = this.protocolInterval;
        data["byteOrder16"] = this.byteOrder16;
        data["byteOrder32"] = this.byteOrder32;
        data["byteOrderFloat"] = this.byteOrderFloat;
        data["retryType"] = this.retryType;
        data["alarmInfDispTms"] = this.alarmInfDispTms;
        data["errMsgDispTime"] = this.errMsgDispTime;
        data["connectionType"] = this.connectionType;
        data["cpuBase"] = this.cpuBase;
        data["cpuSlot"] = this.cpuSlot;
        data["ltsap"] = this.ltsap;
        data["rtsap"] = this.rtsap;
        data["retryCount"] = this.retryCount;
        return data;
    };
    return PlcAdvancedSettings;
}());
export { PlcAdvancedSettings };
var ConfigureDashboardDto = /** @class */ (function () {
    function ConfigureDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureDashboardDto.prototype.init = function (data) {
        if (data) {
            this.stringId = data["stringId"];
            this.name = data["name"];
            this.configureId = data["configureId"];
            this.tag = data["tag"];
            this.order = data["order"];
            if (data["contentItems"] && data["contentItems"].constructor === Array) {
                this.contentItems = [];
                for (var _i = 0, _a = data["contentItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contentItems.push(ConfigureDashboardContentDto.fromJS(item));
                }
            }
        }
    };
    ConfigureDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureDashboardDto();
        result.init(data);
        return result;
    };
    ConfigureDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["stringId"] = this.stringId;
        data["name"] = this.name;
        data["configureId"] = this.configureId;
        data["tag"] = this.tag;
        data["order"] = this.order;
        if (this.contentItems && this.contentItems.constructor === Array) {
            data["contentItems"] = [];
            for (var _i = 0, _a = this.contentItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contentItems"].push(item.toJSON());
            }
        }
        return data;
    };
    return ConfigureDashboardDto;
}());
export { ConfigureDashboardDto };
var ConfigureDashboardContentDto = /** @class */ (function () {
    function ConfigureDashboardContentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureDashboardContentDto.prototype.init = function (data) {
        if (data) {
            this.dashboardType = data["dashboardType"];
            this.id = data["id"];
            this.title = data["title"];
            this.config = data["config"] ? DeviceDashboardContentConfig.fromJS(data["config"]) : undefined;
            if (data["props"]) {
                this.props = {};
                for (var key in data["props"]) {
                    if (data["props"].hasOwnProperty(key))
                        this.props[key] = data["props"][key];
                }
            }
        }
    };
    ConfigureDashboardContentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureDashboardContentDto();
        result.init(data);
        return result;
    };
    ConfigureDashboardContentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardType"] = this.dashboardType;
        data["id"] = this.id;
        data["title"] = this.title;
        data["config"] = this.config ? this.config.toJSON() : undefined;
        if (this.props) {
            data["props"] = {};
            for (var key in this.props) {
                if (this.props.hasOwnProperty(key))
                    data["props"][key] = this.props[key];
            }
        }
        return data;
    };
    return ConfigureDashboardContentDto;
}());
export { ConfigureDashboardContentDto };
var DeviceDashboardContentConfig = /** @class */ (function () {
    function DeviceDashboardContentConfig(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceDashboardContentConfig.prototype.init = function (data) {
        if (data) {
            this.dragHandle = data["dragHandle"];
            this.col = data["col"];
            this.row = data["row"];
            this.sizex = data["sizex"];
            this.sizey = data["sizey"];
            this.minCols = data["minCols"];
            this.minRows = data["minRows"];
            this.maxCols = data["maxCols"];
            this.payload = data["payload"];
        }
    };
    DeviceDashboardContentConfig.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceDashboardContentConfig();
        result.init(data);
        return result;
    };
    DeviceDashboardContentConfig.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dragHandle"] = this.dragHandle;
        data["col"] = this.col;
        data["row"] = this.row;
        data["sizex"] = this.sizex;
        data["sizey"] = this.sizey;
        data["minCols"] = this.minCols;
        data["minRows"] = this.minRows;
        data["maxCols"] = this.maxCols;
        data["payload"] = this.payload;
        return data;
    };
    return DeviceDashboardContentConfig;
}());
export { DeviceDashboardContentConfig };
var SaveConfigureDashboardNameDto = /** @class */ (function () {
    function SaveConfigureDashboardNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SaveConfigureDashboardNameDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.configureId = data["configureId"];
            this.name = data["name"];
        }
    };
    SaveConfigureDashboardNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SaveConfigureDashboardNameDto();
        result.init(data);
        return result;
    };
    SaveConfigureDashboardNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        return data;
    };
    return SaveConfigureDashboardNameDto;
}());
export { SaveConfigureDashboardNameDto };
var SaveConfigureDashboardResultDto = /** @class */ (function () {
    function SaveConfigureDashboardResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SaveConfigureDashboardResultDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    };
    SaveConfigureDashboardResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SaveConfigureDashboardResultDto();
        result.init(data);
        return result;
    };
    SaveConfigureDashboardResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return SaveConfigureDashboardResultDto;
}());
export { SaveConfigureDashboardResultDto };
var SaveConfigureDashboardContentDto = /** @class */ (function () {
    function SaveConfigureDashboardContentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SaveConfigureDashboardContentDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (data["content"] && data["content"].constructor === Array) {
                this.content = [];
                for (var _i = 0, _a = data["content"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.content.push(ConfigureDashboardContentDto.fromJS(item));
                }
            }
        }
    };
    SaveConfigureDashboardContentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SaveConfigureDashboardContentDto();
        result.init(data);
        return result;
    };
    SaveConfigureDashboardContentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.content && this.content.constructor === Array) {
            data["content"] = [];
            for (var _i = 0, _a = this.content; _i < _a.length; _i++) {
                var item = _a[_i];
                data["content"].push(item.toJSON());
            }
        }
        return data;
    };
    return SaveConfigureDashboardContentDto;
}());
export { SaveConfigureDashboardContentDto };
var SaveDashboardItemDto = /** @class */ (function () {
    function SaveDashboardItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SaveDashboardItemDto.prototype.init = function (data) {
        if (data) {
            this.dashboardId = data["dashboardId"];
            this.content = data["content"] ? ConfigureDashboardContentDto.fromJS(data["content"]) : undefined;
        }
    };
    SaveDashboardItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SaveDashboardItemDto();
        result.init(data);
        return result;
    };
    SaveDashboardItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardId"] = this.dashboardId;
        data["content"] = this.content ? this.content.toJSON() : undefined;
        return data;
    };
    return SaveDashboardItemDto;
}());
export { SaveDashboardItemDto };
var PagedResultDtoOfEventListDto = /** @class */ (function () {
    function PagedResultDtoOfEventListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfEventListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EventListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfEventListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfEventListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfEventListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfEventListDto;
}());
export { PagedResultDtoOfEventListDto };
var EventListDto = /** @class */ (function () {
    function EventListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.eventMessage = data["eventMessage"];
            this.eventSourceId = data["eventSourceId"];
            this.variableName = data["variableName"];
            this.variableDataType = data["variableDataType"];
            this.triggerRuleType = data["triggerRuleType"];
            this.triggerRuleTypeStr = data["triggerRuleTypeStr"];
            this.triggerRuleValue = data["triggerRuleValue"] ? TriggerRuleValue.fromJS(data["triggerRuleValue"]) : undefined;
            this.configureEventGroupId = data["configureEventGroupId"];
            this.groupName = data["groupName"];
            this.id = data["id"];
        }
    };
    EventListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventListDto();
        result.init(data);
        return result;
    };
    EventListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["eventMessage"] = this.eventMessage;
        data["eventSourceId"] = this.eventSourceId;
        data["variableName"] = this.variableName;
        data["variableDataType"] = this.variableDataType;
        data["triggerRuleType"] = this.triggerRuleType;
        data["triggerRuleTypeStr"] = this.triggerRuleTypeStr;
        data["triggerRuleValue"] = this.triggerRuleValue ? this.triggerRuleValue.toJSON() : undefined;
        data["configureEventGroupId"] = this.configureEventGroupId;
        data["groupName"] = this.groupName;
        data["id"] = this.id;
        return data;
    };
    return EventListDto;
}());
export { EventListDto };
var EventForEditDto = /** @class */ (function () {
    function EventForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventForEditDto.prototype.init = function (data) {
        if (data) {
            this.eventSourceId = data["eventSourceId"];
            this.variableName = data["variableName"];
            this.variableDataType = data["variableDataType"];
            this.name = data["name"];
            this.eventMessage = data["eventMessage"];
            this.configureEventGroupId = data["configureEventGroupId"];
            this.triggerRuleType = data["triggerRuleType"];
            this.triggerRuleValue = data["triggerRuleValue"] ? TriggerRuleValue.fromJS(data["triggerRuleValue"]) : undefined;
            this.delayTime = data["delayTime"];
            this.deadBand = data["deadBand"];
            this.isProduceMessages = data["isProduceMessages"];
        }
    };
    EventForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventForEditDto();
        result.init(data);
        return result;
    };
    EventForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventSourceId"] = this.eventSourceId;
        data["variableName"] = this.variableName;
        data["variableDataType"] = this.variableDataType;
        data["name"] = this.name;
        data["eventMessage"] = this.eventMessage;
        data["configureEventGroupId"] = this.configureEventGroupId;
        data["triggerRuleType"] = this.triggerRuleType;
        data["triggerRuleValue"] = this.triggerRuleValue ? this.triggerRuleValue.toJSON() : undefined;
        data["delayTime"] = this.delayTime;
        data["deadBand"] = this.deadBand;
        data["isProduceMessages"] = this.isProduceMessages;
        return data;
    };
    return EventForEditDto;
}());
export { EventForEditDto };
var CreateOrUpdateEventDto = /** @class */ (function () {
    function CreateOrUpdateEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateEventDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.eventSourceId = data["eventSourceId"];
            this.variableName = data["variableName"];
            this.name = data["name"];
            this.eventMessage = data["eventMessage"];
            this.configureEventGroupId = data["configureEventGroupId"];
            this.triggerRuleType = data["triggerRuleType"];
            this.triggerRuleValue = data["triggerRuleValue"] ? TriggerRuleValue.fromJS(data["triggerRuleValue"]) : undefined;
            this.delayTime = data["delayTime"];
            this.deadBand = data["deadBand"];
            this.isProduceMessages = data["isProduceMessages"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateEventDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateEventDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["eventSourceId"] = this.eventSourceId;
        data["variableName"] = this.variableName;
        data["name"] = this.name;
        data["eventMessage"] = this.eventMessage;
        data["configureEventGroupId"] = this.configureEventGroupId;
        data["triggerRuleType"] = this.triggerRuleType;
        data["triggerRuleValue"] = this.triggerRuleValue ? this.triggerRuleValue.toJSON() : undefined;
        data["delayTime"] = this.delayTime;
        data["deadBand"] = this.deadBand;
        data["isProduceMessages"] = this.isProduceMessages;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateEventDto;
}());
export { CreateOrUpdateEventDto };
var BatchEditEventDto = /** @class */ (function () {
    function BatchEditEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchEditEventDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.groupId = data["groupId"];
            if (data["eventIds"] && data["eventIds"].constructor === Array) {
                this.eventIds = [];
                for (var _i = 0, _a = data["eventIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventIds.push(item);
                }
            }
        }
    };
    BatchEditEventDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchEditEventDto();
        result.init(data);
        return result;
    };
    BatchEditEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["groupId"] = this.groupId;
        if (this.eventIds && this.eventIds.constructor === Array) {
            data["eventIds"] = [];
            for (var _i = 0, _a = this.eventIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventIds"].push(item);
            }
        }
        return data;
    };
    return BatchEditEventDto;
}());
export { BatchEditEventDto };
var BatchDeleteEventDto = /** @class */ (function () {
    function BatchDeleteEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchDeleteEventDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            if (data["eventIds"] && data["eventIds"].constructor === Array) {
                this.eventIds = [];
                for (var _i = 0, _a = data["eventIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventIds.push(item);
                }
            }
        }
    };
    BatchDeleteEventDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchDeleteEventDto();
        result.init(data);
        return result;
    };
    BatchDeleteEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        if (this.eventIds && this.eventIds.constructor === Array) {
            data["eventIds"] = [];
            for (var _i = 0, _a = this.eventIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventIds"].push(item);
            }
        }
        return data;
    };
    return BatchDeleteEventDto;
}());
export { BatchDeleteEventDto };
var EventGroupListDto = /** @class */ (function () {
    function EventGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventGroupListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    EventGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventGroupListDto();
        result.init(data);
        return result;
    };
    EventGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return EventGroupListDto;
}());
export { EventGroupListDto };
var CreateOrUpdateEventGroupDto = /** @class */ (function () {
    function CreateOrUpdateEventGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateEventGroupDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateEventGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateEventGroupDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateEventGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateEventGroupDto;
}());
export { CreateOrUpdateEventGroupDto };
var IListResultOfConfigureGraphDto = /** @class */ (function () {
    function IListResultOfConfigureGraphDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfConfigureGraphDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ConfigureGraphDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfConfigureGraphDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfConfigureGraphDto();
        result.init(data);
        return result;
    };
    IListResultOfConfigureGraphDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfConfigureGraphDto;
}());
export { IListResultOfConfigureGraphDto };
var ConfigureGraphDto = /** @class */ (function () {
    function ConfigureGraphDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureGraphDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.thumbUrl = data["thumbUrl"];
            this.id = data["id"];
        }
    };
    ConfigureGraphDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureGraphDto();
        result.init(data);
        return result;
    };
    ConfigureGraphDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["thumbUrl"] = this.thumbUrl;
        data["id"] = this.id;
        return data;
    };
    return ConfigureGraphDto;
}());
export { ConfigureGraphDto };
var IListResultOfConfigureGraphStateDto = /** @class */ (function () {
    function IListResultOfConfigureGraphStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfConfigureGraphStateDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ConfigureGraphStateDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfConfigureGraphStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfConfigureGraphStateDto();
        result.init(data);
        return result;
    };
    IListResultOfConfigureGraphStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfConfigureGraphStateDto;
}());
export { IListResultOfConfigureGraphStateDto };
var ConfigureGraphStateDto = /** @class */ (function () {
    function ConfigureGraphStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureGraphStateDto.prototype.init = function (data) {
        if (data) {
            this.index = data["index"];
            this.url = data["url"];
            this.fileId = data["fileId"];
            this.type = data["type"];
            this.canChangeFill = data["canChangeFill"];
            this.canChangeBorder = data["canChangeBorder"];
            this.id = data["id"];
        }
    };
    ConfigureGraphStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureGraphStateDto();
        result.init(data);
        return result;
    };
    ConfigureGraphStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["url"] = this.url;
        data["fileId"] = this.fileId;
        data["type"] = this.type;
        data["canChangeFill"] = this.canChangeFill;
        data["canChangeBorder"] = this.canChangeBorder;
        data["id"] = this.id;
        return data;
    };
    return ConfigureGraphStateDto;
}());
export { ConfigureGraphStateDto };
var ConfigureGraphEditDto = /** @class */ (function () {
    function ConfigureGraphEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureGraphEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.configureId = data["configureId"];
            if (data["states"] && data["states"].constructor === Array) {
                this.states = [];
                for (var _i = 0, _a = data["states"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.states.push(ConfigureGraphStateEditDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ConfigureGraphEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureGraphEditDto();
        result.init(data);
        return result;
    };
    ConfigureGraphEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["configureId"] = this.configureId;
        if (this.states && this.states.constructor === Array) {
            data["states"] = [];
            for (var _i = 0, _a = this.states; _i < _a.length; _i++) {
                var item = _a[_i];
                data["states"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ConfigureGraphEditDto;
}());
export { ConfigureGraphEditDto };
var ConfigureGraphStateEditDto = /** @class */ (function () {
    function ConfigureGraphStateEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureGraphStateEditDto.prototype.init = function (data) {
        if (data) {
            this.index = data["index"];
            this.url = data["url"];
            this.fileId = data["fileId"];
            this.type = data["type"];
            this.canChangeFill = data["canChangeFill"];
            this.canChangeBorder = data["canChangeBorder"];
            this.tempFileId = data["tempFileId"];
            this.id = data["id"];
        }
    };
    ConfigureGraphStateEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureGraphStateEditDto();
        result.init(data);
        return result;
    };
    ConfigureGraphStateEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["url"] = this.url;
        data["fileId"] = this.fileId;
        data["type"] = this.type;
        data["canChangeFill"] = this.canChangeFill;
        data["canChangeBorder"] = this.canChangeBorder;
        data["tempFileId"] = this.tempFileId;
        data["id"] = this.id;
        return data;
    };
    return ConfigureGraphStateEditDto;
}());
export { ConfigureGraphStateEditDto };
var GraphStateUrlDto = /** @class */ (function () {
    function GraphStateUrlDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GraphStateUrlDto.prototype.init = function (data) {
        if (data) {
            this.url = data["url"];
        }
    };
    GraphStateUrlDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GraphStateUrlDto();
        result.init(data);
        return result;
    };
    GraphStateUrlDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    };
    return GraphStateUrlDto;
}());
export { GraphStateUrlDto };
var GraphSettingDto = /** @class */ (function () {
    function GraphSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GraphSettingDto.prototype.init = function (data) {
        if (data) {
            this.category = data["category"];
            this.graphId = data["graphId"];
            this.url = data["url"];
        }
    };
    GraphSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GraphSettingDto();
        result.init(data);
        return result;
    };
    GraphSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["graphId"] = this.graphId;
        data["url"] = this.url;
        return data;
    };
    return GraphSettingDto;
}());
export { GraphSettingDto };
var ImportIntoUserGalleryDto = /** @class */ (function () {
    function ImportIntoUserGalleryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportIntoUserGalleryDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.configureId = data["configureId"];
            this.configureGraphId = data["configureGraphId"];
            this.graphName = data["graphName"];
        }
    };
    ImportIntoUserGalleryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportIntoUserGalleryDto();
        result.init(data);
        return result;
    };
    ImportIntoUserGalleryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["configureId"] = this.configureId;
        data["configureGraphId"] = this.configureGraphId;
        data["graphName"] = this.graphName;
        return data;
    };
    return ImportIntoUserGalleryDto;
}());
export { ImportIntoUserGalleryDto };
var GetConfigureGraphStatesDto = /** @class */ (function () {
    function GetConfigureGraphStatesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetConfigureGraphStatesDto.prototype.init = function (data) {
        if (data) {
            if (data["states"] && data["states"].constructor === Array) {
                this.states = [];
                for (var _i = 0, _a = data["states"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.states.push(GraphStateDto.fromJS(item));
                }
            }
        }
    };
    GetConfigureGraphStatesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetConfigureGraphStatesDto();
        result.init(data);
        return result;
    };
    GetConfigureGraphStatesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.states && this.states.constructor === Array) {
            data["states"] = [];
            for (var _i = 0, _a = this.states; _i < _a.length; _i++) {
                var item = _a[_i];
                data["states"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetConfigureGraphStatesDto;
}());
export { GetConfigureGraphStatesDto };
var GraphStateDto = /** @class */ (function () {
    function GraphStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GraphStateDto.prototype.init = function (data) {
        if (data) {
            this.graphId = data["graphId"];
            this.stateIndex = data["stateIndex"];
        }
    };
    GraphStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GraphStateDto();
        result.init(data);
        return result;
    };
    GraphStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["graphId"] = this.graphId;
        data["stateIndex"] = this.stateIndex;
        return data;
    };
    return GraphStateDto;
}());
export { GraphStateDto };
var IListResultOfGetConfigureGraphStateResultDto = /** @class */ (function () {
    function IListResultOfGetConfigureGraphStateResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfGetConfigureGraphStateResultDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetConfigureGraphStateResultDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfGetConfigureGraphStateResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfGetConfigureGraphStateResultDto();
        result.init(data);
        return result;
    };
    IListResultOfGetConfigureGraphStateResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfGetConfigureGraphStateResultDto;
}());
export { IListResultOfGetConfigureGraphStateResultDto };
var GetConfigureGraphStateResultDto = /** @class */ (function () {
    function GetConfigureGraphStateResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetConfigureGraphStateResultDto.prototype.init = function (data) {
        if (data) {
            this.graphId = data["graphId"];
            this.stateIndex = data["stateIndex"];
            this.result = data["result"] ? GraphStateResult.fromJS(data["result"]) : undefined;
        }
    };
    GetConfigureGraphStateResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetConfigureGraphStateResultDto();
        result.init(data);
        return result;
    };
    GetConfigureGraphStateResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["graphId"] = this.graphId;
        data["stateIndex"] = this.stateIndex;
        data["result"] = this.result ? this.result.toJSON() : undefined;
        return data;
    };
    return GetConfigureGraphStateResultDto;
}());
export { GetConfigureGraphStateResultDto };
var GraphStateResult = /** @class */ (function () {
    function GraphStateResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GraphStateResult.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.url = data["url"];
        }
    };
    GraphStateResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GraphStateResult();
        result.init(data);
        return result;
    };
    GraphStateResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["url"] = this.url;
        return data;
    };
    return GraphStateResult;
}());
export { GraphStateResult };
var ConfigurePermissionDto = /** @class */ (function () {
    function ConfigurePermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigurePermissionDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.description = data["description"];
            this.configureId = data["configureId"];
            this.tag = data["tag"];
        }
    };
    ConfigurePermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigurePermissionDto();
        result.init(data);
        return result;
    };
    ConfigurePermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["configureId"] = this.configureId;
        data["tag"] = this.tag;
        return data;
    };
    return ConfigurePermissionDto;
}());
export { ConfigurePermissionDto };
var CheckPermissionUsedDto = /** @class */ (function () {
    function CheckPermissionUsedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckPermissionUsedDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.tag = data["tag"];
        }
    };
    CheckPermissionUsedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckPermissionUsedDto();
        result.init(data);
        return result;
    };
    CheckPermissionUsedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["tag"] = this.tag;
        return data;
    };
    return CheckPermissionUsedDto;
}());
export { CheckPermissionUsedDto };
var IListResultOfConfigurePermissionDto = /** @class */ (function () {
    function IListResultOfConfigurePermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfConfigurePermissionDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ConfigurePermissionDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfConfigurePermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfConfigurePermissionDto();
        result.init(data);
        return result;
    };
    IListResultOfConfigurePermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfConfigurePermissionDto;
}());
export { IListResultOfConfigurePermissionDto };
var ReleaseConfigureDto = /** @class */ (function () {
    function ReleaseConfigureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleaseConfigureDto.prototype.init = function (data) {
        if (data) {
            if (data["views"] && data["views"].constructor === Array) {
                this.views = [];
                for (var _i = 0, _a = data["views"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.views.push(ReleaseViewDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ReleaseConfigureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleaseConfigureDto();
        result.init(data);
        return result;
    };
    ReleaseConfigureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.views && this.views.constructor === Array) {
            data["views"] = [];
            for (var _i = 0, _a = this.views; _i < _a.length; _i++) {
                var item = _a[_i];
                data["views"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ReleaseConfigureDto;
}());
export { ReleaseConfigureDto };
var ReleaseViewDto = /** @class */ (function () {
    function ReleaseViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleaseViewDto.prototype.init = function (data) {
        if (data) {
            this.viewIndex = data["viewIndex"];
            this.width = data["width"];
            this.height = data["height"];
            this.releasedView = data["releasedView"];
            this.code = data["code"];
            this.id = data["id"];
        }
    };
    ReleaseViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleaseViewDto();
        result.init(data);
        return result;
    };
    ReleaseViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["viewIndex"] = this.viewIndex;
        data["width"] = this.width;
        data["height"] = this.height;
        data["releasedView"] = this.releasedView;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    };
    return ReleaseViewDto;
}());
export { ReleaseViewDto };
var IListResultOfDeletedDataSourceDto = /** @class */ (function () {
    function IListResultOfDeletedDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfDeletedDataSourceDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeletedDataSourceDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfDeletedDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfDeletedDataSourceDto();
        result.init(data);
        return result;
    };
    IListResultOfDeletedDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfDeletedDataSourceDto;
}());
export { IListResultOfDeletedDataSourceDto };
var DeletedDataSourceDto = /** @class */ (function () {
    function DeletedDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeletedDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    DeletedDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeletedDataSourceDto();
        result.init(data);
        return result;
    };
    DeletedDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return DeletedDataSourceDto;
}());
export { DeletedDataSourceDto };
var ConfigureSettingsDto = /** @class */ (function () {
    function ConfigureSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureSettingsDto.prototype.init = function (data) {
        if (data) {
            this.designerSettings = data["designerSettings"] ? DesignerSettingsDto.fromJS(data["designerSettings"]) : undefined;
        }
    };
    ConfigureSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureSettingsDto();
        result.init(data);
        return result;
    };
    ConfigureSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["designerSettings"] = this.designerSettings ? this.designerSettings.toJSON() : undefined;
        return data;
    };
    return ConfigureSettingsDto;
}());
export { ConfigureSettingsDto };
var DesignerSettingsDto = /** @class */ (function () {
    function DesignerSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DesignerSettingsDto.prototype.init = function (data) {
        if (data) {
            this.isShowGrid = data["isShowGrid"];
            this.isGridSnapEnabled = data["isGridSnapEnabled"];
            this.isGuidelineSnapEnabled = data["isGuidelineSnapEnabled"];
        }
    };
    DesignerSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DesignerSettingsDto();
        result.init(data);
        return result;
    };
    DesignerSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isShowGrid"] = this.isShowGrid;
        data["isGridSnapEnabled"] = this.isGridSnapEnabled;
        data["isGuidelineSnapEnabled"] = this.isGuidelineSnapEnabled;
        return data;
    };
    return DesignerSettingsDto;
}());
export { DesignerSettingsDto };
var IListResultOfConfigureVideoDto = /** @class */ (function () {
    function IListResultOfConfigureVideoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfConfigureVideoDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ConfigureVideoDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfConfigureVideoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfConfigureVideoDto();
        result.init(data);
        return result;
    };
    IListResultOfConfigureVideoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfConfigureVideoDto;
}());
export { IListResultOfConfigureVideoDto };
var ConfigureVideoDto = /** @class */ (function () {
    function ConfigureVideoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureVideoDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.isDefaultUrl = data["isDefaultUrl"];
            this.videoType = data["videoType"];
            this.tag = data["tag"];
            this.name = data["name"];
            this.videoUrl = data["videoUrl"];
            this.configureId = data["configureId"];
        }
    };
    ConfigureVideoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureVideoDto();
        result.init(data);
        return result;
    };
    ConfigureVideoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDefaultUrl"] = this.isDefaultUrl;
        data["videoType"] = this.videoType;
        data["tag"] = this.tag;
        data["name"] = this.name;
        data["videoUrl"] = this.videoUrl;
        data["configureId"] = this.configureId;
        return data;
    };
    return ConfigureVideoDto;
}());
export { ConfigureVideoDto };
var IListResultOfConfigureVideoNameDto = /** @class */ (function () {
    function IListResultOfConfigureVideoNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfConfigureVideoNameDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ConfigureVideoNameDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfConfigureVideoNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfConfigureVideoNameDto();
        result.init(data);
        return result;
    };
    IListResultOfConfigureVideoNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfConfigureVideoNameDto;
}());
export { IListResultOfConfigureVideoNameDto };
var ConfigureVideoNameDto = /** @class */ (function () {
    function ConfigureVideoNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureVideoNameDto.prototype.init = function (data) {
        if (data) {
            this.tag = data["tag"];
            this.name = data["name"];
            this.videoType = data["videoType"];
        }
    };
    ConfigureVideoNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureVideoNameDto();
        result.init(data);
        return result;
    };
    ConfigureVideoNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["name"] = this.name;
        data["videoType"] = this.videoType;
        return data;
    };
    return ConfigureVideoNameDto;
}());
export { ConfigureVideoNameDto };
var CreateOrUpdateViewDto = /** @class */ (function () {
    function CreateOrUpdateViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateViewDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.viewType = data["viewType"];
            this.configureId = data["configureId"];
            this.name = data["name"];
            this.width = data["width"];
            this.height = data["height"];
            this.configure = data["configure"];
        }
    };
    CreateOrUpdateViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateViewDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["viewType"] = this.viewType;
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        data["width"] = this.width;
        data["height"] = this.height;
        data["configure"] = this.configure;
        return data;
    };
    return CreateOrUpdateViewDto;
}());
export { CreateOrUpdateViewDto };
var IListResultOfConfigureViewNameDto = /** @class */ (function () {
    function IListResultOfConfigureViewNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfConfigureViewNameDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ConfigureViewNameDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfConfigureViewNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfConfigureViewNameDto();
        result.init(data);
        return result;
    };
    IListResultOfConfigureViewNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfConfigureViewNameDto;
}());
export { IListResultOfConfigureViewNameDto };
var ConfigureViewNameDto = /** @class */ (function () {
    function ConfigureViewNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureViewNameDto.prototype.init = function (data) {
        if (data) {
            this.index = data["index"];
            this.name = data["name"];
            this.type = data["type"];
            this.isMainView = data["isMainView"];
            this.width = data["width"];
            this.height = data["height"];
            this.id = data["id"];
        }
    };
    ConfigureViewNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureViewNameDto();
        result.init(data);
        return result;
    };
    ConfigureViewNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isMainView"] = this.isMainView;
        data["width"] = this.width;
        data["height"] = this.height;
        data["id"] = this.id;
        return data;
    };
    return ConfigureViewNameDto;
}());
export { ConfigureViewNameDto };
var ViewConfigureDto = /** @class */ (function () {
    function ViewConfigureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ViewConfigureDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.width = data["width"];
            this.height = data["height"];
            this.configure = data["configure"];
            this.type = data["type"];
        }
    };
    ViewConfigureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ViewConfigureDto();
        result.init(data);
        return result;
    };
    ViewConfigureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["width"] = this.width;
        data["height"] = this.height;
        data["configure"] = this.configure;
        data["type"] = this.type;
        return data;
    };
    return ViewConfigureDto;
}());
export { ViewConfigureDto };
var IListResultOfViewConfiguresDto = /** @class */ (function () {
    function IListResultOfViewConfiguresDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfViewConfiguresDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ViewConfiguresDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfViewConfiguresDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfViewConfiguresDto();
        result.init(data);
        return result;
    };
    IListResultOfViewConfiguresDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfViewConfiguresDto;
}());
export { IListResultOfViewConfiguresDto };
var ViewConfiguresDto = /** @class */ (function () {
    function ViewConfiguresDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ViewConfiguresDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.configure = data["configure"];
        }
    };
    ViewConfiguresDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ViewConfiguresDto();
        result.init(data);
        return result;
    };
    ViewConfiguresDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configure"] = this.configure;
        return data;
    };
    return ViewConfiguresDto;
}());
export { ViewConfiguresDto };
var CopyConfigureViewDto = /** @class */ (function () {
    function CopyConfigureViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CopyConfigureViewDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.copyedViewId = data["copyedViewId"];
            this.name = data["name"];
        }
    };
    CopyConfigureViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CopyConfigureViewDto();
        result.init(data);
        return result;
    };
    CopyConfigureViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["copyedViewId"] = this.copyedViewId;
        data["name"] = this.name;
        return data;
    };
    return CopyConfigureViewDto;
}());
export { CopyConfigureViewDto };
var SetMainViewDto = /** @class */ (function () {
    function SetMainViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetMainViewDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.viewId = data["viewId"];
        }
    };
    SetMainViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetMainViewDto();
        result.init(data);
        return result;
    };
    SetMainViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["viewId"] = this.viewId;
        return data;
    };
    return SetMainViewDto;
}());
export { SetMainViewDto };
var EntityDtoOfInt32 = /** @class */ (function () {
    function EntityDtoOfInt32(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfInt32.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfInt32.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfInt32();
        result.init(data);
        return result;
    };
    EntityDtoOfInt32.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfInt32;
}());
export { EntityDtoOfInt32 };
var ConfigureViewSettingDto = /** @class */ (function () {
    function ConfigureViewSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureViewSettingDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.defaultWidth = data["defaultWidth"];
            this.defaultHeight = data["defaultHeight"];
        }
    };
    ConfigureViewSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureViewSettingDto();
        result.init(data);
        return result;
    };
    ConfigureViewSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["defaultWidth"] = this.defaultWidth;
        data["defaultHeight"] = this.defaultHeight;
        return data;
    };
    return ConfigureViewSettingDto;
}());
export { ConfigureViewSettingDto };
var UpdateConfigureViewSettingDto = /** @class */ (function () {
    function UpdateConfigureViewSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateConfigureViewSettingDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.width = data["width"];
            this.height = data["height"];
            this.type = data["type"];
        }
    };
    UpdateConfigureViewSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateConfigureViewSettingDto();
        result.init(data);
        return result;
    };
    UpdateConfigureViewSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["width"] = this.width;
        data["height"] = this.height;
        data["type"] = this.type;
        return data;
    };
    return UpdateConfigureViewSettingDto;
}());
export { UpdateConfigureViewSettingDto };
var PagedResultDtoOfGetNotificationOutputDto = /** @class */ (function () {
    function PagedResultDtoOfGetNotificationOutputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetNotificationOutputDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetNotificationOutputDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetNotificationOutputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetNotificationOutputDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetNotificationOutputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetNotificationOutputDto;
}());
export { PagedResultDtoOfGetNotificationOutputDto };
var GetNotificationOutputDto = /** @class */ (function () {
    function GetNotificationOutputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNotificationOutputDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.content = data["content"];
            this.recipientRole = data["recipientRole"];
            this.status = data["status"];
            this.publishedDateTime = data["publishedDateTime"] ? moment(data["publishedDateTime"].toString()) : undefined;
            this.recipientType = data["recipientType"];
            this.expireTime = data["expireTime"] ? moment(data["expireTime"].toString()) : undefined;
            this.useMobilePushService = data["useMobilePushService"];
            if (data["notificationTenants"] && data["notificationTenants"].constructor === Array) {
                this.notificationTenants = [];
                for (var _i = 0, _a = data["notificationTenants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.notificationTenants.push(TenantIdNameDto.fromJS(item));
                }
            }
        }
    };
    GetNotificationOutputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNotificationOutputDto();
        result.init(data);
        return result;
    };
    GetNotificationOutputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["recipientRole"] = this.recipientRole;
        data["status"] = this.status;
        data["publishedDateTime"] = this.publishedDateTime ? this.publishedDateTime.toISOString() : undefined;
        data["recipientType"] = this.recipientType;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : undefined;
        data["useMobilePushService"] = this.useMobilePushService;
        if (this.notificationTenants && this.notificationTenants.constructor === Array) {
            data["notificationTenants"] = [];
            for (var _i = 0, _a = this.notificationTenants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["notificationTenants"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetNotificationOutputDto;
}());
export { GetNotificationOutputDto };
var TenantIdNameDto = /** @class */ (function () {
    function TenantIdNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantIdNameDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    };
    TenantIdNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantIdNameDto();
        result.init(data);
        return result;
    };
    TenantIdNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return TenantIdNameDto;
}());
export { TenantIdNameDto };
var CreateOrEditCustomManualNotificationInputDto = /** @class */ (function () {
    function CreateOrEditCustomManualNotificationInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditCustomManualNotificationInputDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.content = data["content"];
            this.recipientRole = data["recipientRole"];
            this.status = data["status"];
            this.expireTime = data["expireTime"] ? moment(data["expireTime"].toString()) : undefined;
            this.useMobilePushService = data["useMobilePushService"];
            this.recipientType = data["recipientType"];
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (var _i = 0, _a = data["tenantIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenantIds.push(item);
                }
            }
        }
    };
    CreateOrEditCustomManualNotificationInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditCustomManualNotificationInputDto();
        result.init(data);
        return result;
    };
    CreateOrEditCustomManualNotificationInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["recipientRole"] = this.recipientRole;
        data["status"] = this.status;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : undefined;
        data["useMobilePushService"] = this.useMobilePushService;
        data["recipientType"] = this.recipientType;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (var _i = 0, _a = this.tenantIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenantIds"].push(item);
            }
        }
        return data;
    };
    return CreateOrEditCustomManualNotificationInputDto;
}());
export { CreateOrEditCustomManualNotificationInputDto };
var CustomManualNotificationIdDto = /** @class */ (function () {
    function CustomManualNotificationIdDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomManualNotificationIdDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    CustomManualNotificationIdDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomManualNotificationIdDto();
        result.init(data);
        return result;
    };
    CustomManualNotificationIdDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return CustomManualNotificationIdDto;
}());
export { CustomManualNotificationIdDto };
/** 自定义列模型 */
var TitleInfoDto = /** @class */ (function () {
    function TitleInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TitleInfoDto.prototype.init = function (data) {
        if (data) {
            this.tableName = data["tableName"];
            if (data["titles"] && data["titles"].constructor === Array) {
                this.titles = [];
                for (var _i = 0, _a = data["titles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.titles.push(item);
                }
            }
        }
    };
    TitleInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TitleInfoDto();
        result.init(data);
        return result;
    };
    TitleInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        if (this.titles && this.titles.constructor === Array) {
            data["titles"] = [];
            for (var _i = 0, _a = this.titles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["titles"].push(item);
            }
        }
        return data;
    };
    return TitleInfoDto;
}());
export { TitleInfoDto };
var DashboardListDto = /** @class */ (function () {
    function DashboardListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DashboardListDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.index = data["index"];
            this.content = data["content"];
        }
    };
    DashboardListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DashboardListDto();
        result.init(data);
        return result;
    };
    DashboardListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["index"] = this.index;
        data["content"] = this.content;
        return data;
    };
    return DashboardListDto;
}());
export { DashboardListDto };
var SaveDashboardDto = /** @class */ (function () {
    function SaveDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SaveDashboardDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(DashboardPermissionDto.fromJS(item));
                }
            }
        }
    };
    SaveDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SaveDashboardDto();
        result.init(data);
        return result;
    };
    SaveDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item.toJSON());
            }
        }
        return data;
    };
    return SaveDashboardDto;
}());
export { SaveDashboardDto };
var DashboardPermissionDto = /** @class */ (function () {
    function DashboardPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DashboardPermissionDto.prototype.init = function (data) {
        if (data) {
            this.permissionOwnerType = data["permissionOwnerType"];
            if (data["ownerIds"] && data["ownerIds"].constructor === Array) {
                this.ownerIds = [];
                for (var _i = 0, _a = data["ownerIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.ownerIds.push(item);
                }
            }
        }
    };
    DashboardPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DashboardPermissionDto();
        result.init(data);
        return result;
    };
    DashboardPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["permissionOwnerType"] = this.permissionOwnerType;
        if (this.ownerIds && this.ownerIds.constructor === Array) {
            data["ownerIds"] = [];
            for (var _i = 0, _a = this.ownerIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["ownerIds"].push(item);
            }
        }
        return data;
    };
    return DashboardPermissionDto;
}());
export { DashboardPermissionDto };
var ReOrderDashBoardDto = /** @class */ (function () {
    function ReOrderDashBoardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReOrderDashBoardDto.prototype.init = function (data) {
        if (data) {
            if (data["dashboardId"] && data["dashboardId"].constructor === Array) {
                this.dashboardId = [];
                for (var _i = 0, _a = data["dashboardId"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.dashboardId.push(item);
                }
            }
        }
    };
    ReOrderDashBoardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReOrderDashBoardDto();
        result.init(data);
        return result;
    };
    ReOrderDashBoardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.dashboardId && this.dashboardId.constructor === Array) {
            data["dashboardId"] = [];
            for (var _i = 0, _a = this.dashboardId; _i < _a.length; _i++) {
                var item = _a[_i];
                data["dashboardId"].push(item);
            }
        }
        return data;
    };
    return ReOrderDashBoardDto;
}());
export { ReOrderDashBoardDto };
var SaveDashBoardContentDto = /** @class */ (function () {
    function SaveDashBoardContentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SaveDashBoardContentDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.content = data["content"];
        }
    };
    SaveDashBoardContentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SaveDashBoardContentDto();
        result.init(data);
        return result;
    };
    SaveDashBoardContentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        return data;
    };
    return SaveDashBoardContentDto;
}());
export { SaveDashBoardContentDto };
var Dashboard = /** @class */ (function () {
    function Dashboard(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Dashboard.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.index = data["index"];
            this.content = data["content"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Dashboard.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Dashboard();
        result.init(data);
        return result;
    };
    Dashboard.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        data["content"] = this.content;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Dashboard;
}());
export { Dashboard };
var TargetOwnerPermission = /** @class */ (function () {
    function TargetOwnerPermission(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TargetOwnerPermission.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.permissionTargetId = data["permissionTargetId"];
            this.permissionTargetType = data["permissionTargetType"];
            this.permissionCategory = data["permissionCategory"];
            this.targetOwnerType = data["targetOwnerType"];
            this.targetOwnerId = data["targetOwnerId"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    TargetOwnerPermission.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TargetOwnerPermission();
        result.init(data);
        return result;
    };
    TargetOwnerPermission.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["permissionTargetId"] = this.permissionTargetId;
        data["permissionTargetType"] = this.permissionTargetType;
        data["permissionCategory"] = this.permissionCategory;
        data["targetOwnerType"] = this.targetOwnerType;
        data["targetOwnerId"] = this.targetOwnerId;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return TargetOwnerPermission;
}());
export { TargetOwnerPermission };
var DashboardOwnerInfoDto = /** @class */ (function () {
    function DashboardOwnerInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DashboardOwnerInfoDto.prototype.init = function (data) {
        if (data) {
            this.ownerType = data["ownerType"];
            this.ownerId = data["ownerId"];
            this.ownerName = data["ownerName"];
        }
    };
    DashboardOwnerInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DashboardOwnerInfoDto();
        result.init(data);
        return result;
    };
    DashboardOwnerInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["ownerType"] = this.ownerType;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        return data;
    };
    return DashboardOwnerInfoDto;
}());
export { DashboardOwnerInfoDto };
var User = /** @class */ (function () {
    function User(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    User.prototype.init = function (data) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.jobNumber = data["jobNumber"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isLocationEnabled = data["isLocationEnabled"];
            this.signInTokenExpireTimeUtc = data["signInTokenExpireTimeUtc"] ? moment(data["signInTokenExpireTimeUtc"].toString()) : undefined;
            this.signInToken = data["signInToken"];
            this.googleAuthenticatorKey = data["googleAuthenticatorKey"];
            this.fullName = data["fullName"];
            this.mergerName = data["mergerName"];
            this.expireTime = data["expireTime"] ? moment(data["expireTime"].toString()) : undefined;
            this.dataPolicy = data["dataPolicy"];
            this.creatorOrganizationId = data["creatorOrganizationId"];
            this.openId = data["openId"];
            this.wxPushEnabled = data["wxPushEnabled"];
            this.sequentialId = data["sequentialId"];
            this.externalSuperAdmin = data["externalSuperAdmin"];
            this.emailAddress = data["emailAddress"];
            this.normalizedUserName = data["normalizedUserName"];
            this.normalizedEmailAddress = data["normalizedEmailAddress"];
            this.concurrencyStamp = data["concurrencyStamp"];
            if (data["tokens"] && data["tokens"].constructor === Array) {
                this.tokens = [];
                for (var _i = 0, _a = data["tokens"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tokens.push(UserToken.fromJS(item));
                }
            }
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : undefined;
            this.authenticationSource = data["authenticationSource"];
            this.userName = data["userName"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.password = data["password"];
            this.emailConfirmationCode = data["emailConfirmationCode"];
            this.passwordResetCode = data["passwordResetCode"];
            this.lockoutEndDateUtc = data["lockoutEndDateUtc"] ? moment(data["lockoutEndDateUtc"].toString()) : undefined;
            this.accessFailedCount = data["accessFailedCount"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.securityStamp = data["securityStamp"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            if (data["logins"] && data["logins"].constructor === Array) {
                this.logins = [];
                for (var _b = 0, _c = data["logins"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.logins.push(UserLogin.fromJS(item));
                }
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _d = 0, _e = data["roles"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.roles.push(UserRole.fromJS(item));
                }
            }
            if (data["claims"] && data["claims"].constructor === Array) {
                this.claims = [];
                for (var _f = 0, _g = data["claims"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.claims.push(UserClaim.fromJS(item));
                }
            }
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _h = 0, _j = data["permissions"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.permissions.push(UserPermissionSetting.fromJS(item));
                }
            }
            if (data["settings"] && data["settings"].constructor === Array) {
                this.settings = [];
                for (var _k = 0, _l = data["settings"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.settings.push(Setting.fromJS(item));
                }
            }
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.isActive = data["isActive"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    User.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new User();
        result.init(data);
        return result;
    };
    User.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["jobNumber"] = this.jobNumber;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isLocationEnabled"] = this.isLocationEnabled;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : undefined;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["fullName"] = this.fullName;
        data["mergerName"] = this.mergerName;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : undefined;
        data["dataPolicy"] = this.dataPolicy;
        data["creatorOrganizationId"] = this.creatorOrganizationId;
        data["openId"] = this.openId;
        data["wxPushEnabled"] = this.wxPushEnabled;
        data["sequentialId"] = this.sequentialId;
        data["externalSuperAdmin"] = this.externalSuperAdmin;
        data["emailAddress"] = this.emailAddress;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (this.tokens && this.tokens.constructor === Array) {
            data["tokens"] = [];
            for (var _i = 0, _a = this.tokens; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tokens"].push(item.toJSON());
            }
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (this.logins && this.logins.constructor === Array) {
            data["logins"] = [];
            for (var _b = 0, _c = this.logins; _b < _c.length; _b++) {
                var item = _c[_b];
                data["logins"].push(item.toJSON());
            }
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _d = 0, _e = this.roles; _d < _e.length; _d++) {
                var item = _e[_d];
                data["roles"].push(item.toJSON());
            }
        }
        if (this.claims && this.claims.constructor === Array) {
            data["claims"] = [];
            for (var _f = 0, _g = this.claims; _f < _g.length; _f++) {
                var item = _g[_f];
                data["claims"].push(item.toJSON());
            }
        }
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _h = 0, _j = this.permissions; _h < _j.length; _h++) {
                var item = _j[_h];
                data["permissions"].push(item.toJSON());
            }
        }
        if (this.settings && this.settings.constructor === Array) {
            data["settings"] = [];
            for (var _k = 0, _l = this.settings; _k < _l.length; _k++) {
                var item = _l[_k];
                data["settings"].push(item.toJSON());
            }
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return User;
}());
export { User };
var UserToken = /** @class */ (function () {
    function UserToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserToken.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.name = data["name"];
            this.value = data["value"];
            this.id = data["id"];
        }
    };
    UserToken.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserToken();
        result.init(data);
        return result;
    };
    UserToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    };
    return UserToken;
}());
export { UserToken };
var UserLogin = /** @class */ (function () {
    function UserLogin(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLogin.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.providerKey = data["providerKey"];
            this.id = data["id"];
        }
    };
    UserLogin.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLogin();
        result.init(data);
        return result;
    };
    UserLogin.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    };
    return UserLogin;
}());
export { UserLogin };
var UserRole = /** @class */ (function () {
    function UserRole(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserRole.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.roleId = data["roleId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    UserRole.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserRole();
        result.init(data);
        return result;
    };
    UserRole.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return UserRole;
}());
export { UserRole };
var UserClaim = /** @class */ (function () {
    function UserClaim(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserClaim.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    UserClaim.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserClaim();
        result.init(data);
        return result;
    };
    UserClaim.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return UserClaim;
}());
export { UserClaim };
var UserPermissionSetting = /** @class */ (function () {
    function UserPermissionSetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserPermissionSetting.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    UserPermissionSetting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserPermissionSetting();
        result.init(data);
        return result;
    };
    UserPermissionSetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return UserPermissionSetting;
}());
export { UserPermissionSetting };
var Setting = /** @class */ (function () {
    function Setting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Setting.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.value = data["value"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Setting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Setting();
        result.init(data);
        return result;
    };
    Setting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Setting;
}());
export { Setting };
var CheckReportDto = /** @class */ (function () {
    function CheckReportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckReportDto.prototype.init = function (data) {
        if (data) {
            this.reportId = data["reportId"];
        }
    };
    CheckReportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckReportDto();
        result.init(data);
        return result;
    };
    CheckReportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        return data;
    };
    return CheckReportDto;
}());
export { CheckReportDto };
var PagedResultDtoOfReportListDto = /** @class */ (function () {
    function PagedResultDtoOfReportListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfReportListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ReportListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfReportListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfReportListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfReportListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfReportListDto;
}());
export { PagedResultDtoOfReportListDto };
var ReportListDto = /** @class */ (function () {
    function ReportListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportListDto.prototype.init = function (data) {
        if (data) {
            this.reportId = data["reportId"];
            this.reportTitle = data["reportTitle"];
            this.reportDisplayType = data["reportDisplayType"];
            this.creator = data["creator"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    ReportListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportListDto();
        result.init(data);
        return result;
    };
    ReportListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportTitle"] = this.reportTitle;
        data["reportDisplayType"] = this.reportDisplayType;
        data["creator"] = this.creator;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return ReportListDto;
}());
export { ReportListDto };
var UpdateDashboardThemeDto = /** @class */ (function () {
    function UpdateDashboardThemeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateDashboardThemeDto.prototype.init = function (data) {
        if (data) {
            this.color = data["color"];
            this.hasBorder = data["hasBorder"];
        }
    };
    UpdateDashboardThemeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateDashboardThemeDto();
        result.init(data);
        return result;
    };
    UpdateDashboardThemeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["hasBorder"] = this.hasBorder;
        return data;
    };
    return UpdateDashboardThemeDto;
}());
export { UpdateDashboardThemeDto };
var DashboardThemeDto = /** @class */ (function () {
    function DashboardThemeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DashboardThemeDto.prototype.init = function (data) {
        if (data) {
            this.dashboardColor = data["dashboardColor"];
            this.hasBorder = data["hasBorder"];
        }
    };
    DashboardThemeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DashboardThemeDto();
        result.init(data);
        return result;
    };
    DashboardThemeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardColor"] = this.dashboardColor;
        data["hasBorder"] = this.hasBorder;
        return data;
    };
    return DashboardThemeDto;
}());
export { DashboardThemeDto };
var UpdateUserMapInfoDto = /** @class */ (function () {
    function UpdateUserMapInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserMapInfoDto.prototype.init = function (data) {
        if (data) {
            this.zoomLevel = data["zoomLevel"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    };
    UpdateUserMapInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserMapInfoDto();
        result.init(data);
        return result;
    };
    UpdateUserMapInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["zoomLevel"] = this.zoomLevel;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    };
    return UpdateUserMapInfoDto;
}());
export { UpdateUserMapInfoDto };
var UpdateMapInfo = /** @class */ (function () {
    function UpdateMapInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateMapInfo.prototype.init = function (data) {
        if (data) {
            this.dashBoardId = data["dashBoardId"];
            this.zoomLevel = data["zoomLevel"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    };
    UpdateMapInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateMapInfo();
        result.init(data);
        return result;
    };
    UpdateMapInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashBoardId"] = this.dashBoardId;
        data["zoomLevel"] = this.zoomLevel;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    };
    return UpdateMapInfo;
}());
export { UpdateMapInfo };
var ListResultDtoOfDictionaryDto = /** @class */ (function () {
    function ListResultDtoOfDictionaryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDictionaryDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DictionaryDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDictionaryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDictionaryDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDictionaryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDictionaryDto;
}());
export { ListResultDtoOfDictionaryDto };
var DictionaryDto = /** @class */ (function () {
    function DictionaryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DictionaryDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.order = data["order"];
            this.code = data["code"];
            this.id = data["id"];
        }
    };
    DictionaryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DictionaryDto();
        result.init(data);
        return result;
    };
    DictionaryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    };
    return DictionaryDto;
}());
export { DictionaryDto };
var ListResultDtoOfDictionaryItemDto = /** @class */ (function () {
    function ListResultDtoOfDictionaryItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDictionaryItemDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DictionaryItemDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDictionaryItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDictionaryItemDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDictionaryItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDictionaryItemDto;
}());
export { ListResultDtoOfDictionaryItemDto };
var DictionaryItemDto = /** @class */ (function () {
    function DictionaryItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DictionaryItemDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.dataDictionaryId = data["dataDictionaryId"];
            this.shorthand = data["shorthand"];
            this.isPreset = data["isPreset"];
            this.order = data["order"];
            this.value = data["value"];
            this.isEnabled = data["isEnabled"];
            this.id = data["id"];
        }
    };
    DictionaryItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DictionaryItemDto();
        result.init(data);
        return result;
    };
    DictionaryItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataDictionaryId"] = this.dataDictionaryId;
        data["shorthand"] = this.shorthand;
        data["isPreset"] = this.isPreset;
        data["order"] = this.order;
        data["value"] = this.value;
        data["isEnabled"] = this.isEnabled;
        data["id"] = this.id;
        return data;
    };
    return DictionaryItemDto;
}());
export { DictionaryItemDto };
var PagedResultDtoOfDictionaryItemDto = /** @class */ (function () {
    function PagedResultDtoOfDictionaryItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDictionaryItemDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DictionaryItemDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDictionaryItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDictionaryItemDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDictionaryItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDictionaryItemDto;
}());
export { PagedResultDtoOfDictionaryItemDto };
var PagedResultDtoOfHostDataDictionaryItem = /** @class */ (function () {
    function PagedResultDtoOfHostDataDictionaryItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfHostDataDictionaryItem.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(HostDataDictionaryItem.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfHostDataDictionaryItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfHostDataDictionaryItem();
        result.init(data);
        return result;
    };
    PagedResultDtoOfHostDataDictionaryItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfHostDataDictionaryItem;
}());
export { PagedResultDtoOfHostDataDictionaryItem };
var HostDataDictionaryItem = /** @class */ (function () {
    function HostDataDictionaryItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostDataDictionaryItem.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.dataDictionaryId = data["dataDictionaryId"];
            this.shorthand = data["shorthand"];
            this.value = data["value"];
        }
    };
    HostDataDictionaryItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostDataDictionaryItem();
        result.init(data);
        return result;
    };
    HostDataDictionaryItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataDictionaryId"] = this.dataDictionaryId;
        data["shorthand"] = this.shorthand;
        data["value"] = this.value;
        return data;
    };
    return HostDataDictionaryItem;
}());
export { HostDataDictionaryItem };
var DictionaryCode = /** @class */ (function () {
    function DictionaryCode(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DictionaryCode.prototype.init = function (data) {
        if (data) {
            this.faultTypeCode = data["faultTypeCode"];
        }
    };
    DictionaryCode.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DictionaryCode();
        result.init(data);
        return result;
    };
    DictionaryCode.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["faultTypeCode"] = this.faultTypeCode;
        return data;
    };
    return DictionaryCode;
}());
export { DictionaryCode };
var PagedResultDtoOfDictionaryDto = /** @class */ (function () {
    function PagedResultDtoOfDictionaryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDictionaryDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DictionaryDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDictionaryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDictionaryDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDictionaryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDictionaryDto;
}());
export { PagedResultDtoOfDictionaryDto };
var DataSourceDto = /** @class */ (function () {
    function DataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DataSourceDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.id = data["id"];
            this.configureId = data["configureId"];
            this.code = data["code"];
            this.dataSourceType = data["dataSourceType"];
            this.dataSourceTypeString = data["dataSourceTypeString"];
            this.type = data["type"];
            this.boxTypeDisplayText = data["boxTypeDisplayText"];
            this.refDataSourceId = data["refDataSourceId"];
            this.refDataSourceKey = data["refDataSourceKey"];
        }
    };
    DataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DataSourceDto();
        result.init(data);
        return result;
    };
    DataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        data["configureId"] = this.configureId;
        data["code"] = this.code;
        data["dataSourceType"] = this.dataSourceType;
        data["dataSourceTypeString"] = this.dataSourceTypeString;
        data["type"] = this.type;
        data["boxTypeDisplayText"] = this.boxTypeDisplayText;
        data["refDataSourceId"] = this.refDataSourceId;
        data["refDataSourceKey"] = this.refDataSourceKey;
        return data;
    };
    return DataSourceDto;
}());
export { DataSourceDto };
var DataSourceForDataConfigDto = /** @class */ (function () {
    function DataSourceForDataConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DataSourceForDataConfigDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.id = data["id"];
        }
    };
    DataSourceForDataConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DataSourceForDataConfigDto();
        result.init(data);
        return result;
    };
    DataSourceForDataConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        return data;
    };
    return DataSourceForDataConfigDto;
}());
export { DataSourceForDataConfigDto };
var ImportFromFBoxDto = /** @class */ (function () {
    function ImportFromFBoxDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportFromFBoxDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.username = data["username"];
            this.password = data["password"];
            this.boxSerialNumber = data["boxSerialNumber"];
            this.dataSourceType = data["dataSourceType"];
        }
    };
    ImportFromFBoxDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportFromFBoxDto();
        result.init(data);
        return result;
    };
    ImportFromFBoxDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["username"] = this.username;
        data["password"] = this.password;
        data["boxSerialNumber"] = this.boxSerialNumber;
        data["dataSourceType"] = this.dataSourceType;
        return data;
    };
    return ImportFromFBoxDto;
}());
export { ImportFromFBoxDto };
var BuildDataAfterImportCheckRepeatNameDto = /** @class */ (function () {
    function BuildDataAfterImportCheckRepeatNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BuildDataAfterImportCheckRepeatNameDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.dataSourceType = data["dataSourceType"];
        }
    };
    BuildDataAfterImportCheckRepeatNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BuildDataAfterImportCheckRepeatNameDto();
        result.init(data);
        return result;
    };
    BuildDataAfterImportCheckRepeatNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["dataSourceType"] = this.dataSourceType;
        return data;
    };
    return BuildDataAfterImportCheckRepeatNameDto;
}());
export { BuildDataAfterImportCheckRepeatNameDto };
var BuildDataAfterImportDto = /** @class */ (function () {
    function BuildDataAfterImportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BuildDataAfterImportDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.dataSourceName = data["dataSourceName"];
            this.dataSourceType = data["dataSourceType"];
            this.renameType = data["renameType"];
        }
    };
    BuildDataAfterImportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BuildDataAfterImportDto();
        result.init(data);
        return result;
    };
    BuildDataAfterImportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["dataSourceName"] = this.dataSourceName;
        data["dataSourceType"] = this.dataSourceType;
        data["renameType"] = this.renameType;
        return data;
    };
    return BuildDataAfterImportDto;
}());
export { BuildDataAfterImportDto };
var CreateOrUpdateDataSourceImportInfoDto = /** @class */ (function () {
    function CreateOrUpdateDataSourceImportInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateDataSourceImportInfoDto.prototype.init = function (data) {
        if (data) {
            this.dataSourceId = data["dataSourceId"];
            this.username = data["username"];
            this.password = data["password"];
            this.boxSerialNumber = data["boxSerialNumber"];
        }
    };
    CreateOrUpdateDataSourceImportInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateDataSourceImportInfoDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateDataSourceImportInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dataSourceId"] = this.dataSourceId;
        data["username"] = this.username;
        data["password"] = this.password;
        data["boxSerialNumber"] = this.boxSerialNumber;
        return data;
    };
    return CreateOrUpdateDataSourceImportInfoDto;
}());
export { CreateOrUpdateDataSourceImportInfoDto };
var GetDataSourceImportInfoForEditDto = /** @class */ (function () {
    function GetDataSourceImportInfoForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDataSourceImportInfoForEditDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.username = data["username"];
            this.password = data["password"];
            this.boxSerialNumber = data["boxSerialNumber"];
        }
    };
    GetDataSourceImportInfoForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDataSourceImportInfoForEditDto();
        result.init(data);
        return result;
    };
    GetDataSourceImportInfoForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["username"] = this.username;
        data["password"] = this.password;
        data["boxSerialNumber"] = this.boxSerialNumber;
        return data;
    };
    return GetDataSourceImportInfoForEditDto;
}());
export { GetDataSourceImportInfoForEditDto };
var DateToStringOutput = /** @class */ (function () {
    function DateToStringOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DateToStringOutput.prototype.init = function (data) {
        if (data) {
            this.dateString = data["dateString"];
        }
    };
    DateToStringOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DateToStringOutput();
        result.init(data);
        return result;
    };
    DateToStringOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    };
    return DateToStringOutput;
}());
export { DateToStringOutput };
var NameValueOfString = /** @class */ (function () {
    function NameValueOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueOfString.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueOfString();
        result.init(data);
        return result;
    };
    NameValueOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueOfString;
}());
export { NameValueOfString };
var StringOutput = /** @class */ (function () {
    function StringOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StringOutput.prototype.init = function (data) {
        if (data) {
            this.output = data["output"];
        }
    };
    StringOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StringOutput();
        result.init(data);
        return result;
    };
    StringOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    };
    return StringOutput;
}());
export { StringOutput };
var DeviceForEditDto = /** @class */ (function () {
    function DeviceForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceForEditDto.prototype.init = function (data) {
        if (data) {
            this.device = data["device"] ? DeviceEditDto.fromJS(data["device"]) : undefined;
            this.devicePosition = data["devicePosition"] ? DevicePositionDto.fromJS(data["devicePosition"]) : undefined;
        }
    };
    DeviceForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceForEditDto();
        result.init(data);
        return result;
    };
    DeviceForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["device"] = this.device ? this.device.toJSON() : undefined;
        data["devicePosition"] = this.devicePosition ? this.devicePosition.toJSON() : undefined;
        return data;
    };
    return DeviceForEditDto;
}());
export { DeviceForEditDto };
var DeviceEditDto = /** @class */ (function () {
    function DeviceEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.deviceModelId = data["deviceModelId"];
            this.serialNumber = data["serialNumber"];
            this.orderNumber = data["orderNumber"];
            this.state = data["state"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.locationAcquisitionMode = data["locationAcquisitionMode"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.boxId = data["boxId"];
            this.isGaode = data["isGaode"];
            this.autoPositionDataSourceCode = data["autoPositionDataSourceCode"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.devicePattern = data["devicePattern"];
            this.deviceContractNumber = data["deviceContractNumber"];
            this.deviceProductionDate = data["deviceProductionDate"] ? moment(data["deviceProductionDate"].toString()) : undefined;
            this.deviceDeliveryDate = data["deviceDeliveryDate"] ? moment(data["deviceDeliveryDate"].toString()) : undefined;
            this.devicePicture = data["devicePicture"];
            this.approximateAddress = data["approximateAddress"];
            this.id = data["id"];
        }
    };
    DeviceEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceEditDto();
        result.init(data);
        return result;
    };
    DeviceEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["deviceModelId"] = this.deviceModelId;
        data["serialNumber"] = this.serialNumber;
        data["orderNumber"] = this.orderNumber;
        data["state"] = this.state;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["locationAcquisitionMode"] = this.locationAcquisitionMode;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["boxId"] = this.boxId;
        data["isGaode"] = this.isGaode;
        data["autoPositionDataSourceCode"] = this.autoPositionDataSourceCode;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["devicePattern"] = this.devicePattern;
        data["deviceContractNumber"] = this.deviceContractNumber;
        data["deviceProductionDate"] = this.deviceProductionDate ? this.deviceProductionDate.toISOString() : undefined;
        data["deviceDeliveryDate"] = this.deviceDeliveryDate ? this.deviceDeliveryDate.toISOString() : undefined;
        data["devicePicture"] = this.devicePicture;
        data["approximateAddress"] = this.approximateAddress;
        data["id"] = this.id;
        return data;
    };
    return DeviceEditDto;
}());
export { DeviceEditDto };
var DevicePositionDto = /** @class */ (function () {
    function DevicePositionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DevicePositionDto.prototype.init = function (data) {
        if (data) {
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    };
    DevicePositionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DevicePositionDto();
        result.init(data);
        return result;
    };
    DevicePositionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    };
    return DevicePositionDto;
}());
export { DevicePositionDto };
var CreateOrUpdateDeviceDto = /** @class */ (function () {
    function CreateOrUpdateDeviceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateDeviceDto.prototype.init = function (data) {
        if (data) {
            this.device = data["device"] ? DeviceEditDto.fromJS(data["device"]) : undefined;
            this.deviceAddress = data["deviceAddress"] ? DeviceAddressDto.fromJS(data["deviceAddress"]) : undefined;
            if (data["deviceCustomFieldDetails"] && data["deviceCustomFieldDetails"].constructor === Array) {
                this.deviceCustomFieldDetails = [];
                for (var _i = 0, _a = data["deviceCustomFieldDetails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.deviceCustomFieldDetails.push(CustomFieldDetailDto.fromJS(item));
                }
            }
            this.deviceGroupId = data["deviceGroupId"];
            if (data["devicePictures"] && data["devicePictures"].constructor === Array) {
                this.devicePictures = [];
                for (var _b = 0, _c = data["devicePictures"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.devicePictures.push(DevicePictureDto.fromJS(item));
                }
            }
            if (data["deletePictureIds"] && data["deletePictureIds"].constructor === Array) {
                this.deletePictureIds = [];
                for (var _d = 0, _e = data["deletePictureIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.deletePictureIds.push(item);
                }
            }
        }
    };
    CreateOrUpdateDeviceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateDeviceDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateDeviceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["device"] = this.device ? this.device.toJSON() : undefined;
        data["deviceAddress"] = this.deviceAddress ? this.deviceAddress.toJSON() : undefined;
        if (this.deviceCustomFieldDetails && this.deviceCustomFieldDetails.constructor === Array) {
            data["deviceCustomFieldDetails"] = [];
            for (var _i = 0, _a = this.deviceCustomFieldDetails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["deviceCustomFieldDetails"].push(item.toJSON());
            }
        }
        data["deviceGroupId"] = this.deviceGroupId;
        if (this.devicePictures && this.devicePictures.constructor === Array) {
            data["devicePictures"] = [];
            for (var _b = 0, _c = this.devicePictures; _b < _c.length; _b++) {
                var item = _c[_b];
                data["devicePictures"].push(item.toJSON());
            }
        }
        if (this.deletePictureIds && this.deletePictureIds.constructor === Array) {
            data["deletePictureIds"] = [];
            for (var _d = 0, _e = this.deletePictureIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["deletePictureIds"].push(item);
            }
        }
        return data;
    };
    return CreateOrUpdateDeviceDto;
}());
export { CreateOrUpdateDeviceDto };
var DeviceAddressDto = /** @class */ (function () {
    function DeviceAddressDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceAddressDto.prototype.init = function (data) {
        if (data) {
            this.cityName = data["cityName"];
            this.districtName = data["districtName"];
            this.provinceName = data["provinceName"];
        }
    };
    DeviceAddressDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceAddressDto();
        result.init(data);
        return result;
    };
    DeviceAddressDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cityName"] = this.cityName;
        data["districtName"] = this.districtName;
        data["provinceName"] = this.provinceName;
        return data;
    };
    return DeviceAddressDto;
}());
export { DeviceAddressDto };
var CustomFieldDetailDto = /** @class */ (function () {
    function CustomFieldDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomFieldDetailDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.deviceCustomFieldId = data["deviceCustomFieldId"];
            this.deviceId = data["deviceId"];
            this.content = data["content"];
        }
    };
    CustomFieldDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomFieldDetailDto();
        result.init(data);
        return result;
    };
    CustomFieldDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceCustomFieldId"] = this.deviceCustomFieldId;
        data["deviceId"] = this.deviceId;
        data["content"] = this.content;
        return data;
    };
    return CustomFieldDetailDto;
}());
export { CustomFieldDetailDto };
/** 设备图片 */
var DevicePictureDto = /** @class */ (function () {
    function DevicePictureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DevicePictureDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.fileSize = data["fileSize"];
            this.byteString = data["byteString"];
            this.thumbnail = data["thumbnail"];
            this.id = data["id"];
        }
    };
    DevicePictureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DevicePictureDto();
        result.init(data);
        return result;
    };
    DevicePictureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["fileSize"] = this.fileSize;
        data["byteString"] = this.byteString;
        data["thumbnail"] = this.thumbnail;
        data["id"] = this.id;
        return data;
    };
    return DevicePictureDto;
}());
export { DevicePictureDto };
var OperationResultDto = /** @class */ (function () {
    function OperationResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OperationResultDto.prototype.init = function (data) {
        if (data) {
            this.errorMessage = data["errorMessage"];
        }
    };
    OperationResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OperationResultDto();
        result.init(data);
        return result;
    };
    OperationResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return OperationResultDto;
}());
export { OperationResultDto };
var IFormFile = /** @class */ (function () {
    function IFormFile(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IFormFile.prototype.init = function (data) {
        if (data) {
            this.contentType = data["contentType"];
            this.contentDisposition = data["contentDisposition"];
            if (data["headers"]) {
                this.headers = {};
                for (var key in data["headers"]) {
                    if (data["headers"].hasOwnProperty(key))
                        this.headers[key] = data["headers"][key];
                }
            }
            this.length = data["length"];
            this.name = data["name"];
            this.fileName = data["fileName"];
        }
    };
    IFormFile.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IFormFile();
        result.init(data);
        return result;
    };
    IFormFile.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["contentDisposition"] = this.contentDisposition;
        if (this.headers) {
            data["headers"] = {};
            for (var key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    data["headers"][key] = this.headers[key];
            }
        }
        data["length"] = this.length;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        return data;
    };
    return IFormFile;
}());
export { IFormFile };
var EntityDtoOfInt64 = /** @class */ (function () {
    function EntityDtoOfInt64(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfInt64.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfInt64.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    };
    EntityDtoOfInt64.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfInt64;
}());
export { EntityDtoOfInt64 };
var BindCameraDto = /** @class */ (function () {
    function BindCameraDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BindCameraDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.alias = data["alias"];
            this.serialNumber = data["serialNumber"];
            this.validateCode = data["validateCode"];
        }
    };
    BindCameraDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BindCameraDto();
        result.init(data);
        return result;
    };
    BindCameraDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["alias"] = this.alias;
        data["serialNumber"] = this.serialNumber;
        data["validateCode"] = this.validateCode;
        return data;
    };
    return BindCameraDto;
}());
export { BindCameraDto };
var UnBindCameraDto = /** @class */ (function () {
    function UnBindCameraDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnBindCameraDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.includeEzviz = data["includeEzviz"];
        }
    };
    UnBindCameraDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnBindCameraDto();
        result.init(data);
        return result;
    };
    UnBindCameraDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["includeEzviz"] = this.includeEzviz;
        return data;
    };
    return UnBindCameraDto;
}());
export { UnBindCameraDto };
var PagedResultDtoOfCameraListDto = /** @class */ (function () {
    function PagedResultDtoOfCameraListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfCameraListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CameraListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfCameraListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfCameraListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfCameraListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfCameraListDto;
}());
export { PagedResultDtoOfCameraListDto };
var CameraListDto = /** @class */ (function () {
    function CameraListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CameraListDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.deviceId = data["deviceId"];
            this.alias = data["alias"];
            this.serialNumber = data["serialNumber"];
            this.channelNo = data["channelNo"];
        }
    };
    CameraListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CameraListDto();
        result.init(data);
        return result;
    };
    CameraListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceId"] = this.deviceId;
        data["alias"] = this.alias;
        data["serialNumber"] = this.serialNumber;
        data["channelNo"] = this.channelNo;
        return data;
    };
    return CameraListDto;
}());
export { CameraListDto };
var LiveCameraDto = /** @class */ (function () {
    function LiveCameraDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LiveCameraDto.prototype.init = function (data) {
        if (data) {
            this.camera = data["camera"] ? DeviceCamera.fromJS(data["camera"]) : undefined;
            this.channel = data["channel"] ? CameraChannel.fromJS(data["channel"]) : undefined;
            this.liveAddress = data["liveAddress"] ? CameraAddress.fromJS(data["liveAddress"]) : undefined;
        }
    };
    LiveCameraDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LiveCameraDto();
        result.init(data);
        return result;
    };
    LiveCameraDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["camera"] = this.camera ? this.camera.toJSON() : undefined;
        data["channel"] = this.channel ? this.channel.toJSON() : undefined;
        data["liveAddress"] = this.liveAddress ? this.liveAddress.toJSON() : undefined;
        return data;
    };
    return LiveCameraDto;
}());
export { LiveCameraDto };
var DeviceCamera = /** @class */ (function () {
    function DeviceCamera(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceCamera.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.alias = data["alias"];
            this.serialNumber = data["serialNumber"];
            this.validateCode = data["validateCode"];
            this.device = data["device"] ? Device.fromJS(data["device"]) : undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    DeviceCamera.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceCamera();
        result.init(data);
        return result;
    };
    DeviceCamera.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["alias"] = this.alias;
        data["serialNumber"] = this.serialNumber;
        data["validateCode"] = this.validateCode;
        data["device"] = this.device ? this.device.toJSON() : undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return DeviceCamera;
}());
export { DeviceCamera };
var CameraChannel = /** @class */ (function () {
    function CameraChannel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CameraChannel.prototype.init = function (data) {
        if (data) {
            this.channelNo = data["channelNo"];
            this.channelName = data["channelName"];
            this.picUrl = data["picUrl"];
        }
    };
    CameraChannel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CameraChannel();
        result.init(data);
        return result;
    };
    CameraChannel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["channelNo"] = this.channelNo;
        data["channelName"] = this.channelName;
        data["picUrl"] = this.picUrl;
        return data;
    };
    return CameraChannel;
}());
export { CameraChannel };
var CameraAddress = /** @class */ (function () {
    function CameraAddress(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CameraAddress.prototype.init = function (data) {
        if (data) {
            this.deviceSerial = data["deviceSerial"];
            this.channelNo = data["channelNo"];
            this.liveAddress = data["liveAddress"];
            this.hdAddress = data["hdAddress"];
            this.rtmp = data["rtmp"];
            this.rtmpHd = data["rtmpHd"];
        }
    };
    CameraAddress.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CameraAddress();
        result.init(data);
        return result;
    };
    CameraAddress.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceSerial"] = this.deviceSerial;
        data["channelNo"] = this.channelNo;
        data["liveAddress"] = this.liveAddress;
        data["hdAddress"] = this.hdAddress;
        data["rtmp"] = this.rtmp;
        data["rtmpHd"] = this.rtmpHd;
        return data;
    };
    return CameraAddress;
}());
export { CameraAddress };
var Device = /** @class */ (function () {
    function Device(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Device.prototype.init = function (data) {
        if (data) {
            this.deviceModelId = data["deviceModelId"];
            this.configureId = data["configureId"];
            this.name = data["name"];
            this.serialNumber = data["serialNumber"];
            this.orderNumber = data["orderNumber"];
            this.state = data["state"];
            this.remark = data["remark"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.locationAcquisitionMode = data["locationAcquisitionMode"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.address = data["address"];
            this.issuedState = data["issuedState"];
            this.isAssigned = data["isAssigned"];
            this.issuedCompletedTime = data["issuedCompletedTime"] ? moment(data["issuedCompletedTime"].toString()) : undefined;
            this.deviceModel = data["deviceModel"] ? DeviceModel.fromJS(data["deviceModel"]) : undefined;
            this.configureProjectId = data["configureProjectId"];
            this.isGaode = data["isGaode"];
            this.autoPositionDataSourceCode = data["autoPositionDataSourceCode"];
            this.oemEndUserDealerCompany = data["oemEndUserDealerCompany"];
            this.dealerEndUserCompany = data["dealerEndUserCompany"];
            this.issuedFailedType = data["issuedFailedType"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.tenantId = data["tenantId"];
            this.devicePattern = data["devicePattern"];
            this.deviceContractNumber = data["deviceContractNumber"];
            this.deviceProductionDate = data["deviceProductionDate"] ? moment(data["deviceProductionDate"].toString()) : undefined;
            this.deviceDeliveryDate = data["deviceDeliveryDate"] ? moment(data["deviceDeliveryDate"].toString()) : undefined;
            this.devicePicture = data["devicePicture"];
            this.approximateAddress = data["approximateAddress"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Device.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Device();
        result.init(data);
        return result;
    };
    Device.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelId"] = this.deviceModelId;
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["orderNumber"] = this.orderNumber;
        data["state"] = this.state;
        data["remark"] = this.remark;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["locationAcquisitionMode"] = this.locationAcquisitionMode;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["address"] = this.address;
        data["issuedState"] = this.issuedState;
        data["isAssigned"] = this.isAssigned;
        data["issuedCompletedTime"] = this.issuedCompletedTime ? this.issuedCompletedTime.toISOString() : undefined;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        data["configureProjectId"] = this.configureProjectId;
        data["isGaode"] = this.isGaode;
        data["autoPositionDataSourceCode"] = this.autoPositionDataSourceCode;
        data["oemEndUserDealerCompany"] = this.oemEndUserDealerCompany;
        data["dealerEndUserCompany"] = this.dealerEndUserCompany;
        data["issuedFailedType"] = this.issuedFailedType;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["tenantId"] = this.tenantId;
        data["devicePattern"] = this.devicePattern;
        data["deviceContractNumber"] = this.deviceContractNumber;
        data["deviceProductionDate"] = this.deviceProductionDate ? this.deviceProductionDate.toISOString() : undefined;
        data["deviceDeliveryDate"] = this.deviceDeliveryDate ? this.deviceDeliveryDate.toISOString() : undefined;
        data["devicePicture"] = this.devicePicture;
        data["approximateAddress"] = this.approximateAddress;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Device;
}());
export { Device };
var DeviceModel = /** @class */ (function () {
    function DeviceModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.industry = data["industry"];
            this.remark = data["remark"];
            this.configureId = data["configureId"];
            this.modelGroupId = data["modelGroupId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    DeviceModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceModel();
        result.init(data);
        return result;
    };
    DeviceModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["industry"] = this.industry;
        data["remark"] = this.remark;
        data["configureId"] = this.configureId;
        data["modelGroupId"] = this.modelGroupId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return DeviceModel;
}());
export { DeviceModel };
var PagedResultDtoOfCustomFieldDto = /** @class */ (function () {
    function PagedResultDtoOfCustomFieldDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfCustomFieldDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CustomFieldDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfCustomFieldDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfCustomFieldDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfCustomFieldDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfCustomFieldDto;
}());
export { PagedResultDtoOfCustomFieldDto };
var CustomFieldDto = /** @class */ (function () {
    function CustomFieldDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomFieldDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.deviceFieldType = data["deviceFieldType"];
            this.fieldName = data["fieldName"];
            this.fieldDescription = data["fieldDescription"];
            this.required = data["required"];
            this.customFieldDetailDto = data["customFieldDetailDto"] ? CustomFieldDetailDto.fromJS(data["customFieldDetailDto"]) : undefined;
        }
    };
    CustomFieldDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomFieldDto();
        result.init(data);
        return result;
    };
    CustomFieldDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceFieldType"] = this.deviceFieldType;
        data["fieldName"] = this.fieldName;
        data["fieldDescription"] = this.fieldDescription;
        data["required"] = this.required;
        data["customFieldDetailDto"] = this.customFieldDetailDto ? this.customFieldDetailDto.toJSON() : undefined;
        return data;
    };
    return CustomFieldDto;
}());
export { CustomFieldDto };
var ListResultDtoOfCustomFieldDto = /** @class */ (function () {
    function ListResultDtoOfCustomFieldDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfCustomFieldDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CustomFieldDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfCustomFieldDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfCustomFieldDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfCustomFieldDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfCustomFieldDto;
}());
export { ListResultDtoOfCustomFieldDto };
var ListResultDtoOfCustomFieldDetailForShowDto = /** @class */ (function () {
    function ListResultDtoOfCustomFieldDetailForShowDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfCustomFieldDetailForShowDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CustomFieldDetailForShowDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfCustomFieldDetailForShowDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfCustomFieldDetailForShowDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfCustomFieldDetailForShowDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfCustomFieldDetailForShowDto;
}());
export { ListResultDtoOfCustomFieldDetailForShowDto };
var CustomFieldDetailForShowDto = /** @class */ (function () {
    function CustomFieldDetailForShowDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomFieldDetailForShowDto.prototype.init = function (data) {
        if (data) {
            this.deviceFieldType = data["deviceFieldType"];
            this.fieldName = data["fieldName"];
            this.content = data["content"];
        }
    };
    CustomFieldDetailForShowDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomFieldDetailForShowDto();
        result.init(data);
        return result;
    };
    CustomFieldDetailForShowDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceFieldType"] = this.deviceFieldType;
        data["fieldName"] = this.fieldName;
        data["content"] = this.content;
        return data;
    };
    return CustomFieldDetailForShowDto;
}());
export { CustomFieldDetailForShowDto };
var DeviceDashboardDto = /** @class */ (function () {
    function DeviceDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceDashboardDto.prototype.init = function (data) {
        if (data) {
            if (data["content"] && data["content"].constructor === Array) {
                this.content = [];
                for (var _i = 0, _a = data["content"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.content.push(DeviceDashboardContentDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    DeviceDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceDashboardDto();
        result.init(data);
        return result;
    };
    DeviceDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.content && this.content.constructor === Array) {
            data["content"] = [];
            for (var _i = 0, _a = this.content; _i < _a.length; _i++) {
                var item = _a[_i];
                data["content"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return DeviceDashboardDto;
}());
export { DeviceDashboardDto };
var DeviceDashboardContentDto = /** @class */ (function () {
    function DeviceDashboardContentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceDashboardContentDto.prototype.init = function (data) {
        if (data) {
            this.dashboardType = data["dashboardType"];
            this.id = data["id"];
            this.title = data["title"];
            this.reportId = data["reportId"];
            this.displayType = data["displayType"];
            this.config = data["config"] ? DeviceDashboardContentConfig.fromJS(data["config"]) : undefined;
            if (data["props"]) {
                this.props = {};
                for (var key in data["props"]) {
                    if (data["props"].hasOwnProperty(key))
                        this.props[key] = data["props"][key];
                }
            }
        }
    };
    DeviceDashboardContentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceDashboardContentDto();
        result.init(data);
        return result;
    };
    DeviceDashboardContentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardType"] = this.dashboardType;
        data["id"] = this.id;
        data["title"] = this.title;
        data["reportId"] = this.reportId;
        data["displayType"] = this.displayType;
        data["config"] = this.config ? this.config.toJSON() : undefined;
        if (this.props) {
            data["props"] = {};
            for (var key in this.props) {
                if (this.props.hasOwnProperty(key))
                    data["props"][key] = this.props[key];
            }
        }
        return data;
    };
    return DeviceDashboardContentDto;
}());
export { DeviceDashboardContentDto };
var UpdateDeviceDashboardDto = /** @class */ (function () {
    function UpdateDeviceDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateDeviceDashboardDto.prototype.init = function (data) {
        if (data) {
            if (data["content"] && data["content"].constructor === Array) {
                this.content = [];
                for (var _i = 0, _a = data["content"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.content.push(DeviceDashboardContentDto.fromJS(item));
                }
            }
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    UpdateDeviceDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateDeviceDashboardDto();
        result.init(data);
        return result;
    };
    UpdateDeviceDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.content && this.content.constructor === Array) {
            data["content"] = [];
            for (var _i = 0, _a = this.content; _i < _a.length; _i++) {
                var item = _a[_i];
                data["content"].push(item.toJSON());
            }
        }
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return UpdateDeviceDashboardDto;
}());
export { UpdateDeviceDashboardDto };
var CreateDeviceDashboardDto = /** @class */ (function () {
    function CreateDeviceDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateDeviceDashboardDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.name = data["name"];
        }
    };
    CreateDeviceDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateDeviceDashboardDto();
        result.init(data);
        return result;
    };
    CreateDeviceDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["name"] = this.name;
        return data;
    };
    return CreateDeviceDashboardDto;
}());
export { CreateDeviceDashboardDto };
var DeviceDashboardOrderDto = /** @class */ (function () {
    function DeviceDashboardOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceDashboardOrderDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.dashboardId = data["dashboardId"];
            this.dashboardStringId = data["dashboardStringId"];
            this.name = data["name"];
            this.monitorType = data["monitorType"];
            this.index = data["index"];
            this.isEditDisabled = data["isEditDisabled"];
        }
    };
    DeviceDashboardOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceDashboardOrderDto();
        result.init(data);
        return result;
    };
    DeviceDashboardOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dashboardId"] = this.dashboardId;
        data["dashboardStringId"] = this.dashboardStringId;
        data["name"] = this.name;
        data["monitorType"] = this.monitorType;
        data["index"] = this.index;
        data["isEditDisabled"] = this.isEditDisabled;
        return data;
    };
    return DeviceDashboardOrderDto;
}());
export { DeviceDashboardOrderDto };
var UpdateOrdersDto = /** @class */ (function () {
    function UpdateOrdersDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateOrdersDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [];
                for (var _i = 0, _a = data["orders"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.orders.push(DeviceDashboardOrderDto.fromJS(item));
                }
            }
        }
    };
    UpdateOrdersDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateOrdersDto();
        result.init(data);
        return result;
    };
    UpdateOrdersDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (var _i = 0, _a = this.orders; _i < _a.length; _i++) {
                var item = _a[_i];
                data["orders"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateOrdersDto;
}());
export { UpdateOrdersDto };
var DeviceDetailDto = /** @class */ (function () {
    function DeviceDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceDetailDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.serialNumber = data["serialNumber"];
            this.virtualDeviceState = data["virtualDeviceState"];
            this.deviceGroupName = data["deviceGroupName"];
            this.address = data["address"];
            this.orderNumber = data["orderNumber"];
            this.companyName = data["companyName"];
            this.devicePattern = data["devicePattern"];
            this.state = data["state"];
            this.remark = data["remark"];
            this.deviceContractNumber = data["deviceContractNumber"];
            this.deviceProductionDate = data["deviceProductionDate"] ? moment(data["deviceProductionDate"].toString()) : undefined;
            this.deviceDeliveryDate = data["deviceDeliveryDate"] ? moment(data["deviceDeliveryDate"].toString()) : undefined;
            this.devicePicture = data["devicePicture"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.permissionCategory = data["permissionCategory"];
            if (data["commonDeviceSns"] && data["commonDeviceSns"].constructor === Array) {
                this.commonDeviceSns = [];
                for (var _i = 0, _a = data["commonDeviceSns"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.commonDeviceSns.push(item);
                }
            }
            this.creatorName = data["creatorName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.deviceModel = data["deviceModel"] ? DeviceModelListDto.fromJS(data["deviceModel"]) : undefined;
            this.virtualDeviceId = data["virtualDeviceId"];
            this.id = data["id"];
        }
    };
    DeviceDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceDetailDto();
        result.init(data);
        return result;
    };
    DeviceDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["virtualDeviceState"] = this.virtualDeviceState;
        data["deviceGroupName"] = this.deviceGroupName;
        data["address"] = this.address;
        data["orderNumber"] = this.orderNumber;
        data["companyName"] = this.companyName;
        data["devicePattern"] = this.devicePattern;
        data["state"] = this.state;
        data["remark"] = this.remark;
        data["deviceContractNumber"] = this.deviceContractNumber;
        data["deviceProductionDate"] = this.deviceProductionDate ? this.deviceProductionDate.toISOString() : undefined;
        data["deviceDeliveryDate"] = this.deviceDeliveryDate ? this.deviceDeliveryDate.toISOString() : undefined;
        data["devicePicture"] = this.devicePicture;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["permissionCategory"] = this.permissionCategory;
        if (this.commonDeviceSns && this.commonDeviceSns.constructor === Array) {
            data["commonDeviceSns"] = [];
            for (var _i = 0, _a = this.commonDeviceSns; _i < _a.length; _i++) {
                var item = _a[_i];
                data["commonDeviceSns"].push(item);
            }
        }
        data["creatorName"] = this.creatorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["id"] = this.id;
        return data;
    };
    return DeviceDetailDto;
}());
export { DeviceDetailDto };
var DeviceModelListDto = /** @class */ (function () {
    function DeviceModelListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceModelListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.industry = data["industry"];
            this.remark = data["remark"];
            this.configId = data["ConfigId"];
            this.permissionCategory = data["permissionCategory"];
            this.id = data["id"];
        }
    };
    DeviceModelListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceModelListDto();
        result.init(data);
        return result;
    };
    DeviceModelListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["industry"] = this.industry;
        data["remark"] = this.remark;
        data["ConfigId"] = this.configId;
        data["permissionCategory"] = this.permissionCategory;
        data["id"] = this.id;
        return data;
    };
    return DeviceModelListDto;
}());
export { DeviceModelListDto };
var DeviceForIoTDto = /** @class */ (function () {
    function DeviceForIoTDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceForIoTDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.deviceModelId = data["deviceModelId"];
            this.deviceModelName = data["deviceModelName"];
        }
    };
    DeviceForIoTDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceForIoTDto();
        result.init(data);
        return result;
    };
    DeviceForIoTDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["deviceModelId"] = this.deviceModelId;
        data["deviceModelName"] = this.deviceModelName;
        return data;
    };
    return DeviceForIoTDto;
}());
export { DeviceForIoTDto };
var DeviceBaseInfoDto = /** @class */ (function () {
    function DeviceBaseInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceBaseInfoDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.permissionCategory = data["permissionCategory"];
            this.deviceModelId = data["deviceModelId"];
        }
    };
    DeviceBaseInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceBaseInfoDto();
        result.init(data);
        return result;
    };
    DeviceBaseInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["permissionCategory"] = this.permissionCategory;
        data["deviceModelId"] = this.deviceModelId;
        return data;
    };
    return DeviceBaseInfoDto;
}());
export { DeviceBaseInfoDto };
/** 设置设备缩略图 Dto */
var DeviceThumbnailForDetailDto = /** @class */ (function () {
    function DeviceThumbnailForDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceThumbnailForDetailDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.devicePictureId = data["devicePictureId"];
        }
    };
    DeviceThumbnailForDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceThumbnailForDetailDto();
        result.init(data);
        return result;
    };
    DeviceThumbnailForDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["devicePictureId"] = this.devicePictureId;
        return data;
    };
    return DeviceThumbnailForDetailDto;
}());
export { DeviceThumbnailForDetailDto };
var PagedResultDtoOfDeviceDocumentDto = /** @class */ (function () {
    function PagedResultDtoOfDeviceDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDeviceDocumentDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceDocumentDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDeviceDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDeviceDocumentDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDeviceDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDeviceDocumentDto;
}());
export { PagedResultDtoOfDeviceDocumentDto };
var DeviceDocumentDto = /** @class */ (function () {
    function DeviceDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceDocumentDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.documentType = data["documentType"];
            this.documentTypeStr = data["documentTypeStr"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorName = data["creatorName"];
            this.parentId = data["parentId"];
            this.depth = data["depth"];
            this.id = data["id"];
        }
    };
    DeviceDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceDocumentDto();
        result.init(data);
        return result;
    };
    DeviceDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["documentType"] = this.documentType;
        data["documentTypeStr"] = this.documentTypeStr;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorName"] = this.creatorName;
        data["parentId"] = this.parentId;
        data["depth"] = this.depth;
        data["id"] = this.id;
        return data;
    };
    return DeviceDocumentDto;
}());
export { DeviceDocumentDto };
var DeviceFolderListDto = /** @class */ (function () {
    function DeviceFolderListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceFolderListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.depth = data["depth"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    DeviceFolderListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceFolderListDto();
        result.init(data);
        return result;
    };
    DeviceFolderListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["depth"] = this.depth;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return DeviceFolderListDto;
}());
export { DeviceFolderListDto };
var CreateOrUpdateDeviceDocumentFolderDto = /** @class */ (function () {
    function CreateOrUpdateDeviceDocumentFolderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateDeviceDocumentFolderDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateDeviceDocumentFolderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateDeviceDocumentFolderDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateDeviceDocumentFolderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateDeviceDocumentFolderDto;
}());
export { CreateOrUpdateDeviceDocumentFolderDto };
var BatchDeleteFolderOrDocumentDto = /** @class */ (function () {
    function BatchDeleteFolderOrDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchDeleteFolderOrDocumentDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (var _i = 0, _a = data["ids"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.ids.push(item);
                }
            }
        }
    };
    BatchDeleteFolderOrDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchDeleteFolderOrDocumentDto();
        result.init(data);
        return result;
    };
    BatchDeleteFolderOrDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (var _i = 0, _a = this.ids; _i < _a.length; _i++) {
                var item = _a[_i];
                data["ids"].push(item);
            }
        }
        return data;
    };
    return BatchDeleteFolderOrDocumentDto;
}());
export { BatchDeleteFolderOrDocumentDto };
var CreateDeviceGroupDto = /** @class */ (function () {
    function CreateDeviceGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateDeviceGroupDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
            this.groupComment = data["groupComment"];
            this.type = data["type"];
        }
    };
    CreateDeviceGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateDeviceGroupDto();
        result.init(data);
        return result;
    };
    CreateDeviceGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["groupComment"] = this.groupComment;
        data["type"] = this.type;
        return data;
    };
    return CreateDeviceGroupDto;
}());
export { CreateDeviceGroupDto };
var DeviceGroupDto = /** @class */ (function () {
    function DeviceGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceGroupDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.type = data["type"];
            this.groupComment = data["groupComment"];
            this.deviceCount = data["deviceCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    DeviceGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceGroupDto();
        result.init(data);
        return result;
    };
    DeviceGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["groupComment"] = this.groupComment;
        data["deviceCount"] = this.deviceCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return DeviceGroupDto;
}());
export { DeviceGroupDto };
var UpdateDeviceGroupDto = /** @class */ (function () {
    function UpdateDeviceGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateDeviceGroupDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.groupComment = data["groupComment"];
            this.type = data["type"];
        }
    };
    UpdateDeviceGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateDeviceGroupDto();
        result.init(data);
        return result;
    };
    UpdateDeviceGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["groupComment"] = this.groupComment;
        data["type"] = this.type;
        return data;
    };
    return UpdateDeviceGroupDto;
}());
export { UpdateDeviceGroupDto };
var MoveDeviceGroupDto = /** @class */ (function () {
    function MoveDeviceGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MoveDeviceGroupDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    };
    MoveDeviceGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MoveDeviceGroupDto();
        result.init(data);
        return result;
    };
    MoveDeviceGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    };
    return MoveDeviceGroupDto;
}());
export { MoveDeviceGroupDto };
var ListResultDtoOfDeviceGroupDto = /** @class */ (function () {
    function ListResultDtoOfDeviceGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeviceGroupDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceGroupDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeviceGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeviceGroupDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeviceGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeviceGroupDto;
}());
export { ListResultDtoOfDeviceGroupDto };
var ListResultDtoOfDeviceGroupListDto = /** @class */ (function () {
    function ListResultDtoOfDeviceGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeviceGroupListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceGroupListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeviceGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeviceGroupListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeviceGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeviceGroupListDto;
}());
export { ListResultDtoOfDeviceGroupListDto };
var DeviceGroupListDto = /** @class */ (function () {
    function DeviceGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceGroupListDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.parentId = data["parentId"];
            this.id = data["id"];
        }
    };
    DeviceGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceGroupListDto();
        result.init(data);
        return result;
    };
    DeviceGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data;
    };
    return DeviceGroupListDto;
}());
export { DeviceGroupListDto };
var FindDeviceGroupDevicesDto = /** @class */ (function () {
    function FindDeviceGroupDevicesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindDeviceGroupDevicesDto.prototype.init = function (data) {
        if (data) {
            this.deviceGroupId = data["deviceGroupId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    };
    FindDeviceGroupDevicesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindDeviceGroupDevicesDto();
        result.init(data);
        return result;
    };
    FindDeviceGroupDevicesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceGroupId"] = this.deviceGroupId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    };
    return FindDeviceGroupDevicesDto;
}());
export { FindDeviceGroupDevicesDto };
var PagedResultDtoOfDeviceGroupDevicesListDto = /** @class */ (function () {
    function PagedResultDtoOfDeviceGroupDevicesListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDeviceGroupDevicesListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceGroupDevicesListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDeviceGroupDevicesListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDeviceGroupDevicesListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDeviceGroupDevicesListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDeviceGroupDevicesListDto;
}());
export { PagedResultDtoOfDeviceGroupDevicesListDto };
var DeviceGroupDevicesListDto = /** @class */ (function () {
    function DeviceGroupDevicesListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceGroupDevicesListDto.prototype.init = function (data) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.deviceModelName = data["deviceModelName"];
            this.orderNumber = data["orderNumber"];
            this.serialNumber = data["serialNumber"];
            this.client = data["client"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    DeviceGroupDevicesListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceGroupDevicesListDto();
        result.init(data);
        return result;
    };
    DeviceGroupDevicesListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["deviceModelName"] = this.deviceModelName;
        data["orderNumber"] = this.orderNumber;
        data["serialNumber"] = this.serialNumber;
        data["client"] = this.client;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return DeviceGroupDevicesListDto;
}());
export { DeviceGroupDevicesListDto };
var DevicesToDeviceGroupDto = /** @class */ (function () {
    function DevicesToDeviceGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DevicesToDeviceGroupDto.prototype.init = function (data) {
        if (data) {
            if (data["deviceIds"] && data["deviceIds"].constructor === Array) {
                this.deviceIds = [];
                for (var _i = 0, _a = data["deviceIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.deviceIds.push(item);
                }
            }
            this.deviceGroupId = data["deviceGroupId"];
        }
    };
    DevicesToDeviceGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DevicesToDeviceGroupDto();
        result.init(data);
        return result;
    };
    DevicesToDeviceGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceIds && this.deviceIds.constructor === Array) {
            data["deviceIds"] = [];
            for (var _i = 0, _a = this.deviceIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["deviceIds"].push(item);
            }
        }
        data["deviceGroupId"] = this.deviceGroupId;
        return data;
    };
    return DevicesToDeviceGroupDto;
}());
export { DevicesToDeviceGroupDto };
var PagedResultDtoOfDeviceInfoCount = /** @class */ (function () {
    function PagedResultDtoOfDeviceInfoCount(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDeviceInfoCount.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceInfoCount.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDeviceInfoCount.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDeviceInfoCount();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDeviceInfoCount.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDeviceInfoCount;
}());
export { PagedResultDtoOfDeviceInfoCount };
var DeviceInfoCount = /** @class */ (function () {
    function DeviceInfoCount(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceInfoCount.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.companyName = data["companyName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isActive = data["isActive"];
            this.editionId = data["editionId"];
            this.deviceCount = data["deviceCount"];
            this.onlineDeviceCount = data["onlineDeviceCount"];
            this.alarmingDeviceCount = data["alarmingDeviceCount"];
            this.offlineDeviceCount = data["offlineDeviceCount"];
            this.userCount = data["userCount"];
            this.deviceModelCount = data["deviceModelCount"];
            this.boxCount = data["boxCount"];
            this.proportionOfDeviceAndBox = data["proportionOfDeviceAndBox"];
        }
    };
    DeviceInfoCount.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceInfoCount();
        result.init(data);
        return result;
    };
    DeviceInfoCount.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["companyName"] = this.companyName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isActive"] = this.isActive;
        data["editionId"] = this.editionId;
        data["deviceCount"] = this.deviceCount;
        data["onlineDeviceCount"] = this.onlineDeviceCount;
        data["alarmingDeviceCount"] = this.alarmingDeviceCount;
        data["offlineDeviceCount"] = this.offlineDeviceCount;
        data["userCount"] = this.userCount;
        data["deviceModelCount"] = this.deviceModelCount;
        data["boxCount"] = this.boxCount;
        data["proportionOfDeviceAndBox"] = this.proportionOfDeviceAndBox;
        return data;
    };
    return DeviceInfoCount;
}());
export { DeviceInfoCount };
var ExportTenantsReqDto = /** @class */ (function () {
    function ExportTenantsReqDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportTenantsReqDto.prototype.init = function (data) {
        if (data) {
            this.filter = data["filter"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : undefined;
            this.creationDateStart = data["creationDateStart"] ? moment(data["creationDateStart"].toString()) : undefined;
            this.creationDateEnd = data["creationDateEnd"] ? moment(data["creationDateEnd"].toString()) : undefined;
            this.editionId = data["editionId"];
            this.editionIdSpecified = data["editionIdSpecified"];
            this.sorting = data["sorting"];
        }
    };
    ExportTenantsReqDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportTenantsReqDto();
        result.init(data);
        return result;
    };
    ExportTenantsReqDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : undefined;
        data["creationDateStart"] = this.creationDateStart ? this.creationDateStart.toISOString() : undefined;
        data["creationDateEnd"] = this.creationDateEnd ? this.creationDateEnd.toISOString() : undefined;
        data["editionId"] = this.editionId;
        data["editionIdSpecified"] = this.editionIdSpecified;
        data["sorting"] = this.sorting;
        return data;
    };
    return ExportTenantsReqDto;
}());
export { ExportTenantsReqDto };
/** 设备列表查询Dto */
var DeviceListQueryDto = /** @class */ (function () {
    function DeviceListQueryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceListQueryDto.prototype.init = function (data) {
        if (data) {
            this.deviceListPagedResult = data["deviceListPagedResult"] ? PagedResultDtoOfDeviceListDto.fromJS(data["deviceListPagedResult"]) : undefined;
            this.deviceStateCount = data["deviceStateCount"] ? DeviceStateCountDto.fromJS(data["deviceStateCount"]) : undefined;
        }
    };
    DeviceListQueryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceListQueryDto();
        result.init(data);
        return result;
    };
    DeviceListQueryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceListPagedResult"] = this.deviceListPagedResult ? this.deviceListPagedResult.toJSON() : undefined;
        data["deviceStateCount"] = this.deviceStateCount ? this.deviceStateCount.toJSON() : undefined;
        return data;
    };
    return DeviceListQueryDto;
}());
export { DeviceListQueryDto };
var PagedResultDtoOfDeviceListDto = /** @class */ (function () {
    function PagedResultDtoOfDeviceListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDeviceListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDeviceListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDeviceListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDeviceListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDeviceListDto;
}());
export { PagedResultDtoOfDeviceListDto };
/** 设备状态数dto */
var DeviceStateCountDto = /** @class */ (function () {
    function DeviceStateCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceStateCountDto.prototype.init = function (data) {
        if (data) {
            this.onlineDeviceNum = data["onlineDeviceNum"];
            this.offlineDeviceNum = data["offlineDeviceNum"];
            this.alarmingNum = data["alarmingNum"];
            this.unboundNum = data["unboundNum"];
        }
    };
    DeviceStateCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceStateCountDto();
        result.init(data);
        return result;
    };
    DeviceStateCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["onlineDeviceNum"] = this.onlineDeviceNum;
        data["offlineDeviceNum"] = this.offlineDeviceNum;
        data["alarmingNum"] = this.alarmingNum;
        data["unboundNum"] = this.unboundNum;
        return data;
    };
    return DeviceStateCountDto;
}());
export { DeviceStateCountDto };
/** 设备列表Dto */
var DeviceListDto = /** @class */ (function () {
    function DeviceListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.configureId = data["configureId"];
            this.serialNumber = data["serialNumber"];
            this.orderNumber = data["orderNumber"];
            this.remark = data["remark"];
            this.deviceModel = data["deviceModel"] ? DeviceModelNameDto.fromJS(data["deviceModel"]) : undefined;
            this.companyName = data["companyName"];
            this.commDeviceSn = data["commDeviceSn"];
            this.activationErrorType = data["activationErrorType"];
            this.address = data["address"];
            this.cameraCount = data["cameraCount"];
            if (data["communicationDeviceSns"] && data["communicationDeviceSns"].constructor === Array) {
                this.communicationDeviceSns = [];
                for (var _i = 0, _a = data["communicationDeviceSns"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.communicationDeviceSns.push(item);
                }
            }
            this.virtualDeviceId = data["virtualDeviceId"];
            this.groupName = data["groupName"];
            this.devicePattern = data["devicePattern"];
            this.deviceProductionDate = data["deviceProductionDate"] ? moment(data["deviceProductionDate"].toString()) : undefined;
            this.deviceDeliveryDate = data["deviceDeliveryDate"] ? moment(data["deviceDeliveryDate"].toString()) : undefined;
            this.devicePicture = data["devicePicture"];
            this.permissionCategory = data["permissionCategory"];
            this.deviceCommunicateState = data["deviceCommunicateState"];
            this.creatorName = data["creatorName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.provinceName = data["provinceName"];
            this.cityName = data["cityName"];
            this.districtName = data["districtName"];
            this.id = data["id"];
        }
    };
    DeviceListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceListDto();
        result.init(data);
        return result;
    };
    DeviceListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["configureId"] = this.configureId;
        data["serialNumber"] = this.serialNumber;
        data["orderNumber"] = this.orderNumber;
        data["remark"] = this.remark;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        data["companyName"] = this.companyName;
        data["commDeviceSn"] = this.commDeviceSn;
        data["activationErrorType"] = this.activationErrorType;
        data["address"] = this.address;
        data["cameraCount"] = this.cameraCount;
        if (this.communicationDeviceSns && this.communicationDeviceSns.constructor === Array) {
            data["communicationDeviceSns"] = [];
            for (var _i = 0, _a = this.communicationDeviceSns; _i < _a.length; _i++) {
                var item = _a[_i];
                data["communicationDeviceSns"].push(item);
            }
        }
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["groupName"] = this.groupName;
        data["devicePattern"] = this.devicePattern;
        data["deviceProductionDate"] = this.deviceProductionDate ? this.deviceProductionDate.toISOString() : undefined;
        data["deviceDeliveryDate"] = this.deviceDeliveryDate ? this.deviceDeliveryDate.toISOString() : undefined;
        data["devicePicture"] = this.devicePicture;
        data["permissionCategory"] = this.permissionCategory;
        data["deviceCommunicateState"] = this.deviceCommunicateState;
        data["creatorName"] = this.creatorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["provinceName"] = this.provinceName;
        data["cityName"] = this.cityName;
        data["districtName"] = this.districtName;
        data["id"] = this.id;
        return data;
    };
    return DeviceListDto;
}());
export { DeviceListDto };
var DeviceModelNameDto = /** @class */ (function () {
    function DeviceModelNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceModelNameDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    DeviceModelNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceModelNameDto();
        result.init(data);
        return result;
    };
    DeviceModelNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return DeviceModelNameDto;
}());
export { DeviceModelNameDto };
var ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto = /** @class */ (function () {
    function ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto.prototype.init = function (data) {
        if (data) {
            if (data["item1"] && data["item1"].constructor === Array) {
                this.item1 = [];
                for (var _i = 0, _a = data["item1"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.item1.push(DeviceListDto.fromJS(item));
                }
            }
            this.item2 = data["item2"];
            this.item3 = data["item3"] ? DeviceStateCountDto.fromJS(data["item3"]) : undefined;
        }
    };
    ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto();
        result.init(data);
        return result;
    };
    ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.item1 && this.item1.constructor === Array) {
            data["item1"] = [];
            for (var _i = 0, _a = this.item1; _i < _a.length; _i++) {
                var item = _a[_i];
                data["item1"].push(item.toJSON());
            }
        }
        data["item2"] = this.item2;
        data["item3"] = this.item3 ? this.item3.toJSON() : undefined;
        return data;
    };
    return ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto;
}());
export { ValueTupleOfIQueryableOfDeviceListDtoAndInt32AndDeviceStateCountDto };
/** 导出设备列表的查询Dto */
var ExportDeviceCondition = /** @class */ (function () {
    function ExportDeviceCondition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportDeviceCondition.prototype.init = function (data) {
        if (data) {
            this.deviceCommunicateState = data["deviceCommunicateState"];
            this.deviceModelId = data["deviceModelId"];
            this.deviceGroupId = data["deviceGroupId"];
            this.address = data["address"];
            this.deviceNameOrSerialNo = data["deviceNameOrSerialNo"];
            this.boxSerialNumber = data["boxSerialNumber"];
            this.orderNumber = data["orderNumber"];
            this.deviceProductionStartDate = data["deviceProductionStartDate"] ? moment(data["deviceProductionStartDate"].toString()) : undefined;
            this.deviceProductionEndDate = data["deviceProductionEndDate"] ? moment(data["deviceProductionEndDate"].toString()) : undefined;
            this.deviceDeliveryStartDate = data["deviceDeliveryStartDate"] ? moment(data["deviceDeliveryStartDate"].toString()) : undefined;
            this.deviceDeliveryEndDate = data["deviceDeliveryEndDate"] ? moment(data["deviceDeliveryEndDate"].toString()) : undefined;
            this.creationStartTime = data["creationStartTime"] ? moment(data["creationStartTime"].toString()) : undefined;
            this.creationEndTime = data["creationEndTime"] ? moment(data["creationEndTime"].toString()) : undefined;
            this.markTableDataFavorites = data["markTableDataFavorites"];
            this.devicePattern = data["devicePattern"];
            if (data["deviceIdList"] && data["deviceIdList"].constructor === Array) {
                this.deviceIdList = [];
                for (var _i = 0, _a = data["deviceIdList"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.deviceIdList.push(item);
                }
            }
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
        }
    };
    ExportDeviceCondition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportDeviceCondition();
        result.init(data);
        return result;
    };
    ExportDeviceCondition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceCommunicateState"] = this.deviceCommunicateState;
        data["deviceModelId"] = this.deviceModelId;
        data["deviceGroupId"] = this.deviceGroupId;
        data["address"] = this.address;
        data["deviceNameOrSerialNo"] = this.deviceNameOrSerialNo;
        data["boxSerialNumber"] = this.boxSerialNumber;
        data["orderNumber"] = this.orderNumber;
        data["deviceProductionStartDate"] = this.deviceProductionStartDate ? this.deviceProductionStartDate.toISOString() : undefined;
        data["deviceProductionEndDate"] = this.deviceProductionEndDate ? this.deviceProductionEndDate.toISOString() : undefined;
        data["deviceDeliveryStartDate"] = this.deviceDeliveryStartDate ? this.deviceDeliveryStartDate.toISOString() : undefined;
        data["deviceDeliveryEndDate"] = this.deviceDeliveryEndDate ? this.deviceDeliveryEndDate.toISOString() : undefined;
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : undefined;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : undefined;
        data["markTableDataFavorites"] = this.markTableDataFavorites;
        data["devicePattern"] = this.devicePattern;
        if (this.deviceIdList && this.deviceIdList.constructor === Array) {
            data["deviceIdList"] = [];
            for (var _i = 0, _a = this.deviceIdList; _i < _a.length; _i++) {
                var item = _a[_i];
                data["deviceIdList"].push(item);
            }
        }
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        return data;
    };
    return ExportDeviceCondition;
}());
export { ExportDeviceCondition };
var BoxLogDto = /** @class */ (function () {
    function BoxLogDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BoxLogDto.prototype.init = function (data) {
        if (data) {
            this.timestamp = data["timestamp"] ? moment(data["timestamp"].toString()) : undefined;
            this.boxSerialNumber = data["boxSerialNumber"];
            this.boxEvent = data["boxEvent"];
        }
    };
    BoxLogDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BoxLogDto();
        result.init(data);
        return result;
    };
    BoxLogDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["boxSerialNumber"] = this.boxSerialNumber;
        data["boxEvent"] = this.boxEvent;
        return data;
    };
    return BoxLogDto;
}());
export { BoxLogDto };
var GetBoxLogDto = /** @class */ (function () {
    function GetBoxLogDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBoxLogDto.prototype.init = function (data) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : undefined;
            this.offset = data["offset"];
            this.boxSerialNumber = data["boxSerialNumber"];
        }
    };
    GetBoxLogDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBoxLogDto();
        result.init(data);
        return result;
    };
    GetBoxLogDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["offset"] = this.offset;
        data["boxSerialNumber"] = this.boxSerialNumber;
        return data;
    };
    return GetBoxLogDto;
}());
export { GetBoxLogDto };
var DeviceMaintenancePlanDto = /** @class */ (function () {
    function DeviceMaintenancePlanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceMaintenancePlanDto.prototype.init = function (data) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.serialNumber = data["serialNumber"];
            this.deviceModelName = data["deviceModelName"];
            this.commDeviceSn = data["commDeviceSn"];
            this.address = data["address"];
            this.customer = data["customer"];
            this.customerContact = data["customerContact"];
            if (data["maintenancePlans"] && data["maintenancePlans"].constructor === Array) {
                this.maintenancePlans = [];
                for (var _i = 0, _a = data["maintenancePlans"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.maintenancePlans.push(MaintenancePlanDto.fromJS(item));
                }
            }
        }
    };
    DeviceMaintenancePlanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceMaintenancePlanDto();
        result.init(data);
        return result;
    };
    DeviceMaintenancePlanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["serialNumber"] = this.serialNumber;
        data["deviceModelName"] = this.deviceModelName;
        data["commDeviceSn"] = this.commDeviceSn;
        data["address"] = this.address;
        data["customer"] = this.customer;
        data["customerContact"] = this.customerContact;
        if (this.maintenancePlans && this.maintenancePlans.constructor === Array) {
            data["maintenancePlans"] = [];
            for (var _i = 0, _a = this.maintenancePlans; _i < _a.length; _i++) {
                var item = _a[_i];
                data["maintenancePlans"].push(item.toJSON());
            }
        }
        return data;
    };
    return DeviceMaintenancePlanDto;
}());
export { DeviceMaintenancePlanDto };
var MaintenancePlanDto = /** @class */ (function () {
    function MaintenancePlanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MaintenancePlanDto.prototype.init = function (data) {
        if (data) {
            this.planName = data["planName"];
            this.warrantyPeriod = data["warrantyPeriod"];
            this.warrantyPeriodCycleType = data["warrantyPeriodCycleType"];
            this.warrantyCycle = data["warrantyCycle"];
            this.warrantyCycleType = data["warrantyCycleType"];
            this.firstMaintenanceTime = data["firstMaintenanceTime"] ? moment(data["firstMaintenanceTime"].toString()) : undefined;
            this.isAutoStopExpired = data["isAutoStopExpired"];
            this.notifyType = data["notifyType"];
            this.warrantyType = data["warrantyType"];
            this.deviceName = data["deviceName"];
            this.customerName = data["customerName"];
            this.nextMaintenanceDate = data["nextMaintenanceDate"] ? moment(data["nextMaintenanceDate"].toString()) : undefined;
            this.planState = data["planState"];
            this.deviceId = data["deviceId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    MaintenancePlanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MaintenancePlanDto();
        result.init(data);
        return result;
    };
    MaintenancePlanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["planName"] = this.planName;
        data["warrantyPeriod"] = this.warrantyPeriod;
        data["warrantyPeriodCycleType"] = this.warrantyPeriodCycleType;
        data["warrantyCycle"] = this.warrantyCycle;
        data["warrantyCycleType"] = this.warrantyCycleType;
        data["firstMaintenanceTime"] = this.firstMaintenanceTime ? this.firstMaintenanceTime.toISOString() : undefined;
        data["isAutoStopExpired"] = this.isAutoStopExpired;
        data["notifyType"] = this.notifyType;
        data["warrantyType"] = this.warrantyType;
        data["deviceName"] = this.deviceName;
        data["customerName"] = this.customerName;
        data["nextMaintenanceDate"] = this.nextMaintenanceDate ? this.nextMaintenanceDate.toISOString() : undefined;
        data["planState"] = this.planState;
        data["deviceId"] = this.deviceId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return MaintenancePlanDto;
}());
export { MaintenancePlanDto };
var PagedResultDtoOfDeviceModelListDto = /** @class */ (function () {
    function PagedResultDtoOfDeviceModelListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDeviceModelListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceModelListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDeviceModelListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDeviceModelListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDeviceModelListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDeviceModelListDto;
}());
export { PagedResultDtoOfDeviceModelListDto };
var GetDeviceModelForEditDto = /** @class */ (function () {
    function GetDeviceModelForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDeviceModelForEditDto.prototype.init = function (data) {
        if (data) {
            this.deviceModel = data["deviceModel"] ? DeviceModelEditDto.fromJS(data["deviceModel"]) : undefined;
        }
    };
    GetDeviceModelForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDeviceModelForEditDto();
        result.init(data);
        return result;
    };
    GetDeviceModelForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        return data;
    };
    return GetDeviceModelForEditDto;
}());
export { GetDeviceModelForEditDto };
var DeviceModelEditDto = /** @class */ (function () {
    function DeviceModelEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceModelEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.industry = data["industry"];
            this.modelGroupId = data["modelGroupId"];
            this.remark = data["remark"];
            this.id = data["id"];
        }
    };
    DeviceModelEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceModelEditDto();
        result.init(data);
        return result;
    };
    DeviceModelEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["industry"] = this.industry;
        data["modelGroupId"] = this.modelGroupId;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    };
    return DeviceModelEditDto;
}());
export { DeviceModelEditDto };
var CreateOrUpdateDeviceModelDto = /** @class */ (function () {
    function CreateOrUpdateDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.deviceModel = new DeviceModelEditDto();
        }
    }
    CreateOrUpdateDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.deviceModel = data["deviceModel"] ? DeviceModelEditDto.fromJS(data["deviceModel"]) : new DeviceModelEditDto();
        }
    };
    CreateOrUpdateDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateDeviceModelDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        return data;
    };
    return CreateOrUpdateDeviceModelDto;
}());
export { CreateOrUpdateDeviceModelDto };
var ListResultDtoOfDeviceModelListDto = /** @class */ (function () {
    function ListResultDtoOfDeviceModelListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeviceModelListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceModelListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeviceModelListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeviceModelListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeviceModelListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeviceModelListDto;
}());
export { ListResultDtoOfDeviceModelListDto };
var DeviceModelSelectorDto = /** @class */ (function () {
    function DeviceModelSelectorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceModelSelectorDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    DeviceModelSelectorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceModelSelectorDto();
        result.init(data);
        return result;
    };
    DeviceModelSelectorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return DeviceModelSelectorDto;
}());
export { DeviceModelSelectorDto };
var PagedResultDtoOfDeviceModelsOfGroupDto = /** @class */ (function () {
    function PagedResultDtoOfDeviceModelsOfGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDeviceModelsOfGroupDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceModelsOfGroupDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDeviceModelsOfGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDeviceModelsOfGroupDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDeviceModelsOfGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDeviceModelsOfGroupDto;
}());
export { PagedResultDtoOfDeviceModelsOfGroupDto };
var DeviceModelsOfGroupDto = /** @class */ (function () {
    function DeviceModelsOfGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceModelsOfGroupDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.industry = data["industry"];
            this.remark = data["remark"];
            this.configId = data["ConfigId"];
            this.modelGroupName = data["modelGroupName"];
            this.permissionCategory = data["permissionCategory"];
            this.id = data["id"];
        }
    };
    DeviceModelsOfGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceModelsOfGroupDto();
        result.init(data);
        return result;
    };
    DeviceModelsOfGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["industry"] = this.industry;
        data["remark"] = this.remark;
        data["ConfigId"] = this.configId;
        data["modelGroupName"] = this.modelGroupName;
        data["permissionCategory"] = this.permissionCategory;
        data["id"] = this.id;
        return data;
    };
    return DeviceModelsOfGroupDto;
}());
export { DeviceModelsOfGroupDto };
var MoveModelGroupDto = /** @class */ (function () {
    function MoveModelGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MoveModelGroupDto.prototype.init = function (data) {
        if (data) {
            if (data["modelIds"] && data["modelIds"].constructor === Array) {
                this.modelIds = [];
                for (var _i = 0, _a = data["modelIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.modelIds.push(item);
                }
            }
            this.modelGroupId = data["modelGroupId"];
        }
    };
    MoveModelGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MoveModelGroupDto();
        result.init(data);
        return result;
    };
    MoveModelGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.modelIds && this.modelIds.constructor === Array) {
            data["modelIds"] = [];
            for (var _i = 0, _a = this.modelIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["modelIds"].push(item);
            }
        }
        data["modelGroupId"] = this.modelGroupId;
        return data;
    };
    return MoveModelGroupDto;
}());
export { MoveModelGroupDto };
var DeviceViewDto = /** @class */ (function () {
    function DeviceViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceViewDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.configureId = data["configureId"];
            this.serialNumber = data["serialNumber"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.deviceModelName = data["deviceModelName"];
            this.companyName = data["companyName"];
            if (data["configurePermissions"] && data["configurePermissions"].constructor === Array) {
                this.configurePermissions = [];
                for (var _i = 0, _a = data["configurePermissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.configurePermissions.push(item);
                }
            }
            if (data["communicationDeviceSns"] && data["communicationDeviceSns"].constructor === Array) {
                this.communicationDeviceSns = [];
                for (var _b = 0, _c = data["communicationDeviceSns"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.communicationDeviceSns.push(item);
                }
            }
            this.virtualDeviceId = data["virtualDeviceId"];
            this.virtualDeviceState = data["virtualDeviceState"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.id = data["id"];
        }
    };
    DeviceViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceViewDto();
        result.init(data);
        return result;
    };
    DeviceViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["configureId"] = this.configureId;
        data["serialNumber"] = this.serialNumber;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["deviceModelName"] = this.deviceModelName;
        data["companyName"] = this.companyName;
        if (this.configurePermissions && this.configurePermissions.constructor === Array) {
            data["configurePermissions"] = [];
            for (var _i = 0, _a = this.configurePermissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["configurePermissions"].push(item);
            }
        }
        if (this.communicationDeviceSns && this.communicationDeviceSns.constructor === Array) {
            data["communicationDeviceSns"] = [];
            for (var _b = 0, _c = this.communicationDeviceSns; _b < _c.length; _b++) {
                var item = _c[_b];
                data["communicationDeviceSns"].push(item);
            }
        }
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["virtualDeviceState"] = this.virtualDeviceState;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["id"] = this.id;
        return data;
    };
    return DeviceViewDto;
}());
export { DeviceViewDto };
var DeviceTreeWithRegionDto = /** @class */ (function () {
    function DeviceTreeWithRegionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceTreeWithRegionDto.prototype.init = function (data) {
        if (data) {
            if (data["devices"] && data["devices"].constructor === Array) {
                this.devices = [];
                for (var _i = 0, _a = data["devices"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.devices.push(DeviceTreeDto.fromJS(item));
                }
            }
            if (data["regions"] && data["regions"].constructor === Array) {
                this.regions = [];
                for (var _b = 0, _c = data["regions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.regions.push(RegionListDto.fromJS(item));
                }
            }
        }
    };
    DeviceTreeWithRegionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceTreeWithRegionDto();
        result.init(data);
        return result;
    };
    DeviceTreeWithRegionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.devices && this.devices.constructor === Array) {
            data["devices"] = [];
            for (var _i = 0, _a = this.devices; _i < _a.length; _i++) {
                var item = _a[_i];
                data["devices"].push(item.toJSON());
            }
        }
        if (this.regions && this.regions.constructor === Array) {
            data["regions"] = [];
            for (var _b = 0, _c = this.regions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["regions"].push(item.toJSON());
            }
        }
        return data;
    };
    return DeviceTreeWithRegionDto;
}());
export { DeviceTreeWithRegionDto };
var DeviceTreeDto = /** @class */ (function () {
    function DeviceTreeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceTreeDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.districtId = data["districtId"];
            this.cityId = data["cityId"];
            this.provinceId = data["provinceId"];
            this.virtualDeviceState = data["virtualDeviceState"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.serialNumber = data["serialNumber"];
            this.id = data["id"];
        }
    };
    DeviceTreeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceTreeDto();
        result.init(data);
        return result;
    };
    DeviceTreeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["districtId"] = this.districtId;
        data["cityId"] = this.cityId;
        data["provinceId"] = this.provinceId;
        data["virtualDeviceState"] = this.virtualDeviceState;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["serialNumber"] = this.serialNumber;
        data["id"] = this.id;
        return data;
    };
    return DeviceTreeDto;
}());
export { DeviceTreeDto };
var RegionListDto = /** @class */ (function () {
    function RegionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegionListDto.prototype.init = function (data) {
        if (data) {
            this.regionId = data["regionId"];
            this.name = data["name"];
            this.parentId = data["parentId"];
        }
    };
    RegionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegionListDto();
        result.init(data);
        return result;
    };
    RegionListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    };
    return RegionListDto;
}());
export { RegionListDto };
var DeviceTreeWithExtentiontDto = /** @class */ (function () {
    function DeviceTreeWithExtentiontDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceTreeWithExtentiontDto.prototype.init = function (data) {
        if (data) {
            if (data["devices"] && data["devices"].constructor === Array) {
                this.devices = [];
                for (var _i = 0, _a = data["devices"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.devices.push(DeviceTreeForExtentionDto.fromJS(item));
                }
            }
            if (data["extentions"] && data["extentions"].constructor === Array) {
                this.extentions = [];
                for (var _b = 0, _c = data["extentions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.extentions.push(ExtentionListDto.fromJS(item));
                }
            }
        }
    };
    DeviceTreeWithExtentiontDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceTreeWithExtentiontDto();
        result.init(data);
        return result;
    };
    DeviceTreeWithExtentiontDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.devices && this.devices.constructor === Array) {
            data["devices"] = [];
            for (var _i = 0, _a = this.devices; _i < _a.length; _i++) {
                var item = _a[_i];
                data["devices"].push(item.toJSON());
            }
        }
        if (this.extentions && this.extentions.constructor === Array) {
            data["extentions"] = [];
            for (var _b = 0, _c = this.extentions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["extentions"].push(item.toJSON());
            }
        }
        return data;
    };
    return DeviceTreeWithExtentiontDto;
}());
export { DeviceTreeWithExtentiontDto };
var DeviceTreeForExtentionDto = /** @class */ (function () {
    function DeviceTreeForExtentionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceTreeForExtentionDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.virtualDeviceState = data["virtualDeviceState"];
            this.parentId = data["parentId"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.serialNumber = data["serialNumber"];
            this.deviceModelId = data["deviceModelId"];
            this.id = data["id"];
        }
    };
    DeviceTreeForExtentionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceTreeForExtentionDto();
        result.init(data);
        return result;
    };
    DeviceTreeForExtentionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["virtualDeviceState"] = this.virtualDeviceState;
        data["parentId"] = this.parentId;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["serialNumber"] = this.serialNumber;
        data["deviceModelId"] = this.deviceModelId;
        data["id"] = this.id;
        return data;
    };
    return DeviceTreeForExtentionDto;
}());
export { DeviceTreeForExtentionDto };
var ExtentionListDto = /** @class */ (function () {
    function ExtentionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExtentionListDto.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.name = data["name"];
            this.parentId = data["parentId"];
        }
    };
    ExtentionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExtentionListDto();
        result.init(data);
        return result;
    };
    ExtentionListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    };
    return ExtentionListDto;
}());
export { ExtentionListDto };
var DeviceUserPermissionDto = /** @class */ (function () {
    function DeviceUserPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceUserPermissionDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.name = data["name"];
            this.permissionCategory = data["permissionCategory"];
            if (data["configurePermissionNames"] && data["configurePermissionNames"].constructor === Array) {
                this.configurePermissionNames = [];
                for (var _i = 0, _a = data["configurePermissionNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.configurePermissionNames.push(item);
                }
            }
        }
    };
    DeviceUserPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceUserPermissionDto();
        result.init(data);
        return result;
    };
    DeviceUserPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["permissionCategory"] = this.permissionCategory;
        if (this.configurePermissionNames && this.configurePermissionNames.constructor === Array) {
            data["configurePermissionNames"] = [];
            for (var _i = 0, _a = this.configurePermissionNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["configurePermissionNames"].push(item);
            }
        }
        return data;
    };
    return DeviceUserPermissionDto;
}());
export { DeviceUserPermissionDto };
var ListResultDtoOfReleasedDataSourceWithPositionDto = /** @class */ (function () {
    function ListResultDtoOfReleasedDataSourceWithPositionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfReleasedDataSourceWithPositionDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ReleasedDataSourceWithPositionDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfReleasedDataSourceWithPositionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfReleasedDataSourceWithPositionDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfReleasedDataSourceWithPositionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfReleasedDataSourceWithPositionDto;
}());
export { ListResultDtoOfReleasedDataSourceWithPositionDto };
var ReleasedDataSourceWithPositionDto = /** @class */ (function () {
    function ReleasedDataSourceWithPositionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedDataSourceWithPositionDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.releasedConfigureId = data["releasedConfigureId"];
            this.type = data["type"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
        }
    };
    ReleasedDataSourceWithPositionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedDataSourceWithPositionDto();
        result.init(data);
        return result;
    };
    ReleasedDataSourceWithPositionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["releasedConfigureId"] = this.releasedConfigureId;
        data["type"] = this.type;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    };
    return ReleasedDataSourceWithPositionDto;
}());
export { ReleasedDataSourceWithPositionDto };
var PagedResultDtoOfDeviceRepairBomData = /** @class */ (function () {
    function PagedResultDtoOfDeviceRepairBomData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDeviceRepairBomData.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceRepairBomData.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDeviceRepairBomData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDeviceRepairBomData();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDeviceRepairBomData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDeviceRepairBomData;
}());
export { PagedResultDtoOfDeviceRepairBomData };
var DeviceRepairBomData = /** @class */ (function () {
    function DeviceRepairBomData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceRepairBomData.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.materialsName = data["materialsName"];
            this.materialsType = data["materialsType"];
            this.materialsCode = data["materialsCode"];
            this.materialsModel = data["materialsModel"];
            this.bitNumber = data["bitNumber"];
            this.material = data["material"];
            this.supplierName = data["supplierName"];
            this.price = data["price"];
            this.number = data["number"];
            this.unit = data["unit"];
            this.fileGuid = data["fileGuid"];
            this.serviceLife = data["serviceLife"];
            this.serviceLifeType = data["serviceLifeType"];
            this.maintenanceCycle = data["maintenanceCycle"];
            this.maintenanceCycleType = data["maintenanceCycleType"];
            this.maintenanceDetail = data["maintenanceDetail"];
            this.remarks = data["remarks"];
            this.parentNodeId = data["parentNodeId"];
            this.isRootAndHaveNoChildren = data["isRootAndHaveNoChildren"];
            this.isRoot = data["isRoot"];
            this.show = data["show"];
            this.expanded = data["expanded"];
        }
    };
    DeviceRepairBomData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceRepairBomData();
        result.init(data);
        return result;
    };
    DeviceRepairBomData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialsName"] = this.materialsName;
        data["materialsType"] = this.materialsType;
        data["materialsCode"] = this.materialsCode;
        data["materialsModel"] = this.materialsModel;
        data["bitNumber"] = this.bitNumber;
        data["material"] = this.material;
        data["supplierName"] = this.supplierName;
        data["price"] = this.price;
        data["number"] = this.number;
        data["unit"] = this.unit;
        data["fileGuid"] = this.fileGuid;
        data["serviceLife"] = this.serviceLife;
        data["serviceLifeType"] = this.serviceLifeType;
        data["maintenanceCycle"] = this.maintenanceCycle;
        data["maintenanceCycleType"] = this.maintenanceCycleType;
        data["maintenanceDetail"] = this.maintenanceDetail;
        data["remarks"] = this.remarks;
        data["parentNodeId"] = this.parentNodeId;
        data["isRootAndHaveNoChildren"] = this.isRootAndHaveNoChildren;
        data["isRoot"] = this.isRoot;
        data["show"] = this.show;
        data["expanded"] = this.expanded;
        return data;
    };
    return DeviceRepairBomData;
}());
export { DeviceRepairBomData };
var AddDeviceRepairBomDto = /** @class */ (function () {
    function AddDeviceRepairBomDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddDeviceRepairBomDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.materialsType = data["materialsType"];
            this.materialsName = data["materialsName"];
            this.materialsCode = data["materialsCode"];
            this.parentNodeId = data["parentNodeId"];
            this.materialsModel = data["materialsModel"];
            this.bitNumber = data["bitNumber"];
            this.material = data["material"];
            this.supplierName = data["supplierName"];
            this.price = data["price"];
            this.number = data["number"];
            this.unit = data["unit"];
            this.serviceLife = data["serviceLife"];
            this.serviceLifeType = data["serviceLifeType"];
            this.maintenanceCycle = data["maintenanceCycle"];
            this.maintenanceCycleType = data["maintenanceCycleType"];
            this.maintenanceDetail = data["maintenanceDetail"];
            this.remarks = data["remarks"];
            this.fileGuid = data["fileGuid"];
            this.deviceId = data["deviceId"];
        }
    };
    AddDeviceRepairBomDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddDeviceRepairBomDto();
        result.init(data);
        return result;
    };
    AddDeviceRepairBomDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialsType"] = this.materialsType;
        data["materialsName"] = this.materialsName;
        data["materialsCode"] = this.materialsCode;
        data["parentNodeId"] = this.parentNodeId;
        data["materialsModel"] = this.materialsModel;
        data["bitNumber"] = this.bitNumber;
        data["material"] = this.material;
        data["supplierName"] = this.supplierName;
        data["price"] = this.price;
        data["number"] = this.number;
        data["unit"] = this.unit;
        data["serviceLife"] = this.serviceLife;
        data["serviceLifeType"] = this.serviceLifeType;
        data["maintenanceCycle"] = this.maintenanceCycle;
        data["maintenanceCycleType"] = this.maintenanceCycleType;
        data["maintenanceDetail"] = this.maintenanceDetail;
        data["remarks"] = this.remarks;
        data["fileGuid"] = this.fileGuid;
        data["deviceId"] = this.deviceId;
        return data;
    };
    return AddDeviceRepairBomDto;
}());
export { AddDeviceRepairBomDto };
var ParentNodesDto = /** @class */ (function () {
    function ParentNodesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ParentNodesDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.materialsName = data["materialsName"];
        }
    };
    ParentNodesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ParentNodesDto();
        result.init(data);
        return result;
    };
    ParentNodesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialsName"] = this.materialsName;
        return data;
    };
    return ParentNodesDto;
}());
export { ParentNodesDto };
var OutputExcelFileDto = /** @class */ (function () {
    function OutputExcelFileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OutputExcelFileDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.queryStr = data["queryStr"];
        }
    };
    OutputExcelFileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OutputExcelFileDto();
        result.init(data);
        return result;
    };
    OutputExcelFileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["queryStr"] = this.queryStr;
        return data;
    };
    return OutputExcelFileDto;
}());
export { OutputExcelFileDto };
var ParseDataFromChartDto = /** @class */ (function () {
    function ParseDataFromChartDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ParseDataFromChartDto.prototype.init = function (data) {
        if (data) {
            this.fileId = data["fileId"];
            this.deviceId = data["deviceId"];
        }
    };
    ParseDataFromChartDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ParseDataFromChartDto();
        result.init(data);
        return result;
    };
    ParseDataFromChartDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["deviceId"] = this.deviceId;
        return data;
    };
    return ParseDataFromChartDto;
}());
export { ParseDataFromChartDto };
var PagedResultDtoOfNameCriteriaResultDtoOfString = /** @class */ (function () {
    function PagedResultDtoOfNameCriteriaResultDtoOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfNameCriteriaResultDtoOfString.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameCriteriaResultDtoOfString.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfNameCriteriaResultDtoOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfNameCriteriaResultDtoOfString();
        result.init(data);
        return result;
    };
    PagedResultDtoOfNameCriteriaResultDtoOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfNameCriteriaResultDtoOfString;
}());
export { PagedResultDtoOfNameCriteriaResultDtoOfString };
var NameCriteriaResultDtoOfString = /** @class */ (function () {
    function NameCriteriaResultDtoOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameCriteriaResultDtoOfString.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    NameCriteriaResultDtoOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameCriteriaResultDtoOfString();
        result.init(data);
        return result;
    };
    NameCriteriaResultDtoOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return NameCriteriaResultDtoOfString;
}());
export { NameCriteriaResultDtoOfString };
var PagedResultDtoOfNameCriteriaResultDtoOfInt32 = /** @class */ (function () {
    function PagedResultDtoOfNameCriteriaResultDtoOfInt32(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfNameCriteriaResultDtoOfInt32.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameCriteriaResultDtoOfInt32.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfNameCriteriaResultDtoOfInt32.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfNameCriteriaResultDtoOfInt32();
        result.init(data);
        return result;
    };
    PagedResultDtoOfNameCriteriaResultDtoOfInt32.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfNameCriteriaResultDtoOfInt32;
}());
export { PagedResultDtoOfNameCriteriaResultDtoOfInt32 };
var NameCriteriaResultDtoOfInt32 = /** @class */ (function () {
    function NameCriteriaResultDtoOfInt32(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameCriteriaResultDtoOfInt32.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    NameCriteriaResultDtoOfInt32.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameCriteriaResultDtoOfInt32();
        result.init(data);
        return result;
    };
    NameCriteriaResultDtoOfInt32.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return NameCriteriaResultDtoOfInt32;
}());
export { NameCriteriaResultDtoOfInt32 };
var PagedResultDtoOfNameCriteriaResultDtoOfInt64 = /** @class */ (function () {
    function PagedResultDtoOfNameCriteriaResultDtoOfInt64(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfNameCriteriaResultDtoOfInt64.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameCriteriaResultDtoOfInt64.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfNameCriteriaResultDtoOfInt64.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfNameCriteriaResultDtoOfInt64();
        result.init(data);
        return result;
    };
    PagedResultDtoOfNameCriteriaResultDtoOfInt64.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfNameCriteriaResultDtoOfInt64;
}());
export { PagedResultDtoOfNameCriteriaResultDtoOfInt64 };
var NameCriteriaResultDtoOfInt64 = /** @class */ (function () {
    function NameCriteriaResultDtoOfInt64(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameCriteriaResultDtoOfInt64.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    NameCriteriaResultDtoOfInt64.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameCriteriaResultDtoOfInt64();
        result.init(data);
        return result;
    };
    NameCriteriaResultDtoOfInt64.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return NameCriteriaResultDtoOfInt64;
}());
export { NameCriteriaResultDtoOfInt64 };
var CreateDocumentDto = /** @class */ (function () {
    function CreateDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateDocumentDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.privilege = data["privilege"];
            this.uploadFileDto = data["uploadFileDto"] ? UploadFileDto.fromJS(data["uploadFileDto"]) : undefined;
        }
    };
    CreateDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateDocumentDto();
        result.init(data);
        return result;
    };
    CreateDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["privilege"] = this.privilege;
        data["uploadFileDto"] = this.uploadFileDto ? this.uploadFileDto.toJSON() : undefined;
        return data;
    };
    return CreateDocumentDto;
}());
export { CreateDocumentDto };
var UploadFileDto = /** @class */ (function () {
    function UploadFileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadFileDto.prototype.init = function (data) {
        if (data) {
            this.size = data["size"];
            this.fileId = data["fileId"];
            this.ext = data["ext"];
            this.fileName = data["fileName"];
            this.fileUrl = data["fileUrl"];
            this.fileType = data["fileType"];
        }
    };
    UploadFileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadFileDto();
        result.init(data);
        return result;
    };
    UploadFileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["size"] = this.size;
        data["fileId"] = this.fileId;
        data["ext"] = this.ext;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["fileType"] = this.fileType;
        return data;
    };
    return UploadFileDto;
}());
export { UploadFileDto };
var UpdateDocumentDto = /** @class */ (function () {
    function UpdateDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateDocumentDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.privilege = data["privilege"];
            this.id = data["id"];
        }
    };
    UpdateDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateDocumentDto();
        result.init(data);
        return result;
    };
    UpdateDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["privilege"] = this.privilege;
        data["id"] = this.id;
        return data;
    };
    return UpdateDocumentDto;
}());
export { UpdateDocumentDto };
var DownloadFileDto = /** @class */ (function () {
    function DownloadFileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DownloadFileDto.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
            this.year = data["year"];
            this.month = data["month"];
            this.day = data["day"];
        }
    };
    DownloadFileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DownloadFileDto();
        result.init(data);
        return result;
    };
    DownloadFileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        return data;
    };
    return DownloadFileDto;
}());
export { DownloadFileDto };
var PagedResultDtoOfDocumentListDto = /** @class */ (function () {
    function PagedResultDtoOfDocumentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDocumentListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DocumentListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDocumentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDocumentListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDocumentListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDocumentListDto;
}());
export { PagedResultDtoOfDocumentListDto };
/** 文档列表Dto */
var DocumentListDto = /** @class */ (function () {
    function DocumentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.privilege = data["privilege"];
            this.size = data["size"];
            this.downloads = data["downloads"];
            this.fileType = data["fileType"];
            this.ext = data["ext"];
            this.creator = data["creator"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorOrganizationId = data["creatorOrganizationId"];
            this.id = data["id"];
        }
    };
    DocumentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentListDto();
        result.init(data);
        return result;
    };
    DocumentListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["privilege"] = this.privilege;
        data["size"] = this.size;
        data["downloads"] = this.downloads;
        data["fileType"] = this.fileType;
        data["ext"] = this.ext;
        data["creator"] = this.creator;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorOrganizationId"] = this.creatorOrganizationId;
        data["id"] = this.id;
        return data;
    };
    return DocumentListDto;
}());
export { DocumentListDto };
var DocumentSpaceDto = /** @class */ (function () {
    function DocumentSpaceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentSpaceDto.prototype.init = function (data) {
        if (data) {
            this.allowTotalSpace = data["allowTotalSpace"];
            this.useTotalSpace = data["useTotalSpace"];
        }
    };
    DocumentSpaceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentSpaceDto();
        result.init(data);
        return result;
    };
    DocumentSpaceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowTotalSpace"] = this.allowTotalSpace;
        data["useTotalSpace"] = this.useTotalSpace;
        return data;
    };
    return DocumentSpaceDto;
}());
export { DocumentSpaceDto };
var DocumentSingleFileSizeDto = /** @class */ (function () {
    function DocumentSingleFileSizeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentSingleFileSizeDto.prototype.init = function (data) {
        if (data) {
            this.maxSize = data["maxSize"];
        }
    };
    DocumentSingleFileSizeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentSingleFileSizeDto();
        result.init(data);
        return result;
    };
    DocumentSingleFileSizeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["maxSize"] = this.maxSize;
        return data;
    };
    return DocumentSingleFileSizeDto;
}());
export { DocumentSingleFileSizeDto };
var DocumentLimitDto = /** @class */ (function () {
    function DocumentLimitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentLimitDto.prototype.init = function (data) {
        if (data) {
            this.maxSize = data["maxSize"];
            this.singleMaxSize = data["singleMaxSize"];
        }
    };
    DocumentLimitDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentLimitDto();
        result.init(data);
        return result;
    };
    DocumentLimitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["maxSize"] = this.maxSize;
        data["singleMaxSize"] = this.singleMaxSize;
        return data;
    };
    return DocumentLimitDto;
}());
export { DocumentLimitDto };
var ListResultDtoOfEditionListDto = /** @class */ (function () {
    function ListResultDtoOfEditionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfEditionListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EditionListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfEditionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfEditionListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfEditionListDto;
}());
export { ListResultDtoOfEditionListDto };
var EditionListDto = /** @class */ (function () {
    function EditionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    EditionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionListDto();
        result.init(data);
        return result;
    };
    EditionListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return EditionListDto;
}());
export { EditionListDto };
var GetEditionEditOutput = /** @class */ (function () {
    function GetEditionEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEditionEditOutput.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (var _b = 0, _c = data["features"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.features.push(FlatFeatureDto.fromJS(item));
                }
            }
        }
    };
    GetEditionEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEditionEditOutput();
        result.init(data);
        return result;
    };
    GetEditionEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (var _b = 0, _c = this.features; _b < _c.length; _b++) {
                var item = _c[_b];
                data["features"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetEditionEditOutput;
}());
export { GetEditionEditOutput };
var EditionEditDto = /** @class */ (function () {
    function EditionEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    };
    EditionEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionEditDto();
        result.init(data);
        return result;
    };
    EditionEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    };
    return EditionEditDto;
}());
export { EditionEditDto };
var FlatFeatureDto = /** @class */ (function () {
    function FlatFeatureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatFeatureDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : undefined;
        }
    };
    FlatFeatureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatFeatureDto();
        result.init(data);
        return result;
    };
    FlatFeatureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined;
        return data;
    };
    return FlatFeatureDto;
}());
export { FlatFeatureDto };
var FeatureInputTypeDto = /** @class */ (function () {
    function FeatureInputTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FeatureInputTypeDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : undefined;
        }
    };
    FeatureInputTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    };
    FeatureInputTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : undefined;
        return data;
    };
    return FeatureInputTypeDto;
}());
export { FeatureInputTypeDto };
var IValueValidator = /** @class */ (function () {
    function IValueValidator(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IValueValidator.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
        }
    };
    IValueValidator.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IValueValidator();
        result.init(data);
        return result;
    };
    IValueValidator.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data;
    };
    return IValueValidator;
}());
export { IValueValidator };
var LocalizableComboboxItemSourceDto = /** @class */ (function () {
    function LocalizableComboboxItemSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableComboboxItemSourceDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
                }
            }
        }
    };
    LocalizableComboboxItemSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    };
    LocalizableComboboxItemSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return LocalizableComboboxItemSourceDto;
}());
export { LocalizableComboboxItemSourceDto };
var LocalizableComboboxItemDto = /** @class */ (function () {
    function LocalizableComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    };
    LocalizableComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    };
    LocalizableComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    };
    return LocalizableComboboxItemDto;
}());
export { LocalizableComboboxItemDto };
var CreateOrUpdateEditionDto = /** @class */ (function () {
    function CreateOrUpdateEditionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }
    CreateOrUpdateEditionDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    CreateOrUpdateEditionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateEditionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateOrUpdateEditionDto;
}());
export { CreateOrUpdateEditionDto };
var PagedResultDtoOfExternalOrganizationListDto = /** @class */ (function () {
    function PagedResultDtoOfExternalOrganizationListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfExternalOrganizationListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ExternalOrganizationListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfExternalOrganizationListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfExternalOrganizationListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfExternalOrganizationListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfExternalOrganizationListDto;
}());
export { PagedResultDtoOfExternalOrganizationListDto };
var ExternalOrganizationListDto = /** @class */ (function () {
    function ExternalOrganizationListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalOrganizationListDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.serialNumber = data["serialNumber"];
            this.enumOrganizationRole = data["enumOrganizationRole"];
            this.level = data["level"];
            this.ownerStr = data["ownerStr"];
            this.organizationOwnerStr = data["organizationOwnerStr"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.id = data["id"];
        }
    };
    ExternalOrganizationListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalOrganizationListDto();
        result.init(data);
        return result;
    };
    ExternalOrganizationListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["serialNumber"] = this.serialNumber;
        data["enumOrganizationRole"] = this.enumOrganizationRole;
        data["level"] = this.level;
        data["ownerStr"] = this.ownerStr;
        data["organizationOwnerStr"] = this.organizationOwnerStr;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    };
    return ExternalOrganizationListDto;
}());
export { ExternalOrganizationListDto };
var OrganizationListForMapDto = /** @class */ (function () {
    function OrganizationListForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationListForMapDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.code = data["code"];
            this.fullName = data["fullName"];
            this.parentId = data["parentId"];
            this.serialNumber = data["serialNumber"];
            this.parentName = data["parentName"];
            this.type = data["type"];
            this.enumOrganizationRole = data["enumOrganizationRole"];
            this.level = data["level"];
            this.owner = data["owner"];
            this.ownerName = data["ownerName"];
            this.organizationOwner = data["organizationOwner"];
            this.organizationOwnerName = data["organizationOwnerName"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.id = data["id"];
        }
    };
    OrganizationListForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationListForMapDto();
        result.init(data);
        return result;
    };
    OrganizationListForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["code"] = this.code;
        data["fullName"] = this.fullName;
        data["parentId"] = this.parentId;
        data["serialNumber"] = this.serialNumber;
        data["parentName"] = this.parentName;
        data["type"] = this.type;
        data["enumOrganizationRole"] = this.enumOrganizationRole;
        data["level"] = this.level;
        data["owner"] = this.owner;
        data["ownerName"] = this.ownerName;
        data["organizationOwner"] = this.organizationOwner;
        data["organizationOwnerName"] = this.organizationOwnerName;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    };
    return OrganizationListForMapDto;
}());
export { OrganizationListForMapDto };
/** 组织机构树形选择 */
var OrganizationForTreeDto = /** @class */ (function () {
    function OrganizationForTreeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationForTreeDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.organizationOwner = data["organizationOwner"];
            this.enumOrganizationRole = data["enumOrganizationRole"];
            this.id = data["id"];
        }
    };
    OrganizationForTreeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationForTreeDto();
        result.init(data);
        return result;
    };
    OrganizationForTreeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["organizationOwner"] = this.organizationOwner;
        data["enumOrganizationRole"] = this.enumOrganizationRole;
        data["id"] = this.id;
        return data;
    };
    return OrganizationForTreeDto;
}());
export { OrganizationForTreeDto };
var OrganizationAttachmentDto = /** @class */ (function () {
    function OrganizationAttachmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationAttachmentDto.prototype.init = function (data) {
        if (data) {
            this.attachType = data["attachType"];
            this.name = data["name"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.fileSize = data["fileSize"];
            this.byteString = data["byteString"];
            this.id = data["id"];
        }
    };
    OrganizationAttachmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationAttachmentDto();
        result.init(data);
        return result;
    };
    OrganizationAttachmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["attachType"] = this.attachType;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["fileSize"] = this.fileSize;
        data["byteString"] = this.byteString;
        data["id"] = this.id;
        return data;
    };
    return OrganizationAttachmentDto;
}());
export { OrganizationAttachmentDto };
var ExternalOrganizationForEditDto = /** @class */ (function () {
    function ExternalOrganizationForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalOrganizationForEditDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.serialNumber = data["serialNumber"];
            this.enumOrganizationRole = data["enumOrganizationRole"];
            this.level = data["level"];
            this.owner = data["owner"];
            this.organizationOwner = data["organizationOwner"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.companyDetail = data["companyDetail"] ? CompanyDetailDto.fromJS(data["companyDetail"]) : undefined;
            if (data["contacts"] && data["contacts"].constructor === Array) {
                this.contacts = [];
                for (var _i = 0, _a = data["contacts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contacts.push(OrganizationContactDto.fromJS(item));
                }
            }
        }
    };
    ExternalOrganizationForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalOrganizationForEditDto();
        result.init(data);
        return result;
    };
    ExternalOrganizationForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["serialNumber"] = this.serialNumber;
        data["enumOrganizationRole"] = this.enumOrganizationRole;
        data["level"] = this.level;
        data["owner"] = this.owner;
        data["organizationOwner"] = this.organizationOwner;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["companyDetail"] = this.companyDetail ? this.companyDetail.toJSON() : undefined;
        if (this.contacts && this.contacts.constructor === Array) {
            data["contacts"] = [];
            for (var _i = 0, _a = this.contacts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contacts"].push(item.toJSON());
            }
        }
        return data;
    };
    return ExternalOrganizationForEditDto;
}());
export { ExternalOrganizationForEditDto };
var CompanyDetailDto = /** @class */ (function () {
    function CompanyDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyDetailDto.prototype.init = function (data) {
        if (data) {
            this.organizationId = data["organizationId"];
            this.industryType = data["industryType"];
            this.companyType = data["companyType"];
            this.socialCreditCode = data["socialCreditCode"];
            this.openingBank = data["openingBank"];
            this.bankCardNumber = data["bankCardNumber"];
            this.companyWebsite = data["companyWebsite"];
            this.businessLicense = data["businessLicense"];
        }
    };
    CompanyDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyDetailDto();
        result.init(data);
        return result;
    };
    CompanyDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["industryType"] = this.industryType;
        data["companyType"] = this.companyType;
        data["socialCreditCode"] = this.socialCreditCode;
        data["openingBank"] = this.openingBank;
        data["bankCardNumber"] = this.bankCardNumber;
        data["companyWebsite"] = this.companyWebsite;
        data["businessLicense"] = this.businessLicense;
        return data;
    };
    return CompanyDetailDto;
}());
export { CompanyDetailDto };
var OrganizationContactDto = /** @class */ (function () {
    function OrganizationContactDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationContactDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.gender = data["gender"];
            this.post = data["post"];
            this.id = data["id"];
        }
    };
    OrganizationContactDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationContactDto();
        result.init(data);
        return result;
    };
    OrganizationContactDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["post"] = this.post;
        data["id"] = this.id;
        return data;
    };
    return OrganizationContactDto;
}());
export { OrganizationContactDto };
var OrganizationDetailDto = /** @class */ (function () {
    function OrganizationDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationDetailDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.parentId = data["parentId"];
            this.serialNumber = data["serialNumber"];
            this.parentName = data["parentName"];
            this.type = data["type"];
            this.enumOrganizationRole = data["enumOrganizationRole"];
            this.level = data["level"];
            this.owner = data["owner"];
            this.ownerName = data["ownerName"];
            this.organizationOwner = data["organizationOwner"];
            this.organizationOwnerName = data["organizationOwnerName"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.companyDetail = data["companyDetail"] ? CompanyDetailDto.fromJS(data["companyDetail"]) : undefined;
            if (data["contacts"] && data["contacts"].constructor === Array) {
                this.contacts = [];
                for (var _i = 0, _a = data["contacts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contacts.push(OrganizationContactDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    OrganizationDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationDetailDto();
        result.init(data);
        return result;
    };
    OrganizationDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["parentId"] = this.parentId;
        data["serialNumber"] = this.serialNumber;
        data["parentName"] = this.parentName;
        data["type"] = this.type;
        data["enumOrganizationRole"] = this.enumOrganizationRole;
        data["level"] = this.level;
        data["owner"] = this.owner;
        data["ownerName"] = this.ownerName;
        data["organizationOwner"] = this.organizationOwner;
        data["organizationOwnerName"] = this.organizationOwnerName;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["companyDetail"] = this.companyDetail ? this.companyDetail.toJSON() : undefined;
        if (this.contacts && this.contacts.constructor === Array) {
            data["contacts"] = [];
            for (var _i = 0, _a = this.contacts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contacts"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return OrganizationDetailDto;
}());
export { OrganizationDetailDto };
var RoleListDto = /** @class */ (function () {
    function RoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.description = data["description"];
            this.id = data["id"];
        }
    };
    RoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleListDto();
        result.init(data);
        return result;
    };
    RoleListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    };
    return RoleListDto;
}());
export { RoleListDto };
var PagedResultDtoOfUserListForDetailDto = /** @class */ (function () {
    function PagedResultDtoOfUserListForDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfUserListForDetailDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserListForDetailDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfUserListForDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfUserListForDetailDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfUserListForDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfUserListForDetailDto;
}());
export { PagedResultDtoOfUserListForDetailDto };
var UserListForDetailDto = /** @class */ (function () {
    function UserListForDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListForDetailDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.jobNumber = data["jobNumber"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.dataPolicy = data["dataPolicy"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.roles = data["roles"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.isLocationEnabled = data["isLocationEnabled"];
            this.expireTime = data["expireTime"] ? moment(data["expireTime"].toString()) : undefined;
            this.organizationNames = data["organizationNames"];
            this.externalSuperAdmin = data["externalSuperAdmin"];
            this.id = data["id"];
        }
    };
    UserListForDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListForDetailDto();
        result.init(data);
        return result;
    };
    UserListForDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jobNumber"] = this.jobNumber;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["dataPolicy"] = this.dataPolicy;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["roles"] = this.roles;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["isLocationEnabled"] = this.isLocationEnabled;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : undefined;
        data["organizationNames"] = this.organizationNames;
        data["externalSuperAdmin"] = this.externalSuperAdmin;
        data["id"] = this.id;
        return data;
    };
    return UserListForDetailDto;
}());
export { UserListForDetailDto };
var CreateOrUpdateExternalOrganizationDto = /** @class */ (function () {
    function CreateOrUpdateExternalOrganizationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateExternalOrganizationDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.enumOrganizationRole = data["enumOrganizationRole"];
            this.level = data["level"];
            this.owner = data["owner"];
            this.organizationOwner = data["organizationOwner"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.companyDetail = data["companyDetail"] ? CompanyDetailDto.fromJS(data["companyDetail"]) : undefined;
            if (data["contacts"] && data["contacts"].constructor === Array) {
                this.contacts = [];
                for (var _i = 0, _a = data["contacts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contacts.push(OrganizationContactDto.fromJS(item));
                }
            }
            if (data["attachments"] && data["attachments"].constructor === Array) {
                this.attachments = [];
                for (var _b = 0, _c = data["attachments"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.attachments.push(OrganizationAttachmentDto.fromJS(item));
                }
            }
            if (data["deleteContactIds"] && data["deleteContactIds"].constructor === Array) {
                this.deleteContactIds = [];
                for (var _d = 0, _e = data["deleteContactIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.deleteContactIds.push(item);
                }
            }
            if (data["deleteAttachments"] && data["deleteAttachments"].constructor === Array) {
                this.deleteAttachments = [];
                for (var _f = 0, _g = data["deleteAttachments"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.deleteAttachments.push(item);
                }
            }
            this.organizationAddress = data["organizationAddress"] ? OrganizationAddressDto.fromJS(data["organizationAddress"]) : undefined;
            this.id = data["id"];
        }
    };
    CreateOrUpdateExternalOrganizationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateExternalOrganizationDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateExternalOrganizationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["enumOrganizationRole"] = this.enumOrganizationRole;
        data["level"] = this.level;
        data["owner"] = this.owner;
        data["organizationOwner"] = this.organizationOwner;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["companyDetail"] = this.companyDetail ? this.companyDetail.toJSON() : undefined;
        if (this.contacts && this.contacts.constructor === Array) {
            data["contacts"] = [];
            for (var _i = 0, _a = this.contacts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contacts"].push(item.toJSON());
            }
        }
        if (this.attachments && this.attachments.constructor === Array) {
            data["attachments"] = [];
            for (var _b = 0, _c = this.attachments; _b < _c.length; _b++) {
                var item = _c[_b];
                data["attachments"].push(item.toJSON());
            }
        }
        if (this.deleteContactIds && this.deleteContactIds.constructor === Array) {
            data["deleteContactIds"] = [];
            for (var _d = 0, _e = this.deleteContactIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["deleteContactIds"].push(item);
            }
        }
        if (this.deleteAttachments && this.deleteAttachments.constructor === Array) {
            data["deleteAttachments"] = [];
            for (var _f = 0, _g = this.deleteAttachments; _f < _g.length; _f++) {
                var item = _g[_f];
                data["deleteAttachments"].push(item);
            }
        }
        data["organizationAddress"] = this.organizationAddress ? this.organizationAddress.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateExternalOrganizationDto;
}());
export { CreateOrUpdateExternalOrganizationDto };
var OrganizationAddressDto = /** @class */ (function () {
    function OrganizationAddressDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationAddressDto.prototype.init = function (data) {
        if (data) {
            this.provinceName = data["provinceName"];
            this.cityName = data["cityName"];
            this.districtName = data["districtName"];
        }
    };
    OrganizationAddressDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationAddressDto();
        result.init(data);
        return result;
    };
    OrganizationAddressDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["provinceName"] = this.provinceName;
        data["cityName"] = this.cityName;
        data["districtName"] = this.districtName;
        return data;
    };
    return OrganizationAddressDto;
}());
export { OrganizationAddressDto };
var DownloadAttachmentDto = /** @class */ (function () {
    function DownloadAttachmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DownloadAttachmentDto.prototype.init = function (data) {
        if (data) {
            this.organizationId = data["organizationId"];
            this.attachmentId = data["attachmentId"];
        }
    };
    DownloadAttachmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DownloadAttachmentDto();
        result.init(data);
        return result;
    };
    DownloadAttachmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["attachmentId"] = this.attachmentId;
        return data;
    };
    return DownloadAttachmentDto;
}());
export { DownloadAttachmentDto };
var GetExternalOrganizationListDto = /** @class */ (function () {
    function GetExternalOrganizationListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetExternalOrganizationListDto.prototype.init = function (data) {
        if (data) {
            this.term = data["term"];
            this.organizationRole = data["organizationRole"];
            this.organizationLevel = data["organizationLevel"];
            this.sorting = data["sorting"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    };
    GetExternalOrganizationListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetExternalOrganizationListDto();
        result.init(data);
        return result;
    };
    GetExternalOrganizationListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        data["organizationRole"] = this.organizationRole;
        data["organizationLevel"] = this.organizationLevel;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    };
    return GetExternalOrganizationListDto;
}());
export { GetExternalOrganizationListDto };
var PagedResultDtoOfExternalOrganizationWithContactDto = /** @class */ (function () {
    function PagedResultDtoOfExternalOrganizationWithContactDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfExternalOrganizationWithContactDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ExternalOrganizationWithContactDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfExternalOrganizationWithContactDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfExternalOrganizationWithContactDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfExternalOrganizationWithContactDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfExternalOrganizationWithContactDto;
}());
export { PagedResultDtoOfExternalOrganizationWithContactDto };
var ExternalOrganizationWithContactDto = /** @class */ (function () {
    function ExternalOrganizationWithContactDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalOrganizationWithContactDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.serialNumber = data["serialNumber"];
            this.enumOrganizationRole = data["enumOrganizationRole"];
            this.level = data["level"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.contact = data["contact"] ? OrganizationContactDto.fromJS(data["contact"]) : undefined;
            this.id = data["id"];
        }
    };
    ExternalOrganizationWithContactDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalOrganizationWithContactDto();
        result.init(data);
        return result;
    };
    ExternalOrganizationWithContactDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["serialNumber"] = this.serialNumber;
        data["enumOrganizationRole"] = this.enumOrganizationRole;
        data["level"] = this.level;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return ExternalOrganizationWithContactDto;
}());
export { ExternalOrganizationWithContactDto };
/** 检查外部组织是否有管理员 */
var CheckAdminUserDto = /** @class */ (function () {
    function CheckAdminUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckAdminUserDto.prototype.init = function (data) {
        if (data) {
            this.organizationId = data["organizationId"];
        }
    };
    CheckAdminUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckAdminUserDto();
        result.init(data);
        return result;
    };
    CheckAdminUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    };
    return CheckAdminUserDto;
}());
export { CheckAdminUserDto };
var CameraDto = /** @class */ (function () {
    function CameraDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CameraDto.prototype.init = function (data) {
        if (data) {
            this.deviceSerial = data["deviceSerial"];
            this.channelNo = data["channelNo"];
            this.liveAddress = data["liveAddress"];
            this.hdAddress = data["hdAddress"];
            this.rtmp = data["rtmp"];
            this.rtmpHd = data["rtmpHd"];
        }
    };
    CameraDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CameraDto();
        result.init(data);
        return result;
    };
    CameraDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceSerial"] = this.deviceSerial;
        data["channelNo"] = this.channelNo;
        data["liveAddress"] = this.liveAddress;
        data["hdAddress"] = this.hdAddress;
        data["rtmp"] = this.rtmp;
        data["rtmpHd"] = this.rtmpHd;
        return data;
    };
    return CameraDto;
}());
export { CameraDto };
var RotateDto = /** @class */ (function () {
    function RotateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RotateDto.prototype.init = function (data) {
        if (data) {
            this.deviceSerial = data["deviceSerial"];
            this.channelNo = data["channelNo"];
            this.direction = data["direction"];
            this.speed = data["speed"];
        }
    };
    RotateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RotateDto();
        result.init(data);
        return result;
    };
    RotateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceSerial"] = this.deviceSerial;
        data["channelNo"] = this.channelNo;
        data["direction"] = this.direction;
        data["speed"] = this.speed;
        return data;
    };
    return RotateDto;
}());
export { RotateDto };
var TenantEzvizSettingsEditDto = /** @class */ (function () {
    function TenantEzvizSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEzvizSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.appKey = data["appKey"];
            this.secret = data["secret"];
        }
    };
    TenantEzvizSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEzvizSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantEzvizSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["appKey"] = this.appKey;
        data["secret"] = this.secret;
        return data;
    };
    return TenantEzvizSettingsEditDto;
}());
export { TenantEzvizSettingsEditDto };
var ListResultDtoOfFaultTypeListDto = /** @class */ (function () {
    function ListResultDtoOfFaultTypeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfFaultTypeListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FaultTypeListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfFaultTypeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfFaultTypeListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfFaultTypeListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfFaultTypeListDto;
}());
export { ListResultDtoOfFaultTypeListDto };
var FaultTypeListDto = /** @class */ (function () {
    function FaultTypeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FaultTypeListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    FaultTypeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FaultTypeListDto();
        result.init(data);
        return result;
    };
    FaultTypeListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return FaultTypeListDto;
}());
export { FaultTypeListDto };
var CreateOrUpdateFaultTypeDto = /** @class */ (function () {
    function CreateOrUpdateFaultTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateFaultTypeDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateFaultTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateFaultTypeDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateFaultTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateFaultTypeDto;
}());
export { CreateOrUpdateFaultTypeDto };
var CheckBoxBelongToTenantDto = /** @class */ (function () {
    function CheckBoxBelongToTenantDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckBoxBelongToTenantDto.prototype.init = function (data) {
        if (data) {
            this.boxSerialNumber = data["boxSerialNumber"];
        }
    };
    CheckBoxBelongToTenantDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckBoxBelongToTenantDto();
        result.init(data);
        return result;
    };
    CheckBoxBelongToTenantDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["boxSerialNumber"] = this.boxSerialNumber;
        return data;
    };
    return CheckBoxBelongToTenantDto;
}());
export { CheckBoxBelongToTenantDto };
var CheckBoxResult = /** @class */ (function () {
    function CheckBoxResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckBoxResult.prototype.init = function (data) {
        if (data) {
            this.isMine = data["isMine"];
            this.errorMessage = data["errorMessage"];
        }
    };
    CheckBoxResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckBoxResult();
        result.init(data);
        return result;
    };
    CheckBoxResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isMine"] = this.isMine;
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return CheckBoxResult;
}());
export { CheckBoxResult };
var IListResultOfFBoxInfoDto = /** @class */ (function () {
    function IListResultOfFBoxInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfFBoxInfoDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FBoxInfoDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfFBoxInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfFBoxInfoDto();
        result.init(data);
        return result;
    };
    IListResultOfFBoxInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfFBoxInfoDto;
}());
export { IListResultOfFBoxInfoDto };
var FBoxInfoDto = /** @class */ (function () {
    function FBoxInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxInfoDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.serialNumber = data["serialNumber"];
            this.deviceName = data["deviceName"];
            this.dataSourceName = data["dataSourceName"];
            this.dataSourceCode = data["dataSourceCode"];
            this.tenantName = data["tenantName"];
            this.tenancyName = data["tenancyName"];
        }
    };
    FBoxInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxInfoDto();
        result.init(data);
        return result;
    };
    FBoxInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["serialNumber"] = this.serialNumber;
        data["deviceName"] = this.deviceName;
        data["dataSourceName"] = this.dataSourceName;
        data["dataSourceCode"] = this.dataSourceCode;
        data["tenantName"] = this.tenantName;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return FBoxInfoDto;
}());
export { FBoxInfoDto };
var UnbindBoxDto = /** @class */ (function () {
    function UnbindBoxDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnbindBoxDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.boxSerialNumber = data["boxSerialNumber"];
            this.dataSourceCode = data["dataSourceCode"];
        }
    };
    UnbindBoxDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnbindBoxDto();
        result.init(data);
        return result;
    };
    UnbindBoxDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["boxSerialNumber"] = this.boxSerialNumber;
        data["dataSourceCode"] = this.dataSourceCode;
        return data;
    };
    return UnbindBoxDto;
}());
export { UnbindBoxDto };
var AccountSettingStatusInfoDto = /** @class */ (function () {
    function AccountSettingStatusInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountSettingStatusInfoDto.prototype.init = function (data) {
        if (data) {
            this.fBoxAccountSettings = data["fBoxAccountSettings"] ? GetFBoxAccountSettingsDto.fromJS(data["fBoxAccountSettings"]) : undefined;
            this.hasError = data["hasError"];
            this.errorInfo = data["errorInfo"];
        }
    };
    AccountSettingStatusInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountSettingStatusInfoDto();
        result.init(data);
        return result;
    };
    AccountSettingStatusInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fBoxAccountSettings"] = this.fBoxAccountSettings ? this.fBoxAccountSettings.toJSON() : undefined;
        data["hasError"] = this.hasError;
        data["errorInfo"] = this.errorInfo;
        return data;
    };
    return AccountSettingStatusInfoDto;
}());
export { AccountSettingStatusInfoDto };
var GetFBoxAccountSettingsDto = /** @class */ (function () {
    function GetFBoxAccountSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetFBoxAccountSettingsDto.prototype.init = function (data) {
        if (data) {
            this.userName = data["userName"];
            this.isCustom = data["isCustom"];
            this.idServerUrl = data["idServerUrl"];
            this.mainServerUrl = data["mainServerUrl"];
            this.boxServerUrl = data["boxServerUrl"];
            this.historyDataServerUrl = data["historyDataServerUrl"];
            this.clientId = data["clientId"];
            this.id = data["id"];
        }
    };
    GetFBoxAccountSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetFBoxAccountSettingsDto();
        result.init(data);
        return result;
    };
    GetFBoxAccountSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["isCustom"] = this.isCustom;
        data["idServerUrl"] = this.idServerUrl;
        data["mainServerUrl"] = this.mainServerUrl;
        data["boxServerUrl"] = this.boxServerUrl;
        data["historyDataServerUrl"] = this.historyDataServerUrl;
        data["clientId"] = this.clientId;
        data["id"] = this.id;
        return data;
    };
    return GetFBoxAccountSettingsDto;
}());
export { GetFBoxAccountSettingsDto };
var FBoxAccountSettingsDto = /** @class */ (function () {
    function FBoxAccountSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxAccountSettingsDto.prototype.init = function (data) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
            this.isCustom = data["isCustom"];
            this.idServerUrl = data["idServerUrl"];
            this.mainServerUrl = data["mainServerUrl"];
            this.boxServerUrl = data["boxServerUrl"];
            this.historyDataServerUrl = data["historyDataServerUrl"];
            this.clientId = data["clientId"];
            this.clientSecret = data["clientSecret"];
        }
    };
    FBoxAccountSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxAccountSettingsDto();
        result.init(data);
        return result;
    };
    FBoxAccountSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["isCustom"] = this.isCustom;
        data["idServerUrl"] = this.idServerUrl;
        data["mainServerUrl"] = this.mainServerUrl;
        data["boxServerUrl"] = this.boxServerUrl;
        data["historyDataServerUrl"] = this.historyDataServerUrl;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    };
    return FBoxAccountSettingsDto;
}());
export { FBoxAccountSettingsDto };
var FBoxAccountPasswordDto = /** @class */ (function () {
    function FBoxAccountPasswordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxAccountPasswordDto.prototype.init = function (data) {
        if (data) {
            this.password = data["password"];
        }
    };
    FBoxAccountPasswordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxAccountPasswordDto();
        result.init(data);
        return result;
    };
    FBoxAccountPasswordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    };
    return FBoxAccountPasswordDto;
}());
export { FBoxAccountPasswordDto };
var GetFBoxAccountNameDto = /** @class */ (function () {
    function GetFBoxAccountNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetFBoxAccountNameDto.prototype.init = function (data) {
        if (data) {
            this.fBoxAccountSettingsName = data["fBoxAccountSettingsName"] ? GetFBoxAccountSettingsNameDto.fromJS(data["fBoxAccountSettingsName"]) : undefined;
        }
    };
    GetFBoxAccountNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetFBoxAccountNameDto();
        result.init(data);
        return result;
    };
    GetFBoxAccountNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fBoxAccountSettingsName"] = this.fBoxAccountSettingsName ? this.fBoxAccountSettingsName.toJSON() : undefined;
        return data;
    };
    return GetFBoxAccountNameDto;
}());
export { GetFBoxAccountNameDto };
var GetFBoxAccountSettingsNameDto = /** @class */ (function () {
    function GetFBoxAccountSettingsNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetFBoxAccountSettingsNameDto.prototype.init = function (data) {
        if (data) {
            this.userName = data["userName"];
        }
    };
    GetFBoxAccountSettingsNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetFBoxAccountSettingsNameDto();
        result.init(data);
        return result;
    };
    GetFBoxAccountSettingsNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        return data;
    };
    return GetFBoxAccountSettingsNameDto;
}());
export { GetFBoxAccountSettingsNameDto };
var FBoxServerStateDto = /** @class */ (function () {
    function FBoxServerStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxServerStateDto.prototype.init = function (data) {
        if (data) {
            this.state = data["state"];
        }
    };
    FBoxServerStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxServerStateDto();
        result.init(data);
        return result;
    };
    FBoxServerStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        return data;
    };
    return FBoxServerStateDto;
}());
export { FBoxServerStateDto };
var PagedResultDtoOfFBoxAlarmForSingleDataSource = /** @class */ (function () {
    function PagedResultDtoOfFBoxAlarmForSingleDataSource(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfFBoxAlarmForSingleDataSource.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FBoxAlarmForSingleDataSource.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfFBoxAlarmForSingleDataSource.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfFBoxAlarmForSingleDataSource();
        result.init(data);
        return result;
    };
    PagedResultDtoOfFBoxAlarmForSingleDataSource.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfFBoxAlarmForSingleDataSource;
}());
export { PagedResultDtoOfFBoxAlarmForSingleDataSource };
var FBoxAlarmForSingleDataSource = /** @class */ (function () {
    function FBoxAlarmForSingleDataSource(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxAlarmForSingleDataSource.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.groupName = data["groupName"];
            this.alarmMessage = data["alarmMessage"];
            this.condition1 = data["condition1"];
            this.condition2 = data["condition2"];
            this.operand1 = data["operand1"];
            this.operand2 = data["operand2"];
            this.conditionCombineMethod = data["conditionCombineMethod"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.devAlias = data["devAlias"];
            this.dataType = data["dataType"];
            this.addressDescription = data["addressDescription"];
            this.stationNo = data["stationNo"];
            this.refAlarmDefinitionKey = data["refAlarmDefinitionKey"];
            this.id = data["id"];
        }
    };
    FBoxAlarmForSingleDataSource.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxAlarmForSingleDataSource();
        result.init(data);
        return result;
    };
    FBoxAlarmForSingleDataSource.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["alarmMessage"] = this.alarmMessage;
        data["condition1"] = this.condition1;
        data["condition2"] = this.condition2;
        data["operand1"] = this.operand1;
        data["operand2"] = this.operand2;
        data["conditionCombineMethod"] = this.conditionCombineMethod;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["devAlias"] = this.devAlias;
        data["dataType"] = this.dataType;
        data["addressDescription"] = this.addressDescription;
        data["stationNo"] = this.stationNo;
        data["refAlarmDefinitionKey"] = this.refAlarmDefinitionKey;
        data["id"] = this.id;
        return data;
    };
    return FBoxAlarmForSingleDataSource;
}());
export { FBoxAlarmForSingleDataSource };
var RefAlarmGroupNameDto = /** @class */ (function () {
    function RefAlarmGroupNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RefAlarmGroupNameDto.prototype.init = function (data) {
        if (data) {
            this.groupName = data["groupName"];
        }
    };
    RefAlarmGroupNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RefAlarmGroupNameDto();
        result.init(data);
        return result;
    };
    RefAlarmGroupNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        return data;
    };
    return RefAlarmGroupNameDto;
}());
export { RefAlarmGroupNameDto };
var PagedResultDtoOfRefAlarmDto = /** @class */ (function () {
    function PagedResultDtoOfRefAlarmDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfRefAlarmDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RefAlarmDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfRefAlarmDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfRefAlarmDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfRefAlarmDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfRefAlarmDto;
}());
export { PagedResultDtoOfRefAlarmDto };
var PagedResultDtoOfFBoxHistoryDataListDto = /** @class */ (function () {
    function PagedResultDtoOfFBoxHistoryDataListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfFBoxHistoryDataListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FBoxHistoryDataListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfFBoxHistoryDataListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfFBoxHistoryDataListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfFBoxHistoryDataListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfFBoxHistoryDataListDto;
}());
export { PagedResultDtoOfFBoxHistoryDataListDto };
var FBoxHistoryDataListDto = /** @class */ (function () {
    function FBoxHistoryDataListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxHistoryDataListDto.prototype.init = function (data) {
        if (data) {
            if (data["fBoxHistoryChannels"] && data["fBoxHistoryChannels"].constructor === Array) {
                this.fBoxHistoryChannels = [];
                for (var _i = 0, _a = data["fBoxHistoryChannels"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.fBoxHistoryChannels.push(FBoxHistoryChannelDto.fromJS(item));
                }
            }
            this.name = data["name"];
            this.sampleType = data["sampleType"];
            this.recordingPeriod = data["recordingPeriod"];
            this.id = data["id"];
        }
    };
    FBoxHistoryDataListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxHistoryDataListDto();
        result.init(data);
        return result;
    };
    FBoxHistoryDataListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.fBoxHistoryChannels && this.fBoxHistoryChannels.constructor === Array) {
            data["fBoxHistoryChannels"] = [];
            for (var _i = 0, _a = this.fBoxHistoryChannels; _i < _a.length; _i++) {
                var item = _a[_i];
                data["fBoxHistoryChannels"].push(item.toJSON());
            }
        }
        data["name"] = this.name;
        data["sampleType"] = this.sampleType;
        data["recordingPeriod"] = this.recordingPeriod;
        data["id"] = this.id;
        return data;
    };
    return FBoxHistoryDataListDto;
}());
export { FBoxHistoryDataListDto };
var FBoxHistoryChannelDto = /** @class */ (function () {
    function FBoxHistoryChannelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxHistoryChannelDto.prototype.init = function (data) {
        if (data) {
            this.channelName = data["channelName"];
            this.devAlias = data["devAlias"];
            this.dataType = data["dataType"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.bitIndex = data["bitIndex"];
            this.addressDescription = data["addressDescription"];
        }
    };
    FBoxHistoryChannelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxHistoryChannelDto();
        result.init(data);
        return result;
    };
    FBoxHistoryChannelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["channelName"] = this.channelName;
        data["devAlias"] = this.devAlias;
        data["dataType"] = this.dataType;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["bitIndex"] = this.bitIndex;
        data["addressDescription"] = this.addressDescription;
        return data;
    };
    return FBoxHistoryChannelDto;
}());
export { FBoxHistoryChannelDto };
var PagedResultDtoOfFBoxMacroExecutePlanDetailDto = /** @class */ (function () {
    function PagedResultDtoOfFBoxMacroExecutePlanDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfFBoxMacroExecutePlanDetailDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FBoxMacroExecutePlanDetailDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfFBoxMacroExecutePlanDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfFBoxMacroExecutePlanDetailDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfFBoxMacroExecutePlanDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfFBoxMacroExecutePlanDetailDto;
}());
export { PagedResultDtoOfFBoxMacroExecutePlanDetailDto };
var FBoxMacroExecutePlanDetailDto = /** @class */ (function () {
    function FBoxMacroExecutePlanDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxMacroExecutePlanDetailDto.prototype.init = function (data) {
        if (data) {
            this.script = data["script"];
            this.scriptName = data["scriptName"];
            this.description = data["description"];
            this.mode = data["mode"];
            this.macroExecutionDisplayRule = data["macroExecutionDisplayRule"];
            this.marcoScriptId = data["marcoScriptId"];
        }
    };
    FBoxMacroExecutePlanDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxMacroExecutePlanDetailDto();
        result.init(data);
        return result;
    };
    FBoxMacroExecutePlanDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["script"] = this.script;
        data["scriptName"] = this.scriptName;
        data["description"] = this.description;
        data["mode"] = this.mode;
        data["macroExecutionDisplayRule"] = this.macroExecutionDisplayRule;
        data["marcoScriptId"] = this.marcoScriptId;
        return data;
    };
    return FBoxMacroExecutePlanDetailDto;
}());
export { FBoxMacroExecutePlanDetailDto };
var PagedResultDtoOfFBoxVariableForSingleDataSourceDto = /** @class */ (function () {
    function PagedResultDtoOfFBoxVariableForSingleDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfFBoxVariableForSingleDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FBoxVariableForSingleDataSourceDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfFBoxVariableForSingleDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfFBoxVariableForSingleDataSourceDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfFBoxVariableForSingleDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfFBoxVariableForSingleDataSourceDto;
}());
export { PagedResultDtoOfFBoxVariableForSingleDataSourceDto };
var FBoxVariableForSingleDataSourceDto = /** @class */ (function () {
    function FBoxVariableForSingleDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxVariableForSingleDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.unit = data["unit"];
            this.groupName = data["groupName"];
            this.devAlias = data["devAlias"];
            this.stationNo = data["stationNo"];
            this.dataType = data["dataType"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.regName = data["regName"];
            this.addressDescription = data["addressDescription"];
            this.integralDigits = data["integralDigits"];
            this.fractionalDigits = data["fractionalDigits"];
            this.dMonPermissionTypeStr = data["dMonPermissionTypeStr"];
            this.memo = data["memo"];
        }
    };
    FBoxVariableForSingleDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxVariableForSingleDataSourceDto();
        result.init(data);
        return result;
    };
    FBoxVariableForSingleDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["groupName"] = this.groupName;
        data["devAlias"] = this.devAlias;
        data["stationNo"] = this.stationNo;
        data["dataType"] = this.dataType;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["regName"] = this.regName;
        data["addressDescription"] = this.addressDescription;
        data["integralDigits"] = this.integralDigits;
        data["fractionalDigits"] = this.fractionalDigits;
        data["dMonPermissionTypeStr"] = this.dMonPermissionTypeStr;
        data["memo"] = this.memo;
        return data;
    };
    return FBoxVariableForSingleDataSourceDto;
}());
export { FBoxVariableForSingleDataSourceDto };
var FBoxVariableGroupNameDto = /** @class */ (function () {
    function FBoxVariableGroupNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxVariableGroupNameDto.prototype.init = function (data) {
        if (data) {
            this.groupName = data["groupName"];
        }
    };
    FBoxVariableGroupNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxVariableGroupNameDto();
        result.init(data);
        return result;
    };
    FBoxVariableGroupNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        return data;
    };
    return FBoxVariableGroupNameDto;
}());
export { FBoxVariableGroupNameDto };
var CreateFriendshipRequestInput = /** @class */ (function () {
    function CreateFriendshipRequestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateFriendshipRequestInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    CreateFriendshipRequestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    };
    CreateFriendshipRequestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return CreateFriendshipRequestInput;
}());
export { CreateFriendshipRequestInput };
var CreateFriendshipRequestByUserNameInput = /** @class */ (function () {
    function CreateFriendshipRequestByUserNameInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateFriendshipRequestByUserNameInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    };
    CreateFriendshipRequestByUserNameInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    };
    CreateFriendshipRequestByUserNameInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    };
    return CreateFriendshipRequestByUserNameInput;
}());
export { CreateFriendshipRequestByUserNameInput };
var BlockUserInput = /** @class */ (function () {
    function BlockUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlockUserInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    BlockUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BlockUserInput();
        result.init(data);
        return result;
    };
    BlockUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return BlockUserInput;
}());
export { BlockUserInput };
var UnblockUserInput = /** @class */ (function () {
    function UnblockUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnblockUserInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    UnblockUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnblockUserInput();
        result.init(data);
        return result;
    };
    UnblockUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return UnblockUserInput;
}());
export { UnblockUserInput };
var AcceptFriendshipRequestInput = /** @class */ (function () {
    function AcceptFriendshipRequestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AcceptFriendshipRequestInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    AcceptFriendshipRequestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    };
    AcceptFriendshipRequestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return AcceptFriendshipRequestInput;
}());
export { AcceptFriendshipRequestInput };
var GraphConfigDto = /** @class */ (function () {
    function GraphConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GraphConfigDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.thumbUrl = data["thumbUrl"];
            this.stateCount = data["stateCount"];
        }
    };
    GraphConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GraphConfigDto();
        result.init(data);
        return result;
    };
    GraphConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["thumbUrl"] = this.thumbUrl;
        data["stateCount"] = this.stateCount;
        return data;
    };
    return GraphConfigDto;
}());
export { GraphConfigDto };
var PagedResultDtoOfHistoryAlarmOutput = /** @class */ (function () {
    function PagedResultDtoOfHistoryAlarmOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfHistoryAlarmOutput.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(HistoryAlarmOutput.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfHistoryAlarmOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfHistoryAlarmOutput();
        result.init(data);
        return result;
    };
    PagedResultDtoOfHistoryAlarmOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfHistoryAlarmOutput;
}());
export { PagedResultDtoOfHistoryAlarmOutput };
var HistoryAlarmOutput = /** @class */ (function () {
    function HistoryAlarmOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryAlarmOutput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.deviceName = data["deviceName"];
            this.name = data["name"];
            this.message = data["message"];
            this.state = data["state"];
            this.triggeredTime = data["triggeredTime"] ? moment(data["triggeredTime"].toString()) : undefined;
            this.value = data["value"];
            this.malfunctionCode = data["malfunctionCode"];
            this.alarmLevel = data["alarmLevel"];
            this.alarmGroupName = data["alarmGroupName"];
            this.unit = data["unit"];
            this.fCloudVariableName = data["fCloudVariableName"];
            this.triggeredRuleDesp = data["triggeredRuleDesp"];
            this.delaySeconds = data["delaySeconds"];
            this.deadBand = data["deadBand"];
            this.recoveryValue = data["recoveryValue"];
            this.recoveryTime = data["recoveryTime"] ? moment(data["recoveryTime"].toString()) : undefined;
            this.confirmUserName = data["confirmUserName"];
            this.confirmTime = data["confirmTime"] ? moment(data["confirmTime"].toString()) : undefined;
        }
    };
    HistoryAlarmOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryAlarmOutput();
        result.init(data);
        return result;
    };
    HistoryAlarmOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceName"] = this.deviceName;
        data["name"] = this.name;
        data["message"] = this.message;
        data["state"] = this.state;
        data["triggeredTime"] = this.triggeredTime ? this.triggeredTime.toISOString() : undefined;
        data["value"] = this.value;
        data["malfunctionCode"] = this.malfunctionCode;
        data["alarmLevel"] = this.alarmLevel;
        data["alarmGroupName"] = this.alarmGroupName;
        data["unit"] = this.unit;
        data["fCloudVariableName"] = this.fCloudVariableName;
        data["triggeredRuleDesp"] = this.triggeredRuleDesp;
        data["delaySeconds"] = this.delaySeconds;
        data["deadBand"] = this.deadBand;
        data["recoveryValue"] = this.recoveryValue;
        data["recoveryTime"] = this.recoveryTime ? this.recoveryTime.toISOString() : undefined;
        data["confirmUserName"] = this.confirmUserName;
        data["confirmTime"] = this.confirmTime ? this.confirmTime.toISOString() : undefined;
        return data;
    };
    return HistoryAlarmOutput;
}());
export { HistoryAlarmOutput };
/** 导出事件模型 */
var ExportAlarmFileInput = /** @class */ (function () {
    function ExportAlarmFileInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportAlarmFileInput.prototype.init = function (data) {
        if (data) {
            this.isCurrentAlarm = data["isCurrentAlarm"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.triggeredStartTime = data["triggeredStartTime"] ? moment(data["triggeredStartTime"].toString()) : undefined;
            this.triggeredEndTime = data["triggeredEndTime"] ? moment(data["triggeredEndTime"].toString()) : undefined;
            this.state = data["state"];
            this.alarmLevel = data["alarmLevel"];
            this.alarmName = data["alarmName"];
            this.deviceName = data["deviceName"];
            this.alarmGroupName = data["alarmGroupName"];
            this.malfunctionCode = data["malfunctionCode"];
            this.fCloudVariableName = data["fCloudVariableName"];
            this.recoveryStartTime = data["recoveryStartTime"] ? moment(data["recoveryStartTime"].toString()) : undefined;
            this.recoveryEndTime = data["recoveryEndTime"] ? moment(data["recoveryEndTime"].toString()) : undefined;
            this.confirmStartTime = data["confirmStartTime"] ? moment(data["confirmStartTime"].toString()) : undefined;
            this.confirmEndTime = data["confirmEndTime"] ? moment(data["confirmEndTime"].toString()) : undefined;
        }
    };
    ExportAlarmFileInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportAlarmFileInput();
        result.init(data);
        return result;
    };
    ExportAlarmFileInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCurrentAlarm"] = this.isCurrentAlarm;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["triggeredStartTime"] = this.triggeredStartTime ? this.triggeredStartTime.toISOString() : undefined;
        data["triggeredEndTime"] = this.triggeredEndTime ? this.triggeredEndTime.toISOString() : undefined;
        data["state"] = this.state;
        data["alarmLevel"] = this.alarmLevel;
        data["alarmName"] = this.alarmName;
        data["deviceName"] = this.deviceName;
        data["alarmGroupName"] = this.alarmGroupName;
        data["malfunctionCode"] = this.malfunctionCode;
        data["fCloudVariableName"] = this.fCloudVariableName;
        data["recoveryStartTime"] = this.recoveryStartTime ? this.recoveryStartTime.toISOString() : undefined;
        data["recoveryEndTime"] = this.recoveryEndTime ? this.recoveryEndTime.toISOString() : undefined;
        data["confirmStartTime"] = this.confirmStartTime ? this.confirmStartTime.toISOString() : undefined;
        data["confirmEndTime"] = this.confirmEndTime ? this.confirmEndTime.toISOString() : undefined;
        return data;
    };
    return ExportAlarmFileInput;
}());
export { ExportAlarmFileInput };
var PagedResultDtoOfHistoryDataDto = /** @class */ (function () {
    function PagedResultDtoOfHistoryDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfHistoryDataDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(HistoryDataDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfHistoryDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfHistoryDataDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfHistoryDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfHistoryDataDto;
}());
export { PagedResultDtoOfHistoryDataDto };
/** 显示历史数据管道 */
var HistoryDataDto = /** @class */ (function () {
    function HistoryDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.channelId = data["channelId"];
            this.historyDataId = data["historyDataId"];
            this.dataSourceId = data["dataSourceId"];
            this.refHistoryDataKey = data["refHistoryDataKey"];
            this.refHistoryDataChannelKey = data["refHistoryDataChannelKey"];
            this.channelName = data["channelName"];
            this.historyDataName = data["historyDataName"];
            this.dataSourceName = data["dataSourceName"];
            this.stationNo = data["stationNo"];
            this.dataType = data["dataType"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.bitIndex = data["bitIndex"];
            this.sampleType = data["sampleType"];
            this.recordingPeriod = data["recordingPeriod"];
            this.address = data["address"];
            this.devAlias = data["devAlias"];
        }
    };
    HistoryDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataDto();
        result.init(data);
        return result;
    };
    HistoryDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channelId"] = this.channelId;
        data["historyDataId"] = this.historyDataId;
        data["dataSourceId"] = this.dataSourceId;
        data["refHistoryDataKey"] = this.refHistoryDataKey;
        data["refHistoryDataChannelKey"] = this.refHistoryDataChannelKey;
        data["channelName"] = this.channelName;
        data["historyDataName"] = this.historyDataName;
        data["dataSourceName"] = this.dataSourceName;
        data["stationNo"] = this.stationNo;
        data["dataType"] = this.dataType;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["bitIndex"] = this.bitIndex;
        data["sampleType"] = this.sampleType;
        data["recordingPeriod"] = this.recordingPeriod;
        data["address"] = this.address;
        data["devAlias"] = this.devAlias;
        return data;
    };
    return HistoryDataDto;
}());
export { HistoryDataDto };
var ListResultDtoOfHistoryDataNameListDto = /** @class */ (function () {
    function ListResultDtoOfHistoryDataNameListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfHistoryDataNameListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(HistoryDataNameListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfHistoryDataNameListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfHistoryDataNameListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfHistoryDataNameListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfHistoryDataNameListDto;
}());
export { ListResultDtoOfHistoryDataNameListDto };
var HistoryDataNameListDto = /** @class */ (function () {
    function HistoryDataNameListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataNameListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    HistoryDataNameListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataNameListDto();
        result.init(data);
        return result;
    };
    HistoryDataNameListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return HistoryDataNameListDto;
}());
export { HistoryDataNameListDto };
var ListResultDtoOfHistoryDataChannelNameListDto = /** @class */ (function () {
    function ListResultDtoOfHistoryDataChannelNameListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfHistoryDataChannelNameListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(HistoryDataChannelNameListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfHistoryDataChannelNameListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfHistoryDataChannelNameListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfHistoryDataChannelNameListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfHistoryDataChannelNameListDto;
}());
export { ListResultDtoOfHistoryDataChannelNameListDto };
var HistoryDataChannelNameListDto = /** @class */ (function () {
    function HistoryDataChannelNameListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataChannelNameListDto.prototype.init = function (data) {
        if (data) {
            this.channelName = data["channelName"];
        }
    };
    HistoryDataChannelNameListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataChannelNameListDto();
        result.init(data);
        return result;
    };
    HistoryDataChannelNameListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["channelName"] = this.channelName;
        return data;
    };
    return HistoryDataChannelNameListDto;
}());
export { HistoryDataChannelNameListDto };
var CreateOrUpdateHistoryDataItemDto = /** @class */ (function () {
    function CreateOrUpdateHistoryDataItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateHistoryDataItemDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.uid = data["uid"];
            this.dataSourceId = data["dataSourceId"];
            this.name = data["name"];
            this.recordingPeriod = data["recordingPeriod"];
            if (data["channels"] && data["channels"].constructor === Array) {
                this.channels = [];
                for (var _i = 0, _a = data["channels"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.channels.push(FBoxHistoryDataChannel.fromJS(item));
                }
            }
            this.isControl = data["isControl"];
            this.controlOption = data["controlOption"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateHistoryDataItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateHistoryDataItemDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateHistoryDataItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["uid"] = this.uid;
        data["dataSourceId"] = this.dataSourceId;
        data["name"] = this.name;
        data["recordingPeriod"] = this.recordingPeriod;
        if (this.channels && this.channels.constructor === Array) {
            data["channels"] = [];
            for (var _i = 0, _a = this.channels; _i < _a.length; _i++) {
                var item = _a[_i];
                data["channels"].push(item.toJSON());
            }
        }
        data["isControl"] = this.isControl;
        data["controlOption"] = this.controlOption;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateHistoryDataItemDto;
}());
export { CreateOrUpdateHistoryDataItemDto };
var FBoxHistoryDataChannel = /** @class */ (function () {
    function FBoxHistoryDataChannel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxHistoryDataChannel.prototype.init = function (data) {
        if (data) {
            this.fBoxHistoryDataItemId = data["fBoxHistoryDataItemId"];
            this.uid = data["uid"];
            this.channelName = data["channelName"];
            this.unit = data["unit"];
            this.description = data["description"];
            this.integralDigits = data["integralDigits"];
            this.fractionalDigits = data["fractionalDigits"];
            this.devAlias = data["devAlias"];
            this.stationNo = data["stationNo"];
            this.dataType = data["dataType"];
            this.regId = data["regId"];
            this.ioWidth = data["ioWidth"];
            this.regName = data["regName"];
            this.mainAddress = data["mainAddress"];
            this.subAddress = data["subAddress"];
            this.subIndex = data["subIndex"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.bitIndex = data["bitIndex"];
            this.addressDescription = data["addressDescription"];
            this.tagName = data["tagName"];
            this.deviceTagMapper = data["deviceTagMapper"];
            this.addressTag = data["addressTag"];
            this.refHistoryDataChannelKey = data["refHistoryDataChannelKey"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    FBoxHistoryDataChannel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxHistoryDataChannel();
        result.init(data);
        return result;
    };
    FBoxHistoryDataChannel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fBoxHistoryDataItemId"] = this.fBoxHistoryDataItemId;
        data["uid"] = this.uid;
        data["channelName"] = this.channelName;
        data["unit"] = this.unit;
        data["description"] = this.description;
        data["integralDigits"] = this.integralDigits;
        data["fractionalDigits"] = this.fractionalDigits;
        data["devAlias"] = this.devAlias;
        data["stationNo"] = this.stationNo;
        data["dataType"] = this.dataType;
        data["regId"] = this.regId;
        data["ioWidth"] = this.ioWidth;
        data["regName"] = this.regName;
        data["mainAddress"] = this.mainAddress;
        data["subAddress"] = this.subAddress;
        data["subIndex"] = this.subIndex;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["bitIndex"] = this.bitIndex;
        data["addressDescription"] = this.addressDescription;
        data["tagName"] = this.tagName;
        data["deviceTagMapper"] = this.deviceTagMapper;
        data["addressTag"] = this.addressTag;
        data["refHistoryDataChannelKey"] = this.refHistoryDataChannelKey;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return FBoxHistoryDataChannel;
}());
export { FBoxHistoryDataChannel };
/** 根据数据源进行导入 */
var BatchImportHistoryDataByDataSourceDto = /** @class */ (function () {
    function BatchImportHistoryDataByDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchImportHistoryDataByDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.dataSourceType = data["dataSourceType"];
        }
    };
    BatchImportHistoryDataByDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchImportHistoryDataByDataSourceDto();
        result.init(data);
        return result;
    };
    BatchImportHistoryDataByDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["dataSourceType"] = this.dataSourceType;
        return data;
    };
    return BatchImportHistoryDataByDataSourceDto;
}());
export { BatchImportHistoryDataByDataSourceDto };
var BatchImportHistoryData = /** @class */ (function () {
    function BatchImportHistoryData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchImportHistoryData.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.refHistoryDataKey = data["refHistoryDataKey"];
            this.refHistoryDataChannelKey = data["refHistoryDataChannelKey"];
        }
    };
    BatchImportHistoryData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchImportHistoryData();
        result.init(data);
        return result;
    };
    BatchImportHistoryData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["refHistoryDataKey"] = this.refHistoryDataKey;
        data["refHistoryDataChannelKey"] = this.refHistoryDataChannelKey;
        return data;
    };
    return BatchImportHistoryData;
}());
export { BatchImportHistoryData };
var PagedResultDtoOfHistoryEventOutput = /** @class */ (function () {
    function PagedResultDtoOfHistoryEventOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfHistoryEventOutput.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(HistoryEventOutput.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfHistoryEventOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfHistoryEventOutput();
        result.init(data);
        return result;
    };
    PagedResultDtoOfHistoryEventOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfHistoryEventOutput;
}());
export { PagedResultDtoOfHistoryEventOutput };
var HistoryEventOutput = /** @class */ (function () {
    function HistoryEventOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryEventOutput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.deviceName = data["deviceName"];
            this.eventName = data["eventName"];
            this.eventContent = data["eventContent"];
            this.eventGroupName = data["eventGroupName"];
            this.fCloudVariableName = data["fCloudVariableName"];
            this.state = data["state"];
            this.value = data["value"];
            this.unit = data["unit"];
            this.triggerRuleType = data["triggerRuleType"];
            this.delaySeconds = data["delaySeconds"];
            this.deadBand = data["deadBand"];
            this.triggeredRuleDesp = data["triggeredRuleDesp"];
            this.triggeredTime = data["triggeredTime"] ? moment(data["triggeredTime"].toString()) : undefined;
            this.recoveryTime = data["recoveryTime"] ? moment(data["recoveryTime"].toString()) : undefined;
            this.recoveryValue = data["recoveryValue"];
        }
    };
    HistoryEventOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryEventOutput();
        result.init(data);
        return result;
    };
    HistoryEventOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceName"] = this.deviceName;
        data["eventName"] = this.eventName;
        data["eventContent"] = this.eventContent;
        data["eventGroupName"] = this.eventGroupName;
        data["fCloudVariableName"] = this.fCloudVariableName;
        data["state"] = this.state;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["triggerRuleType"] = this.triggerRuleType;
        data["delaySeconds"] = this.delaySeconds;
        data["deadBand"] = this.deadBand;
        data["triggeredRuleDesp"] = this.triggeredRuleDesp;
        data["triggeredTime"] = this.triggeredTime ? this.triggeredTime.toISOString() : undefined;
        data["recoveryTime"] = this.recoveryTime ? this.recoveryTime.toISOString() : undefined;
        data["recoveryValue"] = this.recoveryValue;
        return data;
    };
    return HistoryEventOutput;
}());
export { HistoryEventOutput };
var ExportEventFileInput = /** @class */ (function () {
    function ExportEventFileInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportEventFileInput.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.triggeredStartTime = data["triggeredStartTime"] ? moment(data["triggeredStartTime"].toString()) : undefined;
            this.triggeredEndTime = data["triggeredEndTime"] ? moment(data["triggeredEndTime"].toString()) : undefined;
            this.state = data["state"];
            this.eventName = data["eventName"];
            this.deviceName = data["deviceName"];
            this.eventGroupName = data["eventGroupName"];
            this.fCloudVariableName = data["fCloudVariableName"];
            this.recoveryStartTime = data["recoveryStartTime"] ? moment(data["recoveryStartTime"].toString()) : undefined;
            this.recoveryEndTime = data["recoveryEndTime"] ? moment(data["recoveryEndTime"].toString()) : undefined;
        }
    };
    ExportEventFileInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportEventFileInput();
        result.init(data);
        return result;
    };
    ExportEventFileInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["triggeredStartTime"] = this.triggeredStartTime ? this.triggeredStartTime.toISOString() : undefined;
        data["triggeredEndTime"] = this.triggeredEndTime ? this.triggeredEndTime.toISOString() : undefined;
        data["state"] = this.state;
        data["eventName"] = this.eventName;
        data["deviceName"] = this.deviceName;
        data["eventGroupName"] = this.eventGroupName;
        data["fCloudVariableName"] = this.fCloudVariableName;
        data["recoveryStartTime"] = this.recoveryStartTime ? this.recoveryStartTime.toISOString() : undefined;
        data["recoveryEndTime"] = this.recoveryEndTime ? this.recoveryEndTime.toISOString() : undefined;
        return data;
    };
    return ExportEventFileInput;
}());
export { ExportEventFileInput };
var HostDashboardData = /** @class */ (function () {
    function HostDashboardData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostDashboardData.prototype.init = function (data) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (var _i = 0, _a = data["incomeStatistics"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
                }
            }
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (var _b = 0, _c = data["editionStatistics"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.editionStatistics.push(TenantEdition.fromJS(item));
                }
            }
            if (data["expiringTenants"] && data["expiringTenants"].constructor === Array) {
                this.expiringTenants = [];
                for (var _d = 0, _e = data["expiringTenants"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.expiringTenants.push(ExpiringTenant.fromJS(item));
                }
            }
            if (data["recentTenants"] && data["recentTenants"].constructor === Array) {
                this.recentTenants = [];
                for (var _f = 0, _g = data["recentTenants"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.recentTenants.push(RecentTenant.fromJS(item));
                }
            }
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : undefined;
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : undefined;
            this.deviceInfosOutput = data["deviceInfosOutput"] ? GetDeviceInfosOutput.fromJS(data["deviceInfosOutput"]) : undefined;
        }
    };
    HostDashboardData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostDashboardData();
        result.init(data);
        return result;
    };
    HostDashboardData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (var _i = 0, _a = this.incomeStatistics; _i < _a.length; _i++) {
                var item = _a[_i];
                data["incomeStatistics"].push(item.toJSON());
            }
        }
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (var _b = 0, _c = this.editionStatistics; _b < _c.length; _b++) {
                var item = _c[_b];
                data["editionStatistics"].push(item.toJSON());
            }
        }
        if (this.expiringTenants && this.expiringTenants.constructor === Array) {
            data["expiringTenants"] = [];
            for (var _d = 0, _e = this.expiringTenants; _d < _e.length; _d++) {
                var item = _e[_d];
                data["expiringTenants"].push(item.toJSON());
            }
        }
        if (this.recentTenants && this.recentTenants.constructor === Array) {
            data["recentTenants"] = [];
            for (var _f = 0, _g = this.recentTenants; _f < _g.length; _f++) {
                var item = _g[_f];
                data["recentTenants"].push(item.toJSON());
            }
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : undefined;
        data["deviceInfosOutput"] = this.deviceInfosOutput ? this.deviceInfosOutput.toJSON() : undefined;
        return data;
    };
    return HostDashboardData;
}());
export { HostDashboardData };
var IncomeStastistic = /** @class */ (function () {
    function IncomeStastistic(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IncomeStastistic.prototype.init = function (data) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.amount = data["amount"];
        }
    };
    IncomeStastistic.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IncomeStastistic();
        result.init(data);
        return result;
    };
    IncomeStastistic.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["amount"] = this.amount;
        return data;
    };
    return IncomeStastistic;
}());
export { IncomeStastistic };
var TenantEdition = /** @class */ (function () {
    function TenantEdition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEdition.prototype.init = function (data) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    };
    TenantEdition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEdition();
        result.init(data);
        return result;
    };
    TenantEdition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    };
    return TenantEdition;
}());
export { TenantEdition };
var ExpiringTenant = /** @class */ (function () {
    function ExpiringTenant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExpiringTenant.prototype.init = function (data) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    };
    ExpiringTenant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExpiringTenant();
        result.init(data);
        return result;
    };
    ExpiringTenant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    };
    return ExpiringTenant;
}());
export { ExpiringTenant };
var RecentTenant = /** @class */ (function () {
    function RecentTenant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RecentTenant.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    RecentTenant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RecentTenant();
        result.init(data);
        return result;
    };
    RecentTenant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return RecentTenant;
}());
export { RecentTenant };
var GetDeviceInfosOutput = /** @class */ (function () {
    function GetDeviceInfosOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDeviceInfosOutput.prototype.init = function (data) {
        if (data) {
            this.totalDeviceCount = data["totalDeviceCount"];
            this.onlineDeviceCount = data["onlineDeviceCount"];
            this.alarmDeviceCount = data["alarmDeviceCount"];
            this.offlineDeviceCount = data["offlineDeviceCount"];
            this.onlineDeviceCountShare = data["onlineDeviceCountShare"];
            this.alarmDeviceCountShare = data["alarmDeviceCountShare"];
            this.offlineDeviceCountShare = data["offlineDeviceCountShare"];
        }
    };
    GetDeviceInfosOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDeviceInfosOutput();
        result.init(data);
        return result;
    };
    GetDeviceInfosOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalDeviceCount"] = this.totalDeviceCount;
        data["onlineDeviceCount"] = this.onlineDeviceCount;
        data["alarmDeviceCount"] = this.alarmDeviceCount;
        data["offlineDeviceCount"] = this.offlineDeviceCount;
        data["onlineDeviceCountShare"] = this.onlineDeviceCountShare;
        data["alarmDeviceCountShare"] = this.alarmDeviceCountShare;
        data["offlineDeviceCountShare"] = this.offlineDeviceCountShare;
        return data;
    };
    return GetDeviceInfosOutput;
}());
export { GetDeviceInfosOutput };
var GetIncomeStatisticsDataOutput = /** @class */ (function () {
    function GetIncomeStatisticsDataOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetIncomeStatisticsDataOutput.prototype.init = function (data) {
        if (data) {
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (var _i = 0, _a = data["incomeStatistics"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
                }
            }
        }
    };
    GetIncomeStatisticsDataOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    };
    GetIncomeStatisticsDataOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (var _i = 0, _a = this.incomeStatistics; _i < _a.length; _i++) {
                var item = _a[_i];
                data["incomeStatistics"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetIncomeStatisticsDataOutput;
}());
export { GetIncomeStatisticsDataOutput };
var GetEditionTenantStatisticsOutput = /** @class */ (function () {
    function GetEditionTenantStatisticsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEditionTenantStatisticsOutput.prototype.init = function (data) {
        if (data) {
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (var _i = 0, _a = data["editionStatistics"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.editionStatistics.push(TenantEdition.fromJS(item));
                }
            }
        }
    };
    GetEditionTenantStatisticsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    };
    GetEditionTenantStatisticsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (var _i = 0, _a = this.editionStatistics; _i < _a.length; _i++) {
                var item = _a[_i];
                data["editionStatistics"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetEditionTenantStatisticsOutput;
}());
export { GetEditionTenantStatisticsOutput };
var HostSettingsEditDto = /** @class */ (function () {
    function HostSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }
    HostSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : undefined;
        }
    };
    HostSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostSettingsEditDto();
        result.init(data);
        return result;
    };
    HostSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined;
        data["email"] = this.email ? this.email.toJSON() : undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : undefined;
        data["security"] = this.security ? this.security.toJSON() : undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined;
        return data;
    };
    return HostSettingsEditDto;
}());
export { HostSettingsEditDto };
var GeneralSettingsEditDto = /** @class */ (function () {
    function GeneralSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeneralSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    };
    GeneralSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    };
    GeneralSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    };
    return GeneralSettingsEditDto;
}());
export { GeneralSettingsEditDto };
var HostUserManagementSettingsEditDto = /** @class */ (function () {
    function HostUserManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostUserManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEmailOrPhoneConfirmationRequiredForLogin = data["isEmailOrPhoneConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
        }
    };
    HostUserManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    HostUserManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEmailOrPhoneConfirmationRequiredForLogin"] = this.isEmailOrPhoneConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        return data;
    };
    return HostUserManagementSettingsEditDto;
}());
export { HostUserManagementSettingsEditDto };
var EmailSettingsEditDto = /** @class */ (function () {
    function EmailSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmailSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    };
    EmailSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    };
    EmailSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    };
    return EmailSettingsEditDto;
}());
export { EmailSettingsEditDto };
var TenantManagementSettingsEditDto = /** @class */ (function () {
    function TenantManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    };
    TenantManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    };
    return TenantManagementSettingsEditDto;
}());
export { TenantManagementSettingsEditDto };
var SecuritySettingsEditDto = /** @class */ (function () {
    function SecuritySettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SecuritySettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : undefined;
        }
    };
    SecuritySettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    };
    SecuritySettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : undefined;
        return data;
    };
    return SecuritySettingsEditDto;
}());
export { SecuritySettingsEditDto };
var HostBillingSettingsEditDto = /** @class */ (function () {
    function HostBillingSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostBillingSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    };
    HostBillingSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    };
    HostBillingSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    };
    return HostBillingSettingsEditDto;
}());
export { HostBillingSettingsEditDto };
var PasswordComplexitySetting = /** @class */ (function () {
    function PasswordComplexitySetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PasswordComplexitySetting.prototype.init = function (data) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    };
    PasswordComplexitySetting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    };
    PasswordComplexitySetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    };
    return PasswordComplexitySetting;
}());
export { PasswordComplexitySetting };
var UserLockOutSettingsEditDto = /** @class */ (function () {
    function UserLockOutSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLockOutSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    };
    UserLockOutSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    };
    UserLockOutSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    };
    return UserLockOutSettingsEditDto;
}());
export { UserLockOutSettingsEditDto };
var TwoFactorLoginSettingsEditDto = /** @class */ (function () {
    function TwoFactorLoginSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TwoFactorLoginSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    };
    TwoFactorLoginSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    };
    TwoFactorLoginSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    };
    return TwoFactorLoginSettingsEditDto;
}());
export { TwoFactorLoginSettingsEditDto };
var SendTestEmailInput = /** @class */ (function () {
    function SendTestEmailInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendTestEmailInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendTestEmailInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendTestEmailInput();
        result.init(data);
        return result;
    };
    SendTestEmailInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendTestEmailInput;
}());
export { SendTestEmailInput };
var InstallDto = /** @class */ (function () {
    function InstallDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InstallDto.prototype.init = function (data) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : undefined;
        }
    };
    InstallDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InstallDto();
        result.init(data);
        return result;
    };
    InstallDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : undefined;
        return data;
    };
    return InstallDto;
}());
export { InstallDto };
var AppSettingsJsonDto = /** @class */ (function () {
    function AppSettingsJsonDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AppSettingsJsonDto.prototype.init = function (data) {
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (var _i = 0, _a = data["languages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.languages.push(NameValue.fromJS(item));
                }
            }
        }
    };
    AppSettingsJsonDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    };
    AppSettingsJsonDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (var _i = 0, _a = this.languages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["languages"].push(item.toJSON());
            }
        }
        return data;
    };
    return AppSettingsJsonDto;
}());
export { AppSettingsJsonDto };
var NameValue = /** @class */ (function () {
    function NameValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValue.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValue();
        result.init(data);
        return result;
    };
    NameValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValue;
}());
export { NameValue };
var CheckDatabaseOutput = /** @class */ (function () {
    function CheckDatabaseOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckDatabaseOutput.prototype.init = function (data) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    };
    CheckDatabaseOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    };
    CheckDatabaseOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    };
    return CheckDatabaseOutput;
}());
export { CheckDatabaseOutput };
var PagedResultDtoOfOrganizationListDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfOrganizationListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationListDto;
}());
export { PagedResultDtoOfOrganizationListDto };
var OrganizationListDto = /** @class */ (function () {
    function OrganizationListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationListDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.type = data["type"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.id = data["id"];
        }
    };
    OrganizationListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationListDto();
        result.init(data);
        return result;
    };
    OrganizationListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    };
    return OrganizationListDto;
}());
export { OrganizationListDto };
var OrganizationForEditDto = /** @class */ (function () {
    function OrganizationForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationForEditDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.type = data["type"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.companyDetail = data["companyDetail"] ? CompanyDetailDto.fromJS(data["companyDetail"]) : undefined;
            if (data["contacts"] && data["contacts"].constructor === Array) {
                this.contacts = [];
                for (var _i = 0, _a = data["contacts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contacts.push(OrganizationContactDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    OrganizationForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationForEditDto();
        result.init(data);
        return result;
    };
    OrganizationForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["companyDetail"] = this.companyDetail ? this.companyDetail.toJSON() : undefined;
        if (this.contacts && this.contacts.constructor === Array) {
            data["contacts"] = [];
            for (var _i = 0, _a = this.contacts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contacts"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return OrganizationForEditDto;
}());
export { OrganizationForEditDto };
var CreateOrUpdateOrganizationDto = /** @class */ (function () {
    function CreateOrUpdateOrganizationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateOrganizationDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.type = data["type"];
            this.callingCode = data["callingCode"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.approximateAddress = data["approximateAddress"];
            this.address = data["address"];
            this.remark = data["remark"];
            this.companyDetail = data["companyDetail"] ? CompanyDetailDto.fromJS(data["companyDetail"]) : undefined;
            if (data["contacts"] && data["contacts"].constructor === Array) {
                this.contacts = [];
                for (var _i = 0, _a = data["contacts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contacts.push(OrganizationContactDto.fromJS(item));
                }
            }
            if (data["attachments"] && data["attachments"].constructor === Array) {
                this.attachments = [];
                for (var _b = 0, _c = data["attachments"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.attachments.push(OrganizationAttachmentDto.fromJS(item));
                }
            }
            if (data["deleteContactIds"] && data["deleteContactIds"].constructor === Array) {
                this.deleteContactIds = [];
                for (var _d = 0, _e = data["deleteContactIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.deleteContactIds.push(item);
                }
            }
            if (data["deleteAttachments"] && data["deleteAttachments"].constructor === Array) {
                this.deleteAttachments = [];
                for (var _f = 0, _g = data["deleteAttachments"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.deleteAttachments.push(item);
                }
            }
            this.organizationAddress = data["organizationAddress"] ? OrganizationAddressDto.fromJS(data["organizationAddress"]) : undefined;
            this.id = data["id"];
        }
    };
    CreateOrUpdateOrganizationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateOrganizationDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateOrganizationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["callingCode"] = this.callingCode;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["approximateAddress"] = this.approximateAddress;
        data["address"] = this.address;
        data["remark"] = this.remark;
        data["companyDetail"] = this.companyDetail ? this.companyDetail.toJSON() : undefined;
        if (this.contacts && this.contacts.constructor === Array) {
            data["contacts"] = [];
            for (var _i = 0, _a = this.contacts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contacts"].push(item.toJSON());
            }
        }
        if (this.attachments && this.attachments.constructor === Array) {
            data["attachments"] = [];
            for (var _b = 0, _c = this.attachments; _b < _c.length; _b++) {
                var item = _c[_b];
                data["attachments"].push(item.toJSON());
            }
        }
        if (this.deleteContactIds && this.deleteContactIds.constructor === Array) {
            data["deleteContactIds"] = [];
            for (var _d = 0, _e = this.deleteContactIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["deleteContactIds"].push(item);
            }
        }
        if (this.deleteAttachments && this.deleteAttachments.constructor === Array) {
            data["deleteAttachments"] = [];
            for (var _f = 0, _g = this.deleteAttachments; _f < _g.length; _f++) {
                var item = _g[_f];
                data["deleteAttachments"].push(item);
            }
        }
        data["organizationAddress"] = this.organizationAddress ? this.organizationAddress.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateOrganizationDto;
}());
export { CreateOrUpdateOrganizationDto };
var GetOrganizationListDto = /** @class */ (function () {
    function GetOrganizationListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetOrganizationListDto.prototype.init = function (data) {
        if (data) {
            this.term = data["term"];
            this.organizationType = data["organizationType"];
            this.sorting = data["sorting"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    };
    GetOrganizationListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetOrganizationListDto();
        result.init(data);
        return result;
    };
    GetOrganizationListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        data["organizationType"] = this.organizationType;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    };
    return GetOrganizationListDto;
}());
export { GetOrganizationListDto };
var InvoiceDto = /** @class */ (function () {
    function InvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvoiceDto.prototype.init = function (data) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (data["tenantAddress"] && data["tenantAddress"].constructor === Array) {
                this.tenantAddress = [];
                for (var _i = 0, _a = data["tenantAddress"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenantAddress.push(item);
                }
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (data["hostAddress"] && data["hostAddress"].constructor === Array) {
                this.hostAddress = [];
                for (var _b = 0, _c = data["hostAddress"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.hostAddress.push(item);
                }
            }
        }
    };
    InvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvoiceDto();
        result.init(data);
        return result;
    };
    InvoiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (this.tenantAddress && this.tenantAddress.constructor === Array) {
            data["tenantAddress"] = [];
            for (var _i = 0, _a = this.tenantAddress; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenantAddress"].push(item);
            }
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (this.hostAddress && this.hostAddress.constructor === Array) {
            data["hostAddress"] = [];
            for (var _b = 0, _c = this.hostAddress; _b < _c.length; _b++) {
                var item = _c[_b];
                data["hostAddress"].push(item);
            }
        }
        return data;
    };
    return InvoiceDto;
}());
export { InvoiceDto };
var CreateInvoiceDto = /** @class */ (function () {
    function CreateInvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateInvoiceDto.prototype.init = function (data) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    };
    CreateInvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateInvoiceDto();
        result.init(data);
        return result;
    };
    CreateInvoiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    };
    return CreateInvoiceDto;
}());
export { CreateInvoiceDto };
var GetLanguagesOutput = /** @class */ (function () {
    function GetLanguagesOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLanguagesOutput.prototype.init = function (data) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ApplicationLanguageListDto.fromJS(item));
                }
            }
        }
    };
    GetLanguagesOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLanguagesOutput();
        result.init(data);
        return result;
    };
    GetLanguagesOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetLanguagesOutput;
}());
export { GetLanguagesOutput };
var ApplicationLanguageListDto = /** @class */ (function () {
    function ApplicationLanguageListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationLanguageListDto.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ApplicationLanguageListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    };
    ApplicationLanguageListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ApplicationLanguageListDto;
}());
export { ApplicationLanguageListDto };
var GetLanguageForEditOutput = /** @class */ (function () {
    function GetLanguageForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLanguageForEditOutput.prototype.init = function (data) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : undefined;
            if (data["languageNames"] && data["languageNames"].constructor === Array) {
                this.languageNames = [];
                for (var _i = 0, _a = data["languageNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
                }
            }
            if (data["flags"] && data["flags"].constructor === Array) {
                this.flags = [];
                for (var _b = 0, _c = data["flags"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.flags.push(ComboboxItemDto.fromJS(item));
                }
            }
        }
    };
    GetLanguageForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    };
    GetLanguageForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined;
        if (this.languageNames && this.languageNames.constructor === Array) {
            data["languageNames"] = [];
            for (var _i = 0, _a = this.languageNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["languageNames"].push(item.toJSON());
            }
        }
        if (this.flags && this.flags.constructor === Array) {
            data["flags"] = [];
            for (var _b = 0, _c = this.flags; _b < _c.length; _b++) {
                var item = _c[_b];
                data["flags"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetLanguageForEditOutput;
}());
export { GetLanguageForEditOutput };
var ApplicationLanguageEditDto = /** @class */ (function () {
    function ApplicationLanguageEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationLanguageEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    };
    ApplicationLanguageEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    };
    ApplicationLanguageEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    };
    return ApplicationLanguageEditDto;
}());
export { ApplicationLanguageEditDto };
var ComboboxItemDto = /** @class */ (function () {
    function ComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    };
    ComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComboboxItemDto();
        result.init(data);
        return result;
    };
    ComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    };
    return ComboboxItemDto;
}());
export { ComboboxItemDto };
var CreateOrUpdateLanguageInput = /** @class */ (function () {
    function CreateOrUpdateLanguageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }
    CreateOrUpdateLanguageInput.prototype.init = function (data) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    };
    CreateOrUpdateLanguageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateLanguageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined;
        return data;
    };
    return CreateOrUpdateLanguageInput;
}());
export { CreateOrUpdateLanguageInput };
var SetDefaultLanguageInput = /** @class */ (function () {
    function SetDefaultLanguageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetDefaultLanguageInput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    SetDefaultLanguageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    };
    SetDefaultLanguageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return SetDefaultLanguageInput;
}());
export { SetDefaultLanguageInput };
var PagedResultDtoOfLanguageTextListDto = /** @class */ (function () {
    function PagedResultDtoOfLanguageTextListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfLanguageTextListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LanguageTextListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfLanguageTextListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfLanguageTextListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfLanguageTextListDto;
}());
export { PagedResultDtoOfLanguageTextListDto };
var LanguageTextListDto = /** @class */ (function () {
    function LanguageTextListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LanguageTextListDto.prototype.init = function (data) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    };
    LanguageTextListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LanguageTextListDto();
        result.init(data);
        return result;
    };
    LanguageTextListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    };
    return LanguageTextListDto;
}());
export { LanguageTextListDto };
var UpdateLanguageTextInput = /** @class */ (function () {
    function UpdateLanguageTextInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateLanguageTextInput.prototype.init = function (data) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    };
    UpdateLanguageTextInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    };
    UpdateLanguageTextInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    };
    return UpdateLanguageTextInput;
}());
export { UpdateLanguageTextInput };
var PagedResultDtoOfVariableItemForLiveReportDto = /** @class */ (function () {
    function PagedResultDtoOfVariableItemForLiveReportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfVariableItemForLiveReportDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(VariableItemForLiveReportDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfVariableItemForLiveReportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfVariableItemForLiveReportDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfVariableItemForLiveReportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfVariableItemForLiveReportDto;
}());
export { PagedResultDtoOfVariableItemForLiveReportDto };
var VariableItemForLiveReportDto = /** @class */ (function () {
    function VariableItemForLiveReportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableItemForLiveReportDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.groupName = data["groupName"];
            this.unit = data["unit"];
            this.dataSourceName = data["dataSourceName"];
            this.dataType = data["dataType"];
            this.variableRwType = data["variableRwType"];
            this.monitorName = data["monitorName"];
            this.address = data["address"];
            this.isUnbind = data["isUnbind"];
            this.labelText = data["labelText"];
        }
    };
    VariableItemForLiveReportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableItemForLiveReportDto();
        result.init(data);
        return result;
    };
    VariableItemForLiveReportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["unit"] = this.unit;
        data["dataSourceName"] = this.dataSourceName;
        data["dataType"] = this.dataType;
        data["variableRwType"] = this.variableRwType;
        data["monitorName"] = this.monitorName;
        data["address"] = this.address;
        data["isUnbind"] = this.isUnbind;
        data["labelText"] = this.labelText;
        return data;
    };
    return VariableItemForLiveReportDto;
}());
export { VariableItemForLiveReportDto };
var LoadFCloudVariableDataDto = /** @class */ (function () {
    function LoadFCloudVariableDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoadFCloudVariableDataDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.variableName = data["variableName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : undefined;
        }
    };
    LoadFCloudVariableDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoadFCloudVariableDataDto();
        result.init(data);
        return result;
    };
    LoadFCloudVariableDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["variableName"] = this.variableName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        return data;
    };
    return LoadFCloudVariableDataDto;
}());
export { LoadFCloudVariableDataDto };
var LiveVariableDataDto = /** @class */ (function () {
    function LiveVariableDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LiveVariableDataDto.prototype.init = function (data) {
        if (data) {
            this.timeStamp = data["timeStamp"] ? moment(data["timeStamp"].toString()) : undefined;
            this.value = data["value"];
        }
    };
    LiveVariableDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LiveVariableDataDto();
        result.init(data);
        return result;
    };
    LiveVariableDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : undefined;
        data["value"] = this.value;
        return data;
    };
    return LiveVariableDataDto;
}());
export { LiveVariableDataDto };
var QueryVirtualDeviceTrajectoryDto = /** @class */ (function () {
    function QueryVirtualDeviceTrajectoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QueryVirtualDeviceTrajectoryDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
            this.longitudeVariable = data["longitudeVariable"];
            this.latitudeVariable = data["latitudeVariable"];
        }
    };
    QueryVirtualDeviceTrajectoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QueryVirtualDeviceTrajectoryDto();
        result.init(data);
        return result;
    };
    QueryVirtualDeviceTrajectoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["longitudeVariable"] = this.longitudeVariable;
        data["latitudeVariable"] = this.latitudeVariable;
        return data;
    };
    return QueryVirtualDeviceTrajectoryDto;
}());
export { QueryVirtualDeviceTrajectoryDto };
var VirtualDeviceTrajectoryDto = /** @class */ (function () {
    function VirtualDeviceTrajectoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VirtualDeviceTrajectoryDto.prototype.init = function (data) {
        if (data) {
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    };
    VirtualDeviceTrajectoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VirtualDeviceTrajectoryDto();
        result.init(data);
        return result;
    };
    VirtualDeviceTrajectoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    };
    return VirtualDeviceTrajectoryDto;
}());
export { VirtualDeviceTrajectoryDto };
var PagedResultDtoOfActionLogInfoDto = /** @class */ (function () {
    function PagedResultDtoOfActionLogInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfActionLogInfoDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ActionLogInfoDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfActionLogInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfActionLogInfoDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfActionLogInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfActionLogInfoDto;
}());
export { PagedResultDtoOfActionLogInfoDto };
var ActionLogInfoDto = /** @class */ (function () {
    function ActionLogInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActionLogInfoDto.prototype.init = function (data) {
        if (data) {
            this.actionTime = data["actionTime"] ? moment(data["actionTime"].toString()) : undefined;
            this.userName = data["userName"];
            this.actionType = data["actionType"];
            this.ipAddress = data["ipAddress"];
            this.browser = data["browser"];
            this.clientType = data["clientType"];
        }
    };
    ActionLogInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActionLogInfoDto();
        result.init(data);
        return result;
    };
    ActionLogInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : undefined;
        data["userName"] = this.userName;
        data["actionType"] = this.actionType;
        data["ipAddress"] = this.ipAddress;
        data["browser"] = this.browser;
        data["clientType"] = this.clientType;
        return data;
    };
    return ActionLogInfoDto;
}());
export { ActionLogInfoDto };
var CreateMaintenancePlanDto = /** @class */ (function () {
    function CreateMaintenancePlanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateMaintenancePlanDto.prototype.init = function (data) {
        if (data) {
            this.planName = data["planName"];
            if (data["deviceIds"] && data["deviceIds"].constructor === Array) {
                this.deviceIds = [];
                for (var _i = 0, _a = data["deviceIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.deviceIds.push(item);
                }
            }
            this.warrantyPeriod = data["warrantyPeriod"];
            this.warrantyPeriodCycleType = data["warrantyPeriodCycleType"];
            this.warrantyCycle = data["warrantyCycle"];
            this.warrantyCycleType = data["warrantyCycleType"];
            this.firstMaintenanceTime = data["firstMaintenanceTime"] ? moment(data["firstMaintenanceTime"].toString()) : undefined;
            this.isAutoStopExpired = data["isAutoStopExpired"];
            this.notifyType = data["notifyType"];
            this.id = data["id"];
        }
    };
    CreateMaintenancePlanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateMaintenancePlanDto();
        result.init(data);
        return result;
    };
    CreateMaintenancePlanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["planName"] = this.planName;
        if (this.deviceIds && this.deviceIds.constructor === Array) {
            data["deviceIds"] = [];
            for (var _i = 0, _a = this.deviceIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["deviceIds"].push(item);
            }
        }
        data["warrantyPeriod"] = this.warrantyPeriod;
        data["warrantyPeriodCycleType"] = this.warrantyPeriodCycleType;
        data["warrantyCycle"] = this.warrantyCycle;
        data["warrantyCycleType"] = this.warrantyCycleType;
        data["firstMaintenanceTime"] = this.firstMaintenanceTime ? this.firstMaintenanceTime.toISOString() : undefined;
        data["isAutoStopExpired"] = this.isAutoStopExpired;
        data["notifyType"] = this.notifyType;
        data["id"] = this.id;
        return data;
    };
    return CreateMaintenancePlanDto;
}());
export { CreateMaintenancePlanDto };
var PagedResultDtoOfUnAssignedDeviceDto = /** @class */ (function () {
    function PagedResultDtoOfUnAssignedDeviceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfUnAssignedDeviceDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UnAssignedDeviceDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfUnAssignedDeviceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfUnAssignedDeviceDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfUnAssignedDeviceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfUnAssignedDeviceDto;
}());
export { PagedResultDtoOfUnAssignedDeviceDto };
var UnAssignedDeviceDto = /** @class */ (function () {
    function UnAssignedDeviceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnAssignedDeviceDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.serialNumber = data["serialNumber"];
            this.deviceModel = data["deviceModel"] ? DeviceModelNameDto.fromJS(data["deviceModel"]) : undefined;
            this.id = data["id"];
        }
    };
    UnAssignedDeviceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnAssignedDeviceDto();
        result.init(data);
        return result;
    };
    UnAssignedDeviceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return UnAssignedDeviceDto;
}());
export { UnAssignedDeviceDto };
var GetAssignWorkOrderDto = /** @class */ (function () {
    function GetAssignWorkOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAssignWorkOrderDto.prototype.init = function (data) {
        if (data) {
            this.assignOrderId = data["assignOrderId"];
            this.description = data["description"];
            this.executorId = data["executorId"];
            this.executorName = data["executorName"];
            this.customerName = data["customerName"];
            this.customerConcat = data["customerConcat"];
        }
    };
    GetAssignWorkOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAssignWorkOrderDto();
        result.init(data);
        return result;
    };
    GetAssignWorkOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assignOrderId"] = this.assignOrderId;
        data["description"] = this.description;
        data["executorId"] = this.executorId;
        data["executorName"] = this.executorName;
        data["customerName"] = this.customerName;
        data["customerConcat"] = this.customerConcat;
        return data;
    };
    return GetAssignWorkOrderDto;
}());
export { GetAssignWorkOrderDto };
var PagedResultDtoOfMaintenancePlanDto = /** @class */ (function () {
    function PagedResultDtoOfMaintenancePlanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfMaintenancePlanDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(MaintenancePlanDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfMaintenancePlanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfMaintenancePlanDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfMaintenancePlanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfMaintenancePlanDto;
}());
export { PagedResultDtoOfMaintenancePlanDto };
var ExportMaintenancePlanListDto = /** @class */ (function () {
    function ExportMaintenancePlanListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportMaintenancePlanListDto.prototype.init = function (data) {
        if (data) {
            this.baseFilter = data["baseFilter"];
            this.warrantyType = data["warrantyType"];
            this.planState = data["planState"];
            this.deviceModelId = data["deviceModelId"];
        }
    };
    ExportMaintenancePlanListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportMaintenancePlanListDto();
        result.init(data);
        return result;
    };
    ExportMaintenancePlanListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["baseFilter"] = this.baseFilter;
        data["warrantyType"] = this.warrantyType;
        data["planState"] = this.planState;
        data["deviceModelId"] = this.deviceModelId;
        return data;
    };
    return ExportMaintenancePlanListDto;
}());
export { ExportMaintenancePlanListDto };
var PagedResultDtoOfMaintenanceRecordDto = /** @class */ (function () {
    function PagedResultDtoOfMaintenanceRecordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfMaintenanceRecordDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(MaintenanceRecordDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfMaintenanceRecordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfMaintenanceRecordDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfMaintenanceRecordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfMaintenanceRecordDto;
}());
export { PagedResultDtoOfMaintenanceRecordDto };
var MaintenanceRecordDto = /** @class */ (function () {
    function MaintenanceRecordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MaintenanceRecordDto.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"];
            this.description = data["description"];
            this.state = data["state"];
            this.workOrderType = data["workOrderType"];
            this.executorName = data["executorName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    MaintenanceRecordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MaintenanceRecordDto();
        result.init(data);
        return result;
    };
    MaintenanceRecordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["description"] = this.description;
        data["state"] = this.state;
        data["workOrderType"] = this.workOrderType;
        data["executorName"] = this.executorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return MaintenanceRecordDto;
}());
export { MaintenanceRecordDto };
var ModelGroupListDto = /** @class */ (function () {
    function ModelGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModelGroupListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayOrder = data["displayOrder"];
            this.id = data["id"];
        }
    };
    ModelGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModelGroupListDto();
        result.init(data);
        return result;
    };
    ModelGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayOrder"] = this.displayOrder;
        data["id"] = this.id;
        return data;
    };
    return ModelGroupListDto;
}());
export { ModelGroupListDto };
var ModelGroupForEditDto = /** @class */ (function () {
    function ModelGroupForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModelGroupForEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.id = data["id"];
        }
    };
    ModelGroupForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModelGroupForEditDto();
        result.init(data);
        return result;
    };
    ModelGroupForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data;
    };
    return ModelGroupForEditDto;
}());
export { ModelGroupForEditDto };
var CreateOrUpdateModelGroupDto = /** @class */ (function () {
    function CreateOrUpdateModelGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateModelGroupDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateModelGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateModelGroupDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateModelGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateModelGroupDto;
}());
export { CreateOrUpdateModelGroupDto };
var UpdateModelGroupOrderDto = /** @class */ (function () {
    function UpdateModelGroupOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateModelGroupOrderDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.beforeId = data["beforeId"];
            this.afterId = data["afterId"];
            this.id = data["id"];
        }
    };
    UpdateModelGroupOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateModelGroupOrderDto();
        result.init(data);
        return result;
    };
    UpdateModelGroupOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["beforeId"] = this.beforeId;
        data["afterId"] = this.afterId;
        data["id"] = this.id;
        return data;
    };
    return UpdateModelGroupOrderDto;
}());
export { UpdateModelGroupOrderDto };
/** 检查模板名是否存在 */
var CheckRepeatNameDto = /** @class */ (function () {
    function CheckRepeatNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckRepeatNameDto.prototype.init = function (data) {
        if (data) {
            this.modelName = data["modelName"];
        }
    };
    CheckRepeatNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckRepeatNameDto();
        result.init(data);
        return result;
    };
    CheckRepeatNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName;
        return data;
    };
    return CheckRepeatNameDto;
}());
export { CheckRepeatNameDto };
var ImportModelDto = /** @class */ (function () {
    function ImportModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportModelDto.prototype.init = function (data) {
        if (data) {
            this.shareCode = data["shareCode"];
            this.modelName = data["modelName"];
            this.modelGroupId = data["modelGroupId"];
        }
    };
    ImportModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportModelDto();
        result.init(data);
        return result;
    };
    ImportModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shareCode"] = this.shareCode;
        data["modelName"] = this.modelName;
        data["modelGroupId"] = this.modelGroupId;
        return data;
    };
    return ImportModelDto;
}());
export { ImportModelDto };
var CreateShareCodeDto = /** @class */ (function () {
    function CreateShareCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateShareCodeDto.prototype.init = function (data) {
        if (data) {
            this.modelId = data["modelId"];
            this.validity = data["validity"];
        }
    };
    CreateShareCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateShareCodeDto();
        result.init(data);
        return result;
    };
    CreateShareCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["validity"] = this.validity;
        return data;
    };
    return CreateShareCodeDto;
}());
export { CreateShareCodeDto };
var CheckShareCodeDto = /** @class */ (function () {
    function CheckShareCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckShareCodeDto.prototype.init = function (data) {
        if (data) {
            this.shareCode = data["shareCode"];
        }
    };
    CheckShareCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckShareCodeDto();
        result.init(data);
        return result;
    };
    CheckShareCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shareCode"] = this.shareCode;
        return data;
    };
    return CheckShareCodeDto;
}());
export { CheckShareCodeDto };
var GetNotificationsOutput = /** @class */ (function () {
    function GetNotificationsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNotificationsOutput.prototype.init = function (data) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserNotification.fromJS(item));
                }
            }
        }
    };
    GetNotificationsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNotificationsOutput();
        result.init(data);
        return result;
    };
    GetNotificationsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetNotificationsOutput;
}());
export { GetNotificationsOutput };
var UserNotification = /** @class */ (function () {
    function UserNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserNotification.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : undefined;
            this.id = data["id"];
        }
    };
    UserNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserNotification();
        result.init(data);
        return result;
    };
    UserNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return UserNotification;
}());
export { UserNotification };
var TenantNotification = /** @class */ (function () {
    function TenantNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantNotification.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            if (data["entityId"]) {
                this.entityId = {};
                for (var key in data["entityId"]) {
                    if (data["entityId"].hasOwnProperty(key))
                        this.entityId[key] = data["entityId"][key];
                }
            }
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    TenantNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantNotification();
        result.init(data);
        return result;
    };
    TenantNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        if (this.entityId) {
            data["entityId"] = {};
            for (var key in this.entityId) {
                if (this.entityId.hasOwnProperty(key))
                    data["entityId"][key] = this.entityId[key];
            }
        }
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return TenantNotification;
}());
export { TenantNotification };
var NotificationData = /** @class */ (function () {
    function NotificationData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationData.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (var key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    };
    NotificationData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationData();
        result.init(data);
        return result;
    };
    NotificationData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (var key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data;
    };
    return NotificationData;
}());
export { NotificationData };
var GetNotificationSettingsOutput = /** @class */ (function () {
    function GetNotificationSettingsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNotificationSettingsOutput.prototype.init = function (data) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            this.enableAlarmSound = data["enableAlarmSound"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (var _i = 0, _a = data["notifications"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
                }
            }
        }
    };
    GetNotificationSettingsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    };
    GetNotificationSettingsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        data["enableAlarmSound"] = this.enableAlarmSound;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (var _i = 0, _a = this.notifications; _i < _a.length; _i++) {
                var item = _a[_i];
                data["notifications"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetNotificationSettingsOutput;
}());
export { GetNotificationSettingsOutput };
var NotificationSubscriptionWithDisplayNameDto = /** @class */ (function () {
    function NotificationSubscriptionWithDisplayNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationSubscriptionWithDisplayNameDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    };
    NotificationSubscriptionWithDisplayNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    };
    NotificationSubscriptionWithDisplayNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    };
    return NotificationSubscriptionWithDisplayNameDto;
}());
export { NotificationSubscriptionWithDisplayNameDto };
var AlarmSoundConfigDto = /** @class */ (function () {
    function AlarmSoundConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AlarmSoundConfigDto.prototype.init = function (data) {
        if (data) {
            this.isAlarmSoundOpen = data["isAlarmSoundOpen"];
            this.isAlarmSoundEnabled = data["isAlarmSoundEnabled"];
        }
    };
    AlarmSoundConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AlarmSoundConfigDto();
        result.init(data);
        return result;
    };
    AlarmSoundConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isAlarmSoundOpen"] = this.isAlarmSoundOpen;
        data["isAlarmSoundEnabled"] = this.isAlarmSoundEnabled;
        return data;
    };
    return AlarmSoundConfigDto;
}());
export { AlarmSoundConfigDto };
var UpdateNotificationSettingsInput = /** @class */ (function () {
    function UpdateNotificationSettingsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateNotificationSettingsInput.prototype.init = function (data) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            this.enableAlarmSound = data["enableAlarmSound"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (var _i = 0, _a = data["notifications"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
                }
            }
        }
    };
    UpdateNotificationSettingsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    };
    UpdateNotificationSettingsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        data["enableAlarmSound"] = this.enableAlarmSound;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (var _i = 0, _a = this.notifications; _i < _a.length; _i++) {
                var item = _a[_i];
                data["notifications"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateNotificationSettingsInput;
}());
export { UpdateNotificationSettingsInput };
var NotificationSubscriptionDto = /** @class */ (function () {
    function NotificationSubscriptionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationSubscriptionDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    };
    NotificationSubscriptionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    };
    NotificationSubscriptionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    };
    return NotificationSubscriptionDto;
}());
export { NotificationSubscriptionDto };
var ExportAlarmNotificationsDto = /** @class */ (function () {
    function ExportAlarmNotificationsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportAlarmNotificationsDto.prototype.init = function (data) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
            this.tenantId = data["tenantId"];
            this.exportAll = data["exportAll"];
        }
    };
    ExportAlarmNotificationsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportAlarmNotificationsDto();
        result.init(data);
        return result;
    };
    ExportAlarmNotificationsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["tenantId"] = this.tenantId;
        data["exportAll"] = this.exportAll;
        return data;
    };
    return ExportAlarmNotificationsDto;
}());
export { ExportAlarmNotificationsDto };
var ListResultDtoOfDeviceListForMapDto = /** @class */ (function () {
    function ListResultDtoOfDeviceListForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeviceListForMapDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceListForMapDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeviceListForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeviceListForMapDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeviceListForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeviceListForMapDto;
}());
export { ListResultDtoOfDeviceListForMapDto };
var DeviceListForMapDto = /** @class */ (function () {
    function DeviceListForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceListForMapDto.prototype.init = function (data) {
        if (data) {
            this.deviceInfoForMapDto = data["deviceInfoForMapDto"] ? DeviceInfoForMapDto.fromJS(data["deviceInfoForMapDto"]) : undefined;
            this.deviceThumbnailDto = data["deviceThumbnailDto"] ? DeviceThumbnailDto.fromJS(data["deviceThumbnailDto"]) : undefined;
        }
    };
    DeviceListForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceListForMapDto();
        result.init(data);
        return result;
    };
    DeviceListForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceInfoForMapDto"] = this.deviceInfoForMapDto ? this.deviceInfoForMapDto.toJSON() : undefined;
        data["deviceThumbnailDto"] = this.deviceThumbnailDto ? this.deviceThumbnailDto.toJSON() : undefined;
        return data;
    };
    return DeviceListForMapDto;
}());
export { DeviceListForMapDto };
var DeviceInfoForMapDto = /** @class */ (function () {
    function DeviceInfoForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceInfoForMapDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.serialNumber = data["serialNumber"];
            this.deviceModel = data["deviceModel"] ? DeviceModelListDto.fromJS(data["deviceModel"]) : undefined;
            this.orderNumber = data["orderNumber"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.address = data["address"];
            this.companyName = data["companyName"];
            this.isGaode = data["isGaode"];
            this.virtualDeviceState = data["virtualDeviceState"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.devicePattern = data["devicePattern"];
            this.groupName = data["groupName"];
            this.id = data["id"];
        }
    };
    DeviceInfoForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceInfoForMapDto();
        result.init(data);
        return result;
    };
    DeviceInfoForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        data["orderNumber"] = this.orderNumber;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["address"] = this.address;
        data["companyName"] = this.companyName;
        data["isGaode"] = this.isGaode;
        data["virtualDeviceState"] = this.virtualDeviceState;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["devicePattern"] = this.devicePattern;
        data["groupName"] = this.groupName;
        data["id"] = this.id;
        return data;
    };
    return DeviceInfoForMapDto;
}());
export { DeviceInfoForMapDto };
var DeviceThumbnailDto = /** @class */ (function () {
    function DeviceThumbnailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceThumbnailDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.name = data["name"];
            this.serialNumber = data["serialNumber"];
            this.deviceModelName = data["deviceModelName"];
            this.companyName = data["companyName"];
            this.releasedConfigure = data["releasedConfigure"] ? ReleasedConfigureVersionDto.fromJS(data["releasedConfigure"]) : undefined;
            if (data["variables"] && data["variables"].constructor === Array) {
                this.variables = [];
                for (var _i = 0, _a = data["variables"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.variables.push(ReleasedVariableNameMappingListDto.fromJS(item));
                }
            }
            if (data["configurePermissions"] && data["configurePermissions"].constructor === Array) {
                this.configurePermissions = [];
                for (var _b = 0, _c = data["configurePermissions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.configurePermissions.push(item);
                }
            }
            this.virtualDeviceId = data["virtualDeviceId"];
            this.virtualDeviceState = data["virtualDeviceState"];
            this.id = data["id"];
        }
    };
    DeviceThumbnailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceThumbnailDto();
        result.init(data);
        return result;
    };
    DeviceThumbnailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["deviceModelName"] = this.deviceModelName;
        data["companyName"] = this.companyName;
        data["releasedConfigure"] = this.releasedConfigure ? this.releasedConfigure.toJSON() : undefined;
        if (this.variables && this.variables.constructor === Array) {
            data["variables"] = [];
            for (var _i = 0, _a = this.variables; _i < _a.length; _i++) {
                var item = _a[_i];
                data["variables"].push(item.toJSON());
            }
        }
        if (this.configurePermissions && this.configurePermissions.constructor === Array) {
            data["configurePermissions"] = [];
            for (var _b = 0, _c = this.configurePermissions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["configurePermissions"].push(item);
            }
        }
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["virtualDeviceState"] = this.virtualDeviceState;
        data["id"] = this.id;
        return data;
    };
    return DeviceThumbnailDto;
}());
export { DeviceThumbnailDto };
var ReleasedConfigureVersionDto = /** @class */ (function () {
    function ReleasedConfigureVersionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedConfigureVersionDto.prototype.init = function (data) {
        if (data) {
            this.version = data["version"];
            this.releasedConfigureId = data["releasedConfigureId"];
            this.configureId = data["configureId"];
        }
    };
    ReleasedConfigureVersionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedConfigureVersionDto();
        result.init(data);
        return result;
    };
    ReleasedConfigureVersionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releasedConfigureId"] = this.releasedConfigureId;
        data["configureId"] = this.configureId;
        return data;
    };
    return ReleasedConfigureVersionDto;
}());
export { ReleasedConfigureVersionDto };
var ReleasedVariableNameMappingListDto = /** @class */ (function () {
    function ReleasedVariableNameMappingListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedVariableNameMappingListDto.prototype.init = function (data) {
        if (data) {
            this.variableName = data["variableName"];
            this.fBoxVariableName = data["fBoxVariableName"];
            this.fBoxGroupName = data["fBoxGroupName"];
            this.dataSourceCode = data["dataSourceCode"];
        }
    };
    ReleasedVariableNameMappingListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedVariableNameMappingListDto();
        result.init(data);
        return result;
    };
    ReleasedVariableNameMappingListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["variableName"] = this.variableName;
        data["fBoxVariableName"] = this.fBoxVariableName;
        data["fBoxGroupName"] = this.fBoxGroupName;
        data["dataSourceCode"] = this.dataSourceCode;
        return data;
    };
    return ReleasedVariableNameMappingListDto;
}());
export { ReleasedVariableNameMappingListDto };
var ListResultDtoOfDeviceLocationInfoForMapDto = /** @class */ (function () {
    function ListResultDtoOfDeviceLocationInfoForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeviceLocationInfoForMapDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceLocationInfoForMapDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeviceLocationInfoForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeviceLocationInfoForMapDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeviceLocationInfoForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeviceLocationInfoForMapDto;
}());
export { ListResultDtoOfDeviceLocationInfoForMapDto };
var DeviceLocationInfoForMapDto = /** @class */ (function () {
    function DeviceLocationInfoForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceLocationInfoForMapDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.address = data["address"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    };
    DeviceLocationInfoForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceLocationInfoForMapDto();
        result.init(data);
        return result;
    };
    DeviceLocationInfoForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["address"] = this.address;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    };
    return DeviceLocationInfoForMapDto;
}());
export { DeviceLocationInfoForMapDto };
var ListResultDtoOfUserLocationsForMapDto = /** @class */ (function () {
    function ListResultDtoOfUserLocationsForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfUserLocationsForMapDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserLocationsForMapDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfUserLocationsForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfUserLocationsForMapDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfUserLocationsForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfUserLocationsForMapDto;
}());
export { ListResultDtoOfUserLocationsForMapDto };
var UserLocationsForMapDto = /** @class */ (function () {
    function UserLocationsForMapDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLocationsForMapDto.prototype.init = function (data) {
        if (data) {
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.status = data["status"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    UserLocationsForMapDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLocationsForMapDto();
        result.init(data);
        return result;
    };
    UserLocationsForMapDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return UserLocationsForMapDto;
}());
export { UserLocationsForMapDto };
var UserContactDto = /** @class */ (function () {
    function UserContactDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserContactDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    UserContactDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserContactDto();
        result.init(data);
        return result;
    };
    UserContactDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return UserContactDto;
}());
export { UserContactDto };
var ListResultDtoOfReleasedVariableNameMappingListDto = /** @class */ (function () {
    function ListResultDtoOfReleasedVariableNameMappingListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfReleasedVariableNameMappingListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ReleasedVariableNameMappingListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfReleasedVariableNameMappingListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfReleasedVariableNameMappingListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfReleasedVariableNameMappingListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfReleasedVariableNameMappingListDto;
}());
export { ListResultDtoOfReleasedVariableNameMappingListDto };
var UpdateMapColorDto = /** @class */ (function () {
    function UpdateMapColorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateMapColorDto.prototype.init = function (data) {
        if (data) {
            this.color = data["color"];
            this.hasBorder = data["hasBorder"];
        }
    };
    UpdateMapColorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateMapColorDto();
        result.init(data);
        return result;
    };
    UpdateMapColorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["hasBorder"] = this.hasBorder;
        return data;
    };
    return UpdateMapColorDto;
}());
export { UpdateMapColorDto };
var UserMapAndThemeInfoDto = /** @class */ (function () {
    function UserMapAndThemeInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserMapAndThemeInfoDto.prototype.init = function (data) {
        if (data) {
            this.updateUserMapInfo = data["updateUserMapInfo"] ? UpdateUserMapInfoDto.fromJS(data["updateUserMapInfo"]) : undefined;
            this.mapTheme = data["mapTheme"] ? MapThemeDto.fromJS(data["mapTheme"]) : undefined;
            this.isPointAggregation = data["isPointAggregation"];
        }
    };
    UserMapAndThemeInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserMapAndThemeInfoDto();
        result.init(data);
        return result;
    };
    UserMapAndThemeInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["updateUserMapInfo"] = this.updateUserMapInfo ? this.updateUserMapInfo.toJSON() : undefined;
        data["mapTheme"] = this.mapTheme ? this.mapTheme.toJSON() : undefined;
        data["isPointAggregation"] = this.isPointAggregation;
        return data;
    };
    return UserMapAndThemeInfoDto;
}());
export { UserMapAndThemeInfoDto };
var MapThemeDto = /** @class */ (function () {
    function MapThemeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MapThemeDto.prototype.init = function (data) {
        if (data) {
            this.color = data["color"];
            this.hasBorder = data["hasBorder"];
        }
    };
    MapThemeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MapThemeDto();
        result.init(data);
        return result;
    };
    MapThemeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["hasBorder"] = this.hasBorder;
        return data;
    };
    return MapThemeDto;
}());
export { MapThemeDto };
var ThumbnailConfigDto = /** @class */ (function () {
    function ThumbnailConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThumbnailConfigDto.prototype.init = function (data) {
        if (data) {
            this.isMapDisplayThumbnail = data["isMapDisplayThumbnail"];
        }
    };
    ThumbnailConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThumbnailConfigDto();
        result.init(data);
        return result;
    };
    ThumbnailConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isMapDisplayThumbnail"] = this.isMapDisplayThumbnail;
        return data;
    };
    return ThumbnailConfigDto;
}());
export { ThumbnailConfigDto };
/** 运营仪表盘 */
var UserListForDashboardDto = /** @class */ (function () {
    function UserListForDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListForDashboardDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.name = data["name"];
        }
    };
    UserListForDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListForDashboardDto();
        result.init(data);
        return result;
    };
    UserListForDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        return data;
    };
    return UserListForDashboardDto;
}());
export { UserListForDashboardDto };
var UserListForOrganizationDto = /** @class */ (function () {
    function UserListForOrganizationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListForOrganizationDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    UserListForOrganizationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListForOrganizationDto();
        result.init(data);
        return result;
    };
    UserListForOrganizationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return UserListForOrganizationDto;
}());
export { UserListForOrganizationDto };
var OrganizationDeviceQueryOptionDto = /** @class */ (function () {
    function OrganizationDeviceQueryOptionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationDeviceQueryOptionDto.prototype.init = function (data) {
        if (data) {
            if (data["devicePatterns"] && data["devicePatterns"].constructor === Array) {
                this.devicePatterns = [];
                for (var _i = 0, _a = data["devicePatterns"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.devicePatterns.push(item);
                }
            }
            if (data["deviceModelOptions"] && data["deviceModelOptions"].constructor === Array) {
                this.deviceModelOptions = [];
                for (var _b = 0, _c = data["deviceModelOptions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.deviceModelOptions.push(OrganizationDeviceModelOptionDto.fromJS(item));
                }
            }
        }
    };
    OrganizationDeviceQueryOptionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationDeviceQueryOptionDto();
        result.init(data);
        return result;
    };
    OrganizationDeviceQueryOptionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.devicePatterns && this.devicePatterns.constructor === Array) {
            data["devicePatterns"] = [];
            for (var _i = 0, _a = this.devicePatterns; _i < _a.length; _i++) {
                var item = _a[_i];
                data["devicePatterns"].push(item);
            }
        }
        if (this.deviceModelOptions && this.deviceModelOptions.constructor === Array) {
            data["deviceModelOptions"] = [];
            for (var _b = 0, _c = this.deviceModelOptions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["deviceModelOptions"].push(item.toJSON());
            }
        }
        return data;
    };
    return OrganizationDeviceQueryOptionDto;
}());
export { OrganizationDeviceQueryOptionDto };
var OrganizationDeviceModelOptionDto = /** @class */ (function () {
    function OrganizationDeviceModelOptionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationDeviceModelOptionDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    OrganizationDeviceModelOptionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationDeviceModelOptionDto();
        result.init(data);
        return result;
    };
    OrganizationDeviceModelOptionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return OrganizationDeviceModelOptionDto;
}());
export { OrganizationDeviceModelOptionDto };
var PagedResultDtoOfOrganizationDeviceDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationDeviceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationDeviceDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationDeviceDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfOrganizationDeviceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationDeviceDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationDeviceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationDeviceDto;
}());
export { PagedResultDtoOfOrganizationDeviceDto };
var OrganizationDeviceDto = /** @class */ (function () {
    function OrganizationDeviceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationDeviceDto.prototype.init = function (data) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.permissionCategory = data["permissionCategory"];
            if (data["configurePermissions"] && data["configurePermissions"].constructor === Array) {
                this.configurePermissions = [];
                for (var _i = 0, _a = data["configurePermissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.configurePermissions.push(OrganizationConfigurePermissionDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    OrganizationDeviceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationDeviceDto();
        result.init(data);
        return result;
    };
    OrganizationDeviceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["permissionCategory"] = this.permissionCategory;
        if (this.configurePermissions && this.configurePermissions.constructor === Array) {
            data["configurePermissions"] = [];
            for (var _i = 0, _a = this.configurePermissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["configurePermissions"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return OrganizationDeviceDto;
}());
export { OrganizationDeviceDto };
var OrganizationConfigurePermissionDto = /** @class */ (function () {
    function OrganizationConfigurePermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationConfigurePermissionDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
        }
    };
    OrganizationConfigurePermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationConfigurePermissionDto();
        result.init(data);
        return result;
    };
    OrganizationConfigurePermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    };
    return OrganizationConfigurePermissionDto;
}());
export { OrganizationConfigurePermissionDto };
var PagedResultDtoOfOrganizationDeviceModelDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationDeviceModelDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfOrganizationDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationDeviceModelDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationDeviceModelDto;
}());
export { PagedResultDtoOfOrganizationDeviceModelDto };
var OrganizationDeviceModelDto = /** @class */ (function () {
    function OrganizationDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.deviceModelName = data["deviceModelName"];
            this.industry = data["industry"];
            this.remark = data["remark"];
            this.configureId = data["configureId"];
            this.permissionCategory = data["permissionCategory"];
            this.id = data["id"];
        }
    };
    OrganizationDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationDeviceModelDto();
        result.init(data);
        return result;
    };
    OrganizationDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelName"] = this.deviceModelName;
        data["industry"] = this.industry;
        data["remark"] = this.remark;
        data["configureId"] = this.configureId;
        data["permissionCategory"] = this.permissionCategory;
        data["id"] = this.id;
        return data;
    };
    return OrganizationDeviceModelDto;
}());
export { OrganizationDeviceModelDto };
var PagedResultDtoOfOrganizationAssignDeviceDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationAssignDeviceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationAssignDeviceDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationAssignDeviceDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfOrganizationAssignDeviceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationAssignDeviceDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationAssignDeviceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationAssignDeviceDto;
}());
export { PagedResultDtoOfOrganizationAssignDeviceDto };
var OrganizationAssignDeviceDto = /** @class */ (function () {
    function OrganizationAssignDeviceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationAssignDeviceDto.prototype.init = function (data) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.serialNumber = data["serialNumber"];
            this.devicePattern = data["devicePattern"];
            this.deviceModelName = data["deviceModelName"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.permissionCategory = data["permissionCategory"];
            if (data["configurePermissions"] && data["configurePermissions"].constructor === Array) {
                this.configurePermissions = [];
                for (var _i = 0, _a = data["configurePermissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.configurePermissions.push(OrganizationConfigurePermissionDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    OrganizationAssignDeviceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationAssignDeviceDto();
        result.init(data);
        return result;
    };
    OrganizationAssignDeviceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["serialNumber"] = this.serialNumber;
        data["devicePattern"] = this.devicePattern;
        data["deviceModelName"] = this.deviceModelName;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["permissionCategory"] = this.permissionCategory;
        if (this.configurePermissions && this.configurePermissions.constructor === Array) {
            data["configurePermissions"] = [];
            for (var _i = 0, _a = this.configurePermissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["configurePermissions"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return OrganizationAssignDeviceDto;
}());
export { OrganizationAssignDeviceDto };
var PagedResultDtoOfOrganizationAssignDeviceModelDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationAssignDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationAssignDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationAssignDeviceModelDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfOrganizationAssignDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationAssignDeviceModelDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationAssignDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationAssignDeviceModelDto;
}());
export { PagedResultDtoOfOrganizationAssignDeviceModelDto };
var OrganizationAssignDeviceModelDto = /** @class */ (function () {
    function OrganizationAssignDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationAssignDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.deviceModelName = data["deviceModelName"];
            this.industry = data["industry"];
            this.remark = data["remark"];
            this.permissionCategory = data["permissionCategory"];
            this.id = data["id"];
        }
    };
    OrganizationAssignDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationAssignDeviceModelDto();
        result.init(data);
        return result;
    };
    OrganizationAssignDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelName"] = this.deviceModelName;
        data["industry"] = this.industry;
        data["remark"] = this.remark;
        data["permissionCategory"] = this.permissionCategory;
        data["id"] = this.id;
        return data;
    };
    return OrganizationAssignDeviceModelDto;
}());
export { OrganizationAssignDeviceModelDto };
var BatchAssignDevicePermissionDto = /** @class */ (function () {
    function BatchAssignDevicePermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchAssignDevicePermissionDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (data["devicePermissions"] && data["devicePermissions"].constructor === Array) {
                this.devicePermissions = [];
                for (var _i = 0, _a = data["devicePermissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.devicePermissions.push(OrganizationDevicePermissionDto.fromJS(item));
                }
            }
        }
    };
    BatchAssignDevicePermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchAssignDevicePermissionDto();
        result.init(data);
        return result;
    };
    BatchAssignDevicePermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.devicePermissions && this.devicePermissions.constructor === Array) {
            data["devicePermissions"] = [];
            for (var _i = 0, _a = this.devicePermissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["devicePermissions"].push(item.toJSON());
            }
        }
        return data;
    };
    return BatchAssignDevicePermissionDto;
}());
export { BatchAssignDevicePermissionDto };
var OrganizationDevicePermissionDto = /** @class */ (function () {
    function OrganizationDevicePermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationDevicePermissionDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.permissionCategory = data["permissionCategory"];
            if (data["codes"] && data["codes"].constructor === Array) {
                this.codes = [];
                for (var _i = 0, _a = data["codes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.codes.push(item);
                }
            }
            this.virtualDeviceId = data["virtualDeviceId"];
        }
    };
    OrganizationDevicePermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationDevicePermissionDto();
        result.init(data);
        return result;
    };
    OrganizationDevicePermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["permissionCategory"] = this.permissionCategory;
        if (this.codes && this.codes.constructor === Array) {
            data["codes"] = [];
            for (var _i = 0, _a = this.codes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["codes"].push(item);
            }
        }
        data["virtualDeviceId"] = this.virtualDeviceId;
        return data;
    };
    return OrganizationDevicePermissionDto;
}());
export { OrganizationDevicePermissionDto };
var BatchAssignDeviceModelPermissionDto = /** @class */ (function () {
    function BatchAssignDeviceModelPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchAssignDeviceModelPermissionDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (data["deviceModelPermissions"] && data["deviceModelPermissions"].constructor === Array) {
                this.deviceModelPermissions = [];
                for (var _i = 0, _a = data["deviceModelPermissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.deviceModelPermissions.push(OrganizationDeviceModelPermissionDto.fromJS(item));
                }
            }
        }
    };
    BatchAssignDeviceModelPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchAssignDeviceModelPermissionDto();
        result.init(data);
        return result;
    };
    BatchAssignDeviceModelPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.deviceModelPermissions && this.deviceModelPermissions.constructor === Array) {
            data["deviceModelPermissions"] = [];
            for (var _i = 0, _a = this.deviceModelPermissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["deviceModelPermissions"].push(item.toJSON());
            }
        }
        return data;
    };
    return BatchAssignDeviceModelPermissionDto;
}());
export { BatchAssignDeviceModelPermissionDto };
var OrganizationDeviceModelPermissionDto = /** @class */ (function () {
    function OrganizationDeviceModelPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationDeviceModelPermissionDto.prototype.init = function (data) {
        if (data) {
            this.deviceModelId = data["deviceModelId"];
            this.permissionCategory = data["permissionCategory"];
        }
    };
    OrganizationDeviceModelPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationDeviceModelPermissionDto();
        result.init(data);
        return result;
    };
    OrganizationDeviceModelPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelId"] = this.deviceModelId;
        data["permissionCategory"] = this.permissionCategory;
        return data;
    };
    return OrganizationDeviceModelPermissionDto;
}());
export { OrganizationDeviceModelPermissionDto };
var EditDeviceDataPermissionDto = /** @class */ (function () {
    function EditDeviceDataPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditDeviceDataPermissionDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.deviceId = data["deviceId"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.permissionCategory = data["permissionCategory"];
            if (data["codes"] && data["codes"].constructor === Array) {
                this.codes = [];
                for (var _i = 0, _a = data["codes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.codes.push(item);
                }
            }
        }
    };
    EditDeviceDataPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditDeviceDataPermissionDto();
        result.init(data);
        return result;
    };
    EditDeviceDataPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceId"] = this.deviceId;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["permissionCategory"] = this.permissionCategory;
        if (this.codes && this.codes.constructor === Array) {
            data["codes"] = [];
            for (var _i = 0, _a = this.codes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["codes"].push(item);
            }
        }
        return data;
    };
    return EditDeviceDataPermissionDto;
}());
export { EditDeviceDataPermissionDto };
var EditModelDataPermissionDto = /** @class */ (function () {
    function EditModelDataPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditModelDataPermissionDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.deviceModelId = data["deviceModelId"];
            this.permissionCategory = data["permissionCategory"];
        }
    };
    EditModelDataPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditModelDataPermissionDto();
        result.init(data);
        return result;
    };
    EditModelDataPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceModelId"] = this.deviceModelId;
        data["permissionCategory"] = this.permissionCategory;
        return data;
    };
    return EditModelDataPermissionDto;
}());
export { EditModelDataPermissionDto };
var RemoveDataPermissionDto = /** @class */ (function () {
    function RemoveDataPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RemoveDataPermissionDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (data["dataIds"] && data["dataIds"].constructor === Array) {
                this.dataIds = [];
                for (var _i = 0, _a = data["dataIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.dataIds.push(item);
                }
            }
        }
    };
    RemoveDataPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RemoveDataPermissionDto();
        result.init(data);
        return result;
    };
    RemoveDataPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.dataIds && this.dataIds.constructor === Array) {
            data["dataIds"] = [];
            for (var _i = 0, _a = this.dataIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["dataIds"].push(item);
            }
        }
        return data;
    };
    return RemoveDataPermissionDto;
}());
export { RemoveDataPermissionDto };
var ListResultDtoOfOrganizationUnitDto = /** @class */ (function () {
    function ListResultDtoOfOrganizationUnitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfOrganizationUnitDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationUnitDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfOrganizationUnitDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfOrganizationUnitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfOrganizationUnitDto;
}());
export { ListResultDtoOfOrganizationUnitDto };
var OrganizationUnitDto = /** @class */ (function () {
    function OrganizationUnitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationUnitDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    OrganizationUnitDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationUnitDto();
        result.init(data);
        return result;
    };
    OrganizationUnitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return OrganizationUnitDto;
}());
export { OrganizationUnitDto };
var ListResultDtoOfOrganizationUserListDto = /** @class */ (function () {
    function ListResultDtoOfOrganizationUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfOrganizationUserListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationUserListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfOrganizationUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfOrganizationUserListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfOrganizationUserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfOrganizationUserListDto;
}());
export { ListResultDtoOfOrganizationUserListDto };
var OrganizationUserListDto = /** @class */ (function () {
    function OrganizationUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationUserListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.organizationId = data["organizationId"];
        }
    };
    OrganizationUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationUserListDto();
        result.init(data);
        return result;
    };
    OrganizationUserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["organizationId"] = this.organizationId;
        return data;
    };
    return OrganizationUserListDto;
}());
export { OrganizationUserListDto };
var UserInfoListDto = /** @class */ (function () {
    function UserInfoListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserInfoListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
        }
    };
    UserInfoListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserInfoListDto();
        result.init(data);
        return result;
    };
    UserInfoListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    };
    return UserInfoListDto;
}());
export { UserInfoListDto };
var PaymentInfoDto = /** @class */ (function () {
    function PaymentInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentInfoDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    };
    PaymentInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentInfoDto();
        result.init(data);
        return result;
    };
    PaymentInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    };
    return PaymentInfoDto;
}());
export { PaymentInfoDto };
var EditionSelectDto = /** @class */ (function () {
    function EditionSelectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionSelectDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : undefined;
        }
    };
    EditionSelectDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionSelectDto();
        result.init(data);
        return result;
    };
    EditionSelectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : undefined;
        return data;
    };
    return EditionSelectDto;
}());
export { EditionSelectDto };
var CreatePaymentDto = /** @class */ (function () {
    function CreatePaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePaymentDto.prototype.init = function (data) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
        }
    };
    CreatePaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePaymentDto();
        result.init(data);
        return result;
    };
    CreatePaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        return data;
    };
    return CreatePaymentDto;
}());
export { CreatePaymentDto };
var ExecutePaymentDto = /** @class */ (function () {
    function ExecutePaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExecutePaymentDto.prototype.init = function (data) {
        if (data) {
            this.gateway = data["gateway"];
            this.editionPaymentType = data["editionPaymentType"];
            this.editionId = data["editionId"];
            this.paymentPeriodType = data["paymentPeriodType"];
            if (data["additionalData"]) {
                this.additionalData = {};
                for (var key in data["additionalData"]) {
                    if (data["additionalData"].hasOwnProperty(key))
                        this.additionalData[key] = data["additionalData"][key];
                }
            }
        }
    };
    ExecutePaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExecutePaymentDto();
        result.init(data);
        return result;
    };
    ExecutePaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["editionPaymentType"] = this.editionPaymentType;
        data["editionId"] = this.editionId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (var key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    data["additionalData"][key] = this.additionalData[key];
            }
        }
        return data;
    };
    return ExecutePaymentDto;
}());
export { ExecutePaymentDto };
var PagedResultDtoOfSubscriptionPaymentListDto = /** @class */ (function () {
    function PagedResultDtoOfSubscriptionPaymentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfSubscriptionPaymentListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(SubscriptionPaymentListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfSubscriptionPaymentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfSubscriptionPaymentListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfSubscriptionPaymentListDto;
}());
export { PagedResultDtoOfSubscriptionPaymentListDto };
var SubscriptionPaymentListDto = /** @class */ (function () {
    function SubscriptionPaymentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscriptionPaymentListDto.prototype.init = function (data) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    SubscriptionPaymentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    };
    SubscriptionPaymentListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return SubscriptionPaymentListDto;
}());
export { SubscriptionPaymentListDto };
var ListResultDtoOfFlatPermissionWithLevelDto = /** @class */ (function () {
    function ListResultDtoOfFlatPermissionWithLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfFlatPermissionWithLevelDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfFlatPermissionWithLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfFlatPermissionWithLevelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfFlatPermissionWithLevelDto;
}());
export { ListResultDtoOfFlatPermissionWithLevelDto };
var FlatPermissionWithLevelDto = /** @class */ (function () {
    function FlatPermissionWithLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatPermissionWithLevelDto.prototype.init = function (data) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"] ? PermissionDescription.fromJS(data["description"]) : undefined;
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    };
    FlatPermissionWithLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    };
    FlatPermissionWithLevelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    };
    return FlatPermissionWithLevelDto;
}());
export { FlatPermissionWithLevelDto };
var PermissionDescription = /** @class */ (function () {
    function PermissionDescription(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PermissionDescription.prototype.init = function (data) {
        if (data) {
            this.permissionType = data["permissionType"];
            this.canFold = data["canFold"];
            this.isWithParentShow = data["isWithParentShow"];
        }
    };
    PermissionDescription.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PermissionDescription();
        result.init(data);
        return result;
    };
    PermissionDescription.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["permissionType"] = this.permissionType;
        data["canFold"] = this.canFold;
        data["isWithParentShow"] = this.isWithParentShow;
        return data;
    };
    return PermissionDescription;
}());
export { PermissionDescription };
var CurrentUserProfileEditDto = /** @class */ (function () {
    function CurrentUserProfileEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrentUserProfileEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
            this.wxPushEnabled = data["wxPushEnabled"];
            this.isFollowed = data["isFollowed"];
        }
    };
    CurrentUserProfileEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    };
    CurrentUserProfileEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        data["wxPushEnabled"] = this.wxPushEnabled;
        data["isFollowed"] = this.isFollowed;
        return data;
    };
    return CurrentUserProfileEditDto;
}());
export { CurrentUserProfileEditDto };
var UpdateGoogleAuthenticatorKeyOutput = /** @class */ (function () {
    function UpdateGoogleAuthenticatorKeyOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateGoogleAuthenticatorKeyOutput.prototype.init = function (data) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    };
    UpdateGoogleAuthenticatorKeyOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    };
    UpdateGoogleAuthenticatorKeyOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    };
    return UpdateGoogleAuthenticatorKeyOutput;
}());
export { UpdateGoogleAuthenticatorKeyOutput };
var SendVerificationSmsDto = /** @class */ (function () {
    function SendVerificationSmsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendVerificationSmsDto.prototype.init = function (data) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
        }
    };
    SendVerificationSmsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendVerificationSmsDto();
        result.init(data);
        return result;
    };
    SendVerificationSmsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return SendVerificationSmsDto;
}());
export { SendVerificationSmsDto };
var VerifySmsCodeDto = /** @class */ (function () {
    function VerifySmsCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifySmsCodeDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    VerifySmsCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifySmsCodeDto();
        result.init(data);
        return result;
    };
    VerifySmsCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return VerifySmsCodeDto;
}());
export { VerifySmsCodeDto };
var SendVerificationEmailDto = /** @class */ (function () {
    function SendVerificationEmailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendVerificationEmailDto.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendVerificationEmailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendVerificationEmailDto();
        result.init(data);
        return result;
    };
    SendVerificationEmailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendVerificationEmailDto;
}());
export { SendVerificationEmailDto };
var VerifyEmailCodeDto = /** @class */ (function () {
    function VerifyEmailCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifyEmailCodeDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.emailAddress = data["emailAddress"];
        }
    };
    VerifyEmailCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifyEmailCodeDto();
        result.init(data);
        return result;
    };
    VerifyEmailCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return VerifyEmailCodeDto;
}());
export { VerifyEmailCodeDto };
var ChangePasswordInput = /** @class */ (function () {
    function ChangePasswordInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePasswordInput.prototype.init = function (data) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    };
    ChangePasswordInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangePasswordInput();
        result.init(data);
        return result;
    };
    ChangePasswordInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    };
    return ChangePasswordInput;
}());
export { ChangePasswordInput };
var JwtAccessToken = /** @class */ (function () {
    function JwtAccessToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    JwtAccessToken.prototype.init = function (data) {
        if (data) {
            this.token = data["token"];
            this.encryptedToken = data["encryptedToken"];
            this.expireSeconds = data["expireSeconds"];
        }
    };
    JwtAccessToken.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new JwtAccessToken();
        result.init(data);
        return result;
    };
    JwtAccessToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["encryptedToken"] = this.encryptedToken;
        data["expireSeconds"] = this.expireSeconds;
        return data;
    };
    return JwtAccessToken;
}());
export { JwtAccessToken };
var UpdateProfilePictureInput = /** @class */ (function () {
    function UpdateProfilePictureInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateProfilePictureInput.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    };
    UpdateProfilePictureInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    };
    UpdateProfilePictureInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    };
    return UpdateProfilePictureInput;
}());
export { UpdateProfilePictureInput };
var GetPasswordComplexitySettingOutput = /** @class */ (function () {
    function GetPasswordComplexitySettingOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPasswordComplexitySettingOutput.prototype.init = function (data) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : undefined;
        }
    };
    GetPasswordComplexitySettingOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    };
    GetPasswordComplexitySettingOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : undefined;
        return data;
    };
    return GetPasswordComplexitySettingOutput;
}());
export { GetPasswordComplexitySettingOutput };
var GetProfilePictureOutput = /** @class */ (function () {
    function GetProfilePictureOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetProfilePictureOutput.prototype.init = function (data) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    };
    GetProfilePictureOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    };
    GetProfilePictureOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    };
    return GetProfilePictureOutput;
}());
export { GetProfilePictureOutput };
var ChangeUserLanguageDto = /** @class */ (function () {
    function ChangeUserLanguageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeUserLanguageDto.prototype.init = function (data) {
        if (data) {
            this.languageName = data["languageName"];
        }
    };
    ChangeUserLanguageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    };
    ChangeUserLanguageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    };
    return ChangeUserLanguageDto;
}());
export { ChangeUserLanguageDto };
var Region = /** @class */ (function () {
    function Region(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Region.prototype.init = function (data) {
        if (data) {
            this.regionId = data["regionId"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.shortName = data["shortName"];
            this.levelType = data["levelType"];
            this.cityCode = data["cityCode"];
            this.zipCode = data["zipCode"];
            this.mergerName = data["mergerName"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.pinyin = data["pinyin"];
            this.previousRegionId = data["previousRegionId"];
            this.id = data["id"];
        }
    };
    Region.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Region();
        result.init(data);
        return result;
    };
    Region.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["shortName"] = this.shortName;
        data["levelType"] = this.levelType;
        data["cityCode"] = this.cityCode;
        data["zipCode"] = this.zipCode;
        data["mergerName"] = this.mergerName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["pinyin"] = this.pinyin;
        data["previousRegionId"] = this.previousRegionId;
        data["id"] = this.id;
        return data;
    };
    return Region;
}());
export { Region };
var RegionCode = /** @class */ (function () {
    function RegionCode(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegionCode.prototype.init = function (data) {
        if (data) {
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
        }
    };
    RegionCode.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegionCode();
        result.init(data);
        return result;
    };
    RegionCode.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        return data;
    };
    return RegionCode;
}());
export { RegionCode };
var ReleasedConfigureInfoDto = /** @class */ (function () {
    function ReleasedConfigureInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedConfigureInfoDto.prototype.init = function (data) {
        if (data) {
            this.releasedConfigure = data["releasedConfigure"] ? ReleasedConfigureVersionDto.fromJS(data["releasedConfigure"]) : undefined;
            if (data["variables"] && data["variables"].constructor === Array) {
                this.variables = [];
                for (var _i = 0, _a = data["variables"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.variables.push(ReleasedVariableNameMappingListDto.fromJS(item));
                }
            }
            this.releasedConfigureErrorType = data["releasedConfigureErrorType"];
            if (data["configurePermissions"] && data["configurePermissions"].constructor === Array) {
                this.configurePermissions = [];
                for (var _b = 0, _c = data["configurePermissions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.configurePermissions.push(item);
                }
            }
        }
    };
    ReleasedConfigureInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedConfigureInfoDto();
        result.init(data);
        return result;
    };
    ReleasedConfigureInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["releasedConfigure"] = this.releasedConfigure ? this.releasedConfigure.toJSON() : undefined;
        if (this.variables && this.variables.constructor === Array) {
            data["variables"] = [];
            for (var _i = 0, _a = this.variables; _i < _a.length; _i++) {
                var item = _a[_i];
                data["variables"].push(item.toJSON());
            }
        }
        data["releasedConfigureErrorType"] = this.releasedConfigureErrorType;
        if (this.configurePermissions && this.configurePermissions.constructor === Array) {
            data["configurePermissions"] = [];
            for (var _b = 0, _c = this.configurePermissions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["configurePermissions"].push(item);
            }
        }
        return data;
    };
    return ReleasedConfigureInfoDto;
}());
export { ReleasedConfigureInfoDto };
var ReleasedConfigureDto = /** @class */ (function () {
    function ReleasedConfigureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedConfigureDto.prototype.init = function (data) {
        if (data) {
            this.viewIndex = data["viewIndex"];
            this.releasedConfigure = data["releasedConfigure"];
        }
    };
    ReleasedConfigureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedConfigureDto();
        result.init(data);
        return result;
    };
    ReleasedConfigureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["viewIndex"] = this.viewIndex;
        data["releasedConfigure"] = this.releasedConfigure;
        return data;
    };
    return ReleasedConfigureDto;
}());
export { ReleasedConfigureDto };
var ReleasedConfigureViewForDevice = /** @class */ (function () {
    function ReleasedConfigureViewForDevice(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedConfigureViewForDevice.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.configureViewId = data["configureViewId"];
            this.configureViewCode = data["configureViewCode"];
            this.name = data["name"];
            this.type = data["type"];
            this.typeStr = data["typeStr"];
            this.index = data["index"];
        }
    };
    ReleasedConfigureViewForDevice.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedConfigureViewForDevice();
        result.init(data);
        return result;
    };
    ReleasedConfigureViewForDevice.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["configureViewId"] = this.configureViewId;
        data["configureViewCode"] = this.configureViewCode;
        data["name"] = this.name;
        data["type"] = this.type;
        data["typeStr"] = this.typeStr;
        data["index"] = this.index;
        return data;
    };
    return ReleasedConfigureViewForDevice;
}());
export { ReleasedConfigureViewForDevice };
var DeviceNameAndConfigureViewNameDto = /** @class */ (function () {
    function DeviceNameAndConfigureViewNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceNameAndConfigureViewNameDto.prototype.init = function (data) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.configureViewName = data["configureViewName"];
        }
    };
    DeviceNameAndConfigureViewNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceNameAndConfigureViewNameDto();
        result.init(data);
        return result;
    };
    DeviceNameAndConfigureViewNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["configureViewName"] = this.configureViewName;
        return data;
    };
    return DeviceNameAndConfigureViewNameDto;
}());
export { DeviceNameAndConfigureViewNameDto };
var MainConfigureViewNameDto = /** @class */ (function () {
    function MainConfigureViewNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MainConfigureViewNameDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    MainConfigureViewNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MainConfigureViewNameDto();
        result.init(data);
        return result;
    };
    MainConfigureViewNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return MainConfigureViewNameDto;
}());
export { MainConfigureViewNameDto };
var ReleasedConfigureGraphStateDto = /** @class */ (function () {
    function ReleasedConfigureGraphStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedConfigureGraphStateDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.url = data["url"];
        }
    };
    ReleasedConfigureGraphStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedConfigureGraphStateDto();
        result.init(data);
        return result;
    };
    ReleasedConfigureGraphStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["url"] = this.url;
        return data;
    };
    return ReleasedConfigureGraphStateDto;
}());
export { ReleasedConfigureGraphStateDto };
var GetReleasedGraphStatesDto = /** @class */ (function () {
    function GetReleasedGraphStatesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetReleasedGraphStatesDto.prototype.init = function (data) {
        if (data) {
            this.releasedId = data["releasedId"];
            if (data["states"] && data["states"].constructor === Array) {
                this.states = [];
                for (var _i = 0, _a = data["states"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.states.push(GraphStateDto.fromJS(item));
                }
            }
        }
    };
    GetReleasedGraphStatesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetReleasedGraphStatesDto();
        result.init(data);
        return result;
    };
    GetReleasedGraphStatesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["releasedId"] = this.releasedId;
        if (this.states && this.states.constructor === Array) {
            data["states"] = [];
            for (var _i = 0, _a = this.states; _i < _a.length; _i++) {
                var item = _a[_i];
                data["states"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetReleasedGraphStatesDto;
}());
export { GetReleasedGraphStatesDto };
var IListResultOfGetReleasedGraphStateResultDto = /** @class */ (function () {
    function IListResultOfGetReleasedGraphStateResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfGetReleasedGraphStateResultDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetReleasedGraphStateResultDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfGetReleasedGraphStateResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfGetReleasedGraphStateResultDto();
        result.init(data);
        return result;
    };
    IListResultOfGetReleasedGraphStateResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfGetReleasedGraphStateResultDto;
}());
export { IListResultOfGetReleasedGraphStateResultDto };
var GetReleasedGraphStateResultDto = /** @class */ (function () {
    function GetReleasedGraphStateResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetReleasedGraphStateResultDto.prototype.init = function (data) {
        if (data) {
            this.graphId = data["graphId"];
            this.stateIndex = data["stateIndex"];
            this.result = data["result"] ? GraphStateResult.fromJS(data["result"]) : undefined;
        }
    };
    GetReleasedGraphStateResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetReleasedGraphStateResultDto();
        result.init(data);
        return result;
    };
    GetReleasedGraphStateResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["graphId"] = this.graphId;
        data["stateIndex"] = this.stateIndex;
        data["result"] = this.result ? this.result.toJSON() : undefined;
        return data;
    };
    return GetReleasedGraphStateResultDto;
}());
export { GetReleasedGraphStateResultDto };
var ListResultDtoOfReleasedDataSourceDto = /** @class */ (function () {
    function ListResultDtoOfReleasedDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfReleasedDataSourceDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ReleasedDataSourceDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfReleasedDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfReleasedDataSourceDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfReleasedDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfReleasedDataSourceDto;
}());
export { ListResultDtoOfReleasedDataSourceDto };
var ReleasedDataSourceDto = /** @class */ (function () {
    function ReleasedDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.releasedConfigureId = data["releasedConfigureId"];
            this.type = data["type"];
        }
    };
    ReleasedDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedDataSourceDto();
        result.init(data);
        return result;
    };
    ReleasedDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["releasedConfigureId"] = this.releasedConfigureId;
        data["type"] = this.type;
        return data;
    };
    return ReleasedDataSourceDto;
}());
export { ReleasedDataSourceDto };
var ReleasedVariableDto = /** @class */ (function () {
    function ReleasedVariableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleasedVariableDto.prototype.init = function (data) {
        if (data) {
            this.variableGroupName = data["variableGroupName"];
            this.name = data["name"];
            this.unit = data["unit"];
        }
    };
    ReleasedVariableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleasedVariableDto();
        result.init(data);
        return result;
    };
    ReleasedVariableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["variableGroupName"] = this.variableGroupName;
        data["name"] = this.name;
        data["unit"] = this.unit;
        return data;
    };
    return ReleasedVariableDto;
}());
export { ReleasedVariableDto };
var PagedResultDtoOfRepairDto = /** @class */ (function () {
    function PagedResultDtoOfRepairDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfRepairDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RepairDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfRepairDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfRepairDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfRepairDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfRepairDto;
}());
export { PagedResultDtoOfRepairDto };
var RepairDto = /** @class */ (function () {
    function RepairDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RepairDto.prototype.init = function (data) {
        if (data) {
            this.faultCode = data["faultCode"];
            this.faultDescription = data["faultDescription"];
            this.state = data["state"];
            this.deviceName = data["deviceName"];
            this.contactName = data["contactName"];
            this.contactPhoneNumber = data["contactPhoneNumber"];
            this.companyName = data["companyName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(RepairImage.fromJS(item));
                }
            }
            this.isCompletedByAssigner = data["isCompletedByAssigner"];
            this.workOrderId = data["workOrderId"];
            this.memo = data["memo"];
            this.id = data["id"];
        }
    };
    RepairDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RepairDto();
        result.init(data);
        return result;
    };
    RepairDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["faultCode"] = this.faultCode;
        data["faultDescription"] = this.faultDescription;
        data["state"] = this.state;
        data["deviceName"] = this.deviceName;
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["companyName"] = this.companyName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["isCompletedByAssigner"] = this.isCompletedByAssigner;
        data["workOrderId"] = this.workOrderId;
        data["memo"] = this.memo;
        data["id"] = this.id;
        return data;
    };
    return RepairDto;
}());
export { RepairDto };
var RepairImage = /** @class */ (function () {
    function RepairImage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RepairImage.prototype.init = function (data) {
        if (data) {
            this.repairId = data["repairId"];
            this.thumbId = data["thumbId"];
            this.imageId = data["imageId"];
            this.id = data["id"];
        }
    };
    RepairImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RepairImage();
        result.init(data);
        return result;
    };
    RepairImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["repairId"] = this.repairId;
        data["thumbId"] = this.thumbId;
        data["imageId"] = this.imageId;
        data["id"] = this.id;
        return data;
    };
    return RepairImage;
}());
export { RepairImage };
var ExportRepairListDto = /** @class */ (function () {
    function ExportRepairListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportRepairListDto.prototype.init = function (data) {
        if (data) {
            this.filterString = data["filterString"];
            this.faultCode = data["faultCode"];
            this.state = data["state"];
            this.deviceName = data["deviceName"];
            this.contactName = data["contactName"];
            this.contactPhoneNumber = data["contactPhoneNumber"];
            this.companyName = data["companyName"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
        }
    };
    ExportRepairListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportRepairListDto();
        result.init(data);
        return result;
    };
    ExportRepairListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["filterString"] = this.filterString;
        data["faultCode"] = this.faultCode;
        data["state"] = this.state;
        data["deviceName"] = this.deviceName;
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["companyName"] = this.companyName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        return data;
    };
    return ExportRepairListDto;
}());
export { ExportRepairListDto };
var GetMarkAsCompletedDto = /** @class */ (function () {
    function GetMarkAsCompletedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMarkAsCompletedDto.prototype.init = function (data) {
        if (data) {
            this.memo = data["memo"];
            this.repairId = data["repairId"];
        }
    };
    GetMarkAsCompletedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMarkAsCompletedDto();
        result.init(data);
        return result;
    };
    GetMarkAsCompletedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memo"] = this.memo;
        data["repairId"] = this.repairId;
        return data;
    };
    return GetMarkAsCompletedDto;
}());
export { GetMarkAsCompletedDto };
var ReportFaultCodeDto = /** @class */ (function () {
    function ReportFaultCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportFaultCodeDto.prototype.init = function (data) {
        if (data) {
            this.faultCode = data["faultCode"];
        }
    };
    ReportFaultCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportFaultCodeDto();
        result.init(data);
        return result;
    };
    ReportFaultCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["faultCode"] = this.faultCode;
        return data;
    };
    return ReportFaultCodeDto;
}());
export { ReportFaultCodeDto };
var CreateRepairDto = /** @class */ (function () {
    function CreateRepairDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateRepairDto.prototype.init = function (data) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.faultDescription = data["faultDescription"];
            this.state = data["state"];
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(RepairImageDto.fromJS(item));
                }
            }
            this.contactName = data["contactName"];
            this.contactPhoneNumber = data["contactPhoneNumber"];
        }
    };
    CreateRepairDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateRepairDto();
        result.init(data);
        return result;
    };
    CreateRepairDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["faultDescription"] = this.faultDescription;
        data["state"] = this.state;
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        return data;
    };
    return CreateRepairDto;
}());
export { CreateRepairDto };
var RepairImageDto = /** @class */ (function () {
    function RepairImageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RepairImageDto.prototype.init = function (data) {
        if (data) {
            this.repairId = data["repairId"];
            this.thumbId = data["thumbId"];
            this.imageId = data["imageId"];
        }
    };
    RepairImageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RepairImageDto();
        result.init(data);
        return result;
    };
    RepairImageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["repairId"] = this.repairId;
        data["thumbId"] = this.thumbId;
        data["imageId"] = this.imageId;
        return data;
    };
    return RepairImageDto;
}());
export { RepairImageDto };
var RepairContactDto = /** @class */ (function () {
    function RepairContactDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RepairContactDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    RepairContactDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RepairContactDto();
        result.init(data);
        return result;
    };
    RepairContactDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return RepairContactDto;
}());
export { RepairContactDto };
var RepairProgressDto = /** @class */ (function () {
    function RepairProgressDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RepairProgressDto.prototype.init = function (data) {
        if (data) {
            this.handlerName = data["handlerName"];
            this.state = data["state"];
            this.handleTime = data["handleTime"] ? moment(data["handleTime"].toString()) : undefined;
            if (data["parameters"]) {
                this.parameters = {};
                for (var key in data["parameters"]) {
                    if (data["parameters"].hasOwnProperty(key))
                        this.parameters[key] = data["parameters"][key];
                }
            }
        }
    };
    RepairProgressDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RepairProgressDto();
        result.init(data);
        return result;
    };
    RepairProgressDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["handlerName"] = this.handlerName;
        data["state"] = this.state;
        data["handleTime"] = this.handleTime ? this.handleTime.toISOString() : undefined;
        if (this.parameters) {
            data["parameters"] = {};
            for (var key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    data["parameters"][key] = this.parameters[key];
            }
        }
        return data;
    };
    return RepairProgressDto;
}());
export { RepairProgressDto };
var ApplyInfoDto = /** @class */ (function () {
    function ApplyInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplyInfoDto.prototype.init = function (data) {
        if (data) {
            this.enterpriseName = data["enterpriseName"];
        }
    };
    ApplyInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplyInfoDto();
        result.init(data);
        return result;
    };
    ApplyInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseName"] = this.enterpriseName;
        return data;
    };
    return ApplyInfoDto;
}());
export { ApplyInfoDto };
var UpdateApplyInfoDto = /** @class */ (function () {
    function UpdateApplyInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateApplyInfoDto.prototype.init = function (data) {
        if (data) {
            this.enumEnterpriseType = data["enumEnterpriseType"];
            this.enumIndustryType = data["enumIndustryType"];
            this.enumDeviceScaleRange = data["enumDeviceScaleRange"];
            this.enumAfterSalesPersonScaleRange = data["enumAfterSalesPersonScaleRange"];
            this.enumApplicantRole = data["enumApplicantRole"];
            this.applicantName = data["applicantName"];
            this.applicantPhone = data["applicantPhone"];
        }
    };
    UpdateApplyInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateApplyInfoDto();
        result.init(data);
        return result;
    };
    UpdateApplyInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["enumEnterpriseType"] = this.enumEnterpriseType;
        data["enumIndustryType"] = this.enumIndustryType;
        data["enumDeviceScaleRange"] = this.enumDeviceScaleRange;
        data["enumAfterSalesPersonScaleRange"] = this.enumAfterSalesPersonScaleRange;
        data["enumApplicantRole"] = this.enumApplicantRole;
        data["applicantName"] = this.applicantName;
        data["applicantPhone"] = this.applicantPhone;
        return data;
    };
    return UpdateApplyInfoDto;
}());
export { UpdateApplyInfoDto };
var ReportDataQueryDto = /** @class */ (function () {
    function ReportDataQueryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportDataQueryDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.reportModel = data["reportModel"] ? ReportQueryDefinition.fromJS(data["reportModel"]) : undefined;
            this.displayType = data["displayType"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : undefined;
        }
    };
    ReportDataQueryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportDataQueryDto();
        result.init(data);
        return result;
    };
    ReportDataQueryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportModel"] = this.reportModel ? this.reportModel.toJSON() : undefined;
        data["displayType"] = this.displayType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        return data;
    };
    return ReportDataQueryDto;
}());
export { ReportDataQueryDto };
var ReportQueryDefinition = /** @class */ (function () {
    function ReportQueryDefinition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportQueryDefinition.prototype.init = function (data) {
        if (data) {
            this.target = data["target"];
            this.xDimensionFieldIndex = data["xDimensionFieldIndex"];
            this.timeDimensionType = data["timeDimensionType"];
            this.metricFieldIndex = data["metricFieldIndex"];
            this.timeMetricType = data["timeMetricType"];
            if (data["aggregateFieldActions"] && data["aggregateFieldActions"].constructor === Array) {
                this.aggregateFieldActions = [];
                for (var _i = 0, _a = data["aggregateFieldActions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.aggregateFieldActions.push(AggregateFieldActionDef.fromJS(item));
                }
            }
            if (data["criteria"] && data["criteria"].constructor === Array) {
                this.criteria = [];
                for (var _b = 0, _c = data["criteria"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.criteria.push(ReportQueryCriteria.fromJS(item));
                }
            }
            this.reportQueryType = data["reportQueryType"];
            this.metricAggregateAction = data["metricAggregateAction"];
        }
    };
    ReportQueryDefinition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportQueryDefinition();
        result.init(data);
        return result;
    };
    ReportQueryDefinition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["xDimensionFieldIndex"] = this.xDimensionFieldIndex;
        data["timeDimensionType"] = this.timeDimensionType;
        data["metricFieldIndex"] = this.metricFieldIndex;
        data["timeMetricType"] = this.timeMetricType;
        if (this.aggregateFieldActions && this.aggregateFieldActions.constructor === Array) {
            data["aggregateFieldActions"] = [];
            for (var _i = 0, _a = this.aggregateFieldActions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["aggregateFieldActions"].push(item.toJSON());
            }
        }
        if (this.criteria && this.criteria.constructor === Array) {
            data["criteria"] = [];
            for (var _b = 0, _c = this.criteria; _b < _c.length; _b++) {
                var item = _c[_b];
                data["criteria"].push(item.toJSON());
            }
        }
        data["reportQueryType"] = this.reportQueryType;
        data["metricAggregateAction"] = this.metricAggregateAction;
        return data;
    };
    return ReportQueryDefinition;
}());
export { ReportQueryDefinition };
var AggregateFieldActionDef = /** @class */ (function () {
    function AggregateFieldActionDef(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AggregateFieldActionDef.prototype.init = function (data) {
        if (data) {
            this.fieldIndex = data["fieldIndex"];
            this.aggregateAction = data["aggregateAction"];
        }
    };
    AggregateFieldActionDef.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AggregateFieldActionDef();
        result.init(data);
        return result;
    };
    AggregateFieldActionDef.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fieldIndex"] = this.fieldIndex;
        data["aggregateAction"] = this.aggregateAction;
        return data;
    };
    return AggregateFieldActionDef;
}());
export { AggregateFieldActionDef };
var ReportQueryCriteria = /** @class */ (function () {
    function ReportQueryCriteria(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportQueryCriteria.prototype.init = function (data) {
        if (data) {
            this.fieldIndex = data["fieldIndex"];
            this.stringOperatorType = data["stringOperatorType"];
            this.dateOperatorType = data["dateOperatorType"];
            this.numberOperatorType = data["numberOperatorType"];
            if (data["operands"] && data["operands"].constructor === Array) {
                this.operands = [];
                for (var _i = 0, _a = data["operands"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.operands.push(item);
                }
            }
            if (data["operandsForDisplay"] && data["operandsForDisplay"].constructor === Array) {
                this.operandsForDisplay = [];
                for (var _b = 0, _c = data["operandsForDisplay"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.operandsForDisplay.push(IdNameItem.fromJS(item));
                }
            }
        }
    };
    ReportQueryCriteria.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportQueryCriteria();
        result.init(data);
        return result;
    };
    ReportQueryCriteria.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fieldIndex"] = this.fieldIndex;
        data["stringOperatorType"] = this.stringOperatorType;
        data["dateOperatorType"] = this.dateOperatorType;
        data["numberOperatorType"] = this.numberOperatorType;
        if (this.operands && this.operands.constructor === Array) {
            data["operands"] = [];
            for (var _i = 0, _a = this.operands; _i < _a.length; _i++) {
                var item = _a[_i];
                data["operands"].push(item);
            }
        }
        if (this.operandsForDisplay && this.operandsForDisplay.constructor === Array) {
            data["operandsForDisplay"] = [];
            for (var _b = 0, _c = this.operandsForDisplay; _b < _c.length; _b++) {
                var item = _c[_b];
                data["operandsForDisplay"].push(item.toJSON());
            }
        }
        return data;
    };
    return ReportQueryCriteria;
}());
export { ReportQueryCriteria };
var IdNameItem = /** @class */ (function () {
    function IdNameItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IdNameItem.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    };
    IdNameItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IdNameItem();
        result.init(data);
        return result;
    };
    IdNameItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return IdNameItem;
}());
export { IdNameItem };
var ReportDataResultDto = /** @class */ (function () {
    function ReportDataResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportDataResultDto.prototype.init = function (data) {
        if (data) {
            this.graphicResult = data["graphicResult"] ? ReportDataGraphicResult.fromJS(data["graphicResult"]) : undefined;
            this.tableResult = data["tableResult"] ? HistoryDataAlarmTableResult.fromJS(data["tableResult"]) : undefined;
            if (data["pieChartResult"] && data["pieChartResult"].constructor === Array) {
                this.pieChartResult = [];
                for (var _i = 0, _a = data["pieChartResult"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.pieChartResult.push(NameValueOfDouble.fromJS(item));
                }
            }
            this.success = data["success"];
            this.errorMessage = data["errorMessage"];
        }
    };
    ReportDataResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportDataResultDto();
        result.init(data);
        return result;
    };
    ReportDataResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["graphicResult"] = this.graphicResult ? this.graphicResult.toJSON() : undefined;
        data["tableResult"] = this.tableResult ? this.tableResult.toJSON() : undefined;
        if (this.pieChartResult && this.pieChartResult.constructor === Array) {
            data["pieChartResult"] = [];
            for (var _i = 0, _a = this.pieChartResult; _i < _a.length; _i++) {
                var item = _a[_i];
                data["pieChartResult"].push(item.toJSON());
            }
        }
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return ReportDataResultDto;
}());
export { ReportDataResultDto };
var ReportDataGraphicResult = /** @class */ (function () {
    function ReportDataGraphicResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportDataGraphicResult.prototype.init = function (data) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [];
                for (var _i = 0, _a = data["list"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.list.push(HistoryDataAlarmMetricList.fromJS(item));
                }
            }
            this.containMetricData = data["containMetricData"];
            if (data["dimensionValueList"] && data["dimensionValueList"].constructor === Array) {
                this.dimensionValueList = [];
                for (var _b = 0, _c = data["dimensionValueList"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.dimensionValueList.push(item);
                }
            }
            if (data["labels"] && data["labels"].constructor === Array) {
                this.labels = [];
                for (var _d = 0, _e = data["labels"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.labels.push(item);
                }
            }
        }
    };
    ReportDataGraphicResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportDataGraphicResult();
        result.init(data);
        return result;
    };
    ReportDataGraphicResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (var _i = 0, _a = this.list; _i < _a.length; _i++) {
                var item = _a[_i];
                data["list"].push(item.toJSON());
            }
        }
        data["containMetricData"] = this.containMetricData;
        if (this.dimensionValueList && this.dimensionValueList.constructor === Array) {
            data["dimensionValueList"] = [];
            for (var _b = 0, _c = this.dimensionValueList; _b < _c.length; _b++) {
                var item = _c[_b];
                data["dimensionValueList"].push(item);
            }
        }
        if (this.labels && this.labels.constructor === Array) {
            data["labels"] = [];
            for (var _d = 0, _e = this.labels; _d < _e.length; _d++) {
                var item = _e[_d];
                data["labels"].push(item);
            }
        }
        return data;
    };
    return ReportDataGraphicResult;
}());
export { ReportDataGraphicResult };
var HistoryDataAlarmTableResult = /** @class */ (function () {
    function HistoryDataAlarmTableResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataAlarmTableResult.prototype.init = function (data) {
        if (data) {
            if (data["headers"] && data["headers"].constructor === Array) {
                this.headers = [];
                for (var _i = 0, _a = data["headers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.headers.push(item);
                }
            }
            if (data["content"] && data["content"].constructor === Array) {
                this.content = [];
                for (var _b = 0, _c = data["content"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.content.push(item);
                }
            }
        }
    };
    HistoryDataAlarmTableResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataAlarmTableResult();
        result.init(data);
        return result;
    };
    HistoryDataAlarmTableResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.headers && this.headers.constructor === Array) {
            data["headers"] = [];
            for (var _i = 0, _a = this.headers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["headers"].push(item);
            }
        }
        if (this.content && this.content.constructor === Array) {
            data["content"] = [];
            for (var _b = 0, _c = this.content; _b < _c.length; _b++) {
                var item = _c[_b];
                data["content"].push(item);
            }
        }
        return data;
    };
    return HistoryDataAlarmTableResult;
}());
export { HistoryDataAlarmTableResult };
var NameValueOfDouble = /** @class */ (function () {
    function NameValueOfDouble(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueOfDouble.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueOfDouble.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueOfDouble();
        result.init(data);
        return result;
    };
    NameValueOfDouble.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueOfDouble;
}());
export { NameValueOfDouble };
var HistoryDataAlarmMetricList = /** @class */ (function () {
    function HistoryDataAlarmMetricList(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataAlarmMetricList.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (var _i = 0, _a = data["data"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.data.push(item);
                }
            }
        }
    };
    HistoryDataAlarmMetricList.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataAlarmMetricList();
        result.init(data);
        return result;
    };
    HistoryDataAlarmMetricList.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
                var item = _a[_i];
                data["data"].push(item);
            }
        }
        return data;
    };
    return HistoryDataAlarmMetricList;
}());
export { HistoryDataAlarmMetricList };
var ExportHistoryDataAlarmDto = /** @class */ (function () {
    function ExportHistoryDataAlarmDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportHistoryDataAlarmDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : undefined;
        }
    };
    ExportHistoryDataAlarmDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportHistoryDataAlarmDto();
        result.init(data);
        return result;
    };
    ExportHistoryDataAlarmDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        return data;
    };
    return ExportHistoryDataAlarmDto;
}());
export { ExportHistoryDataAlarmDto };
var PagedResultDtoOfNameReportResultDto = /** @class */ (function () {
    function PagedResultDtoOfNameReportResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfNameReportResultDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameReportResultDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfNameReportResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfNameReportResultDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfNameReportResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfNameReportResultDto;
}());
export { PagedResultDtoOfNameReportResultDto };
var NameReportResultDto = /** @class */ (function () {
    function NameReportResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameReportResultDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
            this.displayType = data["displayType"];
        }
    };
    NameReportResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameReportResultDto();
        result.init(data);
        return result;
    };
    NameReportResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["displayType"] = this.displayType;
        return data;
    };
    return NameReportResultDto;
}());
export { NameReportResultDto };
var PagedResultDtoOfReportsListDto = /** @class */ (function () {
    function PagedResultDtoOfReportsListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfReportsListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ReportsListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfReportsListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfReportsListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfReportsListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfReportsListDto;
}());
export { PagedResultDtoOfReportsListDto };
var ReportsListDto = /** @class */ (function () {
    function ReportsListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportsListDto.prototype.init = function (data) {
        if (data) {
            this.reportId = data["reportId"];
            this.reportTitle = data["reportTitle"];
            this.allowExportData = data["allowExportData"];
            this.creator = data["creator"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.modifier = data["modifier"];
            this.modificationTime = data["modificationTime"] ? moment(data["modificationTime"].toString()) : undefined;
            this.reportDisplayType = data["reportDisplayType"];
            this.reportDefinition = data["reportDefinition"] ? ReportQueryDefinition.fromJS(data["reportDefinition"]) : undefined;
        }
    };
    ReportsListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportsListDto();
        result.init(data);
        return result;
    };
    ReportsListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportTitle"] = this.reportTitle;
        data["allowExportData"] = this.allowExportData;
        data["creator"] = this.creator;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["modifier"] = this.modifier;
        data["modificationTime"] = this.modificationTime ? this.modificationTime.toISOString() : undefined;
        data["reportDisplayType"] = this.reportDisplayType;
        data["reportDefinition"] = this.reportDefinition ? this.reportDefinition.toJSON() : undefined;
        return data;
    };
    return ReportsListDto;
}());
export { ReportsListDto };
var StatisticReportDto = /** @class */ (function () {
    function StatisticReportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StatisticReportDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.displayType = data["displayType"];
            this.reportDefinitionModel = data["reportDefinitionModel"] ? ReportQueryDefinition.fromJS(data["reportDefinitionModel"]) : undefined;
            this.allowExportData = data["allowExportData"];
        }
    };
    StatisticReportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StatisticReportDto();
        result.init(data);
        return result;
    };
    StatisticReportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["displayType"] = this.displayType;
        data["reportDefinitionModel"] = this.reportDefinitionModel ? this.reportDefinitionModel.toJSON() : undefined;
        data["allowExportData"] = this.allowExportData;
        return data;
    };
    return StatisticReportDto;
}());
export { StatisticReportDto };
var GetReportConfigByIdResultDto = /** @class */ (function () {
    function GetReportConfigByIdResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetReportConfigByIdResultDto.prototype.init = function (data) {
        if (data) {
            this.report = data["report"] ? ReportsListDto.fromJS(data["report"]) : undefined;
            this.recommendedStartTime = data["recommendedStartTime"] ? moment(data["recommendedStartTime"].toString()) : undefined;
            this.recommendedEndTime = data["recommendedEndTime"] ? moment(data["recommendedEndTime"].toString()) : undefined;
        }
    };
    GetReportConfigByIdResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetReportConfigByIdResultDto();
        result.init(data);
        return result;
    };
    GetReportConfigByIdResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : undefined;
        data["recommendedStartTime"] = this.recommendedStartTime ? this.recommendedStartTime.toISOString() : undefined;
        data["recommendedEndTime"] = this.recommendedEndTime ? this.recommendedEndTime.toISOString() : undefined;
        return data;
    };
    return GetReportConfigByIdResultDto;
}());
export { GetReportConfigByIdResultDto };
var ReportSaveDto = /** @class */ (function () {
    function ReportSaveDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.reportDefinition = new ReportQueryDefinition();
        }
    }
    ReportSaveDto.prototype.init = function (data) {
        if (data) {
            this.reportId = data["reportId"];
            this.reportTitle = data["reportTitle"];
            this.allowExportData = data["allowExportData"];
            this.displayType = data["displayType"];
            this.reportDefinition = data["reportDefinition"] ? ReportQueryDefinition.fromJS(data["reportDefinition"]) : new ReportQueryDefinition();
        }
    };
    ReportSaveDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportSaveDto();
        result.init(data);
        return result;
    };
    ReportSaveDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportTitle"] = this.reportTitle;
        data["allowExportData"] = this.allowExportData;
        data["displayType"] = this.displayType;
        data["reportDefinition"] = this.reportDefinition ? this.reportDefinition.toJSON() : undefined;
        return data;
    };
    return ReportSaveDto;
}());
export { ReportSaveDto };
var ListResultDtoOfHistoryDataTableDto = /** @class */ (function () {
    function ListResultDtoOfHistoryDataTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfHistoryDataTableDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(HistoryDataTableDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfHistoryDataTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfHistoryDataTableDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfHistoryDataTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfHistoryDataTableDto;
}());
export { ListResultDtoOfHistoryDataTableDto };
var HistoryDataTableDto = /** @class */ (function () {
    function HistoryDataTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataTableDto.prototype.init = function (data) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.devicePattern = data["devicePattern"];
            this.deviceGroupName = data["deviceGroupName"];
            this.deviceModelName = data["deviceModelName"];
            this.commdevicesn = data["commdevicesn"];
            this.dataSourceName = data["dataSourceName"];
            this.hdataName = data["hdataName"];
            this.hdataChannelName = data["hdataChannelName"];
            this.value = data["value"];
            this.timestamp = data["timestamp"];
        }
    };
    HistoryDataTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataTableDto();
        result.init(data);
        return result;
    };
    HistoryDataTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["devicePattern"] = this.devicePattern;
        data["deviceGroupName"] = this.deviceGroupName;
        data["deviceModelName"] = this.deviceModelName;
        data["commdevicesn"] = this.commdevicesn;
        data["dataSourceName"] = this.dataSourceName;
        data["hdataName"] = this.hdataName;
        data["hdataChannelName"] = this.hdataChannelName;
        data["value"] = this.value;
        data["timestamp"] = this.timestamp;
        return data;
    };
    return HistoryDataTableDto;
}());
export { HistoryDataTableDto };
var ListResultDtoOfAlarmTableDto = /** @class */ (function () {
    function ListResultDtoOfAlarmTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfAlarmTableDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(AlarmTableDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfAlarmTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfAlarmTableDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfAlarmTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfAlarmTableDto;
}());
export { ListResultDtoOfAlarmTableDto };
var AlarmTableDto = /** @class */ (function () {
    function AlarmTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AlarmTableDto.prototype.init = function (data) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.devicePattern = data["devicePattern"];
            this.deviceGroupName = data["deviceGroupName"];
            this.deviceModelName = data["deviceModelName"];
            this.dataSourceName = data["dataSourceName"];
            this.fCloudAlarmName = data["fCloudAlarmName"];
            this.state = data["state"];
            this.message = data["message"];
            this.value = data["value"];
            this.timeStamp = data["timeStamp"];
            this.malfunctionCode = data["malfunctionCode"];
            this.alarmLevel = data["alarmLevel"];
        }
    };
    AlarmTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AlarmTableDto();
        result.init(data);
        return result;
    };
    AlarmTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["devicePattern"] = this.devicePattern;
        data["deviceGroupName"] = this.deviceGroupName;
        data["deviceModelName"] = this.deviceModelName;
        data["dataSourceName"] = this.dataSourceName;
        data["fCloudAlarmName"] = this.fCloudAlarmName;
        data["state"] = this.state;
        data["message"] = this.message;
        data["value"] = this.value;
        data["timeStamp"] = this.timeStamp;
        data["malfunctionCode"] = this.malfunctionCode;
        data["alarmLevel"] = this.alarmLevel;
        return data;
    };
    return AlarmTableDto;
}());
export { AlarmTableDto };
var ListResultDtoOfDeviceTableDto = /** @class */ (function () {
    function ListResultDtoOfDeviceTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeviceTableDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceTableDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeviceTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeviceTableDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeviceTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeviceTableDto;
}());
export { ListResultDtoOfDeviceTableDto };
var DeviceTableDto = /** @class */ (function () {
    function DeviceTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceTableDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.serialNumber = data["serialNumber"];
            this.devicePattern = data["devicePattern"];
            this.deviceGroup = data["deviceGroup"];
            this.deviceModel = data["deviceModel"];
            this.commDeviceSn = data["commDeviceSn"];
            this.deviceState = data["deviceState"];
            this.deviceDeliveryStatus = data["deviceDeliveryStatus"];
            this.orderNumber = data["orderNumber"];
            this.oemEndUserDealerCompany = data["oemEndUserDealerCompany"];
            this.provinceId = data["provinceId"];
            this.cityId = data["cityId"];
            this.districtId = data["districtId"];
            this.creationTime = data["creationTime"];
            this.lastModificationTime = data["lastModificationTime"];
        }
    };
    DeviceTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceTableDto();
        result.init(data);
        return result;
    };
    DeviceTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["devicePattern"] = this.devicePattern;
        data["deviceGroup"] = this.deviceGroup;
        data["deviceModel"] = this.deviceModel;
        data["commDeviceSn"] = this.commDeviceSn;
        data["deviceState"] = this.deviceState;
        data["deviceDeliveryStatus"] = this.deviceDeliveryStatus;
        data["orderNumber"] = this.orderNumber;
        data["oemEndUserDealerCompany"] = this.oemEndUserDealerCompany;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["creationTime"] = this.creationTime;
        data["lastModificationTime"] = this.lastModificationTime;
        return data;
    };
    return DeviceTableDto;
}());
export { DeviceTableDto };
var ListResultDtoOfUserTableDto = /** @class */ (function () {
    function ListResultDtoOfUserTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfUserTableDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserTableDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfUserTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfUserTableDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfUserTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfUserTableDto;
}());
export { ListResultDtoOfUserTableDto };
var UserTableDto = /** @class */ (function () {
    function UserTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserTableDto.prototype.init = function (data) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.abpRoles = data["abpRoles"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.emailAddress = data["emailAddress"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"];
            this.lastModificationTime = data["lastModificationTime"];
        }
    };
    UserTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserTableDto();
        result.init(data);
        return result;
    };
    UserTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["abpRoles"] = this.abpRoles;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["emailAddress"] = this.emailAddress;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime;
        data["lastModificationTime"] = this.lastModificationTime;
        return data;
    };
    return UserTableDto;
}());
export { UserTableDto };
var ListResultDtoOfFBoxStateTableDto = /** @class */ (function () {
    function ListResultDtoOfFBoxStateTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfFBoxStateTableDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FBoxStateTableDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfFBoxStateTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfFBoxStateTableDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfFBoxStateTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfFBoxStateTableDto;
}());
export { ListResultDtoOfFBoxStateTableDto };
var FBoxStateTableDto = /** @class */ (function () {
    function FBoxStateTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FBoxStateTableDto.prototype.init = function (data) {
        if (data) {
            this.boxSerialNumber = data["boxSerialNumber"];
            this.state = data["state"];
        }
    };
    FBoxStateTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FBoxStateTableDto();
        result.init(data);
        return result;
    };
    FBoxStateTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["boxSerialNumber"] = this.boxSerialNumber;
        data["state"] = this.state;
        return data;
    };
    return FBoxStateTableDto;
}());
export { FBoxStateTableDto };
var TableDefinition = /** @class */ (function () {
    function TableDefinition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TableDefinition.prototype.init = function (data) {
        if (data) {
            this.tableName = data["tableName"];
            this.tableEnum = data["tableEnum"];
            if (data["fields"] && data["fields"].constructor === Array) {
                this.fields = [];
                for (var _i = 0, _a = data["fields"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.fields.push(FieldDefinition.fromJS(item));
                }
            }
            this.timeStampField = data["timeStampField"] ? FieldDefinition.fromJS(data["timeStampField"]) : undefined;
        }
    };
    TableDefinition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TableDefinition();
        result.init(data);
        return result;
    };
    TableDefinition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["tableEnum"] = this.tableEnum;
        if (this.fields && this.fields.constructor === Array) {
            data["fields"] = [];
            for (var _i = 0, _a = this.fields; _i < _a.length; _i++) {
                var item = _a[_i];
                data["fields"].push(item.toJSON());
            }
        }
        data["timeStampField"] = this.timeStampField ? this.timeStampField.toJSON() : undefined;
        return data;
    };
    return TableDefinition;
}());
export { TableDefinition };
var FieldDefinition = /** @class */ (function () {
    function FieldDefinition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FieldDefinition.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.type = data["type"];
            this.index = data["index"];
            if (data["optionalValues"] && data["optionalValues"].constructor === Array) {
                this.optionalValues = [];
                for (var _i = 0, _a = data["optionalValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.optionalValues.push(OptionalValue.fromJS(item));
                }
            }
            this.referenceField = data["referenceField"] ? ReferenceFieldDefinition.fromJS(data["referenceField"]) : undefined;
            this.isVirtualField = data["isVirtualField"];
            this.multiSideInfo = data["multiSideInfo"] ? FieldDefinitionMultiSideInfo.fromJS(data["multiSideInfo"]) : undefined;
        }
    };
    FieldDefinition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FieldDefinition();
        result.init(data);
        return result;
    };
    FieldDefinition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["index"] = this.index;
        if (this.optionalValues && this.optionalValues.constructor === Array) {
            data["optionalValues"] = [];
            for (var _i = 0, _a = this.optionalValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["optionalValues"].push(item.toJSON());
            }
        }
        data["referenceField"] = this.referenceField ? this.referenceField.toJSON() : undefined;
        data["isVirtualField"] = this.isVirtualField;
        data["multiSideInfo"] = this.multiSideInfo ? this.multiSideInfo.toJSON() : undefined;
        return data;
    };
    return FieldDefinition;
}());
export { FieldDefinition };
var OptionalValue = /** @class */ (function () {
    function OptionalValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OptionalValue.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.name = data["name"];
        }
    };
    OptionalValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OptionalValue();
        result.init(data);
        return result;
    };
    OptionalValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    };
    return OptionalValue;
}());
export { OptionalValue };
var ReferenceFieldDefinition = /** @class */ (function () {
    function ReferenceFieldDefinition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReferenceFieldDefinition.prototype.init = function (data) {
        if (data) {
            this.joinLeftFieldName = data["joinLeftFieldName"];
            this.joinInnerFieldName = data["joinInnerFieldName"];
            this.displayFieldName = data["displayFieldName"];
            this.displayFieldType = data["displayFieldType"];
            this.idFieldName = data["idFieldName"];
            this.idFieldType = data["idFieldType"];
            this.tableName = data["tableName"];
            this.referenceField = data["referenceField"] ? ReferenceFieldDefinition.fromJS(data["referenceField"]) : undefined;
        }
    };
    ReferenceFieldDefinition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReferenceFieldDefinition();
        result.init(data);
        return result;
    };
    ReferenceFieldDefinition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["joinLeftFieldName"] = this.joinLeftFieldName;
        data["joinInnerFieldName"] = this.joinInnerFieldName;
        data["displayFieldName"] = this.displayFieldName;
        data["displayFieldType"] = this.displayFieldType;
        data["idFieldName"] = this.idFieldName;
        data["idFieldType"] = this.idFieldType;
        data["tableName"] = this.tableName;
        data["referenceField"] = this.referenceField ? this.referenceField.toJSON() : undefined;
        return data;
    };
    return ReferenceFieldDefinition;
}());
export { ReferenceFieldDefinition };
var FieldDefinitionMultiSideInfo = /** @class */ (function () {
    function FieldDefinitionMultiSideInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FieldDefinitionMultiSideInfo.prototype.init = function (data) {
        if (data) {
            this.multiSideTableName = data["multiSideTableName"];
            this.joinFieldName = data["joinFieldName"];
            this.mainTableJoinFieldName = data["mainTableJoinFieldName"];
            this.filterIdFiledName = data["filterIdFiledName"];
            this.filterDisplayNameField = data["filterDisplayNameField"];
            this.displayFieldType = data["displayFieldType"];
            this.idFieldType = data["idFieldType"];
        }
    };
    FieldDefinitionMultiSideInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FieldDefinitionMultiSideInfo();
        result.init(data);
        return result;
    };
    FieldDefinitionMultiSideInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["multiSideTableName"] = this.multiSideTableName;
        data["joinFieldName"] = this.joinFieldName;
        data["mainTableJoinFieldName"] = this.mainTableJoinFieldName;
        data["filterIdFiledName"] = this.filterIdFiledName;
        data["filterDisplayNameField"] = this.filterDisplayNameField;
        data["displayFieldType"] = this.displayFieldType;
        data["idFieldType"] = this.idFieldType;
        return data;
    };
    return FieldDefinitionMultiSideInfo;
}());
export { FieldDefinitionMultiSideInfo };
var TableFieldFilterDefinitionDto = /** @class */ (function () {
    function TableFieldFilterDefinitionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TableFieldFilterDefinitionDto.prototype.init = function (data) {
        if (data) {
            this.tableEnum = data["tableEnum"];
            this.fieldIndex = data["fieldIndex"];
            this.filterUrl = data["filterUrl"];
            this.displayIndex = data["displayIndex"];
        }
    };
    TableFieldFilterDefinitionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TableFieldFilterDefinitionDto();
        result.init(data);
        return result;
    };
    TableFieldFilterDefinitionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tableEnum"] = this.tableEnum;
        data["fieldIndex"] = this.fieldIndex;
        data["filterUrl"] = this.filterUrl;
        data["displayIndex"] = this.displayIndex;
        return data;
    };
    return TableFieldFilterDefinitionDto;
}());
export { TableFieldFilterDefinitionDto };
var EmailPhoneDto = /** @class */ (function () {
    function EmailPhoneDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmailPhoneDto.prototype.init = function (data) {
        if (data) {
            this.emailOrPhone = data["emailOrPhone"];
        }
    };
    EmailPhoneDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmailPhoneDto();
        result.init(data);
        return result;
    };
    EmailPhoneDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailOrPhone"] = this.emailOrPhone;
        return data;
    };
    return EmailPhoneDto;
}());
export { EmailPhoneDto };
var CheckEmailPhoneResultDto = /** @class */ (function () {
    function CheckEmailPhoneResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckEmailPhoneResultDto.prototype.init = function (data) {
        if (data) {
            this.validate = data["validate"];
        }
    };
    CheckEmailPhoneResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckEmailPhoneResultDto();
        result.init(data);
        return result;
    };
    CheckEmailPhoneResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["validate"] = this.validate;
        return data;
    };
    return CheckEmailPhoneResultDto;
}());
export { CheckEmailPhoneResultDto };
var EmialPhoneCaptchaDto = /** @class */ (function () {
    function EmialPhoneCaptchaDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmialPhoneCaptchaDto.prototype.init = function (data) {
        if (data) {
            this.captcha = data["captcha"];
            this.emailOrPhone = data["emailOrPhone"];
        }
    };
    EmialPhoneCaptchaDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmialPhoneCaptchaDto();
        result.init(data);
        return result;
    };
    EmialPhoneCaptchaDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["emailOrPhone"] = this.emailOrPhone;
        return data;
    };
    return EmialPhoneCaptchaDto;
}());
export { EmialPhoneCaptchaDto };
var CheckResetPwdCaptchaResultDto = /** @class */ (function () {
    function CheckResetPwdCaptchaResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckResetPwdCaptchaResultDto.prototype.init = function (data) {
        if (data) {
            this.token = data["token"];
            this.validate = data["validate"];
        }
    };
    CheckResetPwdCaptchaResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckResetPwdCaptchaResultDto();
        result.init(data);
        return result;
    };
    CheckResetPwdCaptchaResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["validate"] = this.validate;
        return data;
    };
    return CheckResetPwdCaptchaResultDto;
}());
export { CheckResetPwdCaptchaResultDto };
var ResetPasswordDto = /** @class */ (function () {
    function ResetPasswordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordDto.prototype.init = function (data) {
        if (data) {
            this.password = data["password"];
            this.token = data["token"];
            this.emailOrPhone = data["emailOrPhone"];
        }
    };
    ResetPasswordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordDto();
        result.init(data);
        return result;
    };
    ResetPasswordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["token"] = this.token;
        data["emailOrPhone"] = this.emailOrPhone;
        return data;
    };
    return ResetPasswordDto;
}());
export { ResetPasswordDto };
var ResetPasswordResetCodeDto = /** @class */ (function () {
    function ResetPasswordResetCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordResetCodeDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
        }
    };
    ResetPasswordResetCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordResetCodeDto();
        result.init(data);
        return result;
    };
    ResetPasswordResetCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        return data;
    };
    return ResetPasswordResetCodeDto;
}());
export { ResetPasswordResetCodeDto };
var ResetPasswordByResetCodeResultDto = /** @class */ (function () {
    function ResetPasswordByResetCodeResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordByResetCodeResultDto.prototype.init = function (data) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.username = data["username"];
        }
    };
    ResetPasswordByResetCodeResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordByResetCodeResultDto();
        result.init(data);
        return result;
    };
    ResetPasswordByResetCodeResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["username"] = this.username;
        return data;
    };
    return ResetPasswordByResetCodeResultDto;
}());
export { ResetPasswordByResetCodeResultDto };
var ListResultDtoOfRoleListDto = /** @class */ (function () {
    function ListResultDtoOfRoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfRoleListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RoleListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfRoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfRoleListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfRoleListDto;
}());
export { ListResultDtoOfRoleListDto };
var GetRoleForEditOutput = /** @class */ (function () {
    function GetRoleForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetRoleForEditOutput.prototype.init = function (data) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(FlatPermissionDto.fromJS(item));
                }
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (var _b = 0, _c = data["grantedPermissionNames"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.grantedPermissionNames.push(item);
                }
            }
        }
    };
    GetRoleForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    };
    GetRoleForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item.toJSON());
            }
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (var _b = 0, _c = this.grantedPermissionNames; _b < _c.length; _b++) {
                var item = _c[_b];
                data["grantedPermissionNames"].push(item);
            }
        }
        return data;
    };
    return GetRoleForEditOutput;
}());
export { GetRoleForEditOutput };
var RoleEditDto = /** @class */ (function () {
    function RoleEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.isDefault = data["isDefault"];
        }
    };
    RoleEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleEditDto();
        result.init(data);
        return result;
    };
    RoleEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        return data;
    };
    return RoleEditDto;
}());
export { RoleEditDto };
var FlatPermissionDto = /** @class */ (function () {
    function FlatPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatPermissionDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"] ? PermissionDescription.fromJS(data["description"]) : undefined;
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    };
    FlatPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatPermissionDto();
        result.init(data);
        return result;
    };
    FlatPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    };
    return FlatPermissionDto;
}());
export { FlatPermissionDto };
var UpdateRoleInput = /** @class */ (function () {
    function UpdateRoleInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }
    UpdateRoleInput.prototype.init = function (data) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (var _i = 0, _a = data["grantedPermissionNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.grantedPermissionNames.push(item);
                }
            }
            if (data["grantedDeviceModelPostInfos"] && data["grantedDeviceModelPostInfos"].constructor === Array) {
                this.grantedDeviceModelPostInfos = [];
                for (var _b = 0, _c = data["grantedDeviceModelPostInfos"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.grantedDeviceModelPostInfos.push(GrantedDeviceModelPostInfo.fromJS(item));
                }
            }
        }
    };
    UpdateRoleInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateRoleInput();
        result.init(data);
        return result;
    };
    UpdateRoleInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (var _i = 0, _a = this.grantedPermissionNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["grantedPermissionNames"].push(item);
            }
        }
        if (this.grantedDeviceModelPostInfos && this.grantedDeviceModelPostInfos.constructor === Array) {
            data["grantedDeviceModelPostInfos"] = [];
            for (var _b = 0, _c = this.grantedDeviceModelPostInfos; _b < _c.length; _b++) {
                var item = _c[_b];
                data["grantedDeviceModelPostInfos"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateRoleInput;
}());
export { UpdateRoleInput };
var GrantedDeviceModelPostInfo = /** @class */ (function () {
    function GrantedDeviceModelPostInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GrantedDeviceModelPostInfo.prototype.init = function (data) {
        if (data) {
            this.permissionTargetId = data["permissionTargetId"];
            this.isConfigureDesign = data["isConfigureDesign"];
        }
    };
    GrantedDeviceModelPostInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GrantedDeviceModelPostInfo();
        result.init(data);
        return result;
    };
    GrantedDeviceModelPostInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["permissionTargetId"] = this.permissionTargetId;
        data["isConfigureDesign"] = this.isConfigureDesign;
        return data;
    };
    return GrantedDeviceModelPostInfo;
}());
export { GrantedDeviceModelPostInfo };
var CreateOrEditRoleDto = /** @class */ (function () {
    function CreateOrEditRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditRoleDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.description = data["description"];
        }
    };
    CreateOrEditRoleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditRoleDto();
        result.init(data);
        return result;
    };
    CreateOrEditRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    };
    return CreateOrEditRoleDto;
}());
export { CreateOrEditRoleDto };
var PagedResultDtoOfSerialNumberListDto = /** @class */ (function () {
    function PagedResultDtoOfSerialNumberListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfSerialNumberListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(SerialNumberListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfSerialNumberListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfSerialNumberListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfSerialNumberListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfSerialNumberListDto;
}());
export { PagedResultDtoOfSerialNumberListDto };
var SerialNumberListDto = /** @class */ (function () {
    function SerialNumberListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SerialNumberListDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.format = data["format"];
            this.startNumber = data["startNumber"];
            this.nextUseNumber = data["nextUseNumber"];
            this.preview = data["preview"];
            this.serialNumberReset = data["serialNumberReset"];
            this.id = data["id"];
        }
    };
    SerialNumberListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SerialNumberListDto();
        result.init(data);
        return result;
    };
    SerialNumberListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["format"] = this.format;
        data["startNumber"] = this.startNumber;
        data["nextUseNumber"] = this.nextUseNumber;
        data["preview"] = this.preview;
        data["serialNumberReset"] = this.serialNumberReset;
        data["id"] = this.id;
        return data;
    };
    return SerialNumberListDto;
}());
export { SerialNumberListDto };
var SerialNumberForEditDto = /** @class */ (function () {
    function SerialNumberForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SerialNumberForEditDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.format = data["format"];
            this.startNumber = data["startNumber"];
            this.preview = data["preview"];
            this.serialNumberReset = data["serialNumberReset"];
        }
    };
    SerialNumberForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SerialNumberForEditDto();
        result.init(data);
        return result;
    };
    SerialNumberForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["format"] = this.format;
        data["startNumber"] = this.startNumber;
        data["preview"] = this.preview;
        data["serialNumberReset"] = this.serialNumberReset;
        return data;
    };
    return SerialNumberForEditDto;
}());
export { SerialNumberForEditDto };
var GenerateSerialNumberDto = /** @class */ (function () {
    function GenerateSerialNumberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GenerateSerialNumberDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
        }
    };
    GenerateSerialNumberDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GenerateSerialNumberDto();
        result.init(data);
        return result;
    };
    GenerateSerialNumberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    };
    return GenerateSerialNumberDto;
}());
export { GenerateSerialNumberDto };
var BatchGenerateSerialNumberDto = /** @class */ (function () {
    function BatchGenerateSerialNumberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchGenerateSerialNumberDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.count = data["count"];
        }
    };
    BatchGenerateSerialNumberDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchGenerateSerialNumberDto();
        result.init(data);
        return result;
    };
    BatchGenerateSerialNumberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["count"] = this.count;
        return data;
    };
    return BatchGenerateSerialNumberDto;
}());
export { BatchGenerateSerialNumberDto };
var CreateOrUpdateSerialNumberDto = /** @class */ (function () {
    function CreateOrUpdateSerialNumberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateSerialNumberDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.format = data["format"];
            this.startNumber = data["startNumber"];
            this.serialNumberReset = data["serialNumberReset"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateSerialNumberDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateSerialNumberDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateSerialNumberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["format"] = this.format;
        data["startNumber"] = this.startNumber;
        data["serialNumberReset"] = this.serialNumberReset;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateSerialNumberDto;
}());
export { CreateOrUpdateSerialNumberDto };
var PreviewSerialNumberDto = /** @class */ (function () {
    function PreviewSerialNumberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PreviewSerialNumberDto.prototype.init = function (data) {
        if (data) {
            this.startNumber = data["startNumber"];
            this.format = data["format"];
        }
    };
    PreviewSerialNumberDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PreviewSerialNumberDto();
        result.init(data);
        return result;
    };
    PreviewSerialNumberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["startNumber"] = this.startNumber;
        data["format"] = this.format;
        return data;
    };
    return PreviewSerialNumberDto;
}());
export { PreviewSerialNumberDto };
var GetCurrentLoginInformationsOutput = /** @class */ (function () {
    function GetCurrentLoginInformationsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCurrentLoginInformationsOutput.prototype.init = function (data) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : undefined;
            this.friendshipLink = data["friendshipLink"] ? FriendshipLinkDto.fromJS(data["friendshipLink"]) : undefined;
            this.fBoxAlias = data["fBoxAlias"];
            this.flexAlias = data["flexAlias"];
            this.isSupportAdvancedCommunication = data["isSupportAdvancedCommunication"];
        }
    };
    GetCurrentLoginInformationsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    };
    GetCurrentLoginInformationsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined;
        data["application"] = this.application ? this.application.toJSON() : undefined;
        data["friendshipLink"] = this.friendshipLink ? this.friendshipLink.toJSON() : undefined;
        data["fBoxAlias"] = this.fBoxAlias;
        data["flexAlias"] = this.flexAlias;
        data["isSupportAdvancedCommunication"] = this.isSupportAdvancedCommunication;
        return data;
    };
    return GetCurrentLoginInformationsOutput;
}());
export { GetCurrentLoginInformationsOutput };
var UserLoginInfoDto = /** @class */ (function () {
    function UserLoginInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLoginInfoDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    };
    UserLoginInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLoginInfoDto();
        result.init(data);
        return result;
    };
    UserLoginInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    };
    return UserLoginInfoDto;
}());
export { UserLoginInfoDto };
var TenantLoginInfoDto = /** @class */ (function () {
    function TenantLoginInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantLoginInfoDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.appLogoId = data["appLogoId"];
            this.loginPageBackgroundImageId = data["loginPageBackgroundImageId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.activationCount = data["activationCount"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    };
    TenantLoginInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    };
    TenantLoginInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["appLogoId"] = this.appLogoId;
        data["loginPageBackgroundImageId"] = this.loginPageBackgroundImageId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["activationCount"] = this.activationCount;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    };
    return TenantLoginInfoDto;
}());
export { TenantLoginInfoDto };
var ApplicationInfoDto = /** @class */ (function () {
    function ApplicationInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationInfoDto.prototype.init = function (data) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : undefined;
            if (data["features"]) {
                this.features = {};
                for (var key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    };
    ApplicationInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationInfoDto();
        result.init(data);
        return result;
    };
    ApplicationInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        if (this.features) {
            data["features"] = {};
            for (var key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data;
    };
    return ApplicationInfoDto;
}());
export { ApplicationInfoDto };
var FriendshipLinkDto = /** @class */ (function () {
    function FriendshipLinkDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FriendshipLinkDto.prototype.init = function (data) {
        if (data) {
            this.isDisplayFriendshipLink = data["isDisplayFriendshipLink"];
            this.friendshipLinkName = data["friendshipLinkName"];
            this.friendshipLinkAddress = data["friendshipLinkAddress"];
        }
    };
    FriendshipLinkDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FriendshipLinkDto();
        result.init(data);
        return result;
    };
    FriendshipLinkDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isDisplayFriendshipLink"] = this.isDisplayFriendshipLink;
        data["friendshipLinkName"] = this.friendshipLinkName;
        data["friendshipLinkAddress"] = this.friendshipLinkAddress;
        return data;
    };
    return FriendshipLinkDto;
}());
export { FriendshipLinkDto };
var EditionInfoDto = /** @class */ (function () {
    function EditionInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionInfoDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    };
    EditionInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionInfoDto();
        result.init(data);
        return result;
    };
    EditionInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    };
    return EditionInfoDto;
}());
export { EditionInfoDto };
var UpdateUserSignInTokenOutput = /** @class */ (function () {
    function UpdateUserSignInTokenOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserSignInTokenOutput.prototype.init = function (data) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    };
    UpdateUserSignInTokenOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    };
    UpdateUserSignInTokenOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    };
    return UpdateUserSignInTokenOutput;
}());
export { UpdateUserSignInTokenOutput };
var SystemCategoryDto = /** @class */ (function () {
    function SystemCategoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SystemCategoryDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    };
    SystemCategoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SystemCategoryDto();
        result.init(data);
        return result;
    };
    SystemCategoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return SystemCategoryDto;
}());
export { SystemCategoryDto };
var SystemGraphDto = /** @class */ (function () {
    function SystemGraphDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SystemGraphDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.thumbUrl = data["thumbUrl"];
        }
    };
    SystemGraphDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SystemGraphDto();
        result.init(data);
        return result;
    };
    SystemGraphDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["thumbUrl"] = this.thumbUrl;
        return data;
    };
    return SystemGraphDto;
}());
export { SystemGraphDto };
var SystemGraphStateDto = /** @class */ (function () {
    function SystemGraphStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SystemGraphStateDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.url = data["url"];
            this.id = data["id"];
        }
    };
    SystemGraphStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SystemGraphStateDto();
        result.init(data);
        return result;
    };
    SystemGraphStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["url"] = this.url;
        data["id"] = this.id;
        return data;
    };
    return SystemGraphStateDto;
}());
export { SystemGraphStateDto };
var ImportIntoConfigureGalleryDto = /** @class */ (function () {
    function ImportIntoConfigureGalleryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportIntoConfigureGalleryDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.name = data["name"];
            this.categoryId = data["categoryId"];
            this.graphId = data["graphId"];
        }
    };
    ImportIntoConfigureGalleryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportIntoConfigureGalleryDto();
        result.init(data);
        return result;
    };
    ImportIntoConfigureGalleryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["graphId"] = this.graphId;
        return data;
    };
    return ImportIntoConfigureGalleryDto;
}());
export { ImportIntoConfigureGalleryDto };
/** 表格数据收藏编辑Dto */
var TableDataFavoriteEditDto = /** @class */ (function () {
    function TableDataFavoriteEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TableDataFavoriteEditDto.prototype.init = function (data) {
        if (data) {
            this.objectId = data["objectId"];
            this.objectType = data["objectType"];
        }
    };
    TableDataFavoriteEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TableDataFavoriteEditDto();
        result.init(data);
        return result;
    };
    TableDataFavoriteEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        return data;
    };
    return TableDataFavoriteEditDto;
}());
export { TableDataFavoriteEditDto };
var TableDataFavorite = /** @class */ (function () {
    function TableDataFavorite(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TableDataFavorite.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.objectId = data["objectId"];
            this.objectType = data["objectType"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    TableDataFavorite.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TableDataFavorite();
        result.init(data);
        return result;
    };
    TableDataFavorite.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return TableDataFavorite;
}());
export { TableDataFavorite };
var AddTableUserFilterInDto = /** @class */ (function () {
    function AddTableUserFilterInDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddTableUserFilterInDto.prototype.init = function (data) {
        if (data) {
            this.pageName = data["pageName"];
            this.filterName = data["filterName"];
            this.filterData = data["filterData"];
        }
    };
    AddTableUserFilterInDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddTableUserFilterInDto();
        result.init(data);
        return result;
    };
    AddTableUserFilterInDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pageName"] = this.pageName;
        data["filterName"] = this.filterName;
        data["filterData"] = this.filterData;
        return data;
    };
    return AddTableUserFilterInDto;
}());
export { AddTableUserFilterInDto };
var QueryTableUserFilterListInDto = /** @class */ (function () {
    function QueryTableUserFilterListInDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QueryTableUserFilterListInDto.prototype.init = function (data) {
        if (data) {
            this.pageName = data["pageName"];
        }
    };
    QueryTableUserFilterListInDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QueryTableUserFilterListInDto();
        result.init(data);
        return result;
    };
    QueryTableUserFilterListInDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pageName"] = this.pageName;
        return data;
    };
    return QueryTableUserFilterListInDto;
}());
export { QueryTableUserFilterListInDto };
var TableUserFilterDto = /** @class */ (function () {
    function TableUserFilterDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TableUserFilterDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.pageName = data["pageName"];
            this.filterName = data["filterName"];
            this.filterData = data["filterData"];
        }
    };
    TableUserFilterDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TableUserFilterDto();
        result.init(data);
        return result;
    };
    TableUserFilterDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageName"] = this.pageName;
        data["filterName"] = this.filterName;
        data["filterData"] = this.filterData;
        return data;
    };
    return TableUserFilterDto;
}());
export { TableUserFilterDto };
var PagedResultDtoOfTenantListDto = /** @class */ (function () {
    function PagedResultDtoOfTenantListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfTenantListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(TenantListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfTenantListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfTenantListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfTenantListDto;
}());
export { PagedResultDtoOfTenantListDto };
var TenantListDto = /** @class */ (function () {
    function TenantListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantListDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.customerLinkman = data["customerLinkman"];
            this.customerPhone = data["customerPhone"];
            this.enterpriseType = data["enterpriseType"];
            this.industryType = data["industryType"];
            this.deviceScale = data["deviceScale"];
            this.afterSales = data["afterSales"];
            this.applicantRole = data["applicantRole"];
            this.applicantName = data["applicantName"];
            this.applicantPhone = data["applicantPhone"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.customerNote = data["customerNote"];
            this.activationCount = data["activationCount"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    TenantListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantListDto();
        result.init(data);
        return result;
    };
    TenantListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["customerLinkman"] = this.customerLinkman;
        data["customerPhone"] = this.customerPhone;
        data["enterpriseType"] = this.enterpriseType;
        data["industryType"] = this.industryType;
        data["deviceScale"] = this.deviceScale;
        data["afterSales"] = this.afterSales;
        data["applicantRole"] = this.applicantRole;
        data["applicantName"] = this.applicantName;
        data["applicantPhone"] = this.applicantPhone;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customerNote"] = this.customerNote;
        data["activationCount"] = this.activationCount;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return TenantListDto;
}());
export { TenantListDto };
var CreateTenantInput = /** @class */ (function () {
    function CreateTenantInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTenantInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.customerLinkman = data["customerLinkman"];
            this.customerPhone = data["customerPhone"];
            this.customerNote = data["customerNote"];
        }
    };
    CreateTenantInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTenantInput();
        result.init(data);
        return result;
    };
    CreateTenantInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customerLinkman"] = this.customerLinkman;
        data["customerPhone"] = this.customerPhone;
        data["customerNote"] = this.customerNote;
        return data;
    };
    return CreateTenantInput;
}());
export { CreateTenantInput };
var TenantEditDto = /** @class */ (function () {
    function TenantEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEditDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.customerLinkman = data["customerLinkman"];
            this.customerPhone = data["customerPhone"];
            this.customerNote = data["customerNote"];
            this.id = data["id"];
        }
    };
    TenantEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEditDto();
        result.init(data);
        return result;
    };
    TenantEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customerLinkman"] = this.customerLinkman;
        data["customerPhone"] = this.customerPhone;
        data["customerNote"] = this.customerNote;
        data["id"] = this.id;
        return data;
    };
    return TenantEditDto;
}());
export { TenantEditDto };
var GetTenantFeaturesEditOutput = /** @class */ (function () {
    function GetTenantFeaturesEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetTenantFeaturesEditOutput.prototype.init = function (data) {
        if (data) {
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (var _b = 0, _c = data["features"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.features.push(FlatFeatureDto.fromJS(item));
                }
            }
        }
    };
    GetTenantFeaturesEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    };
    GetTenantFeaturesEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (var _b = 0, _c = this.features; _b < _c.length; _b++) {
                var item = _c[_b];
                data["features"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetTenantFeaturesEditOutput;
}());
export { GetTenantFeaturesEditOutput };
var UpdateTenantFeaturesInput = /** @class */ (function () {
    function UpdateTenantFeaturesInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }
    UpdateTenantFeaturesInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    UpdateTenantFeaturesInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    };
    UpdateTenantFeaturesInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateTenantFeaturesInput;
}());
export { UpdateTenantFeaturesInput };
var TenantOrHostNameInput = /** @class */ (function () {
    function TenantOrHostNameInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantOrHostNameInput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    TenantOrHostNameInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantOrHostNameInput();
        result.init(data);
        return result;
    };
    TenantOrHostNameInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return TenantOrHostNameInput;
}());
export { TenantOrHostNameInput };
var IListResultOfString = /** @class */ (function () {
    function IListResultOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfString.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(item);
                }
            }
        }
    };
    IListResultOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfString();
        result.init(data);
        return result;
    };
    IListResultOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item);
            }
        }
        return data;
    };
    return IListResultOfString;
}());
export { IListResultOfString };
var GetMemberActivityOutput = /** @class */ (function () {
    function GetMemberActivityOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMemberActivityOutput.prototype.init = function (data) {
        if (data) {
            if (data["memberActivities"] && data["memberActivities"].constructor === Array) {
                this.memberActivities = [];
                for (var _i = 0, _a = data["memberActivities"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.memberActivities.push(MemberActivity.fromJS(item));
                }
            }
        }
    };
    GetMemberActivityOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    };
    GetMemberActivityOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.memberActivities && this.memberActivities.constructor === Array) {
            data["memberActivities"] = [];
            for (var _i = 0, _a = this.memberActivities; _i < _a.length; _i++) {
                var item = _a[_i];
                data["memberActivities"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetMemberActivityOutput;
}());
export { GetMemberActivityOutput };
var MemberActivity = /** @class */ (function () {
    function MemberActivity(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberActivity.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    };
    MemberActivity.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MemberActivity();
        result.init(data);
        return result;
    };
    MemberActivity.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    };
    return MemberActivity;
}());
export { MemberActivity };
var GetDashboardDataOutput = /** @class */ (function () {
    function GetDashboardDataOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDashboardDataOutput.prototype.init = function (data) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (var _i = 0, _a = data["salesSummary"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
                }
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (data["dailySales"] && data["dailySales"].constructor === Array) {
                this.dailySales = [];
                for (var _b = 0, _c = data["dailySales"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.dailySales.push(item);
                }
            }
            if (data["profitShares"] && data["profitShares"].constructor === Array) {
                this.profitShares = [];
                for (var _d = 0, _e = data["profitShares"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.profitShares.push(item);
                }
            }
        }
    };
    GetDashboardDataOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    };
    GetDashboardDataOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (var _i = 0, _a = this.salesSummary; _i < _a.length; _i++) {
                var item = _a[_i];
                data["salesSummary"].push(item.toJSON());
            }
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (this.dailySales && this.dailySales.constructor === Array) {
            data["dailySales"] = [];
            for (var _b = 0, _c = this.dailySales; _b < _c.length; _b++) {
                var item = _c[_b];
                data["dailySales"].push(item);
            }
        }
        if (this.profitShares && this.profitShares.constructor === Array) {
            data["profitShares"] = [];
            for (var _d = 0, _e = this.profitShares; _d < _e.length; _d++) {
                var item = _e[_d];
                data["profitShares"].push(item);
            }
        }
        return data;
    };
    return GetDashboardDataOutput;
}());
export { GetDashboardDataOutput };
var SalesSummaryData = /** @class */ (function () {
    function SalesSummaryData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SalesSummaryData.prototype.init = function (data) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    };
    SalesSummaryData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SalesSummaryData();
        result.init(data);
        return result;
    };
    SalesSummaryData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    };
    return SalesSummaryData;
}());
export { SalesSummaryData };
var GetSalesSummaryOutput = /** @class */ (function () {
    function GetSalesSummaryOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetSalesSummaryOutput.prototype.init = function (data) {
        if (data) {
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (var _i = 0, _a = data["salesSummary"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
                }
            }
        }
    };
    GetSalesSummaryOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    };
    GetSalesSummaryOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (var _i = 0, _a = this.salesSummary; _i < _a.length; _i++) {
                var item = _a[_i];
                data["salesSummary"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetSalesSummaryOutput;
}());
export { GetSalesSummaryOutput };
var GetRegionalStatsOutput = /** @class */ (function () {
    function GetRegionalStatsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetRegionalStatsOutput.prototype.init = function (data) {
        if (data) {
            if (data["stats"] && data["stats"].constructor === Array) {
                this.stats = [];
                for (var _i = 0, _a = data["stats"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.stats.push(RegionalStatCountry.fromJS(item));
                }
            }
        }
    };
    GetRegionalStatsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    };
    GetRegionalStatsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.stats && this.stats.constructor === Array) {
            data["stats"] = [];
            for (var _i = 0, _a = this.stats; _i < _a.length; _i++) {
                var item = _a[_i];
                data["stats"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetRegionalStatsOutput;
}());
export { GetRegionalStatsOutput };
var RegionalStatCountry = /** @class */ (function () {
    function RegionalStatCountry(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegionalStatCountry.prototype.init = function (data) {
        if (data) {
            this.countryName = data["countryName"];
            this.sales = data["sales"];
            if (data["change"] && data["change"].constructor === Array) {
                this.change = [];
                for (var _i = 0, _a = data["change"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.change.push(item);
                }
            }
            this.averagePrice = data["averagePrice"];
            this.totalPrice = data["totalPrice"];
        }
    };
    RegionalStatCountry.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegionalStatCountry();
        result.init(data);
        return result;
    };
    RegionalStatCountry.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (this.change && this.change.constructor === Array) {
            data["change"] = [];
            for (var _i = 0, _a = this.change; _i < _a.length; _i++) {
                var item = _a[_i];
                data["change"].push(item);
            }
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    };
    return RegionalStatCountry;
}());
export { RegionalStatCountry };
var GetGeneralStatsOutput = /** @class */ (function () {
    function GetGeneralStatsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetGeneralStatsOutput.prototype.init = function (data) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    };
    GetGeneralStatsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    };
    GetGeneralStatsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    };
    return GetGeneralStatsOutput;
}());
export { GetGeneralStatsOutput };
/** 注册租户DTO */
var CreateOrUpdateTenantRegistDto = /** @class */ (function () {
    function CreateOrUpdateTenantRegistDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateTenantRegistDto.prototype.init = function (data) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.blnRegistrationMethod = data["blnRegistrationMethod"];
            this.mobilePhone = data["mobilePhone"];
            this.email = data["email"];
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
            this.companyName = data["companyName"];
            this.contactName = data["contactName"];
            this.contactMobileNumber = data["contactMobileNumber"];
            this.approvalStatus = data["approvalStatus"];
            this.rejectReason = data["rejectReason"];
            this.remarks = data["remarks"];
        }
    };
    CreateOrUpdateTenantRegistDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateTenantRegistDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateTenantRegistDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["blnRegistrationMethod"] = this.blnRegistrationMethod;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["contactMobileNumber"] = this.contactMobileNumber;
        data["approvalStatus"] = this.approvalStatus;
        data["rejectReason"] = this.rejectReason;
        data["remarks"] = this.remarks;
        return data;
    };
    return CreateOrUpdateTenantRegistDto;
}());
export { CreateOrUpdateTenantRegistDto };
var PagedResultDtoOfTenantRegistration = /** @class */ (function () {
    function PagedResultDtoOfTenantRegistration(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfTenantRegistration.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(TenantRegistration.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfTenantRegistration.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfTenantRegistration();
        result.init(data);
        return result;
    };
    PagedResultDtoOfTenantRegistration.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfTenantRegistration;
}());
export { PagedResultDtoOfTenantRegistration };
var TenantRegistration = /** @class */ (function () {
    function TenantRegistration(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantRegistration.prototype.init = function (data) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.blnRegistrationMethod = data["blnRegistrationMethod"];
            this.mobilePhone = data["mobilePhone"];
            this.email = data["email"];
            this.password = data["password"];
            this.companyName = data["companyName"];
            this.contactName = data["contactName"];
            this.contactMobileNumber = data["contactMobileNumber"];
            this.approvalStatus = data["approvalStatus"];
            this.rejectReason = data["rejectReason"];
            this.remarks = data["remarks"];
            this.approvalTime = data["approvalTime"] ? moment(data["approvalTime"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    TenantRegistration.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantRegistration();
        result.init(data);
        return result;
    };
    TenantRegistration.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["blnRegistrationMethod"] = this.blnRegistrationMethod;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["password"] = this.password;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["contactMobileNumber"] = this.contactMobileNumber;
        data["approvalStatus"] = this.approvalStatus;
        data["rejectReason"] = this.rejectReason;
        data["remarks"] = this.remarks;
        data["approvalTime"] = this.approvalTime ? this.approvalTime.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return TenantRegistration;
}());
export { TenantRegistration };
var ApprovedInDto = /** @class */ (function () {
    function ApprovedInDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.idList = [];
        }
    }
    ApprovedInDto.prototype.init = function (data) {
        if (data) {
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [];
                for (var _i = 0, _a = data["idList"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.idList.push(item);
                }
            }
            this.remarks = data["remarks"];
        }
    };
    ApprovedInDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApprovedInDto();
        result.init(data);
        return result;
    };
    ApprovedInDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (var _i = 0, _a = this.idList; _i < _a.length; _i++) {
                var item = _a[_i];
                data["idList"].push(item);
            }
        }
        data["remarks"] = this.remarks;
        return data;
    };
    return ApprovedInDto;
}());
export { ApprovedInDto };
var RejectInDto = /** @class */ (function () {
    function RejectInDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.idList = [];
        }
    }
    RejectInDto.prototype.init = function (data) {
        if (data) {
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [];
                for (var _i = 0, _a = data["idList"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.idList.push(item);
                }
            }
            this.rejectReason = data["rejectReason"];
            this.remarks = data["remarks"];
        }
    };
    RejectInDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RejectInDto();
        result.init(data);
        return result;
    };
    RejectInDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (var _i = 0, _a = this.idList; _i < _a.length; _i++) {
                var item = _a[_i];
                data["idList"].push(item);
            }
        }
        data["rejectReason"] = this.rejectReason;
        data["remarks"] = this.remarks;
        return data;
    };
    return RejectInDto;
}());
export { RejectInDto };
/** 发送验证码DTO */
var VerificationCodeDto = /** @class */ (function () {
    function VerificationCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerificationCodeDto.prototype.init = function (data) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.blnRegistrationMethod = data["blnRegistrationMethod"];
            this.mobilePhone = data["mobilePhone"];
            this.email = data["email"];
            this.verificationCode = data["verificationCode"];
        }
    };
    VerificationCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerificationCodeDto();
        result.init(data);
        return result;
    };
    VerificationCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["blnRegistrationMethod"] = this.blnRegistrationMethod;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["verificationCode"] = this.verificationCode;
        return data;
    };
    return VerificationCodeDto;
}());
export { VerificationCodeDto };
/** 租户名称DTO */
var TenantNameDto = /** @class */ (function () {
    function TenantNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantNameDto.prototype.init = function (data) {
        if (data) {
            this.tenantName = data["tenantName"];
        }
    };
    TenantNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantNameDto();
        result.init(data);
        return result;
    };
    TenantNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        return data;
    };
    return TenantNameDto;
}());
export { TenantNameDto };
var RegisterTenantInput = /** @class */ (function () {
    function RegisterTenantInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterTenantInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.gateway = data["gateway"];
            this.editionId = data["editionId"];
            this.paymentId = data["paymentId"];
        }
    };
    RegisterTenantInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterTenantInput();
        result.init(data);
        return result;
    };
    RegisterTenantInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["gateway"] = this.gateway;
        data["editionId"] = this.editionId;
        data["paymentId"] = this.paymentId;
        return data;
    };
    return RegisterTenantInput;
}());
export { RegisterTenantInput };
var RegisterTenantOutput = /** @class */ (function () {
    function RegisterTenantOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterTenantOutput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    };
    RegisterTenantOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterTenantOutput();
        result.init(data);
        return result;
    };
    RegisterTenantOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    };
    return RegisterTenantOutput;
}());
export { RegisterTenantOutput };
var EditionsSelectOutput = /** @class */ (function () {
    function EditionsSelectOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionsSelectOutput.prototype.init = function (data) {
        if (data) {
            if (data["allFeatures"] && data["allFeatures"].constructor === Array) {
                this.allFeatures = [];
                for (var _i = 0, _a = data["allFeatures"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
                }
            }
            if (data["editionsWithFeatures"] && data["editionsWithFeatures"].constructor === Array) {
                this.editionsWithFeatures = [];
                for (var _b = 0, _c = data["editionsWithFeatures"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
                }
            }
            this.tenantEditionId = data["tenantEditionId"];
        }
    };
    EditionsSelectOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionsSelectOutput();
        result.init(data);
        return result;
    };
    EditionsSelectOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures && this.allFeatures.constructor === Array) {
            data["allFeatures"] = [];
            for (var _i = 0, _a = this.allFeatures; _i < _a.length; _i++) {
                var item = _a[_i];
                data["allFeatures"].push(item.toJSON());
            }
        }
        if (this.editionsWithFeatures && this.editionsWithFeatures.constructor === Array) {
            data["editionsWithFeatures"] = [];
            for (var _b = 0, _c = this.editionsWithFeatures; _b < _c.length; _b++) {
                var item = _c[_b];
                data["editionsWithFeatures"].push(item.toJSON());
            }
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data;
    };
    return EditionsSelectOutput;
}());
export { EditionsSelectOutput };
var FlatFeatureSelectDto = /** @class */ (function () {
    function FlatFeatureSelectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatFeatureSelectDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    };
    FlatFeatureSelectDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    };
    FlatFeatureSelectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    };
    return FlatFeatureSelectDto;
}());
export { FlatFeatureSelectDto };
var EditionWithFeaturesDto = /** @class */ (function () {
    function EditionWithFeaturesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionWithFeaturesDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    EditionWithFeaturesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    };
    EditionWithFeaturesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        return data;
    };
    return EditionWithFeaturesDto;
}());
export { EditionWithFeaturesDto };
var IInputType = /** @class */ (function () {
    function IInputType(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IInputType.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : undefined;
        }
    };
    IInputType.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IInputType();
        result.init(data);
        return result;
    };
    IInputType.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        return data;
    };
    return IInputType;
}());
export { IInputType };
var TenantSettingsEditDto = /** @class */ (function () {
    function TenantSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }
    TenantSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : undefined;
            this.personalization = data["personalization"] ? TenantPersonalizationEditDto.fromJS(data["personalization"]) : undefined;
        }
    };
    TenantSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined;
        data["email"] = this.email ? this.email.toJSON() : undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : undefined;
        data["security"] = this.security ? this.security.toJSON() : undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined;
        data["personalization"] = this.personalization ? this.personalization.toJSON() : undefined;
        return data;
    };
    return TenantSettingsEditDto;
}());
export { TenantSettingsEditDto };
var TenantUserManagementSettingsEditDto = /** @class */ (function () {
    function TenantUserManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantUserManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailOrPhoneConfirmationRequiredForLogin = data["isEmailOrPhoneConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.displayMode = data["displayMode"];
            this.isMapDisplayThumbnail = data["isMapDisplayThumbnail"];
            this.isDisplayFriendshipLink = data["isDisplayFriendshipLink"];
            this.friendshipLinkName = data["friendshipLinkName"];
            this.friendshipLinkAddress = data["friendshipLinkAddress"];
            this.isEnabledDemonstrationSystem = data["isEnabledDemonstrationSystem"];
            this.isSettingDemonstrationSystem = data["isSettingDemonstrationSystem"];
        }
    };
    TenantUserManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantUserManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailOrPhoneConfirmationRequiredForLogin"] = this.isEmailOrPhoneConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["displayMode"] = this.displayMode;
        data["isMapDisplayThumbnail"] = this.isMapDisplayThumbnail;
        data["isDisplayFriendshipLink"] = this.isDisplayFriendshipLink;
        data["friendshipLinkName"] = this.friendshipLinkName;
        data["friendshipLinkAddress"] = this.friendshipLinkAddress;
        data["isEnabledDemonstrationSystem"] = this.isEnabledDemonstrationSystem;
        data["isSettingDemonstrationSystem"] = this.isSettingDemonstrationSystem;
        return data;
    };
    return TenantUserManagementSettingsEditDto;
}());
export { TenantUserManagementSettingsEditDto };
var LdapSettingsEditDto = /** @class */ (function () {
    function LdapSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LdapSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    };
    LdapSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    };
    LdapSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    };
    return LdapSettingsEditDto;
}());
export { LdapSettingsEditDto };
var TenantBillingSettingsEditDto = /** @class */ (function () {
    function TenantBillingSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantBillingSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    };
    TenantBillingSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantBillingSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    };
    return TenantBillingSettingsEditDto;
}());
export { TenantBillingSettingsEditDto };
var TenantPersonalizationEditDto = /** @class */ (function () {
    function TenantPersonalizationEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantPersonalizationEditDto.prototype.init = function (data) {
        if (data) {
            this.loginPageDisplayName = data["loginPageDisplayName"];
        }
    };
    TenantPersonalizationEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantPersonalizationEditDto();
        result.init(data);
        return result;
    };
    TenantPersonalizationEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["loginPageDisplayName"] = this.loginPageDisplayName;
        return data;
    };
    return TenantPersonalizationEditDto;
}());
export { TenantPersonalizationEditDto };
var CreateThumbnailDto = /** @class */ (function () {
    function CreateThumbnailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateThumbnailDto.prototype.init = function (data) {
        if (data) {
            if (data["deviceIds"] && data["deviceIds"].constructor === Array) {
                this.deviceIds = [];
                for (var _i = 0, _a = data["deviceIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.deviceIds.push(item);
                }
            }
            this.thumbnailGroupId = data["thumbnailGroupId"];
        }
    };
    CreateThumbnailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateThumbnailDto();
        result.init(data);
        return result;
    };
    CreateThumbnailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceIds && this.deviceIds.constructor === Array) {
            data["deviceIds"] = [];
            for (var _i = 0, _a = this.deviceIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["deviceIds"].push(item);
            }
        }
        data["thumbnailGroupId"] = this.thumbnailGroupId;
        return data;
    };
    return CreateThumbnailDto;
}());
export { CreateThumbnailDto };
var ListResultDtoOfDeviceThumbnailDto = /** @class */ (function () {
    function ListResultDtoOfDeviceThumbnailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeviceThumbnailDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeviceThumbnailDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeviceThumbnailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeviceThumbnailDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeviceThumbnailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeviceThumbnailDto;
}());
export { ListResultDtoOfDeviceThumbnailDto };
var PagedResultDtoOfThumbnailUnAssignedDeviceModelDto = /** @class */ (function () {
    function PagedResultDtoOfThumbnailUnAssignedDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfThumbnailUnAssignedDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ThumbnailUnAssignedDeviceModelDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfThumbnailUnAssignedDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfThumbnailUnAssignedDeviceModelDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfThumbnailUnAssignedDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfThumbnailUnAssignedDeviceModelDto;
}());
export { PagedResultDtoOfThumbnailUnAssignedDeviceModelDto };
var ThumbnailUnAssignedDeviceModelDto = /** @class */ (function () {
    function ThumbnailUnAssignedDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThumbnailUnAssignedDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.serialNumber = data["serialNumber"];
            this.deviceModel = data["deviceModel"] ? DeviceModelNameDto.fromJS(data["deviceModel"]) : undefined;
            this.id = data["id"];
        }
    };
    ThumbnailUnAssignedDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThumbnailUnAssignedDeviceModelDto();
        result.init(data);
        return result;
    };
    ThumbnailUnAssignedDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return ThumbnailUnAssignedDeviceModelDto;
}());
export { ThumbnailUnAssignedDeviceModelDto };
var ListResultDtoOfUnAssignedDeviceModelDto = /** @class */ (function () {
    function ListResultDtoOfUnAssignedDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfUnAssignedDeviceModelDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UnAssignedDeviceModelDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfUnAssignedDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfUnAssignedDeviceModelDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfUnAssignedDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfUnAssignedDeviceModelDto;
}());
export { ListResultDtoOfUnAssignedDeviceModelDto };
var UnAssignedDeviceModelDto = /** @class */ (function () {
    function UnAssignedDeviceModelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnAssignedDeviceModelDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    UnAssignedDeviceModelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnAssignedDeviceModelDto();
        result.init(data);
        return result;
    };
    UnAssignedDeviceModelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return UnAssignedDeviceModelDto;
}());
export { UnAssignedDeviceModelDto };
var CreateOrUpdateThumbnailGroupDto = /** @class */ (function () {
    function CreateOrUpdateThumbnailGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateThumbnailGroupDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateThumbnailGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateThumbnailGroupDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateThumbnailGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateThumbnailGroupDto;
}());
export { CreateOrUpdateThumbnailGroupDto };
var ListResultDtoOfThumbnailGroupListDto = /** @class */ (function () {
    function ListResultDtoOfThumbnailGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfThumbnailGroupListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ThumbnailGroupListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfThumbnailGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfThumbnailGroupListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfThumbnailGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfThumbnailGroupListDto;
}());
export { ListResultDtoOfThumbnailGroupListDto };
var ThumbnailGroupListDto = /** @class */ (function () {
    function ThumbnailGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThumbnailGroupListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    ThumbnailGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThumbnailGroupListDto();
        result.init(data);
        return result;
    };
    ThumbnailGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return ThumbnailGroupListDto;
}());
export { ThumbnailGroupListDto };
var ThumbnailGroupEditDto = /** @class */ (function () {
    function ThumbnailGroupEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThumbnailGroupEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    ThumbnailGroupEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThumbnailGroupEditDto();
        result.init(data);
        return result;
    };
    ThumbnailGroupEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return ThumbnailGroupEditDto;
}());
export { ThumbnailGroupEditDto };
var ListResultDtoOfNameValueDto = /** @class */ (function () {
    function ListResultDtoOfNameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfNameValueDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfNameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfNameValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfNameValueDto;
}());
export { ListResultDtoOfNameValueDto };
var DemonstrationSystemApiGetAccessCodeResult = /** @class */ (function () {
    function DemonstrationSystemApiGetAccessCodeResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DemonstrationSystemApiGetAccessCodeResult.prototype.init = function (data) {
        if (data) {
            this.returnUrl = data["returnUrl"];
            this.status = data["status"];
            this.accessCode = data["accessCode"];
            this.detail = data["detail"] ? AuthenticateResultModel.fromJS(data["detail"]) : undefined;
            this.errorMessage = data["errorMessage"];
        }
    };
    DemonstrationSystemApiGetAccessCodeResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DemonstrationSystemApiGetAccessCodeResult();
        result.init(data);
        return result;
    };
    DemonstrationSystemApiGetAccessCodeResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["returnUrl"] = this.returnUrl;
        data["status"] = this.status;
        data["accessCode"] = this.accessCode;
        data["detail"] = this.detail ? this.detail.toJSON() : undefined;
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return DemonstrationSystemApiGetAccessCodeResult;
}());
export { DemonstrationSystemApiGetAccessCodeResult };
var AuthenticateResultModel = /** @class */ (function () {
    function AuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                for (var _i = 0, _a = data["twoFactorAuthProviders"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.twoFactorAuthProviders.push(item);
                }
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
            this.requiresTwoFactorConfirmation = data["requiresTwoFactorConfirmation"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    AuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthenticateResultModel();
        result.init(data);
        return result;
    };
    AuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            for (var _i = 0, _a = this.twoFactorAuthProviders; _i < _a.length; _i++) {
                var item = _a[_i];
                data["twoFactorAuthProviders"].push(item);
            }
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["requiresTwoFactorConfirmation"] = this.requiresTwoFactorConfirmation;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return AuthenticateResultModel;
}());
export { AuthenticateResultModel };
var AuthenticateModel = /** @class */ (function () {
    function AuthenticateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateModel.prototype.init = function (data) {
        if (data) {
            this.userNameOrEmailAddressOrPhoneNumber = data["userNameOrEmailAddressOrPhoneNumber"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.twoFactorConfirmationCode = data["twoFactorConfirmationCode"];
            this.confirmationType = data["confirmationType"];
            this.emailOrPhone = data["emailOrPhone"];
            this.requestFromConfirmation = data["requestFromConfirmation"];
        }
    };
    AuthenticateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthenticateModel();
        result.init(data);
        return result;
    };
    AuthenticateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddressOrPhoneNumber"] = this.userNameOrEmailAddressOrPhoneNumber;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["twoFactorConfirmationCode"] = this.twoFactorConfirmationCode;
        data["confirmationType"] = this.confirmationType;
        data["emailOrPhone"] = this.emailOrPhone;
        data["requestFromConfirmation"] = this.requestFromConfirmation;
        return data;
    };
    return AuthenticateModel;
}());
export { AuthenticateModel };
var ApiGetAccessCodeModel = /** @class */ (function () {
    function ApiGetAccessCodeModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiGetAccessCodeModel.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    };
    ApiGetAccessCodeModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiGetAccessCodeModel();
        result.init(data);
        return result;
    };
    ApiGetAccessCodeModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    };
    return ApiGetAccessCodeModel;
}());
export { ApiGetAccessCodeModel };
var ApiGetAccessCodeResult = /** @class */ (function () {
    function ApiGetAccessCodeResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiGetAccessCodeResult.prototype.init = function (data) {
        if (data) {
            this.status = data["status"];
            this.accessCode = data["accessCode"];
            this.detail = data["detail"] ? AuthenticateResultModel.fromJS(data["detail"]) : undefined;
            this.errorMessage = data["errorMessage"];
        }
    };
    ApiGetAccessCodeResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiGetAccessCodeResult();
        result.init(data);
        return result;
    };
    ApiGetAccessCodeResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["accessCode"] = this.accessCode;
        data["detail"] = this.detail ? this.detail.toJSON() : undefined;
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return ApiGetAccessCodeResult;
}());
export { ApiGetAccessCodeResult };
var ApiAuthenticateResult = /** @class */ (function () {
    function ApiAuthenticateResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiAuthenticateResult.prototype.init = function (data) {
        if (data) {
            this.status = data["status"];
            this.result = data["result"] ? AuthenticateResultModel.fromJS(data["result"]) : undefined;
            this.errorMessage = data["errorMessage"];
        }
    };
    ApiAuthenticateResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiAuthenticateResult();
        result.init(data);
        return result;
    };
    ApiAuthenticateResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["result"] = this.result ? this.result.toJSON() : undefined;
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return ApiAuthenticateResult;
}());
export { ApiAuthenticateResult };
var SendTwoFactorConfirmationCodeModel = /** @class */ (function () {
    function SendTwoFactorConfirmationCodeModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendTwoFactorConfirmationCodeModel.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationType = data["confirmationType"];
            this.emailOrPhone = data["emailOrPhone"];
        }
    };
    SendTwoFactorConfirmationCodeModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendTwoFactorConfirmationCodeModel();
        result.init(data);
        return result;
    };
    SendTwoFactorConfirmationCodeModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationType"] = this.confirmationType;
        data["emailOrPhone"] = this.emailOrPhone;
        return data;
    };
    return SendTwoFactorConfirmationCodeModel;
}());
export { SendTwoFactorConfirmationCodeModel };
var SendTwoFactorAuthCodeModel = /** @class */ (function () {
    function SendTwoFactorAuthCodeModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendTwoFactorAuthCodeModel.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    };
    SendTwoFactorAuthCodeModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    };
    SendTwoFactorAuthCodeModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    };
    return SendTwoFactorAuthCodeModel;
}());
export { SendTwoFactorAuthCodeModel };
var ImpersonatedAuthenticateResultModel = /** @class */ (function () {
    function ImpersonatedAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonatedAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    };
    ImpersonatedAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    };
    ImpersonatedAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    };
    return ImpersonatedAuthenticateResultModel;
}());
export { ImpersonatedAuthenticateResultModel };
var SwitchedAccountAuthenticateResultModel = /** @class */ (function () {
    function SwitchedAccountAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchedAccountAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    };
    SwitchedAccountAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    };
    SwitchedAccountAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    };
    return SwitchedAccountAuthenticateResultModel;
}());
export { SwitchedAccountAuthenticateResultModel };
var ExternalLoginProviderInfoModel = /** @class */ (function () {
    function ExternalLoginProviderInfoModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalLoginProviderInfoModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
        }
    };
    ExternalLoginProviderInfoModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    };
    ExternalLoginProviderInfoModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    };
    return ExternalLoginProviderInfoModel;
}());
export { ExternalLoginProviderInfoModel };
var ExternalAuthenticateModel = /** @class */ (function () {
    function ExternalAuthenticateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticateModel.prototype.init = function (data) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    };
    ExternalAuthenticateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    };
    ExternalAuthenticateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    };
    return ExternalAuthenticateModel;
}());
export { ExternalAuthenticateModel };
var ExternalAuthenticateResultModel = /** @class */ (function () {
    function ExternalAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
        }
    };
    ExternalAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    };
    ExternalAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data;
    };
    return ExternalAuthenticateResultModel;
}());
export { ExternalAuthenticateResultModel };
var UiCustomizationSettingsEditDto = /** @class */ (function () {
    function UiCustomizationSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UiCustomizationSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.layout = data["layout"] ? UiCustomizationLayoutSettingsEditDto.fromJS(data["layout"]) : undefined;
            this.header = data["header"] ? UiCustomizationHeaderSettingsEditDto.fromJS(data["header"]) : undefined;
            this.menu = data["menu"] ? UiCustomizationMenuSettingsEditDto.fromJS(data["menu"]) : undefined;
            this.footer = data["footer"] ? UiCustomizationFooterSettingsEditDto.fromJS(data["footer"]) : undefined;
        }
    };
    UiCustomizationSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UiCustomizationSettingsEditDto();
        result.init(data);
        return result;
    };
    UiCustomizationSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout ? this.layout.toJSON() : undefined;
        data["header"] = this.header ? this.header.toJSON() : undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : undefined;
        return data;
    };
    return UiCustomizationSettingsEditDto;
}());
export { UiCustomizationSettingsEditDto };
var UiCustomizationLayoutSettingsEditDto = /** @class */ (function () {
    function UiCustomizationLayoutSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UiCustomizationLayoutSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.layoutType = data["layoutType"];
            this.contentSkin = data["contentSkin"];
            this.theme = data["theme"];
        }
    };
    UiCustomizationLayoutSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UiCustomizationLayoutSettingsEditDto();
        result.init(data);
        return result;
    };
    UiCustomizationLayoutSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["contentSkin"] = this.contentSkin;
        data["theme"] = this.theme;
        return data;
    };
    return UiCustomizationLayoutSettingsEditDto;
}());
export { UiCustomizationLayoutSettingsEditDto };
var UiCustomizationHeaderSettingsEditDto = /** @class */ (function () {
    function UiCustomizationHeaderSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UiCustomizationHeaderSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.desktopMinimizeMode = data["desktopMinimizeMode"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.headerSkin = data["headerSkin"];
            this.displaySubmenuArrowDesktop = data["displaySubmenuArrowDesktop"];
        }
    };
    UiCustomizationHeaderSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UiCustomizationHeaderSettingsEditDto();
        result.init(data);
        return result;
    };
    UiCustomizationHeaderSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["desktopMinimizeMode"] = this.desktopMinimizeMode;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["displaySubmenuArrowDesktop"] = this.displaySubmenuArrowDesktop;
        return data;
    };
    return UiCustomizationHeaderSettingsEditDto;
}());
export { UiCustomizationHeaderSettingsEditDto };
var UiCustomizationMenuSettingsEditDto = /** @class */ (function () {
    function UiCustomizationMenuSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UiCustomizationMenuSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.allowAsideHiding = data["allowAsideHiding"];
            this.defaultHiddenAside = data["defaultHiddenAside"];
            this.submenuToggle = data["submenuToggle"];
            this.dropdownSubmenuSkin = data["dropdownSubmenuSkin"];
            this.dropdownSubmenuArrow = data["dropdownSubmenuArrow"];
        }
    };
    UiCustomizationMenuSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UiCustomizationMenuSettingsEditDto();
        result.init(data);
        return result;
    };
    UiCustomizationMenuSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        data["dropdownSubmenuSkin"] = this.dropdownSubmenuSkin;
        data["dropdownSubmenuArrow"] = this.dropdownSubmenuArrow;
        return data;
    };
    return UiCustomizationMenuSettingsEditDto;
}());
export { UiCustomizationMenuSettingsEditDto };
var UiCustomizationFooterSettingsEditDto = /** @class */ (function () {
    function UiCustomizationFooterSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UiCustomizationFooterSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    };
    UiCustomizationFooterSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UiCustomizationFooterSettingsEditDto();
        result.init(data);
        return result;
    };
    UiCustomizationFooterSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    };
    return UiCustomizationFooterSettingsEditDto;
}());
export { UiCustomizationFooterSettingsEditDto };
var GetUsersForPickInput = /** @class */ (function () {
    function GetUsersForPickInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUsersForPickInput.prototype.init = function (data) {
        if (data) {
            this.filter = data["filter"];
            if (data["excludedUserIds"] && data["excludedUserIds"].constructor === Array) {
                this.excludedUserIds = [];
                for (var _i = 0, _a = data["excludedUserIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.excludedUserIds.push(item);
                }
            }
            this.sorting = data["sorting"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    };
    GetUsersForPickInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUsersForPickInput();
        result.init(data);
        return result;
    };
    GetUsersForPickInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (this.excludedUserIds && this.excludedUserIds.constructor === Array) {
            data["excludedUserIds"] = [];
            for (var _i = 0, _a = this.excludedUserIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["excludedUserIds"].push(item);
            }
        }
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    };
    return GetUsersForPickInput;
}());
export { GetUsersForPickInput };
var PagedResultDtoOfUserListForPickDto = /** @class */ (function () {
    function PagedResultDtoOfUserListForPickDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfUserListForPickDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserListForPickDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfUserListForPickDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfUserListForPickDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfUserListForPickDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfUserListForPickDto;
}());
export { PagedResultDtoOfUserListForPickDto };
var UserListForPickDto = /** @class */ (function () {
    function UserListForPickDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListForPickDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.jobNumber = data["jobNumber"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    UserListForPickDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListForPickDto();
        result.init(data);
        return result;
    };
    UserListForPickDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["jobNumber"] = this.jobNumber;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return UserListForPickDto;
}());
export { UserListForPickDto };
var PagedResultDtoOfUserListDto = /** @class */ (function () {
    function PagedResultDtoOfUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfUserListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfUserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfUserListDto;
}());
export { PagedResultDtoOfUserListDto };
var UserListDto = /** @class */ (function () {
    function UserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.jobNumber = data["jobNumber"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.dataPolicy = data["dataPolicy"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _i = 0, _a = data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(UserListRoleDto.fromJS(item));
                }
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.isLocationEnabled = data["isLocationEnabled"];
            this.expireTime = data["expireTime"] ? moment(data["expireTime"].toString()) : undefined;
            this.creatorOrganizationId = data["creatorOrganizationId"];
            this.externalSuperAdmin = data["externalSuperAdmin"];
            this.organizationNames = data["organizationNames"];
            this.id = data["id"];
        }
    };
    UserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListDto();
        result.init(data);
        return result;
    };
    UserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jobNumber"] = this.jobNumber;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["dataPolicy"] = this.dataPolicy;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item.toJSON());
            }
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["isLocationEnabled"] = this.isLocationEnabled;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : undefined;
        data["creatorOrganizationId"] = this.creatorOrganizationId;
        data["externalSuperAdmin"] = this.externalSuperAdmin;
        data["organizationNames"] = this.organizationNames;
        data["id"] = this.id;
        return data;
    };
    return UserListDto;
}());
export { UserListDto };
var UserListRoleDto = /** @class */ (function () {
    function UserListRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListRoleDto.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    };
    UserListRoleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListRoleDto();
        result.init(data);
        return result;
    };
    UserListRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    };
    return UserListRoleDto;
}());
export { UserListRoleDto };
var GetUserForEditOutput = /** @class */ (function () {
    function GetUserForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserForEditOutput.prototype.init = function (data) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _i = 0, _a = data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(UserRoleDto.fromJS(item));
                }
            }
            if (data["selectedOrganizationIds"] && data["selectedOrganizationIds"].constructor === Array) {
                this.selectedOrganizationIds = [];
                for (var _b = 0, _c = data["selectedOrganizationIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.selectedOrganizationIds.push(item);
                }
            }
        }
    };
    GetUserForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserForEditOutput();
        result.init(data);
        return result;
    };
    GetUserForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item.toJSON());
            }
        }
        if (this.selectedOrganizationIds && this.selectedOrganizationIds.constructor === Array) {
            data["selectedOrganizationIds"] = [];
            for (var _b = 0, _c = this.selectedOrganizationIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["selectedOrganizationIds"].push(item);
            }
        }
        return data;
    };
    return GetUserForEditOutput;
}());
export { GetUserForEditOutput };
var UserEditDto = /** @class */ (function () {
    function UserEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.jobNumber = data["jobNumber"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.isLocationEnabled = data["isLocationEnabled"];
            this.dataPolicy = data["dataPolicy"];
            this.expireDays = data["expireDays"];
            this.creatorOrganizationId = data["creatorOrganizationId"];
            this.externalSuperAdmin = data["externalSuperAdmin"];
        }
    };
    UserEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserEditDto();
        result.init(data);
        return result;
    };
    UserEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["jobNumber"] = this.jobNumber;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["isLocationEnabled"] = this.isLocationEnabled;
        data["dataPolicy"] = this.dataPolicy;
        data["expireDays"] = this.expireDays;
        data["creatorOrganizationId"] = this.creatorOrganizationId;
        data["externalSuperAdmin"] = this.externalSuperAdmin;
        return data;
    };
    return UserEditDto;
}());
export { UserEditDto };
var UserRoleDto = /** @class */ (function () {
    function UserRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserRoleDto.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
        }
    };
    UserRoleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserRoleDto();
        result.init(data);
        return result;
    };
    UserRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data;
    };
    return UserRoleDto;
}());
export { UserRoleDto };
var GetUserPermissionsForEditOutput = /** @class */ (function () {
    function GetUserPermissionsForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserPermissionsForEditOutput.prototype.init = function (data) {
        if (data) {
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(FlatPermissionDto.fromJS(item));
                }
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (var _b = 0, _c = data["grantedPermissionNames"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.grantedPermissionNames.push(item);
                }
            }
        }
    };
    GetUserPermissionsForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    };
    GetUserPermissionsForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item.toJSON());
            }
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (var _b = 0, _c = this.grantedPermissionNames; _b < _c.length; _b++) {
                var item = _c[_b];
                data["grantedPermissionNames"].push(item);
            }
        }
        return data;
    };
    return GetUserPermissionsForEditOutput;
}());
export { GetUserPermissionsForEditOutput };
var UpdateUserPermissionsInput = /** @class */ (function () {
    function UpdateUserPermissionsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }
    UpdateUserPermissionsInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (var _i = 0, _a = data["grantedPermissionNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.grantedPermissionNames.push(item);
                }
            }
        }
    };
    UpdateUserPermissionsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    };
    UpdateUserPermissionsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (var _i = 0, _a = this.grantedPermissionNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["grantedPermissionNames"].push(item);
            }
        }
        return data;
    };
    return UpdateUserPermissionsInput;
}());
export { UpdateUserPermissionsInput };
var CreateOrUpdateUserInput = /** @class */ (function () {
    function CreateOrUpdateUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }
    CreateOrUpdateUserInput.prototype.init = function (data) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (data["assignedRoleNames"] && data["assignedRoleNames"].constructor === Array) {
                this.assignedRoleNames = [];
                for (var _i = 0, _a = data["assignedRoleNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.assignedRoleNames.push(item);
                }
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (var _b = 0, _c = data["organizationUnits"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.organizationUnits.push(item);
                }
            }
            this.externalMode = data["externalMode"];
            this.organizationId = data["organizationId"];
        }
    };
    CreateOrUpdateUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (this.assignedRoleNames && this.assignedRoleNames.constructor === Array) {
            data["assignedRoleNames"] = [];
            for (var _i = 0, _a = this.assignedRoleNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["assignedRoleNames"].push(item);
            }
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (var _b = 0, _c = this.organizationUnits; _b < _c.length; _b++) {
                var item = _c[_b];
                data["organizationUnits"].push(item);
            }
        }
        data["externalMode"] = this.externalMode;
        data["organizationId"] = this.organizationId;
        return data;
    };
    return CreateOrUpdateUserInput;
}());
export { CreateOrUpdateUserInput };
var CreateOrUpdateUserResultDto = /** @class */ (function () {
    function CreateOrUpdateUserResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateUserResultDto.prototype.init = function (data) {
        if (data) {
            this.newJwtTokenInfo = data["newJwtTokenInfo"] ? JwtAccessToken.fromJS(data["newJwtTokenInfo"]) : undefined;
        }
    };
    CreateOrUpdateUserResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateUserResultDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateUserResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["newJwtTokenInfo"] = this.newJwtTokenInfo ? this.newJwtTokenInfo.toJSON() : undefined;
        return data;
    };
    return CreateOrUpdateUserResultDto;
}());
export { CreateOrUpdateUserResultDto };
var BatchDeleteUserDto = /** @class */ (function () {
    function BatchDeleteUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchDeleteUserDto.prototype.init = function (data) {
        if (data) {
            if (data["batchDeleteIds"] && data["batchDeleteIds"].constructor === Array) {
                this.batchDeleteIds = [];
                for (var _i = 0, _a = data["batchDeleteIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.batchDeleteIds.push(item);
                }
            }
        }
    };
    BatchDeleteUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchDeleteUserDto();
        result.init(data);
        return result;
    };
    BatchDeleteUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.batchDeleteIds && this.batchDeleteIds.constructor === Array) {
            data["batchDeleteIds"] = [];
            for (var _i = 0, _a = this.batchDeleteIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["batchDeleteIds"].push(item);
            }
        }
        return data;
    };
    return BatchDeleteUserDto;
}());
export { BatchDeleteUserDto };
var SetAccountStateDto = /** @class */ (function () {
    function SetAccountStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetAccountStateDto.prototype.init = function (data) {
        if (data) {
            this.active = data["active"];
            this.id = data["id"];
        }
    };
    SetAccountStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetAccountStateDto();
        result.init(data);
        return result;
    };
    SetAccountStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["id"] = this.id;
        return data;
    };
    return SetAccountStateDto;
}());
export { SetAccountStateDto };
var BatchSetAccountStateDto = /** @class */ (function () {
    function BatchSetAccountStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchSetAccountStateDto.prototype.init = function (data) {
        if (data) {
            this.active = data["active"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (var _i = 0, _a = data["ids"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.ids.push(item);
                }
            }
        }
    };
    BatchSetAccountStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchSetAccountStateDto();
        result.init(data);
        return result;
    };
    BatchSetAccountStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (var _i = 0, _a = this.ids; _i < _a.length; _i++) {
                var item = _a[_i];
                data["ids"].push(item);
            }
        }
        return data;
    };
    return BatchSetAccountStateDto;
}());
export { BatchSetAccountStateDto };
var ListResultDtoOfUserInfoListDto = /** @class */ (function () {
    function ListResultDtoOfUserInfoListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfUserInfoListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserInfoListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfUserInfoListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfUserInfoListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfUserInfoListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfUserInfoListDto;
}());
export { ListResultDtoOfUserInfoListDto };
var UserDetailDto = /** @class */ (function () {
    function UserDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserDetailDto.prototype.init = function (data) {
        if (data) {
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.name = data["name"];
            this.jobNumber = data["jobNumber"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.dataPolicy = data["dataPolicy"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _i = 0, _a = data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(UserListRoleDto.fromJS(item));
                }
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.isLocationEnabled = data["isLocationEnabled"];
            this.expireTime = data["expireTime"] ? moment(data["expireTime"].toString()) : undefined;
            this.creatorOrganizationId = data["creatorOrganizationId"];
            this.externalSuperAdmin = data["externalSuperAdmin"];
            this.organizationNames = data["organizationNames"];
            this.id = data["id"];
        }
    };
    UserDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserDetailDto();
        result.init(data);
        return result;
    };
    UserDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["name"] = this.name;
        data["jobNumber"] = this.jobNumber;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["dataPolicy"] = this.dataPolicy;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item.toJSON());
            }
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["isLocationEnabled"] = this.isLocationEnabled;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : undefined;
        data["creatorOrganizationId"] = this.creatorOrganizationId;
        data["externalSuperAdmin"] = this.externalSuperAdmin;
        data["organizationNames"] = this.organizationNames;
        data["id"] = this.id;
        return data;
    };
    return UserDetailDto;
}());
export { UserDetailDto };
var UserGroupsDto = /** @class */ (function () {
    function UserGroupsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserGroupsDto.prototype.init = function (data) {
        if (data) {
            this.mineGalelryId = data["mineGalelryId"];
            if (data["otherUsers"] && data["otherUsers"].constructor === Array) {
                this.otherUsers = [];
                for (var _i = 0, _a = data["otherUsers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.otherUsers.push(UserGalleryDto.fromJS(item));
                }
            }
        }
    };
    UserGroupsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserGroupsDto();
        result.init(data);
        return result;
    };
    UserGroupsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mineGalelryId"] = this.mineGalelryId;
        if (this.otherUsers && this.otherUsers.constructor === Array) {
            data["otherUsers"] = [];
            for (var _i = 0, _a = this.otherUsers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["otherUsers"].push(item.toJSON());
            }
        }
        return data;
    };
    return UserGroupsDto;
}());
export { UserGroupsDto };
var UserGalleryDto = /** @class */ (function () {
    function UserGalleryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserGalleryDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    UserGalleryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserGalleryDto();
        result.init(data);
        return result;
    };
    UserGalleryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return UserGalleryDto;
}());
export { UserGalleryDto };
var IListResultOfUserGraphDto = /** @class */ (function () {
    function IListResultOfUserGraphDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfUserGraphDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserGraphDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfUserGraphDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfUserGraphDto();
        result.init(data);
        return result;
    };
    IListResultOfUserGraphDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfUserGraphDto;
}());
export { IListResultOfUserGraphDto };
var UserGraphDto = /** @class */ (function () {
    function UserGraphDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserGraphDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.thumbUrl = data["thumbUrl"];
            this.id = data["id"];
        }
    };
    UserGraphDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserGraphDto();
        result.init(data);
        return result;
    };
    UserGraphDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["thumbUrl"] = this.thumbUrl;
        data["id"] = this.id;
        return data;
    };
    return UserGraphDto;
}());
export { UserGraphDto };
var IListResultOfUserGraphStateDto = /** @class */ (function () {
    function IListResultOfUserGraphStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfUserGraphStateDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserGraphStateDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfUserGraphStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfUserGraphStateDto();
        result.init(data);
        return result;
    };
    IListResultOfUserGraphStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfUserGraphStateDto;
}());
export { IListResultOfUserGraphStateDto };
var UserGraphStateDto = /** @class */ (function () {
    function UserGraphStateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserGraphStateDto.prototype.init = function (data) {
        if (data) {
            this.index = data["index"];
            this.url = data["url"];
            this.type = data["type"];
            this.id = data["id"];
        }
    };
    UserGraphStateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserGraphStateDto();
        result.init(data);
        return result;
    };
    UserGraphStateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["url"] = this.url;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    };
    return UserGraphStateDto;
}());
export { UserGraphStateDto };
var ImportUserGraphIntoConfigureGalleryDto = /** @class */ (function () {
    function ImportUserGraphIntoConfigureGalleryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportUserGraphIntoConfigureGalleryDto.prototype.init = function (data) {
        if (data) {
            this.userGalleryId = data["userGalleryId"];
            this.configureId = data["configureId"];
            this.userGraphId = data["userGraphId"];
            this.userGraphName = data["userGraphName"];
        }
    };
    ImportUserGraphIntoConfigureGalleryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportUserGraphIntoConfigureGalleryDto();
        result.init(data);
        return result;
    };
    ImportUserGraphIntoConfigureGalleryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userGalleryId"] = this.userGalleryId;
        data["configureId"] = this.configureId;
        data["userGraphId"] = this.userGraphId;
        data["userGraphName"] = this.userGraphName;
        return data;
    };
    return ImportUserGraphIntoConfigureGalleryDto;
}());
export { ImportUserGraphIntoConfigureGalleryDto };
var UserGraphEditDto = /** @class */ (function () {
    function UserGraphEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserGraphEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.userGalleryId = data["userGalleryId"];
            if (data["states"] && data["states"].constructor === Array) {
                this.states = [];
                for (var _i = 0, _a = data["states"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.states.push(UserGraphStateEditDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    UserGraphEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserGraphEditDto();
        result.init(data);
        return result;
    };
    UserGraphEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userGalleryId"] = this.userGalleryId;
        if (this.states && this.states.constructor === Array) {
            data["states"] = [];
            for (var _i = 0, _a = this.states; _i < _a.length; _i++) {
                var item = _a[_i];
                data["states"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return UserGraphEditDto;
}());
export { UserGraphEditDto };
var UserGraphStateEditDto = /** @class */ (function () {
    function UserGraphStateEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserGraphStateEditDto.prototype.init = function (data) {
        if (data) {
            this.index = data["index"];
            this.type = data["type"];
            this.url = data["url"];
            this.fileId = data["fileId"];
            this.tempFileId = data["tempFileId"];
            this.id = data["id"];
        }
    };
    UserGraphStateEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserGraphStateEditDto();
        result.init(data);
        return result;
    };
    UserGraphStateEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["type"] = this.type;
        data["url"] = this.url;
        data["fileId"] = this.fileId;
        data["tempFileId"] = this.tempFileId;
        data["id"] = this.id;
        return data;
    };
    return UserGraphStateEditDto;
}());
export { UserGraphStateEditDto };
var LinkToUserInput = /** @class */ (function () {
    function LinkToUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LinkToUserInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    };
    LinkToUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LinkToUserInput();
        result.init(data);
        return result;
    };
    LinkToUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    };
    return LinkToUserInput;
}());
export { LinkToUserInput };
var PagedResultDtoOfLinkedUserDto = /** @class */ (function () {
    function PagedResultDtoOfLinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfLinkedUserDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LinkedUserDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfLinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfLinkedUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfLinkedUserDto;
}());
export { PagedResultDtoOfLinkedUserDto };
var LinkedUserDto = /** @class */ (function () {
    function LinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LinkedUserDto.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    LinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LinkedUserDto();
        result.init(data);
        return result;
    };
    LinkedUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return LinkedUserDto;
}());
export { LinkedUserDto };
var ListResultDtoOfLinkedUserDto = /** @class */ (function () {
    function ListResultDtoOfLinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfLinkedUserDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LinkedUserDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfLinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfLinkedUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfLinkedUserDto;
}());
export { ListResultDtoOfLinkedUserDto };
var UnlinkUserInput = /** @class */ (function () {
    function UnlinkUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnlinkUserInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    UnlinkUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnlinkUserInput();
        result.init(data);
        return result;
    };
    UnlinkUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return UnlinkUserInput;
}());
export { UnlinkUserInput };
var ListResultDtoOfUserLoginAttemptDto = /** @class */ (function () {
    function ListResultDtoOfUserLoginAttemptDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfUserLoginAttemptDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserLoginAttemptDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfUserLoginAttemptDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfUserLoginAttemptDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfUserLoginAttemptDto;
}());
export { ListResultDtoOfUserLoginAttemptDto };
var UserLoginAttemptDto = /** @class */ (function () {
    function UserLoginAttemptDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLoginAttemptDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    UserLoginAttemptDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    };
    UserLoginAttemptDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return UserLoginAttemptDto;
}());
export { UserLoginAttemptDto };
var PagedResultDtoOfVariableListDto = /** @class */ (function () {
    function PagedResultDtoOfVariableListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfVariableListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(VariableListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfVariableListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfVariableListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfVariableListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfVariableListDto;
}());
export { PagedResultDtoOfVariableListDto };
var VariableListDto = /** @class */ (function () {
    function VariableListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.unit = data["unit"];
            this.groupName = data["groupName"];
            this.configureVariableGroupId = data["configureVariableGroupId"];
            this.configureDataSourceName = data["configureDataSourceName"];
            this.dataType = data["dataType"];
            this.dataTypeStr = data["dataTypeStr"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
            this.labelText = data["labelText"];
            this.charCount = data["charCount"];
            this.variableRwTypeStr = data["variableRwTypeStr"];
            this.refFBoxVariableDto = data["refFBoxVariableDto"] ? RefFBoxVariableDto.fromJS(data["refFBoxVariableDto"]) : undefined;
            this.id = data["id"];
        }
    };
    VariableListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableListDto();
        result.init(data);
        return result;
    };
    VariableListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["groupName"] = this.groupName;
        data["configureVariableGroupId"] = this.configureVariableGroupId;
        data["configureDataSourceName"] = this.configureDataSourceName;
        data["dataType"] = this.dataType;
        data["dataTypeStr"] = this.dataTypeStr;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["labelText"] = this.labelText;
        data["charCount"] = this.charCount;
        data["variableRwTypeStr"] = this.variableRwTypeStr;
        data["refFBoxVariableDto"] = this.refFBoxVariableDto ? this.refFBoxVariableDto.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return VariableListDto;
}());
export { VariableListDto };
var RefFBoxVariableDto = /** @class */ (function () {
    function RefFBoxVariableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RefFBoxVariableDto.prototype.init = function (data) {
        if (data) {
            this.refVariableKey = data["refVariableKey"];
            this.name = data["name"];
            this.unit = data["unit"];
            this.groupName = data["groupName"];
            this.devAlias = data["devAlias"];
            this.stationNo = data["stationNo"];
            this.dataType = data["dataType"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.deadValue = data["deadValue"];
            this.addressDescription = data["addressDescription"];
            this.memo = data["memo"];
            this.labelTextObj = data["labelTextObj"] ? LabelText.fromJS(data["labelTextObj"]) : undefined;
            this.variableDataType = data["variableDataType"];
            this.id = data["id"];
        }
    };
    RefFBoxVariableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RefFBoxVariableDto();
        result.init(data);
        return result;
    };
    RefFBoxVariableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["refVariableKey"] = this.refVariableKey;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["groupName"] = this.groupName;
        data["devAlias"] = this.devAlias;
        data["stationNo"] = this.stationNo;
        data["dataType"] = this.dataType;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["deadValue"] = this.deadValue;
        data["addressDescription"] = this.addressDescription;
        data["memo"] = this.memo;
        data["labelTextObj"] = this.labelTextObj ? this.labelTextObj.toJSON() : undefined;
        data["variableDataType"] = this.variableDataType;
        data["id"] = this.id;
        return data;
    };
    return RefFBoxVariableDto;
}());
export { RefFBoxVariableDto };
var LabelText = /** @class */ (function () {
    function LabelText(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LabelText.prototype.init = function (data) {
        if (data) {
            this.ttext = data["ttext"];
            this.ftext = data["ftext"];
        }
    };
    LabelText.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LabelText();
        result.init(data);
        return result;
    };
    LabelText.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["ttext"] = this.ttext;
        data["ftext"] = this.ftext;
        return data;
    };
    return LabelText;
}());
export { LabelText };
var PagedResultDtoOfRefFBoxVariableDto = /** @class */ (function () {
    function PagedResultDtoOfRefFBoxVariableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfRefFBoxVariableDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RefFBoxVariableDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfRefFBoxVariableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfRefFBoxVariableDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfRefFBoxVariableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfRefFBoxVariableDto;
}());
export { PagedResultDtoOfRefFBoxVariableDto };
/** 变量编辑Dto */
var VariableForEditDto = /** @class */ (function () {
    function VariableForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableForEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.unit = data["unit"];
            this.dataSourceId = data["dataSourceId"];
            this.refVariableId = data["refVariableId"];
            this.enableVariableStorage = data["enableVariableStorage"];
            this.sampleMode = data["sampleMode"];
            this.sampleRate = data["sampleRate"];
            this.configureVariableGroupId = data["configureVariableGroupId"];
            this.dataType = data["dataType"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
            this.variableRwType = data["variableRwType"];
            this.labelText = data["labelText"];
            this.charCount = data["charCount"];
            this.configureDataSourceDto = data["configureDataSourceDto"] ? ConfigureDataSourceDto.fromJS(data["configureDataSourceDto"]) : undefined;
            this.refFBoxVariableDto = data["refFBoxVariableDto"] ? RefFBoxVariableDto.fromJS(data["refFBoxVariableDto"]) : undefined;
        }
    };
    VariableForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableForEditDto();
        result.init(data);
        return result;
    };
    VariableForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["dataSourceId"] = this.dataSourceId;
        data["refVariableId"] = this.refVariableId;
        data["enableVariableStorage"] = this.enableVariableStorage;
        data["sampleMode"] = this.sampleMode;
        data["sampleRate"] = this.sampleRate;
        data["configureVariableGroupId"] = this.configureVariableGroupId;
        data["dataType"] = this.dataType;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["variableRwType"] = this.variableRwType;
        data["labelText"] = this.labelText;
        data["charCount"] = this.charCount;
        data["configureDataSourceDto"] = this.configureDataSourceDto ? this.configureDataSourceDto.toJSON() : undefined;
        data["refFBoxVariableDto"] = this.refFBoxVariableDto ? this.refFBoxVariableDto.toJSON() : undefined;
        return data;
    };
    return VariableForEditDto;
}());
export { VariableForEditDto };
var ConfigureDataSourceDto = /** @class */ (function () {
    function ConfigureDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfigureDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.id = data["id"];
        }
    };
    ConfigureDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfigureDataSourceDto();
        result.init(data);
        return result;
    };
    ConfigureDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        return data;
    };
    return ConfigureDataSourceDto;
}());
export { ConfigureDataSourceDto };
var CreateOrUpdateVariableCheckDto = /** @class */ (function () {
    function CreateOrUpdateVariableCheckDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateVariableCheckDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.variableName = data["variableName"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateVariableCheckDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateVariableCheckDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateVariableCheckDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["variableName"] = this.variableName;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateVariableCheckDto;
}());
export { CreateOrUpdateVariableCheckDto };
var CreateOrUpdateVariableDto = /** @class */ (function () {
    function CreateOrUpdateVariableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateVariableDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.name = data["name"];
            this.unit = data["unit"];
            this.dataSourceId = data["dataSourceId"];
            this.configureVariableGroupId = data["configureVariableGroupId"];
            this.dataType = data["dataType"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
            this.variableRwType = data["variableRwType"];
            this.labelText = data["labelText"];
            this.charCount = data["charCount"];
            this.refVariableId = data["refVariableId"];
            this.enableVariableStorage = data["enableVariableStorage"];
            this.sampleMode = data["sampleMode"];
            this.sampleRate = data["sampleRate"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateVariableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateVariableDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateVariableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["dataSourceId"] = this.dataSourceId;
        data["configureVariableGroupId"] = this.configureVariableGroupId;
        data["dataType"] = this.dataType;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["variableRwType"] = this.variableRwType;
        data["labelText"] = this.labelText;
        data["charCount"] = this.charCount;
        data["refVariableId"] = this.refVariableId;
        data["enableVariableStorage"] = this.enableVariableStorage;
        data["sampleMode"] = this.sampleMode;
        data["sampleRate"] = this.sampleRate;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateVariableDto;
}());
export { CreateOrUpdateVariableDto };
var BatchImportVariableCheckDto = /** @class */ (function () {
    function BatchImportVariableCheckDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchImportVariableCheckDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            if (data["refVariableIdList"] && data["refVariableIdList"].constructor === Array) {
                this.refVariableIdList = [];
                for (var _i = 0, _a = data["refVariableIdList"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.refVariableIdList.push(item);
                }
            }
        }
    };
    BatchImportVariableCheckDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchImportVariableCheckDto();
        result.init(data);
        return result;
    };
    BatchImportVariableCheckDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        if (this.refVariableIdList && this.refVariableIdList.constructor === Array) {
            data["refVariableIdList"] = [];
            for (var _i = 0, _a = this.refVariableIdList; _i < _a.length; _i++) {
                var item = _a[_i];
                data["refVariableIdList"].push(item);
            }
        }
        return data;
    };
    return BatchImportVariableCheckDto;
}());
export { BatchImportVariableCheckDto };
var BatchImportVariablesDto = /** @class */ (function () {
    function BatchImportVariablesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchImportVariablesDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.dataSourceId = data["dataSourceId"];
            this.dataSourceName = data["dataSourceName"];
            this.renameType = data["renameType"];
            if (data["refVariableIdList"] && data["refVariableIdList"].constructor === Array) {
                this.refVariableIdList = [];
                for (var _i = 0, _a = data["refVariableIdList"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.refVariableIdList.push(item);
                }
            }
        }
    };
    BatchImportVariablesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchImportVariablesDto();
        result.init(data);
        return result;
    };
    BatchImportVariablesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["dataSourceId"] = this.dataSourceId;
        data["dataSourceName"] = this.dataSourceName;
        data["renameType"] = this.renameType;
        if (this.refVariableIdList && this.refVariableIdList.constructor === Array) {
            data["refVariableIdList"] = [];
            for (var _i = 0, _a = this.refVariableIdList; _i < _a.length; _i++) {
                var item = _a[_i];
                data["refVariableIdList"].push(item);
            }
        }
        return data;
    };
    return BatchImportVariablesDto;
}());
export { BatchImportVariablesDto };
var BatchDeleteVariableDto = /** @class */ (function () {
    function BatchDeleteVariableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchDeleteVariableDto.prototype.init = function (data) {
        if (data) {
            if (data["variableIds"] && data["variableIds"].constructor === Array) {
                this.variableIds = [];
                for (var _i = 0, _a = data["variableIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.variableIds.push(item);
                }
            }
        }
    };
    BatchDeleteVariableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchDeleteVariableDto();
        result.init(data);
        return result;
    };
    BatchDeleteVariableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.variableIds && this.variableIds.constructor === Array) {
            data["variableIds"] = [];
            for (var _i = 0, _a = this.variableIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["variableIds"].push(item);
            }
        }
        return data;
    };
    return BatchDeleteVariableDto;
}());
export { BatchDeleteVariableDto };
var BatchEditVariableDto = /** @class */ (function () {
    function BatchEditVariableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchEditVariableDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            if (data["variableIds"] && data["variableIds"].constructor === Array) {
                this.variableIds = [];
                for (var _i = 0, _a = data["variableIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.variableIds.push(item);
                }
            }
            this.groupId = data["groupId"];
            this.unit = data["unit"];
            this.variableRwType = data["variableRwType"];
            this.enableVariableStorage = data["enableVariableStorage"];
            this.sampleMode = data["sampleMode"];
            this.sampleRate = data["sampleRate"];
        }
    };
    BatchEditVariableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchEditVariableDto();
        result.init(data);
        return result;
    };
    BatchEditVariableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        if (this.variableIds && this.variableIds.constructor === Array) {
            data["variableIds"] = [];
            for (var _i = 0, _a = this.variableIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["variableIds"].push(item);
            }
        }
        data["groupId"] = this.groupId;
        data["unit"] = this.unit;
        data["variableRwType"] = this.variableRwType;
        data["enableVariableStorage"] = this.enableVariableStorage;
        data["sampleMode"] = this.sampleMode;
        data["sampleRate"] = this.sampleRate;
        return data;
    };
    return BatchEditVariableDto;
}());
export { BatchEditVariableDto };
var PagedResultDtoOfVariableForDesignerDto = /** @class */ (function () {
    function PagedResultDtoOfVariableForDesignerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfVariableForDesignerDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(VariableForDesignerDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfVariableForDesignerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfVariableForDesignerDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfVariableForDesignerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfVariableForDesignerDto;
}());
export { PagedResultDtoOfVariableForDesignerDto };
var VariableForDesignerDto = /** @class */ (function () {
    function VariableForDesignerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableForDesignerDto.prototype.init = function (data) {
        if (data) {
            this.variableName = data["variableName"];
            this.dataTypeStr = data["dataTypeStr"];
            this.dataSourceName = data["dataSourceName"];
            this.groupName = data["groupName"];
            this.refVariableName = data["refVariableName"];
            this.refVariableAddress = data["refVariableAddress"];
        }
    };
    VariableForDesignerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableForDesignerDto();
        result.init(data);
        return result;
    };
    VariableForDesignerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["variableName"] = this.variableName;
        data["dataTypeStr"] = this.dataTypeStr;
        data["dataSourceName"] = this.dataSourceName;
        data["groupName"] = this.groupName;
        data["refVariableName"] = this.refVariableName;
        data["refVariableAddress"] = this.refVariableAddress;
        return data;
    };
    return VariableForDesignerDto;
}());
export { VariableForDesignerDto };
var VariableForDesignerListDto = /** @class */ (function () {
    function VariableForDesignerListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableForDesignerListDto.prototype.init = function (data) {
        if (data) {
            this.variableName = data["variableName"];
            this.groupName = data["groupName"];
            this.readWriteModel = data["readWriteModel"];
        }
    };
    VariableForDesignerListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableForDesignerListDto();
        result.init(data);
        return result;
    };
    VariableForDesignerListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["variableName"] = this.variableName;
        data["groupName"] = this.groupName;
        data["readWriteModel"] = this.readWriteModel;
        return data;
    };
    return VariableForDesignerListDto;
}());
export { VariableForDesignerListDto };
var FindVariableForDesignerDto = /** @class */ (function () {
    function FindVariableForDesignerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindVariableForDesignerDto.prototype.init = function (data) {
        if (data) {
            this.configureVariableName = data["configureVariableName"];
            this.configureId = data["configureId"];
        }
    };
    FindVariableForDesignerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindVariableForDesignerDto();
        result.init(data);
        return result;
    };
    FindVariableForDesignerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureVariableName"] = this.configureVariableName;
        data["configureId"] = this.configureId;
        return data;
    };
    return FindVariableForDesignerDto;
}());
export { FindVariableForDesignerDto };
var VariableSpecifiedForDesignerDto = /** @class */ (function () {
    function VariableSpecifiedForDesignerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableSpecifiedForDesignerDto.prototype.init = function (data) {
        if (data) {
            this.dataType = data["dataType"];
            this.charCount = data["charCount"];
            this.unit = data["unit"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
        }
    };
    VariableSpecifiedForDesignerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableSpecifiedForDesignerDto();
        result.init(data);
        return result;
    };
    VariableSpecifiedForDesignerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dataType"] = this.dataType;
        data["charCount"] = this.charCount;
        data["unit"] = this.unit;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    };
    return VariableSpecifiedForDesignerDto;
}());
export { VariableSpecifiedForDesignerDto };
var ListResultDtoOfVariableNameMappingListDto = /** @class */ (function () {
    function ListResultDtoOfVariableNameMappingListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfVariableNameMappingListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(VariableNameMappingListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfVariableNameMappingListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfVariableNameMappingListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfVariableNameMappingListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfVariableNameMappingListDto;
}());
export { ListResultDtoOfVariableNameMappingListDto };
var VariableNameMappingListDto = /** @class */ (function () {
    function VariableNameMappingListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableNameMappingListDto.prototype.init = function (data) {
        if (data) {
            this.variableName = data["variableName"];
            this.fBoxVariableName = data["fBoxVariableName"];
            this.fBoxGroupName = data["fBoxGroupName"];
            this.dataSourceCode = data["dataSourceCode"];
            this.dataType = data["dataType"];
            this.readWriteModel = data["readWriteModel"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
        }
    };
    VariableNameMappingListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableNameMappingListDto();
        result.init(data);
        return result;
    };
    VariableNameMappingListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["variableName"] = this.variableName;
        data["fBoxVariableName"] = this.fBoxVariableName;
        data["fBoxGroupName"] = this.fBoxGroupName;
        data["dataSourceCode"] = this.dataSourceCode;
        data["dataType"] = this.dataType;
        data["readWriteModel"] = this.readWriteModel;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    };
    return VariableNameMappingListDto;
}());
export { VariableNameMappingListDto };
var VariableDataSourceListDto = /** @class */ (function () {
    function VariableDataSourceListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableDataSourceListDto.prototype.init = function (data) {
        if (data) {
            this.dataSourceId = data["dataSourceId"];
            this.dataSourceName = data["dataSourceName"];
        }
    };
    VariableDataSourceListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableDataSourceListDto();
        result.init(data);
        return result;
    };
    VariableDataSourceListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dataSourceId"] = this.dataSourceId;
        data["dataSourceName"] = this.dataSourceName;
        return data;
    };
    return VariableDataSourceListDto;
}());
export { VariableDataSourceListDto };
var VariableGroupListDto = /** @class */ (function () {
    function VariableGroupListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VariableGroupListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    VariableGroupListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VariableGroupListDto();
        result.init(data);
        return result;
    };
    VariableGroupListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return VariableGroupListDto;
}());
export { VariableGroupListDto };
var CreateOrUpdateVariableGroupDto = /** @class */ (function () {
    function CreateOrUpdateVariableGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateVariableGroupDto.prototype.init = function (data) {
        if (data) {
            this.configureId = data["configureId"];
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    CreateOrUpdateVariableGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateVariableGroupDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateVariableGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["configureId"] = this.configureId;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateVariableGroupDto;
}());
export { CreateOrUpdateVariableGroupDto };
var VirtualDeviceElementPasswordDto = /** @class */ (function () {
    function VirtualDeviceElementPasswordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VirtualDeviceElementPasswordDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.elementPassword = data["elementPassword"];
        }
    };
    VirtualDeviceElementPasswordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VirtualDeviceElementPasswordDto();
        result.init(data);
        return result;
    };
    VirtualDeviceElementPasswordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["elementPassword"] = this.elementPassword;
        return data;
    };
    return VirtualDeviceElementPasswordDto;
}());
export { VirtualDeviceElementPasswordDto };
var CurrentAlarmResultDto = /** @class */ (function () {
    function CurrentAlarmResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrentAlarmResultDto.prototype.init = function (data) {
        if (data) {
            if (data["currentAlarms"] && data["currentAlarms"].constructor === Array) {
                this.currentAlarms = [];
                for (var _i = 0, _a = data["currentAlarms"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.currentAlarms.push(CurrentAlarmDto.fromJS(item));
                }
            }
            this.errorMessage = data["errorMessage"];
        }
    };
    CurrentAlarmResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrentAlarmResultDto();
        result.init(data);
        return result;
    };
    CurrentAlarmResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.currentAlarms && this.currentAlarms.constructor === Array) {
            data["currentAlarms"] = [];
            for (var _i = 0, _a = this.currentAlarms; _i < _a.length; _i++) {
                var item = _a[_i];
                data["currentAlarms"].push(item.toJSON());
            }
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return CurrentAlarmResultDto;
}());
export { CurrentAlarmResultDto };
var CurrentAlarmDto = /** @class */ (function () {
    function CurrentAlarmDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrentAlarmDto.prototype.init = function (data) {
        if (data) {
            this.uid = data["uid"];
            this.name = data["name"];
            this.message = data["message"];
            this.state = data["state"];
            this.triggeredTime = data["triggeredTime"] ? moment(data["triggeredTime"].toString()) : undefined;
            this.value = data["value"];
            this.virtualDeviceId = data["virtualDeviceId"];
            this.dataSourceCode = data["dataSourceCode"];
            this.dataSourceName = data["dataSourceName"];
            this.fCloudAlarmName = data["fCloudAlarmName"];
            this.faultCode = data["faultCode"];
            this.alarmLevel = data["alarmLevel"];
        }
    };
    CurrentAlarmDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrentAlarmDto();
        result.init(data);
        return result;
    };
    CurrentAlarmDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["message"] = this.message;
        data["state"] = this.state;
        data["triggeredTime"] = this.triggeredTime ? this.triggeredTime.toISOString() : undefined;
        data["value"] = this.value;
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["dataSourceCode"] = this.dataSourceCode;
        data["dataSourceName"] = this.dataSourceName;
        data["fCloudAlarmName"] = this.fCloudAlarmName;
        data["faultCode"] = this.faultCode;
        data["alarmLevel"] = this.alarmLevel;
        return data;
    };
    return CurrentAlarmDto;
}());
export { CurrentAlarmDto };
var HistoryAlarmResultDto = /** @class */ (function () {
    function HistoryAlarmResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryAlarmResultDto.prototype.init = function (data) {
        if (data) {
            if (data["historyAlarms"] && data["historyAlarms"].constructor === Array) {
                this.historyAlarms = [];
                for (var _i = 0, _a = data["historyAlarms"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.historyAlarms.push(HistoryAlarmDto.fromJS(item));
                }
            }
            this.errorMessage = data["errorMessage"];
        }
    };
    HistoryAlarmResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryAlarmResultDto();
        result.init(data);
        return result;
    };
    HistoryAlarmResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.historyAlarms && this.historyAlarms.constructor === Array) {
            data["historyAlarms"] = [];
            for (var _i = 0, _a = this.historyAlarms; _i < _a.length; _i++) {
                var item = _a[_i];
                data["historyAlarms"].push(item.toJSON());
            }
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return HistoryAlarmResultDto;
}());
export { HistoryAlarmResultDto };
var HistoryAlarmDto = /** @class */ (function () {
    function HistoryAlarmDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryAlarmDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.action = data["action"];
            this.message = data["message"];
            this.value = data["value"];
            this.timestamp = data["timestamp"] ? moment(data["timestamp"].toString()) : undefined;
            this.alarmLevel = data["alarmLevel"];
            this.malfunctionCode = data["malfunctionCode"];
        }
    };
    HistoryAlarmDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryAlarmDto();
        result.init(data);
        return result;
    };
    HistoryAlarmDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["action"] = this.action;
        data["message"] = this.message;
        data["value"] = this.value;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["alarmLevel"] = this.alarmLevel;
        data["malfunctionCode"] = this.malfunctionCode;
        return data;
    };
    return HistoryAlarmDto;
}());
export { HistoryAlarmDto };
var ConfirmAlarmDto = /** @class */ (function () {
    function ConfirmAlarmDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfirmAlarmDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.dataSourceCode = data["dataSourceCode"];
            this.alarmUid = data["alarmUid"];
        }
    };
    ConfirmAlarmDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfirmAlarmDto();
        result.init(data);
        return result;
    };
    ConfirmAlarmDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["dataSourceCode"] = this.dataSourceCode;
        data["alarmUid"] = this.alarmUid;
        return data;
    };
    return ConfirmAlarmDto;
}());
export { ConfirmAlarmDto };
var ConfirmAlarmResultDto = /** @class */ (function () {
    function ConfirmAlarmResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConfirmAlarmResultDto.prototype.init = function (data) {
        if (data) {
            this.errorMessage = data["errorMessage"];
        }
    };
    ConfirmAlarmResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConfirmAlarmResultDto();
        result.init(data);
        return result;
    };
    ConfirmAlarmResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return ConfirmAlarmResultDto;
}());
export { ConfirmAlarmResultDto };
var GetHistoryAlarmsDto = /** @class */ (function () {
    function GetHistoryAlarmsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetHistoryAlarmsDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.alarmName = data["alarmName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : undefined;
            this.limit = data["limit"];
            this.dataSourceCode = data["dataSourceCode"];
            this.nextPage = data["nextPage"];
            this.limitDateTime = data["limitDateTime"] ? moment(data["limitDateTime"].toString()) : undefined;
        }
    };
    GetHistoryAlarmsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetHistoryAlarmsDto();
        result.init(data);
        return result;
    };
    GetHistoryAlarmsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["alarmName"] = this.alarmName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["limit"] = this.limit;
        data["dataSourceCode"] = this.dataSourceCode;
        data["nextPage"] = this.nextPage;
        data["limitDateTime"] = this.limitDateTime ? this.limitDateTime.toISOString() : undefined;
        return data;
    };
    return GetHistoryAlarmsDto;
}());
export { GetHistoryAlarmsDto };
var ListResultDtoOfVirtualDeviceDataSourceListDto = /** @class */ (function () {
    function ListResultDtoOfVirtualDeviceDataSourceListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfVirtualDeviceDataSourceListDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(VirtualDeviceDataSourceListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfVirtualDeviceDataSourceListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfVirtualDeviceDataSourceListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfVirtualDeviceDataSourceListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfVirtualDeviceDataSourceListDto;
}());
export { ListResultDtoOfVirtualDeviceDataSourceListDto };
var VirtualDeviceDataSourceListDto = /** @class */ (function () {
    function VirtualDeviceDataSourceListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VirtualDeviceDataSourceListDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.dataSourceCode = data["dataSourceCode"];
            this.boxSerialNumber = data["boxSerialNumber"];
        }
    };
    VirtualDeviceDataSourceListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VirtualDeviceDataSourceListDto();
        result.init(data);
        return result;
    };
    VirtualDeviceDataSourceListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["dataSourceCode"] = this.dataSourceCode;
        data["boxSerialNumber"] = this.boxSerialNumber;
        return data;
    };
    return VirtualDeviceDataSourceListDto;
}());
export { VirtualDeviceDataSourceListDto };
var VirtualDeviceIdDto = /** @class */ (function () {
    function VirtualDeviceIdDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VirtualDeviceIdDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    VirtualDeviceIdDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VirtualDeviceIdDto();
        result.init(data);
        return result;
    };
    VirtualDeviceIdDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return VirtualDeviceIdDto;
}());
export { VirtualDeviceIdDto };
var BindDataSourceDto = /** @class */ (function () {
    function BindDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BindDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.boxSerialNumber = data["boxSerialNumber"];
            this.boxPassword = data["boxPassword"];
            this.dataSourceCode = data["dataSourceCode"];
        }
    };
    BindDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BindDataSourceDto();
        result.init(data);
        return result;
    };
    BindDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["boxSerialNumber"] = this.boxSerialNumber;
        data["boxPassword"] = this.boxPassword;
        data["dataSourceCode"] = this.dataSourceCode;
        return data;
    };
    return BindDataSourceDto;
}());
export { BindDataSourceDto };
var UnBindDataSourceDto = /** @class */ (function () {
    function UnBindDataSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnBindDataSourceDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.boxSerialNumber = data["boxSerialNumber"];
            this.dataSourceCode = data["dataSourceCode"];
        }
    };
    UnBindDataSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnBindDataSourceDto();
        result.init(data);
        return result;
    };
    UnBindDataSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["boxSerialNumber"] = this.boxSerialNumber;
        data["dataSourceCode"] = this.dataSourceCode;
        return data;
    };
    return UnBindDataSourceDto;
}());
export { UnBindDataSourceDto };
var ForceIssueInputDto = /** @class */ (function () {
    function ForceIssueInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ForceIssueInputDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
        }
    };
    ForceIssueInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ForceIssueInputDto();
        result.init(data);
        return result;
    };
    ForceIssueInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        return data;
    };
    return ForceIssueInputDto;
}());
export { ForceIssueInputDto };
var HistoryDataItemResultDto = /** @class */ (function () {
    function HistoryDataItemResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataItemResultDto.prototype.init = function (data) {
        if (data) {
            if (data["historyDataItems"] && data["historyDataItems"].constructor === Array) {
                this.historyDataItems = [];
                for (var _i = 0, _a = data["historyDataItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.historyDataItems.push(HistoryDataItemDto.fromJS(item));
                }
            }
            this.errorMessage = data["errorMessage"];
        }
    };
    HistoryDataItemResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataItemResultDto();
        result.init(data);
        return result;
    };
    HistoryDataItemResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.historyDataItems && this.historyDataItems.constructor === Array) {
            data["historyDataItems"] = [];
            for (var _i = 0, _a = this.historyDataItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["historyDataItems"].push(item.toJSON());
            }
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    };
    return HistoryDataItemResultDto;
}());
export { HistoryDataItemResultDto };
var HistoryDataItemDto = /** @class */ (function () {
    function HistoryDataItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataItemDto.prototype.init = function (data) {
        if (data) {
            this.uid = data["uid"];
            this.name = data["name"];
            this.boxId = data["boxId"];
            if (data["channels"] && data["channels"].constructor === Array) {
                this.channels = [];
                for (var _i = 0, _a = data["channels"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.channels.push(HdataChannel.fromJS(item));
                }
            }
        }
    };
    HistoryDataItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataItemDto();
        result.init(data);
        return result;
    };
    HistoryDataItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["boxId"] = this.boxId;
        if (this.channels && this.channels.constructor === Array) {
            data["channels"] = [];
            for (var _i = 0, _a = this.channels; _i < _a.length; _i++) {
                var item = _a[_i];
                data["channels"].push(item.toJSON());
            }
        }
        return data;
    };
    return HistoryDataItemDto;
}());
export { HistoryDataItemDto };
var HdataChannel = /** @class */ (function () {
    function HdataChannel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HdataChannel.prototype.init = function (data) {
        if (data) {
            this.uid = data["uid"];
            this.hasSubAddress = data["hasSubAddress"];
            this.hasSubIndex = data["hasSubIndex"];
            this.tagName = data["tagName"];
            this.deviceTag = data["deviceTag"] ? DeviceTagMapper.fromJS(data["deviceTag"]) : undefined;
            this.addressTag = data["addressTag"] ? AddressTagDto.fromJS(data["addressTag"]) : undefined;
            this.name = data["name"];
            this.unit = data["unit"];
            this.desc = data["desc"];
            this.intDigits = data["intDigits"];
            this.fracDigits = data["fracDigits"];
            this.devAlias = data["devAlias"];
            this.station = data["station"];
            this.dataType = data["dataType"];
            this.regId = data["regId"];
            this.ioWidth = data["ioWidth"];
            this.regName = data["regName"];
            this.addr = data["addr"];
            this.subAddr = data["subAddr"];
            this.addrBlk = data["addrBlk"];
            this.bitIndexEnabled = data["bitIndexEnabled"];
            this.bitIndex = data["bitIndex"];
            this.addrDesc = data["addrDesc"];
        }
    };
    HdataChannel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HdataChannel();
        result.init(data);
        return result;
    };
    HdataChannel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["hasSubAddress"] = this.hasSubAddress;
        data["hasSubIndex"] = this.hasSubIndex;
        data["tagName"] = this.tagName;
        data["deviceTag"] = this.deviceTag ? this.deviceTag.toJSON() : undefined;
        data["addressTag"] = this.addressTag ? this.addressTag.toJSON() : undefined;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["desc"] = this.desc;
        data["intDigits"] = this.intDigits;
        data["fracDigits"] = this.fracDigits;
        data["devAlias"] = this.devAlias;
        data["station"] = this.station;
        data["dataType"] = this.dataType;
        data["regId"] = this.regId;
        data["ioWidth"] = this.ioWidth;
        data["regName"] = this.regName;
        data["addr"] = this.addr;
        data["subAddr"] = this.subAddr;
        data["addrBlk"] = this.addrBlk;
        data["bitIndexEnabled"] = this.bitIndexEnabled;
        data["bitIndex"] = this.bitIndex;
        data["addrDesc"] = this.addrDesc;
        return data;
    };
    return HdataChannel;
}());
export { HdataChannel };
var DeviceTagMapper = /** @class */ (function () {
    function DeviceTagMapper(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceTagMapper.prototype.init = function (data) {
        if (data) {
            this.index = data["index"];
            this.deviceId = data["deviceId"];
            this.regId = data["regId"];
            this.ioWidth = data["ioWidth"];
            this.stationNo = data["stationNo"];
            this.name = data["name"];
        }
    };
    DeviceTagMapper.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceTagMapper();
        result.init(data);
        return result;
    };
    DeviceTagMapper.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["deviceId"] = this.deviceId;
        data["regId"] = this.regId;
        data["ioWidth"] = this.ioWidth;
        data["stationNo"] = this.stationNo;
        data["name"] = this.name;
        return data;
    };
    return DeviceTagMapper;
}());
export { DeviceTagMapper };
var AddressTagDto = /** @class */ (function () {
    function AddressTagDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddressTagDto.prototype.init = function (data) {
        if (data) {
            this.uid = data["uid"];
            this.name = data["name"];
            this.devAlias = data["devAlias"];
            this.stationNo = data["stationNo"];
            this.addrTagDataType = data["addrTagDataType"];
            this.regName = data["regName"];
            this.mainAddr = data["mainAddr"];
            this.subAddr = data["subAddr"];
            this.subIndex = data["subIndex"];
            this.deviceTagName = data["deviceTagName"];
            this.deviceTagMapper = data["deviceTagMapper"] ? DeviceTagMapper.fromJS(data["deviceTagMapper"]) : undefined;
            this.addrDesc = data["addrDesc"];
            this.addrHelper = data["addrHelper"];
        }
    };
    AddressTagDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddressTagDto();
        result.init(data);
        return result;
    };
    AddressTagDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["devAlias"] = this.devAlias;
        data["stationNo"] = this.stationNo;
        data["addrTagDataType"] = this.addrTagDataType;
        data["regName"] = this.regName;
        data["mainAddr"] = this.mainAddr;
        data["subAddr"] = this.subAddr;
        data["subIndex"] = this.subIndex;
        data["deviceTagName"] = this.deviceTagName;
        data["deviceTagMapper"] = this.deviceTagMapper ? this.deviceTagMapper.toJSON() : undefined;
        data["addrDesc"] = this.addrDesc;
        data["addrHelper"] = this.addrHelper;
        return data;
    };
    return AddressTagDto;
}());
export { AddressTagDto };
var GetHistoryDataDto = /** @class */ (function () {
    function GetHistoryDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetHistoryDataDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.dataSourceCode = data["dataSourceCode"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
            this.limit = data["limit"];
            this.hdataItemName = data["hdataItemName"];
            if (data["channelNames"] && data["channelNames"].constructor === Array) {
                this.channelNames = [];
                for (var _i = 0, _a = data["channelNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.channelNames.push(item);
                }
            }
            this.timeRange = data["timeRange"];
            this.nextPage = data["nextPage"];
            this.limitDateTime = data["limitDateTime"] ? moment(data["limitDateTime"].toString()) : undefined;
        }
    };
    GetHistoryDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetHistoryDataDto();
        result.init(data);
        return result;
    };
    GetHistoryDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["dataSourceCode"] = this.dataSourceCode;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["limit"] = this.limit;
        data["hdataItemName"] = this.hdataItemName;
        if (this.channelNames && this.channelNames.constructor === Array) {
            data["channelNames"] = [];
            for (var _i = 0, _a = this.channelNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["channelNames"].push(item);
            }
        }
        data["timeRange"] = this.timeRange;
        data["nextPage"] = this.nextPage;
        data["limitDateTime"] = this.limitDateTime ? this.limitDateTime.toISOString() : undefined;
        return data;
    };
    return GetHistoryDataDto;
}());
export { GetHistoryDataDto };
var RowHistoryDataDto = /** @class */ (function () {
    function RowHistoryDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RowHistoryDataDto.prototype.init = function (data) {
        if (data) {
            if (data["rows"] && data["rows"].constructor === Array) {
                this.rows = [];
                for (var _i = 0, _a = data["rows"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.rows.push(HistoryDataRowDto.fromJS(item));
                }
            }
            this.errorMessage = data["errorMessage"];
            this.isUnbind = data["isUnbind"];
        }
    };
    RowHistoryDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RowHistoryDataDto();
        result.init(data);
        return result;
    };
    RowHistoryDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.rows && this.rows.constructor === Array) {
            data["rows"] = [];
            for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
                var item = _a[_i];
                data["rows"].push(item.toJSON());
            }
        }
        data["errorMessage"] = this.errorMessage;
        data["isUnbind"] = this.isUnbind;
        return data;
    };
    return RowHistoryDataDto;
}());
export { RowHistoryDataDto };
var HistoryDataRowDto = /** @class */ (function () {
    function HistoryDataRowDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HistoryDataRowDto.prototype.init = function (data) {
        if (data) {
            this.time = data["time"] ? moment(data["time"].toString()) : undefined;
            if (data["values"] && data["values"].constructor === Array) {
                this.values = [];
                for (var _i = 0, _a = data["values"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.values.push(item);
                }
            }
        }
    };
    HistoryDataRowDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HistoryDataRowDto();
        result.init(data);
        return result;
    };
    HistoryDataRowDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : undefined;
        if (this.values && this.values.constructor === Array) {
            data["values"] = [];
            for (var _i = 0, _a = this.values; _i < _a.length; _i++) {
                var item = _a[_i];
                data["values"].push(item);
            }
        }
        return data;
    };
    return HistoryDataRowDto;
}());
export { HistoryDataRowDto };
var ExportHistoryDataCsvDto = /** @class */ (function () {
    function ExportHistoryDataCsvDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportHistoryDataCsvDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.dataSourceCode = data["dataSourceCode"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
            this.hdataItemName = data["hdataItemName"];
            if (data["channelNames"] && data["channelNames"].constructor === Array) {
                this.channelNames = [];
                for (var _i = 0, _a = data["channelNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.channelNames.push(item);
                }
            }
        }
    };
    ExportHistoryDataCsvDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportHistoryDataCsvDto();
        result.init(data);
        return result;
    };
    ExportHistoryDataCsvDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["dataSourceCode"] = this.dataSourceCode;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["hdataItemName"] = this.hdataItemName;
        if (this.channelNames && this.channelNames.constructor === Array) {
            data["channelNames"] = [];
            for (var _i = 0, _a = this.channelNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["channelNames"].push(item);
            }
        }
        return data;
    };
    return ExportHistoryDataCsvDto;
}());
export { ExportHistoryDataCsvDto };
var PagedResultDtoOfVirtualDeviceOperationHistoryDto = /** @class */ (function () {
    function PagedResultDtoOfVirtualDeviceOperationHistoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfVirtualDeviceOperationHistoryDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(VirtualDeviceOperationHistoryDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfVirtualDeviceOperationHistoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfVirtualDeviceOperationHistoryDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfVirtualDeviceOperationHistoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfVirtualDeviceOperationHistoryDto;
}());
export { PagedResultDtoOfVirtualDeviceOperationHistoryDto };
var VirtualDeviceOperationHistoryDto = /** @class */ (function () {
    function VirtualDeviceOperationHistoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VirtualDeviceOperationHistoryDto.prototype.init = function (data) {
        if (data) {
            this.operatorName = data["operatorName"];
            this.variableName = data["variableName"];
            this.variableOriginValue = data["variableOriginValue"];
            this.variableNewValue = data["variableNewValue"];
            this.operationDescription = data["operationDescription"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.dataSourceName = data["dataSourceName"];
            this.id = data["id"];
        }
    };
    VirtualDeviceOperationHistoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VirtualDeviceOperationHistoryDto();
        result.init(data);
        return result;
    };
    VirtualDeviceOperationHistoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["operatorName"] = this.operatorName;
        data["variableName"] = this.variableName;
        data["variableOriginValue"] = this.variableOriginValue;
        data["variableNewValue"] = this.variableNewValue;
        data["operationDescription"] = this.operationDescription;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["dataSourceName"] = this.dataSourceName;
        data["id"] = this.id;
        return data;
    };
    return VirtualDeviceOperationHistoryDto;
}());
export { VirtualDeviceOperationHistoryDto };
var CreateVirtualDeviceOperationHistoryDto = /** @class */ (function () {
    function CreateVirtualDeviceOperationHistoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateVirtualDeviceOperationHistoryDto.prototype.init = function (data) {
        if (data) {
            this.virtualDeviceId = data["virtualDeviceId"];
            this.variableName = data["variableName"];
            this.variableOriginValue = data["variableOriginValue"];
            this.variableNewValue = data["variableNewValue"];
            this.operationDescription = data["operationDescription"];
        }
    };
    CreateVirtualDeviceOperationHistoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateVirtualDeviceOperationHistoryDto();
        result.init(data);
        return result;
    };
    CreateVirtualDeviceOperationHistoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["virtualDeviceId"] = this.virtualDeviceId;
        data["variableName"] = this.variableName;
        data["variableOriginValue"] = this.variableOriginValue;
        data["variableNewValue"] = this.variableNewValue;
        data["operationDescription"] = this.operationDescription;
        return data;
    };
    return CreateVirtualDeviceOperationHistoryDto;
}());
export { CreateVirtualDeviceOperationHistoryDto };
var VirtualDeviceOperationResultDto = /** @class */ (function () {
    function VirtualDeviceOperationResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VirtualDeviceOperationResultDto.prototype.init = function (data) {
        if (data) {
            this.errorMessage = data["errorMessage"];
            this.virtualDeviceState = data["virtualDeviceState"];
        }
    };
    VirtualDeviceOperationResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VirtualDeviceOperationResultDto();
        result.init(data);
        return result;
    };
    VirtualDeviceOperationResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["virtualDeviceState"] = this.virtualDeviceState;
        return data;
    };
    return VirtualDeviceOperationResultDto;
}());
export { VirtualDeviceOperationResultDto };
var RefreshAllTenantDeviceStateResultDto = /** @class */ (function () {
    function RefreshAllTenantDeviceStateResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RefreshAllTenantDeviceStateResultDto.prototype.init = function (data) {
        if (data) {
            this.result = data["result"];
            this.errorInfo = data["errorInfo"];
        }
    };
    RefreshAllTenantDeviceStateResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RefreshAllTenantDeviceStateResultDto();
        result.init(data);
        return result;
    };
    RefreshAllTenantDeviceStateResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["errorInfo"] = this.errorInfo;
        return data;
    };
    return RefreshAllTenantDeviceStateResultDto;
}());
export { RefreshAllTenantDeviceStateResultDto };
var IListResultOfVirtualDeviceVideoDto = /** @class */ (function () {
    function IListResultOfVirtualDeviceVideoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IListResultOfVirtualDeviceVideoDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(VirtualDeviceVideoDto.fromJS(item));
                }
            }
        }
    };
    IListResultOfVirtualDeviceVideoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IListResultOfVirtualDeviceVideoDto();
        result.init(data);
        return result;
    };
    IListResultOfVirtualDeviceVideoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return IListResultOfVirtualDeviceVideoDto;
}());
export { IListResultOfVirtualDeviceVideoDto };
var VirtualDeviceVideoDto = /** @class */ (function () {
    function VirtualDeviceVideoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VirtualDeviceVideoDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.configureVideoId = data["configureVideoId"];
            this.videoType = data["videoType"];
            this.tag = data["tag"];
            this.videoUrl = data["videoUrl"];
            this.name = data["name"];
            this.virtualDeviceId = data["virtualDeviceId"];
        }
    };
    VirtualDeviceVideoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VirtualDeviceVideoDto();
        result.init(data);
        return result;
    };
    VirtualDeviceVideoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configureVideoId"] = this.configureVideoId;
        data["videoType"] = this.videoType;
        data["tag"] = this.tag;
        data["videoUrl"] = this.videoUrl;
        data["name"] = this.name;
        data["virtualDeviceId"] = this.virtualDeviceId;
        return data;
    };
    return VirtualDeviceVideoDto;
}());
export { VirtualDeviceVideoDto };
var WeatherInfoDto = /** @class */ (function () {
    function WeatherInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeatherInfoDto.prototype.init = function (data) {
        if (data) {
            this.hasAddress = data["hasAddress"];
            this.gettingAddress = data["gettingAddress"];
            this.supported = data["supported"];
            this.temperature = data["temperature"];
            this.humidity = data["humidity"];
            this.weatherPhenomenon = data["weatherPhenomenon"];
            this.weatherIcon = data["weatherIcon"];
            this.wind = data["wind"];
            this.location = data["location"];
        }
    };
    WeatherInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeatherInfoDto();
        result.init(data);
        return result;
    };
    WeatherInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["hasAddress"] = this.hasAddress;
        data["gettingAddress"] = this.gettingAddress;
        data["supported"] = this.supported;
        data["temperature"] = this.temperature;
        data["humidity"] = this.humidity;
        data["weatherPhenomenon"] = this.weatherPhenomenon;
        data["weatherIcon"] = this.weatherIcon;
        data["wind"] = this.wind;
        data["location"] = this.location;
        return data;
    };
    return WeatherInfoDto;
}());
export { WeatherInfoDto };
var GetLatestWebLogsOutput = /** @class */ (function () {
    function GetLatestWebLogsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLatestWebLogsOutput.prototype.init = function (data) {
        if (data) {
            if (data["latestWebLogLines"] && data["latestWebLogLines"].constructor === Array) {
                this.latestWebLogLines = [];
                for (var _i = 0, _a = data["latestWebLogLines"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.latestWebLogLines.push(item);
                }
            }
        }
    };
    GetLatestWebLogsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    };
    GetLatestWebLogsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.latestWebLogLines && this.latestWebLogLines.constructor === Array) {
            data["latestWebLogLines"] = [];
            for (var _i = 0, _a = this.latestWebLogLines; _i < _a.length; _i++) {
                var item = _a[_i];
                data["latestWebLogLines"].push(item);
            }
        }
        return data;
    };
    return GetLatestWebLogsOutput;
}());
export { GetLatestWebLogsOutput };
var OfficialAccountDto = /** @class */ (function () {
    function OfficialAccountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OfficialAccountDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.originId = data["originId"];
            this.appId = data["appId"];
            this.appSecret = data["appSecret"];
            this.templateMessageId = data["templateMessageId"];
            this.isBind = data["isBind"];
        }
    };
    OfficialAccountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OfficialAccountDto();
        result.init(data);
        return result;
    };
    OfficialAccountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originId"] = this.originId;
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        data["templateMessageId"] = this.templateMessageId;
        data["isBind"] = this.isBind;
        return data;
    };
    return OfficialAccountDto;
}());
export { OfficialAccountDto };
var WeChatTempQrCodeDto = /** @class */ (function () {
    function WeChatTempQrCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeChatTempQrCodeDto.prototype.init = function (data) {
        if (data) {
            this.picBase64Str = data["picBase64Str"];
        }
    };
    WeChatTempQrCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeChatTempQrCodeDto();
        result.init(data);
        return result;
    };
    WeChatTempQrCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["picBase64Str"] = this.picBase64Str;
        return data;
    };
    return WeChatTempQrCodeDto;
}());
export { WeChatTempQrCodeDto };
var WeChatUrlConfigDto = /** @class */ (function () {
    function WeChatUrlConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeChatUrlConfigDto.prototype.init = function (data) {
        if (data) {
            this.url = data["url"];
            this.token = data["token"];
        }
    };
    WeChatUrlConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeChatUrlConfigDto();
        result.init(data);
        return result;
    };
    WeChatUrlConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["token"] = this.token;
        return data;
    };
    return WeChatUrlConfigDto;
}());
export { WeChatUrlConfigDto };
var WorkRuleDto = /** @class */ (function () {
    function WorkRuleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkRuleDto.prototype.init = function (data) {
        if (data) {
            this.message = data["message"];
            if (data["workConfigurations"] && data["workConfigurations"].constructor === Array) {
                this.workConfigurations = [];
                for (var _i = 0, _a = data["workConfigurations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.workConfigurations.push(WorkConfiguration.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    WorkRuleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkRuleDto();
        result.init(data);
        return result;
    };
    WorkRuleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.workConfigurations && this.workConfigurations.constructor === Array) {
            data["workConfigurations"] = [];
            for (var _i = 0, _a = this.workConfigurations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["workConfigurations"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return WorkRuleDto;
}());
export { WorkRuleDto };
var WorkConfiguration = /** @class */ (function () {
    function WorkConfiguration(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkConfiguration.prototype.init = function (data) {
        if (data) {
            this.workRuleType = data["workRuleType"];
            this.bindDevice = data["bindDevice"];
            this.radius = data["radius"];
        }
    };
    WorkConfiguration.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkConfiguration();
        result.init(data);
        return result;
    };
    WorkConfiguration.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workRuleType"] = this.workRuleType;
        data["bindDevice"] = this.bindDevice;
        data["radius"] = this.radius;
        return data;
    };
    return WorkConfiguration;
}());
export { WorkConfiguration };
var CreateOrUpdateWorkRuleDto = /** @class */ (function () {
    function CreateOrUpdateWorkRuleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateWorkRuleDto.prototype.init = function (data) {
        if (data) {
            this.message = data["message"];
            if (data["workConfigurations"] && data["workConfigurations"].constructor === Array) {
                this.workConfigurations = [];
                for (var _i = 0, _a = data["workConfigurations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.workConfigurations.push(WorkConfiguration.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    CreateOrUpdateWorkRuleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateWorkRuleDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateWorkRuleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.workConfigurations && this.workConfigurations.constructor === Array) {
            data["workConfigurations"] = [];
            for (var _i = 0, _a = this.workConfigurations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["workConfigurations"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return CreateOrUpdateWorkRuleDto;
}());
export { CreateOrUpdateWorkRuleDto };
var PagedResultDtoOfWorkAttendanceRecordOutput = /** @class */ (function () {
    function PagedResultDtoOfWorkAttendanceRecordOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfWorkAttendanceRecordOutput.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(WorkAttendanceRecordOutput.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfWorkAttendanceRecordOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfWorkAttendanceRecordOutput();
        result.init(data);
        return result;
    };
    PagedResultDtoOfWorkAttendanceRecordOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfWorkAttendanceRecordOutput;
}());
export { PagedResultDtoOfWorkAttendanceRecordOutput };
var WorkAttendanceRecordOutput = /** @class */ (function () {
    function WorkAttendanceRecordOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkAttendanceRecordOutput.prototype.init = function (data) {
        if (data) {
            this.workAttendanceType = data["workAttendanceType"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.locationName = data["locationName"];
            this.userName = data["userName"];
            this.userJobNumber = data["userJobNumber"];
            this.isSucceed = data["isSucceed"];
            this.workAttendanceErrorType = data["workAttendanceErrorType"];
            this.deviceName = data["deviceName"];
        }
    };
    WorkAttendanceRecordOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkAttendanceRecordOutput();
        result.init(data);
        return result;
    };
    WorkAttendanceRecordOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workAttendanceType"] = this.workAttendanceType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["locationName"] = this.locationName;
        data["userName"] = this.userName;
        data["userJobNumber"] = this.userJobNumber;
        data["isSucceed"] = this.isSucceed;
        data["workAttendanceErrorType"] = this.workAttendanceErrorType;
        data["deviceName"] = this.deviceName;
        return data;
    };
    return WorkAttendanceRecordOutput;
}());
export { WorkAttendanceRecordOutput };
var CreateMaintenanceReportDto = /** @class */ (function () {
    function CreateMaintenanceReportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateMaintenanceReportDto.prototype.init = function (data) {
        if (data) {
            this.workOrderId = data["workOrderId"];
            this.faultDescription = data["faultDescription"];
            this.treatmentResult = data["treatmentResult"];
            this.faultType = data["faultType"];
            this.isCheckExposedDevice = data["isCheckExposedDevice"];
            this.exposedDeviceMaintenanceMemo = data["exposedDeviceMaintenanceMemo"];
            this.isCheckInnerDevicePart = data["isCheckInnerDevicePart"];
            this.innerDeviceMaintenanceMemo = data["innerDeviceMaintenanceMemo"];
            this.isChangeDeviceParts = data["isChangeDeviceParts"];
            this.changeDevicePartMaintenanceMemo = data["changeDevicePartMaintenanceMemo"];
            this.isChangeOil = data["isChangeOil"];
            this.changeOilMaintenanceMemo = data["changeOilMaintenanceMemo"];
            this.isCheckAllFunction = data["isCheckAllFunction"];
            this.checkAllMaintenanceMemo = data["checkAllMaintenanceMemo"];
            this.isBackupWorkData = data["isBackupWorkData"];
            this.backupDataMaintenanceMemo = data["backupDataMaintenanceMemo"];
            this.isAdvanced = data["isAdvanced"];
            this.advancedMaintenanceMemo = data["advancedMaintenanceMemo"];
        }
    };
    CreateMaintenanceReportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateMaintenanceReportDto();
        result.init(data);
        return result;
    };
    CreateMaintenanceReportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["faultDescription"] = this.faultDescription;
        data["treatmentResult"] = this.treatmentResult;
        data["faultType"] = this.faultType;
        data["isCheckExposedDevice"] = this.isCheckExposedDevice;
        data["exposedDeviceMaintenanceMemo"] = this.exposedDeviceMaintenanceMemo;
        data["isCheckInnerDevicePart"] = this.isCheckInnerDevicePart;
        data["innerDeviceMaintenanceMemo"] = this.innerDeviceMaintenanceMemo;
        data["isChangeDeviceParts"] = this.isChangeDeviceParts;
        data["changeDevicePartMaintenanceMemo"] = this.changeDevicePartMaintenanceMemo;
        data["isChangeOil"] = this.isChangeOil;
        data["changeOilMaintenanceMemo"] = this.changeOilMaintenanceMemo;
        data["isCheckAllFunction"] = this.isCheckAllFunction;
        data["checkAllMaintenanceMemo"] = this.checkAllMaintenanceMemo;
        data["isBackupWorkData"] = this.isBackupWorkData;
        data["backupDataMaintenanceMemo"] = this.backupDataMaintenanceMemo;
        data["isAdvanced"] = this.isAdvanced;
        data["advancedMaintenanceMemo"] = this.advancedMaintenanceMemo;
        return data;
    };
    return CreateMaintenanceReportDto;
}());
export { CreateMaintenanceReportDto };
var WorkOrderDetailDto = /** @class */ (function () {
    function WorkOrderDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkOrderDetailDto.prototype.init = function (data) {
        if (data) {
            this.workOrder = data["workOrder"] ? WorkOrderForDetailDto.fromJS(data["workOrder"]) : undefined;
            this.device = data["device"] ? DeviceForWorkOrderDetailDto.fromJS(data["device"]) : undefined;
            this.report = data["report"] ? MaintenanceReportForWorkOrderDetailDto.fromJS(data["report"]) : undefined;
            if (data["progress"] && data["progress"].constructor === Array) {
                this.progress = [];
                for (var _i = 0, _a = data["progress"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.progress.push(WorkOrderProgressDto.fromJS(item));
                }
            }
        }
    };
    WorkOrderDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkOrderDetailDto();
        result.init(data);
        return result;
    };
    WorkOrderDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workOrder"] = this.workOrder ? this.workOrder.toJSON() : undefined;
        data["device"] = this.device ? this.device.toJSON() : undefined;
        data["report"] = this.report ? this.report.toJSON() : undefined;
        if (this.progress && this.progress.constructor === Array) {
            data["progress"] = [];
            for (var _i = 0, _a = this.progress; _i < _a.length; _i++) {
                var item = _a[_i];
                data["progress"].push(item.toJSON());
            }
        }
        return data;
    };
    return WorkOrderDetailDto;
}());
export { WorkOrderDetailDto };
var WorkOrderForDetailDto = /** @class */ (function () {
    function WorkOrderForDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkOrderForDetailDto.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"];
            this.executorName = data["executorName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.description = data["description"];
            this.customerName = data["customerName"];
            this.customerConcat = data["customerConcat"];
            this.workOrderCreatorName = data["workOrderCreatorName"];
            this.state = data["state"];
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(WorkOrderImage.fromJS(item));
                }
            }
            this.workOrderType = data["workOrderType"];
        }
    };
    WorkOrderForDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkOrderForDetailDto();
        result.init(data);
        return result;
    };
    WorkOrderForDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["executorName"] = this.executorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["description"] = this.description;
        data["customerName"] = this.customerName;
        data["customerConcat"] = this.customerConcat;
        data["workOrderCreatorName"] = this.workOrderCreatorName;
        data["state"] = this.state;
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["workOrderType"] = this.workOrderType;
        return data;
    };
    return WorkOrderForDetailDto;
}());
export { WorkOrderForDetailDto };
var DeviceForWorkOrderDetailDto = /** @class */ (function () {
    function DeviceForWorkOrderDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeviceForWorkOrderDetailDto.prototype.init = function (data) {
        if (data) {
            this.companyName = data["companyName"];
            this.name = data["name"];
        }
    };
    DeviceForWorkOrderDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeviceForWorkOrderDetailDto();
        result.init(data);
        return result;
    };
    DeviceForWorkOrderDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["name"] = this.name;
        return data;
    };
    return DeviceForWorkOrderDetailDto;
}());
export { DeviceForWorkOrderDetailDto };
var MaintenanceReportForWorkOrderDetailDto = /** @class */ (function () {
    function MaintenanceReportForWorkOrderDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MaintenanceReportForWorkOrderDetailDto.prototype.init = function (data) {
        if (data) {
            this.faultTypeName = data["faultTypeName"];
            this.faultDescription = data["faultDescription"];
            this.treatmentResult = data["treatmentResult"];
            this.isCheckExposedDevice = data["isCheckExposedDevice"];
            this.exposedDeviceMaintenanceMemo = data["exposedDeviceMaintenanceMemo"];
            this.isCheckInnerDevicePart = data["isCheckInnerDevicePart"];
            this.innerDeviceMaintenanceMemo = data["innerDeviceMaintenanceMemo"];
            this.isChangeDeviceParts = data["isChangeDeviceParts"];
            this.changeDevicePartMaintenanceMemo = data["changeDevicePartMaintenanceMemo"];
            this.isChangeOil = data["isChangeOil"];
            this.changeOilMaintenanceMemo = data["changeOilMaintenanceMemo"];
            this.isCheckAllFunction = data["isCheckAllFunction"];
            this.checkAllMaintenanceMemo = data["checkAllMaintenanceMemo"];
            this.isBackupWorkData = data["isBackupWorkData"];
            this.backupDataMaintenanceMemo = data["backupDataMaintenanceMemo"];
            this.isAdvanced = data["isAdvanced"];
            this.advancedMaintenanceMemo = data["advancedMaintenanceMemo"];
        }
    };
    MaintenanceReportForWorkOrderDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MaintenanceReportForWorkOrderDetailDto();
        result.init(data);
        return result;
    };
    MaintenanceReportForWorkOrderDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["faultTypeName"] = this.faultTypeName;
        data["faultDescription"] = this.faultDescription;
        data["treatmentResult"] = this.treatmentResult;
        data["isCheckExposedDevice"] = this.isCheckExposedDevice;
        data["exposedDeviceMaintenanceMemo"] = this.exposedDeviceMaintenanceMemo;
        data["isCheckInnerDevicePart"] = this.isCheckInnerDevicePart;
        data["innerDeviceMaintenanceMemo"] = this.innerDeviceMaintenanceMemo;
        data["isChangeDeviceParts"] = this.isChangeDeviceParts;
        data["changeDevicePartMaintenanceMemo"] = this.changeDevicePartMaintenanceMemo;
        data["isChangeOil"] = this.isChangeOil;
        data["changeOilMaintenanceMemo"] = this.changeOilMaintenanceMemo;
        data["isCheckAllFunction"] = this.isCheckAllFunction;
        data["checkAllMaintenanceMemo"] = this.checkAllMaintenanceMemo;
        data["isBackupWorkData"] = this.isBackupWorkData;
        data["backupDataMaintenanceMemo"] = this.backupDataMaintenanceMemo;
        data["isAdvanced"] = this.isAdvanced;
        data["advancedMaintenanceMemo"] = this.advancedMaintenanceMemo;
        return data;
    };
    return MaintenanceReportForWorkOrderDetailDto;
}());
export { MaintenanceReportForWorkOrderDetailDto };
var WorkOrderProgressDto = /** @class */ (function () {
    function WorkOrderProgressDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkOrderProgressDto.prototype.init = function (data) {
        if (data) {
            this.handlerName = data["handlerName"];
            this.state = data["state"];
            this.handleTime = data["handleTime"] ? moment(data["handleTime"].toString()) : undefined;
            if (data["parameters"]) {
                this.parameters = {};
                for (var key in data["parameters"]) {
                    if (data["parameters"].hasOwnProperty(key))
                        this.parameters[key] = data["parameters"][key];
                }
            }
        }
    };
    WorkOrderProgressDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkOrderProgressDto();
        result.init(data);
        return result;
    };
    WorkOrderProgressDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["handlerName"] = this.handlerName;
        data["state"] = this.state;
        data["handleTime"] = this.handleTime ? this.handleTime.toISOString() : undefined;
        if (this.parameters) {
            data["parameters"] = {};
            for (var key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    data["parameters"][key] = this.parameters[key];
            }
        }
        return data;
    };
    return WorkOrderProgressDto;
}());
export { WorkOrderProgressDto };
var WorkOrderImage = /** @class */ (function () {
    function WorkOrderImage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkOrderImage.prototype.init = function (data) {
        if (data) {
            this.workOrderId = data["workOrderId"];
            this.thumbId = data["thumbId"];
            this.imageId = data["imageId"];
            this.id = data["id"];
        }
    };
    WorkOrderImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkOrderImage();
        result.init(data);
        return result;
    };
    WorkOrderImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["thumbId"] = this.thumbId;
        data["imageId"] = this.imageId;
        data["id"] = this.id;
        return data;
    };
    return WorkOrderImage;
}());
export { WorkOrderImage };
var ListResultDtoOfExecutorNameDto = /** @class */ (function () {
    function ListResultDtoOfExecutorNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfExecutorNameDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ExecutorNameDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfExecutorNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfExecutorNameDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfExecutorNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfExecutorNameDto;
}());
export { ListResultDtoOfExecutorNameDto };
var ExecutorNameDto = /** @class */ (function () {
    function ExecutorNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExecutorNameDto.prototype.init = function (data) {
        if (data) {
            this.executorName = data["executorName"];
        }
    };
    ExecutorNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExecutorNameDto();
        result.init(data);
        return result;
    };
    ExecutorNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["executorName"] = this.executorName;
        return data;
    };
    return ExecutorNameDto;
}());
export { ExecutorNameDto };
var ListResultDtoOfCompanyNameDto = /** @class */ (function () {
    function ListResultDtoOfCompanyNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfCompanyNameDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CompanyNameDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfCompanyNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfCompanyNameDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfCompanyNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfCompanyNameDto;
}());
export { ListResultDtoOfCompanyNameDto };
var CompanyNameDto = /** @class */ (function () {
    function CompanyNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyNameDto.prototype.init = function (data) {
        if (data) {
            this.companyName = data["companyName"];
        }
    };
    CompanyNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyNameDto();
        result.init(data);
        return result;
    };
    CompanyNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        return data;
    };
    return CompanyNameDto;
}());
export { CompanyNameDto };
var ListResultDtoOfAssignerNameDto = /** @class */ (function () {
    function ListResultDtoOfAssignerNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfAssignerNameDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(AssignerNameDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfAssignerNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfAssignerNameDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfAssignerNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfAssignerNameDto;
}());
export { ListResultDtoOfAssignerNameDto };
var AssignerNameDto = /** @class */ (function () {
    function AssignerNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssignerNameDto.prototype.init = function (data) {
        if (data) {
            this.assignerName = data["assignerName"];
        }
    };
    AssignerNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssignerNameDto();
        result.init(data);
        return result;
    };
    AssignerNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assignerName"] = this.assignerName;
        return data;
    };
    return AssignerNameDto;
}());
export { AssignerNameDto };
var CreateWorkOrderDto = /** @class */ (function () {
    function CreateWorkOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateWorkOrderDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.deviceId = data["deviceId"];
            this.executorId = data["executorId"];
            this.executorName = data["executorName"];
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(WorkOrderImageDto.fromJS(item));
                }
            }
            this.customerName = data["customerName"];
            this.customerConcat = data["customerConcat"];
        }
    };
    CreateWorkOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateWorkOrderDto();
        result.init(data);
        return result;
    };
    CreateWorkOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["deviceId"] = this.deviceId;
        data["executorId"] = this.executorId;
        data["executorName"] = this.executorName;
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["customerName"] = this.customerName;
        data["customerConcat"] = this.customerConcat;
        return data;
    };
    return CreateWorkOrderDto;
}());
export { CreateWorkOrderDto };
var WorkOrderImageDto = /** @class */ (function () {
    function WorkOrderImageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkOrderImageDto.prototype.init = function (data) {
        if (data) {
            this.thumbId = data["thumbId"];
            this.imageId = data["imageId"];
        }
    };
    WorkOrderImageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkOrderImageDto();
        result.init(data);
        return result;
    };
    WorkOrderImageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["thumbId"] = this.thumbId;
        data["imageId"] = this.imageId;
        return data;
    };
    return WorkOrderImageDto;
}());
export { WorkOrderImageDto };
var WorkOrderSerialNumberDto = /** @class */ (function () {
    function WorkOrderSerialNumberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkOrderSerialNumberDto.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"];
        }
    };
    WorkOrderSerialNumberDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkOrderSerialNumberDto();
        result.init(data);
        return result;
    };
    WorkOrderSerialNumberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        return data;
    };
    return WorkOrderSerialNumberDto;
}());
export { WorkOrderSerialNumberDto };
var PagedResultDtoOfWorkOrderDto = /** @class */ (function () {
    function PagedResultDtoOfWorkOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfWorkOrderDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(WorkOrderDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfWorkOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfWorkOrderDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfWorkOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfWorkOrderDto;
}());
export { PagedResultDtoOfWorkOrderDto };
var WorkOrderDto = /** @class */ (function () {
    function WorkOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkOrderDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.serialNumber = data["serialNumber"];
            this.description = data["description"];
            this.state = data["state"];
            this.deviceName = data["deviceName"];
            this.executorName = data["executorName"];
            this.customerCompanyName = data["customerCompanyName"];
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(WorkOrderImage.fromJS(item));
                }
            }
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.workOrderType = data["workOrderType"];
        }
    };
    WorkOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkOrderDto();
        result.init(data);
        return result;
    };
    WorkOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["description"] = this.description;
        data["state"] = this.state;
        data["deviceName"] = this.deviceName;
        data["executorName"] = this.executorName;
        data["customerCompanyName"] = this.customerCompanyName;
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["workOrderType"] = this.workOrderType;
        return data;
    };
    return WorkOrderDto;
}());
export { WorkOrderDto };
var PagedResultDtoOfMyWorkOrderDto = /** @class */ (function () {
    function PagedResultDtoOfMyWorkOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfMyWorkOrderDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(MyWorkOrderDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfMyWorkOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfMyWorkOrderDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfMyWorkOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfMyWorkOrderDto;
}());
export { PagedResultDtoOfMyWorkOrderDto };
var MyWorkOrderDto = /** @class */ (function () {
    function MyWorkOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MyWorkOrderDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.serialNumber = data["serialNumber"];
            this.description = data["description"];
            this.state = data["state"];
            this.deviceName = data["deviceName"];
            this.customerCompanyName = data["customerCompanyName"];
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(WorkOrderImage.fromJS(item));
                }
            }
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.workOrderType = data["workOrderType"];
        }
    };
    MyWorkOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MyWorkOrderDto();
        result.init(data);
        return result;
    };
    MyWorkOrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["description"] = this.description;
        data["state"] = this.state;
        data["deviceName"] = this.deviceName;
        data["customerCompanyName"] = this.customerCompanyName;
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["workOrderType"] = this.workOrderType;
        return data;
    };
    return MyWorkOrderDto;
}());
export { MyWorkOrderDto };
var ExportWorkOrderListDto = /** @class */ (function () {
    function ExportWorkOrderListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportWorkOrderListDto.prototype.init = function (data) {
        if (data) {
            this.executorName = data["executorName"];
            this.baseFilter = data["baseFilter"];
            this.state = data["state"];
            this.customerName = data["customerName"];
            this.assignerName = data["assignerName"];
            this.assignStartTime = data["assignStartTime"] ? moment(data["assignStartTime"].toString()) : undefined;
            this.assignEndTime = data["assignEndTime"] ? moment(data["assignEndTime"].toString()) : undefined;
            this.finishStartTime = data["finishStartTime"] ? moment(data["finishStartTime"].toString()) : undefined;
            this.finishEndTime = data["finishEndTime"] ? moment(data["finishEndTime"].toString()) : undefined;
            this.workOrderType = data["workOrderType"];
        }
    };
    ExportWorkOrderListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportWorkOrderListDto();
        result.init(data);
        return result;
    };
    ExportWorkOrderListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["executorName"] = this.executorName;
        data["baseFilter"] = this.baseFilter;
        data["state"] = this.state;
        data["customerName"] = this.customerName;
        data["assignerName"] = this.assignerName;
        data["assignStartTime"] = this.assignStartTime ? this.assignStartTime.toISOString() : undefined;
        data["assignEndTime"] = this.assignEndTime ? this.assignEndTime.toISOString() : undefined;
        data["finishStartTime"] = this.finishStartTime ? this.finishStartTime.toISOString() : undefined;
        data["finishEndTime"] = this.finishEndTime ? this.finishEndTime.toISOString() : undefined;
        data["workOrderType"] = this.workOrderType;
        return data;
    };
    return ExportWorkOrderListDto;
}());
export { ExportWorkOrderListDto };
var ExportMyWorkOrderListDto = /** @class */ (function () {
    function ExportMyWorkOrderListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportMyWorkOrderListDto.prototype.init = function (data) {
        if (data) {
            this.baseFilter = data["baseFilter"];
            this.state = data["state"];
            this.customerName = data["customerName"];
            this.assignerName = data["assignerName"];
            this.assignStartTime = data["assignStartTime"] ? moment(data["assignStartTime"].toString()) : undefined;
            this.assignEndTime = data["assignEndTime"] ? moment(data["assignEndTime"].toString()) : undefined;
            this.finishStartTime = data["finishStartTime"] ? moment(data["finishStartTime"].toString()) : undefined;
            this.finishEndTime = data["finishEndTime"] ? moment(data["finishEndTime"].toString()) : undefined;
            this.workOrderType = data["workOrderType"];
        }
    };
    ExportMyWorkOrderListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportMyWorkOrderListDto();
        result.init(data);
        return result;
    };
    ExportMyWorkOrderListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["baseFilter"] = this.baseFilter;
        data["state"] = this.state;
        data["customerName"] = this.customerName;
        data["assignerName"] = this.assignerName;
        data["assignStartTime"] = this.assignStartTime ? this.assignStartTime.toISOString() : undefined;
        data["assignEndTime"] = this.assignEndTime ? this.assignEndTime.toISOString() : undefined;
        data["finishStartTime"] = this.finishStartTime ? this.finishStartTime.toISOString() : undefined;
        data["finishEndTime"] = this.finishEndTime ? this.finishEndTime.toISOString() : undefined;
        data["workOrderType"] = this.workOrderType;
        return data;
    };
    return ExportMyWorkOrderListDto;
}());
export { ExportMyWorkOrderListDto };
/** 告警来源 */
export var AlarmDataSource;
(function (AlarmDataSource) {
    AlarmDataSource[AlarmDataSource["_0"] = 0] = "_0";
    AlarmDataSource[AlarmDataSource["_1"] = 1] = "_1";
})(AlarmDataSource || (AlarmDataSource = {}));
/** 告警级别 */
export var AlarmLevel;
(function (AlarmLevel) {
    AlarmLevel[AlarmLevel["_0"] = 0] = "_0";
    AlarmLevel[AlarmLevel["_1"] = 1] = "_1";
    AlarmLevel[AlarmLevel["_2"] = 2] = "_2";
    AlarmLevel[AlarmLevel["_3"] = 3] = "_3";
})(AlarmLevel || (AlarmLevel = {}));
export var ViewType;
(function (ViewType) {
    ViewType[ViewType["_0"] = 0] = "_0";
    ViewType[ViewType["_1"] = 1] = "_1";
    ViewType[ViewType["_2"] = 2] = "_2";
    ViewType[ViewType["_3"] = 3] = "_3";
})(ViewType || (ViewType = {}));
export var Type;
(function (Type) {
    Type[Type["_0"] = 0] = "_0";
    Type[Type["_1"] = 1] = "_1";
    Type[Type["_2"] = 2] = "_2";
    Type[Type["_3"] = 3] = "_3";
})(Type || (Type = {}));
export var ReportDisplayType;
(function (ReportDisplayType) {
    ReportDisplayType[ReportDisplayType["_0"] = 0] = "_0";
    ReportDisplayType[ReportDisplayType["_1"] = 1] = "_1";
    ReportDisplayType[ReportDisplayType["_2"] = 2] = "_2";
    ReportDisplayType[ReportDisplayType["_3"] = 3] = "_3";
    ReportDisplayType[ReportDisplayType["_4"] = 4] = "_4";
    ReportDisplayType[ReportDisplayType["_5"] = 5] = "_5";
})(ReportDisplayType || (ReportDisplayType = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["_0"] = 0] = "_0";
    DocumentType[DocumentType["_1"] = 1] = "_1";
    DocumentType[DocumentType["_2"] = 2] = "_2";
    DocumentType[DocumentType["_3"] = 3] = "_3";
    DocumentType[DocumentType["_4"] = 4] = "_4";
    DocumentType[DocumentType["_5"] = 5] = "_5";
})(DocumentType || (DocumentType = {}));
/** 设备状态 */
export var DeviceCommunicateState;
(function (DeviceCommunicateState) {
    DeviceCommunicateState[DeviceCommunicateState["_1"] = 1] = "_1";
    DeviceCommunicateState[DeviceCommunicateState["_3"] = 3] = "_3";
    DeviceCommunicateState[DeviceCommunicateState["_4"] = 4] = "_4";
    DeviceCommunicateState[DeviceCommunicateState["_5"] = 5] = "_5";
})(DeviceCommunicateState || (DeviceCommunicateState = {}));
/** 设备状态 */
export var DeviceCommunicateState2;
(function (DeviceCommunicateState2) {
    DeviceCommunicateState2[DeviceCommunicateState2["_1"] = 1] = "_1";
    DeviceCommunicateState2[DeviceCommunicateState2["_3"] = 3] = "_3";
    DeviceCommunicateState2[DeviceCommunicateState2["_4"] = 4] = "_4";
    DeviceCommunicateState2[DeviceCommunicateState2["_5"] = 5] = "_5";
})(DeviceCommunicateState2 || (DeviceCommunicateState2 = {}));
export var OrganizationRole;
(function (OrganizationRole) {
    OrganizationRole[OrganizationRole["_1"] = 1] = "_1";
    OrganizationRole[OrganizationRole["_2"] = 2] = "_2";
    OrganizationRole[OrganizationRole["_3"] = 3] = "_3";
    OrganizationRole[OrganizationRole["_4"] = 4] = "_4";
    OrganizationRole[OrganizationRole["_5"] = 5] = "_5";
    OrganizationRole[OrganizationRole["_6"] = 6] = "_6";
    OrganizationRole[OrganizationRole["_7"] = 7] = "_7";
})(OrganizationRole || (OrganizationRole = {}));
export var OrganizationLevel;
(function (OrganizationLevel) {
    OrganizationLevel[OrganizationLevel["_1"] = 1] = "_1";
    OrganizationLevel[OrganizationLevel["_2"] = 2] = "_2";
    OrganizationLevel[OrganizationLevel["_3"] = 3] = "_3";
    OrganizationLevel[OrganizationLevel["_4"] = 4] = "_4";
})(OrganizationLevel || (OrganizationLevel = {}));
/** 组织角色 */
export var Role;
(function (Role) {
    Role[Role["_1"] = 1] = "_1";
    Role[Role["_2"] = 2] = "_2";
    Role[Role["_3"] = 3] = "_3";
    Role[Role["_4"] = 4] = "_4";
    Role[Role["_5"] = 5] = "_5";
    Role[Role["_6"] = 6] = "_6";
    Role[Role["_7"] = 7] = "_7";
})(Role || (Role = {}));
/** 组织级别 */
export var Level;
(function (Level) {
    Level[Level["_1"] = 1] = "_1";
    Level[Level["_2"] = 2] = "_2";
    Level[Level["_3"] = 3] = "_3";
    Level[Level["_4"] = 4] = "_4";
})(Level || (Level = {}));
/** 状态 */
export var State;
(function (State) {
    State[State["_0"] = 0] = "_0";
    State[State["_1"] = 1] = "_1";
    State[State["_2"] = 2] = "_2";
    State[State["_3"] = 3] = "_3";
})(State || (State = {}));
/** 告警等级 */
export var AlarmLevel2;
(function (AlarmLevel2) {
    AlarmLevel2[AlarmLevel2["_0"] = 0] = "_0";
    AlarmLevel2[AlarmLevel2["_1"] = 1] = "_1";
    AlarmLevel2[AlarmLevel2["_2"] = 2] = "_2";
    AlarmLevel2[AlarmLevel2["_3"] = 3] = "_3";
})(AlarmLevel2 || (AlarmLevel2 = {}));
/** 状态 */
export var State2;
(function (State2) {
    State2[State2["_0"] = 0] = "_0";
    State2[State2["_1"] = 1] = "_1";
})(State2 || (State2 = {}));
export var IncomeStatisticsDateInterval;
(function (IncomeStatisticsDateInterval) {
    IncomeStatisticsDateInterval[IncomeStatisticsDateInterval["_1"] = 1] = "_1";
    IncomeStatisticsDateInterval[IncomeStatisticsDateInterval["_2"] = 2] = "_2";
    IncomeStatisticsDateInterval[IncomeStatisticsDateInterval["_3"] = 3] = "_3";
})(IncomeStatisticsDateInterval || (IncomeStatisticsDateInterval = {}));
export var IncomeStatisticsDateInterval2;
(function (IncomeStatisticsDateInterval2) {
    IncomeStatisticsDateInterval2[IncomeStatisticsDateInterval2["_1"] = 1] = "_1";
    IncomeStatisticsDateInterval2[IncomeStatisticsDateInterval2["_2"] = 2] = "_2";
    IncomeStatisticsDateInterval2[IncomeStatisticsDateInterval2["_3"] = 3] = "_3";
})(IncomeStatisticsDateInterval2 || (IncomeStatisticsDateInterval2 = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType[OrganizationType["_1"] = 1] = "_1";
    OrganizationType[OrganizationType["_2"] = 2] = "_2";
})(OrganizationType || (OrganizationType = {}));
export var DataType;
(function (DataType) {
    DataType[DataType["_1"] = 1] = "_1";
    DataType[DataType["_2"] = 2] = "_2";
    DataType[DataType["_4"] = 4] = "_4";
    DataType[DataType["_8"] = 8] = "_8";
})(DataType || (DataType = {}));
export var RwType;
(function (RwType) {
    RwType[RwType["_2"] = 2] = "_2";
    RwType[RwType["_4"] = 4] = "_4";
    RwType[RwType["_6"] = 6] = "_6";
})(RwType || (RwType = {}));
export var ClientType;
(function (ClientType) {
    ClientType[ClientType["_1"] = 1] = "_1";
    ClientType[ClientType["_2"] = 2] = "_2";
})(ClientType || (ClientType = {}));
/** 维保类型 */
export var WarrantyType;
(function (WarrantyType) {
    WarrantyType[WarrantyType["_1"] = 1] = "_1";
    WarrantyType[WarrantyType["_2"] = 2] = "_2";
})(WarrantyType || (WarrantyType = {}));
/** 计划状态 */
export var PlanState;
(function (PlanState) {
    PlanState[PlanState["_1"] = 1] = "_1";
    PlanState[PlanState["_2"] = 2] = "_2";
    PlanState[PlanState["_4"] = 4] = "_4";
    PlanState[PlanState["_8"] = 8] = "_8";
    PlanState[PlanState["_16"] = 16] = "_16";
})(PlanState || (PlanState = {}));
/** 工单类型 */
export var WorkOrderType;
(function (WorkOrderType) {
    WorkOrderType[WorkOrderType["_1"] = 1] = "_1";
    WorkOrderType[WorkOrderType["_2"] = 2] = "_2";
})(WorkOrderType || (WorkOrderType = {}));
/** 工单状态 */
export var State3;
(function (State3) {
    State3[State3["_1"] = 1] = "_1";
    State3[State3["_512"] = 512] = "_512";
    State3[State3["_1024"] = 1024] = "_1024";
})(State3 || (State3 = {}));
export var State4;
(function (State4) {
    State4[State4["_0"] = 0] = "_0";
    State4[State4["_1"] = 1] = "_1";
})(State4 || (State4 = {}));
export var VariableDataTypes;
(function (VariableDataTypes) {
    VariableDataTypes[VariableDataTypes["_1"] = 1] = "_1";
    VariableDataTypes[VariableDataTypes["_2"] = 2] = "_2";
    VariableDataTypes[VariableDataTypes["_4"] = 4] = "_4";
    VariableDataTypes[VariableDataTypes["_8"] = 8] = "_8";
})(VariableDataTypes || (VariableDataTypes = {}));
/** 状态 */
export var State5;
(function (State5) {
    State5[State5["_0"] = 0] = "_0";
    State5[State5["_10"] = 10] = "_10";
    State5[State5["_20"] = 20] = "_20";
    State5[State5["_999"] = 999] = "_999";
})(State5 || (State5 = {}));
export var Table;
(function (Table) {
    Table[Table["_0"] = 0] = "_0";
    Table[Table["_1"] = 1] = "_1";
    Table[Table["_2"] = 2] = "_2";
    Table[Table["_3"] = 3] = "_3";
    Table[Table["_4"] = 4] = "_4";
})(Table || (Table = {}));
export var Table2;
(function (Table2) {
    Table2[Table2["_0"] = 0] = "_0";
    Table2[Table2["_1"] = 1] = "_1";
    Table2[Table2["_2"] = 2] = "_2";
    Table2[Table2["_3"] = 3] = "_3";
    Table2[Table2["_4"] = 4] = "_4";
})(Table2 || (Table2 = {}));
export var Table3;
(function (Table3) {
    Table3[Table3["_0"] = 0] = "_0";
    Table3[Table3["_1"] = 1] = "_1";
    Table3[Table3["_2"] = 2] = "_2";
    Table3[Table3["_3"] = 3] = "_3";
    Table3[Table3["_4"] = 4] = "_4";
})(Table3 || (Table3 = {}));
export var Table4;
(function (Table4) {
    Table4[Table4["_0"] = 0] = "_0";
    Table4[Table4["_1"] = 1] = "_1";
    Table4[Table4["_2"] = 2] = "_2";
    Table4[Table4["_3"] = 3] = "_3";
    Table4[Table4["_4"] = 4] = "_4";
})(Table4 || (Table4 = {}));
export var Table5;
(function (Table5) {
    Table5[Table5["_0"] = 0] = "_0";
    Table5[Table5["_1"] = 1] = "_1";
    Table5[Table5["_2"] = 2] = "_2";
    Table5[Table5["_3"] = 3] = "_3";
    Table5[Table5["_4"] = 4] = "_4";
})(Table5 || (Table5 = {}));
export var SalesSummaryDatePeriod;
(function (SalesSummaryDatePeriod) {
    SalesSummaryDatePeriod[SalesSummaryDatePeriod["_1"] = 1] = "_1";
    SalesSummaryDatePeriod[SalesSummaryDatePeriod["_2"] = 2] = "_2";
    SalesSummaryDatePeriod[SalesSummaryDatePeriod["_3"] = 3] = "_3";
})(SalesSummaryDatePeriod || (SalesSummaryDatePeriod = {}));
export var SalesSummaryDatePeriod2;
(function (SalesSummaryDatePeriod2) {
    SalesSummaryDatePeriod2[SalesSummaryDatePeriod2["_1"] = 1] = "_1";
    SalesSummaryDatePeriod2[SalesSummaryDatePeriod2["_2"] = 2] = "_2";
    SalesSummaryDatePeriod2[SalesSummaryDatePeriod2["_3"] = 3] = "_3";
})(SalesSummaryDatePeriod2 || (SalesSummaryDatePeriod2 = {}));
/** 审核状态（枚举项：未审核、驳回、已通过） */
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus[ApprovalStatus["_0"] = 0] = "_0";
    ApprovalStatus[ApprovalStatus["_1"] = 1] = "_1";
    ApprovalStatus[ApprovalStatus["_2"] = 2] = "_2";
})(ApprovalStatus || (ApprovalStatus = {}));
export var DefaultTimezoneScope;
(function (DefaultTimezoneScope) {
    DefaultTimezoneScope[DefaultTimezoneScope["_1"] = 1] = "_1";
    DefaultTimezoneScope[DefaultTimezoneScope["_2"] = 2] = "_2";
    DefaultTimezoneScope[DefaultTimezoneScope["_4"] = 4] = "_4";
    DefaultTimezoneScope[DefaultTimezoneScope["_7"] = 7] = "_7";
})(DefaultTimezoneScope || (DefaultTimezoneScope = {}));
export var DataType2;
(function (DataType2) {
    DataType2[DataType2["_1"] = 1] = "_1";
    DataType2[DataType2["_2"] = 2] = "_2";
    DataType2[DataType2["_4"] = 4] = "_4";
    DataType2[DataType2["_8"] = 8] = "_8";
})(DataType2 || (DataType2 = {}));
export var VariableRwType;
(function (VariableRwType) {
    VariableRwType[VariableRwType["_2"] = 2] = "_2";
    VariableRwType[VariableRwType["_4"] = 4] = "_4";
    VariableRwType[VariableRwType["_6"] = 6] = "_6";
})(VariableRwType || (VariableRwType = {}));
export var DataType3;
(function (DataType3) {
    DataType3[DataType3["_1"] = 1] = "_1";
    DataType3[DataType3["_2"] = 2] = "_2";
    DataType3[DataType3["_4"] = 4] = "_4";
    DataType3[DataType3["_8"] = 8] = "_8";
})(DataType3 || (DataType3 = {}));
export var ReadWriteModel;
(function (ReadWriteModel) {
    ReadWriteModel[ReadWriteModel["_2"] = 2] = "_2";
    ReadWriteModel[ReadWriteModel["_4"] = 4] = "_4";
    ReadWriteModel[ReadWriteModel["_6"] = 6] = "_6";
})(ReadWriteModel || (ReadWriteModel = {}));
export var ReadWriteModel2;
(function (ReadWriteModel2) {
    ReadWriteModel2[ReadWriteModel2["_2"] = 2] = "_2";
    ReadWriteModel2[ReadWriteModel2["_4"] = 4] = "_4";
    ReadWriteModel2[ReadWriteModel2["_6"] = 6] = "_6";
})(ReadWriteModel2 || (ReadWriteModel2 = {}));
export var AttendanceTime;
(function (AttendanceTime) {
    AttendanceTime[AttendanceTime["_0"] = 0] = "_0";
    AttendanceTime[AttendanceTime["_1"] = 1] = "_1";
    AttendanceTime[AttendanceTime["_2"] = 2] = "_2";
    AttendanceTime[AttendanceTime["_3"] = 3] = "_3";
})(AttendanceTime || (AttendanceTime = {}));
/** 工单状态 */
export var State6;
(function (State6) {
    State6[State6["_1"] = 1] = "_1";
    State6[State6["_512"] = 512] = "_512";
    State6[State6["_1024"] = 1024] = "_1024";
})(State6 || (State6 = {}));
/** 工单类型 */
export var WorkOrderType2;
(function (WorkOrderType2) {
    WorkOrderType2[WorkOrderType2["_1"] = 1] = "_1";
    WorkOrderType2[WorkOrderType2["_2"] = 2] = "_2";
})(WorkOrderType2 || (WorkOrderType2 = {}));
/** 工单状态 */
export var State7;
(function (State7) {
    State7[State7["_1"] = 1] = "_1";
    State7[State7["_512"] = 512] = "_512";
    State7[State7["_1024"] = 1024] = "_1024";
})(State7 || (State7 = {}));
/** 工单类型 */
export var WorkOrderType3;
(function (WorkOrderType3) {
    WorkOrderType3[WorkOrderType3["_1"] = 1] = "_1";
    WorkOrderType3[WorkOrderType3["_2"] = 2] = "_2";
})(WorkOrderType3 || (WorkOrderType3 = {}));
export var Anonymous;
(function (Anonymous) {
    Anonymous[Anonymous["_0"] = 0] = "_0";
    Anonymous[Anonymous["_1"] = 1] = "_1";
    Anonymous[Anonymous["_2"] = 2] = "_2";
})(Anonymous || (Anonymous = {}));
export var Anonymous2;
(function (Anonymous2) {
    Anonymous2[Anonymous2["_0"] = 0] = "_0";
    Anonymous2[Anonymous2["_1"] = 1] = "_1";
})(Anonymous2 || (Anonymous2 = {}));
export var Anonymous3;
(function (Anonymous3) {
    Anonymous3[Anonymous3["_0"] = 0] = "_0";
    Anonymous3[Anonymous3["_1"] = 1] = "_1";
})(Anonymous3 || (Anonymous3 = {}));
export var Anonymous4;
(function (Anonymous4) {
    Anonymous4[Anonymous4["_0"] = 0] = "_0";
    Anonymous4[Anonymous4["_1"] = 1] = "_1";
})(Anonymous4 || (Anonymous4 = {}));
export var IsTenantAvailableOutputState;
(function (IsTenantAvailableOutputState) {
    IsTenantAvailableOutputState[IsTenantAvailableOutputState["_1"] = 1] = "_1";
    IsTenantAvailableOutputState[IsTenantAvailableOutputState["_2"] = 2] = "_2";
    IsTenantAvailableOutputState[IsTenantAvailableOutputState["_3"] = 3] = "_3";
})(IsTenantAvailableOutputState || (IsTenantAvailableOutputState = {}));
export var AlarmDefListDtoAlarmDataSource;
(function (AlarmDefListDtoAlarmDataSource) {
    AlarmDefListDtoAlarmDataSource[AlarmDefListDtoAlarmDataSource["_0"] = 0] = "_0";
    AlarmDefListDtoAlarmDataSource[AlarmDefListDtoAlarmDataSource["_1"] = 1] = "_1";
})(AlarmDefListDtoAlarmDataSource || (AlarmDefListDtoAlarmDataSource = {}));
export var AlarmDefListDtoAlarmLevel;
(function (AlarmDefListDtoAlarmLevel) {
    AlarmDefListDtoAlarmLevel[AlarmDefListDtoAlarmLevel["_0"] = 0] = "_0";
    AlarmDefListDtoAlarmLevel[AlarmDefListDtoAlarmLevel["_1"] = 1] = "_1";
    AlarmDefListDtoAlarmLevel[AlarmDefListDtoAlarmLevel["_2"] = 2] = "_2";
    AlarmDefListDtoAlarmLevel[AlarmDefListDtoAlarmLevel["_3"] = 3] = "_3";
})(AlarmDefListDtoAlarmLevel || (AlarmDefListDtoAlarmLevel = {}));
export var AlarmDefListDtoTriggerRuleType;
(function (AlarmDefListDtoTriggerRuleType) {
    AlarmDefListDtoTriggerRuleType[AlarmDefListDtoTriggerRuleType["_0"] = 0] = "_0";
    AlarmDefListDtoTriggerRuleType[AlarmDefListDtoTriggerRuleType["_1"] = 1] = "_1";
    AlarmDefListDtoTriggerRuleType[AlarmDefListDtoTriggerRuleType["_2"] = 2] = "_2";
    AlarmDefListDtoTriggerRuleType[AlarmDefListDtoTriggerRuleType["_3"] = 3] = "_3";
})(AlarmDefListDtoTriggerRuleType || (AlarmDefListDtoTriggerRuleType = {}));
export var AlarmDefListDtoVariableDataType;
(function (AlarmDefListDtoVariableDataType) {
    AlarmDefListDtoVariableDataType[AlarmDefListDtoVariableDataType["_1"] = 1] = "_1";
    AlarmDefListDtoVariableDataType[AlarmDefListDtoVariableDataType["_2"] = 2] = "_2";
    AlarmDefListDtoVariableDataType[AlarmDefListDtoVariableDataType["_4"] = 4] = "_4";
    AlarmDefListDtoVariableDataType[AlarmDefListDtoVariableDataType["_8"] = 8] = "_8";
})(AlarmDefListDtoVariableDataType || (AlarmDefListDtoVariableDataType = {}));
export var RefAlarmDtoCondition1;
(function (RefAlarmDtoCondition1) {
    RefAlarmDtoCondition1[RefAlarmDtoCondition1["_0"] = 0] = "_0";
    RefAlarmDtoCondition1[RefAlarmDtoCondition1["_1"] = 1] = "_1";
    RefAlarmDtoCondition1[RefAlarmDtoCondition1["_2"] = 2] = "_2";
    RefAlarmDtoCondition1[RefAlarmDtoCondition1["_3"] = 3] = "_3";
    RefAlarmDtoCondition1[RefAlarmDtoCondition1["_4"] = 4] = "_4";
    RefAlarmDtoCondition1[RefAlarmDtoCondition1["_5"] = 5] = "_5";
})(RefAlarmDtoCondition1 || (RefAlarmDtoCondition1 = {}));
export var RefAlarmDtoCondition2;
(function (RefAlarmDtoCondition2) {
    RefAlarmDtoCondition2[RefAlarmDtoCondition2["_0"] = 0] = "_0";
    RefAlarmDtoCondition2[RefAlarmDtoCondition2["_1"] = 1] = "_1";
    RefAlarmDtoCondition2[RefAlarmDtoCondition2["_2"] = 2] = "_2";
    RefAlarmDtoCondition2[RefAlarmDtoCondition2["_3"] = 3] = "_3";
    RefAlarmDtoCondition2[RefAlarmDtoCondition2["_4"] = 4] = "_4";
    RefAlarmDtoCondition2[RefAlarmDtoCondition2["_5"] = 5] = "_5";
})(RefAlarmDtoCondition2 || (RefAlarmDtoCondition2 = {}));
export var RefAlarmDtoConditionCombineMethod;
(function (RefAlarmDtoConditionCombineMethod) {
    RefAlarmDtoConditionCombineMethod[RefAlarmDtoConditionCombineMethod["_0"] = 0] = "_0";
    RefAlarmDtoConditionCombineMethod[RefAlarmDtoConditionCombineMethod["_1"] = 1] = "_1";
    RefAlarmDtoConditionCombineMethod[RefAlarmDtoConditionCombineMethod["_2"] = 2] = "_2";
})(RefAlarmDtoConditionCombineMethod || (RefAlarmDtoConditionCombineMethod = {}));
export var RefAlarmDtoDataType;
(function (RefAlarmDtoDataType) {
    RefAlarmDtoDataType[RefAlarmDtoDataType["_0"] = 0] = "_0";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_1"] = 1] = "_1";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_2"] = 2] = "_2";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_3"] = 3] = "_3";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_4"] = 4] = "_4";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_5"] = 5] = "_5";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_11"] = 11] = "_11";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_12"] = 12] = "_12";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_13"] = 13] = "_13";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_14"] = 14] = "_14";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_15"] = 15] = "_15";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_16"] = 16] = "_16";
    RefAlarmDtoDataType[RefAlarmDtoDataType["_30"] = 30] = "_30";
})(RefAlarmDtoDataType || (RefAlarmDtoDataType = {}));
export var TriggerRuleValueValue;
(function (TriggerRuleValueValue) {
    TriggerRuleValueValue[TriggerRuleValueValue["_0"] = 0] = "_0";
    TriggerRuleValueValue[TriggerRuleValueValue["_1"] = 1] = "_1";
    TriggerRuleValueValue[TriggerRuleValueValue["_2"] = 2] = "_2";
})(TriggerRuleValueValue || (TriggerRuleValueValue = {}));
export var ThresholdValueCondition1;
(function (ThresholdValueCondition1) {
    ThresholdValueCondition1[ThresholdValueCondition1["_0"] = 0] = "_0";
    ThresholdValueCondition1[ThresholdValueCondition1["_1"] = 1] = "_1";
    ThresholdValueCondition1[ThresholdValueCondition1["_2"] = 2] = "_2";
    ThresholdValueCondition1[ThresholdValueCondition1["_3"] = 3] = "_3";
    ThresholdValueCondition1[ThresholdValueCondition1["_4"] = 4] = "_4";
    ThresholdValueCondition1[ThresholdValueCondition1["_5"] = 5] = "_5";
})(ThresholdValueCondition1 || (ThresholdValueCondition1 = {}));
export var ThresholdValueConditionCombine;
(function (ThresholdValueConditionCombine) {
    ThresholdValueConditionCombine[ThresholdValueConditionCombine["_0"] = 0] = "_0";
    ThresholdValueConditionCombine[ThresholdValueConditionCombine["_1"] = 1] = "_1";
    ThresholdValueConditionCombine[ThresholdValueConditionCombine["_2"] = 2] = "_2";
})(ThresholdValueConditionCombine || (ThresholdValueConditionCombine = {}));
export var ThresholdValueCondition2;
(function (ThresholdValueCondition2) {
    ThresholdValueCondition2[ThresholdValueCondition2["_0"] = 0] = "_0";
    ThresholdValueCondition2[ThresholdValueCondition2["_1"] = 1] = "_1";
    ThresholdValueCondition2[ThresholdValueCondition2["_2"] = 2] = "_2";
    ThresholdValueCondition2[ThresholdValueCondition2["_3"] = 3] = "_3";
    ThresholdValueCondition2[ThresholdValueCondition2["_4"] = 4] = "_4";
    ThresholdValueCondition2[ThresholdValueCondition2["_5"] = 5] = "_5";
})(ThresholdValueCondition2 || (ThresholdValueCondition2 = {}));
export var BatchImportAlarmsDtoEnumHandleDuplicateNameRule;
(function (BatchImportAlarmsDtoEnumHandleDuplicateNameRule) {
    BatchImportAlarmsDtoEnumHandleDuplicateNameRule[BatchImportAlarmsDtoEnumHandleDuplicateNameRule["_0"] = 0] = "_0";
    BatchImportAlarmsDtoEnumHandleDuplicateNameRule[BatchImportAlarmsDtoEnumHandleDuplicateNameRule["_1"] = 1] = "_1";
    BatchImportAlarmsDtoEnumHandleDuplicateNameRule[BatchImportAlarmsDtoEnumHandleDuplicateNameRule["_2"] = 2] = "_2";
})(BatchImportAlarmsDtoEnumHandleDuplicateNameRule || (BatchImportAlarmsDtoEnumHandleDuplicateNameRule = {}));
export var CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource;
(function (CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource) {
    CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource[CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource["_0"] = 0] = "_0";
    CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource[CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource["_1"] = 1] = "_1";
})(CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource || (CreateOrUpdateConfigureAlarmDefDtoAlarmDataSource = {}));
export var CreateOrUpdateConfigureAlarmDefDtoAlarmLevel;
(function (CreateOrUpdateConfigureAlarmDefDtoAlarmLevel) {
    CreateOrUpdateConfigureAlarmDefDtoAlarmLevel[CreateOrUpdateConfigureAlarmDefDtoAlarmLevel["_0"] = 0] = "_0";
    CreateOrUpdateConfigureAlarmDefDtoAlarmLevel[CreateOrUpdateConfigureAlarmDefDtoAlarmLevel["_1"] = 1] = "_1";
    CreateOrUpdateConfigureAlarmDefDtoAlarmLevel[CreateOrUpdateConfigureAlarmDefDtoAlarmLevel["_2"] = 2] = "_2";
    CreateOrUpdateConfigureAlarmDefDtoAlarmLevel[CreateOrUpdateConfigureAlarmDefDtoAlarmLevel["_3"] = 3] = "_3";
})(CreateOrUpdateConfigureAlarmDefDtoAlarmLevel || (CreateOrUpdateConfigureAlarmDefDtoAlarmLevel = {}));
export var CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType;
(function (CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType) {
    CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType[CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType["_0"] = 0] = "_0";
    CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType[CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType["_1"] = 1] = "_1";
    CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType[CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType["_2"] = 2] = "_2";
    CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType[CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType["_3"] = 3] = "_3";
})(CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType || (CreateOrUpdateConfigureAlarmDefDtoTriggerRuleType = {}));
export var BatchModifyAlarmLevelDtoAlarmLevel;
(function (BatchModifyAlarmLevelDtoAlarmLevel) {
    BatchModifyAlarmLevelDtoAlarmLevel[BatchModifyAlarmLevelDtoAlarmLevel["_0"] = 0] = "_0";
    BatchModifyAlarmLevelDtoAlarmLevel[BatchModifyAlarmLevelDtoAlarmLevel["_1"] = 1] = "_1";
    BatchModifyAlarmLevelDtoAlarmLevel[BatchModifyAlarmLevelDtoAlarmLevel["_2"] = 2] = "_2";
    BatchModifyAlarmLevelDtoAlarmLevel[BatchModifyAlarmLevelDtoAlarmLevel["_3"] = 3] = "_3";
})(BatchModifyAlarmLevelDtoAlarmLevel || (BatchModifyAlarmLevelDtoAlarmLevel = {}));
export var AlarmToEditDtoAlarmDataSource;
(function (AlarmToEditDtoAlarmDataSource) {
    AlarmToEditDtoAlarmDataSource[AlarmToEditDtoAlarmDataSource["_0"] = 0] = "_0";
    AlarmToEditDtoAlarmDataSource[AlarmToEditDtoAlarmDataSource["_1"] = 1] = "_1";
})(AlarmToEditDtoAlarmDataSource || (AlarmToEditDtoAlarmDataSource = {}));
export var AlarmToEditDtoVariableDataType;
(function (AlarmToEditDtoVariableDataType) {
    AlarmToEditDtoVariableDataType[AlarmToEditDtoVariableDataType["_1"] = 1] = "_1";
    AlarmToEditDtoVariableDataType[AlarmToEditDtoVariableDataType["_2"] = 2] = "_2";
    AlarmToEditDtoVariableDataType[AlarmToEditDtoVariableDataType["_4"] = 4] = "_4";
    AlarmToEditDtoVariableDataType[AlarmToEditDtoVariableDataType["_8"] = 8] = "_8";
})(AlarmToEditDtoVariableDataType || (AlarmToEditDtoVariableDataType = {}));
export var AlarmToEditDtoAlarmLevel;
(function (AlarmToEditDtoAlarmLevel) {
    AlarmToEditDtoAlarmLevel[AlarmToEditDtoAlarmLevel["_0"] = 0] = "_0";
    AlarmToEditDtoAlarmLevel[AlarmToEditDtoAlarmLevel["_1"] = 1] = "_1";
    AlarmToEditDtoAlarmLevel[AlarmToEditDtoAlarmLevel["_2"] = 2] = "_2";
    AlarmToEditDtoAlarmLevel[AlarmToEditDtoAlarmLevel["_3"] = 3] = "_3";
})(AlarmToEditDtoAlarmLevel || (AlarmToEditDtoAlarmLevel = {}));
export var AlarmToEditDtoTriggerRuleType;
(function (AlarmToEditDtoTriggerRuleType) {
    AlarmToEditDtoTriggerRuleType[AlarmToEditDtoTriggerRuleType["_0"] = 0] = "_0";
    AlarmToEditDtoTriggerRuleType[AlarmToEditDtoTriggerRuleType["_1"] = 1] = "_1";
    AlarmToEditDtoTriggerRuleType[AlarmToEditDtoTriggerRuleType["_2"] = 2] = "_2";
    AlarmToEditDtoTriggerRuleType[AlarmToEditDtoTriggerRuleType["_3"] = 3] = "_3";
})(AlarmToEditDtoTriggerRuleType || (AlarmToEditDtoTriggerRuleType = {}));
export var EntityChangeListDtoChangeType;
(function (EntityChangeListDtoChangeType) {
    EntityChangeListDtoChangeType[EntityChangeListDtoChangeType["_0"] = 0] = "_0";
    EntityChangeListDtoChangeType[EntityChangeListDtoChangeType["_1"] = 1] = "_1";
    EntityChangeListDtoChangeType[EntityChangeListDtoChangeType["_2"] = 2] = "_2";
})(EntityChangeListDtoChangeType || (EntityChangeListDtoChangeType = {}));
export var BatchControlListDtoDataType;
(function (BatchControlListDtoDataType) {
    BatchControlListDtoDataType[BatchControlListDtoDataType["_0"] = 0] = "_0";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_1"] = 1] = "_1";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_2"] = 2] = "_2";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_3"] = 3] = "_3";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_4"] = 4] = "_4";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_5"] = 5] = "_5";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_11"] = 11] = "_11";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_12"] = 12] = "_12";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_13"] = 13] = "_13";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_14"] = 14] = "_14";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_15"] = 15] = "_15";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_16"] = 16] = "_16";
    BatchControlListDtoDataType[BatchControlListDtoDataType["_30"] = 30] = "_30";
})(BatchControlListDtoDataType || (BatchControlListDtoDataType = {}));
export var BatchControlLogListDtoStatus;
(function (BatchControlLogListDtoStatus) {
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_0"] = 0] = "_0";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_1"] = 1] = "_1";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_2"] = 2] = "_2";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_3"] = 3] = "_3";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_31"] = 31] = "_31";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_32"] = 32] = "_32";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_33"] = 33] = "_33";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_34"] = 34] = "_34";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_35"] = 35] = "_35";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_36"] = 36] = "_36";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_37"] = 37] = "_37";
    BatchControlLogListDtoStatus[BatchControlLogListDtoStatus["_38"] = 38] = "_38";
})(BatchControlLogListDtoStatus || (BatchControlLogListDtoStatus = {}));
export var FriendDtoState;
(function (FriendDtoState) {
    FriendDtoState[FriendDtoState["_1"] = 1] = "_1";
    FriendDtoState[FriendDtoState["_2"] = 2] = "_2";
})(FriendDtoState || (FriendDtoState = {}));
export var ChatMessageDtoSide;
(function (ChatMessageDtoSide) {
    ChatMessageDtoSide[ChatMessageDtoSide["_1"] = 1] = "_1";
    ChatMessageDtoSide[ChatMessageDtoSide["_2"] = 2] = "_2";
})(ChatMessageDtoSide || (ChatMessageDtoSide = {}));
export var ChatMessageDtoReadState;
(function (ChatMessageDtoReadState) {
    ChatMessageDtoReadState[ChatMessageDtoReadState["_1"] = 1] = "_1";
    ChatMessageDtoReadState[ChatMessageDtoReadState["_2"] = 2] = "_2";
})(ChatMessageDtoReadState || (ChatMessageDtoReadState = {}));
export var ChatMessageDtoReceiverReadState;
(function (ChatMessageDtoReceiverReadState) {
    ChatMessageDtoReceiverReadState[ChatMessageDtoReceiverReadState["_1"] = 1] = "_1";
    ChatMessageDtoReceiverReadState[ChatMessageDtoReceiverReadState["_2"] = 2] = "_2";
})(ChatMessageDtoReceiverReadState || (ChatMessageDtoReceiverReadState = {}));
export var ConfigureViewListDtoType;
(function (ConfigureViewListDtoType) {
    ConfigureViewListDtoType[ConfigureViewListDtoType["_0"] = 0] = "_0";
    ConfigureViewListDtoType[ConfigureViewListDtoType["_1"] = 1] = "_1";
    ConfigureViewListDtoType[ConfigureViewListDtoType["_2"] = 2] = "_2";
    ConfigureViewListDtoType[ConfigureViewListDtoType["_3"] = 3] = "_3";
})(ConfigureViewListDtoType || (ConfigureViewListDtoType = {}));
export var PlcInfoDtoType;
(function (PlcInfoDtoType) {
    PlcInfoDtoType[PlcInfoDtoType["_0"] = 0] = "_0";
    PlcInfoDtoType[PlcInfoDtoType["_2"] = 2] = "_2";
})(PlcInfoDtoType || (PlcInfoDtoType = {}));
export var PlcInfoDtoPlcDongleFlag;
(function (PlcInfoDtoPlcDongleFlag) {
    PlcInfoDtoPlcDongleFlag[PlcInfoDtoPlcDongleFlag["_0"] = 0] = "_0";
    PlcInfoDtoPlcDongleFlag[PlcInfoDtoPlcDongleFlag["_1"] = 1] = "_1";
    PlcInfoDtoPlcDongleFlag[PlcInfoDtoPlcDongleFlag["_2"] = 2] = "_2";
    PlcInfoDtoPlcDongleFlag[PlcInfoDtoPlcDongleFlag["_3"] = 3] = "_3";
    PlcInfoDtoPlcDongleFlag[PlcInfoDtoPlcDongleFlag["_9"] = 9] = "_9";
})(PlcInfoDtoPlcDongleFlag || (PlcInfoDtoPlcDongleFlag = {}));
export var PlcInfoDtoInterface;
(function (PlcInfoDtoInterface) {
    PlcInfoDtoInterface[PlcInfoDtoInterface["_0"] = 0] = "_0";
    PlcInfoDtoInterface[PlcInfoDtoInterface["_1"] = 1] = "_1";
    PlcInfoDtoInterface[PlcInfoDtoInterface["_2"] = 2] = "_2";
    PlcInfoDtoInterface[PlcInfoDtoInterface["_3"] = 3] = "_3";
    PlcInfoDtoInterface[PlcInfoDtoInterface["_16"] = 16] = "_16";
    PlcInfoDtoInterface[PlcInfoDtoInterface["_85"] = 85] = "_85";
})(PlcInfoDtoInterface || (PlcInfoDtoInterface = {}));
export var PlcInfoDtoParityType;
(function (PlcInfoDtoParityType) {
    PlcInfoDtoParityType[PlcInfoDtoParityType["_0"] = 0] = "_0";
    PlcInfoDtoParityType[PlcInfoDtoParityType["_1"] = 1] = "_1";
    PlcInfoDtoParityType[PlcInfoDtoParityType["_2"] = 2] = "_2";
})(PlcInfoDtoParityType || (PlcInfoDtoParityType = {}));
export var PlcInfoDtoClass;
(function (PlcInfoDtoClass) {
    PlcInfoDtoClass[PlcInfoDtoClass["_0"] = 0] = "_0";
    PlcInfoDtoClass[PlcInfoDtoClass["_1"] = 1] = "_1";
    PlcInfoDtoClass[PlcInfoDtoClass["_2"] = 2] = "_2";
})(PlcInfoDtoClass || (PlcInfoDtoClass = {}));
export var PlcAdvancedSettingsByteOrder16;
(function (PlcAdvancedSettingsByteOrder16) {
    PlcAdvancedSettingsByteOrder16[PlcAdvancedSettingsByteOrder16["_0"] = 0] = "_0";
    PlcAdvancedSettingsByteOrder16[PlcAdvancedSettingsByteOrder16["_1"] = 1] = "_1";
})(PlcAdvancedSettingsByteOrder16 || (PlcAdvancedSettingsByteOrder16 = {}));
export var PlcAdvancedSettingsByteOrder32;
(function (PlcAdvancedSettingsByteOrder32) {
    PlcAdvancedSettingsByteOrder32[PlcAdvancedSettingsByteOrder32["_0"] = 0] = "_0";
    PlcAdvancedSettingsByteOrder32[PlcAdvancedSettingsByteOrder32["_1"] = 1] = "_1";
    PlcAdvancedSettingsByteOrder32[PlcAdvancedSettingsByteOrder32["_2"] = 2] = "_2";
    PlcAdvancedSettingsByteOrder32[PlcAdvancedSettingsByteOrder32["_3"] = 3] = "_3";
})(PlcAdvancedSettingsByteOrder32 || (PlcAdvancedSettingsByteOrder32 = {}));
export var PlcAdvancedSettingsByteOrderFloat;
(function (PlcAdvancedSettingsByteOrderFloat) {
    PlcAdvancedSettingsByteOrderFloat[PlcAdvancedSettingsByteOrderFloat["_0"] = 0] = "_0";
    PlcAdvancedSettingsByteOrderFloat[PlcAdvancedSettingsByteOrderFloat["_1"] = 1] = "_1";
    PlcAdvancedSettingsByteOrderFloat[PlcAdvancedSettingsByteOrderFloat["_2"] = 2] = "_2";
    PlcAdvancedSettingsByteOrderFloat[PlcAdvancedSettingsByteOrderFloat["_3"] = 3] = "_3";
})(PlcAdvancedSettingsByteOrderFloat || (PlcAdvancedSettingsByteOrderFloat = {}));
export var PlcAdvancedSettingsRetryType;
(function (PlcAdvancedSettingsRetryType) {
    PlcAdvancedSettingsRetryType[PlcAdvancedSettingsRetryType["_0"] = 0] = "_0";
    PlcAdvancedSettingsRetryType[PlcAdvancedSettingsRetryType["_1"] = 1] = "_1";
})(PlcAdvancedSettingsRetryType || (PlcAdvancedSettingsRetryType = {}));
export var PlcAdvancedSettingsConnectionType;
(function (PlcAdvancedSettingsConnectionType) {
    PlcAdvancedSettingsConnectionType[PlcAdvancedSettingsConnectionType["_1"] = 1] = "_1";
    PlcAdvancedSettingsConnectionType[PlcAdvancedSettingsConnectionType["_2"] = 2] = "_2";
    PlcAdvancedSettingsConnectionType[PlcAdvancedSettingsConnectionType["_3"] = 3] = "_3";
})(PlcAdvancedSettingsConnectionType || (PlcAdvancedSettingsConnectionType = {}));
export var ConfigureDashboardContentDtoDashboardType;
(function (ConfigureDashboardContentDtoDashboardType) {
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_0"] = 0] = "_0";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_1"] = 1] = "_1";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_2"] = 2] = "_2";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_3"] = 3] = "_3";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_4"] = 4] = "_4";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_5"] = 5] = "_5";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_6"] = 6] = "_6";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_7"] = 7] = "_7";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_8"] = 8] = "_8";
    ConfigureDashboardContentDtoDashboardType[ConfigureDashboardContentDtoDashboardType["_9"] = 9] = "_9";
})(ConfigureDashboardContentDtoDashboardType || (ConfigureDashboardContentDtoDashboardType = {}));
export var EventListDtoVariableDataType;
(function (EventListDtoVariableDataType) {
    EventListDtoVariableDataType[EventListDtoVariableDataType["_1"] = 1] = "_1";
    EventListDtoVariableDataType[EventListDtoVariableDataType["_2"] = 2] = "_2";
    EventListDtoVariableDataType[EventListDtoVariableDataType["_4"] = 4] = "_4";
    EventListDtoVariableDataType[EventListDtoVariableDataType["_8"] = 8] = "_8";
})(EventListDtoVariableDataType || (EventListDtoVariableDataType = {}));
export var EventListDtoTriggerRuleType;
(function (EventListDtoTriggerRuleType) {
    EventListDtoTriggerRuleType[EventListDtoTriggerRuleType["_0"] = 0] = "_0";
    EventListDtoTriggerRuleType[EventListDtoTriggerRuleType["_1"] = 1] = "_1";
    EventListDtoTriggerRuleType[EventListDtoTriggerRuleType["_2"] = 2] = "_2";
    EventListDtoTriggerRuleType[EventListDtoTriggerRuleType["_3"] = 3] = "_3";
})(EventListDtoTriggerRuleType || (EventListDtoTriggerRuleType = {}));
export var EventForEditDtoVariableDataType;
(function (EventForEditDtoVariableDataType) {
    EventForEditDtoVariableDataType[EventForEditDtoVariableDataType["_1"] = 1] = "_1";
    EventForEditDtoVariableDataType[EventForEditDtoVariableDataType["_2"] = 2] = "_2";
    EventForEditDtoVariableDataType[EventForEditDtoVariableDataType["_4"] = 4] = "_4";
    EventForEditDtoVariableDataType[EventForEditDtoVariableDataType["_8"] = 8] = "_8";
})(EventForEditDtoVariableDataType || (EventForEditDtoVariableDataType = {}));
export var EventForEditDtoTriggerRuleType;
(function (EventForEditDtoTriggerRuleType) {
    EventForEditDtoTriggerRuleType[EventForEditDtoTriggerRuleType["_0"] = 0] = "_0";
    EventForEditDtoTriggerRuleType[EventForEditDtoTriggerRuleType["_1"] = 1] = "_1";
    EventForEditDtoTriggerRuleType[EventForEditDtoTriggerRuleType["_2"] = 2] = "_2";
    EventForEditDtoTriggerRuleType[EventForEditDtoTriggerRuleType["_3"] = 3] = "_3";
})(EventForEditDtoTriggerRuleType || (EventForEditDtoTriggerRuleType = {}));
export var CreateOrUpdateEventDtoTriggerRuleType;
(function (CreateOrUpdateEventDtoTriggerRuleType) {
    CreateOrUpdateEventDtoTriggerRuleType[CreateOrUpdateEventDtoTriggerRuleType["_0"] = 0] = "_0";
    CreateOrUpdateEventDtoTriggerRuleType[CreateOrUpdateEventDtoTriggerRuleType["_1"] = 1] = "_1";
    CreateOrUpdateEventDtoTriggerRuleType[CreateOrUpdateEventDtoTriggerRuleType["_2"] = 2] = "_2";
    CreateOrUpdateEventDtoTriggerRuleType[CreateOrUpdateEventDtoTriggerRuleType["_3"] = 3] = "_3";
})(CreateOrUpdateEventDtoTriggerRuleType || (CreateOrUpdateEventDtoTriggerRuleType = {}));
export var ConfigureGraphStateDtoType;
(function (ConfigureGraphStateDtoType) {
    ConfigureGraphStateDtoType[ConfigureGraphStateDtoType["_0"] = 0] = "_0";
    ConfigureGraphStateDtoType[ConfigureGraphStateDtoType["_1"] = 1] = "_1";
})(ConfigureGraphStateDtoType || (ConfigureGraphStateDtoType = {}));
export var ConfigureGraphStateEditDtoType;
(function (ConfigureGraphStateEditDtoType) {
    ConfigureGraphStateEditDtoType[ConfigureGraphStateEditDtoType["_0"] = 0] = "_0";
    ConfigureGraphStateEditDtoType[ConfigureGraphStateEditDtoType["_1"] = 1] = "_1";
})(ConfigureGraphStateEditDtoType || (ConfigureGraphStateEditDtoType = {}));
export var GraphStateResultType;
(function (GraphStateResultType) {
    GraphStateResultType[GraphStateResultType["_0"] = 0] = "_0";
    GraphStateResultType[GraphStateResultType["_1"] = 1] = "_1";
})(GraphStateResultType || (GraphStateResultType = {}));
export var ConfigureVideoDtoVideoType;
(function (ConfigureVideoDtoVideoType) {
    ConfigureVideoDtoVideoType[ConfigureVideoDtoVideoType["_0"] = 0] = "_0";
    ConfigureVideoDtoVideoType[ConfigureVideoDtoVideoType["_1"] = 1] = "_1";
})(ConfigureVideoDtoVideoType || (ConfigureVideoDtoVideoType = {}));
export var ConfigureVideoNameDtoVideoType;
(function (ConfigureVideoNameDtoVideoType) {
    ConfigureVideoNameDtoVideoType[ConfigureVideoNameDtoVideoType["_0"] = 0] = "_0";
    ConfigureVideoNameDtoVideoType[ConfigureVideoNameDtoVideoType["_1"] = 1] = "_1";
})(ConfigureVideoNameDtoVideoType || (ConfigureVideoNameDtoVideoType = {}));
export var CreateOrUpdateViewDtoViewType;
(function (CreateOrUpdateViewDtoViewType) {
    CreateOrUpdateViewDtoViewType[CreateOrUpdateViewDtoViewType["_0"] = 0] = "_0";
    CreateOrUpdateViewDtoViewType[CreateOrUpdateViewDtoViewType["_1"] = 1] = "_1";
    CreateOrUpdateViewDtoViewType[CreateOrUpdateViewDtoViewType["_2"] = 2] = "_2";
    CreateOrUpdateViewDtoViewType[CreateOrUpdateViewDtoViewType["_3"] = 3] = "_3";
})(CreateOrUpdateViewDtoViewType || (CreateOrUpdateViewDtoViewType = {}));
export var ConfigureViewNameDtoType;
(function (ConfigureViewNameDtoType) {
    ConfigureViewNameDtoType[ConfigureViewNameDtoType["_0"] = 0] = "_0";
    ConfigureViewNameDtoType[ConfigureViewNameDtoType["_1"] = 1] = "_1";
    ConfigureViewNameDtoType[ConfigureViewNameDtoType["_2"] = 2] = "_2";
    ConfigureViewNameDtoType[ConfigureViewNameDtoType["_3"] = 3] = "_3";
})(ConfigureViewNameDtoType || (ConfigureViewNameDtoType = {}));
export var ViewConfigureDtoType;
(function (ViewConfigureDtoType) {
    ViewConfigureDtoType[ViewConfigureDtoType["_0"] = 0] = "_0";
    ViewConfigureDtoType[ViewConfigureDtoType["_1"] = 1] = "_1";
    ViewConfigureDtoType[ViewConfigureDtoType["_2"] = 2] = "_2";
    ViewConfigureDtoType[ViewConfigureDtoType["_3"] = 3] = "_3";
})(ViewConfigureDtoType || (ViewConfigureDtoType = {}));
export var UpdateConfigureViewSettingDtoType;
(function (UpdateConfigureViewSettingDtoType) {
    UpdateConfigureViewSettingDtoType[UpdateConfigureViewSettingDtoType["_0"] = 0] = "_0";
    UpdateConfigureViewSettingDtoType[UpdateConfigureViewSettingDtoType["_1"] = 1] = "_1";
    UpdateConfigureViewSettingDtoType[UpdateConfigureViewSettingDtoType["_2"] = 2] = "_2";
    UpdateConfigureViewSettingDtoType[UpdateConfigureViewSettingDtoType["_3"] = 3] = "_3";
})(UpdateConfigureViewSettingDtoType || (UpdateConfigureViewSettingDtoType = {}));
export var GetNotificationOutputDtoRecipientRole;
(function (GetNotificationOutputDtoRecipientRole) {
    GetNotificationOutputDtoRecipientRole[GetNotificationOutputDtoRecipientRole["_0"] = 0] = "_0";
    GetNotificationOutputDtoRecipientRole[GetNotificationOutputDtoRecipientRole["_1"] = 1] = "_1";
})(GetNotificationOutputDtoRecipientRole || (GetNotificationOutputDtoRecipientRole = {}));
export var GetNotificationOutputDtoStatus;
(function (GetNotificationOutputDtoStatus) {
    GetNotificationOutputDtoStatus[GetNotificationOutputDtoStatus["_0"] = 0] = "_0";
    GetNotificationOutputDtoStatus[GetNotificationOutputDtoStatus["_1"] = 1] = "_1";
    GetNotificationOutputDtoStatus[GetNotificationOutputDtoStatus["_2"] = 2] = "_2";
})(GetNotificationOutputDtoStatus || (GetNotificationOutputDtoStatus = {}));
export var GetNotificationOutputDtoRecipientType;
(function (GetNotificationOutputDtoRecipientType) {
    GetNotificationOutputDtoRecipientType[GetNotificationOutputDtoRecipientType["_0"] = 0] = "_0";
    GetNotificationOutputDtoRecipientType[GetNotificationOutputDtoRecipientType["_1"] = 1] = "_1";
    GetNotificationOutputDtoRecipientType[GetNotificationOutputDtoRecipientType["_2"] = 2] = "_2";
    GetNotificationOutputDtoRecipientType[GetNotificationOutputDtoRecipientType["_3"] = 3] = "_3";
})(GetNotificationOutputDtoRecipientType || (GetNotificationOutputDtoRecipientType = {}));
export var CreateOrEditCustomManualNotificationInputDtoRecipientRole;
(function (CreateOrEditCustomManualNotificationInputDtoRecipientRole) {
    CreateOrEditCustomManualNotificationInputDtoRecipientRole[CreateOrEditCustomManualNotificationInputDtoRecipientRole["_0"] = 0] = "_0";
    CreateOrEditCustomManualNotificationInputDtoRecipientRole[CreateOrEditCustomManualNotificationInputDtoRecipientRole["_1"] = 1] = "_1";
})(CreateOrEditCustomManualNotificationInputDtoRecipientRole || (CreateOrEditCustomManualNotificationInputDtoRecipientRole = {}));
export var CreateOrEditCustomManualNotificationInputDtoStatus;
(function (CreateOrEditCustomManualNotificationInputDtoStatus) {
    CreateOrEditCustomManualNotificationInputDtoStatus[CreateOrEditCustomManualNotificationInputDtoStatus["_0"] = 0] = "_0";
    CreateOrEditCustomManualNotificationInputDtoStatus[CreateOrEditCustomManualNotificationInputDtoStatus["_1"] = 1] = "_1";
    CreateOrEditCustomManualNotificationInputDtoStatus[CreateOrEditCustomManualNotificationInputDtoStatus["_2"] = 2] = "_2";
})(CreateOrEditCustomManualNotificationInputDtoStatus || (CreateOrEditCustomManualNotificationInputDtoStatus = {}));
export var CreateOrEditCustomManualNotificationInputDtoRecipientType;
(function (CreateOrEditCustomManualNotificationInputDtoRecipientType) {
    CreateOrEditCustomManualNotificationInputDtoRecipientType[CreateOrEditCustomManualNotificationInputDtoRecipientType["_0"] = 0] = "_0";
    CreateOrEditCustomManualNotificationInputDtoRecipientType[CreateOrEditCustomManualNotificationInputDtoRecipientType["_1"] = 1] = "_1";
    CreateOrEditCustomManualNotificationInputDtoRecipientType[CreateOrEditCustomManualNotificationInputDtoRecipientType["_2"] = 2] = "_2";
    CreateOrEditCustomManualNotificationInputDtoRecipientType[CreateOrEditCustomManualNotificationInputDtoRecipientType["_3"] = 3] = "_3";
})(CreateOrEditCustomManualNotificationInputDtoRecipientType || (CreateOrEditCustomManualNotificationInputDtoRecipientType = {}));
export var DashboardPermissionDtoPermissionOwnerType;
(function (DashboardPermissionDtoPermissionOwnerType) {
    DashboardPermissionDtoPermissionOwnerType[DashboardPermissionDtoPermissionOwnerType["_0"] = 0] = "_0";
    DashboardPermissionDtoPermissionOwnerType[DashboardPermissionDtoPermissionOwnerType["_1"] = 1] = "_1";
    DashboardPermissionDtoPermissionOwnerType[DashboardPermissionDtoPermissionOwnerType["_2"] = 2] = "_2";
    DashboardPermissionDtoPermissionOwnerType[DashboardPermissionDtoPermissionOwnerType["_3"] = 3] = "_3";
})(DashboardPermissionDtoPermissionOwnerType || (DashboardPermissionDtoPermissionOwnerType = {}));
export var TargetOwnerPermissionTargetOwnerType;
(function (TargetOwnerPermissionTargetOwnerType) {
    TargetOwnerPermissionTargetOwnerType[TargetOwnerPermissionTargetOwnerType["_0"] = 0] = "_0";
    TargetOwnerPermissionTargetOwnerType[TargetOwnerPermissionTargetOwnerType["_1"] = 1] = "_1";
    TargetOwnerPermissionTargetOwnerType[TargetOwnerPermissionTargetOwnerType["_2"] = 2] = "_2";
    TargetOwnerPermissionTargetOwnerType[TargetOwnerPermissionTargetOwnerType["_3"] = 3] = "_3";
})(TargetOwnerPermissionTargetOwnerType || (TargetOwnerPermissionTargetOwnerType = {}));
export var DashboardOwnerInfoDtoOwnerType;
(function (DashboardOwnerInfoDtoOwnerType) {
    DashboardOwnerInfoDtoOwnerType[DashboardOwnerInfoDtoOwnerType["_0"] = 0] = "_0";
    DashboardOwnerInfoDtoOwnerType[DashboardOwnerInfoDtoOwnerType["_1"] = 1] = "_1";
    DashboardOwnerInfoDtoOwnerType[DashboardOwnerInfoDtoOwnerType["_2"] = 2] = "_2";
    DashboardOwnerInfoDtoOwnerType[DashboardOwnerInfoDtoOwnerType["_3"] = 3] = "_3";
})(DashboardOwnerInfoDtoOwnerType || (DashboardOwnerInfoDtoOwnerType = {}));
export var UserDataPolicy;
(function (UserDataPolicy) {
    UserDataPolicy[UserDataPolicy["_0"] = 0] = "_0";
    UserDataPolicy[UserDataPolicy["_1"] = 1] = "_1";
    UserDataPolicy[UserDataPolicy["_2"] = 2] = "_2";
    UserDataPolicy[UserDataPolicy["_3"] = 3] = "_3";
})(UserDataPolicy || (UserDataPolicy = {}));
export var ReportListDtoReportDisplayType;
(function (ReportListDtoReportDisplayType) {
    ReportListDtoReportDisplayType[ReportListDtoReportDisplayType["_0"] = 0] = "_0";
    ReportListDtoReportDisplayType[ReportListDtoReportDisplayType["_1"] = 1] = "_1";
    ReportListDtoReportDisplayType[ReportListDtoReportDisplayType["_2"] = 2] = "_2";
    ReportListDtoReportDisplayType[ReportListDtoReportDisplayType["_3"] = 3] = "_3";
    ReportListDtoReportDisplayType[ReportListDtoReportDisplayType["_4"] = 4] = "_4";
    ReportListDtoReportDisplayType[ReportListDtoReportDisplayType["_5"] = 5] = "_5";
})(ReportListDtoReportDisplayType || (ReportListDtoReportDisplayType = {}));
export var UpdateDashboardThemeDtoColor;
(function (UpdateDashboardThemeDtoColor) {
    UpdateDashboardThemeDtoColor[UpdateDashboardThemeDtoColor["_0"] = 0] = "_0";
    UpdateDashboardThemeDtoColor[UpdateDashboardThemeDtoColor["_1"] = 1] = "_1";
})(UpdateDashboardThemeDtoColor || (UpdateDashboardThemeDtoColor = {}));
export var DashboardThemeDtoDashboardColor;
(function (DashboardThemeDtoDashboardColor) {
    DashboardThemeDtoDashboardColor[DashboardThemeDtoDashboardColor["_0"] = 0] = "_0";
    DashboardThemeDtoDashboardColor[DashboardThemeDtoDashboardColor["_1"] = 1] = "_1";
})(DashboardThemeDtoDashboardColor || (DashboardThemeDtoDashboardColor = {}));
export var DataSourceDtoDataSourceType;
(function (DataSourceDtoDataSourceType) {
    DataSourceDtoDataSourceType[DataSourceDtoDataSourceType["_1"] = 1] = "_1";
})(DataSourceDtoDataSourceType || (DataSourceDtoDataSourceType = {}));
export var DataSourceDtoType;
(function (DataSourceDtoType) {
    DataSourceDtoType[DataSourceDtoType["_0"] = 0] = "_0";
    DataSourceDtoType[DataSourceDtoType["_1"] = 1] = "_1";
    DataSourceDtoType[DataSourceDtoType["_2"] = 2] = "_2";
    DataSourceDtoType[DataSourceDtoType["_3"] = 3] = "_3";
    DataSourceDtoType[DataSourceDtoType["_4"] = 4] = "_4";
    DataSourceDtoType[DataSourceDtoType["_5"] = 5] = "_5";
})(DataSourceDtoType || (DataSourceDtoType = {}));
export var ImportFromFBoxDtoDataSourceType;
(function (ImportFromFBoxDtoDataSourceType) {
    ImportFromFBoxDtoDataSourceType[ImportFromFBoxDtoDataSourceType["_1"] = 1] = "_1";
})(ImportFromFBoxDtoDataSourceType || (ImportFromFBoxDtoDataSourceType = {}));
export var BuildDataAfterImportCheckRepeatNameDtoDataSourceType;
(function (BuildDataAfterImportCheckRepeatNameDtoDataSourceType) {
    BuildDataAfterImportCheckRepeatNameDtoDataSourceType[BuildDataAfterImportCheckRepeatNameDtoDataSourceType["_1"] = 1] = "_1";
})(BuildDataAfterImportCheckRepeatNameDtoDataSourceType || (BuildDataAfterImportCheckRepeatNameDtoDataSourceType = {}));
export var BuildDataAfterImportDtoDataSourceType;
(function (BuildDataAfterImportDtoDataSourceType) {
    BuildDataAfterImportDtoDataSourceType[BuildDataAfterImportDtoDataSourceType["_1"] = 1] = "_1";
})(BuildDataAfterImportDtoDataSourceType || (BuildDataAfterImportDtoDataSourceType = {}));
export var BuildDataAfterImportDtoRenameType;
(function (BuildDataAfterImportDtoRenameType) {
    BuildDataAfterImportDtoRenameType[BuildDataAfterImportDtoRenameType["_0"] = 0] = "_0";
    BuildDataAfterImportDtoRenameType[BuildDataAfterImportDtoRenameType["_1"] = 1] = "_1";
    BuildDataAfterImportDtoRenameType[BuildDataAfterImportDtoRenameType["_2"] = 2] = "_2";
})(BuildDataAfterImportDtoRenameType || (BuildDataAfterImportDtoRenameType = {}));
export var DeviceEditDtoState;
(function (DeviceEditDtoState) {
    DeviceEditDtoState[DeviceEditDtoState["_0"] = 0] = "_0";
    DeviceEditDtoState[DeviceEditDtoState["_1"] = 1] = "_1";
    DeviceEditDtoState[DeviceEditDtoState["_2"] = 2] = "_2";
    DeviceEditDtoState[DeviceEditDtoState["_3"] = 3] = "_3";
    DeviceEditDtoState[DeviceEditDtoState["_4"] = 4] = "_4";
    DeviceEditDtoState[DeviceEditDtoState["_5"] = 5] = "_5";
    DeviceEditDtoState[DeviceEditDtoState["_6"] = 6] = "_6";
    DeviceEditDtoState[DeviceEditDtoState["_7"] = 7] = "_7";
})(DeviceEditDtoState || (DeviceEditDtoState = {}));
export var DeviceEditDtoLocationAcquisitionMode;
(function (DeviceEditDtoLocationAcquisitionMode) {
    DeviceEditDtoLocationAcquisitionMode[DeviceEditDtoLocationAcquisitionMode["_0"] = 0] = "_0";
    DeviceEditDtoLocationAcquisitionMode[DeviceEditDtoLocationAcquisitionMode["_1"] = 1] = "_1";
})(DeviceEditDtoLocationAcquisitionMode || (DeviceEditDtoLocationAcquisitionMode = {}));
export var DeviceState;
(function (DeviceState) {
    DeviceState[DeviceState["_0"] = 0] = "_0";
    DeviceState[DeviceState["_1"] = 1] = "_1";
    DeviceState[DeviceState["_2"] = 2] = "_2";
    DeviceState[DeviceState["_3"] = 3] = "_3";
    DeviceState[DeviceState["_4"] = 4] = "_4";
    DeviceState[DeviceState["_5"] = 5] = "_5";
    DeviceState[DeviceState["_6"] = 6] = "_6";
    DeviceState[DeviceState["_7"] = 7] = "_7";
})(DeviceState || (DeviceState = {}));
export var DeviceLocationAcquisitionMode;
(function (DeviceLocationAcquisitionMode) {
    DeviceLocationAcquisitionMode[DeviceLocationAcquisitionMode["_0"] = 0] = "_0";
    DeviceLocationAcquisitionMode[DeviceLocationAcquisitionMode["_1"] = 1] = "_1";
})(DeviceLocationAcquisitionMode || (DeviceLocationAcquisitionMode = {}));
export var DeviceIssuedState;
(function (DeviceIssuedState) {
    DeviceIssuedState[DeviceIssuedState["_0"] = 0] = "_0";
    DeviceIssuedState[DeviceIssuedState["_1"] = 1] = "_1";
    DeviceIssuedState[DeviceIssuedState["_2"] = 2] = "_2";
})(DeviceIssuedState || (DeviceIssuedState = {}));
export var DeviceIssuedFailedType;
(function (DeviceIssuedFailedType) {
    DeviceIssuedFailedType[DeviceIssuedFailedType["_0"] = 0] = "_0";
    DeviceIssuedFailedType[DeviceIssuedFailedType["_1"] = 1] = "_1";
    DeviceIssuedFailedType[DeviceIssuedFailedType["_2"] = 2] = "_2";
})(DeviceIssuedFailedType || (DeviceIssuedFailedType = {}));
export var CustomFieldDtoDeviceFieldType;
(function (CustomFieldDtoDeviceFieldType) {
    CustomFieldDtoDeviceFieldType[CustomFieldDtoDeviceFieldType["_0"] = 0] = "_0";
    CustomFieldDtoDeviceFieldType[CustomFieldDtoDeviceFieldType["_1"] = 1] = "_1";
    CustomFieldDtoDeviceFieldType[CustomFieldDtoDeviceFieldType["_2"] = 2] = "_2";
    CustomFieldDtoDeviceFieldType[CustomFieldDtoDeviceFieldType["_3"] = 3] = "_3";
})(CustomFieldDtoDeviceFieldType || (CustomFieldDtoDeviceFieldType = {}));
export var CustomFieldDetailForShowDtoDeviceFieldType;
(function (CustomFieldDetailForShowDtoDeviceFieldType) {
    CustomFieldDetailForShowDtoDeviceFieldType[CustomFieldDetailForShowDtoDeviceFieldType["_0"] = 0] = "_0";
    CustomFieldDetailForShowDtoDeviceFieldType[CustomFieldDetailForShowDtoDeviceFieldType["_1"] = 1] = "_1";
    CustomFieldDetailForShowDtoDeviceFieldType[CustomFieldDetailForShowDtoDeviceFieldType["_2"] = 2] = "_2";
    CustomFieldDetailForShowDtoDeviceFieldType[CustomFieldDetailForShowDtoDeviceFieldType["_3"] = 3] = "_3";
})(CustomFieldDetailForShowDtoDeviceFieldType || (CustomFieldDetailForShowDtoDeviceFieldType = {}));
export var DeviceDashboardContentDtoDashboardType;
(function (DeviceDashboardContentDtoDashboardType) {
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_0"] = 0] = "_0";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_1"] = 1] = "_1";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_2"] = 2] = "_2";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_3"] = 3] = "_3";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_4"] = 4] = "_4";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_5"] = 5] = "_5";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_6"] = 6] = "_6";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_7"] = 7] = "_7";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_8"] = 8] = "_8";
    DeviceDashboardContentDtoDashboardType[DeviceDashboardContentDtoDashboardType["_9"] = 9] = "_9";
})(DeviceDashboardContentDtoDashboardType || (DeviceDashboardContentDtoDashboardType = {}));
export var DeviceDashboardContentDtoDisplayType;
(function (DeviceDashboardContentDtoDisplayType) {
    DeviceDashboardContentDtoDisplayType[DeviceDashboardContentDtoDisplayType["_0"] = 0] = "_0";
    DeviceDashboardContentDtoDisplayType[DeviceDashboardContentDtoDisplayType["_1"] = 1] = "_1";
    DeviceDashboardContentDtoDisplayType[DeviceDashboardContentDtoDisplayType["_2"] = 2] = "_2";
    DeviceDashboardContentDtoDisplayType[DeviceDashboardContentDtoDisplayType["_3"] = 3] = "_3";
    DeviceDashboardContentDtoDisplayType[DeviceDashboardContentDtoDisplayType["_4"] = 4] = "_4";
    DeviceDashboardContentDtoDisplayType[DeviceDashboardContentDtoDisplayType["_5"] = 5] = "_5";
})(DeviceDashboardContentDtoDisplayType || (DeviceDashboardContentDtoDisplayType = {}));
export var DeviceDashboardOrderDtoMonitorType;
(function (DeviceDashboardOrderDtoMonitorType) {
    DeviceDashboardOrderDtoMonitorType[DeviceDashboardOrderDtoMonitorType["_0"] = 0] = "_0";
    DeviceDashboardOrderDtoMonitorType[DeviceDashboardOrderDtoMonitorType["_1"] = 1] = "_1";
    DeviceDashboardOrderDtoMonitorType[DeviceDashboardOrderDtoMonitorType["_2"] = 2] = "_2";
    DeviceDashboardOrderDtoMonitorType[DeviceDashboardOrderDtoMonitorType["_3"] = 3] = "_3";
    DeviceDashboardOrderDtoMonitorType[DeviceDashboardOrderDtoMonitorType["_4"] = 4] = "_4";
})(DeviceDashboardOrderDtoMonitorType || (DeviceDashboardOrderDtoMonitorType = {}));
export var DeviceDetailDtoVirtualDeviceState;
(function (DeviceDetailDtoVirtualDeviceState) {
    DeviceDetailDtoVirtualDeviceState[DeviceDetailDtoVirtualDeviceState["_1"] = 1] = "_1";
    DeviceDetailDtoVirtualDeviceState[DeviceDetailDtoVirtualDeviceState["_3"] = 3] = "_3";
    DeviceDetailDtoVirtualDeviceState[DeviceDetailDtoVirtualDeviceState["_4"] = 4] = "_4";
    DeviceDetailDtoVirtualDeviceState[DeviceDetailDtoVirtualDeviceState["_5"] = 5] = "_5";
})(DeviceDetailDtoVirtualDeviceState || (DeviceDetailDtoVirtualDeviceState = {}));
export var DeviceDetailDtoState;
(function (DeviceDetailDtoState) {
    DeviceDetailDtoState[DeviceDetailDtoState["_0"] = 0] = "_0";
    DeviceDetailDtoState[DeviceDetailDtoState["_1"] = 1] = "_1";
    DeviceDetailDtoState[DeviceDetailDtoState["_2"] = 2] = "_2";
    DeviceDetailDtoState[DeviceDetailDtoState["_3"] = 3] = "_3";
    DeviceDetailDtoState[DeviceDetailDtoState["_4"] = 4] = "_4";
    DeviceDetailDtoState[DeviceDetailDtoState["_5"] = 5] = "_5";
    DeviceDetailDtoState[DeviceDetailDtoState["_6"] = 6] = "_6";
    DeviceDetailDtoState[DeviceDetailDtoState["_7"] = 7] = "_7";
})(DeviceDetailDtoState || (DeviceDetailDtoState = {}));
export var DeviceDetailDtoPermissionCategory;
(function (DeviceDetailDtoPermissionCategory) {
    DeviceDetailDtoPermissionCategory[DeviceDetailDtoPermissionCategory["_0"] = 0] = "_0";
    DeviceDetailDtoPermissionCategory[DeviceDetailDtoPermissionCategory["_1"] = 1] = "_1";
})(DeviceDetailDtoPermissionCategory || (DeviceDetailDtoPermissionCategory = {}));
export var DeviceModelListDtoPermissionCategory;
(function (DeviceModelListDtoPermissionCategory) {
    DeviceModelListDtoPermissionCategory[DeviceModelListDtoPermissionCategory["_0"] = 0] = "_0";
    DeviceModelListDtoPermissionCategory[DeviceModelListDtoPermissionCategory["_1"] = 1] = "_1";
})(DeviceModelListDtoPermissionCategory || (DeviceModelListDtoPermissionCategory = {}));
export var DeviceBaseInfoDtoPermissionCategory;
(function (DeviceBaseInfoDtoPermissionCategory) {
    DeviceBaseInfoDtoPermissionCategory[DeviceBaseInfoDtoPermissionCategory["_0"] = 0] = "_0";
    DeviceBaseInfoDtoPermissionCategory[DeviceBaseInfoDtoPermissionCategory["_1"] = 1] = "_1";
})(DeviceBaseInfoDtoPermissionCategory || (DeviceBaseInfoDtoPermissionCategory = {}));
export var DeviceDocumentDtoDocumentType;
(function (DeviceDocumentDtoDocumentType) {
    DeviceDocumentDtoDocumentType[DeviceDocumentDtoDocumentType["_0"] = 0] = "_0";
    DeviceDocumentDtoDocumentType[DeviceDocumentDtoDocumentType["_1"] = 1] = "_1";
    DeviceDocumentDtoDocumentType[DeviceDocumentDtoDocumentType["_2"] = 2] = "_2";
    DeviceDocumentDtoDocumentType[DeviceDocumentDtoDocumentType["_3"] = 3] = "_3";
    DeviceDocumentDtoDocumentType[DeviceDocumentDtoDocumentType["_4"] = 4] = "_4";
    DeviceDocumentDtoDocumentType[DeviceDocumentDtoDocumentType["_5"] = 5] = "_5";
})(DeviceDocumentDtoDocumentType || (DeviceDocumentDtoDocumentType = {}));
export var CreateDeviceGroupDtoType;
(function (CreateDeviceGroupDtoType) {
    CreateDeviceGroupDtoType[CreateDeviceGroupDtoType["_1"] = 1] = "_1";
    CreateDeviceGroupDtoType[CreateDeviceGroupDtoType["_2"] = 2] = "_2";
})(CreateDeviceGroupDtoType || (CreateDeviceGroupDtoType = {}));
export var DeviceGroupDtoType;
(function (DeviceGroupDtoType) {
    DeviceGroupDtoType[DeviceGroupDtoType["_1"] = 1] = "_1";
    DeviceGroupDtoType[DeviceGroupDtoType["_2"] = 2] = "_2";
})(DeviceGroupDtoType || (DeviceGroupDtoType = {}));
export var UpdateDeviceGroupDtoType;
(function (UpdateDeviceGroupDtoType) {
    UpdateDeviceGroupDtoType[UpdateDeviceGroupDtoType["_1"] = 1] = "_1";
    UpdateDeviceGroupDtoType[UpdateDeviceGroupDtoType["_2"] = 2] = "_2";
})(UpdateDeviceGroupDtoType || (UpdateDeviceGroupDtoType = {}));
export var DeviceListDtoActivationErrorType;
(function (DeviceListDtoActivationErrorType) {
    DeviceListDtoActivationErrorType[DeviceListDtoActivationErrorType["_0"] = 0] = "_0";
    DeviceListDtoActivationErrorType[DeviceListDtoActivationErrorType["_1"] = 1] = "_1";
    DeviceListDtoActivationErrorType[DeviceListDtoActivationErrorType["_2"] = 2] = "_2";
    DeviceListDtoActivationErrorType[DeviceListDtoActivationErrorType["_3"] = 3] = "_3";
    DeviceListDtoActivationErrorType[DeviceListDtoActivationErrorType["_888"] = 888] = "_888";
    DeviceListDtoActivationErrorType[DeviceListDtoActivationErrorType["_999"] = 999] = "_999";
})(DeviceListDtoActivationErrorType || (DeviceListDtoActivationErrorType = {}));
export var DeviceListDtoPermissionCategory;
(function (DeviceListDtoPermissionCategory) {
    DeviceListDtoPermissionCategory[DeviceListDtoPermissionCategory["_0"] = 0] = "_0";
    DeviceListDtoPermissionCategory[DeviceListDtoPermissionCategory["_1"] = 1] = "_1";
})(DeviceListDtoPermissionCategory || (DeviceListDtoPermissionCategory = {}));
export var DeviceListDtoDeviceCommunicateState;
(function (DeviceListDtoDeviceCommunicateState) {
    DeviceListDtoDeviceCommunicateState[DeviceListDtoDeviceCommunicateState["_1"] = 1] = "_1";
    DeviceListDtoDeviceCommunicateState[DeviceListDtoDeviceCommunicateState["_3"] = 3] = "_3";
    DeviceListDtoDeviceCommunicateState[DeviceListDtoDeviceCommunicateState["_4"] = 4] = "_4";
    DeviceListDtoDeviceCommunicateState[DeviceListDtoDeviceCommunicateState["_5"] = 5] = "_5";
})(DeviceListDtoDeviceCommunicateState || (DeviceListDtoDeviceCommunicateState = {}));
export var ExportDeviceConditionDeviceCommunicateState;
(function (ExportDeviceConditionDeviceCommunicateState) {
    ExportDeviceConditionDeviceCommunicateState[ExportDeviceConditionDeviceCommunicateState["_1"] = 1] = "_1";
    ExportDeviceConditionDeviceCommunicateState[ExportDeviceConditionDeviceCommunicateState["_3"] = 3] = "_3";
    ExportDeviceConditionDeviceCommunicateState[ExportDeviceConditionDeviceCommunicateState["_4"] = 4] = "_4";
    ExportDeviceConditionDeviceCommunicateState[ExportDeviceConditionDeviceCommunicateState["_5"] = 5] = "_5";
})(ExportDeviceConditionDeviceCommunicateState || (ExportDeviceConditionDeviceCommunicateState = {}));
export var BoxLogDtoBoxEvent;
(function (BoxLogDtoBoxEvent) {
    BoxLogDtoBoxEvent[BoxLogDtoBoxEvent["_1"] = 1] = "_1";
    BoxLogDtoBoxEvent[BoxLogDtoBoxEvent["_3"] = 3] = "_3";
    BoxLogDtoBoxEvent[BoxLogDtoBoxEvent["_7"] = 7] = "_7";
})(BoxLogDtoBoxEvent || (BoxLogDtoBoxEvent = {}));
export var MaintenancePlanDtoWarrantyPeriodCycleType;
(function (MaintenancePlanDtoWarrantyPeriodCycleType) {
    MaintenancePlanDtoWarrantyPeriodCycleType[MaintenancePlanDtoWarrantyPeriodCycleType["_1"] = 1] = "_1";
    MaintenancePlanDtoWarrantyPeriodCycleType[MaintenancePlanDtoWarrantyPeriodCycleType["_2"] = 2] = "_2";
    MaintenancePlanDtoWarrantyPeriodCycleType[MaintenancePlanDtoWarrantyPeriodCycleType["_4"] = 4] = "_4";
    MaintenancePlanDtoWarrantyPeriodCycleType[MaintenancePlanDtoWarrantyPeriodCycleType["_8"] = 8] = "_8";
})(MaintenancePlanDtoWarrantyPeriodCycleType || (MaintenancePlanDtoWarrantyPeriodCycleType = {}));
export var MaintenancePlanDtoWarrantyCycleType;
(function (MaintenancePlanDtoWarrantyCycleType) {
    MaintenancePlanDtoWarrantyCycleType[MaintenancePlanDtoWarrantyCycleType["_1"] = 1] = "_1";
    MaintenancePlanDtoWarrantyCycleType[MaintenancePlanDtoWarrantyCycleType["_2"] = 2] = "_2";
    MaintenancePlanDtoWarrantyCycleType[MaintenancePlanDtoWarrantyCycleType["_4"] = 4] = "_4";
    MaintenancePlanDtoWarrantyCycleType[MaintenancePlanDtoWarrantyCycleType["_8"] = 8] = "_8";
})(MaintenancePlanDtoWarrantyCycleType || (MaintenancePlanDtoWarrantyCycleType = {}));
export var MaintenancePlanDtoNotifyType;
(function (MaintenancePlanDtoNotifyType) {
    MaintenancePlanDtoNotifyType[MaintenancePlanDtoNotifyType["_1"] = 1] = "_1";
    MaintenancePlanDtoNotifyType[MaintenancePlanDtoNotifyType["_2"] = 2] = "_2";
    MaintenancePlanDtoNotifyType[MaintenancePlanDtoNotifyType["_3"] = 3] = "_3";
    MaintenancePlanDtoNotifyType[MaintenancePlanDtoNotifyType["_7"] = 7] = "_7";
    MaintenancePlanDtoNotifyType[MaintenancePlanDtoNotifyType["_14"] = 14] = "_14";
    MaintenancePlanDtoNotifyType[MaintenancePlanDtoNotifyType["_32"] = 32] = "_32";
})(MaintenancePlanDtoNotifyType || (MaintenancePlanDtoNotifyType = {}));
export var MaintenancePlanDtoWarrantyType;
(function (MaintenancePlanDtoWarrantyType) {
    MaintenancePlanDtoWarrantyType[MaintenancePlanDtoWarrantyType["_1"] = 1] = "_1";
    MaintenancePlanDtoWarrantyType[MaintenancePlanDtoWarrantyType["_2"] = 2] = "_2";
})(MaintenancePlanDtoWarrantyType || (MaintenancePlanDtoWarrantyType = {}));
export var MaintenancePlanDtoPlanState;
(function (MaintenancePlanDtoPlanState) {
    MaintenancePlanDtoPlanState[MaintenancePlanDtoPlanState["_1"] = 1] = "_1";
    MaintenancePlanDtoPlanState[MaintenancePlanDtoPlanState["_2"] = 2] = "_2";
    MaintenancePlanDtoPlanState[MaintenancePlanDtoPlanState["_4"] = 4] = "_4";
    MaintenancePlanDtoPlanState[MaintenancePlanDtoPlanState["_8"] = 8] = "_8";
    MaintenancePlanDtoPlanState[MaintenancePlanDtoPlanState["_16"] = 16] = "_16";
})(MaintenancePlanDtoPlanState || (MaintenancePlanDtoPlanState = {}));
export var DeviceModelsOfGroupDtoPermissionCategory;
(function (DeviceModelsOfGroupDtoPermissionCategory) {
    DeviceModelsOfGroupDtoPermissionCategory[DeviceModelsOfGroupDtoPermissionCategory["_0"] = 0] = "_0";
    DeviceModelsOfGroupDtoPermissionCategory[DeviceModelsOfGroupDtoPermissionCategory["_1"] = 1] = "_1";
})(DeviceModelsOfGroupDtoPermissionCategory || (DeviceModelsOfGroupDtoPermissionCategory = {}));
export var DeviceViewDtoVirtualDeviceState;
(function (DeviceViewDtoVirtualDeviceState) {
    DeviceViewDtoVirtualDeviceState[DeviceViewDtoVirtualDeviceState["_1"] = 1] = "_1";
    DeviceViewDtoVirtualDeviceState[DeviceViewDtoVirtualDeviceState["_3"] = 3] = "_3";
    DeviceViewDtoVirtualDeviceState[DeviceViewDtoVirtualDeviceState["_4"] = 4] = "_4";
    DeviceViewDtoVirtualDeviceState[DeviceViewDtoVirtualDeviceState["_5"] = 5] = "_5";
})(DeviceViewDtoVirtualDeviceState || (DeviceViewDtoVirtualDeviceState = {}));
export var DeviceTreeDtoVirtualDeviceState;
(function (DeviceTreeDtoVirtualDeviceState) {
    DeviceTreeDtoVirtualDeviceState[DeviceTreeDtoVirtualDeviceState["_1"] = 1] = "_1";
    DeviceTreeDtoVirtualDeviceState[DeviceTreeDtoVirtualDeviceState["_3"] = 3] = "_3";
    DeviceTreeDtoVirtualDeviceState[DeviceTreeDtoVirtualDeviceState["_4"] = 4] = "_4";
    DeviceTreeDtoVirtualDeviceState[DeviceTreeDtoVirtualDeviceState["_5"] = 5] = "_5";
})(DeviceTreeDtoVirtualDeviceState || (DeviceTreeDtoVirtualDeviceState = {}));
export var DeviceTreeForExtentionDtoVirtualDeviceState;
(function (DeviceTreeForExtentionDtoVirtualDeviceState) {
    DeviceTreeForExtentionDtoVirtualDeviceState[DeviceTreeForExtentionDtoVirtualDeviceState["_1"] = 1] = "_1";
    DeviceTreeForExtentionDtoVirtualDeviceState[DeviceTreeForExtentionDtoVirtualDeviceState["_3"] = 3] = "_3";
    DeviceTreeForExtentionDtoVirtualDeviceState[DeviceTreeForExtentionDtoVirtualDeviceState["_4"] = 4] = "_4";
    DeviceTreeForExtentionDtoVirtualDeviceState[DeviceTreeForExtentionDtoVirtualDeviceState["_5"] = 5] = "_5";
})(DeviceTreeForExtentionDtoVirtualDeviceState || (DeviceTreeForExtentionDtoVirtualDeviceState = {}));
export var DeviceUserPermissionDtoPermissionCategory;
(function (DeviceUserPermissionDtoPermissionCategory) {
    DeviceUserPermissionDtoPermissionCategory[DeviceUserPermissionDtoPermissionCategory["_0"] = 0] = "_0";
    DeviceUserPermissionDtoPermissionCategory[DeviceUserPermissionDtoPermissionCategory["_1"] = 1] = "_1";
})(DeviceUserPermissionDtoPermissionCategory || (DeviceUserPermissionDtoPermissionCategory = {}));
export var ReleasedDataSourceWithPositionDtoType;
(function (ReleasedDataSourceWithPositionDtoType) {
    ReleasedDataSourceWithPositionDtoType[ReleasedDataSourceWithPositionDtoType["_0"] = 0] = "_0";
    ReleasedDataSourceWithPositionDtoType[ReleasedDataSourceWithPositionDtoType["_1"] = 1] = "_1";
    ReleasedDataSourceWithPositionDtoType[ReleasedDataSourceWithPositionDtoType["_2"] = 2] = "_2";
    ReleasedDataSourceWithPositionDtoType[ReleasedDataSourceWithPositionDtoType["_3"] = 3] = "_3";
    ReleasedDataSourceWithPositionDtoType[ReleasedDataSourceWithPositionDtoType["_4"] = 4] = "_4";
    ReleasedDataSourceWithPositionDtoType[ReleasedDataSourceWithPositionDtoType["_5"] = 5] = "_5";
})(ReleasedDataSourceWithPositionDtoType || (ReleasedDataSourceWithPositionDtoType = {}));
export var DeviceRepairBomDataMaterialsType;
(function (DeviceRepairBomDataMaterialsType) {
    DeviceRepairBomDataMaterialsType[DeviceRepairBomDataMaterialsType["_0"] = 0] = "_0";
    DeviceRepairBomDataMaterialsType[DeviceRepairBomDataMaterialsType["_1"] = 1] = "_1";
})(DeviceRepairBomDataMaterialsType || (DeviceRepairBomDataMaterialsType = {}));
export var DeviceRepairBomDataServiceLifeType;
(function (DeviceRepairBomDataServiceLifeType) {
    DeviceRepairBomDataServiceLifeType[DeviceRepairBomDataServiceLifeType["_1"] = 1] = "_1";
    DeviceRepairBomDataServiceLifeType[DeviceRepairBomDataServiceLifeType["_2"] = 2] = "_2";
    DeviceRepairBomDataServiceLifeType[DeviceRepairBomDataServiceLifeType["_4"] = 4] = "_4";
    DeviceRepairBomDataServiceLifeType[DeviceRepairBomDataServiceLifeType["_8"] = 8] = "_8";
})(DeviceRepairBomDataServiceLifeType || (DeviceRepairBomDataServiceLifeType = {}));
export var DeviceRepairBomDataMaintenanceCycleType;
(function (DeviceRepairBomDataMaintenanceCycleType) {
    DeviceRepairBomDataMaintenanceCycleType[DeviceRepairBomDataMaintenanceCycleType["_1"] = 1] = "_1";
    DeviceRepairBomDataMaintenanceCycleType[DeviceRepairBomDataMaintenanceCycleType["_2"] = 2] = "_2";
    DeviceRepairBomDataMaintenanceCycleType[DeviceRepairBomDataMaintenanceCycleType["_4"] = 4] = "_4";
    DeviceRepairBomDataMaintenanceCycleType[DeviceRepairBomDataMaintenanceCycleType["_8"] = 8] = "_8";
})(DeviceRepairBomDataMaintenanceCycleType || (DeviceRepairBomDataMaintenanceCycleType = {}));
export var AddDeviceRepairBomDtoMaterialsType;
(function (AddDeviceRepairBomDtoMaterialsType) {
    AddDeviceRepairBomDtoMaterialsType[AddDeviceRepairBomDtoMaterialsType["_0"] = 0] = "_0";
    AddDeviceRepairBomDtoMaterialsType[AddDeviceRepairBomDtoMaterialsType["_1"] = 1] = "_1";
})(AddDeviceRepairBomDtoMaterialsType || (AddDeviceRepairBomDtoMaterialsType = {}));
export var AddDeviceRepairBomDtoServiceLifeType;
(function (AddDeviceRepairBomDtoServiceLifeType) {
    AddDeviceRepairBomDtoServiceLifeType[AddDeviceRepairBomDtoServiceLifeType["_1"] = 1] = "_1";
    AddDeviceRepairBomDtoServiceLifeType[AddDeviceRepairBomDtoServiceLifeType["_2"] = 2] = "_2";
    AddDeviceRepairBomDtoServiceLifeType[AddDeviceRepairBomDtoServiceLifeType["_4"] = 4] = "_4";
    AddDeviceRepairBomDtoServiceLifeType[AddDeviceRepairBomDtoServiceLifeType["_8"] = 8] = "_8";
})(AddDeviceRepairBomDtoServiceLifeType || (AddDeviceRepairBomDtoServiceLifeType = {}));
export var AddDeviceRepairBomDtoMaintenanceCycleType;
(function (AddDeviceRepairBomDtoMaintenanceCycleType) {
    AddDeviceRepairBomDtoMaintenanceCycleType[AddDeviceRepairBomDtoMaintenanceCycleType["_1"] = 1] = "_1";
    AddDeviceRepairBomDtoMaintenanceCycleType[AddDeviceRepairBomDtoMaintenanceCycleType["_2"] = 2] = "_2";
    AddDeviceRepairBomDtoMaintenanceCycleType[AddDeviceRepairBomDtoMaintenanceCycleType["_4"] = 4] = "_4";
    AddDeviceRepairBomDtoMaintenanceCycleType[AddDeviceRepairBomDtoMaintenanceCycleType["_8"] = 8] = "_8";
})(AddDeviceRepairBomDtoMaintenanceCycleType || (AddDeviceRepairBomDtoMaintenanceCycleType = {}));
export var CreateDocumentDtoPrivilege;
(function (CreateDocumentDtoPrivilege) {
    CreateDocumentDtoPrivilege[CreateDocumentDtoPrivilege["_0"] = 0] = "_0";
    CreateDocumentDtoPrivilege[CreateDocumentDtoPrivilege["_1"] = 1] = "_1";
})(CreateDocumentDtoPrivilege || (CreateDocumentDtoPrivilege = {}));
export var UpdateDocumentDtoPrivilege;
(function (UpdateDocumentDtoPrivilege) {
    UpdateDocumentDtoPrivilege[UpdateDocumentDtoPrivilege["_0"] = 0] = "_0";
    UpdateDocumentDtoPrivilege[UpdateDocumentDtoPrivilege["_1"] = 1] = "_1";
})(UpdateDocumentDtoPrivilege || (UpdateDocumentDtoPrivilege = {}));
export var DocumentListDtoPrivilege;
(function (DocumentListDtoPrivilege) {
    DocumentListDtoPrivilege[DocumentListDtoPrivilege["_0"] = 0] = "_0";
    DocumentListDtoPrivilege[DocumentListDtoPrivilege["_1"] = 1] = "_1";
})(DocumentListDtoPrivilege || (DocumentListDtoPrivilege = {}));
export var ExternalOrganizationListDtoEnumOrganizationRole;
(function (ExternalOrganizationListDtoEnumOrganizationRole) {
    ExternalOrganizationListDtoEnumOrganizationRole[ExternalOrganizationListDtoEnumOrganizationRole["_1"] = 1] = "_1";
    ExternalOrganizationListDtoEnumOrganizationRole[ExternalOrganizationListDtoEnumOrganizationRole["_2"] = 2] = "_2";
    ExternalOrganizationListDtoEnumOrganizationRole[ExternalOrganizationListDtoEnumOrganizationRole["_3"] = 3] = "_3";
    ExternalOrganizationListDtoEnumOrganizationRole[ExternalOrganizationListDtoEnumOrganizationRole["_4"] = 4] = "_4";
    ExternalOrganizationListDtoEnumOrganizationRole[ExternalOrganizationListDtoEnumOrganizationRole["_5"] = 5] = "_5";
    ExternalOrganizationListDtoEnumOrganizationRole[ExternalOrganizationListDtoEnumOrganizationRole["_6"] = 6] = "_6";
    ExternalOrganizationListDtoEnumOrganizationRole[ExternalOrganizationListDtoEnumOrganizationRole["_7"] = 7] = "_7";
})(ExternalOrganizationListDtoEnumOrganizationRole || (ExternalOrganizationListDtoEnumOrganizationRole = {}));
export var ExternalOrganizationListDtoLevel;
(function (ExternalOrganizationListDtoLevel) {
    ExternalOrganizationListDtoLevel[ExternalOrganizationListDtoLevel["_1"] = 1] = "_1";
    ExternalOrganizationListDtoLevel[ExternalOrganizationListDtoLevel["_2"] = 2] = "_2";
    ExternalOrganizationListDtoLevel[ExternalOrganizationListDtoLevel["_3"] = 3] = "_3";
    ExternalOrganizationListDtoLevel[ExternalOrganizationListDtoLevel["_4"] = 4] = "_4";
})(ExternalOrganizationListDtoLevel || (ExternalOrganizationListDtoLevel = {}));
export var OrganizationListForMapDtoType;
(function (OrganizationListForMapDtoType) {
    OrganizationListForMapDtoType[OrganizationListForMapDtoType["_1"] = 1] = "_1";
    OrganizationListForMapDtoType[OrganizationListForMapDtoType["_2"] = 2] = "_2";
})(OrganizationListForMapDtoType || (OrganizationListForMapDtoType = {}));
export var OrganizationListForMapDtoEnumOrganizationRole;
(function (OrganizationListForMapDtoEnumOrganizationRole) {
    OrganizationListForMapDtoEnumOrganizationRole[OrganizationListForMapDtoEnumOrganizationRole["_1"] = 1] = "_1";
    OrganizationListForMapDtoEnumOrganizationRole[OrganizationListForMapDtoEnumOrganizationRole["_2"] = 2] = "_2";
    OrganizationListForMapDtoEnumOrganizationRole[OrganizationListForMapDtoEnumOrganizationRole["_3"] = 3] = "_3";
    OrganizationListForMapDtoEnumOrganizationRole[OrganizationListForMapDtoEnumOrganizationRole["_4"] = 4] = "_4";
    OrganizationListForMapDtoEnumOrganizationRole[OrganizationListForMapDtoEnumOrganizationRole["_5"] = 5] = "_5";
    OrganizationListForMapDtoEnumOrganizationRole[OrganizationListForMapDtoEnumOrganizationRole["_6"] = 6] = "_6";
    OrganizationListForMapDtoEnumOrganizationRole[OrganizationListForMapDtoEnumOrganizationRole["_7"] = 7] = "_7";
})(OrganizationListForMapDtoEnumOrganizationRole || (OrganizationListForMapDtoEnumOrganizationRole = {}));
export var OrganizationListForMapDtoLevel;
(function (OrganizationListForMapDtoLevel) {
    OrganizationListForMapDtoLevel[OrganizationListForMapDtoLevel["_1"] = 1] = "_1";
    OrganizationListForMapDtoLevel[OrganizationListForMapDtoLevel["_2"] = 2] = "_2";
    OrganizationListForMapDtoLevel[OrganizationListForMapDtoLevel["_3"] = 3] = "_3";
    OrganizationListForMapDtoLevel[OrganizationListForMapDtoLevel["_4"] = 4] = "_4";
})(OrganizationListForMapDtoLevel || (OrganizationListForMapDtoLevel = {}));
export var OrganizationForTreeDtoEnumOrganizationRole;
(function (OrganizationForTreeDtoEnumOrganizationRole) {
    OrganizationForTreeDtoEnumOrganizationRole[OrganizationForTreeDtoEnumOrganizationRole["_1"] = 1] = "_1";
    OrganizationForTreeDtoEnumOrganizationRole[OrganizationForTreeDtoEnumOrganizationRole["_2"] = 2] = "_2";
    OrganizationForTreeDtoEnumOrganizationRole[OrganizationForTreeDtoEnumOrganizationRole["_3"] = 3] = "_3";
    OrganizationForTreeDtoEnumOrganizationRole[OrganizationForTreeDtoEnumOrganizationRole["_4"] = 4] = "_4";
    OrganizationForTreeDtoEnumOrganizationRole[OrganizationForTreeDtoEnumOrganizationRole["_5"] = 5] = "_5";
    OrganizationForTreeDtoEnumOrganizationRole[OrganizationForTreeDtoEnumOrganizationRole["_6"] = 6] = "_6";
    OrganizationForTreeDtoEnumOrganizationRole[OrganizationForTreeDtoEnumOrganizationRole["_7"] = 7] = "_7";
})(OrganizationForTreeDtoEnumOrganizationRole || (OrganizationForTreeDtoEnumOrganizationRole = {}));
export var OrganizationAttachmentDtoAttachType;
(function (OrganizationAttachmentDtoAttachType) {
    OrganizationAttachmentDtoAttachType[OrganizationAttachmentDtoAttachType["_1"] = 1] = "_1";
    OrganizationAttachmentDtoAttachType[OrganizationAttachmentDtoAttachType["_2"] = 2] = "_2";
    OrganizationAttachmentDtoAttachType[OrganizationAttachmentDtoAttachType["_3"] = 3] = "_3";
})(OrganizationAttachmentDtoAttachType || (OrganizationAttachmentDtoAttachType = {}));
export var ExternalOrganizationForEditDtoEnumOrganizationRole;
(function (ExternalOrganizationForEditDtoEnumOrganizationRole) {
    ExternalOrganizationForEditDtoEnumOrganizationRole[ExternalOrganizationForEditDtoEnumOrganizationRole["_1"] = 1] = "_1";
    ExternalOrganizationForEditDtoEnumOrganizationRole[ExternalOrganizationForEditDtoEnumOrganizationRole["_2"] = 2] = "_2";
    ExternalOrganizationForEditDtoEnumOrganizationRole[ExternalOrganizationForEditDtoEnumOrganizationRole["_3"] = 3] = "_3";
    ExternalOrganizationForEditDtoEnumOrganizationRole[ExternalOrganizationForEditDtoEnumOrganizationRole["_4"] = 4] = "_4";
    ExternalOrganizationForEditDtoEnumOrganizationRole[ExternalOrganizationForEditDtoEnumOrganizationRole["_5"] = 5] = "_5";
    ExternalOrganizationForEditDtoEnumOrganizationRole[ExternalOrganizationForEditDtoEnumOrganizationRole["_6"] = 6] = "_6";
    ExternalOrganizationForEditDtoEnumOrganizationRole[ExternalOrganizationForEditDtoEnumOrganizationRole["_7"] = 7] = "_7";
})(ExternalOrganizationForEditDtoEnumOrganizationRole || (ExternalOrganizationForEditDtoEnumOrganizationRole = {}));
export var ExternalOrganizationForEditDtoLevel;
(function (ExternalOrganizationForEditDtoLevel) {
    ExternalOrganizationForEditDtoLevel[ExternalOrganizationForEditDtoLevel["_1"] = 1] = "_1";
    ExternalOrganizationForEditDtoLevel[ExternalOrganizationForEditDtoLevel["_2"] = 2] = "_2";
    ExternalOrganizationForEditDtoLevel[ExternalOrganizationForEditDtoLevel["_3"] = 3] = "_3";
    ExternalOrganizationForEditDtoLevel[ExternalOrganizationForEditDtoLevel["_4"] = 4] = "_4";
})(ExternalOrganizationForEditDtoLevel || (ExternalOrganizationForEditDtoLevel = {}));
export var CompanyDetailDtoIndustryType;
(function (CompanyDetailDtoIndustryType) {
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_1"] = 1] = "_1";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_2"] = 2] = "_2";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_3"] = 3] = "_3";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_4"] = 4] = "_4";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_5"] = 5] = "_5";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_6"] = 6] = "_6";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_7"] = 7] = "_7";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_8"] = 8] = "_8";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_9"] = 9] = "_9";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_10"] = 10] = "_10";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_11"] = 11] = "_11";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_12"] = 12] = "_12";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_13"] = 13] = "_13";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_14"] = 14] = "_14";
    CompanyDetailDtoIndustryType[CompanyDetailDtoIndustryType["_15"] = 15] = "_15";
})(CompanyDetailDtoIndustryType || (CompanyDetailDtoIndustryType = {}));
export var CompanyDetailDtoCompanyType;
(function (CompanyDetailDtoCompanyType) {
    CompanyDetailDtoCompanyType[CompanyDetailDtoCompanyType["_1"] = 1] = "_1";
    CompanyDetailDtoCompanyType[CompanyDetailDtoCompanyType["_2"] = 2] = "_2";
    CompanyDetailDtoCompanyType[CompanyDetailDtoCompanyType["_3"] = 3] = "_3";
})(CompanyDetailDtoCompanyType || (CompanyDetailDtoCompanyType = {}));
export var OrganizationContactDtoGender;
(function (OrganizationContactDtoGender) {
    OrganizationContactDtoGender[OrganizationContactDtoGender["_1"] = 1] = "_1";
    OrganizationContactDtoGender[OrganizationContactDtoGender["_2"] = 2] = "_2";
})(OrganizationContactDtoGender || (OrganizationContactDtoGender = {}));
export var OrganizationDetailDtoType;
(function (OrganizationDetailDtoType) {
    OrganizationDetailDtoType[OrganizationDetailDtoType["_1"] = 1] = "_1";
    OrganizationDetailDtoType[OrganizationDetailDtoType["_2"] = 2] = "_2";
})(OrganizationDetailDtoType || (OrganizationDetailDtoType = {}));
export var OrganizationDetailDtoEnumOrganizationRole;
(function (OrganizationDetailDtoEnumOrganizationRole) {
    OrganizationDetailDtoEnumOrganizationRole[OrganizationDetailDtoEnumOrganizationRole["_1"] = 1] = "_1";
    OrganizationDetailDtoEnumOrganizationRole[OrganizationDetailDtoEnumOrganizationRole["_2"] = 2] = "_2";
    OrganizationDetailDtoEnumOrganizationRole[OrganizationDetailDtoEnumOrganizationRole["_3"] = 3] = "_3";
    OrganizationDetailDtoEnumOrganizationRole[OrganizationDetailDtoEnumOrganizationRole["_4"] = 4] = "_4";
    OrganizationDetailDtoEnumOrganizationRole[OrganizationDetailDtoEnumOrganizationRole["_5"] = 5] = "_5";
    OrganizationDetailDtoEnumOrganizationRole[OrganizationDetailDtoEnumOrganizationRole["_6"] = 6] = "_6";
    OrganizationDetailDtoEnumOrganizationRole[OrganizationDetailDtoEnumOrganizationRole["_7"] = 7] = "_7";
})(OrganizationDetailDtoEnumOrganizationRole || (OrganizationDetailDtoEnumOrganizationRole = {}));
export var OrganizationDetailDtoLevel;
(function (OrganizationDetailDtoLevel) {
    OrganizationDetailDtoLevel[OrganizationDetailDtoLevel["_1"] = 1] = "_1";
    OrganizationDetailDtoLevel[OrganizationDetailDtoLevel["_2"] = 2] = "_2";
    OrganizationDetailDtoLevel[OrganizationDetailDtoLevel["_3"] = 3] = "_3";
    OrganizationDetailDtoLevel[OrganizationDetailDtoLevel["_4"] = 4] = "_4";
})(OrganizationDetailDtoLevel || (OrganizationDetailDtoLevel = {}));
export var UserListForDetailDtoDataPolicy;
(function (UserListForDetailDtoDataPolicy) {
    UserListForDetailDtoDataPolicy[UserListForDetailDtoDataPolicy["_0"] = 0] = "_0";
    UserListForDetailDtoDataPolicy[UserListForDetailDtoDataPolicy["_1"] = 1] = "_1";
    UserListForDetailDtoDataPolicy[UserListForDetailDtoDataPolicy["_2"] = 2] = "_2";
    UserListForDetailDtoDataPolicy[UserListForDetailDtoDataPolicy["_3"] = 3] = "_3";
})(UserListForDetailDtoDataPolicy || (UserListForDetailDtoDataPolicy = {}));
export var CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole;
(function (CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole) {
    CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole[CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole["_1"] = 1] = "_1";
    CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole[CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole["_2"] = 2] = "_2";
    CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole[CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole["_3"] = 3] = "_3";
    CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole[CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole["_4"] = 4] = "_4";
    CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole[CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole["_5"] = 5] = "_5";
    CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole[CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole["_6"] = 6] = "_6";
    CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole[CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole["_7"] = 7] = "_7";
})(CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole || (CreateOrUpdateExternalOrganizationDtoEnumOrganizationRole = {}));
export var CreateOrUpdateExternalOrganizationDtoLevel;
(function (CreateOrUpdateExternalOrganizationDtoLevel) {
    CreateOrUpdateExternalOrganizationDtoLevel[CreateOrUpdateExternalOrganizationDtoLevel["_1"] = 1] = "_1";
    CreateOrUpdateExternalOrganizationDtoLevel[CreateOrUpdateExternalOrganizationDtoLevel["_2"] = 2] = "_2";
    CreateOrUpdateExternalOrganizationDtoLevel[CreateOrUpdateExternalOrganizationDtoLevel["_3"] = 3] = "_3";
    CreateOrUpdateExternalOrganizationDtoLevel[CreateOrUpdateExternalOrganizationDtoLevel["_4"] = 4] = "_4";
})(CreateOrUpdateExternalOrganizationDtoLevel || (CreateOrUpdateExternalOrganizationDtoLevel = {}));
export var GetExternalOrganizationListDtoOrganizationRole;
(function (GetExternalOrganizationListDtoOrganizationRole) {
    GetExternalOrganizationListDtoOrganizationRole[GetExternalOrganizationListDtoOrganizationRole["_1"] = 1] = "_1";
    GetExternalOrganizationListDtoOrganizationRole[GetExternalOrganizationListDtoOrganizationRole["_2"] = 2] = "_2";
    GetExternalOrganizationListDtoOrganizationRole[GetExternalOrganizationListDtoOrganizationRole["_3"] = 3] = "_3";
    GetExternalOrganizationListDtoOrganizationRole[GetExternalOrganizationListDtoOrganizationRole["_4"] = 4] = "_4";
    GetExternalOrganizationListDtoOrganizationRole[GetExternalOrganizationListDtoOrganizationRole["_5"] = 5] = "_5";
    GetExternalOrganizationListDtoOrganizationRole[GetExternalOrganizationListDtoOrganizationRole["_6"] = 6] = "_6";
    GetExternalOrganizationListDtoOrganizationRole[GetExternalOrganizationListDtoOrganizationRole["_7"] = 7] = "_7";
})(GetExternalOrganizationListDtoOrganizationRole || (GetExternalOrganizationListDtoOrganizationRole = {}));
export var GetExternalOrganizationListDtoOrganizationLevel;
(function (GetExternalOrganizationListDtoOrganizationLevel) {
    GetExternalOrganizationListDtoOrganizationLevel[GetExternalOrganizationListDtoOrganizationLevel["_1"] = 1] = "_1";
    GetExternalOrganizationListDtoOrganizationLevel[GetExternalOrganizationListDtoOrganizationLevel["_2"] = 2] = "_2";
    GetExternalOrganizationListDtoOrganizationLevel[GetExternalOrganizationListDtoOrganizationLevel["_3"] = 3] = "_3";
    GetExternalOrganizationListDtoOrganizationLevel[GetExternalOrganizationListDtoOrganizationLevel["_4"] = 4] = "_4";
})(GetExternalOrganizationListDtoOrganizationLevel || (GetExternalOrganizationListDtoOrganizationLevel = {}));
export var ExternalOrganizationWithContactDtoEnumOrganizationRole;
(function (ExternalOrganizationWithContactDtoEnumOrganizationRole) {
    ExternalOrganizationWithContactDtoEnumOrganizationRole[ExternalOrganizationWithContactDtoEnumOrganizationRole["_1"] = 1] = "_1";
    ExternalOrganizationWithContactDtoEnumOrganizationRole[ExternalOrganizationWithContactDtoEnumOrganizationRole["_2"] = 2] = "_2";
    ExternalOrganizationWithContactDtoEnumOrganizationRole[ExternalOrganizationWithContactDtoEnumOrganizationRole["_3"] = 3] = "_3";
    ExternalOrganizationWithContactDtoEnumOrganizationRole[ExternalOrganizationWithContactDtoEnumOrganizationRole["_4"] = 4] = "_4";
    ExternalOrganizationWithContactDtoEnumOrganizationRole[ExternalOrganizationWithContactDtoEnumOrganizationRole["_5"] = 5] = "_5";
    ExternalOrganizationWithContactDtoEnumOrganizationRole[ExternalOrganizationWithContactDtoEnumOrganizationRole["_6"] = 6] = "_6";
    ExternalOrganizationWithContactDtoEnumOrganizationRole[ExternalOrganizationWithContactDtoEnumOrganizationRole["_7"] = 7] = "_7";
})(ExternalOrganizationWithContactDtoEnumOrganizationRole || (ExternalOrganizationWithContactDtoEnumOrganizationRole = {}));
export var ExternalOrganizationWithContactDtoLevel;
(function (ExternalOrganizationWithContactDtoLevel) {
    ExternalOrganizationWithContactDtoLevel[ExternalOrganizationWithContactDtoLevel["_1"] = 1] = "_1";
    ExternalOrganizationWithContactDtoLevel[ExternalOrganizationWithContactDtoLevel["_2"] = 2] = "_2";
    ExternalOrganizationWithContactDtoLevel[ExternalOrganizationWithContactDtoLevel["_3"] = 3] = "_3";
    ExternalOrganizationWithContactDtoLevel[ExternalOrganizationWithContactDtoLevel["_4"] = 4] = "_4";
})(ExternalOrganizationWithContactDtoLevel || (ExternalOrganizationWithContactDtoLevel = {}));
export var FBoxServerStateDtoState;
(function (FBoxServerStateDtoState) {
    FBoxServerStateDtoState[FBoxServerStateDtoState["_0"] = 0] = "_0";
    FBoxServerStateDtoState[FBoxServerStateDtoState["_1"] = 1] = "_1";
    FBoxServerStateDtoState[FBoxServerStateDtoState["_2"] = 2] = "_2";
    FBoxServerStateDtoState[FBoxServerStateDtoState["_3"] = 3] = "_3";
    FBoxServerStateDtoState[FBoxServerStateDtoState["_4"] = 4] = "_4";
    FBoxServerStateDtoState[FBoxServerStateDtoState["_5"] = 5] = "_5";
    FBoxServerStateDtoState[FBoxServerStateDtoState["_255"] = 255] = "_255";
})(FBoxServerStateDtoState || (FBoxServerStateDtoState = {}));
export var FBoxAlarmForSingleDataSourceCondition1;
(function (FBoxAlarmForSingleDataSourceCondition1) {
    FBoxAlarmForSingleDataSourceCondition1[FBoxAlarmForSingleDataSourceCondition1["_0"] = 0] = "_0";
    FBoxAlarmForSingleDataSourceCondition1[FBoxAlarmForSingleDataSourceCondition1["_1"] = 1] = "_1";
    FBoxAlarmForSingleDataSourceCondition1[FBoxAlarmForSingleDataSourceCondition1["_2"] = 2] = "_2";
    FBoxAlarmForSingleDataSourceCondition1[FBoxAlarmForSingleDataSourceCondition1["_3"] = 3] = "_3";
    FBoxAlarmForSingleDataSourceCondition1[FBoxAlarmForSingleDataSourceCondition1["_4"] = 4] = "_4";
    FBoxAlarmForSingleDataSourceCondition1[FBoxAlarmForSingleDataSourceCondition1["_5"] = 5] = "_5";
})(FBoxAlarmForSingleDataSourceCondition1 || (FBoxAlarmForSingleDataSourceCondition1 = {}));
export var FBoxAlarmForSingleDataSourceCondition2;
(function (FBoxAlarmForSingleDataSourceCondition2) {
    FBoxAlarmForSingleDataSourceCondition2[FBoxAlarmForSingleDataSourceCondition2["_0"] = 0] = "_0";
    FBoxAlarmForSingleDataSourceCondition2[FBoxAlarmForSingleDataSourceCondition2["_1"] = 1] = "_1";
    FBoxAlarmForSingleDataSourceCondition2[FBoxAlarmForSingleDataSourceCondition2["_2"] = 2] = "_2";
    FBoxAlarmForSingleDataSourceCondition2[FBoxAlarmForSingleDataSourceCondition2["_3"] = 3] = "_3";
    FBoxAlarmForSingleDataSourceCondition2[FBoxAlarmForSingleDataSourceCondition2["_4"] = 4] = "_4";
    FBoxAlarmForSingleDataSourceCondition2[FBoxAlarmForSingleDataSourceCondition2["_5"] = 5] = "_5";
})(FBoxAlarmForSingleDataSourceCondition2 || (FBoxAlarmForSingleDataSourceCondition2 = {}));
export var FBoxAlarmForSingleDataSourceConditionCombineMethod;
(function (FBoxAlarmForSingleDataSourceConditionCombineMethod) {
    FBoxAlarmForSingleDataSourceConditionCombineMethod[FBoxAlarmForSingleDataSourceConditionCombineMethod["_0"] = 0] = "_0";
    FBoxAlarmForSingleDataSourceConditionCombineMethod[FBoxAlarmForSingleDataSourceConditionCombineMethod["_1"] = 1] = "_1";
    FBoxAlarmForSingleDataSourceConditionCombineMethod[FBoxAlarmForSingleDataSourceConditionCombineMethod["_2"] = 2] = "_2";
})(FBoxAlarmForSingleDataSourceConditionCombineMethod || (FBoxAlarmForSingleDataSourceConditionCombineMethod = {}));
export var FBoxAlarmForSingleDataSourceDataType;
(function (FBoxAlarmForSingleDataSourceDataType) {
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_0"] = 0] = "_0";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_1"] = 1] = "_1";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_2"] = 2] = "_2";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_3"] = 3] = "_3";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_4"] = 4] = "_4";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_5"] = 5] = "_5";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_11"] = 11] = "_11";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_12"] = 12] = "_12";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_13"] = 13] = "_13";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_14"] = 14] = "_14";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_15"] = 15] = "_15";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_16"] = 16] = "_16";
    FBoxAlarmForSingleDataSourceDataType[FBoxAlarmForSingleDataSourceDataType["_30"] = 30] = "_30";
})(FBoxAlarmForSingleDataSourceDataType || (FBoxAlarmForSingleDataSourceDataType = {}));
export var FBoxHistoryDataListDtoSampleType;
(function (FBoxHistoryDataListDtoSampleType) {
    FBoxHistoryDataListDtoSampleType[FBoxHistoryDataListDtoSampleType["_0"] = 0] = "_0";
    FBoxHistoryDataListDtoSampleType[FBoxHistoryDataListDtoSampleType["_1"] = 1] = "_1";
})(FBoxHistoryDataListDtoSampleType || (FBoxHistoryDataListDtoSampleType = {}));
export var FBoxHistoryChannelDtoDataType;
(function (FBoxHistoryChannelDtoDataType) {
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_0"] = 0] = "_0";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_1"] = 1] = "_1";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_2"] = 2] = "_2";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_3"] = 3] = "_3";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_4"] = 4] = "_4";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_5"] = 5] = "_5";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_11"] = 11] = "_11";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_12"] = 12] = "_12";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_13"] = 13] = "_13";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_14"] = 14] = "_14";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_15"] = 15] = "_15";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_16"] = 16] = "_16";
    FBoxHistoryChannelDtoDataType[FBoxHistoryChannelDtoDataType["_30"] = 30] = "_30";
})(FBoxHistoryChannelDtoDataType || (FBoxHistoryChannelDtoDataType = {}));
export var FBoxMacroExecutePlanDetailDtoMode;
(function (FBoxMacroExecutePlanDetailDtoMode) {
    FBoxMacroExecutePlanDetailDtoMode[FBoxMacroExecutePlanDetailDtoMode["_0"] = 0] = "_0";
    FBoxMacroExecutePlanDetailDtoMode[FBoxMacroExecutePlanDetailDtoMode["_1"] = 1] = "_1";
    FBoxMacroExecutePlanDetailDtoMode[FBoxMacroExecutePlanDetailDtoMode["_2"] = 2] = "_2";
})(FBoxMacroExecutePlanDetailDtoMode || (FBoxMacroExecutePlanDetailDtoMode = {}));
export var FBoxVariableForSingleDataSourceDtoDataType;
(function (FBoxVariableForSingleDataSourceDtoDataType) {
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_0"] = 0] = "_0";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_1"] = 1] = "_1";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_2"] = 2] = "_2";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_3"] = 3] = "_3";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_4"] = 4] = "_4";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_5"] = 5] = "_5";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_11"] = 11] = "_11";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_12"] = 12] = "_12";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_13"] = 13] = "_13";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_14"] = 14] = "_14";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_15"] = 15] = "_15";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_16"] = 16] = "_16";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_21"] = 21] = "_21";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_22"] = 22] = "_22";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_23"] = 23] = "_23";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_24"] = 24] = "_24";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_25"] = 25] = "_25";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_26"] = 26] = "_26";
    FBoxVariableForSingleDataSourceDtoDataType[FBoxVariableForSingleDataSourceDtoDataType["_30"] = 30] = "_30";
})(FBoxVariableForSingleDataSourceDtoDataType || (FBoxVariableForSingleDataSourceDtoDataType = {}));
export var HistoryAlarmOutputState;
(function (HistoryAlarmOutputState) {
    HistoryAlarmOutputState[HistoryAlarmOutputState["_0"] = 0] = "_0";
    HistoryAlarmOutputState[HistoryAlarmOutputState["_1"] = 1] = "_1";
    HistoryAlarmOutputState[HistoryAlarmOutputState["_2"] = 2] = "_2";
    HistoryAlarmOutputState[HistoryAlarmOutputState["_3"] = 3] = "_3";
})(HistoryAlarmOutputState || (HistoryAlarmOutputState = {}));
export var HistoryAlarmOutputAlarmLevel;
(function (HistoryAlarmOutputAlarmLevel) {
    HistoryAlarmOutputAlarmLevel[HistoryAlarmOutputAlarmLevel["_0"] = 0] = "_0";
    HistoryAlarmOutputAlarmLevel[HistoryAlarmOutputAlarmLevel["_1"] = 1] = "_1";
    HistoryAlarmOutputAlarmLevel[HistoryAlarmOutputAlarmLevel["_2"] = 2] = "_2";
    HistoryAlarmOutputAlarmLevel[HistoryAlarmOutputAlarmLevel["_3"] = 3] = "_3";
})(HistoryAlarmOutputAlarmLevel || (HistoryAlarmOutputAlarmLevel = {}));
export var ExportAlarmFileInputState;
(function (ExportAlarmFileInputState) {
    ExportAlarmFileInputState[ExportAlarmFileInputState["_0"] = 0] = "_0";
    ExportAlarmFileInputState[ExportAlarmFileInputState["_1"] = 1] = "_1";
    ExportAlarmFileInputState[ExportAlarmFileInputState["_2"] = 2] = "_2";
    ExportAlarmFileInputState[ExportAlarmFileInputState["_3"] = 3] = "_3";
})(ExportAlarmFileInputState || (ExportAlarmFileInputState = {}));
export var ExportAlarmFileInputAlarmLevel;
(function (ExportAlarmFileInputAlarmLevel) {
    ExportAlarmFileInputAlarmLevel[ExportAlarmFileInputAlarmLevel["_0"] = 0] = "_0";
    ExportAlarmFileInputAlarmLevel[ExportAlarmFileInputAlarmLevel["_1"] = 1] = "_1";
    ExportAlarmFileInputAlarmLevel[ExportAlarmFileInputAlarmLevel["_2"] = 2] = "_2";
    ExportAlarmFileInputAlarmLevel[ExportAlarmFileInputAlarmLevel["_3"] = 3] = "_3";
})(ExportAlarmFileInputAlarmLevel || (ExportAlarmFileInputAlarmLevel = {}));
export var HistoryDataDtoDataType;
(function (HistoryDataDtoDataType) {
    HistoryDataDtoDataType[HistoryDataDtoDataType["_0"] = 0] = "_0";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_1"] = 1] = "_1";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_2"] = 2] = "_2";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_3"] = 3] = "_3";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_4"] = 4] = "_4";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_5"] = 5] = "_5";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_11"] = 11] = "_11";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_12"] = 12] = "_12";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_13"] = 13] = "_13";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_14"] = 14] = "_14";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_15"] = 15] = "_15";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_16"] = 16] = "_16";
    HistoryDataDtoDataType[HistoryDataDtoDataType["_30"] = 30] = "_30";
})(HistoryDataDtoDataType || (HistoryDataDtoDataType = {}));
export var HistoryDataDtoSampleType;
(function (HistoryDataDtoSampleType) {
    HistoryDataDtoSampleType[HistoryDataDtoSampleType["_0"] = 0] = "_0";
    HistoryDataDtoSampleType[HistoryDataDtoSampleType["_1"] = 1] = "_1";
})(HistoryDataDtoSampleType || (HistoryDataDtoSampleType = {}));
export var FBoxHistoryDataChannelDataType;
(function (FBoxHistoryDataChannelDataType) {
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_0"] = 0] = "_0";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_1"] = 1] = "_1";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_2"] = 2] = "_2";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_3"] = 3] = "_3";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_4"] = 4] = "_4";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_5"] = 5] = "_5";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_11"] = 11] = "_11";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_12"] = 12] = "_12";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_13"] = 13] = "_13";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_14"] = 14] = "_14";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_15"] = 15] = "_15";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_16"] = 16] = "_16";
    FBoxHistoryDataChannelDataType[FBoxHistoryDataChannelDataType["_30"] = 30] = "_30";
})(FBoxHistoryDataChannelDataType || (FBoxHistoryDataChannelDataType = {}));
export var FBoxHistoryDataChannelIoWidth;
(function (FBoxHistoryDataChannelIoWidth) {
    FBoxHistoryDataChannelIoWidth[FBoxHistoryDataChannelIoWidth["_0"] = 0] = "_0";
    FBoxHistoryDataChannelIoWidth[FBoxHistoryDataChannelIoWidth["_1"] = 1] = "_1";
    FBoxHistoryDataChannelIoWidth[FBoxHistoryDataChannelIoWidth["_2"] = 2] = "_2";
    FBoxHistoryDataChannelIoWidth[FBoxHistoryDataChannelIoWidth["_4"] = 4] = "_4";
    FBoxHistoryDataChannelIoWidth[FBoxHistoryDataChannelIoWidth["_8"] = 8] = "_8";
})(FBoxHistoryDataChannelIoWidth || (FBoxHistoryDataChannelIoWidth = {}));
export var BatchImportHistoryDataByDataSourceDtoDataSourceType;
(function (BatchImportHistoryDataByDataSourceDtoDataSourceType) {
    BatchImportHistoryDataByDataSourceDtoDataSourceType[BatchImportHistoryDataByDataSourceDtoDataSourceType["_1"] = 1] = "_1";
})(BatchImportHistoryDataByDataSourceDtoDataSourceType || (BatchImportHistoryDataByDataSourceDtoDataSourceType = {}));
export var HistoryEventOutputState;
(function (HistoryEventOutputState) {
    HistoryEventOutputState[HistoryEventOutputState["_0"] = 0] = "_0";
    HistoryEventOutputState[HistoryEventOutputState["_1"] = 1] = "_1";
})(HistoryEventOutputState || (HistoryEventOutputState = {}));
export var HistoryEventOutputTriggerRuleType;
(function (HistoryEventOutputTriggerRuleType) {
    HistoryEventOutputTriggerRuleType[HistoryEventOutputTriggerRuleType["_0"] = 0] = "_0";
    HistoryEventOutputTriggerRuleType[HistoryEventOutputTriggerRuleType["_1"] = 1] = "_1";
    HistoryEventOutputTriggerRuleType[HistoryEventOutputTriggerRuleType["_2"] = 2] = "_2";
    HistoryEventOutputTriggerRuleType[HistoryEventOutputTriggerRuleType["_3"] = 3] = "_3";
})(HistoryEventOutputTriggerRuleType || (HistoryEventOutputTriggerRuleType = {}));
export var ExportEventFileInputState;
(function (ExportEventFileInputState) {
    ExportEventFileInputState[ExportEventFileInputState["_0"] = 0] = "_0";
    ExportEventFileInputState[ExportEventFileInputState["_1"] = 1] = "_1";
})(ExportEventFileInputState || (ExportEventFileInputState = {}));
export var OrganizationListDtoType;
(function (OrganizationListDtoType) {
    OrganizationListDtoType[OrganizationListDtoType["_1"] = 1] = "_1";
    OrganizationListDtoType[OrganizationListDtoType["_2"] = 2] = "_2";
})(OrganizationListDtoType || (OrganizationListDtoType = {}));
export var OrganizationForEditDtoType;
(function (OrganizationForEditDtoType) {
    OrganizationForEditDtoType[OrganizationForEditDtoType["_1"] = 1] = "_1";
    OrganizationForEditDtoType[OrganizationForEditDtoType["_2"] = 2] = "_2";
})(OrganizationForEditDtoType || (OrganizationForEditDtoType = {}));
export var CreateOrUpdateOrganizationDtoType;
(function (CreateOrUpdateOrganizationDtoType) {
    CreateOrUpdateOrganizationDtoType[CreateOrUpdateOrganizationDtoType["_1"] = 1] = "_1";
    CreateOrUpdateOrganizationDtoType[CreateOrUpdateOrganizationDtoType["_2"] = 2] = "_2";
})(CreateOrUpdateOrganizationDtoType || (CreateOrUpdateOrganizationDtoType = {}));
export var GetOrganizationListDtoOrganizationType;
(function (GetOrganizationListDtoOrganizationType) {
    GetOrganizationListDtoOrganizationType[GetOrganizationListDtoOrganizationType["_1"] = 1] = "_1";
    GetOrganizationListDtoOrganizationType[GetOrganizationListDtoOrganizationType["_2"] = 2] = "_2";
})(GetOrganizationListDtoOrganizationType || (GetOrganizationListDtoOrganizationType = {}));
export var VariableItemForLiveReportDtoDataType;
(function (VariableItemForLiveReportDtoDataType) {
    VariableItemForLiveReportDtoDataType[VariableItemForLiveReportDtoDataType["_1"] = 1] = "_1";
    VariableItemForLiveReportDtoDataType[VariableItemForLiveReportDtoDataType["_2"] = 2] = "_2";
    VariableItemForLiveReportDtoDataType[VariableItemForLiveReportDtoDataType["_4"] = 4] = "_4";
    VariableItemForLiveReportDtoDataType[VariableItemForLiveReportDtoDataType["_8"] = 8] = "_8";
})(VariableItemForLiveReportDtoDataType || (VariableItemForLiveReportDtoDataType = {}));
export var VariableItemForLiveReportDtoVariableRwType;
(function (VariableItemForLiveReportDtoVariableRwType) {
    VariableItemForLiveReportDtoVariableRwType[VariableItemForLiveReportDtoVariableRwType["_2"] = 2] = "_2";
    VariableItemForLiveReportDtoVariableRwType[VariableItemForLiveReportDtoVariableRwType["_4"] = 4] = "_4";
    VariableItemForLiveReportDtoVariableRwType[VariableItemForLiveReportDtoVariableRwType["_6"] = 6] = "_6";
})(VariableItemForLiveReportDtoVariableRwType || (VariableItemForLiveReportDtoVariableRwType = {}));
export var ActionLogInfoDtoActionType;
(function (ActionLogInfoDtoActionType) {
    ActionLogInfoDtoActionType[ActionLogInfoDtoActionType["_1"] = 1] = "_1";
    ActionLogInfoDtoActionType[ActionLogInfoDtoActionType["_2"] = 2] = "_2";
})(ActionLogInfoDtoActionType || (ActionLogInfoDtoActionType = {}));
export var ActionLogInfoDtoClientType;
(function (ActionLogInfoDtoClientType) {
    ActionLogInfoDtoClientType[ActionLogInfoDtoClientType["_1"] = 1] = "_1";
    ActionLogInfoDtoClientType[ActionLogInfoDtoClientType["_2"] = 2] = "_2";
})(ActionLogInfoDtoClientType || (ActionLogInfoDtoClientType = {}));
export var CreateMaintenancePlanDtoWarrantyPeriodCycleType;
(function (CreateMaintenancePlanDtoWarrantyPeriodCycleType) {
    CreateMaintenancePlanDtoWarrantyPeriodCycleType[CreateMaintenancePlanDtoWarrantyPeriodCycleType["_1"] = 1] = "_1";
    CreateMaintenancePlanDtoWarrantyPeriodCycleType[CreateMaintenancePlanDtoWarrantyPeriodCycleType["_2"] = 2] = "_2";
    CreateMaintenancePlanDtoWarrantyPeriodCycleType[CreateMaintenancePlanDtoWarrantyPeriodCycleType["_4"] = 4] = "_4";
    CreateMaintenancePlanDtoWarrantyPeriodCycleType[CreateMaintenancePlanDtoWarrantyPeriodCycleType["_8"] = 8] = "_8";
})(CreateMaintenancePlanDtoWarrantyPeriodCycleType || (CreateMaintenancePlanDtoWarrantyPeriodCycleType = {}));
export var CreateMaintenancePlanDtoWarrantyCycleType;
(function (CreateMaintenancePlanDtoWarrantyCycleType) {
    CreateMaintenancePlanDtoWarrantyCycleType[CreateMaintenancePlanDtoWarrantyCycleType["_1"] = 1] = "_1";
    CreateMaintenancePlanDtoWarrantyCycleType[CreateMaintenancePlanDtoWarrantyCycleType["_2"] = 2] = "_2";
    CreateMaintenancePlanDtoWarrantyCycleType[CreateMaintenancePlanDtoWarrantyCycleType["_4"] = 4] = "_4";
    CreateMaintenancePlanDtoWarrantyCycleType[CreateMaintenancePlanDtoWarrantyCycleType["_8"] = 8] = "_8";
})(CreateMaintenancePlanDtoWarrantyCycleType || (CreateMaintenancePlanDtoWarrantyCycleType = {}));
export var CreateMaintenancePlanDtoNotifyType;
(function (CreateMaintenancePlanDtoNotifyType) {
    CreateMaintenancePlanDtoNotifyType[CreateMaintenancePlanDtoNotifyType["_1"] = 1] = "_1";
    CreateMaintenancePlanDtoNotifyType[CreateMaintenancePlanDtoNotifyType["_2"] = 2] = "_2";
    CreateMaintenancePlanDtoNotifyType[CreateMaintenancePlanDtoNotifyType["_3"] = 3] = "_3";
    CreateMaintenancePlanDtoNotifyType[CreateMaintenancePlanDtoNotifyType["_7"] = 7] = "_7";
    CreateMaintenancePlanDtoNotifyType[CreateMaintenancePlanDtoNotifyType["_14"] = 14] = "_14";
    CreateMaintenancePlanDtoNotifyType[CreateMaintenancePlanDtoNotifyType["_32"] = 32] = "_32";
})(CreateMaintenancePlanDtoNotifyType || (CreateMaintenancePlanDtoNotifyType = {}));
export var ExportMaintenancePlanListDtoWarrantyType;
(function (ExportMaintenancePlanListDtoWarrantyType) {
    ExportMaintenancePlanListDtoWarrantyType[ExportMaintenancePlanListDtoWarrantyType["_1"] = 1] = "_1";
    ExportMaintenancePlanListDtoWarrantyType[ExportMaintenancePlanListDtoWarrantyType["_2"] = 2] = "_2";
})(ExportMaintenancePlanListDtoWarrantyType || (ExportMaintenancePlanListDtoWarrantyType = {}));
export var ExportMaintenancePlanListDtoPlanState;
(function (ExportMaintenancePlanListDtoPlanState) {
    ExportMaintenancePlanListDtoPlanState[ExportMaintenancePlanListDtoPlanState["_1"] = 1] = "_1";
    ExportMaintenancePlanListDtoPlanState[ExportMaintenancePlanListDtoPlanState["_2"] = 2] = "_2";
    ExportMaintenancePlanListDtoPlanState[ExportMaintenancePlanListDtoPlanState["_4"] = 4] = "_4";
    ExportMaintenancePlanListDtoPlanState[ExportMaintenancePlanListDtoPlanState["_8"] = 8] = "_8";
    ExportMaintenancePlanListDtoPlanState[ExportMaintenancePlanListDtoPlanState["_16"] = 16] = "_16";
})(ExportMaintenancePlanListDtoPlanState || (ExportMaintenancePlanListDtoPlanState = {}));
export var MaintenanceRecordDtoState;
(function (MaintenanceRecordDtoState) {
    MaintenanceRecordDtoState[MaintenanceRecordDtoState["_1"] = 1] = "_1";
    MaintenanceRecordDtoState[MaintenanceRecordDtoState["_512"] = 512] = "_512";
    MaintenanceRecordDtoState[MaintenanceRecordDtoState["_1024"] = 1024] = "_1024";
})(MaintenanceRecordDtoState || (MaintenanceRecordDtoState = {}));
export var MaintenanceRecordDtoWorkOrderType;
(function (MaintenanceRecordDtoWorkOrderType) {
    MaintenanceRecordDtoWorkOrderType[MaintenanceRecordDtoWorkOrderType["_1"] = 1] = "_1";
    MaintenanceRecordDtoWorkOrderType[MaintenanceRecordDtoWorkOrderType["_2"] = 2] = "_2";
})(MaintenanceRecordDtoWorkOrderType || (MaintenanceRecordDtoWorkOrderType = {}));
export var CreateShareCodeDtoValidity;
(function (CreateShareCodeDtoValidity) {
    CreateShareCodeDtoValidity[CreateShareCodeDtoValidity["_1"] = 1] = "_1";
    CreateShareCodeDtoValidity[CreateShareCodeDtoValidity["_7"] = 7] = "_7";
})(CreateShareCodeDtoValidity || (CreateShareCodeDtoValidity = {}));
export var UserNotificationState;
(function (UserNotificationState) {
    UserNotificationState[UserNotificationState["_0"] = 0] = "_0";
    UserNotificationState[UserNotificationState["_1"] = 1] = "_1";
})(UserNotificationState || (UserNotificationState = {}));
export var TenantNotificationSeverity;
(function (TenantNotificationSeverity) {
    TenantNotificationSeverity[TenantNotificationSeverity["_0"] = 0] = "_0";
    TenantNotificationSeverity[TenantNotificationSeverity["_1"] = 1] = "_1";
    TenantNotificationSeverity[TenantNotificationSeverity["_2"] = 2] = "_2";
    TenantNotificationSeverity[TenantNotificationSeverity["_3"] = 3] = "_3";
    TenantNotificationSeverity[TenantNotificationSeverity["_4"] = 4] = "_4";
})(TenantNotificationSeverity || (TenantNotificationSeverity = {}));
export var DeviceInfoForMapDtoVirtualDeviceState;
(function (DeviceInfoForMapDtoVirtualDeviceState) {
    DeviceInfoForMapDtoVirtualDeviceState[DeviceInfoForMapDtoVirtualDeviceState["_1"] = 1] = "_1";
    DeviceInfoForMapDtoVirtualDeviceState[DeviceInfoForMapDtoVirtualDeviceState["_3"] = 3] = "_3";
    DeviceInfoForMapDtoVirtualDeviceState[DeviceInfoForMapDtoVirtualDeviceState["_4"] = 4] = "_4";
    DeviceInfoForMapDtoVirtualDeviceState[DeviceInfoForMapDtoVirtualDeviceState["_5"] = 5] = "_5";
})(DeviceInfoForMapDtoVirtualDeviceState || (DeviceInfoForMapDtoVirtualDeviceState = {}));
export var DeviceThumbnailDtoVirtualDeviceState;
(function (DeviceThumbnailDtoVirtualDeviceState) {
    DeviceThumbnailDtoVirtualDeviceState[DeviceThumbnailDtoVirtualDeviceState["_1"] = 1] = "_1";
    DeviceThumbnailDtoVirtualDeviceState[DeviceThumbnailDtoVirtualDeviceState["_3"] = 3] = "_3";
    DeviceThumbnailDtoVirtualDeviceState[DeviceThumbnailDtoVirtualDeviceState["_4"] = 4] = "_4";
    DeviceThumbnailDtoVirtualDeviceState[DeviceThumbnailDtoVirtualDeviceState["_5"] = 5] = "_5";
})(DeviceThumbnailDtoVirtualDeviceState || (DeviceThumbnailDtoVirtualDeviceState = {}));
export var UpdateMapColorDtoColor;
(function (UpdateMapColorDtoColor) {
    UpdateMapColorDtoColor[UpdateMapColorDtoColor["_0"] = 0] = "_0";
    UpdateMapColorDtoColor[UpdateMapColorDtoColor["_1"] = 1] = "_1";
})(UpdateMapColorDtoColor || (UpdateMapColorDtoColor = {}));
export var MapThemeDtoColor;
(function (MapThemeDtoColor) {
    MapThemeDtoColor[MapThemeDtoColor["_0"] = 0] = "_0";
    MapThemeDtoColor[MapThemeDtoColor["_1"] = 1] = "_1";
})(MapThemeDtoColor || (MapThemeDtoColor = {}));
export var OrganizationDeviceDtoPermissionCategory;
(function (OrganizationDeviceDtoPermissionCategory) {
    OrganizationDeviceDtoPermissionCategory[OrganizationDeviceDtoPermissionCategory["_0"] = 0] = "_0";
    OrganizationDeviceDtoPermissionCategory[OrganizationDeviceDtoPermissionCategory["_1"] = 1] = "_1";
})(OrganizationDeviceDtoPermissionCategory || (OrganizationDeviceDtoPermissionCategory = {}));
export var OrganizationDeviceModelDtoPermissionCategory;
(function (OrganizationDeviceModelDtoPermissionCategory) {
    OrganizationDeviceModelDtoPermissionCategory[OrganizationDeviceModelDtoPermissionCategory["_0"] = 0] = "_0";
    OrganizationDeviceModelDtoPermissionCategory[OrganizationDeviceModelDtoPermissionCategory["_1"] = 1] = "_1";
})(OrganizationDeviceModelDtoPermissionCategory || (OrganizationDeviceModelDtoPermissionCategory = {}));
export var OrganizationAssignDeviceDtoPermissionCategory;
(function (OrganizationAssignDeviceDtoPermissionCategory) {
    OrganizationAssignDeviceDtoPermissionCategory[OrganizationAssignDeviceDtoPermissionCategory["_0"] = 0] = "_0";
    OrganizationAssignDeviceDtoPermissionCategory[OrganizationAssignDeviceDtoPermissionCategory["_1"] = 1] = "_1";
})(OrganizationAssignDeviceDtoPermissionCategory || (OrganizationAssignDeviceDtoPermissionCategory = {}));
export var OrganizationAssignDeviceModelDtoPermissionCategory;
(function (OrganizationAssignDeviceModelDtoPermissionCategory) {
    OrganizationAssignDeviceModelDtoPermissionCategory[OrganizationAssignDeviceModelDtoPermissionCategory["_0"] = 0] = "_0";
    OrganizationAssignDeviceModelDtoPermissionCategory[OrganizationAssignDeviceModelDtoPermissionCategory["_1"] = 1] = "_1";
})(OrganizationAssignDeviceModelDtoPermissionCategory || (OrganizationAssignDeviceModelDtoPermissionCategory = {}));
export var OrganizationDevicePermissionDtoPermissionCategory;
(function (OrganizationDevicePermissionDtoPermissionCategory) {
    OrganizationDevicePermissionDtoPermissionCategory[OrganizationDevicePermissionDtoPermissionCategory["_0"] = 0] = "_0";
    OrganizationDevicePermissionDtoPermissionCategory[OrganizationDevicePermissionDtoPermissionCategory["_1"] = 1] = "_1";
})(OrganizationDevicePermissionDtoPermissionCategory || (OrganizationDevicePermissionDtoPermissionCategory = {}));
export var OrganizationDeviceModelPermissionDtoPermissionCategory;
(function (OrganizationDeviceModelPermissionDtoPermissionCategory) {
    OrganizationDeviceModelPermissionDtoPermissionCategory[OrganizationDeviceModelPermissionDtoPermissionCategory["_0"] = 0] = "_0";
    OrganizationDeviceModelPermissionDtoPermissionCategory[OrganizationDeviceModelPermissionDtoPermissionCategory["_1"] = 1] = "_1";
})(OrganizationDeviceModelPermissionDtoPermissionCategory || (OrganizationDeviceModelPermissionDtoPermissionCategory = {}));
export var EditDeviceDataPermissionDtoPermissionCategory;
(function (EditDeviceDataPermissionDtoPermissionCategory) {
    EditDeviceDataPermissionDtoPermissionCategory[EditDeviceDataPermissionDtoPermissionCategory["_0"] = 0] = "_0";
    EditDeviceDataPermissionDtoPermissionCategory[EditDeviceDataPermissionDtoPermissionCategory["_1"] = 1] = "_1";
})(EditDeviceDataPermissionDtoPermissionCategory || (EditDeviceDataPermissionDtoPermissionCategory = {}));
export var EditModelDataPermissionDtoPermissionCategory;
(function (EditModelDataPermissionDtoPermissionCategory) {
    EditModelDataPermissionDtoPermissionCategory[EditModelDataPermissionDtoPermissionCategory["_0"] = 0] = "_0";
    EditModelDataPermissionDtoPermissionCategory[EditModelDataPermissionDtoPermissionCategory["_1"] = 1] = "_1";
})(EditModelDataPermissionDtoPermissionCategory || (EditModelDataPermissionDtoPermissionCategory = {}));
var AdditionalData = /** @class */ (function () {
    function AdditionalData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdditionalData.prototype.init = function (data) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (var key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
        }
    };
    AdditionalData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdditionalData();
        result.init(data);
        return result;
    };
    AdditionalData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (var key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        return data;
    };
    return AdditionalData;
}());
export { AdditionalData };
export var CreatePaymentDtoEditionPaymentType;
(function (CreatePaymentDtoEditionPaymentType) {
    CreatePaymentDtoEditionPaymentType[CreatePaymentDtoEditionPaymentType["_0"] = 0] = "_0";
    CreatePaymentDtoEditionPaymentType[CreatePaymentDtoEditionPaymentType["_1"] = 1] = "_1";
    CreatePaymentDtoEditionPaymentType[CreatePaymentDtoEditionPaymentType["_2"] = 2] = "_2";
    CreatePaymentDtoEditionPaymentType[CreatePaymentDtoEditionPaymentType["_3"] = 3] = "_3";
})(CreatePaymentDtoEditionPaymentType || (CreatePaymentDtoEditionPaymentType = {}));
export var CreatePaymentDtoPaymentPeriodType;
(function (CreatePaymentDtoPaymentPeriodType) {
    CreatePaymentDtoPaymentPeriodType[CreatePaymentDtoPaymentPeriodType["_30"] = 30] = "_30";
    CreatePaymentDtoPaymentPeriodType[CreatePaymentDtoPaymentPeriodType["_365"] = 365] = "_365";
})(CreatePaymentDtoPaymentPeriodType || (CreatePaymentDtoPaymentPeriodType = {}));
export var CreatePaymentDtoSubscriptionPaymentGatewayType;
(function (CreatePaymentDtoSubscriptionPaymentGatewayType) {
    CreatePaymentDtoSubscriptionPaymentGatewayType[CreatePaymentDtoSubscriptionPaymentGatewayType["_1"] = 1] = "_1";
})(CreatePaymentDtoSubscriptionPaymentGatewayType || (CreatePaymentDtoSubscriptionPaymentGatewayType = {}));
export var ExecutePaymentDtoGateway;
(function (ExecutePaymentDtoGateway) {
    ExecutePaymentDtoGateway[ExecutePaymentDtoGateway["_1"] = 1] = "_1";
})(ExecutePaymentDtoGateway || (ExecutePaymentDtoGateway = {}));
export var ExecutePaymentDtoEditionPaymentType;
(function (ExecutePaymentDtoEditionPaymentType) {
    ExecutePaymentDtoEditionPaymentType[ExecutePaymentDtoEditionPaymentType["_0"] = 0] = "_0";
    ExecutePaymentDtoEditionPaymentType[ExecutePaymentDtoEditionPaymentType["_1"] = 1] = "_1";
    ExecutePaymentDtoEditionPaymentType[ExecutePaymentDtoEditionPaymentType["_2"] = 2] = "_2";
    ExecutePaymentDtoEditionPaymentType[ExecutePaymentDtoEditionPaymentType["_3"] = 3] = "_3";
})(ExecutePaymentDtoEditionPaymentType || (ExecutePaymentDtoEditionPaymentType = {}));
export var ExecutePaymentDtoPaymentPeriodType;
(function (ExecutePaymentDtoPaymentPeriodType) {
    ExecutePaymentDtoPaymentPeriodType[ExecutePaymentDtoPaymentPeriodType["_30"] = 30] = "_30";
    ExecutePaymentDtoPaymentPeriodType[ExecutePaymentDtoPaymentPeriodType["_365"] = 365] = "_365";
})(ExecutePaymentDtoPaymentPeriodType || (ExecutePaymentDtoPaymentPeriodType = {}));
export var PermissionDescriptionPermissionType;
(function (PermissionDescriptionPermissionType) {
    PermissionDescriptionPermissionType[PermissionDescriptionPermissionType["_0"] = 0] = "_0";
    PermissionDescriptionPermissionType[PermissionDescriptionPermissionType["_1"] = 1] = "_1";
})(PermissionDescriptionPermissionType || (PermissionDescriptionPermissionType = {}));
export var ReleasedConfigureInfoDtoReleasedConfigureErrorType;
(function (ReleasedConfigureInfoDtoReleasedConfigureErrorType) {
    ReleasedConfigureInfoDtoReleasedConfigureErrorType[ReleasedConfigureInfoDtoReleasedConfigureErrorType["_0"] = 0] = "_0";
    ReleasedConfigureInfoDtoReleasedConfigureErrorType[ReleasedConfigureInfoDtoReleasedConfigureErrorType["_1"] = 1] = "_1";
    ReleasedConfigureInfoDtoReleasedConfigureErrorType[ReleasedConfigureInfoDtoReleasedConfigureErrorType["_2"] = 2] = "_2";
    ReleasedConfigureInfoDtoReleasedConfigureErrorType[ReleasedConfigureInfoDtoReleasedConfigureErrorType["_3"] = 3] = "_3";
})(ReleasedConfigureInfoDtoReleasedConfigureErrorType || (ReleasedConfigureInfoDtoReleasedConfigureErrorType = {}));
export var ReleasedConfigureViewForDeviceType;
(function (ReleasedConfigureViewForDeviceType) {
    ReleasedConfigureViewForDeviceType[ReleasedConfigureViewForDeviceType["_0"] = 0] = "_0";
    ReleasedConfigureViewForDeviceType[ReleasedConfigureViewForDeviceType["_1"] = 1] = "_1";
    ReleasedConfigureViewForDeviceType[ReleasedConfigureViewForDeviceType["_2"] = 2] = "_2";
    ReleasedConfigureViewForDeviceType[ReleasedConfigureViewForDeviceType["_3"] = 3] = "_3";
})(ReleasedConfigureViewForDeviceType || (ReleasedConfigureViewForDeviceType = {}));
export var ReleasedConfigureGraphStateDtoType;
(function (ReleasedConfigureGraphStateDtoType) {
    ReleasedConfigureGraphStateDtoType[ReleasedConfigureGraphStateDtoType["_0"] = 0] = "_0";
    ReleasedConfigureGraphStateDtoType[ReleasedConfigureGraphStateDtoType["_1"] = 1] = "_1";
})(ReleasedConfigureGraphStateDtoType || (ReleasedConfigureGraphStateDtoType = {}));
export var ReleasedDataSourceDtoType;
(function (ReleasedDataSourceDtoType) {
    ReleasedDataSourceDtoType[ReleasedDataSourceDtoType["_0"] = 0] = "_0";
    ReleasedDataSourceDtoType[ReleasedDataSourceDtoType["_1"] = 1] = "_1";
    ReleasedDataSourceDtoType[ReleasedDataSourceDtoType["_2"] = 2] = "_2";
    ReleasedDataSourceDtoType[ReleasedDataSourceDtoType["_3"] = 3] = "_3";
    ReleasedDataSourceDtoType[ReleasedDataSourceDtoType["_4"] = 4] = "_4";
    ReleasedDataSourceDtoType[ReleasedDataSourceDtoType["_5"] = 5] = "_5";
})(ReleasedDataSourceDtoType || (ReleasedDataSourceDtoType = {}));
export var RepairDtoState;
(function (RepairDtoState) {
    RepairDtoState[RepairDtoState["_0"] = 0] = "_0";
    RepairDtoState[RepairDtoState["_10"] = 10] = "_10";
    RepairDtoState[RepairDtoState["_20"] = 20] = "_20";
    RepairDtoState[RepairDtoState["_999"] = 999] = "_999";
})(RepairDtoState || (RepairDtoState = {}));
export var ExportRepairListDtoState;
(function (ExportRepairListDtoState) {
    ExportRepairListDtoState[ExportRepairListDtoState["_0"] = 0] = "_0";
    ExportRepairListDtoState[ExportRepairListDtoState["_10"] = 10] = "_10";
    ExportRepairListDtoState[ExportRepairListDtoState["_20"] = 20] = "_20";
    ExportRepairListDtoState[ExportRepairListDtoState["_999"] = 999] = "_999";
})(ExportRepairListDtoState || (ExportRepairListDtoState = {}));
export var CreateRepairDtoState;
(function (CreateRepairDtoState) {
    CreateRepairDtoState[CreateRepairDtoState["_0"] = 0] = "_0";
    CreateRepairDtoState[CreateRepairDtoState["_10"] = 10] = "_10";
    CreateRepairDtoState[CreateRepairDtoState["_20"] = 20] = "_20";
    CreateRepairDtoState[CreateRepairDtoState["_999"] = 999] = "_999";
})(CreateRepairDtoState || (CreateRepairDtoState = {}));
export var RepairProgressDtoState;
(function (RepairProgressDtoState) {
    RepairProgressDtoState[RepairProgressDtoState["_0"] = 0] = "_0";
    RepairProgressDtoState[RepairProgressDtoState["_20"] = 20] = "_20";
    RepairProgressDtoState[RepairProgressDtoState["_30"] = 30] = "_30";
    RepairProgressDtoState[RepairProgressDtoState["_100"] = 100] = "_100";
    RepairProgressDtoState[RepairProgressDtoState["_200"] = 200] = "_200";
})(RepairProgressDtoState || (RepairProgressDtoState = {}));
export var UpdateApplyInfoDtoEnumEnterpriseType;
(function (UpdateApplyInfoDtoEnumEnterpriseType) {
    UpdateApplyInfoDtoEnumEnterpriseType[UpdateApplyInfoDtoEnumEnterpriseType["_1"] = 1] = "_1";
    UpdateApplyInfoDtoEnumEnterpriseType[UpdateApplyInfoDtoEnumEnterpriseType["_2"] = 2] = "_2";
    UpdateApplyInfoDtoEnumEnterpriseType[UpdateApplyInfoDtoEnumEnterpriseType["_3"] = 3] = "_3";
    UpdateApplyInfoDtoEnumEnterpriseType[UpdateApplyInfoDtoEnumEnterpriseType["_4"] = 4] = "_4";
    UpdateApplyInfoDtoEnumEnterpriseType[UpdateApplyInfoDtoEnumEnterpriseType["_5"] = 5] = "_5";
    UpdateApplyInfoDtoEnumEnterpriseType[UpdateApplyInfoDtoEnumEnterpriseType["_6"] = 6] = "_6";
})(UpdateApplyInfoDtoEnumEnterpriseType || (UpdateApplyInfoDtoEnumEnterpriseType = {}));
export var UpdateApplyInfoDtoEnumIndustryType;
(function (UpdateApplyInfoDtoEnumIndustryType) {
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_1"] = 1] = "_1";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_2"] = 2] = "_2";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_3"] = 3] = "_3";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_4"] = 4] = "_4";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_5"] = 5] = "_5";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_6"] = 6] = "_6";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_7"] = 7] = "_7";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_8"] = 8] = "_8";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_9"] = 9] = "_9";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_10"] = 10] = "_10";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_11"] = 11] = "_11";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_12"] = 12] = "_12";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_13"] = 13] = "_13";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_14"] = 14] = "_14";
    UpdateApplyInfoDtoEnumIndustryType[UpdateApplyInfoDtoEnumIndustryType["_15"] = 15] = "_15";
})(UpdateApplyInfoDtoEnumIndustryType || (UpdateApplyInfoDtoEnumIndustryType = {}));
export var UpdateApplyInfoDtoEnumDeviceScaleRange;
(function (UpdateApplyInfoDtoEnumDeviceScaleRange) {
    UpdateApplyInfoDtoEnumDeviceScaleRange[UpdateApplyInfoDtoEnumDeviceScaleRange["_1"] = 1] = "_1";
    UpdateApplyInfoDtoEnumDeviceScaleRange[UpdateApplyInfoDtoEnumDeviceScaleRange["_2"] = 2] = "_2";
    UpdateApplyInfoDtoEnumDeviceScaleRange[UpdateApplyInfoDtoEnumDeviceScaleRange["_3"] = 3] = "_3";
    UpdateApplyInfoDtoEnumDeviceScaleRange[UpdateApplyInfoDtoEnumDeviceScaleRange["_4"] = 4] = "_4";
    UpdateApplyInfoDtoEnumDeviceScaleRange[UpdateApplyInfoDtoEnumDeviceScaleRange["_5"] = 5] = "_5";
    UpdateApplyInfoDtoEnumDeviceScaleRange[UpdateApplyInfoDtoEnumDeviceScaleRange["_6"] = 6] = "_6";
})(UpdateApplyInfoDtoEnumDeviceScaleRange || (UpdateApplyInfoDtoEnumDeviceScaleRange = {}));
export var UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange;
(function (UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange) {
    UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange[UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange["_1"] = 1] = "_1";
    UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange[UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange["_2"] = 2] = "_2";
    UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange[UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange["_3"] = 3] = "_3";
    UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange[UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange["_4"] = 4] = "_4";
    UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange[UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange["_5"] = 5] = "_5";
})(UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange || (UpdateApplyInfoDtoEnumAfterSalesPersonScaleRange = {}));
export var UpdateApplyInfoDtoEnumApplicantRole;
(function (UpdateApplyInfoDtoEnumApplicantRole) {
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_1"] = 1] = "_1";
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_2"] = 2] = "_2";
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_3"] = 3] = "_3";
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_4"] = 4] = "_4";
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_5"] = 5] = "_5";
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_6"] = 6] = "_6";
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_7"] = 7] = "_7";
    UpdateApplyInfoDtoEnumApplicantRole[UpdateApplyInfoDtoEnumApplicantRole["_8"] = 8] = "_8";
})(UpdateApplyInfoDtoEnumApplicantRole || (UpdateApplyInfoDtoEnumApplicantRole = {}));
export var ReportDataQueryDtoDisplayType;
(function (ReportDataQueryDtoDisplayType) {
    ReportDataQueryDtoDisplayType[ReportDataQueryDtoDisplayType["_0"] = 0] = "_0";
    ReportDataQueryDtoDisplayType[ReportDataQueryDtoDisplayType["_1"] = 1] = "_1";
    ReportDataQueryDtoDisplayType[ReportDataQueryDtoDisplayType["_2"] = 2] = "_2";
    ReportDataQueryDtoDisplayType[ReportDataQueryDtoDisplayType["_3"] = 3] = "_3";
    ReportDataQueryDtoDisplayType[ReportDataQueryDtoDisplayType["_4"] = 4] = "_4";
    ReportDataQueryDtoDisplayType[ReportDataQueryDtoDisplayType["_5"] = 5] = "_5";
})(ReportDataQueryDtoDisplayType || (ReportDataQueryDtoDisplayType = {}));
export var ReportQueryDefinitionTarget;
(function (ReportQueryDefinitionTarget) {
    ReportQueryDefinitionTarget[ReportQueryDefinitionTarget["_0"] = 0] = "_0";
    ReportQueryDefinitionTarget[ReportQueryDefinitionTarget["_1"] = 1] = "_1";
    ReportQueryDefinitionTarget[ReportQueryDefinitionTarget["_2"] = 2] = "_2";
    ReportQueryDefinitionTarget[ReportQueryDefinitionTarget["_3"] = 3] = "_3";
    ReportQueryDefinitionTarget[ReportQueryDefinitionTarget["_4"] = 4] = "_4";
})(ReportQueryDefinitionTarget || (ReportQueryDefinitionTarget = {}));
export var ReportQueryDefinitionTimeDimensionType;
(function (ReportQueryDefinitionTimeDimensionType) {
    ReportQueryDefinitionTimeDimensionType[ReportQueryDefinitionTimeDimensionType["_0"] = 0] = "_0";
    ReportQueryDefinitionTimeDimensionType[ReportQueryDefinitionTimeDimensionType["_1"] = 1] = "_1";
    ReportQueryDefinitionTimeDimensionType[ReportQueryDefinitionTimeDimensionType["_2"] = 2] = "_2";
    ReportQueryDefinitionTimeDimensionType[ReportQueryDefinitionTimeDimensionType["_3"] = 3] = "_3";
    ReportQueryDefinitionTimeDimensionType[ReportQueryDefinitionTimeDimensionType["_4"] = 4] = "_4";
})(ReportQueryDefinitionTimeDimensionType || (ReportQueryDefinitionTimeDimensionType = {}));
export var ReportQueryDefinitionTimeMetricType;
(function (ReportQueryDefinitionTimeMetricType) {
    ReportQueryDefinitionTimeMetricType[ReportQueryDefinitionTimeMetricType["_0"] = 0] = "_0";
    ReportQueryDefinitionTimeMetricType[ReportQueryDefinitionTimeMetricType["_1"] = 1] = "_1";
    ReportQueryDefinitionTimeMetricType[ReportQueryDefinitionTimeMetricType["_2"] = 2] = "_2";
    ReportQueryDefinitionTimeMetricType[ReportQueryDefinitionTimeMetricType["_3"] = 3] = "_3";
    ReportQueryDefinitionTimeMetricType[ReportQueryDefinitionTimeMetricType["_4"] = 4] = "_4";
})(ReportQueryDefinitionTimeMetricType || (ReportQueryDefinitionTimeMetricType = {}));
export var ReportQueryDefinitionReportQueryType;
(function (ReportQueryDefinitionReportQueryType) {
    ReportQueryDefinitionReportQueryType[ReportQueryDefinitionReportQueryType["_0"] = 0] = "_0";
    ReportQueryDefinitionReportQueryType[ReportQueryDefinitionReportQueryType["_1"] = 1] = "_1";
})(ReportQueryDefinitionReportQueryType || (ReportQueryDefinitionReportQueryType = {}));
export var ReportQueryDefinitionMetricAggregateAction;
(function (ReportQueryDefinitionMetricAggregateAction) {
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_0"] = 0] = "_0";
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_1"] = 1] = "_1";
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_2"] = 2] = "_2";
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_3"] = 3] = "_3";
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_4"] = 4] = "_4";
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_5"] = 5] = "_5";
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_6"] = 6] = "_6";
    ReportQueryDefinitionMetricAggregateAction[ReportQueryDefinitionMetricAggregateAction["_7"] = 7] = "_7";
})(ReportQueryDefinitionMetricAggregateAction || (ReportQueryDefinitionMetricAggregateAction = {}));
export var AggregateFieldActionDefAggregateAction;
(function (AggregateFieldActionDefAggregateAction) {
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_0"] = 0] = "_0";
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_1"] = 1] = "_1";
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_2"] = 2] = "_2";
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_3"] = 3] = "_3";
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_4"] = 4] = "_4";
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_5"] = 5] = "_5";
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_6"] = 6] = "_6";
    AggregateFieldActionDefAggregateAction[AggregateFieldActionDefAggregateAction["_7"] = 7] = "_7";
})(AggregateFieldActionDefAggregateAction || (AggregateFieldActionDefAggregateAction = {}));
export var ReportQueryCriteriaStringOperatorType;
(function (ReportQueryCriteriaStringOperatorType) {
    ReportQueryCriteriaStringOperatorType[ReportQueryCriteriaStringOperatorType["_0"] = 0] = "_0";
    ReportQueryCriteriaStringOperatorType[ReportQueryCriteriaStringOperatorType["_1"] = 1] = "_1";
    ReportQueryCriteriaStringOperatorType[ReportQueryCriteriaStringOperatorType["_2"] = 2] = "_2";
    ReportQueryCriteriaStringOperatorType[ReportQueryCriteriaStringOperatorType["_3"] = 3] = "_3";
    ReportQueryCriteriaStringOperatorType[ReportQueryCriteriaStringOperatorType["_4"] = 4] = "_4";
    ReportQueryCriteriaStringOperatorType[ReportQueryCriteriaStringOperatorType["_5"] = 5] = "_5";
})(ReportQueryCriteriaStringOperatorType || (ReportQueryCriteriaStringOperatorType = {}));
export var ReportQueryCriteriaDateOperatorType;
(function (ReportQueryCriteriaDateOperatorType) {
    ReportQueryCriteriaDateOperatorType[ReportQueryCriteriaDateOperatorType["_0"] = 0] = "_0";
    ReportQueryCriteriaDateOperatorType[ReportQueryCriteriaDateOperatorType["_1"] = 1] = "_1";
    ReportQueryCriteriaDateOperatorType[ReportQueryCriteriaDateOperatorType["_2"] = 2] = "_2";
    ReportQueryCriteriaDateOperatorType[ReportQueryCriteriaDateOperatorType["_3"] = 3] = "_3";
    ReportQueryCriteriaDateOperatorType[ReportQueryCriteriaDateOperatorType["_4"] = 4] = "_4";
    ReportQueryCriteriaDateOperatorType[ReportQueryCriteriaDateOperatorType["_5"] = 5] = "_5";
    ReportQueryCriteriaDateOperatorType[ReportQueryCriteriaDateOperatorType["_6"] = 6] = "_6";
})(ReportQueryCriteriaDateOperatorType || (ReportQueryCriteriaDateOperatorType = {}));
export var ReportQueryCriteriaNumberOperatorType;
(function (ReportQueryCriteriaNumberOperatorType) {
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_0"] = 0] = "_0";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_1"] = 1] = "_1";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_2"] = 2] = "_2";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_3"] = 3] = "_3";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_4"] = 4] = "_4";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_5"] = 5] = "_5";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_6"] = 6] = "_6";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_7"] = 7] = "_7";
    ReportQueryCriteriaNumberOperatorType[ReportQueryCriteriaNumberOperatorType["_8"] = 8] = "_8";
})(ReportQueryCriteriaNumberOperatorType || (ReportQueryCriteriaNumberOperatorType = {}));
export var NameReportResultDtoDisplayType;
(function (NameReportResultDtoDisplayType) {
    NameReportResultDtoDisplayType[NameReportResultDtoDisplayType["_0"] = 0] = "_0";
    NameReportResultDtoDisplayType[NameReportResultDtoDisplayType["_1"] = 1] = "_1";
    NameReportResultDtoDisplayType[NameReportResultDtoDisplayType["_2"] = 2] = "_2";
    NameReportResultDtoDisplayType[NameReportResultDtoDisplayType["_3"] = 3] = "_3";
    NameReportResultDtoDisplayType[NameReportResultDtoDisplayType["_4"] = 4] = "_4";
    NameReportResultDtoDisplayType[NameReportResultDtoDisplayType["_5"] = 5] = "_5";
})(NameReportResultDtoDisplayType || (NameReportResultDtoDisplayType = {}));
export var ReportsListDtoReportDisplayType;
(function (ReportsListDtoReportDisplayType) {
    ReportsListDtoReportDisplayType[ReportsListDtoReportDisplayType["_0"] = 0] = "_0";
    ReportsListDtoReportDisplayType[ReportsListDtoReportDisplayType["_1"] = 1] = "_1";
    ReportsListDtoReportDisplayType[ReportsListDtoReportDisplayType["_2"] = 2] = "_2";
    ReportsListDtoReportDisplayType[ReportsListDtoReportDisplayType["_3"] = 3] = "_3";
    ReportsListDtoReportDisplayType[ReportsListDtoReportDisplayType["_4"] = 4] = "_4";
    ReportsListDtoReportDisplayType[ReportsListDtoReportDisplayType["_5"] = 5] = "_5";
})(ReportsListDtoReportDisplayType || (ReportsListDtoReportDisplayType = {}));
export var StatisticReportDtoDisplayType;
(function (StatisticReportDtoDisplayType) {
    StatisticReportDtoDisplayType[StatisticReportDtoDisplayType["_0"] = 0] = "_0";
    StatisticReportDtoDisplayType[StatisticReportDtoDisplayType["_1"] = 1] = "_1";
    StatisticReportDtoDisplayType[StatisticReportDtoDisplayType["_2"] = 2] = "_2";
    StatisticReportDtoDisplayType[StatisticReportDtoDisplayType["_3"] = 3] = "_3";
    StatisticReportDtoDisplayType[StatisticReportDtoDisplayType["_4"] = 4] = "_4";
    StatisticReportDtoDisplayType[StatisticReportDtoDisplayType["_5"] = 5] = "_5";
})(StatisticReportDtoDisplayType || (StatisticReportDtoDisplayType = {}));
export var ReportSaveDtoDisplayType;
(function (ReportSaveDtoDisplayType) {
    ReportSaveDtoDisplayType[ReportSaveDtoDisplayType["_0"] = 0] = "_0";
    ReportSaveDtoDisplayType[ReportSaveDtoDisplayType["_1"] = 1] = "_1";
    ReportSaveDtoDisplayType[ReportSaveDtoDisplayType["_2"] = 2] = "_2";
    ReportSaveDtoDisplayType[ReportSaveDtoDisplayType["_3"] = 3] = "_3";
    ReportSaveDtoDisplayType[ReportSaveDtoDisplayType["_4"] = 4] = "_4";
    ReportSaveDtoDisplayType[ReportSaveDtoDisplayType["_5"] = 5] = "_5";
})(ReportSaveDtoDisplayType || (ReportSaveDtoDisplayType = {}));
export var TableDefinitionTableEnum;
(function (TableDefinitionTableEnum) {
    TableDefinitionTableEnum[TableDefinitionTableEnum["_0"] = 0] = "_0";
    TableDefinitionTableEnum[TableDefinitionTableEnum["_1"] = 1] = "_1";
    TableDefinitionTableEnum[TableDefinitionTableEnum["_2"] = 2] = "_2";
    TableDefinitionTableEnum[TableDefinitionTableEnum["_3"] = 3] = "_3";
    TableDefinitionTableEnum[TableDefinitionTableEnum["_4"] = 4] = "_4";
})(TableDefinitionTableEnum || (TableDefinitionTableEnum = {}));
export var FieldDefinitionType;
(function (FieldDefinitionType) {
    FieldDefinitionType[FieldDefinitionType["_0"] = 0] = "_0";
    FieldDefinitionType[FieldDefinitionType["_1"] = 1] = "_1";
    FieldDefinitionType[FieldDefinitionType["_2"] = 2] = "_2";
})(FieldDefinitionType || (FieldDefinitionType = {}));
export var ReferenceFieldDefinitionDisplayFieldType;
(function (ReferenceFieldDefinitionDisplayFieldType) {
    ReferenceFieldDefinitionDisplayFieldType[ReferenceFieldDefinitionDisplayFieldType["_0"] = 0] = "_0";
    ReferenceFieldDefinitionDisplayFieldType[ReferenceFieldDefinitionDisplayFieldType["_1"] = 1] = "_1";
    ReferenceFieldDefinitionDisplayFieldType[ReferenceFieldDefinitionDisplayFieldType["_2"] = 2] = "_2";
})(ReferenceFieldDefinitionDisplayFieldType || (ReferenceFieldDefinitionDisplayFieldType = {}));
export var ReferenceFieldDefinitionIdFieldType;
(function (ReferenceFieldDefinitionIdFieldType) {
    ReferenceFieldDefinitionIdFieldType[ReferenceFieldDefinitionIdFieldType["_0"] = 0] = "_0";
    ReferenceFieldDefinitionIdFieldType[ReferenceFieldDefinitionIdFieldType["_1"] = 1] = "_1";
    ReferenceFieldDefinitionIdFieldType[ReferenceFieldDefinitionIdFieldType["_2"] = 2] = "_2";
})(ReferenceFieldDefinitionIdFieldType || (ReferenceFieldDefinitionIdFieldType = {}));
export var FieldDefinitionMultiSideInfoDisplayFieldType;
(function (FieldDefinitionMultiSideInfoDisplayFieldType) {
    FieldDefinitionMultiSideInfoDisplayFieldType[FieldDefinitionMultiSideInfoDisplayFieldType["_0"] = 0] = "_0";
    FieldDefinitionMultiSideInfoDisplayFieldType[FieldDefinitionMultiSideInfoDisplayFieldType["_1"] = 1] = "_1";
    FieldDefinitionMultiSideInfoDisplayFieldType[FieldDefinitionMultiSideInfoDisplayFieldType["_2"] = 2] = "_2";
})(FieldDefinitionMultiSideInfoDisplayFieldType || (FieldDefinitionMultiSideInfoDisplayFieldType = {}));
export var FieldDefinitionMultiSideInfoIdFieldType;
(function (FieldDefinitionMultiSideInfoIdFieldType) {
    FieldDefinitionMultiSideInfoIdFieldType[FieldDefinitionMultiSideInfoIdFieldType["_0"] = 0] = "_0";
    FieldDefinitionMultiSideInfoIdFieldType[FieldDefinitionMultiSideInfoIdFieldType["_1"] = 1] = "_1";
    FieldDefinitionMultiSideInfoIdFieldType[FieldDefinitionMultiSideInfoIdFieldType["_2"] = 2] = "_2";
})(FieldDefinitionMultiSideInfoIdFieldType || (FieldDefinitionMultiSideInfoIdFieldType = {}));
export var TableFieldFilterDefinitionDtoTableEnum;
(function (TableFieldFilterDefinitionDtoTableEnum) {
    TableFieldFilterDefinitionDtoTableEnum[TableFieldFilterDefinitionDtoTableEnum["_0"] = 0] = "_0";
    TableFieldFilterDefinitionDtoTableEnum[TableFieldFilterDefinitionDtoTableEnum["_1"] = 1] = "_1";
    TableFieldFilterDefinitionDtoTableEnum[TableFieldFilterDefinitionDtoTableEnum["_2"] = 2] = "_2";
    TableFieldFilterDefinitionDtoTableEnum[TableFieldFilterDefinitionDtoTableEnum["_3"] = 3] = "_3";
    TableFieldFilterDefinitionDtoTableEnum[TableFieldFilterDefinitionDtoTableEnum["_4"] = 4] = "_4";
})(TableFieldFilterDefinitionDtoTableEnum || (TableFieldFilterDefinitionDtoTableEnum = {}));
export var SerialNumberListDtoSerialNumberReset;
(function (SerialNumberListDtoSerialNumberReset) {
    SerialNumberListDtoSerialNumberReset[SerialNumberListDtoSerialNumberReset["_1"] = 1] = "_1";
    SerialNumberListDtoSerialNumberReset[SerialNumberListDtoSerialNumberReset["_2"] = 2] = "_2";
    SerialNumberListDtoSerialNumberReset[SerialNumberListDtoSerialNumberReset["_4"] = 4] = "_4";
    SerialNumberListDtoSerialNumberReset[SerialNumberListDtoSerialNumberReset["_8"] = 8] = "_8";
})(SerialNumberListDtoSerialNumberReset || (SerialNumberListDtoSerialNumberReset = {}));
export var SerialNumberForEditDtoSerialNumberReset;
(function (SerialNumberForEditDtoSerialNumberReset) {
    SerialNumberForEditDtoSerialNumberReset[SerialNumberForEditDtoSerialNumberReset["_1"] = 1] = "_1";
    SerialNumberForEditDtoSerialNumberReset[SerialNumberForEditDtoSerialNumberReset["_2"] = 2] = "_2";
    SerialNumberForEditDtoSerialNumberReset[SerialNumberForEditDtoSerialNumberReset["_4"] = 4] = "_4";
    SerialNumberForEditDtoSerialNumberReset[SerialNumberForEditDtoSerialNumberReset["_8"] = 8] = "_8";
})(SerialNumberForEditDtoSerialNumberReset || (SerialNumberForEditDtoSerialNumberReset = {}));
export var CreateOrUpdateSerialNumberDtoSerialNumberReset;
(function (CreateOrUpdateSerialNumberDtoSerialNumberReset) {
    CreateOrUpdateSerialNumberDtoSerialNumberReset[CreateOrUpdateSerialNumberDtoSerialNumberReset["_1"] = 1] = "_1";
    CreateOrUpdateSerialNumberDtoSerialNumberReset[CreateOrUpdateSerialNumberDtoSerialNumberReset["_2"] = 2] = "_2";
    CreateOrUpdateSerialNumberDtoSerialNumberReset[CreateOrUpdateSerialNumberDtoSerialNumberReset["_4"] = 4] = "_4";
    CreateOrUpdateSerialNumberDtoSerialNumberReset[CreateOrUpdateSerialNumberDtoSerialNumberReset["_8"] = 8] = "_8";
})(CreateOrUpdateSerialNumberDtoSerialNumberReset || (CreateOrUpdateSerialNumberDtoSerialNumberReset = {}));
export var TenantLoginInfoDtoPaymentPeriodType;
(function (TenantLoginInfoDtoPaymentPeriodType) {
    TenantLoginInfoDtoPaymentPeriodType[TenantLoginInfoDtoPaymentPeriodType["_30"] = 30] = "_30";
    TenantLoginInfoDtoPaymentPeriodType[TenantLoginInfoDtoPaymentPeriodType["_365"] = 365] = "_365";
})(TenantLoginInfoDtoPaymentPeriodType || (TenantLoginInfoDtoPaymentPeriodType = {}));
export var SystemGraphStateDtoType;
(function (SystemGraphStateDtoType) {
    SystemGraphStateDtoType[SystemGraphStateDtoType["_0"] = 0] = "_0";
    SystemGraphStateDtoType[SystemGraphStateDtoType["_1"] = 1] = "_1";
})(SystemGraphStateDtoType || (SystemGraphStateDtoType = {}));
export var CreateOrUpdateTenantRegistDtoApprovalStatus;
(function (CreateOrUpdateTenantRegistDtoApprovalStatus) {
    CreateOrUpdateTenantRegistDtoApprovalStatus[CreateOrUpdateTenantRegistDtoApprovalStatus["_0"] = 0] = "_0";
    CreateOrUpdateTenantRegistDtoApprovalStatus[CreateOrUpdateTenantRegistDtoApprovalStatus["_1"] = 1] = "_1";
    CreateOrUpdateTenantRegistDtoApprovalStatus[CreateOrUpdateTenantRegistDtoApprovalStatus["_2"] = 2] = "_2";
})(CreateOrUpdateTenantRegistDtoApprovalStatus || (CreateOrUpdateTenantRegistDtoApprovalStatus = {}));
export var TenantRegistrationApprovalStatus;
(function (TenantRegistrationApprovalStatus) {
    TenantRegistrationApprovalStatus[TenantRegistrationApprovalStatus["_0"] = 0] = "_0";
    TenantRegistrationApprovalStatus[TenantRegistrationApprovalStatus["_1"] = 1] = "_1";
    TenantRegistrationApprovalStatus[TenantRegistrationApprovalStatus["_2"] = 2] = "_2";
})(TenantRegistrationApprovalStatus || (TenantRegistrationApprovalStatus = {}));
export var RegisterTenantInputSubscriptionStartType;
(function (RegisterTenantInputSubscriptionStartType) {
    RegisterTenantInputSubscriptionStartType[RegisterTenantInputSubscriptionStartType["_1"] = 1] = "_1";
    RegisterTenantInputSubscriptionStartType[RegisterTenantInputSubscriptionStartType["_2"] = 2] = "_2";
    RegisterTenantInputSubscriptionStartType[RegisterTenantInputSubscriptionStartType["_3"] = 3] = "_3";
})(RegisterTenantInputSubscriptionStartType || (RegisterTenantInputSubscriptionStartType = {}));
export var RegisterTenantInputGateway;
(function (RegisterTenantInputGateway) {
    RegisterTenantInputGateway[RegisterTenantInputGateway["_1"] = 1] = "_1";
})(RegisterTenantInputGateway || (RegisterTenantInputGateway = {}));
export var TenantUserManagementSettingsEditDtoDisplayMode;
(function (TenantUserManagementSettingsEditDtoDisplayMode) {
    TenantUserManagementSettingsEditDtoDisplayMode[TenantUserManagementSettingsEditDtoDisplayMode["_0"] = 0] = "_0";
    TenantUserManagementSettingsEditDtoDisplayMode[TenantUserManagementSettingsEditDtoDisplayMode["_1"] = 1] = "_1";
})(TenantUserManagementSettingsEditDtoDisplayMode || (TenantUserManagementSettingsEditDtoDisplayMode = {}));
export var AuthenticateModelConfirmationType;
(function (AuthenticateModelConfirmationType) {
    AuthenticateModelConfirmationType[AuthenticateModelConfirmationType["_0"] = 0] = "_0";
    AuthenticateModelConfirmationType[AuthenticateModelConfirmationType["_1"] = 1] = "_1";
})(AuthenticateModelConfirmationType || (AuthenticateModelConfirmationType = {}));
export var SendTwoFactorConfirmationCodeModelConfirmationType;
(function (SendTwoFactorConfirmationCodeModelConfirmationType) {
    SendTwoFactorConfirmationCodeModelConfirmationType[SendTwoFactorConfirmationCodeModelConfirmationType["_0"] = 0] = "_0";
    SendTwoFactorConfirmationCodeModelConfirmationType[SendTwoFactorConfirmationCodeModelConfirmationType["_1"] = 1] = "_1";
})(SendTwoFactorConfirmationCodeModelConfirmationType || (SendTwoFactorConfirmationCodeModelConfirmationType = {}));
export var UserListDtoDataPolicy;
(function (UserListDtoDataPolicy) {
    UserListDtoDataPolicy[UserListDtoDataPolicy["_0"] = 0] = "_0";
    UserListDtoDataPolicy[UserListDtoDataPolicy["_1"] = 1] = "_1";
    UserListDtoDataPolicy[UserListDtoDataPolicy["_2"] = 2] = "_2";
    UserListDtoDataPolicy[UserListDtoDataPolicy["_3"] = 3] = "_3";
})(UserListDtoDataPolicy || (UserListDtoDataPolicy = {}));
export var UserEditDtoDataPolicy;
(function (UserEditDtoDataPolicy) {
    UserEditDtoDataPolicy[UserEditDtoDataPolicy["_0"] = 0] = "_0";
    UserEditDtoDataPolicy[UserEditDtoDataPolicy["_1"] = 1] = "_1";
    UserEditDtoDataPolicy[UserEditDtoDataPolicy["_2"] = 2] = "_2";
    UserEditDtoDataPolicy[UserEditDtoDataPolicy["_3"] = 3] = "_3";
})(UserEditDtoDataPolicy || (UserEditDtoDataPolicy = {}));
export var UserDetailDtoDataPolicy;
(function (UserDetailDtoDataPolicy) {
    UserDetailDtoDataPolicy[UserDetailDtoDataPolicy["_0"] = 0] = "_0";
    UserDetailDtoDataPolicy[UserDetailDtoDataPolicy["_1"] = 1] = "_1";
    UserDetailDtoDataPolicy[UserDetailDtoDataPolicy["_2"] = 2] = "_2";
    UserDetailDtoDataPolicy[UserDetailDtoDataPolicy["_3"] = 3] = "_3";
})(UserDetailDtoDataPolicy || (UserDetailDtoDataPolicy = {}));
export var UserGraphStateDtoType;
(function (UserGraphStateDtoType) {
    UserGraphStateDtoType[UserGraphStateDtoType["_0"] = 0] = "_0";
    UserGraphStateDtoType[UserGraphStateDtoType["_1"] = 1] = "_1";
})(UserGraphStateDtoType || (UserGraphStateDtoType = {}));
export var UserGraphStateEditDtoType;
(function (UserGraphStateEditDtoType) {
    UserGraphStateEditDtoType[UserGraphStateEditDtoType["_0"] = 0] = "_0";
    UserGraphStateEditDtoType[UserGraphStateEditDtoType["_1"] = 1] = "_1";
})(UserGraphStateEditDtoType || (UserGraphStateEditDtoType = {}));
export var VariableListDtoDataType;
(function (VariableListDtoDataType) {
    VariableListDtoDataType[VariableListDtoDataType["_1"] = 1] = "_1";
    VariableListDtoDataType[VariableListDtoDataType["_2"] = 2] = "_2";
    VariableListDtoDataType[VariableListDtoDataType["_4"] = 4] = "_4";
    VariableListDtoDataType[VariableListDtoDataType["_8"] = 8] = "_8";
})(VariableListDtoDataType || (VariableListDtoDataType = {}));
export var RefFBoxVariableDtoDataType;
(function (RefFBoxVariableDtoDataType) {
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_0"] = 0] = "_0";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_1"] = 1] = "_1";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_2"] = 2] = "_2";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_3"] = 3] = "_3";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_4"] = 4] = "_4";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_5"] = 5] = "_5";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_11"] = 11] = "_11";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_12"] = 12] = "_12";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_13"] = 13] = "_13";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_14"] = 14] = "_14";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_15"] = 15] = "_15";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_16"] = 16] = "_16";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_21"] = 21] = "_21";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_22"] = 22] = "_22";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_23"] = 23] = "_23";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_24"] = 24] = "_24";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_25"] = 25] = "_25";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_26"] = 26] = "_26";
    RefFBoxVariableDtoDataType[RefFBoxVariableDtoDataType["_30"] = 30] = "_30";
})(RefFBoxVariableDtoDataType || (RefFBoxVariableDtoDataType = {}));
export var RefFBoxVariableDtoVariableDataType;
(function (RefFBoxVariableDtoVariableDataType) {
    RefFBoxVariableDtoVariableDataType[RefFBoxVariableDtoVariableDataType["_1"] = 1] = "_1";
    RefFBoxVariableDtoVariableDataType[RefFBoxVariableDtoVariableDataType["_2"] = 2] = "_2";
    RefFBoxVariableDtoVariableDataType[RefFBoxVariableDtoVariableDataType["_4"] = 4] = "_4";
    RefFBoxVariableDtoVariableDataType[RefFBoxVariableDtoVariableDataType["_8"] = 8] = "_8";
})(RefFBoxVariableDtoVariableDataType || (RefFBoxVariableDtoVariableDataType = {}));
export var VariableForEditDtoSampleMode;
(function (VariableForEditDtoSampleMode) {
    VariableForEditDtoSampleMode[VariableForEditDtoSampleMode["_0"] = 0] = "_0";
    VariableForEditDtoSampleMode[VariableForEditDtoSampleMode["_1"] = 1] = "_1";
})(VariableForEditDtoSampleMode || (VariableForEditDtoSampleMode = {}));
export var VariableForEditDtoDataType;
(function (VariableForEditDtoDataType) {
    VariableForEditDtoDataType[VariableForEditDtoDataType["_1"] = 1] = "_1";
    VariableForEditDtoDataType[VariableForEditDtoDataType["_2"] = 2] = "_2";
    VariableForEditDtoDataType[VariableForEditDtoDataType["_4"] = 4] = "_4";
    VariableForEditDtoDataType[VariableForEditDtoDataType["_8"] = 8] = "_8";
})(VariableForEditDtoDataType || (VariableForEditDtoDataType = {}));
export var VariableForEditDtoVariableRwType;
(function (VariableForEditDtoVariableRwType) {
    VariableForEditDtoVariableRwType[VariableForEditDtoVariableRwType["_2"] = 2] = "_2";
    VariableForEditDtoVariableRwType[VariableForEditDtoVariableRwType["_4"] = 4] = "_4";
    VariableForEditDtoVariableRwType[VariableForEditDtoVariableRwType["_6"] = 6] = "_6";
})(VariableForEditDtoVariableRwType || (VariableForEditDtoVariableRwType = {}));
export var CreateOrUpdateVariableDtoDataType;
(function (CreateOrUpdateVariableDtoDataType) {
    CreateOrUpdateVariableDtoDataType[CreateOrUpdateVariableDtoDataType["_1"] = 1] = "_1";
    CreateOrUpdateVariableDtoDataType[CreateOrUpdateVariableDtoDataType["_2"] = 2] = "_2";
    CreateOrUpdateVariableDtoDataType[CreateOrUpdateVariableDtoDataType["_4"] = 4] = "_4";
    CreateOrUpdateVariableDtoDataType[CreateOrUpdateVariableDtoDataType["_8"] = 8] = "_8";
})(CreateOrUpdateVariableDtoDataType || (CreateOrUpdateVariableDtoDataType = {}));
export var CreateOrUpdateVariableDtoVariableRwType;
(function (CreateOrUpdateVariableDtoVariableRwType) {
    CreateOrUpdateVariableDtoVariableRwType[CreateOrUpdateVariableDtoVariableRwType["_2"] = 2] = "_2";
    CreateOrUpdateVariableDtoVariableRwType[CreateOrUpdateVariableDtoVariableRwType["_4"] = 4] = "_4";
    CreateOrUpdateVariableDtoVariableRwType[CreateOrUpdateVariableDtoVariableRwType["_6"] = 6] = "_6";
})(CreateOrUpdateVariableDtoVariableRwType || (CreateOrUpdateVariableDtoVariableRwType = {}));
export var CreateOrUpdateVariableDtoSampleMode;
(function (CreateOrUpdateVariableDtoSampleMode) {
    CreateOrUpdateVariableDtoSampleMode[CreateOrUpdateVariableDtoSampleMode["_0"] = 0] = "_0";
    CreateOrUpdateVariableDtoSampleMode[CreateOrUpdateVariableDtoSampleMode["_1"] = 1] = "_1";
})(CreateOrUpdateVariableDtoSampleMode || (CreateOrUpdateVariableDtoSampleMode = {}));
export var BatchImportVariablesDtoRenameType;
(function (BatchImportVariablesDtoRenameType) {
    BatchImportVariablesDtoRenameType[BatchImportVariablesDtoRenameType["_0"] = 0] = "_0";
    BatchImportVariablesDtoRenameType[BatchImportVariablesDtoRenameType["_1"] = 1] = "_1";
    BatchImportVariablesDtoRenameType[BatchImportVariablesDtoRenameType["_2"] = 2] = "_2";
})(BatchImportVariablesDtoRenameType || (BatchImportVariablesDtoRenameType = {}));
export var BatchEditVariableDtoVariableRwType;
(function (BatchEditVariableDtoVariableRwType) {
    BatchEditVariableDtoVariableRwType[BatchEditVariableDtoVariableRwType["_2"] = 2] = "_2";
    BatchEditVariableDtoVariableRwType[BatchEditVariableDtoVariableRwType["_4"] = 4] = "_4";
    BatchEditVariableDtoVariableRwType[BatchEditVariableDtoVariableRwType["_6"] = 6] = "_6";
})(BatchEditVariableDtoVariableRwType || (BatchEditVariableDtoVariableRwType = {}));
export var BatchEditVariableDtoSampleMode;
(function (BatchEditVariableDtoSampleMode) {
    BatchEditVariableDtoSampleMode[BatchEditVariableDtoSampleMode["_0"] = 0] = "_0";
    BatchEditVariableDtoSampleMode[BatchEditVariableDtoSampleMode["_1"] = 1] = "_1";
})(BatchEditVariableDtoSampleMode || (BatchEditVariableDtoSampleMode = {}));
export var VariableForDesignerListDtoReadWriteModel;
(function (VariableForDesignerListDtoReadWriteModel) {
    VariableForDesignerListDtoReadWriteModel[VariableForDesignerListDtoReadWriteModel["_2"] = 2] = "_2";
    VariableForDesignerListDtoReadWriteModel[VariableForDesignerListDtoReadWriteModel["_4"] = 4] = "_4";
    VariableForDesignerListDtoReadWriteModel[VariableForDesignerListDtoReadWriteModel["_6"] = 6] = "_6";
})(VariableForDesignerListDtoReadWriteModel || (VariableForDesignerListDtoReadWriteModel = {}));
export var VariableSpecifiedForDesignerDtoDataType;
(function (VariableSpecifiedForDesignerDtoDataType) {
    VariableSpecifiedForDesignerDtoDataType[VariableSpecifiedForDesignerDtoDataType["_1"] = 1] = "_1";
    VariableSpecifiedForDesignerDtoDataType[VariableSpecifiedForDesignerDtoDataType["_2"] = 2] = "_2";
    VariableSpecifiedForDesignerDtoDataType[VariableSpecifiedForDesignerDtoDataType["_4"] = 4] = "_4";
    VariableSpecifiedForDesignerDtoDataType[VariableSpecifiedForDesignerDtoDataType["_8"] = 8] = "_8";
})(VariableSpecifiedForDesignerDtoDataType || (VariableSpecifiedForDesignerDtoDataType = {}));
export var VariableNameMappingListDtoDataType;
(function (VariableNameMappingListDtoDataType) {
    VariableNameMappingListDtoDataType[VariableNameMappingListDtoDataType["_1"] = 1] = "_1";
    VariableNameMappingListDtoDataType[VariableNameMappingListDtoDataType["_2"] = 2] = "_2";
    VariableNameMappingListDtoDataType[VariableNameMappingListDtoDataType["_4"] = 4] = "_4";
    VariableNameMappingListDtoDataType[VariableNameMappingListDtoDataType["_8"] = 8] = "_8";
})(VariableNameMappingListDtoDataType || (VariableNameMappingListDtoDataType = {}));
export var VariableNameMappingListDtoReadWriteModel;
(function (VariableNameMappingListDtoReadWriteModel) {
    VariableNameMappingListDtoReadWriteModel[VariableNameMappingListDtoReadWriteModel["_2"] = 2] = "_2";
    VariableNameMappingListDtoReadWriteModel[VariableNameMappingListDtoReadWriteModel["_4"] = 4] = "_4";
    VariableNameMappingListDtoReadWriteModel[VariableNameMappingListDtoReadWriteModel["_6"] = 6] = "_6";
})(VariableNameMappingListDtoReadWriteModel || (VariableNameMappingListDtoReadWriteModel = {}));
export var CurrentAlarmDtoState;
(function (CurrentAlarmDtoState) {
    CurrentAlarmDtoState[CurrentAlarmDtoState["_0"] = 0] = "_0";
    CurrentAlarmDtoState[CurrentAlarmDtoState["_1"] = 1] = "_1";
    CurrentAlarmDtoState[CurrentAlarmDtoState["_2"] = 2] = "_2";
    CurrentAlarmDtoState[CurrentAlarmDtoState["_4"] = 4] = "_4";
})(CurrentAlarmDtoState || (CurrentAlarmDtoState = {}));
export var CurrentAlarmDtoAlarmLevel;
(function (CurrentAlarmDtoAlarmLevel) {
    CurrentAlarmDtoAlarmLevel[CurrentAlarmDtoAlarmLevel["_0"] = 0] = "_0";
    CurrentAlarmDtoAlarmLevel[CurrentAlarmDtoAlarmLevel["_1"] = 1] = "_1";
    CurrentAlarmDtoAlarmLevel[CurrentAlarmDtoAlarmLevel["_2"] = 2] = "_2";
    CurrentAlarmDtoAlarmLevel[CurrentAlarmDtoAlarmLevel["_3"] = 3] = "_3";
})(CurrentAlarmDtoAlarmLevel || (CurrentAlarmDtoAlarmLevel = {}));
export var HistoryAlarmDtoAction;
(function (HistoryAlarmDtoAction) {
    HistoryAlarmDtoAction[HistoryAlarmDtoAction["_0"] = 0] = "_0";
    HistoryAlarmDtoAction[HistoryAlarmDtoAction["_1"] = 1] = "_1";
    HistoryAlarmDtoAction[HistoryAlarmDtoAction["_2"] = 2] = "_2";
    HistoryAlarmDtoAction[HistoryAlarmDtoAction["_3"] = 3] = "_3";
})(HistoryAlarmDtoAction || (HistoryAlarmDtoAction = {}));
export var HistoryAlarmDtoAlarmLevel;
(function (HistoryAlarmDtoAlarmLevel) {
    HistoryAlarmDtoAlarmLevel[HistoryAlarmDtoAlarmLevel["_0"] = 0] = "_0";
    HistoryAlarmDtoAlarmLevel[HistoryAlarmDtoAlarmLevel["_1"] = 1] = "_1";
    HistoryAlarmDtoAlarmLevel[HistoryAlarmDtoAlarmLevel["_2"] = 2] = "_2";
    HistoryAlarmDtoAlarmLevel[HistoryAlarmDtoAlarmLevel["_3"] = 3] = "_3";
})(HistoryAlarmDtoAlarmLevel || (HistoryAlarmDtoAlarmLevel = {}));
export var HdataChannelDataType;
(function (HdataChannelDataType) {
    HdataChannelDataType[HdataChannelDataType["_0"] = 0] = "_0";
    HdataChannelDataType[HdataChannelDataType["_1"] = 1] = "_1";
    HdataChannelDataType[HdataChannelDataType["_2"] = 2] = "_2";
    HdataChannelDataType[HdataChannelDataType["_3"] = 3] = "_3";
    HdataChannelDataType[HdataChannelDataType["_4"] = 4] = "_4";
    HdataChannelDataType[HdataChannelDataType["_5"] = 5] = "_5";
    HdataChannelDataType[HdataChannelDataType["_11"] = 11] = "_11";
    HdataChannelDataType[HdataChannelDataType["_12"] = 12] = "_12";
    HdataChannelDataType[HdataChannelDataType["_13"] = 13] = "_13";
    HdataChannelDataType[HdataChannelDataType["_14"] = 14] = "_14";
    HdataChannelDataType[HdataChannelDataType["_15"] = 15] = "_15";
    HdataChannelDataType[HdataChannelDataType["_16"] = 16] = "_16";
    HdataChannelDataType[HdataChannelDataType["_30"] = 30] = "_30";
})(HdataChannelDataType || (HdataChannelDataType = {}));
export var HdataChannelIoWidth;
(function (HdataChannelIoWidth) {
    HdataChannelIoWidth[HdataChannelIoWidth["_0"] = 0] = "_0";
    HdataChannelIoWidth[HdataChannelIoWidth["_1"] = 1] = "_1";
    HdataChannelIoWidth[HdataChannelIoWidth["_2"] = 2] = "_2";
    HdataChannelIoWidth[HdataChannelIoWidth["_4"] = 4] = "_4";
    HdataChannelIoWidth[HdataChannelIoWidth["_8"] = 8] = "_8";
})(HdataChannelIoWidth || (HdataChannelIoWidth = {}));
export var DeviceTagMapperIoWidth;
(function (DeviceTagMapperIoWidth) {
    DeviceTagMapperIoWidth[DeviceTagMapperIoWidth["_0"] = 0] = "_0";
    DeviceTagMapperIoWidth[DeviceTagMapperIoWidth["_1"] = 1] = "_1";
    DeviceTagMapperIoWidth[DeviceTagMapperIoWidth["_2"] = 2] = "_2";
    DeviceTagMapperIoWidth[DeviceTagMapperIoWidth["_4"] = 4] = "_4";
    DeviceTagMapperIoWidth[DeviceTagMapperIoWidth["_8"] = 8] = "_8";
})(DeviceTagMapperIoWidth || (DeviceTagMapperIoWidth = {}));
export var AddressTagDtoAddrTagDataType;
(function (AddressTagDtoAddrTagDataType) {
    AddressTagDtoAddrTagDataType[AddressTagDtoAddrTagDataType["_0"] = 0] = "_0";
    AddressTagDtoAddrTagDataType[AddressTagDtoAddrTagDataType["_1"] = 1] = "_1";
})(AddressTagDtoAddrTagDataType || (AddressTagDtoAddrTagDataType = {}));
export var GetHistoryDataDtoTimeRange;
(function (GetHistoryDataDtoTimeRange) {
    GetHistoryDataDtoTimeRange[GetHistoryDataDtoTimeRange["_0"] = 0] = "_0";
    GetHistoryDataDtoTimeRange[GetHistoryDataDtoTimeRange["_1"] = 1] = "_1";
    GetHistoryDataDtoTimeRange[GetHistoryDataDtoTimeRange["_2"] = 2] = "_2";
    GetHistoryDataDtoTimeRange[GetHistoryDataDtoTimeRange["_3"] = 3] = "_3";
})(GetHistoryDataDtoTimeRange || (GetHistoryDataDtoTimeRange = {}));
export var VirtualDeviceOperationResultDtoVirtualDeviceState;
(function (VirtualDeviceOperationResultDtoVirtualDeviceState) {
    VirtualDeviceOperationResultDtoVirtualDeviceState[VirtualDeviceOperationResultDtoVirtualDeviceState["_1"] = 1] = "_1";
    VirtualDeviceOperationResultDtoVirtualDeviceState[VirtualDeviceOperationResultDtoVirtualDeviceState["_3"] = 3] = "_3";
    VirtualDeviceOperationResultDtoVirtualDeviceState[VirtualDeviceOperationResultDtoVirtualDeviceState["_4"] = 4] = "_4";
    VirtualDeviceOperationResultDtoVirtualDeviceState[VirtualDeviceOperationResultDtoVirtualDeviceState["_5"] = 5] = "_5";
})(VirtualDeviceOperationResultDtoVirtualDeviceState || (VirtualDeviceOperationResultDtoVirtualDeviceState = {}));
export var VirtualDeviceVideoDtoVideoType;
(function (VirtualDeviceVideoDtoVideoType) {
    VirtualDeviceVideoDtoVideoType[VirtualDeviceVideoDtoVideoType["_0"] = 0] = "_0";
    VirtualDeviceVideoDtoVideoType[VirtualDeviceVideoDtoVideoType["_1"] = 1] = "_1";
})(VirtualDeviceVideoDtoVideoType || (VirtualDeviceVideoDtoVideoType = {}));
export var WorkConfigurationWorkRuleType;
(function (WorkConfigurationWorkRuleType) {
    WorkConfigurationWorkRuleType[WorkConfigurationWorkRuleType["_1"] = 1] = "_1";
    WorkConfigurationWorkRuleType[WorkConfigurationWorkRuleType["_2"] = 2] = "_2";
})(WorkConfigurationWorkRuleType || (WorkConfigurationWorkRuleType = {}));
export var WorkAttendanceRecordOutputWorkAttendanceType;
(function (WorkAttendanceRecordOutputWorkAttendanceType) {
    WorkAttendanceRecordOutputWorkAttendanceType[WorkAttendanceRecordOutputWorkAttendanceType["_0"] = 0] = "_0";
    WorkAttendanceRecordOutputWorkAttendanceType[WorkAttendanceRecordOutputWorkAttendanceType["_1"] = 1] = "_1";
    WorkAttendanceRecordOutputWorkAttendanceType[WorkAttendanceRecordOutputWorkAttendanceType["_2"] = 2] = "_2";
})(WorkAttendanceRecordOutputWorkAttendanceType || (WorkAttendanceRecordOutputWorkAttendanceType = {}));
export var WorkAttendanceRecordOutputWorkAttendanceErrorType;
(function (WorkAttendanceRecordOutputWorkAttendanceErrorType) {
    WorkAttendanceRecordOutputWorkAttendanceErrorType[WorkAttendanceRecordOutputWorkAttendanceErrorType["_0"] = 0] = "_0";
    WorkAttendanceRecordOutputWorkAttendanceErrorType[WorkAttendanceRecordOutputWorkAttendanceErrorType["_1"] = 1] = "_1";
    WorkAttendanceRecordOutputWorkAttendanceErrorType[WorkAttendanceRecordOutputWorkAttendanceErrorType["_2"] = 2] = "_2";
    WorkAttendanceRecordOutputWorkAttendanceErrorType[WorkAttendanceRecordOutputWorkAttendanceErrorType["_3"] = 3] = "_3";
    WorkAttendanceRecordOutputWorkAttendanceErrorType[WorkAttendanceRecordOutputWorkAttendanceErrorType["_4"] = 4] = "_4";
})(WorkAttendanceRecordOutputWorkAttendanceErrorType || (WorkAttendanceRecordOutputWorkAttendanceErrorType = {}));
export var WorkOrderForDetailDtoState;
(function (WorkOrderForDetailDtoState) {
    WorkOrderForDetailDtoState[WorkOrderForDetailDtoState["_1"] = 1] = "_1";
    WorkOrderForDetailDtoState[WorkOrderForDetailDtoState["_512"] = 512] = "_512";
    WorkOrderForDetailDtoState[WorkOrderForDetailDtoState["_1024"] = 1024] = "_1024";
})(WorkOrderForDetailDtoState || (WorkOrderForDetailDtoState = {}));
export var WorkOrderForDetailDtoWorkOrderType;
(function (WorkOrderForDetailDtoWorkOrderType) {
    WorkOrderForDetailDtoWorkOrderType[WorkOrderForDetailDtoWorkOrderType["_1"] = 1] = "_1";
    WorkOrderForDetailDtoWorkOrderType[WorkOrderForDetailDtoWorkOrderType["_2"] = 2] = "_2";
})(WorkOrderForDetailDtoWorkOrderType || (WorkOrderForDetailDtoWorkOrderType = {}));
export var WorkOrderProgressDtoState;
(function (WorkOrderProgressDtoState) {
    WorkOrderProgressDtoState[WorkOrderProgressDtoState["_0"] = 0] = "_0";
    WorkOrderProgressDtoState[WorkOrderProgressDtoState["_100"] = 100] = "_100";
    WorkOrderProgressDtoState[WorkOrderProgressDtoState["_200"] = 200] = "_200";
})(WorkOrderProgressDtoState || (WorkOrderProgressDtoState = {}));
export var WorkOrderDtoState;
(function (WorkOrderDtoState) {
    WorkOrderDtoState[WorkOrderDtoState["_1"] = 1] = "_1";
    WorkOrderDtoState[WorkOrderDtoState["_512"] = 512] = "_512";
    WorkOrderDtoState[WorkOrderDtoState["_1024"] = 1024] = "_1024";
})(WorkOrderDtoState || (WorkOrderDtoState = {}));
export var WorkOrderDtoWorkOrderType;
(function (WorkOrderDtoWorkOrderType) {
    WorkOrderDtoWorkOrderType[WorkOrderDtoWorkOrderType["_1"] = 1] = "_1";
    WorkOrderDtoWorkOrderType[WorkOrderDtoWorkOrderType["_2"] = 2] = "_2";
})(WorkOrderDtoWorkOrderType || (WorkOrderDtoWorkOrderType = {}));
export var MyWorkOrderDtoState;
(function (MyWorkOrderDtoState) {
    MyWorkOrderDtoState[MyWorkOrderDtoState["_1"] = 1] = "_1";
    MyWorkOrderDtoState[MyWorkOrderDtoState["_512"] = 512] = "_512";
    MyWorkOrderDtoState[MyWorkOrderDtoState["_1024"] = 1024] = "_1024";
})(MyWorkOrderDtoState || (MyWorkOrderDtoState = {}));
export var MyWorkOrderDtoWorkOrderType;
(function (MyWorkOrderDtoWorkOrderType) {
    MyWorkOrderDtoWorkOrderType[MyWorkOrderDtoWorkOrderType["_1"] = 1] = "_1";
    MyWorkOrderDtoWorkOrderType[MyWorkOrderDtoWorkOrderType["_2"] = 2] = "_2";
})(MyWorkOrderDtoWorkOrderType || (MyWorkOrderDtoWorkOrderType = {}));
export var ExportWorkOrderListDtoState;
(function (ExportWorkOrderListDtoState) {
    ExportWorkOrderListDtoState[ExportWorkOrderListDtoState["_1"] = 1] = "_1";
    ExportWorkOrderListDtoState[ExportWorkOrderListDtoState["_512"] = 512] = "_512";
    ExportWorkOrderListDtoState[ExportWorkOrderListDtoState["_1024"] = 1024] = "_1024";
})(ExportWorkOrderListDtoState || (ExportWorkOrderListDtoState = {}));
export var ExportWorkOrderListDtoWorkOrderType;
(function (ExportWorkOrderListDtoWorkOrderType) {
    ExportWorkOrderListDtoWorkOrderType[ExportWorkOrderListDtoWorkOrderType["_1"] = 1] = "_1";
    ExportWorkOrderListDtoWorkOrderType[ExportWorkOrderListDtoWorkOrderType["_2"] = 2] = "_2";
})(ExportWorkOrderListDtoWorkOrderType || (ExportWorkOrderListDtoWorkOrderType = {}));
export var ExportMyWorkOrderListDtoState;
(function (ExportMyWorkOrderListDtoState) {
    ExportMyWorkOrderListDtoState[ExportMyWorkOrderListDtoState["_1"] = 1] = "_1";
    ExportMyWorkOrderListDtoState[ExportMyWorkOrderListDtoState["_512"] = 512] = "_512";
    ExportMyWorkOrderListDtoState[ExportMyWorkOrderListDtoState["_1024"] = 1024] = "_1024";
})(ExportMyWorkOrderListDtoState || (ExportMyWorkOrderListDtoState = {}));
export var ExportMyWorkOrderListDtoWorkOrderType;
(function (ExportMyWorkOrderListDtoWorkOrderType) {
    ExportMyWorkOrderListDtoWorkOrderType[ExportMyWorkOrderListDtoWorkOrderType["_1"] = 1] = "_1";
    ExportMyWorkOrderListDtoWorkOrderType[ExportMyWorkOrderListDtoWorkOrderType["_2"] = 2] = "_2";
})(ExportMyWorkOrderListDtoWorkOrderType || (ExportMyWorkOrderListDtoWorkOrderType = {}));
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function () {
                observer.next(this.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
